import React__default, { PureComponent, useState, useEffect, useContext, useRef, useMemo, createElement, Component, Fragment, useCallback } from 'react';
import _, { isEqual, cloneDeep, setWith, keyBy, isArray, round, capitalize, isEmpty as isEmpty$1, sortBy as sortBy$1, get, uniqBy, debounce, toNumber, flatMap, set, groupBy, size } from 'lodash';
import { toast } from 'react-toastify';
import { DateTime, Duration, Interval } from 'luxon';
import produce, { produce as produce$1 } from 'immer';
import { faBell, faCircle, faFileContract, faArchive, faBan, faMinusCircle, faCheckCircle, faClipboardCheck, faHourglassHalf, faExclamationTriangle, faExclamationCircle, faArrowLeft, faShare, faPencil, faFilePdf, faUsers, faFileCheck, faUserPlus, faEye, faSignature, faSpinner, faFile, faFileAlt, faBullseye, faChevronLeft, faClock, faChevronRight, faCalendarDay, faCheck, faMinus, faFileImport, faEyeSlash, faSave, faPen, faAngleRight, faFileExcel, faDownload, faInfoCircle, faPlus, faCalendarCheck, faSyncAlt, faTimes, faSortDown, faSortUp, faSort, faFilter, faCalendar, faCopy, faCaretLeft, faCaretRight, faSearchMinus, faSearchPlus, faFileExport, faMapMarkerAlt, faUser } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { determineTimeSteps, ViewerItem, MOVE_CENTER, MOVE_HORIZONTAL, MOVE_VERTICAL, Viewer } from '@teqplay/viewer';
import Button, { snapToHour, calculateMinMonthDate, calculateMaxMonthDate, isAfter, isBefore, datesAreEqual, parseDateOrStringToDateTime, isValidDate, FormElement, FormLabel, NumberInput, FormFieldWrapper, InlineFormElement, FormWrapper, SelectionBox, formatDateTime, ButtonGroup, Collapse as Collapse$1, Dialog, formatDate, Button as Button$1, TextField, FormErrorMessage, isoStringToFormat, NavigationButton, Checkbox, MultiSelectionBox, MultiSelectOption, DateTimePicker, TextArea, FormFieldButtonWrapper, isToday, isSameDayAndMonth, DateDialog, formatDateWithoutYear, dateStringToZonedJSDate, DatePicker, DropDownButton, DropDownButtonItem, formatJSDateWithZone } from '@teqplay/teqplay-ui';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import useForm from '@teqplay/react-useform';
import { faCircle as faCircle$1 } from '@fortawesome/pro-solid-svg-icons';
import classNames from 'classnames';
import { Tabs, TabList, Tab, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import moment from 'moment';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { faAngleDown } from '@fortawesome/pro-regular-svg-icons';
import { useSpring, animated } from 'react-spring';
import { useMeasure } from 'react-use';
import { Prompt } from 'react-router';
import { useTable, useGlobalFilter, useSortBy, usePagination } from 'react-table';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

var FetchError = /** @class */ (function (_super) {
    __extends(FetchError, _super);
    function FetchError(status, error, message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, _newTarget.prototype); // restore prototype chain
        _this.error = error;
        _this.status = status;
        return _this;
    }
    FetchError.prototype.toString = function () {
        return "FetchError: " + (this.error || this.status) + ". " + this.message;
    };
    return FetchError;
}(Error));

/**
 * Helper function to load and deserialize a key/value in the browsers local storage.
 * The function will return undefined when deserializing a stored key failed
 * @param {string} key
 * @param {*} [defaultValue=undefined] Optional default value to be returned
 *                                     When key was not found in local storage
 * @return {*} value
 */
function loadFromLocalStorage(key, defaultValue) {
    try {
        var value = localStorage[key];
        // These values tend to also be stringified, so also check for the string versions of null and undefined.
        return value !== undefined && value !== null && value !== 'undefined' && value !== 'null'
            ? JSON.parse(value)
            : defaultValue;
    }
    catch (err) {
        console.error('error in function loadProperty  ' + err.message);
        return defaultValue;
    }
}
/**
 * Helper function to serialize and store a key/value in the browsers local storage
 * @param {string} key
 * @param {*} value
 */
function saveToLocalStorage(key, value) {
    try {
        localStorage[key] = JSON.stringify(value);
    }
    catch (err) {
        console.error('error in function saveProperty  ' + err.message);
    }
}
/**
 * Remove a key from local storage (if it exists)
 * @param {string} key
 */
function removeFromLocalStorage(key) {
    try {
        delete localStorage[key];
    }
    catch (err) {
        console.error('error in function removeProperty  ' + err.message);
    }
}

var Icon = function (props) {
    return React__default.createElement("span", { className: "icon-wrapper " + (props.className || '') }, props.children);
};

var DEFAULT_INTERVAL = 60000;
/**
 * Refresher is a container component which regularly triggers a callback
 * function onRefresh which can be used to refresh data.
 */
var Refresher = /** @class */ (function (_super) {
    __extends(Refresher, _super);
    function Refresher() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.timer = 0;
        _this.restart = function () {
            _this.stop();
            _this.start();
        };
        _this.start = function () {
            var refreshOnInterval = _this.props.refreshOnInterval !== false; // default to true
            var refreshOnFocus = _this.props.refreshOnFocus !== false; // default to true
            if (_this.props.interval && _this.props.interval <= 0) {
                console.warn("Interval must be a positive number. Actual value: " + _this.props.interval + ".");
            }
            if (refreshOnInterval) {
                var interval = typeof _this.props.interval === 'number' ? _this.props.interval : DEFAULT_INTERVAL;
                _this.timer = window.setInterval(_this.handleRefresh, interval);
            }
            if (refreshOnFocus) {
                window.addEventListener('focus', _this.handleRefresh);
            }
        };
        _this.stop = function () {
            window.clearInterval(_this.timer);
            window.removeEventListener('focus', _this.handleRefresh);
        };
        // We must invoke onRefresh via this intermediate handleRefresh method
        // since onRefresh might change, and we need to keep the same method
        // instance used to subscribe to the 'focus' event else we can never
        // remove the created event listener anymore.
        _this.handleRefresh = function () {
            _this.props.onRefresh();
            if (_this.props.onRefreshCallback) {
                _this.props.onRefreshCallback();
            }
        };
        return _this;
    }
    Refresher.prototype.componentDidMount = function () {
        var refreshOnMount = this.props.refreshOnMount !== false; // default to true
        if (refreshOnMount) {
            this.handleRefresh();
        }
        this.start();
    };
    Refresher.prototype.componentDidUpdate = function (prevProps) {
        // test whether any of the properties except for the callback function
        // is changed.
        if (JSON.stringify(this.props) !== JSON.stringify(prevProps)) {
            this.restart();
        }
    };
    Refresher.prototype.componentWillUnmount = function () {
        this.stop();
    };
    Refresher.prototype.render = function () {
        return null;
    };
    return Refresher;
}(PureComponent));

/**
 * IMPORTANT: This file MUST ONLY contain enums, and types.ts MUST NOT contain
 *            enums, else TypeScript gives issues: when trying to use the enum
 *            from an other project it's undefined. I'm not sure why.
 */
var PriceUnit;
(function (PriceUnit) {
    PriceUnit["EUR"] = "EUR";
    PriceUnit["USD"] = "USD";
    PriceUnit["GBP"] = "GBP";
})(PriceUnit || (PriceUnit = {}));
var EnergyUnit;
(function (EnergyUnit) {
    EnergyUnit["KWH"] = "KWH";
    EnergyUnit["MWH"] = "MWH";
    EnergyUnit["MMBTU"] = "MMBTU";
    EnergyUnit["THERM"] = "THERM";
    EnergyUnit["MJ"] = "MJ";
})(EnergyUnit || (EnergyUnit = {}));
var PressureUnit;
(function (PressureUnit) {
    PressureUnit["BAR"] = "bar";
    PressureUnit["MBAR"] = "mbar";
})(PressureUnit || (PressureUnit = {}));
var SafetyChecklistPressureUnit;
(function (SafetyChecklistPressureUnit) {
    SafetyChecklistPressureUnit["BAR"] = "BAR";
    SafetyChecklistPressureUnit["PSI"] = "PSI";
})(SafetyChecklistPressureUnit || (SafetyChecklistPressureUnit = {}));
var ExternalSignerRole;
(function (ExternalSignerRole) {
    ExternalSignerRole["TERMINAL_OPERATOR"] = "TERMINAL_OPERATOR";
    ExternalSignerRole["PORT_OFFICIAL"] = "PORT_OFFICIAL";
    ExternalSignerRole["SITE_OPERATOR"] = "SITE_OPERATOR";
})(ExternalSignerRole || (ExternalSignerRole = {}));
var QuantityUnit;
(function (QuantityUnit) {
    QuantityUnit["CUBIC_METERS"] = "CUBIC_METERS";
    QuantityUnit["TONNES"] = "TONNES";
    QuantityUnit["KILOGRAMS"] = "KILOGRAMS";
})(QuantityUnit || (QuantityUnit = {}));
var NominationFormLabels;
(function (NominationFormLabels) {
    NominationFormLabels["state"] = "Negotiation State";
    NominationFormLabels["stateChangeReason"] = "Reason for rejection";
    NominationFormLabels["vendorReference"] = "Vendor Reference";
    NominationFormLabels["amount"] = "Nominated Amount";
    NominationFormLabels["actualAmount"] = "Actual Quantity Delivered";
    NominationFormLabels["receivingShipId"] = "Receiving Vessel";
    NominationFormLabels["bunkerShipId"] = "Bunker Vessel";
    NominationFormLabels["locationId"] = "Delivery Point";
    NominationFormLabels["eta"] = "ETA (Receiving Vessel)";
    NominationFormLabels["bunkershipEta"] = "ETA (Bunker Vessel)";
    NominationFormLabels["etd"] = "ETD (Receiving Vessel)";
    NominationFormLabels["bunkershipEtd"] = "ETD (Bunker Vessel)";
    NominationFormLabels["bst"] = "BST (Bunker Start Time)";
    NominationFormLabels["allowedBunkeringTime"] = "Allowed Bunkering Time";
    NominationFormLabels["contractId"] = "Contract";
    NominationFormLabels["supplierId"] = "Supplier";
    NominationFormLabels["buyerRef"] = "Customer Reference";
    NominationFormLabels["agent"] = "Agent";
    NominationFormLabels["companyId"] = "Customer";
    NominationFormLabels["bunkershipAtd"] = "ATD (Bunker Vessel)";
    NominationFormLabels["ata"] = "ATA (Receiving Vessel)";
    NominationFormLabels["atd"] = "ATD (Receiving Vessel)";
    NominationFormLabels["gasUp"] = "Gas Up";
    NominationFormLabels["coolDown"] = "Cool Down";
    NominationFormLabels["hosesConnected"] = "Hose Connected";
    NominationFormLabels["hosesDisconnected"] = "Hose Disconnected";
    NominationFormLabels["quantityUnit"] = "Quantity Unit";
    NominationFormLabels["deliveryMode"] = "Delivery Mode";
    NominationFormLabels["tolerance"] = "Tolarance";
    NominationFormLabels["altFuelTolerance"] = "Alternative Fuel Tolerance";
    NominationFormLabels["altFuelPercentage"] = "Alternative Fuel Percentage";
    NominationFormLabels["altFuelType"] = "Alternative Fuel Type";
    NominationFormLabels["price"] = "Price";
    NominationFormLabels["priceUnit"] = "Price Unit";
    NominationFormLabels["energyUnit"] = "Energy Unit";
    NominationFormLabels["location"] = "Location";
    NominationFormLabels["nextDestination"] = "Next Destination";
    NominationFormLabels["supplierTerms"] = "Supplier Terms";
    NominationFormLabels["buyerTerms"] = "Customer Terms";
})(NominationFormLabels || (NominationFormLabels = {}));
var NominationStateLabels;
(function (NominationStateLabels) {
    NominationStateLabels["PROPOSED"] = "Proposed";
    NominationStateLabels["ACCEPTED"] = "Accepted";
    NominationStateLabels["COMPLETED"] = "Completed";
    NominationStateLabels["CANCELLED"] = "Cancelled";
    NominationStateLabels["REJECTED"] = "Rejected";
    NominationStateLabels["COUNTERED"] = "Countered";
    NominationStateLabels["FINALISED"] = "Finalised";
    NominationStateLabels["PENDING"] = "Pending";
    NominationStateLabels["NEEDS_CONTRACT"] = "Needs Contract";
})(NominationStateLabels || (NominationStateLabels = {}));
var Vessel;
(function (Vessel) {
    Vessel["BUNKER_VESSEL"] = "BUNKER_VESSEL";
    Vessel["RECEIVING_VESSEL"] = "RECEIVING_VESSEL";
})(Vessel || (Vessel = {}));
var Side;
(function (Side) {
    Side["PORT"] = "PORT";
    Side["STARBOARD"] = "STARBOARD";
})(Side || (Side = {}));
var SafetyChecklistType;
(function (SafetyChecklistType) {
    SafetyChecklistType["IAPH"] = "IAPH";
    SafetyChecklistType["IAPH_V2_A"] = "IAPH_V2_A";
    SafetyChecklistType["IAPH_V2_B"] = "IAPH_V2_B";
    SafetyChecklistType["GOTHENBURG"] = "GOTHENBURG";
    SafetyChecklistType["TR56"] = "TR56";
})(SafetyChecklistType || (SafetyChecklistType = {}));
var ChecklistValue;
(function (ChecklistValue) {
    ChecklistValue["BLANK"] = "BLANK";
    ChecklistValue["CHECKED"] = "CHECKED";
    ChecklistValue["NOT_APPLICABLE"] = "NOT_APPLICABLE";
    ChecklistValue["TRUE"] = "TRUE";
    ChecklistValue["FALSE"] = "FALSE";
})(ChecklistValue || (ChecklistValue = {}));
var ChecklistValueType;
(function (ChecklistValueType) {
    ChecklistValueType["BOOLEAN"] = "BOOLEAN";
    ChecklistValueType["CHECKBOX"] = "CHECKBOX";
})(ChecklistValueType || (ChecklistValueType = {}));
var TemperatureUnit;
(function (TemperatureUnit) {
    TemperatureUnit["CELSIUS"] = "CELSIUS";
    TemperatureUnit["FAHRENHEIT"] = "FAHRENHEIT";
})(TemperatureUnit || (TemperatureUnit = {}));
var ChecklistType;
(function (ChecklistType) {
    ChecklistType["A"] = "A";
    ChecklistType["B"] = "B";
    ChecklistType["C"] = "C";
    ChecklistType["D"] = "D";
    ChecklistType["BUNKER"] = "BUNKER";
    ChecklistType["CARGO"] = "CARGO";
    ChecklistType["RESTRICTIONS"] = "RESTRICTIONS";
    ChecklistType["E"] = "E";
    ChecklistType["F"] = "F";
    ChecklistType["G"] = "G";
})(ChecklistType || (ChecklistType = {}));
var SafetyChecklistPart;
(function (SafetyChecklistPart) {
    // IAPH: AB, CD, E, F
    SafetyChecklistPart["AB"] = "AB";
    SafetyChecklistPart["CD"] = "CD";
    SafetyChecklistPart["E"] = "E";
    SafetyChecklistPart["F"] = "F";
    // Gothenburg: AB, CDEF, G
    SafetyChecklistPart["CDEF"] = "CDEF";
    SafetyChecklistPart["G"] = "G";
    // IAPH v2
    SafetyChecklistPart["A"] = "A";
    SafetyChecklistPart["BCD"] = "BCD";
})(SafetyChecklistPart || (SafetyChecklistPart = {}));
var SafetyChecklistIndividualPart;
(function (SafetyChecklistIndividualPart) {
    SafetyChecklistIndividualPart["A"] = "A";
    SafetyChecklistIndividualPart["B"] = "B";
    SafetyChecklistIndividualPart["C"] = "C";
    SafetyChecklistIndividualPart["D"] = "D";
    SafetyChecklistIndividualPart["E"] = "E";
    SafetyChecklistIndividualPart["F"] = "F";
    SafetyChecklistIndividualPart["G"] = "G";
})(SafetyChecklistIndividualPart || (SafetyChecklistIndividualPart = {}));
var POSITION_REPORT_READING_TYPE;
(function (POSITION_REPORT_READING_TYPE) {
    POSITION_REPORT_READING_TYPE["NOON"] = "NOON";
    POSITION_REPORT_READING_TYPE["EOL"] = "EOL";
    POSITION_REPORT_READING_TYPE["EOD"] = "EOD";
    POSITION_REPORT_READING_TYPE["EOB"] = "EOB";
    POSITION_REPORT_READING_TYPE["COMMENCE_TRANSFER"] = "COMMENCE_TRANSFER";
    POSITION_REPORT_READING_TYPE["FAOP"] = "FAOP";
    POSITION_REPORT_READING_TYPE["EOSP"] = "EOSP";
    POSITION_REPORT_READING_TYPE["ALL_MADE_FAST"] = "ALL_MADE_FAST";
    POSITION_REPORT_READING_TYPE["ALL_CAST_OFF"] = "ALL_CAST_OFF";
    POSITION_REPORT_READING_TYPE["BUNKERING"] = "BUNKERING";
})(POSITION_REPORT_READING_TYPE || (POSITION_REPORT_READING_TYPE = {}));
var POSITION_REPORT_VESSEL_STATUS;
(function (POSITION_REPORT_VESSEL_STATUS) {
    POSITION_REPORT_VESSEL_STATUS["UNDERWAY"] = "UNDERWAY";
    POSITION_REPORT_VESSEL_STATUS["ALONGSIDE"] = "ALONGSIDE";
    POSITION_REPORT_VESSEL_STATUS["ANCHORED"] = "ANCHORED";
    POSITION_REPORT_VESSEL_STATUS["DRIFTING"] = "DRIFTING";
    POSITION_REPORT_VESSEL_STATUS["OTHER"] = "OTHER";
})(POSITION_REPORT_VESSEL_STATUS || (POSITION_REPORT_VESSEL_STATUS = {}));
var POSITION_REPORT_OPERATING_MODE;
(function (POSITION_REPORT_OPERATING_MODE) {
    POSITION_REPORT_OPERATING_MODE["FUEL_OIL_ONLY"] = "FUEL_OIL_ONLY";
    POSITION_REPORT_OPERATING_MODE["NATURAL_BOG"] = "NATURAL_BOG";
    POSITION_REPORT_OPERATING_MODE["GAS_ONLY"] = "GAS_ONLY";
    POSITION_REPORT_OPERATING_MODE["FO_AND_MIN_GAS"] = "FO_AND_MIN_GAS";
    POSITION_REPORT_OPERATING_MODE["DUAL_FUE"] = "DUAL_FUEL";
})(POSITION_REPORT_OPERATING_MODE || (POSITION_REPORT_OPERATING_MODE = {}));
var POSITION_REPORT_TYPE;
(function (POSITION_REPORT_TYPE) {
    POSITION_REPORT_TYPE["SEAGOING"] = "SEAGOING";
    POSITION_REPORT_TYPE["INLAND"] = "INLAND";
})(POSITION_REPORT_TYPE || (POSITION_REPORT_TYPE = {}));
var ACTION;
(function (ACTION) {
    ACTION["UPDATE"] = "UPDATE";
    ACTION["DELETE"] = "DELETE";
})(ACTION || (ACTION = {}));
/**
 * According to the backend there are two ship types, bunkerships and customer ships.
 * For the backend logic/API calls those are called 'bunkerships' and 'ship'.
 * To avoid writing duplicate logic this enum exists to choose between the ship types/api call's used.
 */
var SHIP_TYPE_REQUEST;
(function (SHIP_TYPE_REQUEST) {
    SHIP_TYPE_REQUEST["BUNKERSHIP"] = "bunkerships";
    SHIP_TYPE_REQUEST["CUSTOMERSHIP"] = "ship";
})(SHIP_TYPE_REQUEST || (SHIP_TYPE_REQUEST = {}));

var MINIMUM_QUANTITY = 1; // MT
var MAXIMUM_QUANTITY = 100000; // MT
var DATA_REFRESH_INTERVAL = 60 * 1000; // milliseconds
// the following constants specify how wide items are inside a single column
// must be a value between 0 and 1
var COLUMN_NOMINATION_SHIP_LEFT = 0.0;
var COLUMN_NOMINATION_SHIP_RIGHT = 0.1;
var COLUMN_TRAVEL_RIGHT = 0.9;
var COLUMN_CENTER = 0.5;
var REFRESH_INTERVAL_NOW = 60 * 1000; // milliseconds
var ZOOM_FACTOR = 0.7;
var DEFAULT_VIEWPORT_HOURS = 24 * 7;
var DEFAULT_TRANSFER_DURATION_HOURS = 10;
// BDN ENERGY UNIT FACTORS
var MMBTU_FACTOR = 1055.056 / 3600;
var THERM_FACTOR = 105480400 / 3600 / 1000000;
var MJ_FACTOR = 3600;
var COMPANY_COLORS = [
    '#4f81bd',
    '#f79646',
    '#75c841',
    '#ed4648',
    '#9467bd',
    '#8c564b',
    '#e377c2',
    '#7f7f7f',
    '#bcbd22',
    '#17becf'
];
var SIGNED_DOCUMENT_TYPES = [
    'STATEMENT_OF_FACTS',
    'EBDN',
    'SAFETY_CHECKLIST_CDE',
    'SAFETY_CHECKLIST_IAPH_AB',
    'SAFETY_CHECKLIST_IAPH_CD',
    'SAFETY_CHECKLIST_IAPH_E',
    'SAFETY_CHECKLIST_IAPH_F',
    'SAFETY_CHECKLIST_GOTHENBURG_AB',
    'SAFETY_CHECKLIST_GOTHENBURG_CDEF',
    'SAFETY_CHECKLIST_GOTHENBURG_G',
    'SAFETY_CHECKLIST_TR56_AB',
    'SAFETY_CHECKLIST_TR56_CD',
    'SAFETY_CHECKLIST_TR56_E',
    'MASTERS_REQUISITION_FORM',
    'NOR_BUNKERSHIP',
    'NOR_RECEIVINGSHIP',
    'SAFETY_CHECKLIST_IAPH_V2_B_A',
    "SAFETY_CHECKLIST_IAPH_V2_B_BCD",
    'SAFETY_CHECKLIST_IAPH_V2_B_F',
    "SAFETY_CHECKLIST_IAPH_V2_A_BCD",
    'SAFETY_CHECKLIST_IAPH_V2_A_F'
];
var SANDBOX_ID_LIVE = 'live';

/**
 * Get company details (name, color, ...) given a companyId
 */
function getCompanyDetails(companies, companyId) {
    var companyIndex = companies.findIndex(function (c) { return c._id === companyId; });
    var company = companyIndex !== -1 ? companies[companyIndex] : null;
    var companyName = company ? company.name : companyId;
    var companyColor = COMPANY_COLORS[companyIndex % COMPANY_COLORS.length];
    return { companyId: companyId, companyName: companyName, companyColor: companyColor };
}
function getCompanyName(proposal, companies, companyId) {
    var proposalAuthor = proposal ? proposal.author : null;
    var companyIdAuthor = (proposalAuthor ? proposalAuthor.companyId : companyId) || companyId;
    if (!proposalAuthor && companyId === undefined) {
        return '-';
    }
    if (!companyIdAuthor) {
        return '';
    }
    var matchingCompany = companies.find(function (company) { return companyIdAuthor !== undefined && company._id === companyIdAuthor; });
    return matchingCompany ? matchingCompany.name : '-';
}
function proposalMadeByUserCompany(proposal, userCompanyId) {
    var userIsAuthor = proposal && proposal.author && userCompanyId && proposal.author.companyId === userCompanyId ? true : false;
    var onBehalf = proposal && proposal.onBehalf ? proposal.onBehalf : false;
    return (userIsAuthor && !onBehalf) || (!userIsAuthor && onBehalf);
}

// a helper function to write readable code
function isOneOf(value, values) {
    return values.includes(value);
}
function isValidEmail(email) {
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
        return false;
    }
    else {
        return true;
    }
}
function formatPortTerminal(location) {
    return location.port + ' ' + (location.terminal ? location.terminal : '');
}
function formatPortCountry(location) {
    if (location.port && location.country) {
        return location.port + ", " + location.country;
    }
    else if (location.port) {
        return location.port;
    }
    else if (location.country) {
        return location.country;
    }
    else {
        return '-';
    }
}
function formatTerminalCountry(location) {
    if (location.terminal && location.country) {
        return location.terminal + ", " + location.country;
    }
    else if (location.terminal) {
        return location.terminal;
    }
    else if (location.country) {
        return location.country;
    }
    else {
        return '-';
    }
}

function isPromptEvent(item) {
    return item && '_type' in item && 'eventId' in item;
}
function isPromptNomination(item) {
    // we check amount to distinguish between IPromptEvent and IPromptNomination
    return item && item._type === 'nomination' && item.amount !== undefined;
}
function instanceOfBasicTimelineItem(object) {
    return ('_type' in object &&
        !('windowStart' in object || 'windowEnd' in object) &&
        object._type !== 'nomination' &&
        object._type !== 'spot');
}
function instanceOfTimelineEventWithWindow(object) {
    return 'windowStart' in object && 'windowEnd' in object;
}
function instanceOfNominationTimelineItem(object) {
    return '_type' in object && object._type === 'nomination';
}
function hasReceivingShipWithTimes(timelineItem) {
    return (timelineItem === null || timelineItem === void 0 ? void 0 : timelineItem.eta) != null && (timelineItem === null || timelineItem === void 0 ? void 0 : timelineItem.etd) != null;
}
function instanceOfINominationEnquiryEvent(object) {
    return 'eventId' in object && '_type' in object && object._type === 'spot';
}
function instanceOfBunkership(object) {
    return ('_id' in object &&
        'heelQuality' in object &&
        'loadedQuality' in object &&
        'lngComposition' in object &&
        'lngProperties' in object);
}

var ADMIN = ['ROLE_ADMIN'];
var CORPORATE_ADMIN = ['ROLE_CORPORATE_ADMIN'];
var SYS_ADMIN = ['ROLE_SYSADMIN'];
var CUSTOMER = ['ROLE_CUSTOMER'];
var CUSTOMER_ADMIN = ['ROLE_CUSTOMER_ADMIN'];
var SUPPLIER = [
    'ROLE_SCHEDULER',
    'ROLE_BACK_OFFICE',
    'ROLE_CAPTAIN',
    'ROLE_SCHEDULER_CAPTAIN'
];
var SCHEDULER = ['ROLE_SCHEDULER', 'ROLE_BACK_OFFICE'];
var SCHEDULER_WITHOUT_BACK_OFFICE = ['ROLE_SCHEDULER'];
var SCHEDULER_CAPTAIN = [
    'ROLE_RECEIVING_SCHEDULER_CAPTAIN',
    'ROLE_SCHEDULER_CAPTAIN'
];
var BUNKER_CAPTAIN = ['ROLE_CAPTAIN', 'ROLE_SCHEDULER_CAPTAIN'];
var RECEIVING_CAPTAIN = [
    'ROLE_RECEIVING_CAPTAIN',
    'ROLE_RECEIVING_SCHEDULER_CAPTAIN'
];
var CAPTAIN = __spreadArrays(BUNKER_CAPTAIN, RECEIVING_CAPTAIN);
var THIRD_PARTY_SCHEDULER = ['ROLE_THIRD_PARTY_SCHEDULER'];
var OPERATOR = [
    'ROLE_CAPTAIN',
    'ROLE_SCHEDULER_CAPTAIN',
    'ROLE_TERMINAL_OPERATOR'
];
function doesUserHavePermission(userPermissions, permissionToCheck) {
    if (userPermissions.includes(permissionToCheck)) {
        return true;
    }
    else {
        return false;
    }
}
function isAdmin(userRoles) {
    if (!userRoles) {
        return false;
    }
    return isUserAllowed(ADMIN, userRoles);
}
function isCorporateAdmin(userRoles) {
    if (!userRoles) {
        return false;
    }
    return isUserAllowed(CORPORATE_ADMIN, userRoles);
}
function isSysAdmin(userRoles) {
    if (!userRoles) {
        return false;
    }
    return isUserAllowed(SYS_ADMIN, userRoles);
}
function isReadOnlyUser(userRoles) {
    if (!userRoles) {
        return true;
    }
    return isUserAllowed(['ROLE_BACK_OFFICE'], userRoles);
}
function isCustomer(userRoles) {
    if (!userRoles) {
        return false;
    }
    return isUserAllowed(CUSTOMER, userRoles);
}
function isCustomerAdmin(userRoles) {
    if (!userRoles) {
        return false;
    }
    return isUserAllowed(CUSTOMER_ADMIN, userRoles);
}
function isSupplier(userRoles) {
    return isUserAllowed(SUPPLIER, userRoles);
}
function isScheduler(userRoles, includeBackOffice) {
    if (includeBackOffice === void 0) { includeBackOffice = true; }
    if (!userRoles) {
        return false;
    }
    var roles = includeBackOffice ? SCHEDULER : SCHEDULER_WITHOUT_BACK_OFFICE;
    return isUserAllowed(roles, userRoles);
}
function isSchedulerCaptain(userRoles) {
    if (!userRoles) {
        return false;
    }
    return isUserAllowed(SCHEDULER_CAPTAIN, userRoles);
}
function isThirdPartyScheduler(userRoles) {
    if (!userRoles) {
        return false;
    }
    return isUserAllowed(THIRD_PARTY_SCHEDULER, userRoles);
}
function isCaptain(userRoles) {
    if (!userRoles) {
        return false;
    }
    return isUserAllowed(CAPTAIN, userRoles);
}
function isBunkerCaptain(userRoles) {
    if (!userRoles) {
        return false;
    }
    return isUserAllowed(BUNKER_CAPTAIN, userRoles);
}
function isReceivingCaptain(userRoles) {
    if (!userRoles) {
        return false;
    }
    return isUserAllowed(RECEIVING_CAPTAIN, userRoles);
}
function isOperator(userRoles) {
    if (!userRoles) {
        return false;
    }
    return isUserAllowed(OPERATOR, userRoles);
}
// for delegations
function isContractParty(user, event) {
    return isVendorOnOrigin(user, event) || isCustomerOnDelegated(user, event);
}
// for delegations
function isVendorOnOrigin(user, event) {
    if (!isSupplier(user.roles)) {
        return false;
    }
    return event.delegatedNominationEventId != null && user.companyId == event.vendorCompanyId;
}
// for delegations
function isCustomerOnDelegated(user, event) {
    if (!isSupplier(user.roles)) {
        return false;
    }
    return event.delegationOriginEventId != null && user.companyId == event.companyId;
}
function isCaptainOnNomination(user, event) {
    if (user.receivingShipId && event.receivingShipId === user.receivingShipId) {
        return true;
    }
    if (user.bunkerShipId && event.bunkerShipId === user.bunkerShipId) {
        return true;
    }
    return false;
}
function isUserAllowed(allowedRoles, userRoles) {
    var allowed = false;
    allowedRoles.forEach(function (allowedRole) {
        if (userRoles.includes(allowedRole)) {
            allowed = true;
        }
    });
    return allowed;
}
var noActionsAllowed = {
    canAccept: false,
    canAcceptOnBehalf: false,
    canCancel: false,
    canCancelOnBehalf: false,
    canReject: false,
    canRejectOnBehalf: false,
    canEdit: false,
    canComplete: false,
    canFinalise: false,
    canAssignEnquiryContract: false,
    canDelegate: false,
    canCancelDelegation: false
};
/**
 * Function which returns the permissions for each of the possible actions in the negotiation phase of the event.
 *
 * @param event the event to check the permissions for.
 * @param eventIsLatest boolean value to indicate if the event is the last one in the negotiation or if it's a historic one.
 * @param userProfile the user to check the permissions for.
 * @param isEventInSandbox indicates if the event is present within a sandbox.
 * @param isGodMode it means that Corporate Admin can take any action regardless of ownership of the negotiation
 *
 * @deprecated Fuelboss has chartering functionality on ships. instead of updating the logic here we decided to take it out and put it into fuelboss.
 * As discussed marking this as deprecated to notice the chorus team that it might be wise to take this out also and remove the service from the shared library.
 */
function getUserNegotiationPermissions(event, eventIsLatest, userProfile, isEventInSandbox, isGodMode) {
    var userCanAccessNegotiation = isUserAllowed([
        'ROLE_ADMIN',
        'ROLE_CUSTOMER',
        'ROLE_SCHEDULER',
        'ROLE_SCHEDULER_CAPTAIN',
        'ROLE_CORPORATE_ADMIN',
        'ROLE_THIRD_PARTY_SCHEDULER',
        'ROLE_CAPTAIN',
        'ROLE_RECEIVING_CAPTAIN',
        'ROLE_TERMINAL_OPERATOR'
    ], userProfile.roles);
    var eventIsCancelled = event.state === 'CANCELLED';
    var eventIsCompleted = event.state === 'FINALISED' || event.state === 'COMPLETED';
    // return no actions allowed if
    // the user doesn't have the correct role to negotiate
    // OR if the event is not the latest in the history
    // OR the user is indirectly related with the nomination
    if (!userCanAccessNegotiation || !eventIsLatest || eventIsCancelled || eventIsCompleted) {
        return noActionsAllowed;
    }
    else if (!isGodMode && !isNominationBelongsToUsersCompany(event, userProfile)) {
        return noActionsAllowed;
    }
    if (instanceOfNominationTimelineItem(event)) {
        return getNominationNegotiationPermissions(event, eventIsLatest, userProfile, isEventInSandbox);
    }
    else if (instanceOfINominationEnquiryEvent(event)) {
        return getEnquiryNegotiationPermissions(event, eventIsLatest, userProfile);
    }
    else {
        return noActionsAllowed;
    }
}
/**
 * @deprecated Fuelboss has chartering functionality on ships. instead of updating the logic here we decided to take it out and put it into fuelboss.
 * As discussed marking this as deprecated to notice the chorus team that it might be wise to take this out also and remove the service from the shared library.
 */
function getNominationNegotiationPermissions(event, eventIsLatest, userProfile, iseventInSandbox) {
    // checks if the proposal was made by the users company
    var proposalMadeByCurrentUserCompany = proposalMadeByUserCompany(event, userProfile.companyId);
    // The proposal was made by a other company than the users AND the event is not in sandbox mode.
    var counteringPossible = !proposalMadeByCurrentUserCompany && !iseventInSandbox;
    // The company to which the user belongs has made the last change AND the event is not in sandbox mode.
    var onBehalfPossible = proposalMadeByCurrentUserCompany && !iseventInSandbox;
    // Checks to see if various actions are possible based on the current state of the event.
    var hasAcceptOption = isOneOf(event.state, ['PROPOSED', 'COUNTERED', 'REJECTED']);
    var hasRejectOption = isOneOf(event.state, ['PROPOSED', 'COUNTERED']);
    var hasCancelOption = isOneOf(event.state, ['ACCEPTED', 'PROPOSED', 'COUNTERED', 'REJECTED']);
    var hasCompleteOption = isOneOf(event.state, ['ACCEPTED']);
    // Delegated nominations should not have complete allowed for contract holding
    var isContractHolder = userProfile.companyId === event.companyId;
    var isDelegatedNomination = !!event.delegationOriginEventId;
    var hasDelegatedNomination = !!event.delegatedNominationEventId;
    if (isScheduler(userProfile.roles) ||
        isSchedulerCaptain(userProfile.roles) ||
        isCorporateAdmin(userProfile.roles) ||
        isContractParty(userProfile, event)) {
        return {
            // If countering / accepting is possible -> Acceptance is possible.
            // If the event is in pending state, the user can accept the indirect communication.
            canAccept: (counteringPossible && hasAcceptOption) || event.state === 'PENDING',
            // OnBehalf is possible if the users company made the proposal.
            canAcceptOnBehalf: onBehalfPossible && hasAcceptOption,
            // The event can be cancelled if it is in one of the hasCancelOption states.
            canCancel: hasCancelOption && event.state !== 'PENDING' && !isDelegatedNomination,
            canCancelOnBehalf: hasCancelOption && event.state !== 'PENDING',
            // opposing party made the proposal AND the event is in PROPOSED OR COUNTERED State.
            //  Rejection can also be done so the user can reject indirect communication.
            canReject: (counteringPossible && hasRejectOption) || event.state === 'PENDING',
            // user company made the proposal AND the event is in PROPOSED OR COUNTERED State
            canRejectOnBehalf: false,
            canEdit: event.state !== 'PENDING',
            canComplete: hasCompleteOption && !(isContractHolder && isDelegatedNomination),
            canFinalise: false,
            canAssignEnquiryContract: false,
            // Note that getUserNegotiationPermissions checks against cancelled or finished nominations,
            // so no need to do that here too for canDelegate
            canDelegate: isScheduler(userProfile.roles) && !isDelegatedNomination && !hasDelegatedNomination,
            canCancelDelegation: isContractHolder && isDelegatedNomination
        };
    }
    else if (isThirdPartyScheduler(userProfile.roles)) {
        return {
            // opposing party made the proposal AND is in PROPOSED, COUNTERED OR REJECTED STATE
            canAccept: counteringPossible && hasAcceptOption,
            canAcceptOnBehalf: false,
            canCancel: hasCancelOption && event.state !== 'PENDING',
            canCancelOnBehalf: false,
            // opposing party made the proposal AND is in PROPOSED or COUNTERED STATE
            canReject: counteringPossible && hasRejectOption,
            canRejectOnBehalf: false,
            canEdit: eventIsLatest,
            canComplete: hasCompleteOption,
            canFinalise: false,
            canAssignEnquiryContract: false,
            canDelegate: false,
            canCancelDelegation: false
        };
    }
    else if (isCustomer(userProfile.roles)) {
        return {
            // opposing party made the proposal AND is in PROPOSED, COUNTERED OR REJECTED STATE.
            // acceptance is also not possible if the event already has a pending proposal ( means the party on the other side is making a indirect proposal to the vendor )
            canAccept: counteringPossible && hasAcceptOption,
            canAcceptOnBehalf: false,
            canCancel: hasCancelOption && event.state !== 'PENDING',
            canCancelOnBehalf: false,
            canReject: false,
            canRejectOnBehalf: false,
            canEdit: eventIsLatest,
            canComplete: false,
            canFinalise: false,
            canAssignEnquiryContract: false,
            canDelegate: false,
            canCancelDelegation: false
        };
    }
    else if (isCaptain(userProfile.roles)) {
        return {
            canAccept: false,
            canAcceptOnBehalf: false,
            canCancel: false,
            canCancelOnBehalf: false,
            canReject: false,
            canRejectOnBehalf: false,
            canEdit: true,
            canComplete: false,
            canFinalise: false,
            canAssignEnquiryContract: false,
            canDelegate: false,
            canCancelDelegation: false
        };
    }
    else {
        return noActionsAllowed;
    }
}
function isNominationBelongsToUsersCompany(nomination, user) {
    // note that you can both be the "client" and "supplier" at the same time
    // when you're the a contract party delegating a nomination
    return nomination.companyId === user.companyId || nomination.vendorCompanyId === user.companyId;
}
function userCanEditContract(nomination, user, creatingNewNomination) {
    return ((creatingNewNomination || isNominationBelongsToUsersCompany(nomination, user)) &&
        (isAdmin(user.roles) ||
            isCustomer(user.roles) ||
            isScheduler(user.roles, true) ||
            (isSchedulerCaptain(user.roles) && isCaptainOnNomination(user, nomination))));
}
function getNominationNegotiationFieldPermissions(nomination, user, userRoles, creatingNewNomination) {
    var isContractHolder = user.companyId === nomination.companyId;
    var isDelegatedNomination = nomination.delegationOriginEventId;
    var hasDelegatedNomination = nomination.delegatedNominationEventId;
    return {
        vendorReference: (isScheduler(userRoles) || isSchedulerCaptain(userRoles)) &&
            !(isContractHolder && isDelegatedNomination),
        agent: isCustomer(userRoles),
        bunkerShip: (isScheduler(userRoles) || isThirdPartyScheduler(userRoles)) &&
            !(isContractHolder && isDelegatedNomination) &&
            !(isScheduler(userRoles) && hasDelegatedNomination),
        pipeline: isScheduler(userRoles) &&
            !(isContractHolder && isDelegatedNomination) &&
            !(isScheduler(userRoles) && hasDelegatedNomination),
        location: isScheduler(userRoles) || isSchedulerCaptain(userRoles) || isCustomer(userRoles),
        amount: isScheduler(userRoles) || isSchedulerCaptain(userRoles) || isCustomer(userRoles),
        quantityUnit: isScheduler(userRoles) || isSchedulerCaptain(userRoles) || isCustomer(userRoles),
        contractId: isScheduler(userRoles) || isSchedulerCaptain(userRoles),
        allowedBunkeringTime: isScheduler(userRoles) || isSchedulerCaptain(userRoles),
        gasUp: isScheduler(userRoles) || isSchedulerCaptain(userRoles) || isCustomer(userRoles),
        coolDown: isScheduler(userRoles) || isSchedulerCaptain(userRoles) || isCustomer(userRoles),
        tolerance: isScheduler(userRoles) || isSchedulerCaptain(userRoles) || isCustomer(userRoles),
        priceEnabled: isScheduler(userRoles) || isSchedulerCaptain(userRoles),
        price: isScheduler(userRoles) || isSchedulerCaptain(userRoles),
        priceUnit: isScheduler(userRoles) || isSchedulerCaptain(userRoles),
        energyUnit: isScheduler(userRoles) || isSchedulerCaptain(userRoles),
        co2Tax: isScheduler(userRoles) || isSchedulerCaptain(userRoles) || isCustomer(userRoles),
        // bunkership timings
        bunkershipEta: isScheduler(userRoles) || isSchedulerCaptain(userRoles) || isBunkerCaptain(userRoles),
        bunkershipEtd: isScheduler(userRoles) || isSchedulerCaptain(userRoles) || isBunkerCaptain(userRoles),
        bunkershipAta: isScheduler(userRoles) || isSchedulerCaptain(userRoles) || isBunkerCaptain(userRoles),
        bunkershipAtd: isScheduler(userRoles) || isSchedulerCaptain(userRoles) || isBunkerCaptain(userRoles),
        // delivery timings
        bst: isScheduler(userRoles) || isSchedulerCaptain(userRoles) || isCustomer(userRoles),
        deliveryMode: (isScheduler(userRoles) &&
            !(isContractHolder && isDelegatedNomination) &&
            !(isScheduler(userRoles) && hasDelegatedNomination)) ||
            isCustomer(userRoles),
        altFuelPercentage: isScheduler(userRoles) || isSchedulerCaptain(userRoles) || isCustomer(userRoles),
        receivingVessel: isCustomer(userRoles) && creatingNewNomination,
        vendorCompanyId: isCustomer(userRoles) && creatingNewNomination,
        buyerRef: isCustomer(userRoles) ||
            (isScheduler(userRoles) && isDelegatedNomination && isContractHolder ? true : false),
        // receiving vessel timings
        eta: isCustomer(userRoles) || isReceivingCaptain(userRoles),
        ata: isCustomer(userRoles) || isReceivingCaptain(userRoles),
        etd: isCustomer(userRoles) || isReceivingCaptain(userRoles),
        atd: isCustomer(userRoles) || isReceivingCaptain(userRoles)
    };
}
/**
 * @deprecated Fuelboss has chartering functionality on ships. instead of updating the logic here we decided to take it out and put it into fuelboss.
 * As discussed marking this as deprecated to notice the chorus team that it might be wise to take this out also and remove the service from the shared library.
 */
function getEnquiryNegotiationPermissions(event, eventIsLatest, userProfile) {
    var proposalMadeByCurrentUserCompany = proposalMadeByUserCompany(event, userProfile.companyId);
    // The proposal was made by a other company than the users AND the event is not in sandbox mode.
    var counteringPossible = !proposalMadeByCurrentUserCompany;
    var hasAcceptOption = isOneOf(event.state, ['PROPOSED', 'COUNTERED', 'REJECTED']);
    var hasRejectOption = isOneOf(event.state, ['PROPOSED', 'COUNTERED']);
    var hasCancelOption = isOneOf(event.state, ['ACCEPTED', 'PROPOSED', 'COUNTERED', 'REJECTED']);
    var hasFinaliseOption = isOneOf(event.state, ['ACCEPTED']);
    var hasFinaliseProposedOption = !proposalMadeByCurrentUserCompany && event.state === 'PROPOSED';
    var requiresContract = isOneOf(event.state, ['NEEDS_CONTRACT']);
    if (isScheduler(userProfile.roles) || isCorporateAdmin(userProfile.roles)) {
        return {
            // If countering / accepting is possible-> Acceptance is possible.
            canAccept: counteringPossible && hasAcceptOption,
            // Onbehalf never possible for inquiries
            canAcceptOnBehalf: false,
            canCancel: false,
            canCancelOnBehalf: false,
            canReject: counteringPossible && hasRejectOption,
            canRejectOnBehalf: false,
            canEdit: eventIsLatest && !requiresContract,
            canComplete: false,
            canFinalise: false,
            canAssignEnquiryContract: requiresContract,
            canDelegate: false,
            canCancelDelegation: false
        };
    }
    else if (isThirdPartyScheduler(userProfile.roles)) {
        return {
            // opposing party made the proposal AND is in PROPOSED, COUNTERED OR REJECTED STATE
            canAccept: counteringPossible && hasAcceptOption,
            canAcceptOnBehalf: false,
            canCancel: hasCancelOption,
            canCancelOnBehalf: false,
            canReject: counteringPossible && hasRejectOption,
            canRejectOnBehalf: false,
            canEdit: eventIsLatest && !requiresContract,
            canComplete: false,
            canFinalise: false,
            canAssignEnquiryContract: false,
            canDelegate: false,
            canCancelDelegation: false
        };
    }
    else if (isCustomer(userProfile.roles)) {
        return {
            canAccept: counteringPossible && hasAcceptOption && !hasFinaliseProposedOption,
            canAcceptOnBehalf: false,
            canCancel: hasCancelOption,
            canCancelOnBehalf: false,
            canReject: hasRejectOption && !proposalMadeByCurrentUserCompany,
            canRejectOnBehalf: false,
            canEdit: eventIsLatest && !requiresContract,
            canComplete: false,
            canFinalise: hasFinaliseOption || hasFinaliseProposedOption,
            canAssignEnquiryContract: false,
            canDelegate: false,
            canCancelDelegation: false
        };
    }
    else if (isCaptain(userProfile.roles)) {
        return {
            canAccept: false,
            canAcceptOnBehalf: false,
            canCancel: false,
            canCancelOnBehalf: false,
            canReject: false,
            canRejectOnBehalf: false,
            canEdit: false,
            canComplete: false,
            canFinalise: false,
            canAssignEnquiryContract: false,
            canDelegate: false,
            canCancelDelegation: false
        };
    }
    else {
        return noActionsAllowed;
    }
}
function getEnquiryNegotiationFieldPermissions(userRoles) {
    return {
        contractId: isScheduler(userRoles),
        bunkerShipId: isScheduler(userRoles),
        pipelineId: isScheduler(userRoles),
        loadingTerminalId: isScheduler(userRoles),
        receivingVessel: isCustomer(userRoles),
        vendorCompanyId: isCustomer(userRoles),
        agent: isCustomer(userRoles),
        buyerRef: isCustomer(userRoles),
        offerExpiration: isScheduler(userRoles),
        deliveryModes: isScheduler(userRoles) || isCustomer(userRoles),
        location: isScheduler(userRoles) || isCustomer(userRoles),
        amount: isScheduler(userRoles) || isCustomer(userRoles),
        quantityUnit: isScheduler(userRoles) || isCustomer(userRoles),
        gasUp: isScheduler(userRoles) || isCustomer(userRoles),
        coolDown: isScheduler(userRoles) || isCustomer(userRoles),
        grossNet: isScheduler(userRoles) || isCustomer(userRoles),
        priceUnit: isScheduler(userRoles),
        price: isScheduler(userRoles),
        tolerance: isScheduler(userRoles) || isCustomer(userRoles),
        // delivery timings
        bst: isScheduler(userRoles) || isCustomer(userRoles),
        allowedBunkeringTime: isScheduler(userRoles),
        // receiving vessel timings
        eta: isCustomer(userRoles),
        ata: isCustomer(userRoles),
        etd: isCustomer(userRoles),
        atd: isCustomer(userRoles)
    };
}
function getAllowedThirdPartyContactRoles(userRole) {
    var contactRoles = [
        {
            text: 'PORT Authority',
            value: 'PORT_AUTHORITY'
        },
        {
            text: 'Agent',
            value: 'AGENT'
        },
        {
            text: 'Other',
            value: 'OTHER'
        }
    ];
    if (isSupplier(userRole)) {
        return __spreadArrays([
            {
                text: 'Truck Operator',
                value: 'TRUCKING'
            }
        ], contactRoles);
    }
    else {
        return contactRoles;
    }
}

function handleFetchError(error) {
    console.error(error);
    if (error.status !== 401 && error.status !== 404) {
        toast.error(error.toString(), { autoClose: 20000 });
    }
}
/**
 * Stringify an object with parameters into a query string.
 * For example:
 *
 *     stringifyParams({name: 'my name', age: 30}) // 'name=my%20name&age=30'
 */
function stringifyParams(params) {
    return Object.keys(params)
        .filter(function (name) { return params[name] !== null && params[name] !== undefined; })
        .map(function (name) {
        return params[name] instanceof Array
            ? encodeURIComponent(name) + "=" + encodeURIComponent(params[name].join(','))
            : encodeURIComponent(name) + "=" + encodeURIComponent(params[name]);
    })
        .join('&');
}
function handleResponseDownloadFile(response, fileName) {
    if (response.status < 200 || response.status >= 300) {
        var error = {
            message: 'download file error',
            response: response,
            status: response.status,
        };
        return Promise.reject(error);
    }
    return response.blob().then(function (blob) {
        /** @type {HTMLAnchorElement} */
        // @ts-ignore
        var downloadTrigger = document.getElementById('downloadTrigger');
        var ie = navigator.userAgent.match(/MSIE\s([\d.]+)/), ie11 = navigator.userAgent.match(/Trident\/7.0/) && navigator.userAgent.match(/rv:11/), ieEDGE = navigator.userAgent.match(/Edge/g), ieVer = ie ? ie[1] : ie11 ? 11 : ieEDGE ? 12 : -1;
        if (ie && ieVer < 10) {
            toast.error('Downloading files is not supported on IE version < 10');
            return;
        }
        if (ieVer > -1) {
            window.navigator.msSaveBlob(blob, fileName);
        }
        else {
            var url = window.URL.createObjectURL(blob);
            var downloadLink = document.createElement('a');
            downloadLink.setAttribute('href', url);
            downloadLink.setAttribute('class', 'hidden-download-button');
            downloadLink.setAttribute('download', fileName);
            downloadLink.click();
            window.URL.revokeObjectURL(url);
        }
    });
}
function handleRestResponseWithoutBody(response) {
    if (response.status >= 200 && response.status < 300) {
        return Promise.resolve();
    }
    else {
        return Promise.resolve(response.json())
            .catch(function (err) { return ({ status: response.status, message: err.message }); })
            .then(function (restError) {
            throw new FetchError(restError.status, restError.error, restError.message);
        });
    }
}

function getPromptEventHistory(authenticationService, eventId, sandboxId) {
    var options = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    };
    var sandboxIdUrl = sandboxId && sandboxId !== SANDBOX_ID_LIVE ? '/' + sandboxId : '';
    return authenticationService.fetchApiCall("/prompt" + sandboxIdUrl + "/event/" + eventId + "/history", options);
}
function getEnquiryHistory(authenticationService, enquiryId) {
    var options = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    };
    return authenticationService.fetchApiCall("/prompt/event/" + enquiryId + "/history", options);
}
function postPromptProposalState(authenticationService, proposalId, newState, onBehalf, reason, sandboxId) {
    var options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            newState: newState,
            onBehalf: onBehalf
        })
    };
    var query = '?';
    if (reason) {
        query += 'reason=' + reason;
    }
    var sandboxIdUrl = sandboxId && sandboxId !== SANDBOX_ID_LIVE ? '/' + sandboxId : '';
    return authenticationService.fetchApiCall("/prompt" + sandboxIdUrl + "/event/" + proposalId + "/setState" + query, options);
}
function acceptPendingPromptProposal(authenticationService, proposalId) {
    var options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        }
    };
    return authenticationService.fetchApiCall("/prompt/event/" + proposalId + "/acceptPending", options);
}
function completeDelivery(authenticationService, event, eventId) {
    if (!event._type) {
        event._type = 'nomination';
    }
    // Unset the _id because there will be a counter proposal made (with different _id)
    if (event._id) {
        event._id = undefined;
    }
    var options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(event)
    };
    return authenticationService.fetchApiCall("/prompt/event/delivery/" + eventId, options);
}
function createNewPromptNomination(authenticationService, nomination) {
    // unset nomination fields when creating ( just to make sure these are not set accidentally )
    nomination._id = undefined;
    nomination.state = undefined;
    nomination.remark = undefined;
    nomination.created = undefined;
    nomination.author = undefined;
    nomination.reactionTime = undefined;
    nomination.recipient = undefined;
    nomination._type = 'nomination';
    var options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(nomination)
    };
    return authenticationService.fetchApiCall("/prompt/event", options);
}
function getEnquiryList(authenticationService) {
    var options = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    };
    return authenticationService.fetchApiCall("/spotenquiry", options);
}
function createNewSpotEnquiry(authenticationService, spotEnquiry, vendorCompanies) {
    var options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            spotEnquiry: spotEnquiry,
            vendorCompanies: vendorCompanies
        })
    };
    return authenticationService.fetchApiCall("/spotenquiry", options);
}
function amendPromptNomination(authenticationService, nomination, accept) {
    if (accept === void 0) { accept = false; }
    var options = {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(nomination)
    };
    var sandbox = nomination.sandboxId && nomination.sandboxId !== SANDBOX_ID_LIVE
        ? "/" + nomination.sandboxId
        : '';
    return authenticationService.fetchApiCall("/prompt" + sandbox + "/event/" + nomination._id + "?accept=" + accept, options);
}
function amendSpotEnquiry(authenticationService, spotEnquiry) {
    var options = {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(spotEnquiry)
    };
    return authenticationService.fetchApiCall("/prompt/event/" + spotEnquiry._id, options);
}
function cancelDelegation(authenticationService, originNominationId, reason) {
    var options = {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ reason: reason || null })
    };
    return authenticationService.fetchApiCall("/prompt/event/" + originNominationId + "/delegate", options, handleRestResponseWithoutBody);
}
function counterPromptNomination(authenticationService, nomination) {
    // unset nomination fields when doing a counter proposal ( effectively creating a new nomination )
    nomination._id = undefined;
    nomination.state = undefined;
    nomination.remark = undefined;
    nomination.created = undefined;
    nomination.author = undefined;
    nomination.reactionTime = undefined;
    nomination.recipient = undefined;
    nomination._type = 'nomination';
    var options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(nomination)
    };
    return authenticationService.fetchApiCall("/prompt/event/counter/" + nomination.eventId, options);
}
function counterSpotEnquiry(authenticationService, spotEnquiry) {
    spotEnquiry._id = undefined;
    spotEnquiry.author = undefined;
    var options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(spotEnquiry)
    };
    return authenticationService.fetchApiCall("/prompt/event/counter/" + spotEnquiry.eventId, options);
}
function putPromptEventSandbox(authenticationService, event, sandboxId, id) {
    if (!event._type) {
        event._type = 'nomination';
    }
    var options = {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(event)
    };
    if (!id) {
        options.method = 'POST';
    }
    var idUrl = id ? '/' + id : '';
    return authenticationService.fetchApiCall("/prompt/" + sandboxId + "/event" + idUrl, options);
}
function getCompanyFleetList(authenticationService, companyId, includeCharteredVessels) {
    if (includeCharteredVessels === void 0) { includeCharteredVessels = undefined; }
    var options = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    };
    var params = stringifyParams({ includeCharteredVessels: includeCharteredVessels });
    return authenticationService.fetchApiCall("/" + SHIP_TYPE_REQUEST.CUSTOMERSHIP + "/" + companyId + "?" + params, options);
}
function getAllProfiles(authenticationService) {
    var options = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    };
    return authenticationService.fetchApiCall("/profiles", options);
}
function getUserPermissions(authenticationService) {
    var options = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    };
    return authenticationService.fetchApiCall("/profiles/permissions", options);
}
function getAllCompanies(authenticationService) {
    var options = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    };
    return authenticationService.fetchApiCall("/companies", options);
}
function getBunkerShips(authenticationService, vendorCompanyId, includeCharteredVessels) {
    if (includeCharteredVessels === void 0) { includeCharteredVessels = undefined; }
    var options = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    };
    var query = stringifyParams({ vendorCompanyId: vendorCompanyId, includeCharteredVessels: includeCharteredVessels });
    return authenticationService.fetchApiCall("/" + SHIP_TYPE_REQUEST.BUNKERSHIP + "?" + query, options);
}
function putCharterebleShip(authenticationService, shipType, shipId, charteble) {
    var options = {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ charterable: charteble })
    };
    return authenticationService.fetchApiCall("/" + shipType + "/" + shipId + "/charterable", options);
}
function putBunkerShip(authenticationService, bunkerShip) {
    var options = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(bunkerShip)
    };
    return authenticationService.fetchApiCall("/" + SHIP_TYPE_REQUEST.BUNKERSHIP + "/" + bunkerShip._id, options);
}
function postBunkerShip(authenticationService, bunkerShip) {
    var options = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(bunkerShip)
    };
    return authenticationService.fetchApiCall("/" + SHIP_TYPE_REQUEST.BUNKERSHIP, options);
}
function uploadDocument(authenticationService, companyId, type, file, fileName) {
    var formData = new FormData();
    formData.append('file', file, fileName);
    var options = {
        method: 'POST',
        headers: {},
        body: formData
    };
    var query = '?';
    if (companyId) {
        query += "companyId=" + companyId + "&";
    }
    if (type) {
        query += "type=" + type + "&";
    }
    return authenticationService.fetchApiCall("/documents/upload" + query, options);
}
function uploadEBDNFile(authenticationService, file, fileName, nominationId) {
    var formData = new FormData();
    formData.append('file', file, fileName);
    var options = {
        method: 'POST',
        headers: {},
        body: formData
    };
    return authenticationService.fetchApiCall("/prompt/event/ebdn/" + nominationId + "/spreadsheet", options);
}
function updateDocument(authenticationService, file) {
    var options = {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(file)
    };
    return authenticationService.fetchApiCall("/documents/" + file._id, options);
}
function getMaxDocumentSize(authenticationService) {
    var options = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    };
    return authenticationService.fetchApiCall("/documents/maxSize", options);
}
function getPromptEventsForUser(authenticationService, userProfile, start, end, bunkerShipIdOrigin, vendorCompanyId, types, limit, skip) {
    var options = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    };
    var url = '/prompt/schedule/latest';
    var userRoles = userProfile ? userProfile.roles : undefined;
    if (isBunkerCaptain(userRoles) || bunkerShipIdOrigin) {
        var bunkerShipId = bunkerShipIdOrigin
            ? bunkerShipIdOrigin
            : userProfile
                ? userProfile.bunkerShipId
                : undefined;
        url = "/prompt/schedule/bunkerShip/" + bunkerShipId;
    }
    else if (isReceivingCaptain(userRoles) && userProfile) {
        var receivingShipId = userProfile.receivingShipId;
        url = "/prompt/schedule/receivingShip/" + receivingShipId;
    }
    else if (isOperator(userRoles) && userProfile) {
        var pipelineId = userProfile.pipelineId;
        url = "/prompt/schedule/pipeline/" + pipelineId;
    }
    var queryParams = stringifyParams({ start: start, end: end, vendorCompanyId: vendorCompanyId, types: types, limit: limit, skip: skip });
    return authenticationService.fetchApiCall(url + "?" + queryParams, options);
}
function getPromptNominationsForUser(authenticationService, userProfile, start, end, bunkerShipIdOrigin, vendorCompanyId, limit, skip) {
    var options = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    };
    var url = '/prompt/schedule/latest';
    var userRoles = userProfile ? userProfile.roles : undefined;
    if (isBunkerCaptain(userRoles) || bunkerShipIdOrigin) {
        var bunkerShipId = bunkerShipIdOrigin
            ? bunkerShipIdOrigin
            : userProfile
                ? userProfile.bunkerShipId
                : undefined;
        url = "/prompt/schedule/bunkerShip/" + bunkerShipId;
    }
    else if (isReceivingCaptain(userRoles) && userProfile) {
        var receivingShipId = userProfile.receivingShipId;
        url = "/prompt/schedule/receivingShip/" + receivingShipId;
    }
    else if (isOperator(userRoles) && userProfile) {
        var pipelineId = userProfile.pipelineId;
        url = "/prompt/schedule/pipeline/" + pipelineId;
    }
    var queryParams = stringifyParams({
        start: start,
        end: end,
        vendorCompanyId: vendorCompanyId,
        types: ['nomination'],
        limit: limit,
        skip: skip,
        sort: true
    });
    return authenticationService.fetchApiCall(url + "?" + queryParams, options);
}
function generateStatementOfFacts(authenticationService, promptEventId) {
    var options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        }
    };
    return authenticationService.fetchApiCall("/sof/" + promptEventId + "/createDocument", options);
}
function getShipsById(authenticationService, shipIds) {
    var options = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(shipIds)
    };
    return authenticationService.fetchApiCall("/" + SHIP_TYPE_REQUEST.CUSTOMERSHIP + "/idlist", options);
}
function getCharterebleShips(authenticationService, shipType) {
    var options = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    };
    return authenticationService.fetchApiCall("/" + shipType + "/charterable", options);
}
function putCharterShip(authenticationService, shipType, shipId, activeInFleet) {
    var options = {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ activeInFleet: activeInFleet })
    };
    return authenticationService.fetchApiCall("/" + shipType + "/" + shipId + "/charterers", options);
}
function getSofConfigurationList(authenticationService, companyId) {
    var options = {
        // depending on if the id of the configuration is present, we either
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    };
    return authenticationService.fetchApiCall("/companies/" + companyId + "/sofConfiguration", options);
}
function updateStatementOfFactsConfiguration(authenticationService, configuration, companyId) {
    var options = {
        // depending on if the id of the configuration is present, we either
        method: configuration._id ? 'PUT' : 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(configuration)
    };
    return authenticationService.fetchApiCall("/companies/" + companyId + "/sofConfiguration" + (configuration._id ? "/" + configuration._id : ''), options);
}
function deleteSofConfiguration(authenticationService, companyId, configurationId) {
    var options = {
        headers: { 'Content-Type': 'application/json' },
        method: 'DELETE'
    };
    return authenticationService.fetchApiCall("/companies/" + companyId + "/sofConfiguration/" + configurationId, options, handleRestResponseWithoutBody);
}
function getStatementOfFacts(authenticationService, eventId) {
    var options = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    };
    return authenticationService.fetchApiCall("/sof/" + eventId, options);
}
function createStatementOfFacts(authenticationService, eventId, sofOptions, configuration) {
    var options = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            configuration: configuration || {},
            options: sofOptions
        })
    };
    return authenticationService.fetchApiCall("/sof/" + eventId + "/create", options);
}
function updateStatementOfFacts(authenticationService, eventId, timestamps) {
    var options = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(timestamps)
    };
    return authenticationService.fetchApiCall("/sof/" + eventId, options);
}
function getBdnConfigurationList(authenticationService, companyId) {
    var options = {
        // depending on if the id of the configuration is present, we either
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    };
    return authenticationService.fetchApiCall("/companies/" + companyId + "/ebdnConfiguration", options);
}
function updatBdnConfiguration(authenticationService, configuration, companyId) {
    var options = {
        // depending on if the id of the configuration is present, we either
        method: configuration._id ? 'PUT' : 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(configuration)
    };
    return authenticationService.fetchApiCall("/companies/" + companyId + "/ebdnConfiguration" + (configuration._id ? "/" + configuration._id : ''), options);
}
function deleteBdnConfiguration(authenticationService, companyId, configurationId) {
    var options = {
        headers: { 'Content-Type': 'application/json' },
        method: 'DELETE'
    };
    return authenticationService.fetchApiCall("/companies/" + companyId + "/ebdnConfiguration/" + configurationId, options, handleRestResponseWithoutBody);
}
function signDocument(authenticationService, eventWithDocument, documentId, documentType, supplierUserId, customerUserId, 
// externalCustomer?: ExternalSigner,
externalSupplier, otherExternalSigners) {
    return __awaiter(this, void 0, void 0, function () {
        var signers, options;
        return __generator(this, function (_a) {
            signers = {
                supplierUserId: supplierUserId,
                customerUserId: customerUserId,
                externalSupplier: externalSupplier,
                otherExternalSigners: otherExternalSigners
            };
            options = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(signers)
            };
            switch (documentType) {
                case documentType.startsWith('SAFETY_CHECKLIST_') ? documentType : '':
                    return [2 /*return*/, authenticationService.fetchApiCall("/safetychecklist/" + eventWithDocument.eventId + "/sign/" + documentId, options)];
                case 'EBDN':
                    return [2 /*return*/, authenticationService.fetchApiCall("/prompt/event/ebdn/" + eventWithDocument.eventId + "/" + documentId + "/signDocument", options)];
                case 'STATEMENT_OF_FACTS':
                    return [2 /*return*/, authenticationService.fetchApiCall("/sof/" + eventWithDocument.eventId + "/" + documentId + "/signDocument", options)];
                case 'MASTERS_REQUISITION_FORM':
                    return [2 /*return*/, authenticationService.fetchApiCall("/mrf/" + eventWithDocument.eventId + "/" + documentId + "/signDocument", options)];
                case 'NOR_BUNKERSHIP':
                case 'NOR_RECEIVINGSHIP':
                    return [2 /*return*/, authenticationService.fetchApiCall("/nor/" + eventWithDocument.eventId + "/" + documentId + "/signDocument", options)];
                default:
                    return [2 /*return*/, null];
            }
            return [2 /*return*/];
        });
    });
}
function signIAPHPartF(authenticationService, eventId, documentId, externalSigner) {
    return __awaiter(this, void 0, void 0, function () {
        var options;
        return __generator(this, function (_a) {
            options = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(__assign({}, externalSigner))
            };
            return [2 /*return*/, authenticationService.fetchApiCall("/safetychecklist/signPartF/" + eventId + "/" + documentId, options)];
        });
    });
}
function signIAPHPartATIS(authenticationService, eventId, documentId, jpboExternalSignRequest) {
    return __awaiter(this, void 0, void 0, function () {
        var options;
        return __generator(this, function (_a) {
            options = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(__assign({}, jpboExternalSignRequest))
            };
            return [2 /*return*/, authenticationService.fetchApiCall("/safetychecklist/IaphV2/signPartA/" + eventId + "/" + documentId, options)];
        });
    });
}
function convertTentativeToFirm(authenticationService, tentativeEvent) {
    var options = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(tentativeEvent)
    };
    return authenticationService.fetchApiCall("/prompt/event/convertTentative/" + tentativeEvent._id, options);
}
function getProfilesByShipId(authenticationService, shipId) {
    var options = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    };
    return authenticationService.fetchApiCall("/profiles/byShip/" + shipId, options);
}
function getProfilesByBunkerShipId(authenticationService, bunkershipId) {
    var options = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    };
    return authenticationService.fetchApiCall("/profiles/byBunkership/" + bunkershipId, options);
}
function getProfilesByLocationId(authenticationService, locationId) {
    var options = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    };
    return authenticationService.fetchApiCall("/profiles/byLoadingFacility/" + locationId, options);
}
function getLocations(authenticationService, filter) {
    var options = {
        headers: { 'Content-Type': 'application/json' },
        method: 'GET'
    };
    var queryParams = stringifyParams({ filter: filter });
    return authenticationService.fetchApiCall("/location?" + queryParams, options);
}
function getLocationById(authenticationService, locationId) {
    var options = {
        headers: { 'Content-Type': 'application/json' },
        method: 'GET'
    };
    return authenticationService.fetchApiCall("/location/" + locationId, options);
}
function getAllPipelines(authenticationService) {
    var options = {
        headers: { 'Content-Type': 'application/json' },
        method: 'GET'
    };
    return authenticationService.fetchApiCall("/pipelines", options);
}
function getComments(authenticationService, objectId) {
    var options = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    };
    return authenticationService.fetchApiCall("/comments/" + objectId, options);
}
function postComment(authenticationService, objectId, comment, userProfile) {
    var options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ text: comment, author: userProfile })
    };
    return authenticationService.fetchApiCall("/comments/" + objectId, options);
}
function getIAPHHelpText(authenticationService) {
    return __awaiter(this, void 0, void 0, function () {
        var options;
        return __generator(this, function (_a) {
            options = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            };
            return [2 /*return*/, authenticationService.fetchApiCall("/iaph/helpTexts", options)];
        });
    });
}
function getSafetyChecklist(authenticationService, eventId) {
    return __awaiter(this, void 0, void 0, function () {
        var options;
        return __generator(this, function (_a) {
            options = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            };
            return [2 /*return*/, authenticationService.fetchApiCall("/safetychecklist/" + eventId, options)];
        });
    });
}
function updateSafetyChecklist(authenticationService, eventId, safetyChecklist) {
    var options = {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(safetyChecklist)
    };
    return authenticationService.fetchApiCall("/safetychecklist/" + eventId, options);
}
function createSafetyChecklist(authenticationService, eventId, safetyChecklistType) {
    return __awaiter(this, void 0, void 0, function () {
        var options;
        return __generator(this, function (_a) {
            options = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ type: safetyChecklistType })
            };
            return [2 /*return*/, authenticationService.fetchApiCall("/safetychecklist/" + eventId, options)];
        });
    });
}
function setSafetyChecklistValue(authenticationService, eventId, checklistValueUpdate) {
    var options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(checklistValueUpdate)
    };
    return authenticationService.fetchApiCall("/safetychecklist/" + eventId + "/checklistValue", options);
}
function setSafetyChecklistRemarkValue(authenticationService, eventId, remarkUpdate) {
    var options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(remarkUpdate)
    };
    return authenticationService.fetchApiCall("/safetychecklist/" + eventId + "/checklistRemark", options);
}
function setSafetyChecklistAgreementValue(authenticationService, eventId, agreementUpdate) {
    var options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(agreementUpdate)
    };
    return authenticationService.fetchApiCall("/safetychecklist/" + eventId + "/alignmentAgreement", options);
}
function addSafetyChecklistSimOpsCheck(authenticationService, eventId, simOpsType) {
    var options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        // add empty check object
        body: JSON.stringify({
            bunkerShip: 'BLANK',
            receivingShip: 'BLANK',
            text: ''
        })
    };
    return authenticationService.fetchApiCall("/safetychecklist/" + eventId + "/simops/" + simOpsType, options);
}
function useSafetyChecklistSimops(authenticationService, eventId, enabled) {
    return __awaiter(this, void 0, void 0, function () {
        var options;
        return __generator(this, function (_a) {
            options = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            };
            return [2 /*return*/, authenticationService.fetchApiCall("/safetychecklist/" + eventId + "/useSimops?enabled=" + enabled, options)];
        });
    });
}
function setSafetyChecklisTransferData(authenticationService, eventId, transferData) {
    var options = {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(transferData)
    };
    return authenticationService.fetchApiCall("/safetychecklist/" + eventId + "/transferdata", options);
}
function setSafetyChecklistItemNotApplicable(authenticationService, eventId, checklistItemId, value, checklistType) {
    var options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            checklistType: checklistType,
            id: checklistItemId,
            value: value
        })
    };
    return authenticationService.fetchApiCall("/safetychecklist/" + eventId + "/setApplicable", options);
}
function setGothenburgOpsPlanData(authenticationService, eventId, transferData) {
    var options = {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(transferData)
    };
    return authenticationService.fetchApiCall("/safetychecklist/" + eventId + "/gothenburgOpsPlan", options);
}
function setSafetyChecklistIntervals(authenticationService, eventId, interval, value) {
    var _a;
    var options = {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify((_a = {}, _a[interval] = value, _a))
    };
    return authenticationService.fetchApiCall("/safetychecklist/" + eventId + "/intervals", options);
}
/**
 * Create a export from all visits and cargo operations details to Excel
 */
function downloadSafetyChecklistsRepetitiveChecks(authenticationService, eventId, filename) {
    var options = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    };
    return authenticationService.fetchApiCall("/safetychecklist/" + eventId + "/repetitiveChecklist", options, function (response) {
        return handleResponseDownloadFile(response, filename || 'iaph-repetitive-checks.pdf');
    });
}
function generateSafetyChecklistDocument(authenticationService, eventId, part) {
    return __awaiter(this, void 0, void 0, function () {
        var options;
        return __generator(this, function (_a) {
            options = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            };
            return [2 /*return*/, authenticationService.fetchApiCall("/safetychecklist/" + eventId + "/generate/" + part, options)];
        });
    });
}
function getSafetyChecklistHelpText(authenticationService, eventId) {
    return __awaiter(this, void 0, void 0, function () {
        var options, queryParams;
        return __generator(this, function (_a) {
            options = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            };
            queryParams = stringifyParams({ eventId: eventId });
            return [2 /*return*/, authenticationService.fetchApiCall("/safetychecklist/helpTexts?" + queryParams, options)];
        });
    });
}
function getPrefilledEBDN(authenticationService, id) {
    return __awaiter(this, void 0, void 0, function () {
        var options;
        return __generator(this, function (_a) {
            options = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' }
            };
            return [2 /*return*/, authenticationService.fetchApiCall("/prompt/event/ebdn/" + id + "/spreadsheet", options, function (response) {
                    return handleResponseDownloadFile(response, "ebdn-" + id + ".xlsx");
                })];
        });
    });
}
function getCurrentEBDN(authenticationService, id) {
    var options = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    };
    return authenticationService.fetchApiCall("/prompt/event/ebdn/" + id, options);
}
function createNewBDN(authenticationService, id, configuration) {
    var options = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(configuration)
    };
    return authenticationService.fetchApiCall("/prompt/event/ebdn/" + id + "/create", options);
}
function updateBDNDetails(authenticationService, id, bdnDetails) {
    var options = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(bdnDetails)
    };
    return authenticationService.fetchApiCall("/prompt/event/ebdn/" + id + "/details", options);
}
function updateCTMSData(authenticationService, id, ctmsData) {
    var options = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(ctmsData)
    };
    return authenticationService.fetchApiCall("/prompt/event/ebdn/" + id + "/ctmsData", options);
}
function updateLNGComposition(authenticationService, id, lngComposition) {
    var options = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(lngComposition)
    };
    return authenticationService.fetchApiCall("/prompt/event/ebdn/" + id + "/lngComposition", options);
}
function updateLNGProperties(authenticationService, id, lngProperties) {
    var options = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(lngProperties)
    };
    return authenticationService.fetchApiCall("/prompt/event/ebdn/" + id + "/lngProperties", options);
}
function updateLNGQuantity(authenticationService, id, lngQuantity) {
    var options = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(lngQuantity)
    };
    return authenticationService.fetchApiCall("/prompt/event/ebdn/" + id + "/quantity", options);
}
function calculateBDNProperties(authenticationService, eventId) {
    var options = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
    };
    return authenticationService.fetchApiCall("/prompt/event/ebdn/" + eventId + "/calculateLngProperties", options);
}
function calculateBDNQuantity(authenticationService, eventId, lngQualityInput) {
    var options = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(lngQualityInput)
    };
    return authenticationService.fetchApiCall("/prompt/event/ebdn/" + eventId + "/calculateQuantity", options);
}
function createSignableBDNDocument(authenticationService, id) {
    var options = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
    };
    return authenticationService.fetchApiCall("/prompt/event/ebdn/" + id + "/createDocument/", options);
}
function updateBunkershipLNGComposition(authenticationService, id, lngComposition, assetType) {
    var options = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(lngComposition)
    };
    return authenticationService.fetchApiCall("/" + (assetType === 'SHIP' ? 'bunkerships' : 'pipelines') + "/" + id + "/composition", options);
}
function updateBunkershipLNGProperties(authenticationService, id, lngProperties, assetType) {
    var options = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(lngProperties)
    };
    return authenticationService.fetchApiCall("/" + (assetType === 'SHIP' ? 'bunkerships' : 'pipelines') + "/" + id + "/properties", options);
}
function updateBunkershipLNGQuality(authenticationService, id, lngQuality, qualityType) {
    var options = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(lngQuality)
    };
    return authenticationService.fetchApiCall("/" + SHIP_TYPE_REQUEST.BUNKERSHIP + "/" + id + "/" + qualityType, options);
}
function calculateBunkershipLNGComposition(authenticationService, id) {
    var options = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
    };
    return authenticationService.fetchApiCall("/" + SHIP_TYPE_REQUEST.BUNKERSHIP + "/" + id + "/calculateComposition", options);
}
/**
 * Create a export from all visits and cargo operations details to Excel
 */
function downloadFileFromBackend(authenticationService, documentId, fileName, eventId) {
    var options = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    };
    var url = eventId
        ? "/prompt/event/" + eventId + "/document/" + documentId + "/download"
        : "/documents/download/" + documentId;
    return authenticationService.fetchApiCall(url, options, function (response) {
        return handleResponseDownloadFile(response, fileName);
    });
}
function getNominationsExport(authenticationService, startDate, endDate) {
    var options = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    };
    return authenticationService.fetchApiCall("/export/nominations?startTime=" + startDate + "&endTime=" + endDate, options, function (response) {
        return handleResponseDownloadFile(response, 'nominations.xlsx');
    });
}
function getLatestPromptSchedule(authenticationService, sandboxId, start, end, vendorCompanyId) {
    var options = {
        headers: { 'Content-Type': 'application/json' },
        method: 'GET'
    };
    var sandbox = sandboxId && sandboxId !== SANDBOX_ID_LIVE ? "/" + sandboxId : '';
    var queryParams = stringifyParams({ start: start, end: end, vendorCompanyId: vendorCompanyId });
    // /v1/prompt/schedule/thirdparty/{supplierId}
    return authenticationService.fetchApiCall("/prompt" + sandbox + "/schedule/latest?" + queryParams, options);
}
function getSinglePromptEvent(authenticationService, eventId, sandboxId) {
    var options = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    };
    var sandbox = sandboxId && sandboxId !== SANDBOX_ID_LIVE ? "/" + sandboxId : '';
    return authenticationService.fetchApiCall("/prompt" + sandbox + "/" + eventId, options);
}
function updatePromptEventBlock(authenticationService, event) {
    var options = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(event)
    };
    var sandbox = event.sandboxId && event.sandboxId !== SANDBOX_ID_LIVE ? "/" + event.sandboxId : '';
    return authenticationService.fetchApiCall("/prompt" + sandbox + "/event/" + event._id, options);
}
function postPromptEventBlock(authenticationService, event) {
    var options = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(event)
    };
    var sandboxId = event.sandboxId && event.sandboxId !== SANDBOX_ID_LIVE ? "/" + event.sandboxId : '';
    return authenticationService.fetchApiCall("/prompt" + sandboxId + "/event", options);
}
function removePromptEventBlock(authenticationService, id, sandboxId) {
    var options = {
        headers: { 'Content-Type': 'application/json' },
        method: 'DELETE'
    };
    var url = sandboxId && sandboxId !== SANDBOX_ID_LIVE
        ? "/prompt/" + sandboxId + "/event/" + id
        : "/prompt/event/" + id;
    return authenticationService.fetchApiCall(url, options, handleRestResponseWithoutBody);
}
function getSandboxList(authenticationService) {
    var options = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    };
    // TODO: Add vendorCompanyId ???
    return authenticationService.fetchApiCall("/sandbox", options);
}
function getContractsList(authenticationService) {
    var options = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    };
    return authenticationService.fetchApiCall("/contracts", options);
}
function addContractToEnquiry(authenticationService, event, contractId) {
    var options = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: contractId
    };
    return authenticationService.fetchApiCall("/prompt/event/assignContract/" + event._id + "\n  ", options);
}
function createOrderConfirmation(authenticationService, eventId) {
    var options = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: ''
    };
    return authenticationService.fetchApiCall("/prompt/event/" + eventId + "/orderConfirmation", options);
}
//#region  3rd Party Contact
function getThirdPartyContacts(authenticationService, companyId, contactId) {
    var options = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    };
    var endPoint = contactId
        ? "/companies/" + companyId + "/thirdpartycontact/" + contactId // get single contact
        : "/companies/" + companyId + "/thirdpartycontact"; // get all contacts
    return authenticationService.fetchApiCall(endPoint, options);
}
function addThirdPartyContact(authenticationService, companyId, contact) {
    var options = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(contact)
    };
    var endPoint = "/companies/" + companyId + "/thirdpartycontact";
    return authenticationService.fetchApiCall(endPoint, options);
}
function getThirdPartyContactByIds(authenticationService, companyId, thirdPartyContactIds) {
    var options = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(thirdPartyContactIds)
    };
    var endPoint = "/companies/" + companyId + "/thirdpartycontact/idlist";
    return authenticationService.fetchApiCall(endPoint, options);
}
function deleteThirdPartyContacts(authenticationService, companyId, contactId) {
    var options = {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' }
    };
    var endPoint = "/companies/" + companyId + "/thirdpartycontact/" + contactId;
    return authenticationService.fetchApiCall(endPoint, options, handleRestResponseWithoutBody);
}
function updateThirdPartyContact(authenticationService, companyId, contactId, update) {
    var options = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(update)
    };
    var endPoint = "/companies/" + companyId + "/thirdpartycontact/" + contactId;
    return authenticationService.fetchApiCall(endPoint, options);
}
function createDelegation(authenticationService, id, supplierId) {
    var options = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ delegatedSupplierId: supplierId })
    };
    return authenticationService.fetchApiCall("/prompt/event/" + id + "/delegate", options, handleRestResponseWithoutBody);
}
function saveMRF(authenticationService, eventId, mrf) {
    var options = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(mrf)
    };
    return authenticationService.fetchApiCall("/mrf/" + eventId, options);
}
function createMRF(authenticationService, eventId) {
    var options = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
    };
    return authenticationService.fetchApiCall("/mrf/" + eventId + "/createDocument", options);
}
function getMRF(authenticationService, eventId) {
    var options = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    };
    return authenticationService.fetchApiCall("/mrf/" + eventId, options);
}
function createNOR(authenticationService, eventId, datetime) {
    var options = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(datetime)
    };
    return authenticationService.fetchApiCall("/nor/" + eventId, options);
}
function getSignURL(authenticationService, documentId) {
    var options = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    };
    return authenticationService.fetchApiCall("/documents/sign/" + documentId, options);
}

var UserPermissionContext = React__default.createContext({
    userPermissions: [],
});
var UserPermissionProvider = function (props) {
    var _a = useState([]), userPermissions = _a[0], setUserPermissions = _a[1];
    useEffect(function () {
        fetchUserPermissions();
    }, [props.userProfile]);
    function fetchUserPermissions() {
        return __awaiter(this, void 0, void 0, function () {
            var permissions, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, getUserPermissions(props.authenticationService)];
                    case 1:
                        permissions = _a.sent();
                        if (permissions) {
                            setUserPermissions(permissions);
                        }
                        else {
                            setUserPermissions([]);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        handleFetchError(error_1);
                        setUserPermissions([]);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    return (React__default.createElement(UserPermissionContext.Provider, { value: {
            userPermissions: userPermissions,
        } }, props.children));
};

var ShowWithPermission = function (_a) {
    var permission = _a.permission, _b = _a.match, match = _b === void 0 ? 'ALL' : _b, children = _a.children;
    var userPermissions = useContext(UserPermissionContext).userPermissions;
    var hasPermission = typeof permission === 'string'
        ? doesUserHavePermission(userPermissions, permission)
        : (match === 'ALL' ? permission.filter(function (permission) { return !doesUserHavePermission(userPermissions, permission); }).length === 0
            : permission.filter(function (permission) { return doesUserHavePermission(userPermissions, permission); }).length > 0);
    return hasPermission ? React__default.createElement(React__default.Fragment, null, children) : null;
};
React__default.memo(ShowWithPermission);

// Hook
function useOnClickOutside(ref, handler) {
    useEffect(function () {
        var listener = function (event) {
            // Do nothing if clicking ref's element or descendent elements
            if (!ref.current || ref.current.contains(event.target)) {
                return;
            }
            handler(event);
        };
        document.addEventListener('mousedown', listener);
        document.addEventListener('touchstart', listener);
        return function () {
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
        };
    }, 
    // Add ref and handler to effect dependencies
    // It's worth noting that because passed in handler is a new ...
    // ... function on every render that will cause this effect ...
    // ... callback/cleanup to run every render. It's not a big deal ...
    // ... but to optimize you can wrap handler in useCallback before ...
    // ... passing it into this hook.
    [ref, handler]);
}

/**
 * A custom useEffect hook that only triggers on updates, not on initial mount
 * Idea stolen from: https://stackoverflow.com/a/55075818/1526448
 * @param {Function} effect
 * @param {Array<any>} dependencies
 */
function useUpdateEffect(effect, dependencies) {
    if (dependencies === void 0) { dependencies = []; }
    var isInitialMount = useRef(true);
    useEffect(function () {
        if (isInitialMount.current) {
            isInitialMount.current = false;
        }
        else {
            effect();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, dependencies);
}

/**
 * @deprecated Use the new SafetyCheckListHelpTextContext instead
 */
var IAPHHelpTextContext = React__default.createContext({
    helpTexts: {},
});
/**
 * @deprecated Use the new SafetyChecklistHelpTextProvider instead
 */
var IAPHHelpTextProvider = function (props) {
    var _a = useState({}), helpTexts = _a[0], setHelpTexts = _a[1];
    useEffect(function () {
        getHelpText();
    }, []);
    function getHelpText() {
        return __awaiter(this, void 0, void 0, function () {
            var iaphHelpText, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, getIAPHHelpText(props.authenticationService)];
                    case 1:
                        iaphHelpText = _a.sent();
                        setHelpTexts(iaphHelpText);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        handleFetchError(error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    return (React__default.createElement(IAPHHelpTextContext.Provider, { value: {
            helpTexts: helpTexts,
        } }, props.children));
};

var SafetyChecklistHelpTextContext = React__default.createContext({
    helpTexts: {},
});
var SafetyChecklistHelpTextProvider = function (props) {
    var _a = useState({}), helpTexts = _a[0], setHelpTexts = _a[1];
    useEffect(function () {
        getHelpText(props.eventId);
    }, [props.eventId]);
    function getHelpText(eventId) {
        return __awaiter(this, void 0, void 0, function () {
            var iaphHelpText, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, getSafetyChecklistHelpText(props.authenticationService, eventId)];
                    case 1:
                        iaphHelpText = _a.sent();
                        setHelpTexts(iaphHelpText);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        handleFetchError(error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    return (React__default.createElement(SafetyChecklistHelpTextContext.Provider, { value: {
            helpTexts: helpTexts,
        } }, props.children));
};

var STANDARD_LNG_COMPOSITION_COMPOUNDS = [
    'methane',
    'ethane',
    'propane',
    'isoButane',
    'nButane',
    'isoPentane',
    'neoPentane',
    'nPentane',
    'nHexane',
    'nitrogen',
];
function getLNGCompoundName(compound) {
    switch (compound) {
        case 'methane':
            return 'Methane';
        case 'ethane':
            return 'Ethane';
        case 'propane':
            return 'Propane';
        case 'isoButane':
            return 'iso-Butane';
        case 'nButane':
            return 'n-Butane';
        case 'isoPentane':
            return 'iso-Pentane';
        case 'neoPentane':
            return 'neo-Pentane';
        case 'nPentane':
            return 'n-Pentane';
        case 'nHexane':
            return 'n-Hexane';
        case 'nitrogen':
            return 'Nitrogen';
        // case 'oxygen':
        //   return 'Oxygen'
        // case 'carbonDioxide':
        //   return 'Carbon Dioxide'
        case 'sulphur':
            return 'Sulphur';
        default:
            return 'Unknown LNG Compound';
    }
}
function getLNGCompoundFormula(compound) {
    switch (compound) {
        case 'methane':
            return (React__default.createElement("span", null,
                "CH",
                React__default.createElement("sub", null, "4")));
        case 'ethane':
            return (React__default.createElement("span", null,
                "C",
                React__default.createElement("sub", null, "2"),
                "H",
                React__default.createElement("sub", null, "6")));
        case 'propane':
            return (React__default.createElement("span", null,
                "C",
                React__default.createElement("sub", null, "3"),
                "H",
                React__default.createElement("sub", null, "8")));
        case 'isoButane':
            return (React__default.createElement("span", null,
                "i-C",
                React__default.createElement("sub", null, "4"),
                "H",
                React__default.createElement("sub", null, "10")));
        case 'nButane':
            return (React__default.createElement("span", null,
                "n-C",
                React__default.createElement("sub", null, "4"),
                "H",
                React__default.createElement("sub", null, "10")));
        case 'isoPentane':
            return (React__default.createElement("span", null,
                "i-C",
                React__default.createElement("sub", null, "5"),
                "H",
                React__default.createElement("sub", null, "12")));
        case 'neoPentane':
            return (React__default.createElement("span", null,
                "neo-C",
                React__default.createElement("sub", null, "5"),
                "H",
                React__default.createElement("sub", null, "12")));
        case 'nPentane':
            return (React__default.createElement("span", null,
                "n-C",
                React__default.createElement("sub", null, "5"),
                "H",
                React__default.createElement("sub", null, "12")));
        case 'nHexane':
            return (React__default.createElement("span", null,
                "n-C",
                React__default.createElement("sub", null, "6"),
                "H",
                React__default.createElement("sub", null, "14")));
        case 'nitrogen':
            return (React__default.createElement("span", null,
                "N",
                React__default.createElement("sub", null, "2")));
        // case 'oxygen':
        //   return (
        //     <span>
        //       O<sub>2</sub>
        //     </span>
        //   )
        // case 'carbonDioxide':
        //   return (
        //     <span>
        //       CO<sub>2</sub>
        //     </span>
        //   )
        case 'sulphur':
            return React__default.createElement("span", null, "S");
        default:
            return React__default.createElement("span", null, "Unknown LNG Compound Formula");
    }
}
function getPropertiesCompoundUnit(compound, energyUnit) {
    switch (compound) {
        case 'methaneNumber':
            return '-';
        case 'grossHeatingMass':
        case 'grossWobbeIdx':
        case 'netHeatingMass':
        case 'netWobbeIdx':
            return energyUnit === EnergyUnit.KWH ? 'kWh/kg' : energyUnit === EnergyUnit.MMBTU ? 'MMBtu/kg' : 'MJ/kg';
        case 'grossHeatingVol':
        case 'netHeatingVol':
            return energyUnit === EnergyUnit.KWH ? 'kWh/m3' : energyUnit === EnergyUnit.MMBTU ? 'MMBtu/m3' : 'MJ/m3';
        case 'density':
            return 'kg/m3';
    }
}
function getCTMSCompountUnit(compound) {
    switch (compound) {
        case 'pressureAfter':
        case 'pressureBefore':
            return 'kilopascal (a)';
        case 'vaporTemperature':
        case 'temperatureBefore':
            return '°C';
    }
}
function parseBDNNumberValue(value, defaultValue) {
    var parsedInput = parseFloat(value);
    if (isNaN(parsedInput)) {
        return defaultValue;
    }
    else {
        return parsedInput;
    }
}
function getDefaultBdnConfiguration() {
    return {
        _id: '',
        name: '',
        eventLogFields: DEFAULT_EVENT_LOG_FIELDS,
        deliveredFields: DEFAULT_DELIVERED_FIELDS,
        overviewFields: DEFAULT_OVERVIEW_FIELDS,
        propertiesFields: DEFAULT_PROPERTIES_FIELDS,
        ctmsDataFields: DEFAULT_CTMS_FIELDS,
        flowType: 'ONLINE',
        showComposition: true,
    };
}
function getEnabledBDNSteps(bdnConfiguration) {
    if (!bdnConfiguration) {
        return {
            overViewFieldsEnabled: true,
            ctmsFieldsEnabled: true,
            compositionFieldsEnabled: true,
            propertyFieldsEnabled: true,
            deliveredFieldsEnabled: true,
        };
    }
    var ctmsFieldsEnabled = Object.values(bdnConfiguration.ctmsDataFields).some(function (value) { return value === true; });
    var overViewFieldsEnabled = Object.values(bdnConfiguration.overviewFields).some(function (value) { return value === true; });
    var compositionFieldsEnabled = bdnConfiguration.showComposition;
    var propertyFieldsEnabled = Object.values(bdnConfiguration.propertiesFields).some(function (value) { return value === true; });
    var deliveredFieldsEnabled = Object.values(bdnConfiguration.deliveredFields).some(function (value) { return value === true; });
    return {
        overViewFieldsEnabled: overViewFieldsEnabled,
        ctmsFieldsEnabled: ctmsFieldsEnabled,
        compositionFieldsEnabled: compositionFieldsEnabled,
        propertyFieldsEnabled: propertyFieldsEnabled,
        deliveredFieldsEnabled: deliveredFieldsEnabled,
    };
}
function getBDNProgress(ebdn, enabledSteps, optionalSteps) {
    if (!ebdn) {
        return {
            nominationDataCompleted: false,
            ctmsCompleted: false,
            compositionCompleted: false,
            propertiesCompleted: false,
            quantityCompleted: false,
        };
    }
    var nominationDetailsCompleted = (enabledSteps === null || enabledSteps === void 0 ? void 0 : enabledSteps.overViewFieldsEnabled) === false || (optionalSteps === null || optionalSteps === void 0 ? void 0 : optionalSteps.includes('overviewFields'))
        ? true
        : validateEBDNSectionComplete(ebdn, 'details', 'overviewFields');
    var ctmsCompleted = (enabledSteps === null || enabledSteps === void 0 ? void 0 : enabledSteps.ctmsFieldsEnabled) === false || (optionalSteps === null || optionalSteps === void 0 ? void 0 : optionalSteps.includes('ctmsDataFields'))
        ? true
        : validateEBDNSectionComplete(ebdn, 'ctmsData', 'ctmsDataFields');
    var compositionCompleted = !Object.values(ebdn.lngComposition).some(isInCompleteEBNDData);
    var propertiesCompleted = (enabledSteps === null || enabledSteps === void 0 ? void 0 : enabledSteps.propertyFieldsEnabled) === false || (optionalSteps === null || optionalSteps === void 0 ? void 0 : optionalSteps.includes('propertiesFields'))
        ? true
        : validateEBDNSectionComplete(ebdn, 'lngProperties', 'propertiesFields');
    var quantityCompleted = (enabledSteps === null || enabledSteps === void 0 ? void 0 : enabledSteps.deliveredFieldsEnabled) === false || (optionalSteps === null || optionalSteps === void 0 ? void 0 : optionalSteps.includes('deliveredFields'))
        ? true
        : validateEBDNSectionComplete(ebdn, 'quantity', 'deliveredFields');
    return {
        nominationDataCompleted: nominationDetailsCompleted,
        ctmsCompleted: ctmsCompleted,
        compositionCompleted: compositionCompleted,
        propertiesCompleted: propertiesCompleted,
        quantityCompleted: quantityCompleted,
    };
}
function validateEBDNSectionComplete(ebdn, ebdnTable, configurationType) {
    var isComplete = true;
    var configurationFieldsToValidate = Object.entries(ebdn.configuration[configurationType])
        .map(function (_a) {
        var key = _a[0], value = _a[1];
        // if we are validating the quantity table we need to filter out some fields.
        // Filter out various altfuel/lngfuel related fields which are present on the backend model,
        // but not filled in / shown in the frontend.
        if (ebdnTable === 'quantity' &&
            key !== 'altFuelPercentage' &&
            (DELIVERED_FIELDS_GROUPING.altFuel.includes(key) || DELIVERED_FIELDS_GROUPING.lng.includes(key))) {
            return undefined;
        }
        if (value === true) {
            return key;
        }
    })
        .filter(function (property) { return property !== undefined; });
    configurationFieldsToValidate.forEach(function (fieldToValidate) {
        if (isInCompleteEBNDData(ebdn[ebdnTable][fieldToValidate])) {
            isComplete = false;
        }
    });
    return isComplete;
}
function isInCompleteEBNDData(value) {
    return value === undefined || value === null || value === '';
}
var DEFAULT_OVERVIEW_FIELDS = {
    bdnId: false,
    agent: false,
    bunkerShipImoNumber: false,
    bunkerShipName: false,
    date: false,
    deliveryPoint: false,
    driver: false,
    licenseNumbers: false,
    tankerLicenseNumbers: false,
    nextDestination: false,
    portOfLoading: false,
    receiver: false,
    receiverReference: false,
    receivingShipImoNumber: false,
    receivingShipName: false,
    buyerOrganisation: false,
    supplier: false,
    supplierOrganisation: false,
    vendorReference: false,
    co2TaxEnabled: false,
    combustionReferenceTemperature: false,
    meteringReferenceTemperature: false,
    // FueLNG Specific
    supplierAddress: false,
    bdnLicense: false,
    // Fuelboss trucking operations
    loadingTerminalName: false,
    pipelineName: false,
};
var OVERVIEW_LABELS = {
    bdnId: "BDN ID",
    agent: "Agent",
    bunkerShipImoNumber: "Bunker Vessel IMO No.",
    bunkerShipName: "Bunker Vessel Name",
    date: "Date of BDN",
    deliveryPoint: "Delivery Point",
    driver: "Driver",
    licenseNumbers: "Truck License Plate",
    tankerLicenseNumbers: "Tanker License Plate",
    portOfLoading: "Port of Loading",
    nextDestination: "Receiving Vessel's Next Destination",
    receiver: "Receiver",
    receiverReference: "Receiver's Reference",
    receivingShipImoNumber: "Receiving Vessel IMO No.",
    receivingShipName: "Receiving Vessel Name",
    buyerOrganisation: "Buyer organisation number",
    supplier: "Supplier",
    supplierOrganisation: "Supplier organisation number",
    vendorReference: "Supplier reference",
    co2TaxEnabled: "Excise fee/CO2 fee applicable",
    meteringReferenceTemperature: "Metering Reference Temperature",
    combustionReferenceTemperature: "Combustion Reference Temperature",
    // FueLNG Specific
    supplierAddress: "Supplier Address",
    bdnLicense: "Bunker License Number",
    // Fuelboss Hydrogen
    totalQuantityHydrogenKg: 'Total quantity hydrogen (kg)',
    trailer1SerialNumber: 'Trailer 1 serial no.',
    trailer1PressureBeforeTransfer: 'Trailer 1 pressure before transfer [psi]',
    trailer1PressureAfterTransfer: 'Trailer 1 pressure after transfer',
    trailer2SerialNumber: 'Trailer 2 serial no.',
    trailer2PressureBeforeTransfer: 'Trailer 2 pressure before transfer [psi]',
    trailer2PressureAfterTransfer: 'Trailer 2 pressure after transfer [psi]',
    vesselBank1PressureBeforeTransfer: 'Vessel bank 1 pressure before transfer [psi]',
    vesselBank1PressureAfterTransfer: 'Vessel bank 1 pressure after transfer [psi]',
    vesselBank2PressureBeforeTransfer: 'Vessel bank 2 pressure before transfer [psi]',
    vesselBank2PressureAfterTransfer: 'Vessel bank 2 pressure after transfer [psi]',
    totalQuantityOrdered: 'Total quantity ordered',
    // Fuelboss trucking operations
    loadingTerminalName: 'Loading terminal name',
    pipelineName: 'Pipeline Name',
    // Fuelboss AGP
    agpLicenseNumber: 'AGP license number',
    agpLicenseHolder: 'AGP license holder',
    agpLicenseHolderAddress: 'AGP license holder address',
    receivingVesselOwner: 'Receiving vessel owner',
};
var DEFAULT_CTMS_FIELDS = {
    pressureAfter: true,
    pressureBefore: true,
    vaporTemperature: true,
    temperatureBefore: false,
};
var CTMS_LABELS = {
    temperatureBefore: "Arrival LNG Temperature",
    vaporTemperature: "Vapor Temperature After Transfer",
    pressureBefore: "Arrival Vapor Pressure",
    pressureAfter: "Vapor Pressure After Transfer",
};
var DEFAULT_EVENT_LOG_FIELDS = {
    truckLoading: false,
    truckParking: false,
    closingCTS: false,
    completeTransfer: false,
    documentationCompleted: false,
    hosesConnected: false,
    hosesDisconnected: false,
    mooring: false,
    norTenderedRv: false,
    openingCTS: false,
    purging: false,
    rvArrived: false,
    startTransfer: false,
};
var EVENT_LOG_LABELS = {
    truckLoading: "Tanker truck LNG loading at plant",
    truckParking: "Tanker truck parking",
    closingCTS: "Closing CTS",
    completeTransfer: "Complete Transfer",
    documentationCompleted: "Documentation completed",
    hosesConnected: "Hose(s) or arm connected",
    hosesDisconnected: "Hose(s) or arm disconnected",
    mooring: "Mooring to receiving vessel completed",
    norTenderedRv: "NOR tendered by receiving vessel",
    openingCTS: "Opening CTS",
    purging: "Hose(s) or arm purged",
    rvArrived: "Receiving vessel arrived",
    startTransfer: "Start Transfer",
};
var DEFAULT_PROPERTIES_FIELDS = {
    density: false,
    grossHeatingMass: false,
    grossHeatingVol: false,
    grossWobbeIdx: false,
    methaneNumber: false,
    netHeatingMass: false,
    netHeatingVol: false,
    netWobbeIdx: false,
};
var PROPERTIES_LABELS = {
    density: "Density",
    grossHeatingMass: "Gross Heating Value (mass based)",
    grossHeatingVol: "Gross Heating Value (volume based)",
    grossWobbeIdx: "Gross Wobbe Index",
    methaneNumber: "Methane Number",
    netHeatingMass: "Net Heating Value (mass based)",
    netHeatingVol: "Net Heating Value (volume based)",
    netWobbeIdx: "Net Wobbe Index",
};
var DEFAULT_DELIVERED_FIELDS = {
    altFuelPercentage: false,
    altGcvGrossEnergy: false,
    altGcvNetEnergy: false,
    altMass: false,
    altNcvGrossEnergy: false,
    altNcvNetEnergy: false,
    altVolume: false,
    gcvVaporDisplaced: false,
    ncvVaporDisplaced: false,
    gcvGasConsumed: false,
    ncvGasConsumed: false,
    gcvGrossEnergy: false,
    gcvNetEnergy: false,
    lngGcvGrossEnergy: false,
    lngGcvNetEnergy: false,
    lngMass: false,
    lngNcvGrossEnergy: false,
    lngNcvNetEnergy: false,
    lngVolume: false,
    mass: false,
    ncvGrossEnergy: false,
    ncvNetEnergy: false,
    volume: false,
};
var DELIVERED_LABELS = {
    altFuelPercentage: "LBG Percentage",
    altGcvGrossEnergy: "Gross Energy",
    altGcvNetEnergy: "Gross Energy Delivered",
    altMass: "Mass",
    altNcvGrossEnergy: "Net Energy",
    altNcvNetEnergy: "Net Energy Delivered",
    altVolume: "Volume",
    gcvGrossEnergy: "Gross Energy",
    gcvNetEnergy: "Gross Energy Delivered",
    lngGcvGrossEnergy: "Gross Energy",
    lngGcvNetEnergy: "Gross Energy Delivered",
    lngMass: "Mass",
    lngNcvGrossEnergy: "Net Energy",
    lngNcvNetEnergy: "Net Energy Delivered",
    lngVolume: "Volume",
    mass: "Mass",
    ncvGrossEnergy: "Net Energy",
    ncvNetEnergy: "Net Energy Delivered",
    volume: "Volume",
    gcvVaporDisplaced: "Vapor Displaced ( GCV )",
    ncvVaporDisplaced: "Vapor Displaced ( NCV )",
    gcvGasConsumed: "Gas Consumed ( GCV )",
    ncvGasConsumed: "Gas Consumed ( NCV )",
};
var DELIVERED_FIELDS_GROUPING = {
    total: [
        'gasConsumed',
        'gcvGrossEnergy',
        'gcvNetEnergy',
        'gcvVaporDisplaced',
        'gcvGasConsumed',
        'mass',
        'ncvGrossEnergy',
        'ncvNetEnergy',
        'ncvVaporDisplaced',
        'ncvGasConsumed',
        'vaporDisplaced',
        'volume',
    ],
    altFuel: [
        'altFuelPercentage',
        'altGcvGrossEnergy',
        'altGcvNetEnergy',
        'altMass',
        'altNcvGrossEnergy',
        'altNcvNetEnergy',
        'altVolume',
    ],
    lng: ['lngGcvGrossEnergy', 'lngGcvNetEnergy', 'lngMass', 'lngNcvGrossEnergy', 'lngNcvNetEnergy', 'lngVolume'],
};
// if any of the following fields (keys) is selected,
// the corresponding linked field (values) must be selected too
// for example: when you select altGcvGrossEnergy, gcvGrossEnergy must
// automatically be selected too
var DELIVERED_FIELDS_LINKS = {
    altGcvGrossEnergy: 'gcvGrossEnergy',
    altGcvNetEnergy: 'gcvNetEnergy',
    altMass: 'mass',
    altNcvGrossEnergy: 'ncvGrossEnergy',
    altNcvNetEnergy: 'ncvNetEnergy',
    altVolume: 'volume',
    lngGcvGrossEnergy: 'gcvGrossEnergy',
    lngGcvNetEnergy: 'gcvNetEnergy',
    lngMass: 'mass',
    lngNcvGrossEnergy: 'ncvGrossEnergy',
    lngNcvNetEnergy: 'ncvNetEnergy',
    lngVolume: 'volume',
};

function useBdnConfigurationService(authenticationService, vendorCompanyId, selectedConfig, onError, onActionSuccess, defaultBdnConfiguration) {
    var _a = useState([]), bdnConfigurationsList = _a[0], setBdnConfigsList = _a[1];
    var _b = useState(selectedConfig), selectedBdnConfigurationId = _b[0], setSelectedBdnConfiguration = _b[1];
    useEffect(function () {
        getBdnConfigurations();
    }, [vendorCompanyId]);
    function getBdnConfigurations() {
        return __awaiter(this, void 0, void 0, function () {
            var bdnConfigurations, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!vendorCompanyId) return [3 /*break*/, 5];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, getBdnConfigurationList(authenticationService, vendorCompanyId)];
                    case 2:
                        bdnConfigurations = _a.sent();
                        setBdnConfigsList(bdnConfigurations);
                        if (onActionSuccess)
                            onActionSuccess('FETCH');
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        if (onError)
                            onError('FETCH', { message: error_1.message, status: error_1.status });
                        handleFetchError(error_1);
                        return [3 /*break*/, 4];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        setBdnConfigsList([]);
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    }
    function createOrUpdateBdnConfiguration(bdnConfig) {
        return __awaiter(this, void 0, void 0, function () {
            var updatedBdnConfig, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!vendorCompanyId)
                            throw new Error('vendorCompanyId is undefined');
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, updatBdnConfiguration(authenticationService, bdnConfig, vendorCompanyId)];
                    case 2:
                        updatedBdnConfig = _a.sent();
                        setSelectedBdnConfiguration(updatedBdnConfig._id);
                        if (onActionSuccess)
                            onActionSuccess('CREATE');
                        return [4 /*yield*/, getBdnConfigurations()];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        error_2 = _a.sent();
                        if (onError)
                            onError('CREATE', { message: error_2.message, status: error_2.status });
                        handleFetchError(error_2);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    function removeBdnConfiguration(bdnConfig) {
        return __awaiter(this, void 0, void 0, function () {
            var error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!vendorCompanyId)
                            throw new Error('vendorCompanyId is undefined');
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, deleteBdnConfiguration(authenticationService, vendorCompanyId, bdnConfig._id)];
                    case 2:
                        _a.sent();
                        setSelectedBdnConfiguration(undefined);
                        if (onActionSuccess)
                            onActionSuccess('DELETE');
                        return [4 /*yield*/, getBdnConfigurations()];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        error_3 = _a.sent();
                        if (onError)
                            onError('DELETE', { message: error_3.message, status: error_3.status });
                        handleFetchError(error_3);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    return {
        bdnConfigurationsList: bdnConfigurationsList,
        getBdnConfigurations: getBdnConfigurations,
        createOrUpdateBdnConfiguration: createOrUpdateBdnConfiguration,
        selectedBdnConfiguration: bdnConfigurationsList.find(function (config) { return config._id === selectedBdnConfigurationId; }) ||
            defaultBdnConfiguration ||
            getDefaultBdnConfiguration(),
        setSelectedBdnConfiguration: setSelectedBdnConfiguration,
        removeBdnConfiguration: removeBdnConfiguration,
    };
}

function useBdnService(nomination, authenticationService) {
    var _a = useState(), currentBDN = _a[0], setCurrentBDN = _a[1];
    var _b = useState(false), loadingBDNData = _b[0], setLoading = _b[1];
    // const [editingStep, setEditingStep] = useState()
    useEffect(function () {
        if (nomination.eventId) {
            fetchCurrentEBDN(nomination.eventId);
        }
        else {
            setCurrentBDN(undefined);
        }
    }, [nomination.eventId]);
    function fetchCurrentEBDN(nominationId) {
        return __awaiter(this, void 0, void 0, function () {
            var bdn, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, getCurrentEBDN(authenticationService, nominationId)];
                    case 2:
                        bdn = _a.sent();
                        if (bdn) {
                            setCurrentBDN(bdn);
                        }
                        else {
                            setCurrentBDN(undefined);
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _a.sent();
                        setCurrentBDN(undefined);
                        // 404 is fine, the bdn has not been created yet.
                        if (error_1.status !== 404) {
                            handleFetchError(error_1);
                        }
                        else {
                            return [2 /*return*/];
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    function initialiseNewBDN(configuration) {
        return __awaiter(this, void 0, void 0, function () {
            var bdn, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, createNewBDN(authenticationService, nomination.eventId, configuration)];
                    case 2:
                        bdn = _a.sent();
                        if (bdn) {
                            setCurrentBDN(bdn);
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_2 = _a.sent();
                        handleFetchError(error_2);
                        return [3 /*break*/, 5];
                    case 4:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    function updateBDNDetailsData(bdnDetails) {
        return __awaiter(this, void 0, void 0, function () {
            var updatedBDN, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, updateBDNDetails(authenticationService, nomination.eventId, bdnDetails)];
                    case 2:
                        updatedBDN = _a.sent();
                        if (updatedBDN) {
                            setCurrentBDN(updatedBDN);
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_3 = _a.sent();
                        handleFetchError(error_3);
                        return [3 /*break*/, 5];
                    case 4:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    function updateBDNCTMSData(ctmsData) {
        return __awaiter(this, void 0, void 0, function () {
            var updatedBDN, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, updateCTMSData(authenticationService, nomination.eventId, ctmsData)];
                    case 2:
                        updatedBDN = _a.sent();
                        if (updatedBDN) {
                            setCurrentBDN(updatedBDN);
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_4 = _a.sent();
                        handleFetchError(error_4);
                        return [3 /*break*/, 5];
                    case 4:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    function updateLNGCompositionData(compositionData) {
        return __awaiter(this, void 0, void 0, function () {
            var updatedBDN, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, updateLNGComposition(authenticationService, nomination.eventId, compositionData)];
                    case 2:
                        updatedBDN = _a.sent();
                        if (updatedBDN) {
                            setCurrentBDN(updatedBDN);
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_5 = _a.sent();
                        handleFetchError(error_5);
                        return [3 /*break*/, 5];
                    case 4:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    function updateLNGPropertiesData(lngProperties) {
        return __awaiter(this, void 0, void 0, function () {
            var updatedBDN, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, updateLNGProperties(authenticationService, nomination.eventId, lngProperties)];
                    case 2:
                        updatedBDN = _a.sent();
                        if (updatedBDN) {
                            setCurrentBDN(updatedBDN);
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_6 = _a.sent();
                        handleFetchError(error_6);
                        return [3 /*break*/, 5];
                    case 4:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    function updateLNGQuantityData(lngQuantity) {
        return __awaiter(this, void 0, void 0, function () {
            var updatedBDN, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, updateLNGQuantity(authenticationService, nomination.eventId, lngQuantity)];
                    case 2:
                        updatedBDN = _a.sent();
                        if (updatedBDN) {
                            setCurrentBDN(updatedBDN);
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_7 = _a.sent();
                        handleFetchError(error_7);
                        return [3 /*break*/, 5];
                    case 4:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    function calculateLNGProperties() {
        return __awaiter(this, void 0, void 0, function () {
            var updatedBDN, error_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, calculateBDNProperties(authenticationService, nomination.eventId)];
                    case 2:
                        updatedBDN = _a.sent();
                        if (updatedBDN) {
                            setCurrentBDN(updatedBDN);
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_8 = _a.sent();
                        if (error_8.status === 412) {
                            throw error_8;
                        }
                        else {
                            handleFetchError(error_8);
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    function calculateLNGQuantity(inputs) {
        return __awaiter(this, void 0, void 0, function () {
            var updatedBDN, error_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, calculateBDNQuantity(authenticationService, nomination.eventId, inputs)];
                    case 2:
                        updatedBDN = _a.sent();
                        if (updatedBDN) {
                            setCurrentBDN(updatedBDN);
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_9 = _a.sent();
                        if (error_9.status === 412) {
                            throw error_9;
                        }
                        else {
                            handleFetchError(error_9);
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    return {
        currentBDN: currentBDN,
        initialiseNewBDN: initialiseNewBDN,
        loadingBDNData: loadingBDNData,
        updateBDNCTMSData: updateBDNCTMSData,
        updateBDNDetailsData: updateBDNDetailsData,
        updateLNGCompositionData: updateLNGCompositionData,
        updateLNGPropertiesData: updateLNGPropertiesData,
        updateLNGQuantityData: updateLNGQuantityData,
        calculateLNGProperties: calculateLNGProperties,
        calculateLNGQuantity: calculateLNGQuantity,
    };
}

function useBunkerShipService(authenticationService, filterByCompanyId, onError, onActionSuccess) {
    var _a = useState([]), bunkerShips = _a[0], setBunkerShips = _a[1];
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    useEffect(function () {
        fetchBunkerShips();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    function fetchBunkerShips() {
        return __awaiter(this, void 0, void 0, function () {
            var bunkerShips_1, filteredBunkerShips, sortedBunkerShips, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, getBunkerShips(authenticationService, filterByCompanyId)];
                    case 1:
                        bunkerShips_1 = _a.sent();
                        if (bunkerShips_1) {
                            filteredBunkerShips = bunkerShips_1;
                            sortedBunkerShips = filteredBunkerShips.sort(function (a, b) { return a.order - b.order; });
                            setBunkerShips(sortedBunkerShips);
                            if (onActionSuccess)
                                onActionSuccess('FETCH');
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        if (onError) {
                            onError({ message: err_1.message, status: err_1.status });
                        }
                        handleFetchError(err_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    function deleteBunkerShip(bunkerShipId) {
        return __awaiter(this, void 0, void 0, function () {
            var matchingBunkerShip, removeBunkerShipError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        matchingBunkerShip = bunkerShips.find(function (bunkerShip) { return bunkerShip._id === bunkerShipId; });
                        if (!matchingBunkerShip) return [3 /*break*/, 2];
                        return [4 /*yield*/, removeBunkerShip(authenticationService, matchingBunkerShip, onError)];
                    case 1:
                        removeBunkerShipError = _a.sent();
                        if (removeBunkerShipError && onError) {
                            onError({ message: removeBunkerShipError.errorMessage, events: removeBunkerShipError.events });
                        }
                        else if (!removeBunkerShipError) {
                            if (onActionSuccess)
                                onActionSuccess('DELETE');
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        // Should never happen
                        if (onError) {
                            onError({ message: 'Bunker ship not found' });
                        }
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    function createBunkerShip(ship) {
        return __awaiter(this, void 0, void 0, function () {
            var newBunkerShip, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, postBunkerShip(authenticationService, ship)];
                    case 1:
                        newBunkerShip = _a.sent();
                        fetchBunkerShips();
                        if (onActionSuccess)
                            onActionSuccess('CREATE');
                        return [2 /*return*/, newBunkerShip];
                    case 2:
                        err_2 = _a.sent();
                        if (onError) {
                            onError({ message: err_2.message, status: err_2.status });
                        }
                        handleFetchError(err_2);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    function updateBunkerShip(ship) {
        return __awaiter(this, void 0, void 0, function () {
            var updatedBunkerShip, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, putBunkerShip(authenticationService, ship)];
                    case 1:
                        updatedBunkerShip = _a.sent();
                        fetchBunkerShips();
                        if (onActionSuccess)
                            onActionSuccess('UPDATE');
                        return [2 /*return*/, updatedBunkerShip];
                    case 2:
                        err_3 = _a.sent();
                        if (onError) {
                            onError({ message: err_3.message, status: err_3.status });
                        }
                        handleFetchError(err_3);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    function updateLNGQuality(bunkership, lngQuality, qualityType) {
        return __awaiter(this, void 0, void 0, function () {
            var updatedBunkerShip, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, updateBunkershipLNGQuality(authenticationService, bunkership, lngQuality, qualityType)];
                    case 2:
                        updatedBunkerShip = _a.sent();
                        fetchBunkerShips();
                        if (onActionSuccess)
                            onActionSuccess('UPDATE');
                        return [2 /*return*/, updatedBunkerShip];
                    case 3:
                        error_1 = _a.sent();
                        handleFetchError(error_1);
                        return [3 /*break*/, 5];
                    case 4:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    function calculateComposition(bunkership) {
        return __awaiter(this, void 0, void 0, function () {
            var updatedBunkerShip, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, calculateBunkershipLNGComposition(authenticationService, bunkership)];
                    case 2:
                        updatedBunkerShip = _a.sent();
                        fetchBunkerShips();
                        if (onActionSuccess)
                            onActionSuccess('UPDATE');
                        return [2 /*return*/, updatedBunkerShip];
                    case 3:
                        error_2 = _a.sent();
                        if (error_2.status === 412) {
                            throw error_2;
                        }
                        else {
                            handleFetchError(error_2);
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    function updateLNGCompositionData(bunkership, compositionData) {
        return __awaiter(this, void 0, void 0, function () {
            var updatedBunkerShip, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, updateBunkershipLNGComposition(authenticationService, bunkership, compositionData, 'SHIP')];
                    case 2:
                        updatedBunkerShip = _a.sent();
                        fetchBunkerShips();
                        if (onActionSuccess)
                            onActionSuccess('UPDATE');
                        return [2 /*return*/, updatedBunkerShip];
                    case 3:
                        error_3 = _a.sent();
                        handleFetchError(error_3);
                        return [3 /*break*/, 5];
                    case 4:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    function updateLNGPropertiesData(bunkership, lngProperties) {
        return __awaiter(this, void 0, void 0, function () {
            var updatedBunkerShip, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, updateBunkershipLNGProperties(authenticationService, bunkership, lngProperties, 'SHIP')];
                    case 2:
                        updatedBunkerShip = _a.sent();
                        fetchBunkerShips();
                        if (onActionSuccess)
                            onActionSuccess('UPDATE');
                        return [2 /*return*/, updatedBunkerShip];
                    case 3:
                        error_4 = _a.sent();
                        handleFetchError(error_4);
                        return [3 /*break*/, 5];
                    case 4:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    function removeBunkerShip(authenticationService, bunkerShip, onError) {
        return __awaiter(this, void 0, void 0, function () {
            var start, end, promptEvents, deletedBunkerShip, err_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        start = new Date().toISOString();
                        end = DateTime.local().plus({ years: 5 }).toISO();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        return [4 /*yield*/, getPromptEventsForUser(authenticationService, undefined, start, end, bunkerShip._id)];
                    case 2:
                        promptEvents = _a.sent();
                        if (!(promptEvents.length === 0)) return [3 /*break*/, 4];
                        deletedBunkerShip = produce(bunkerShip, function (bunkerShipDraft) {
                            bunkerShipDraft.deleted = true;
                        });
                        return [4 /*yield*/, putBunkerShip(authenticationService, deletedBunkerShip)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4: return [2 /*return*/, {
                            errorMessage: 'The ship cannot be removed when there are still events assigned in the future',
                            events: promptEvents,
                        }];
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        err_4 = _a.sent();
                        if (onError)
                            onError({ message: err_4.message, status: err_4.status });
                        handleFetchError(err_4);
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    }
    return {
        loading: loading,
        bunkerShips: bunkerShips,
        fetchBunkerShips: fetchBunkerShips,
        deleteBunkerShip: deleteBunkerShip,
        manuallySetBunkerShips: setBunkerShips,
        createBunkerShip: createBunkerShip,
        updateBunkerShip: updateBunkerShip,
        updateLNGQuality: updateLNGQuality,
        updateLNGCompositionData: updateLNGCompositionData,
        updateLNGPropertiesData: updateLNGPropertiesData,
        calculateComposition: calculateComposition,
    };
}

function useContractService(authenticationService, hideDeleted, retrieveShips, filterContracts) {
    var _a = useState([]), contractsList = _a[0], setContractsList = _a[1];
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var _c = useState([]), ships = _c[0], setShips = _c[1];
    useEffect(function () {
        fetchContractList();
    }, []);
    function fetchContractList(shouldFetchShips) {
        if (shouldFetchShips === void 0) { shouldFetchShips = retrieveShips; }
        return __awaiter(this, void 0, void 0, function () {
            var contracts, filteredContracts, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, 7, 8]);
                        return [4 /*yield*/, getContractsList(authenticationService)];
                    case 2:
                        contracts = _a.sent();
                        if (!contracts) return [3 /*break*/, 5];
                        filteredContracts = filterContracts
                            ? filterContracts(contracts)
                            : hideDeleted
                                ? contracts.filter(function (contract) { return !contract.deleted; })
                                : contracts;
                        setContractsList(filteredContracts);
                        if (!shouldFetchShips) return [3 /*break*/, 4];
                        return [4 /*yield*/, fetchShips(filteredContracts.reduce(function (all, contract) { return all.concat(contract.receivingVessels); }, []))];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/, contracts];
                    case 5: return [2 /*return*/, null];
                    case 6:
                        err_1 = _a.sent();
                        setContractsList([]);
                        handleFetchError(err_1);
                        return [2 /*return*/, null];
                    case 7:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        });
    }
    function fetchShips(vesselIds) {
        return __awaiter(this, void 0, void 0, function () {
            var fetchedShips, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        return [4 /*yield*/, getShipsById(authenticationService, vesselIds)];
                    case 1:
                        fetchedShips = _a.sent();
                        setShips(fetchedShips);
                        return [3 /*break*/, 4];
                    case 2:
                        err_2 = _a.sent();
                        handleFetchError(err_2);
                        return [3 /*break*/, 4];
                    case 3:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    return {
        contractsList: contractsList,
        loading: loading,
        ships: ships,
        fetchContractList: fetchContractList,
        vendorsWithContract: new Set(contractsList.map(function (contract) { return contract.vendorCompanyId; })),
        customersWithContract: new Set(contractsList.map(function (contract) { return contract.companyId; })),
    };
}

function useEnquiryService(enquiryId, authenticationService, setLoading, onNewerVersionAvailable, successCallback) {
    var _a = useState([]), enquiryHistory = _a[0], setEnquiryHistory = _a[1];
    var _b = useState(undefined), enquiryEventId = _b[0], setEnquiryEventId = _b[1];
    var _c = useState(undefined), latestEnquiry = _c[0], setLatestEnquiry = _c[1];
    var _d = useState(enquiryHistory ? enquiryHistory.length - 1 : 0), selectedEnquiryIndex = _d[0], setSelectedEnquiryIndex = _d[1];
    var selectedHistoricEnquiry = enquiryHistory && !isEqual(enquiryHistory[selectedEnquiryIndex], latestEnquiry)
        ? enquiryHistory[selectedEnquiryIndex]
        : undefined;
    var previousHistoricEnquiry = selectedEnquiryIndex > 0 ? enquiryHistory[selectedEnquiryIndex - 1] : undefined;
    var _e = useState(false), newerVersionAvailable = _e[0], setNewerVersionAvailable = _e[1];
    useEffect(function () {
        fetchEnquiryData(enquiryId);
        setEnquiryEventId(enquiryId);
    }, [enquiryId]);
    function fetchEnquiryData(eventId) {
        return __awaiter(this, void 0, void 0, function () {
            var eventHistory;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        if (!eventId) return [3 /*break*/, 2];
                        return [4 /*yield*/, fetchEnquiryHistory(eventId)];
                    case 1:
                        eventHistory = _a.sent();
                        if (eventHistory) {
                            setEnquiryHistory(eventHistory);
                            setLatestEnquiry(eventHistory[eventHistory.length - 1]);
                            setSelectedEnquiryIndex(eventHistory.length - 1);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        setEnquiryHistory([]);
                        setLatestEnquiry(undefined);
                        setSelectedEnquiryIndex(0);
                        _a.label = 3;
                    case 3:
                        setLoading(false);
                        return [2 /*return*/];
                }
            });
        });
    }
    function fetchEnquiryHistory(eventId) {
        return __awaiter(this, void 0, void 0, function () {
            var eventHistory, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, getEnquiryHistory(authenticationService, eventId)];
                    case 1:
                        eventHistory = _a.sent();
                        return [2 /*return*/, eventHistory];
                    case 2:
                        err_1 = _a.sent();
                        handleFetchError(err_1);
                        return [2 /*return*/, []];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    function fetchEnquiryList() {
        return __awaiter(this, void 0, void 0, function () {
            var allInquiries, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, getEnquiryList(authenticationService)];
                    case 1:
                        allInquiries = _a.sent();
                        return [2 /*return*/, allInquiries];
                    case 2:
                        err_2 = _a.sent();
                        handleFetchError(err_2);
                        return [2 /*return*/, []];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    function updateEnquiry(action, updatedEnquiry) {
        return __awaiter(this, void 0, void 0, function () {
            var enquiryToUpdate, _a, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        setLoading(true);
                        enquiryToUpdate = cloneDeep(updatedEnquiry);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 10, 11, 12]);
                        _a = action;
                        switch (_a) {
                            case 'AMEND': return [3 /*break*/, 2];
                            case 'COUNTER': return [3 /*break*/, 4];
                        }
                        return [3 /*break*/, 6];
                    case 2: return [4 /*yield*/, amendSpotEnquiry(authenticationService, enquiryToUpdate)];
                    case 3:
                        enquiryToUpdate = _b.sent();
                        return [3 /*break*/, 7];
                    case 4: return [4 /*yield*/, counterSpotEnquiry(authenticationService, enquiryToUpdate)];
                    case 5:
                        enquiryToUpdate = _b.sent();
                        return [3 /*break*/, 7];
                    case 6: return [3 /*break*/, 7];
                    case 7:
                        if (!(enquiryToUpdate && enquiryToUpdate.eventId)) return [3 /*break*/, 9];
                        // set the enquiry eventID in case a enquiry was just created.
                        setEnquiryEventId(enquiryToUpdate.eventId);
                        return [4 /*yield*/, fetchEnquiryData(enquiryToUpdate.eventId)];
                    case 8:
                        _b.sent();
                        if (successCallback) {
                            successCallback(action, enquiryToUpdate);
                        }
                        _b.label = 9;
                    case 9: return [3 /*break*/, 12];
                    case 10:
                        error_1 = _b.sent();
                        // 422 => Unprocessable Entity code from the backend which tells us a amend request is not possible.
                        // Therefore a counter should be done.
                        if (error_1.status && error_1.status === 422) {
                            throw error_1;
                        }
                        else {
                            handleFetchError(error_1);
                        }
                        return [3 /*break*/, 12];
                    case 11:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 12: return [2 /*return*/];
                }
            });
        });
    }
    function updateEnquiryEventState(newState, reason) {
        return __awaiter(this, void 0, void 0, function () {
            var updatedEnquiry, resultNomination, resultEnquiry, updateResult, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(latestEnquiry === null || latestEnquiry === void 0 ? void 0 : latestEnquiry._id) || !enquiryEventId) {
                            console.warn('Trying to update the state of a enquiry without eventId');
                            return [2 /*return*/];
                        }
                        setLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, postPromptProposalState(authenticationService, latestEnquiry._id, newState, false, reason)];
                    case 2:
                        updatedEnquiry = (_a.sent());
                        toast.success('Proposal status is updated to ' + newState);
                        if (successCallback) {
                            resultNomination = updatedEnquiry === null || updatedEnquiry === void 0 ? void 0 : updatedEnquiry.nomination;
                            resultEnquiry = updatedEnquiry === null || updatedEnquiry === void 0 ? void 0 : updatedEnquiry.spotEvent;
                            updateResult = resultNomination || resultEnquiry;
                            successCallback('STATE_UPDATE', updateResult);
                        }
                        fetchEnquiryData(enquiryEventId);
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        handleFetchError(error_2);
                        return [3 /*break*/, 4];
                    case 4:
                        setLoading(false);
                        return [2 /*return*/];
                }
            });
        });
    }
    function addContractAndFinaliseEnquiry(event, contractId) {
        return __awaiter(this, void 0, void 0, function () {
            var contractResult, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, addContractToEnquiry(authenticationService, event, contractId)];
                    case 1:
                        contractResult = _a.sent();
                        fetchEnquiryData(enquiryEventId);
                        if (successCallback) {
                            successCallback('CONTRACT_ADDED_AND_FINALISED', contractResult.nomination);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_3 = _a.sent();
                        handleFetchError(error_3);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    function selectNextHistoricEnquiry() {
        if (enquiryHistory) {
            var selectedIndexInHistory = selectedEnquiryIndex + 1 < enquiryHistory.length;
            if (selectedIndexInHistory) {
                setSelectedEnquiryIndex(selectedEnquiryIndex + 1);
            }
        }
    }
    function selectPreviousHistoricEnquiry() {
        if (enquiryHistory) {
            if (selectedEnquiryIndex - 1 >= 0)
                setSelectedEnquiryIndex(selectedEnquiryIndex - 1);
        }
    }
    function refetchEnquiryData() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!enquiryEventId) return [3 /*break*/, 2];
                        return [4 /*yield*/, fetchEnquiryData(enquiryEventId)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    }
    function checkIfNewerEnquiryAvailable() {
        return __awaiter(this, void 0, void 0, function () {
            var eventHistory, newLatestEnquiry;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!enquiryEventId) return [3 /*break*/, 2];
                        return [4 /*yield*/, fetchEnquiryHistory(enquiryEventId)];
                    case 1:
                        eventHistory = _a.sent();
                        if (eventHistory) {
                            newLatestEnquiry = eventHistory[eventHistory.length - 1];
                            if (latestEnquiry && newLatestEnquiry && !isEqual(latestEnquiry, newLatestEnquiry)) {
                                if (!newerVersionAvailable) {
                                    onNewerVersionAvailable(refetchEnquiryData, setNewerVersionAvailable);
                                }
                                setNewerVersionAvailable(true);
                            }
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/, newerVersionAvailable];
                }
            });
        });
    }
    function attachFileToEnquiry(file, fileType, itemWithDocuments, companyId, fileName) {
        return __awaiter(this, void 0, void 0, function () {
            var fileReturn, newItemWithDocuments, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, uploadDocument(authenticationService, companyId, fileType, file, fileName)];
                    case 2:
                        fileReturn = _a.sent();
                        newItemWithDocuments = cloneDeep(itemWithDocuments);
                        if (!newItemWithDocuments.documents) {
                            newItemWithDocuments.documents = [];
                        }
                        newItemWithDocuments.documents.push(fileReturn);
                        return [4 /*yield*/, updateEnquiry('AMEND', newItemWithDocuments)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        err_3 = _a.sent();
                        handleFetchError(err_3);
                        return [3 /*break*/, 5];
                    case 5:
                        setLoading(false);
                        return [2 /*return*/];
                }
            });
        });
    }
    function createNewEnquiry(enquiryToCreate, vendorCompanies) {
        return __awaiter(this, void 0, void 0, function () {
            var newEnquiry, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, createNewSpotEnquiry(authenticationService, enquiryToCreate, vendorCompanies)];
                    case 1:
                        newEnquiry = _a.sent();
                        if (successCallback) {
                            successCallback('CREATE', newEnquiry);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_4 = _a.sent();
                        handleFetchError(error_4);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    return {
        enquiryHistory: enquiryHistory,
        enquirySelection: {
            selectedEnquiryIndex: selectedEnquiryIndex,
            previousHistoricEnquiry: previousHistoricEnquiry,
            selectedHistoricEnquiry: selectedHistoricEnquiry,
            selectNextHistoricEnquiry: selectNextHistoricEnquiry,
            selectPreviousHistoricEnquiry: selectPreviousHistoricEnquiry,
        },
        fetchEnquiryList: fetchEnquiryList,
        updateSpotEnquiry: updateEnquiry,
        attachFileToEnquiry: attachFileToEnquiry,
        checkIfNewerEnquiryAvailable: checkIfNewerEnquiryAvailable,
        latestEnquiry: latestEnquiry,
        refetchEnquiryData: refetchEnquiryData,
        updateEnquiryState: updateEnquiryEventState,
        createNewEnquiry: createNewEnquiry,
        addContractAndFinaliseEnquiry: addContractAndFinaliseEnquiry,
    };
}

function useFindLocation(filter, locationService, minFilterLength) {
    if (minFilterLength === void 0) { minFilterLength = 3; }
    var _a = useState(true), loading = _a[0], setLoading = _a[1];
    var _b = useState([]), locations = _b[0], setLocations = _b[1];
    var _c = useState(undefined), error = _c[0], setError = _c[1];
    useEffect(function () {
        setLoading(true);
        if (filter.length >= minFilterLength) {
            locationService.findLocation(filter)
                .then(function (foundLocations) {
                setLoading(false);
                setLocations(foundLocations);
                setError(undefined);
            })
                .catch(function (error) {
                setLoading(false);
                setLocations([]);
                setError(error);
            });
        }
        else {
            setLoading(false);
            setLocations([]);
            setError(undefined);
        }
    }, [filter, locationService]);
    return {
        loading: loading,
        locations: locations,
        error: error
    };
}

function useLocation(locationId, locationService) {
    var _a = useState(true), loading = _a[0], setLoading = _a[1];
    var _b = useState(undefined), location = _b[0], setLocation = _b[1];
    var _c = useState(undefined), error = _c[0], setError = _c[1];
    useEffect(function () {
        if (!locationId) {
            setLoading(false);
            setLocation(undefined);
            setError(new Error('No location specified'));
            return;
        }
        var cancelled = false;
        setLoading(true);
        locationService.findLocationById(locationId)
            .then(function (foundLocation) {
            if (!cancelled) {
                setLocation(foundLocation);
                setError(undefined);
            }
        })
            .catch(function (err) {
            if (!cancelled) {
                setLocation(undefined);
                setError(err);
            }
        })
            .finally(function () {
            setLoading(false);
        });
        return function () {
            cancelled = true;
        };
    }, [locationId, locationService]);
    return {
        loading: loading,
        location: location,
        error: error
    };
}

function useLocationName(locationId, locationService, format) {
    var _a = useLocation(locationId, locationService), loading = _a.loading, location = _a.location, error = _a.error;
    return {
        loading: loading,
        error: error,
        text: loading
            ? '(Loading...)'
            : error
                ? "(" + error.toString() + ")"
                : location
                    ? format(location)
                    : '(Error loading location)' // this should never happen
    };
}

function useLocationService(authenticationService) {
    // we store a Promise in the cache, so we can directly put a location in cache
    // as soon as we _start_ fetching it instead of only after receiving it: often,
    // on load of the application, the same location is requested multiple times,
    // and we do not want to fetch one location multiple times.
    var cache = useRef({});
    return useMemo(function () {
        return {
            findLocationById: function (locationId) {
                return __awaiter(this, void 0, void 0, function () {
                    var locationPromise, err_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                // use from cache if present
                                if (cache.current[locationId]) {
                                    return [2 /*return*/, cache.current[locationId]];
                                }
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 3, , 4]);
                                locationPromise = getLocationById(authenticationService, locationId);
                                // add it to cache *before* actually resolving it,
                                // so we don't start multiple requests for the same location
                                cache.current[locationId] = locationPromise;
                                return [4 /*yield*/, locationPromise];
                            case 2: 
                            // await here, else we can't catch errors with try/catch
                            return [2 /*return*/, _a.sent()];
                            case 3:
                                err_1 = _a.sent();
                                if (err_1.status !== 404) {
                                    // if fetching a location failed due to broken internet connection
                                    // for example, we want to try again later, therefore we remove it
                                    // from the cache again. Only when there is a 404, trying again will
                                    // not help since in that case the location simply doesn't exist on
                                    // the backend.
                                    delete cache.current[locationId];
                                }
                                throw err_1;
                            case 4: return [2 /*return*/];
                        }
                    });
                });
            },
            findLocation: function (filter) {
                return __awaiter(this, void 0, void 0, function () {
                    var locations;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, getLocations(authenticationService, filter)
                                // add all locations to cache
                            ];
                            case 1:
                                locations = _a.sent();
                                // add all locations to cache
                                locations.forEach(function (location) {
                                    cache.current[location._id] = Promise.resolve(location);
                                });
                                return [2 /*return*/, locations];
                        }
                    });
                });
            },
            getCache: function () {
                return __assign({}, cache.current);
            },
            clearCache: function () {
                cache.current = {};
            }
        };
    }, [authenticationService, cache]);
}

function getTimeZone(location) {
    // also make the sure the timezone is not empty or an empty string like ""
    return location.timezone && location.timezone !== ''
        ? location.timezone
        : undefined;
}
function validateEventDate(label, nomination, path, errors, customErrorMessage) {
    var dateToCheck = nomination[label];
    var isValidDate = dateToCheck && DateTime.fromISO(dateToCheck).isValid ? true : false;
    if (!nomination[label]) {
        return;
    }
    if (label in nomination && !isValidDate) {
        var errorMessage = customErrorMessage || 'Fill in a valid date';
        setWith(errors, path.concat(label).join('.'), errorMessage, Object);
    }
}
/**
 * Calculate a human readable relative time between two times.
 *
 * @example
 *
 *    const now = luxon.DateTime.fromISO('2021-02-11T00:00:00Z')
 *    const plannedTime = luxon.DateTime.fromISO('2021-02-14T00:00:00Z')
 *
 *    const relativeTime = toRelativeTime(plannedTime.toMillis(), now.toMillis())
 *    // returns: { value: 3, unit: 'days', text: '3 days' }
 *
 * @param {number | Date} time
 * @param {number | Date} [base] Defaults to the current system time
 * @return Returns an object containing a value
 */
function toRelativeTime(time, base) {
    if (base === void 0) { base = DateTime.local().toMillis(); }
    var relative = DateTime.fromMillis(time.valueOf()).toRelative({
        base: DateTime.fromMillis(base.valueOf()),
        locale: 'en',
        round: false
    }) || 'Invalid';
    var text = relative // for example 'in 2,71 days'
        .replace(/^in /, '') // remove 'in ' prefix from the text 'in 2,71 days'
        .replace(',', '.'); // replace '2,71 days' with '2.71 days'
    var parts = text.split(' ');
    // luxon rounds down by default, so 2.71 days is displayed as '2 days' by default,
    // but we want that rounded to to '3 days'
    // therefore, we set { round: false }, and do rounding ourselves
    var value = Math.round(parseFloat(parts[0]));
    var joinedUnit = parts.slice(1).join(' ');
    var unit = (value === 1)
        ? joinedUnit.replace(/s$/, '') // change "days" to "day" when value is 1
        : joinedUnit;
    return {
        value: value,
        unit: unit,
        text: (value + ' ' + unit)
    };
}

function useLocationTimeZone(locationId, locationService) {
    var _a = useLocation(locationId, locationService), loading = _a.loading, location = _a.location, error = _a.error;
    var defaultTimezone = 'UTC';
    var value = (loading || !location)
        ? defaultTimezone
        : (getTimeZone(location) || defaultTimezone);
    return {
        loading: loading,
        value: value,
        error: error,
        text: loading
            ? value + " (Loading...)"
            : error
                ? value + " (" + error.toString() + ")"
                : value
    };
}

function useMastersRequisitionService(authenticationService, eventId) {
    var _a = useState(), masterRequisitionForm = _a[0], setMasterRequisitionForm = _a[1];
    useEffect(function () {
        if (eventId) {
            getMastersRequisitionForm();
        }
        else {
            setMasterRequisitionForm(undefined);
        }
    }, [eventId]);
    function getMastersRequisitionForm() {
        return __awaiter(this, void 0, void 0, function () {
            var mrf, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, getMRF(authenticationService, eventId)];
                    case 1:
                        mrf = _a.sent();
                        if (mrf) {
                            setMasterRequisitionForm(mrf);
                        }
                        else {
                            setMasterRequisitionForm(undefined);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        handleFetchError(error_1);
                        toast.error(error_1.toString());
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    function generateMastersRequisitionDocument() {
        return __awaiter(this, void 0, void 0, function () {
            var MRFDoc, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        return [4 /*yield*/, createMRF(authenticationService, eventId)];
                    case 1:
                        MRFDoc = _a.sent();
                        if (!MRFDoc._id) return [3 /*break*/, 3];
                        return [4 /*yield*/, downloadFileFromBackend(authenticationService, MRFDoc._id, MRFDoc.filename, eventId)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, true];
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        error_2 = _a.sent();
                        handleFetchError(error_2);
                        toast.error(error_2.toString());
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    function saveMastersRequisitionForm(values) {
        return __awaiter(this, void 0, void 0, function () {
            var updatedMRF, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, saveMRF(authenticationService, eventId, values)];
                    case 1:
                        updatedMRF = _a.sent();
                        if (updatedMRF) {
                            return [2 /*return*/, updatedMRF];
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_3 = _a.sent();
                        handleFetchError(error_3);
                        toast.error(error_3.toString());
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    return {
        masterRequisitionForm: masterRequisitionForm,
        getMastersRequisitionForm: getMastersRequisitionForm,
        generateMastersRequisitionDocument: generateMastersRequisitionDocument,
        saveMastersRequisitionForm: saveMastersRequisitionForm,
    };
}

function usePipelineService(authenticationService, onError, onActionSuccess) {
    var _a = useState([]), pipelines = _a[0], setPipelines = _a[1];
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    useEffect(function () {
        fetchPipelines();
    }, []);
    function fetchPipelines() {
        return __awaiter(this, void 0, void 0, function () {
            var allpipelines, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, getAllPipelines(authenticationService)];
                    case 1:
                        allpipelines = _a.sent();
                        if (allpipelines) {
                            setPipelines(allpipelines);
                            if (onActionSuccess)
                                onActionSuccess('FETCH');
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        if (onError) {
                            onError({ message: err_1.message, status: err_1.status });
                        }
                        handleFetchError(err_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    function updateLNGCompositionData(pipelineId, compositionData) {
        return __awaiter(this, void 0, void 0, function () {
            var updatedPipeline, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, updateBunkershipLNGComposition(authenticationService, pipelineId, compositionData, 'PIPE')];
                    case 2:
                        updatedPipeline = _a.sent();
                        fetchPipelines();
                        if (onActionSuccess)
                            onActionSuccess('UPDATE');
                        return [2 /*return*/, updatedPipeline];
                    case 3:
                        error_1 = _a.sent();
                        handleFetchError(error_1);
                        return [3 /*break*/, 5];
                    case 4:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    function updateLNGPropertiesData(pipelineId, lngProperties) {
        return __awaiter(this, void 0, void 0, function () {
            var updatedPipeline, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, updateBunkershipLNGProperties(authenticationService, pipelineId, lngProperties, 'PIPE')];
                    case 2:
                        updatedPipeline = _a.sent();
                        fetchPipelines();
                        if (onActionSuccess)
                            onActionSuccess('UPDATE');
                        return [2 /*return*/, updatedPipeline];
                    case 3:
                        error_2 = _a.sent();
                        handleFetchError(error_2);
                        return [3 /*break*/, 5];
                    case 4:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    return {
        loading: loading,
        pipelines: pipelines,
        updateLNGCompositionData: updateLNGCompositionData,
        updateLNGPropertiesData: updateLNGPropertiesData,
    };
}

function usePromptCollectionService(authenticationService, userProfile, sandboxMode, companyId, onSuccess, onError, bunkerShips, pipelines, activeSandBoxes, disabledDeliveryModes, startDate, endDate, externalFilteredBunkerShips, onChangeFilteredBunkerShips) {
    if (onChangeFilteredBunkerShips === void 0) { onChangeFilteredBunkerShips = function () { }; }
    // Two eventscollecitons are being saved so we can safely go back and forth between filtered collection and the orignal collections
    var _a = useState([]), unfilteredEventsCollections = _a[0], setUnfilteredEventsCollections = _a[1];
    var _b = useState([]), filteredEventsCollections = _b[0], setFilteredEventsCollections = _b[1];
    var _c = useState({}), receivingShips = _c[0], setReceivingShips = _c[1];
    var _d = useState(disabledDeliveryModes || []), filteredDeliveryModes = _d[0], setFilteredDeliveryModes = _d[1];
    var _e = useState(externalFilteredBunkerShips || []), filteredBunkerships = _e[0], setFilteredBunkerships = _e[1];
    var _f = useState([]), filteredPipelines = _f[0], setFilteredPipelines = _f[1];
    var _g = useState({
        bunkerShips: [],
        pipelines: [],
    }), bunkerAssets = _g[0], setBunkerAssets = _g[1];
    var filteredBunkerAssets = __spreadArrays(filteredBunkerships, filteredPipelines);
    var _h = useState(false), loading = _h[0], setLoading = _h[1];
    useEffect(function () {
        fetchPromptCollections();
    }, [companyId, activeSandBoxes]);
    useEffect(function () {
        setFilteredBunkerships(externalFilteredBunkerShips || []);
    }, [externalFilteredBunkerShips, setFilteredBunkerships]);
    useEffect(filterInitialInactiveShips, [bunkerShips]);
    useEffect(function () {
        var bunkerAssetsFiltered = filterBunkerAssets(filteredBunkerAssets, filteredDeliveryModes, bunkerShips, pipelines);
        var updatedEventsCollection = filterEventsCollections(unfilteredEventsCollections, filteredBunkerAssets, filteredDeliveryModes);
        setBunkerAssets(bunkerAssetsFiltered);
        setFilteredEventsCollections(updatedEventsCollection);
    }, [bunkerShips, pipelines, filteredDeliveryModes, filteredPipelines, filteredBunkerships]);
    function fetchPromptCollections(from, to) {
        if (from === void 0) { from = startDate; }
        if (to === void 0) { to = endDate; }
        return __awaiter(this, void 0, void 0, function () {
            var liveSchedule, liveCollection, sandBoxCollections, _a, allEventCollections, err_1;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        setLoading(true);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 7, 8, 9]);
                        return [4 /*yield*/, getPromptEventsForUser(authenticationService, userProfile, from, to, undefined, companyId)];
                    case 2:
                        liveSchedule = _b.sent();
                        liveCollection = {
                            _id: SANDBOX_ID_LIVE,
                            name: 'live',
                            promptEvents: liveSchedule,
                            isSandboxCollection: false,
                        };
                        if (!activeSandBoxes) return [3 /*break*/, 4];
                        return [4 /*yield*/, Promise.all(activeSandBoxes.map(function (sandbox) { return __awaiter(_this, void 0, void 0, function () {
                                var sandboxSchedule, sandboxCollection;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, getLatestPromptSchedule(authenticationService, sandbox._id, undefined, undefined, companyId)];
                                        case 1:
                                            sandboxSchedule = _a.sent();
                                            sandboxCollection = __assign(__assign({}, sandbox), { promptEvents: sandboxSchedule, isSandboxCollection: true });
                                            return [2 /*return*/, sandboxCollection];
                                    }
                                });
                            }); }))];
                    case 3:
                        _a = _b.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        _a = [];
                        _b.label = 5;
                    case 5:
                        sandBoxCollections = _a;
                        allEventCollections = sandBoxCollections.concat(liveCollection);
                        setUnfilteredEventsCollections(allEventCollections);
                        setFilteredEventsCollections(filterEventsCollections(allEventCollections, filteredBunkerAssets, filteredDeliveryModes));
                        return [4 /*yield*/, getReceivingShipInformation(allEventCollections)];
                    case 6:
                        _b.sent();
                        return [3 /*break*/, 9];
                    case 7:
                        err_1 = _b.sent();
                        onError('ERROR_FETCH_COLLECTION', err_1);
                        handleFetchError(err_1);
                        return [3 /*break*/, 9];
                    case 8:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 9: return [2 /*return*/];
                }
            });
        });
    }
    function getReceivingShipInformation(collections) {
        return __awaiter(this, void 0, void 0, function () {
            var receivingShipIds, receivingShipDetails, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        receivingShipIds = new Set();
                        // go through all the nominations in the different collections and add the receving ships to the set
                        collections.forEach(function (collection) {
                            var promptNominations = collection.promptEvents.filter(isPromptNomination);
                            promptNominations.forEach(function (nomination) {
                                if (nomination.receivingShipId) {
                                    receivingShipIds.add(nomination.receivingShipId);
                                }
                            });
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, getShipsById(authenticationService, Array.from(receivingShipIds.values()))];
                    case 2:
                        receivingShipDetails = _a.sent();
                        setReceivingShips(keyBy(receivingShipDetails, '_id'));
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        onError('ERROR_FETCH_SHIP_DETAILS', error_1);
                        handleFetchError(error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    function updateTimelineEvent(timelineEvent) {
        return __awaiter(this, void 0, void 0, function () {
            var error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 8, 9, 10]);
                        if (!instanceOfNominationTimelineItem(timelineEvent)) return [3 /*break*/, 3];
                        return [4 /*yield*/, amendPromptNomination(authenticationService, timelineEvent)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        if (!instanceOfINominationEnquiryEvent(timelineEvent)) return [3 /*break*/, 5];
                        return [4 /*yield*/, amendSpotEnquiry(authenticationService, timelineEvent)];
                    case 4: return [2 /*return*/, _a.sent()];
                    case 5: return [4 /*yield*/, updatePromptEventBlock(authenticationService, timelineEvent)];
                    case 6: return [2 /*return*/, _a.sent()];
                    case 7: return [3 /*break*/, 10];
                    case 8:
                        error_2 = _a.sent();
                        handleFetchError(error_2);
                        return [3 /*break*/, 10];
                    case 9:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 10: return [2 /*return*/];
                }
            });
        });
    }
    function createNewPromptEvent(newPromptEvent) {
        return __awaiter(this, void 0, void 0, function () {
            var newEvent, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, postPromptEventBlock(authenticationService, newPromptEvent)];
                    case 1:
                        newEvent = _a.sent();
                        if (newEvent && onSuccess) {
                            onSuccess('COPY_EVENT_SUCCESS', newEvent);
                        }
                        return [2 /*return*/, newEvent];
                    case 2:
                        error_3 = _a.sent();
                        if (onError) {
                            onError('COPY_EVENT_ERROR', newPromptEvent);
                        }
                        handleFetchError(error_3);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    function filterBunkerAssets(filteredAssets, deliveryModesToFilter, allBunkerShips, allPipelines) {
        var filteredBunkerships = allBunkerShips
            ? deliveryModesToFilter.includes('SHIP')
                ? []
                : allBunkerShips.filter(function (shippie) {
                    if (!filteredAssets.includes(shippie._id)) {
                        return shippie;
                    }
                })
            : [];
        var filteredPipelines = allPipelines
            ? deliveryModesToFilter.includes('PIPE')
                ? []
                : allPipelines.filter(function (pipeline) {
                    if (!filteredAssets.includes(pipeline._id)) {
                        return pipeline;
                    }
                })
            : [];
        return {
            bunkerShips: filteredBunkerships,
            pipelines: filteredPipelines,
        };
    }
    function filterEventsCollections(eventsCollections, filteredAssets, filteredDeliveryModes) {
        return cloneDeep(eventsCollections).map(function (collection) {
            var filteredCollectionEvents = collection.promptEvents
                .map(function (promptEvent) {
                // Filters for bunkerships
                if (promptEvent.bunkerShipId && filteredAssets.includes(promptEvent.bunkerShipId)) {
                    return null;
                }
                if (filteredDeliveryModes.includes('SHIP') && promptEvent.bunkerShipId) {
                    return null;
                }
                // Filters for pipelines
                if (promptEvent.pipelineId && filteredAssets.includes(promptEvent.pipelineId)) {
                    return null;
                }
                if (filteredDeliveryModes.includes('PIPE') && promptEvent.pipelineId) {
                    return null;
                }
                return promptEvent;
            })
                .filter(function (event) { return event !== null; });
            collection.promptEvents = filteredCollectionEvents;
            return collection;
        });
    }
    function toggleBunkerAsset(assetId, assetType) {
        // if we are toggling a asset and the asset's delivery mode was disabled -> enable the delivery mode again.
        if (filteredDeliveryModes.includes(assetType)) {
            var updatedDeliveryModes = __spreadArrays(filteredDeliveryModes);
            updatedDeliveryModes.splice(filteredDeliveryModes.indexOf(assetType), 1);
            setFilteredDeliveryModes(updatedDeliveryModes);
        }
        // find the index of the asset to remove
        // is -1 -> means the items is not in the array so we can add it.
        var assestsList = assetType === 'PIPE' ? filteredPipelines : filteredBunkerships;
        var assetToRemove = assestsList.indexOf(assetId);
        if (assetToRemove > -1) {
            if (assetType === 'PIPE') {
                var updatedAssetFilter = __spreadArrays(filteredPipelines);
                updatedAssetFilter.splice(assetToRemove, 1);
                setFilteredPipelines(updatedAssetFilter);
            }
            else {
                // means we are filtering a ship
                var updatedAssetFilter = __spreadArrays(filteredBunkerships);
                updatedAssetFilter.splice(assetToRemove, 1);
                applyFilteredBunkerships(updatedAssetFilter);
            }
        }
        else {
            if (assetType === 'PIPE') {
                var newFilteredPipelines = __spreadArrays(filteredPipelines, [assetId]);
                setFilteredPipelines(newFilteredPipelines);
                // checks the length of the filtered pipelines with the collection of pipelines
                // if lengths are equal, this means all pipelines are filtered, so we can disable the entire delivery mode.
                if (newFilteredPipelines.length === (pipelines === null || pipelines === void 0 ? void 0 : pipelines.length)) {
                    toggleDeliveryMode('PIPE');
                }
            }
            else {
                var newFilteredBunkerships = __spreadArrays(filteredBunkerships, [assetId]);
                applyFilteredBunkerships(newFilteredBunkerships);
                // checks the length of the filtered bunkerships with the collection of bunkerships
                // if lengths are equal, this means all bunkerships are filtered, so we can disable the entire delivery mode.
                if (newFilteredBunkerships.length === (bunkerShips === null || bunkerShips === void 0 ? void 0 : bunkerShips.length)) {
                    toggleDeliveryMode('SHIP');
                }
            }
        }
    }
    function toggleDeliveryMode(deliveryMode) {
        var deliveryModeToRemove = filteredDeliveryModes.indexOf(deliveryMode);
        if (deliveryModeToRemove > -1) {
            var updatedDeliveryModes = __spreadArrays(filteredDeliveryModes);
            updatedDeliveryModes.splice(deliveryModeToRemove, 1);
            setFilteredDeliveryModes(updatedDeliveryModes);
            if (deliveryMode === 'SHIP') {
                applyFilteredBunkerships([]);
            }
            if (deliveryMode === 'PIPE') {
                setFilteredPipelines([]);
            }
        }
        else {
            if (deliveryMode === 'SHIP' && bunkerShips) {
                applyFilteredBunkerships(bunkerShips.map(function (bunkership) {
                    return bunkership._id;
                }));
            }
            if (deliveryMode === 'PIPE' && pipelines) {
                setFilteredPipelines(pipelines.map(function (pipe) {
                    return pipe._id;
                }));
            }
            setFilteredDeliveryModes(__spreadArrays(filteredDeliveryModes, [deliveryMode]));
        }
    }
    function filterInitialInactiveShips() {
        if (!filteredBunkerships.length) {
            var filteredInactiveShips = (bunkerShips === null || bunkerShips === void 0 ? void 0 : bunkerShips.filter(function (ship) { return !ship.active; })) || [];
            applyFilteredBunkerships(filteredInactiveShips.map(function (ship) { return ship._id; }));
        }
    }
    function applyFilteredBunkerships(filteredBunkerShips) {
        setFilteredBunkerships(filteredBunkerShips);
        onChangeFilteredBunkerShips(filteredBunkerShips);
    }
    return {
        eventsCollections: filteredEventsCollections,
        timelineReceivingShips: receivingShips,
        fetchEventsCollections: fetchPromptCollections,
        createNewPromptEvent: createNewPromptEvent,
        updateTimelineEvent: updateTimelineEvent,
        timelineFiltering: {
            toggleBunkerAsset: toggleBunkerAsset,
            toggleDeliveryMode: toggleDeliveryMode,
            bunkerAssets: bunkerAssets,
            filteredDeliveryModes: filteredDeliveryModes,
            filteredBunkerAssets: filteredBunkerAssets,
        },
        loading: loading,
    };
}

function usePromptEventService(promptEventId, authenticationService, userProfile, sandboxId, sandboxMode) {
    if (sandboxMode === void 0) { sandboxMode = false; }
    var _a = useState(false), loading = _a[0], setLoading = _a[1];
    var _b = useState(), promptEvent = _b[0], setPromptEvent = _b[1];
    var _c = useState([]), sandboxList = _c[0], setSandboxList = _c[1];
    var _d = usePromptEventActions(authenticationService), updatePromptEvent = _d.updatePromptEvent, createPromptEvent = _d.createPromptEvent, removePromptEvent = _d.removePromptEvent;
    // Check if prompt event is allowed to be edited
    var readOnly = isReadOnlyUser(userProfile === null || userProfile === void 0 ? void 0 : userProfile.roles) ||
        isReceivingCaptain(userProfile === null || userProfile === void 0 ? void 0 : userProfile.roles) ||
        (!(promptEvent === null || promptEvent === void 0 ? void 0 : promptEvent.sandboxId) && sandboxMode);
    useEffect(function () {
        fetchPromptEvent(promptEventId, sandboxId);
    }, [promptEventId, sandboxId]);
    useEffect(function () {
        fetchSandboxList();
    }, [sandboxMode]);
    function fetchPromptEvent(eventId, sandboxIdPassed) {
        return __awaiter(this, void 0, void 0, function () {
            var fetchedEvent, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, 6, 7]);
                        if (!eventId) return [3 /*break*/, 3];
                        return [4 /*yield*/, getSinglePromptEvent(authenticationService, eventId, sandboxIdPassed)];
                    case 2:
                        fetchedEvent = _a.sent();
                        setPromptEvent(fetchedEvent || undefined);
                        return [2 /*return*/, fetchedEvent || null];
                    case 3:
                        setPromptEvent(undefined);
                        return [2 /*return*/, null];
                    case 4: return [3 /*break*/, 7];
                    case 5:
                        err_1 = _a.sent();
                        handleFetchError(err_1);
                        return [3 /*break*/, 7];
                    case 6:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/, null];
                }
            });
        });
    }
    function promptEventAction(action, event) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, updatedEvent, createdEvent;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = action;
                        switch (_a) {
                            case 'update': return [3 /*break*/, 1];
                            case 'create': return [3 /*break*/, 3];
                            case 'remove': return [3 /*break*/, 5];
                        }
                        return [3 /*break*/, 7];
                    case 1:
                        setLoading(true);
                        return [4 /*yield*/, updatePromptEvent(event)];
                    case 2:
                        updatedEvent = _b.sent();
                        setPromptEvent(updatedEvent || undefined);
                        setLoading(false);
                        return [2 /*return*/, updatedEvent || null];
                    case 3:
                        setLoading(true);
                        return [4 /*yield*/, createPromptEvent(event)];
                    case 4:
                        createdEvent = _b.sent();
                        setPromptEvent(createdEvent || undefined);
                        setLoading(false);
                        return [2 /*return*/, createdEvent || null];
                    case 5:
                        setLoading(true);
                        return [4 /*yield*/, removePromptEvent(event._id, sandboxId)];
                    case 6:
                        _b.sent();
                        setPromptEvent(undefined);
                        setLoading(false);
                        return [2 /*return*/, null];
                    case 7: return [2 /*return*/, null];
                }
            });
        });
    }
    // attachFile
    function uploadFile(file, fileType, eventWithDocuments, companyId, fileName) {
        return __awaiter(this, void 0, void 0, function () {
            var fileReturn_1, newItemWithDocuments, updatedEvent, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, 5, 6]);
                        return [4 /*yield*/, uploadDocument(authenticationService, companyId, fileType, file, fileName)];
                    case 2:
                        fileReturn_1 = _a.sent();
                        newItemWithDocuments = produce(eventWithDocuments, function (draftEvent) {
                            if (!draftEvent.documents) {
                                draftEvent.documents = [];
                            }
                            draftEvent.documents.push(fileReturn_1);
                        });
                        return [4 /*yield*/, updatePromptEvent(newItemWithDocuments)];
                    case 3:
                        updatedEvent = _a.sent();
                        setPromptEvent(updatedEvent || undefined);
                        return [2 /*return*/, updatedEvent];
                    case 4:
                        err_2 = _a.sent();
                        handleFetchError(err_2);
                        return [3 /*break*/, 6];
                    case 5:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/, null];
                }
            });
        });
    }
    // tentative event action
    function convertTentativeToNomination(tentativeEvent) {
        return __awaiter(this, void 0, void 0, function () {
            var nomination, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, convertTentativeToFirm(authenticationService, tentativeEvent)];
                    case 2:
                        nomination = _a.sent();
                        setPromptEvent(undefined);
                        toast.success('Event successfully converted');
                        return [2 /*return*/, nomination];
                    case 3:
                        error_1 = _a.sent();
                        handleFetchError(error_1);
                        return [3 /*break*/, 5];
                    case 4:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    function fetchSandboxList() {
        return __awaiter(this, void 0, void 0, function () {
            var sandboxList_1, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!sandboxMode) {
                            // no need to fetch
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, getSandboxList(authenticationService)];
                    case 2:
                        sandboxList_1 = _a.sent();
                        setSandboxList(sandboxList_1);
                        return [3 /*break*/, 4];
                    case 3:
                        err_3 = _a.sent();
                        handleFetchError(err_3);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    return {
        loading: loading,
        promptEvent: promptEvent,
        fetchPromptEvent: fetchPromptEvent,
        promptEventAction: promptEventAction,
        convertTentativeToNomination: convertTentativeToNomination,
        uploadFile: uploadFile,
        readOnly: readOnly,
        sandboxList: sandboxList,
    };
}
function usePromptEventActions(authenticationService) {
    var _a = useState(false), loading = _a[0], setLoading = _a[1];
    // Update event
    function updatePromptEvent(event) {
        return __awaiter(this, void 0, void 0, function () {
            var updatedEvent, err_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, updatePromptEventBlock(authenticationService, event)];
                    case 2:
                        updatedEvent = _a.sent();
                        toast.success('Successfully updated the prompt event');
                        return [2 /*return*/, updatedEvent];
                    case 3:
                        err_4 = _a.sent();
                        handleFetchError(err_4);
                        return [3 /*break*/, 5];
                    case 4:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/, null];
                }
            });
        });
    }
    // Create event
    function createPromptEvent(event) {
        return __awaiter(this, void 0, void 0, function () {
            var newEvent, err_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, postPromptEventBlock(authenticationService, event)];
                    case 2:
                        newEvent = _a.sent();
                        toast.success('Successfully created a new prompt event');
                        return [2 /*return*/, newEvent];
                    case 3:
                        err_5 = _a.sent();
                        handleFetchError(err_5);
                        return [3 /*break*/, 5];
                    case 4:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/, null];
                }
            });
        });
    }
    // Remove event
    function removePromptEvent(eventId, sandboxId) {
        return __awaiter(this, void 0, void 0, function () {
            var err_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        if (!eventId) return [3 /*break*/, 2];
                        return [4 /*yield*/, removePromptEventBlock(authenticationService, eventId, sandboxId)];
                    case 1:
                        _a.sent();
                        toast.success('Successfully removed the prompt event');
                        _a.label = 2;
                    case 2: return [3 /*break*/, 4];
                    case 3:
                        err_6 = _a.sent();
                        handleFetchError(err_6);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    return { loading: loading, updatePromptEvent: updatePromptEvent, createPromptEvent: createPromptEvent, removePromptEvent: removePromptEvent };
}

function useSignRequestUrlService(document, userProfile, authenticationService) {
    var _a = useState(false), loading = _a[0], setLoading = _a[1];
    var _b = useState(undefined), signRequestURL = _b[0], setSignRequestURLUrl = _b[1];
    var _c = useState(undefined), error = _c[0], setError = _c[1];
    var _d = useState(currentUserCanSign()), canCurrentUserSign = _d[0], setCanCurrentUserSign = _d[1];
    var timeout = useRef();
    var signerStatus = typeof userProfile._id === 'string' && typeof document.signerStatus[userProfile._id] === 'string'
        ? document.signerStatus[userProfile._id] || undefined
        : undefined;
    var alreadySignedByCurrentUser = signerStatus === 'SIGNED';
    useEffect(function () {
        if (currentUserCanSign())
            fetchSingRequestUrl();
        return function () { return clearTimeout(timeout.current); };
    }, [document._id]);
    useEffect(function () {
        var canUserSign = currentUserCanSign();
        setCanCurrentUserSign(canUserSign);
        if (canUserSign && typeof signRequestURL === 'undefined' && typeof error === 'undefined') {
            fetchSingRequestUrl(true);
        }
        return function () { return clearTimeout(timeout.current); };
    }, [document.signers]);
    function fetchSingRequestUrl(recurring, i, interval) {
        if (recurring === void 0) { recurring = false; }
        if (i === void 0) { i = 5; }
        if (interval === void 0) { interval = 1000; }
        setLoading(true);
        var urlResponse = getSignURL(authenticationService, document._id);
        urlResponse
            .then(function (resolved) {
            if (typeof (resolved === null || resolved === void 0 ? void 0 : resolved.url) === 'string') {
                setSignRequestURLUrl(resolved === null || resolved === void 0 ? void 0 : resolved.url);
            }
            else {
                setError('something went wrong fetching the sign url.');
            }
        })
            .catch(function (error) {
            if (recurring && i > 0) {
                timeout.current = setTimeout(fetchSingRequestUrl, interval, true, i - 1, interval);
            }
            else {
                if (typeof (error === null || error === void 0 ? void 0 : error.message) === 'string') {
                    setError(error === null || error === void 0 ? void 0 : error.message);
                }
                else {
                    console.error(error);
                    setError('something went wrong fetching the sign url.');
                }
            }
        })
            .finally(function () {
            setLoading(false);
        });
    }
    function currentUserCanSign() {
        // if document does not have a id signing is not possible
        if (!document._id)
            return false;
        // if signing is not requested. signing is not yet possible so return false
        if (!['REQUEST_SENT', 'REQUESTED'].includes(document.signingStatus))
            return false;
        // if the used emails for signing does not includes the email from the user return false
        if (!document.signers.map(function (item) { return item.email; }).includes(userProfile.email))
            return false;
        // this document should be signeble by this user
        return true;
    }
    return {
        signRequestURL: signRequestURL,
        loading: loading,
        error: error,
        canCurrentUserSign: canCurrentUserSign,
        fetchSingRequestUrl: fetchSingRequestUrl,
        alreadySignedByCurrentUser: alreadySignedByCurrentUser,
        signerStatus: signerStatus,
    };
}

function useSofConfigurationService(authenticationService, vendorCompanyId, selectedConfig, onError, onActionSuccess) {
    var _a = useState([]), sofConfigurationsList = _a[0], setSofConfigsList = _a[1];
    var _b = useState(selectedConfig), selectedSofConfigurationId = _b[0], setSelectedSofConfiguration = _b[1];
    useEffect(function () {
        getSofConfigurationsList();
    }, [vendorCompanyId]);
    function getSofConfigurationsList() {
        return __awaiter(this, void 0, void 0, function () {
            var sofConfigurations, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!vendorCompanyId) return [3 /*break*/, 5];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, getSofConfigurationList(authenticationService, vendorCompanyId)];
                    case 2:
                        sofConfigurations = _a.sent();
                        setSofConfigsList(sofConfigurations);
                        if (onActionSuccess)
                            onActionSuccess('FETCH');
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        if (onError)
                            onError('FETCH', { message: error_1.message, status: error_1.status });
                        handleFetchError(error_1);
                        return [3 /*break*/, 4];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        setSofConfigsList([]);
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    }
    function createOrUpdateSofConfig(sofConfig) {
        return __awaiter(this, void 0, void 0, function () {
            var updatedSofConfig, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!vendorCompanyId)
                            throw new Error('vendorCompanyId is undefined');
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, updateStatementOfFactsConfiguration(authenticationService, sofConfig, vendorCompanyId)];
                    case 2:
                        updatedSofConfig = _a.sent();
                        setSelectedSofConfiguration(updatedSofConfig._id);
                        if (onActionSuccess)
                            onActionSuccess('CREATE');
                        return [4 /*yield*/, getSofConfigurationsList()];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        error_2 = _a.sent();
                        if (onError)
                            onError('CREATE', { message: error_2.message, status: error_2.status });
                        handleFetchError(error_2);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    function removeSofConfiguration(sofConfig) {
        return __awaiter(this, void 0, void 0, function () {
            var error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!vendorCompanyId)
                            throw new Error('vendorCompanyId is undefined');
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, deleteSofConfiguration(authenticationService, vendorCompanyId, sofConfig._id)];
                    case 2:
                        _a.sent();
                        setSelectedSofConfiguration(undefined);
                        if (onActionSuccess)
                            onActionSuccess('DELETE');
                        return [4 /*yield*/, getSofConfigurationsList()];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        error_3 = _a.sent();
                        if (onError)
                            onError('DELETE', { message: error_3.message, status: error_3.status });
                        handleFetchError(error_3);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    return {
        sofConfigurationsList: sofConfigurationsList,
        getSofConfigurationsList: getSofConfigurationsList,
        createOrUpdateSofConfig: createOrUpdateSofConfig,
        selectedSofConfiguration: sofConfigurationsList.find(function (config) { return config._id === selectedSofConfigurationId; }),
        setSelectedSofConfiguration: setSelectedSofConfiguration,
        removeSofConfiguration: removeSofConfiguration,
    };
}

function useSofService(authenticationService, eventId, onGenerateDocument) {
    var _a = useState(), statementOfFacts = _a[0], setStatementOfFacts = _a[1];
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    useEffect(function () {
        if (eventId) {
            fetchStatementOfFacts(eventId);
        }
        else {
            setStatementOfFacts(undefined);
        }
    }, [eventId]);
    function fetchStatementOfFacts(nominationEventId) {
        return __awaiter(this, void 0, void 0, function () {
            var sof, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, getStatementOfFacts(authenticationService, nominationEventId)];
                    case 2:
                        sof = _a.sent();
                        if (sof) {
                            setStatementOfFacts(sof);
                        }
                        else {
                            setStatementOfFacts(undefined);
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _a.sent();
                        setStatementOfFacts(undefined);
                        // 404 is fine, the bdn has not been created yet.
                        if (error_1.status !== 404) {
                            handleFetchError(error_1);
                        }
                        else {
                            return [2 /*return*/];
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    function initialiseStatementOfFacts(options, configuration) {
        return __awaiter(this, void 0, void 0, function () {
            var newSof, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, createStatementOfFacts(authenticationService, eventId, options, configuration)];
                    case 2:
                        newSof = _a.sent();
                        if (newSof) {
                            setStatementOfFacts(newSof);
                        }
                        return [2 /*return*/, true];
                    case 3:
                        error_2 = _a.sent();
                        handleFetchError(error_2);
                        return [2 /*return*/, false];
                    case 4:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    function updateStatementOfFactsTimestamps(timestamps) {
        return __awaiter(this, void 0, void 0, function () {
            var updatedSof, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, updateStatementOfFacts(authenticationService, eventId, timestamps)];
                    case 2:
                        updatedSof = _a.sent();
                        if (updatedSof) {
                            setStatementOfFacts(updatedSof);
                        }
                        return [2 /*return*/, true];
                    case 3:
                        error_3 = _a.sent();
                        handleFetchError(error_3);
                        return [2 /*return*/, false];
                    case 4:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    function generateStatementOfFactsDocument() {
        return __awaiter(this, void 0, void 0, function () {
            var sofDocument, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!eventId) {
                            toast.error('An error occured when generating the SOF');
                            return [2 /*return*/];
                        }
                        setLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, 6, 8]);
                        return [4 /*yield*/, generateStatementOfFacts(authenticationService, eventId)];
                    case 2:
                        sofDocument = _a.sent();
                        if (!sofDocument._id) return [3 /*break*/, 4];
                        return [4 /*yield*/, downloadFileFromBackend(authenticationService, sofDocument._id, sofDocument.filename, eventId)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        toast.success('Statement of Facts Generated');
                        if (onGenerateDocument)
                            onGenerateDocument();
                        return [2 /*return*/, true];
                    case 5:
                        error_4 = _a.sent();
                        toast.error('An error occured when generating the SOF');
                        handleFetchError(error_4);
                        return [2 /*return*/, false];
                    case 6:
                        setLoading(false);
                        return [4 /*yield*/, fetchStatementOfFacts(eventId)];
                    case 7:
                        _a.sent();
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        });
    }
    return {
        statementOfFacts: statementOfFacts,
        loading: loading,
        initialiseStatementOfFacts: initialiseStatementOfFacts,
        fetchStatementOfFacts: fetchStatementOfFacts,
        updateStatementOfFactsTimestamps: updateStatementOfFactsTimestamps,
        generateStatementOfFactsDocument: generateStatementOfFactsDocument,
    };
}

function useThirdPartyContactService(authenticationService, companyId, userRoles) {
    var _a = useState([]), thirdPartyContactList = _a[0], setThirdPartyContactList = _a[1];
    var _b = useState([]), allowedContacts = _b[0], setAllowedContacts = _b[1];
    useEffect(function () {
        listThirdPartyContacts();
    }, []);
    useEffect(function () {
        if (userRoles && userRoles.length > 0) {
            var allowedThirdPartyRoles_1 = getAllowedThirdPartyContactRoles(userRoles).map(function (role) { return role.value; });
            setAllowedContacts(thirdPartyContactList.filter(function (contact) {
                return allowedThirdPartyRoles_1.includes(contact.role);
            }));
        }
    }, [thirdPartyContactList]);
    function listThirdPartyContacts() {
        return __awaiter(this, void 0, void 0, function () {
            var contacts, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, getThirdPartyContacts(authenticationService, companyId)];
                    case 1:
                        contacts = _a.sent();
                        if (contacts) {
                            setThirdPartyContactList(contacts);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        setThirdPartyContactList([]);
                        handleFetchError(err_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    function saveThirdPartyContact(newContact) {
        return __awaiter(this, void 0, void 0, function () {
            var err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        // Loads the fleet based on the companyId and the searchFleet prop
                        return [4 /*yield*/, addThirdPartyContact(authenticationService, companyId, newContact)];
                    case 1:
                        // Loads the fleet based on the companyId and the searchFleet prop
                        _a.sent();
                        listThirdPartyContacts();
                        return [3 /*break*/, 3];
                    case 2:
                        err_2 = _a.sent();
                        handleFetchError(err_2);
                        return [2 /*return*/, {}];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    function updateThirdPartyContactService(update) {
        return __awaiter(this, void 0, void 0, function () {
            var err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!update._id) {
                            console.error("updateThirdPartyContactService: In order to get allowedContacts, you need to supply userRoles as the 3rd parameter");
                            return [2 /*return*/, false];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        // Loads the fleet based on the companyId and the searchFleet prop
                        return [4 /*yield*/, updateThirdPartyContact(authenticationService, companyId, update._id, update)];
                    case 2:
                        // Loads the fleet based on the companyId and the searchFleet prop
                        _a.sent();
                        listThirdPartyContacts();
                        return [3 /*break*/, 4];
                    case 3:
                        err_3 = _a.sent();
                        handleFetchError(err_3);
                        return [2 /*return*/, {}];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    function deleteThirdPartyContactService(contactId) {
        return __awaiter(this, void 0, void 0, function () {
            var err_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, deleteThirdPartyContacts(authenticationService, companyId, contactId)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, listThirdPartyContacts()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_4 = _a.sent();
                        handleFetchError(err_4);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    return {
        thirdPartyContactList: thirdPartyContactList,
        allowedContacts: allowedContacts,
        listThirdPartyContacts: listThirdPartyContacts,
        saveThirdPartyContact: saveThirdPartyContact,
        updateThirdPartyContactService: updateThirdPartyContactService,
        deleteThirdPartyContactService: deleteThirdPartyContactService
    };
}

function useSharedThirdPartyContactsService(isDelegated, isContractHolder, currentUser, currentNomination, prevNomination, authenticationService, ownThirdPartyContact) {
    var _a = useState(true), loadingCurrent = _a[0], setLoadingCurrent = _a[1];
    var _b = useState(true), loadingPrevious = _b[0], setLoadingPrevious = _b[1];
    var _c = useState([]), currentThirdPartyContacts = _c[0], setCurrentThirdPartyContacts = _c[1];
    var _d = useState([]), currentOwnThirdPartyContacts = _d[0], setCurrentOwnThirdPartyContacts = _d[1];
    var _e = useState([]), previousThirdPartyContacts = _e[0], setPreviousThirdPartyContacts = _e[1];
    var _f = useState([]), previousOwnThirdPartyContacts = _f[0], setPreviousOwnThirdPartyContacts = _f[1];
    var requestCompanyId = currentNomination.companyId && currentNomination.companyId !== currentUser.companyId
        ? currentNomination.companyId
        : currentNomination.vendorCompanyId;
    useEffect(function () {
        if (!currentNomination) {
            setLoadingCurrent(false);
        }
        else {
            var ids = getNominationContactsIds(currentNomination);
            handleRequest(ids, setCurrentThirdPartyContacts, setLoadingCurrent);
        }
    }, [currentNomination]);
    useEffect(function () {
        if (!prevNomination) {
            setLoadingCurrent(false);
        }
        else {
            var ids = getNominationContactsIds(prevNomination);
            handleRequest(ids, setPreviousThirdPartyContacts, setLoadingPrevious);
        }
    }, [prevNomination]);
    useEffect(function () {
        setCurrentOwnThirdPartyContacts(addOwnThirdPartyContact(ownThirdPartyContact, getNominationContactsIds(currentNomination)));
        if (prevNomination)
            setPreviousOwnThirdPartyContacts(addOwnThirdPartyContact(ownThirdPartyContact, getNominationContactsIds(prevNomination)));
    }, [prevNomination, currentNomination, ownThirdPartyContact]);
    var handleRequest = function (thirdPartyContactIds, setOnSucces, setLoading) {
        if (requestCompanyId)
            getThirdPartyContactByIds(authenticationService, requestCompanyId, thirdPartyContactIds)
                .then(function (resolved) {
                setOnSucces(resolved);
            })
                .catch(function (err) {
                handleFetchError(err);
            })
                .finally(function () { return setLoading(false); });
    };
    var addOwnThirdPartyContact = function (ownThirdPartyContact, thirdPartyContactIds) {
        return ownThirdPartyContact.filter(function (item) { return thirdPartyContactIds.includes(item._id); });
    };
    var getNominationContactsIds = function (nomination) {
        if (!nomination)
            return [];
        if (!isDelegated) {
            return getCombinedContactsIds(nomination);
        }
        var contactVendorIds = isDelegated && isContractHolder ? nomination.customerThirdPartyContactIds : nomination.vendorThirdPartyContactIds;
        var returnIds = isSupplier(currentUser.roles) ? contactVendorIds : nomination.customerThirdPartyContactIds;
        return returnIds || [];
    };
    var getCombinedContactsIds = function (nomination) {
        if (nomination.customerThirdPartyContactIds) {
            if (nomination.vendorThirdPartyContactIds) {
                return nomination.vendorThirdPartyContactIds.concat(nomination.customerThirdPartyContactIds);
            }
            return nomination.customerThirdPartyContactIds;
        }
        return nomination.vendorThirdPartyContactIds || [];
    };
    return {
        currentThirdPartyContacts: currentThirdPartyContacts.concat(currentOwnThirdPartyContacts),
        previousThirdPartyContacts: previousThirdPartyContacts.concat(previousOwnThirdPartyContacts),
        loading: loadingCurrent || loadingPrevious,
    };
}

var TIMEZONE_NAMES = [
    'UTC',
    'Africa/Abidjan',
    'Africa/Accra',
    'Africa/Algiers',
    'Africa/Bissau',
    'Africa/Cairo',
    'Africa/Casablanca',
    'Africa/Ceuta',
    'Africa/El_Aaiun',
    'Africa/Johannesburg',
    'Africa/Juba',
    'Africa/Khartoum',
    'Africa/Lagos',
    'Africa/Maputo',
    'Africa/Monrovia',
    'Africa/Nairobi',
    'Africa/Ndjamena',
    'Africa/Sao_Tome',
    'Africa/Tripoli',
    'Africa/Tunis',
    'Africa/Windhoek',
    'America/Adak',
    'America/Anchorage',
    'America/Araguaina',
    'America/Argentina/Buenos_Aires',
    'America/Argentina/Catamarca',
    'America/Argentina/Cordoba',
    'America/Argentina/Jujuy',
    'America/Argentina/La_Rioja',
    'America/Argentina/Mendoza',
    'America/Argentina/Rio_Gallegos',
    'America/Argentina/Salta',
    'America/Argentina/San_Juan',
    'America/Argentina/San_Luis',
    'America/Argentina/Tucuman',
    'America/Argentina/Ushuaia',
    'America/Asuncion',
    'America/Atikokan',
    'America/Bahia',
    'America/Bahia_Banderas',
    'America/Barbados',
    'America/Belem',
    'America/Belize',
    'America/Blanc-Sablon',
    'America/Boa_Vista',
    'America/Bogota',
    'America/Boise',
    'America/Cambridge_Bay',
    'America/Campo_Grande',
    'America/Cancun',
    'America/Caracas',
    'America/Cayenne',
    'America/Chicago',
    'America/Chihuahua',
    'America/Costa_Rica',
    'America/Creston',
    'America/Cuiaba',
    'America/Curacao',
    'America/Danmarkshavn',
    'America/Dawson',
    'America/Dawson_Creek',
    'America/Denver',
    'America/Detroit',
    'America/Edmonton',
    'America/Eirunepe',
    'America/El_Salvador',
    'America/Fort_Nelson',
    'America/Fortaleza',
    'America/Glace_Bay',
    'America/Godthab',
    'America/Goose_Bay',
    'America/Grand_Turk',
    'America/Guatemala',
    'America/Guayaquil',
    'America/Guyana',
    'America/Halifax',
    'America/Havana',
    'America/Hermosillo',
    'America/Indiana/Indianapolis',
    'America/Indiana/Knox',
    'America/Indiana/Marengo',
    'America/Indiana/Petersburg',
    'America/Indiana/Tell_City',
    'America/Indiana/Vevay',
    'America/Indiana/Vincennes',
    'America/Indiana/Winamac',
    'America/Inuvik',
    'America/Iqaluit',
    'America/Jamaica',
    'America/Juneau',
    'America/Kentucky/Louisville',
    'America/Kentucky/Monticello',
    'America/La_Paz',
    'America/Lima',
    'America/Los_Angeles',
    'America/Maceio',
    'America/Managua',
    'America/Manaus',
    'America/Martinique',
    'America/Matamoros',
    'America/Mazatlan',
    'America/Menominee',
    'America/Merida',
    'America/Metlakatla',
    'America/Mexico_City',
    'America/Miquelon',
    'America/Moncton',
    'America/Monterrey',
    'America/Montevideo',
    'America/Nassau',
    'America/New_York',
    'America/Nipigon',
    'America/Nome',
    'America/Noronha',
    'America/North_Dakota/Beulah',
    'America/North_Dakota/Center',
    'America/North_Dakota/New_Salem',
    'America/Ojinaga',
    'America/Panama',
    'America/Pangnirtung',
    'America/Paramaribo',
    'America/Phoenix',
    'America/Port-au-Prince',
    'America/Port_of_Spain',
    'America/Porto_Velho',
    'America/Puerto_Rico',
    'America/Punta_Arenas',
    'America/Rainy_River',
    'America/Rankin_Inlet',
    'America/Recife',
    'America/Regina',
    'America/Resolute',
    'America/Rio_Branco',
    'America/Santarem',
    'America/Santiago',
    'America/Santo_Domingo',
    'America/Sao_Paulo',
    'America/Scoresbysund',
    'America/Sitka',
    'America/St_Johns',
    'America/Swift_Current',
    'America/Tegucigalpa',
    'America/Thule',
    'America/Thunder_Bay',
    'America/Tijuana',
    'America/Toronto',
    'America/Vancouver',
    'America/Whitehorse',
    'America/Winnipeg',
    'America/Yakutat',
    'America/Yellowknife',
    'Antarctica/Casey',
    'Antarctica/Davis',
    'Antarctica/DumontDUrville',
    'Antarctica/Macquarie',
    'Antarctica/Mawson',
    'Antarctica/Palmer',
    'Antarctica/Rothera',
    'Antarctica/Syowa',
    'Antarctica/Troll',
    'Antarctica/Vostok',
    'Asia/Almaty',
    'Asia/Amman',
    'Asia/Anadyr',
    'Asia/Aqtau',
    'Asia/Aqtobe',
    'Asia/Ashgabat',
    'Asia/Atyrau',
    'Asia/Baghdad',
    'Asia/Baku',
    'Asia/Bangkok',
    'Asia/Barnaul',
    'Asia/Beirut',
    'Asia/Bishkek',
    'Asia/Brunei',
    'Asia/Chita',
    'Asia/Choibalsan',
    'Asia/Colombo',
    'Asia/Damascus',
    'Asia/Dhaka',
    'Asia/Dili',
    'Asia/Dubai',
    'Asia/Dushanbe',
    'Asia/Famagusta',
    'Asia/Gaza',
    'Asia/Hebron',
    'Asia/Ho_Chi_Minh',
    'Asia/Hong_Kong',
    'Asia/Hovd',
    'Asia/Irkutsk',
    'Asia/Jakarta',
    'Asia/Jayapura',
    'Asia/Jerusalem',
    'Asia/Kabul',
    'Asia/Kamchatka',
    'Asia/Karachi',
    'Asia/Kathmandu',
    'Asia/Khandyga',
    'Asia/Kolkata',
    'Asia/Krasnoyarsk',
    'Asia/Kuala_Lumpur',
    'Asia/Kuching',
    'Asia/Macau',
    'Asia/Magadan',
    'Asia/Makassar',
    'Asia/Manila',
    'Asia/Nicosia',
    'Asia/Novokuznetsk',
    'Asia/Novosibirsk',
    'Asia/Omsk',
    'Asia/Oral',
    'Asia/Pontianak',
    'Asia/Pyongyang',
    'Asia/Qatar',
    'Asia/Qostanay',
    'Asia/Qyzylorda',
    'Asia/Riyadh',
    'Asia/Sakhalin',
    'Asia/Samarkand',
    'Asia/Seoul',
    'Asia/Shanghai',
    'Asia/Singapore',
    'Asia/Srednekolymsk',
    'Asia/Taipei',
    'Asia/Tashkent',
    'Asia/Tbilisi',
    'Asia/Tehran',
    'Asia/Thimphu',
    'Asia/Tokyo',
    'Asia/Tomsk',
    'Asia/Ulaanbaatar',
    'Asia/Urumqi',
    'Asia/Ust-Nera',
    'Asia/Vladivostok',
    'Asia/Yakutsk',
    'Asia/Yangon',
    'Asia/Yekaterinburg',
    'Asia/Yerevan',
    'Atlantic/Azores',
    'Atlantic/Bermuda',
    'Atlantic/Canary',
    'Atlantic/Cape_Verde',
    'Atlantic/Faroe',
    'Atlantic/Madeira',
    'Atlantic/Reykjavik',
    'Atlantic/South_Georgia',
    'Atlantic/Stanley',
    'Australia/Adelaide',
    'Australia/Brisbane',
    'Australia/Broken_Hill',
    'Australia/Currie',
    'Australia/Darwin',
    'Australia/Eucla',
    'Australia/Hobart',
    'Australia/Lindeman',
    'Australia/Lord_Howe',
    'Australia/Melbourne',
    'Australia/Perth',
    'Australia/Sydney',
    'Europe/Amsterdam',
    'Europe/Andorra',
    'Europe/Astrakhan',
    'Europe/Athens',
    'Europe/Belgrade',
    'Europe/Berlin',
    'Europe/Brussels',
    'Europe/Bucharest',
    'Europe/Budapest',
    'Europe/Chisinau',
    'Europe/Copenhagen',
    'Europe/Dublin',
    'Europe/Gibraltar',
    'Europe/Helsinki',
    'Europe/Istanbul',
    'Europe/Kaliningrad',
    'Europe/Kiev',
    'Europe/Kirov',
    'Europe/Lisbon',
    'Europe/London',
    'Europe/Luxembourg',
    'Europe/Madrid',
    'Europe/Malta',
    'Europe/Minsk',
    'Europe/Monaco',
    'Europe/Moscow',
    'Europe/Oslo',
    'Europe/Paris',
    'Europe/Prague',
    'Europe/Riga',
    'Europe/Rome',
    'Europe/Samara',
    'Europe/Saratov',
    'Europe/Simferopol',
    'Europe/Sofia',
    'Europe/Stockholm',
    'Europe/Tallinn',
    'Europe/Tirane',
    'Europe/Ulyanovsk',
    'Europe/Uzhgorod',
    'Europe/Vienna',
    'Europe/Vilnius',
    'Europe/Volgograd',
    'Europe/Warsaw',
    'Europe/Zaporozhye',
    'Europe/Zurich',
    'Indian/Chagos',
    'Indian/Christmas',
    'Indian/Cocos',
    'Indian/Kerguelen',
    'Indian/Mahe',
    'Indian/Maldives',
    'Indian/Mauritius',
    'Indian/Reunion',
    'Pacific/Apia',
    'Pacific/Auckland',
    'Pacific/Bougainville',
    'Pacific/Chatham',
    'Pacific/Chuuk',
    'Pacific/Easter',
    'Pacific/Efate',
    'Pacific/Enderbury',
    'Pacific/Fakaofo',
    'Pacific/Fiji',
    'Pacific/Funafuti',
    'Pacific/Galapagos',
    'Pacific/Gambier',
    'Pacific/Guadalcanal',
    'Pacific/Guam',
    'Pacific/Honolulu',
    'Pacific/Kiritimati',
    'Pacific/Kosrae',
    'Pacific/Kwajalein',
    'Pacific/Majuro',
    'Pacific/Marquesas',
    'Pacific/Nauru',
    'Pacific/Niue',
    'Pacific/Norfolk',
    'Pacific/Noumea',
    'Pacific/Pago_Pago',
    'Pacific/Palau',
    'Pacific/Pitcairn',
    'Pacific/Pohnpei',
    'Pacific/Port_Moresby',
    'Pacific/Rarotonga',
    'Pacific/Tahiti',
    'Pacific/Tarawa',
    'Pacific/Tongatapu',
    'Pacific/Wake',
    'Pacific/Wallis'
];

// Please note that the order of the fields in this array is important:
// it determines the order in which the fields are presented to the user.
var SOF_FORM_FIELDS = [
    {
        fieldName: 'truckLoading',
        type: 'Date',
        eventTypes: ['nomination'],
        labels: {
            allEvents: 'Tanker truck LNG loading at plant',
        },
    },
    {
        fieldName: 'truckParking',
        type: 'Date',
        eventTypes: ['nomination'],
        labels: {
            allEvents: 'Tanker truck parking',
        },
    },
    {
        fieldName: 'eosp',
        type: 'Date',
        eventTypes: ['allEvents'],
        labels: {
            allEvents: 'EOSP / first line ashore',
        },
    },
    {
        fieldName: 'norTendered',
        type: 'Date',
        eventTypes: ['loading', 'discharge'],
        labels: {
            loading: 'NOR tendered',
            discharge: 'NOR tendered',
        },
    },
    {
        fieldName: 'pilotOnBoardArrival',
        type: 'Date',
        eventTypes: ['allEvents'],
        labels: {
            allEvents: 'Pilot on Board ( Arrival )',
        },
    },
    {
        fieldName: 'riggedAndReady',
        type: 'Date',
        eventTypes: ['nomination'],
        labels: {
            nomination: 'All equipment rigged and ready',
        },
    },
    {
        fieldName: 'norTendered',
        type: 'Date',
        eventTypes: ['nomination'],
        labels: {
            nomination: 'NOR tendered by LBV',
        },
    },
    {
        fieldName: 'norTenderedRv',
        type: 'Date',
        eventTypes: ['nomination'],
        labels: {
            nomination: 'NOR tendered by receiving vessel',
        },
    },
    {
        fieldName: 'rvArrived',
        type: 'Date',
        eventTypes: ['nomination'],
        labels: {
            nomination: 'Receiving vessel arrived',
        },
    },
    {
        fieldName: 'norAccepted',
        type: 'Date',
        eventTypes: ['loading', 'discharge'],
        labels: {
            allEvents: 'NOR accepted',
        },
    },
    {
        fieldName: 'mooring',
        type: 'Interval',
        eventTypes: ['allEvents'],
        labels: {
            nomination: 'Mooring to receiving vessel',
            loading: 'Mooring',
            discharge: 'Mooring',
        },
    },
    {
        fieldName: 'pilotAwayArrival',
        type: 'Date',
        eventTypes: ['nomination'],
        labels: {
            nomination: 'Pilot away ( Arrival )',
        },
    },
    {
        fieldName: 'gangwayDown',
        type: 'Date',
        eventTypes: ['loading', 'discharge'],
        labels: {
            allEvents: 'Gangway landed',
        },
    },
    {
        fieldName: 'hosesConnected',
        type: 'Interval',
        eventTypes: ['allEvents'],
        labels: {
            allEvents: 'Hose(s) or arm connection',
        },
    },
    {
        fieldName: 'hosesTested',
        type: 'Interval',
        eventTypes: ['allEvents'],
        labels: {
            allEvents: 'Hose(s) or arm pressure tested',
        },
    },
    {
        fieldName: 'hosesPurged',
        type: 'Interval',
        eventTypes: ['allEvents'],
        labels: {
            allEvents: 'Hose(s) or arm purged with N2',
        },
    },
    {
        fieldName: 'iaphChecklistCD',
        type: 'Date',
        eventTypes: ['nomination'],
        labels: {
            nomination: 'IAPH checklist parts C & D',
        },
    },
    {
        fieldName: 'preOpMeeting',
        type: 'Interval',
        eventTypes: ['loading', 'discharge'],
        labels: {
            allEvents: 'Pre-operations meeting',
        },
    },
    {
        fieldName: 'warmESDTest',
        type: 'Interval',
        eventTypes: ['allEvents'],
        labels: {
            allEvents: 'Warm ESD test',
        },
    },
    {
        fieldName: 'openingCTS',
        type: 'Date',
        eventTypes: ['allEvents'],
        labels: {
            allEvents: 'Opening CTS',
        },
    },
    {
        fieldName: 'gassingUp',
        type: 'Interval',
        eventTypes: ['loading', 'discharge'],
        labels: {
            loading: 'Gassing-up',
            discharge: 'Gassing-up',
        },
    },
    {
        fieldName: 'coolingDownHoses',
        type: 'Interval',
        eventTypes: ['allEvents'],
        labels: {
            allEvents: 'Hose (or arm) & lines cool-down',
        },
    },
    {
        fieldName: 'coldESDTests',
        type: 'Interval',
        eventTypes: ['allEvents'],
        labels: {
            nomination: 'Cold ESD tests / cold stroke test',
            loading: 'Cold ESD tests',
            discharge: 'Cold ESD tests',
        },
    },
    {
        fieldName: 'openBOGValve',
        type: 'Date',
        eventTypes: ['loading', 'discharge'],
        labels: {
            loading: 'Open BOG valve to shore',
            discharge: 'Open BOG valve to shore',
        },
    },
    {
        fieldName: 'stopGasBurning',
        type: 'Date',
        eventTypes: ['nomination'],
        labels: {
            nomination: 'Stop gas burning / commence fuel burning on LBV',
        },
    },
    {
        fieldName: 'gassingUp',
        type: 'Interval',
        eventTypes: ['nomination'],
        labels: {
            nomination: 'Gassing-up of receiving vessel',
        },
    },
    {
        fieldName: 'coolingDownReceivingVessel',
        type: 'Interval',
        eventTypes: ['nomination'],
        labels: {
            nomination: 'Cooling down of receiving vessel',
        },
    },
    {
        fieldName: 'resumeGasBurning',
        type: 'Date',
        eventTypes: ['nomination'],
        labels: {
            nomination: 'Resume gas burning / stop fuel burning on LBV',
        },
    },
    {
        fieldName: 'coolingDownTanks',
        type: 'Interval',
        eventTypes: ['loading', 'discharge'],
        labels: {
            allEvents: 'Cooling down tanks',
        },
    },
    {
        fieldName: 'transferRampUp',
        type: 'Interval',
        eventTypes: ['allEvents'],
        labels: {
            nomination: 'Ramp-up bunker transfer (start transfer)',
            loading: 'Ramp-up',
            discharge: 'Ramp-up',
        },
    },
    {
        fieldName: 'transfer',
        type: 'Interval',
        eventTypes: ['allEvents'],
        labels: {
            nomination: 'Bulk bunker transfer',
            loading: 'Bulk transfer',
            discharge: 'Bulk transfer',
        },
    },
    {
        fieldName: 'transferRampDown',
        type: 'Interval',
        eventTypes: ['allEvents'],
        labels: {
            nomination: 'Ramp-down bunker transfer (complete transfer)',
            loading: 'Ramp-down',
            discharge: 'Ramp-down',
        },
    },
    {
        fieldName: 'draining',
        type: 'Interval',
        eventTypes: ['allEvents'],
        labels: {
            allEvents: 'Draining of hose(s) or arm',
        },
    },
    {
        fieldName: 'closeBOGValve',
        type: 'Date',
        eventTypes: ['loading', 'discharge'],
        labels: {
            allEvents: 'Close BOG valve to shore',
        },
    },
    {
        fieldName: 'purging',
        type: 'Interval',
        eventTypes: ['allEvents'],
        labels: {
            allEvents: 'Hose(s) or arm purged',
        },
    },
    {
        fieldName: 'closingCTS',
        type: 'Date',
        eventTypes: ['allEvents'],
        labels: {
            allEvents: 'Closing CTS',
        },
    },
    {
        fieldName: 'iaphChecklistE',
        type: 'Date',
        eventTypes: ['nomination'],
        labels: {
            nomination: 'IAPH checklist part E',
        },
    },
    {
        fieldName: 'postOpMeeting',
        type: 'Interval',
        eventTypes: ['loading', 'discharge'],
        labels: {
            allEvents: 'Post operation meeting',
        },
    },
    {
        fieldName: 'hosesDisconnected',
        type: 'Interval',
        eventTypes: ['allEvents'],
        labels: {
            allEvents: 'Hose(s) or arm disconnected',
        },
    },
    {
        fieldName: 'documentationCompleted',
        type: 'Date',
        eventTypes: ['allEvents'],
        labels: {
            allEvents: 'Documentation completed',
        },
    },
    {
        fieldName: 'pilotOnBoardDeparture',
        type: 'Date',
        eventTypes: ['allEvents'],
        labels: {
            allEvents: 'Pilot on Board ( Departure )',
        },
    },
    {
        fieldName: 'unmooring',
        type: 'Interval',
        eventTypes: ['allEvents'],
        labels: {
            nomination: 'Unmooring from receiving vessel',
            loading: 'Unmooring',
            discharge: 'Unmooring',
        },
    },
    {
        fieldName: 'pilotAwayDeparture',
        type: 'Date',
        eventTypes: ['allEvents'],
        labels: {
            allEvents: 'Pilot away ( Departure )',
        },
    },
    {
        fieldName: 'faop',
        type: 'Date',
        eventTypes: ['allEvents'],
        labels: {
            allEvents: 'FAOP / all lines gone and clear',
        },
    },
];

// tslint:disable-next-line
var shader = require('shader'); // using import gives an issue r.default is not a function but only with the production bundle, not in develop mode
function getEventColor(eventType) {
    var background = '#eeeff3';
    var color = '#000';
    switch (eventType) {
        case 'loading':
            background = '#555';
            color = '#fff';
            break;
        case 'maintenance':
            background = '#e34e48';
            color = '#fff';
            break;
        case 'discharge':
            background = '#622bfa';
            color = '#fff';
            break;
        case 'travel':
            background = '#e2e2e2';
            break;
        case 'bunkering':
            background = '#4cca38';
            color = '#fff';
            break;
        case 'lngbunkering':
            background = '#4ea740';
            color = '#fff';
            break;
        case 'generic':
            background = '#40E0D0';
            color = '#fff';
            break;
        case 'conditioning':
            background = '#099120';
            color = '#fff';
            break;
        case 'pool':
            background = '#F3A600';
            color = '#fff';
            break;
        case 'charterout':
            background = '#f3c86c';
            color = '#fff';
            break;
        case 'tentative':
            background = '#40E0D0';
            color = '#fff';
            break;
        case 'waiting':
            background = '#9ec6f5';
            color = '#fff';
            break;
    }
    return {
        background: background,
        color: color
    };
}
/**
 * Get shipId in fleet color
 */
function getFleetShipColor(fleet, shipId) {
    var fleetIndex = fleet.findIndex(function (ship) { return ship._id === shipId; });
    var fleetIndexHigh = fleetIndex * 30; // randomise the hsl index color
    var result = fleetIndexHigh - 360 * Math.floor(fleetIndexHigh / 360); // make it between 0 and 360
    if (result > 10 && result < 70) {
        result += 155;
    }
    return hslToHex(result, 75, 44);
}
/**
 * HSL color converting to HEX color: https://stackoverflow.com/a/44134328
 * @param h
 * @param s
 * @param l
 */
function hslToHex(h, s, l) {
    h /= 360;
    s /= 100;
    l /= 100;
    var r;
    var g;
    var b;
    if (s === 0) {
        r = g = b = l; // achromatic
    }
    else {
        var hue2rgb = function (u, v, t) {
            if (t < 0) {
                t += 1;
            }
            if (t > 1) {
                t -= 1;
            }
            if (t < 1 / 6) {
                return u + (v - u) * 6 * t;
            }
            if (t < 1 / 2) {
                return v;
            }
            if (t < 2 / 3) {
                return u + (v - u) * (2 / 3 - t) * 6;
            }
            return u;
        };
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
    }
    var toHex = function (x) {
        var hex = Math.round(x * 255).toString(16);
        return hex.length === 1 ? '0' + hex : hex;
    };
    return "#" + toHex(r) + toHex(g) + toHex(b);
}

function getNominationStatusIcon(state, takeAction) {
    if (takeAction) {
        return (createElement(Icon, null,
            createElement(FontAwesomeIcon, { icon: faBell })));
    }
    switch (state) {
        case 'PROPOSED':
        case 'COUNTERED':
            return (createElement(Icon, null,
                createElement(FontAwesomeIcon, { icon: faHourglassHalf })));
        case 'FINALISED':
            return (createElement(Icon, null,
                createElement(FontAwesomeIcon, { icon: faClipboardCheck })));
        case 'ACCEPTED':
            return (createElement(Icon, null,
                createElement(FontAwesomeIcon, { icon: faCheckCircle })));
        case 'REJECTED':
            return (createElement(Icon, null,
                createElement(FontAwesomeIcon, { icon: faMinusCircle })));
        case 'CANCELLED':
            return (createElement(Icon, null,
                createElement(FontAwesomeIcon, { icon: faBan })));
        case 'COMPLETED':
            return (createElement(Icon, null,
                createElement(FontAwesomeIcon, { icon: faArchive })));
        case 'NEEDS_CONTRACT':
            return (createElement(Icon, null,
                createElement(FontAwesomeIcon, { icon: faFileContract })));
        default:
            return (createElement(Icon, null,
                createElement(FontAwesomeIcon, { icon: faCircle })));
    }
}
function getDeliveryModeIcon(deliveryMode, key) {
    switch (deliveryMode) {
        case 'SHIP':
            return (createElement(Icon, { key: key, className: "delivery-mode-icon ship-icon" },
                createElement("i", { className: "icon-ship-to-ship" })));
        case 'TRUCK':
            return (createElement(Icon, { key: key, className: "delivery-mode-icon truck-icon" },
                createElement("i", { className: "icon-truck-to-ship" })));
        case 'PIPE':
            return (createElement(Icon, { key: key, className: "delivery-mode-icon pipe-icon" },
                createElement("i", { className: "icon-terminal-to-ship" })));
        case 'CONTAINER':
            return (createElement(Icon, { key: key, className: "delivery-mode-icon container-icon" },
                createElement("i", { className: "icon-container-to-ship" })));
    }
}
function getNewPromptNomination() {
    return {
        _type: 'nomination',
        vendorReference: '',
        bunkerShipId: null,
        deleted: false,
        locationId: '',
        receivingShipId: '',
        onBehalf: false,
        eta: null,
        ata: null,
        bst: null,
        etd: null,
        atd: null,
        bunkershipEta: null,
        bunkershipEtd: null,
        bunkershipAta: null,
        bunkershipAtd: null,
        amount: 0,
        quantityUnit: QuantityUnit.TONNES,
        actualAmount: 0,
        hosesConnected: null,
        hosesDisconnected: null,
        ncomments: 0,
        reactionOnBehalf: false,
        hasPendingProposal: false,
        latest: false,
        deliveryMode: undefined,
        pipelineId: null,
        loadingTerminalId: null,
        priceEnabled: false,
        co2TaxEnabled: false,
    };
}

function submitChanges(values, handleFormEditComplete, eventType, activeEvent, vendorCompanyId) {
    return __awaiter(this, void 0, void 0, function () {
        var updatedBlock, newBlock;
        return __generator(this, function (_a) {
            if (activeEvent) {
                updatedBlock = Object.assign(cloneDeep(activeEvent), __assign({}, values));
                handleFormEditComplete(updatedBlock, false);
            }
            else {
                newBlock = Object.assign({}, values, {
                    _type: eventType,
                    vendorCompanyId: vendorCompanyId,
                });
                handleFormEditComplete(newBlock, true);
            }
            return [2 /*return*/];
        });
    });
}

function getEmptySofSelection() {
    return {
        closeBOGValve: false,
        closingCTS: false,
        coldESDTests: false,
        coolingDownHoses: false,
        coolingDownReceivingVessel: false,
        coolingDownTanks: false,
        documentationCompleted: false,
        draining: false,
        eosp: false,
        faop: false,
        gangwayDown: false,
        gassingUp: false,
        hosesConnected: false,
        hosesDisconnected: false,
        hosesLinesCooldown: false,
        hosesPurged: false,
        hosesTested: false,
        iaphChecklistCD: false,
        iaphChecklistE: false,
        mooring: false,
        norAccepted: false,
        norTendered: false,
        norTenderedRv: false,
        openBOGValve: false,
        openingCTS: false,
        pilotAwayArrival: false,
        pilotAwayDeparture: false,
        pilotOnBoardArrival: false,
        pilotOnBoardDeparture: false,
        postOpMeeting: false,
        preOpMeeting: false,
        purging: false,
        resumeGasBurning: false,
        riggedAndReady: false,
        rvArrived: false,
        stopGasBurning: false,
        transfer: false,
        transferRampDown: false,
        transferRampUp: false,
        truckLoading: false,
        truckParking: false,
        tugUtilisedArrival: false,
        tugUtilisedDeparture: false,
        unmooring: false,
        warmESDTest: false,
    };
}

var MAX_ITERATIONS = 1000;
function getTimelineColumn(item, timelineItem, columns) {
    var xOffset = COLUMN_CENTER -
        (hasReceivingShipWithTimes(timelineItem) ? COLUMN_NOMINATION_SHIP_RIGHT : COLUMN_NOMINATION_SHIP_LEFT);
    var xColumn = Math.floor(item.xStart + xOffset);
    var timelineColumn = findColumnByNumber(xColumn, columns);
    return timelineColumn;
}
function getTimeDragged(itemData, timelineItem, isUpdatingWindow) {
    var startTime = snapToHour(itemData.yStart);
    var timelineItemProperties = getTimelineItemTimeProperties(timelineItem, isUpdatingWindow);
    var diffMillis = DateTime.fromJSDate(startTime).diff(DateTime.fromISO(timelineItem[timelineItemProperties.startTimeProperty])).milliseconds;
    return diffMillis;
}
function getTimelineItemTimeProperties(timelineItem, isUpdatingWindow) {
    if ('_type' in timelineItem) {
        switch (timelineItem._type) {
            case 'nomination':
                var nomination = timelineItem;
                return nomination.bunkershipEta
                    ? { startTimeProperty: 'bunkershipEta', endTimeProperty: '' }
                    : { startTimeProperty: 'bst', endTimeProperty: '' };
            case 'loading':
                return isUpdatingWindow
                    ? { startTimeProperty: 'windowStart', endTimeProperty: 'windowEnd' }
                    : { startTimeProperty: 'eta', endTimeProperty: 'etd' };
            case 'discharge':
                return isUpdatingWindow
                    ? { startTimeProperty: 'windowStart', endTimeProperty: 'windowEnd' }
                    : { startTimeProperty: 'eta', endTimeProperty: 'etd' };
            default:
                return {
                    startTimeProperty: 'eta',
                    endTimeProperty: 'etd',
                };
        }
    }
    else {
        // backup and also for the delivery nomination item
        return {
            startTimeProperty: 'bst',
            endTimeProperty: 'bet',
        };
    }
}
/**
 * Finds a bunkership in the timeline columns based on the column number
 * @param xColumn
 * @param columns
 */
function findColumnByNumber(xColumn, columns) {
    // add check to put in last column instead of misuse bunkerShipId
    return columns.find(function (c) { return c.x === xColumn; });
}
/**
 * Finds a column based on a bunker ship id
 */
function findColumn(bunkerShipId, pipelineId, columns, eventColumnType, sandboxId, isDelegated) {
    // in case bunkerShipId is null it puts the item in the unassigned column
    var column;
    if (bunkerShipId !== null) {
        column = sandboxId
            ? columns.find(function (c) { return c.bunkerShipId === bunkerShipId && c.columnCollectionId === sandboxId; })
            : columns.find(function (c) { return c.bunkerShipId === bunkerShipId; });
    }
    else if (pipelineId !== null) {
        column = sandboxId
            ? columns.find(function (c) { return c.pipelineId === pipelineId && c.columnCollectionId === sandboxId; })
            : columns.find(function (c) { return c.pipelineId === pipelineId; });
    }
    else if (isDelegated) {
        column = columns.find(function (c) { return c.columnType === 'UNASSIGNED_DELEGATED'; });
    }
    else {
        column = sandboxId
            ? columns.find(function (c) { return c.columnType === eventColumnType && c.columnCollectionId === sandboxId; })
            : columns.find(function (c) { return c.columnType === eventColumnType; });
    }
    if (!column) {
        // if no column was found, return the unassigned column to put the item in.
        var unplannedColumn = {
            displayName: 'Unplanned',
            collectionName: '',
            unplanned: true,
            bunkerShipId: '',
            pipelineId: null,
            x: 0,
            columnCollectionId: sandboxId ? sandboxId : '',
            columnType: 'UNASSIGNED',
            sandboxClassName: 'timeline-column-detailed',
        };
        return unplannedColumn;
    }
    else {
        return column;
    }
}
function getTimelineItemDisplayName(type, tentativeType) {
    switch (type) {
        case 'loading':
            return 'Loading';
        case 'discharge':
            return 'Discharge';
        case 'bunkering':
            return 'MGO Bunkering';
        case 'lngbunkering':
            return 'LNG Bunkering';
        case 'conditioning':
            return 'Conditioning';
        case 'maintenance':
            return 'Maintenance';
        case 'travel':
            return 'Travel';
        case 'waiting':
            return 'Waiting';
        case 'pool':
            return 'Pool';
        case 'charterout':
            return 'Charter Out';
        case 'tentative':
            return tentativeType ? "Tentative " + tentativeType : 'Tentative';
        case 'unavailable':
            return 'Unavailable';
        default:
            return '';
    }
}
/**
 * Create a TimeStep object
 * @param {Date} startTime               Start time
 * @param {Date} endTime                 End time
 * @param {IStepScale} [stepScale] The desired scale and step size,
 *                      for example {scale: 'hour', step: 4}
 *                      Use the function determineTimeSteps to determine
 *                      a suitable scale based on the time interval.
 * @return {Date[]} Returns a an array with dates
 */
function customListTimes(startTime, endTime) {
    var times = [];
    var stepScale = determineTimeSteps(startTime.toJSDate(), endTime.toJSDate(), 20).major;
    var current = startTime.startOf(getFirst(stepScale));
    while (current.valueOf() < endTime.valueOf() && times.length < MAX_ITERATIONS) {
        times.push(current);
        current = getNext(current, stepScale, endTime);
    }
    times.push(current);
    return times;
}
/**
 * Set the range iterator to the start date.
 * @param {Date} start
 * @param {IStepScale} stepScale
 */
function getFirst(stepScale) {
    var scale = stepScale.scale;
    // Always get start of day, except for month and year
    var getStartOf = 'day';
    if (scale === 'year' || scale === 'month') {
        getStartOf = scale;
    }
    return getStartOf;
}
/**
 * @param {Date} current
 * @param {IStepScale} stepScale
 * @param {Date} end
 * @return {Date} Returns next date
 */
function getNext(current, stepScale, end) {
    var step = stepScale.step, scale = stepScale.scale;
    var next = current;
    switch (scale) {
        case 'millisecond':
            next = next.plus({ milliseconds: step });
            break;
        case 'second':
            next = next.plus({ seconds: step });
            break;
        case 'minute':
            next = next.plus({ minutes: step });
            break;
        case 'hour':
            next = next.plus({ hours: step });
            break;
        case 'day':
            next = next.plus({ days: step });
            break;
        case 'month':
            next = next.plus({ months: step });
            break;
        case 'year':
            next = next.plus({ years: step });
            break;
    }
    // safety mechanism: if next time is still unchanged, move to the end
    if (next.valueOf() === current.valueOf()) {
        next = end;
    }
    return next;
}

function validatePromptNominationForm(deliveryNomination, userProfile, userRoles, deliveryModesEnabled, timezone, contracts) {
    return validateNomination([], deliveryNomination, userProfile, userRoles, deliveryModesEnabled, timezone, undefined, contracts);
}
function validateNomination(path, delivery, userProfile, userRoles, deliveryModesEnabled, timezone, yearMonth, contracts) {
    var errors = {};
    if (!delivery) {
        return errors;
    }
    //
    // REQUIRED FIELDS
    //
    // Required fields to be filled in by the customer
    var REQUIRED_FIELDS_FOR_CUSTOMER = [
        'receivingShipId',
        'locationId',
        'amount',
        'eta',
        'bst',
        'etd',
        'deliveryMode',
    ];
    // Required fields to be filled in by the scheduler
    var REQUIRED_FIELDS_FOR_SCHEDULER = ['locationId', 'amount', 'bst', 'deliveryMode'];
    if (!delivery.delegationOriginEventId) {
        REQUIRED_FIELDS_FOR_SCHEDULER.push('contractId');
    }
    var isContractHolder = userProfile.companyId === delivery.companyId;
    if ((!delivery.delegatedNominationEventId && !delivery.delegationOriginEventId) ||
        (!isContractHolder && delivery.delegationOriginEventId)) {
        REQUIRED_FIELDS_FOR_SCHEDULER.push('vendorReference');
    }
    if (deliveryModesEnabled) {
        REQUIRED_FIELDS_FOR_CUSTOMER.push('deliveryMode');
        REQUIRED_FIELDS_FOR_SCHEDULER.push('deliveryMode');
    }
    // Add required fields if it's a prompt nomination
    if (isPromptEvent(delivery)) {
        REQUIRED_FIELDS_FOR_SCHEDULER.push('allowedBunkeringTime');
    }
    // Determines which fields to validate based on the user role.
    var requiredFieldsToValidate = isScheduler(userRoles) || isSchedulerCaptain(userRoles)
        ? REQUIRED_FIELDS_FOR_SCHEDULER
        : REQUIRED_FIELDS_FOR_CUSTOMER;
    // loops through all the fields and checks if they have been filled in.
    requiredFieldsToValidate.forEach(function (field) {
        if (!delivery[field] || delivery[field] === '') {
            setWith(errors, path.concat(field).join('.'), 'This field is Required', Object);
        }
    });
    // check if the selected receiving vessel, location does really exist under the selected contract
    if (delivery['contractId'] && delivery['locationId'] && contracts) {
        var selectedContract = contracts === null || contracts === void 0 ? void 0 : contracts.find(function (contract) { return contract._id === delivery['contractId']; });
        var receivingVesselsWithinContract = selectedContract === null || selectedContract === void 0 ? void 0 : selectedContract.receivingVessels;
        var locationsWithinContract = selectedContract === null || selectedContract === void 0 ? void 0 : selectedContract.locations;
        // Receiving Vessel
        if (!receivingVesselsWithinContract || receivingVesselsWithinContract.length === 0) {
            setWith(errors, path.concat('receivingShipId').join('.'), 'The selected contract does not contain any receiving ship.', Object);
        }
        else if (!receivingVesselsWithinContract.includes(delivery['receivingShipId'])) {
            setWith(errors, path.concat('receivingShipId').join('.'), 'Please choose a receiving vessel within the selected contract.', Object);
        }
        // Location
        if (!locationsWithinContract || locationsWithinContract.length === 0) {
            setWith(errors, path.concat('locationId').join('.'), 'The selected contract does not contain any location.', Object);
        }
        else if (!locationsWithinContract.includes(delivery['locationId'])) {
            setWith(errors, path.concat('locationId').join('.'), 'Please choose a location within the selected contract.', Object);
        }
    }
    //
    // DATES / TIMES VALIDATION
    //
    validateEventDate('bst', delivery, path, errors);
    validateEventDate('eta', delivery, path, errors);
    validateEventDate('etd', delivery, path, errors);
    validateEventDate('ata', delivery, path, errors);
    validateEventDate('atd', delivery, path, errors);
    validateEventDate('bunkershipEta', delivery, path, errors);
    validateEventDate('bunkershipAta', delivery, path, errors);
    validateEventDate('bunkershipEtd', delivery, path, errors);
    validateEventDate('bunkershipAtd', delivery, path, errors);
    var monthStart = yearMonth ? calculateMinMonthDate(yearMonth, timezone) : undefined;
    var monthEnd = yearMonth ? calculateMaxMonthDate(yearMonth, timezone) : undefined;
    if (delivery.eta) {
        var pathEta = path.concat('eta').join('.');
        if (delivery.etd && isAfter(DateTime.fromISO(delivery.eta), DateTime.fromISO(delivery.etd))) {
            setWith(errors, pathEta, 'ETA must be before ETD', Object);
        }
    }
    if (delivery.deliveryMode === 'SHIP' && delivery.bunkershipEta) {
        var pathEta = path.concat('bunkershipEta').join('.');
        if (delivery.bunkershipEtd &&
            isAfter(DateTime.fromISO(delivery.bunkershipEta), DateTime.fromISO(delivery.bunkershipEtd))) {
            setWith(errors, pathEta, 'LBV ETA must be before ETD', Object);
        }
    }
    if (delivery.bst) {
        var pathBst = path.concat('bst').join('.');
        if ((monthStart && isBefore(DateTime.fromISO(delivery.bst), DateTime.fromJSDate(monthStart))) ||
            (monthEnd && isAfter(DateTime.fromISO(delivery.bst), DateTime.fromJSDate(monthEnd)))) {
            setWith(errors, pathBst, 'BST must be within the current month', Object);
        }
        else if ((selectedContract && isBefore(DateTime.fromISO(delivery.bst), DateTime.fromISO(selectedContract.fromDate))) ||
            (selectedContract && isAfter(DateTime.fromISO(delivery.bst), DateTime.fromISO(selectedContract.toDate)))) {
            setWith(errors, pathBst, "BST must be within the contract's period. (" + DateTime.fromISO(selectedContract.fromDate).toFormat('dd-MM-yyyy') + " - " + DateTime.fromISO(selectedContract.toDate).toFormat('dd-MM-yyyy') + ")", Object);
        }
    }
    if (delivery.etd) {
        var pathEtd = path.concat('etd').join('.');
        if (delivery.eta && isBefore(DateTime.fromISO(delivery.etd), DateTime.fromISO(delivery.eta))) {
            setWith(errors, pathEtd, 'ETD must be after ETA', Object);
        }
    }
    if (delivery.deliveryMode === 'SHIP' && delivery.bunkershipEtd) {
        var pathEtd = path.concat('bunkershipEtd').join('.');
        if (delivery.bunkershipEta &&
            isBefore(DateTime.fromISO(delivery.bunkershipEtd), DateTime.fromISO(delivery.bunkershipEta))) {
            setWith(errors, pathEtd, 'LBV ETD must be after ETA', Object);
        }
    }
    if (delivery.eta && delivery.etd) {
        var pathEta = path.concat('eta').join('.');
        var pathEtd = path.concat('etd').join('.');
        if (datesAreEqual(DateTime.fromISO(delivery.eta), DateTime.fromISO(delivery.etd))) {
            setWith(errors, pathEta, 'ETA can not be at the same time as ETD', Object);
            setWith(errors, pathEtd, 'ETD can not be at the same time as ETA', Object);
        }
    }
    if (delivery.bunkershipEta && delivery.bunkershipEtd) {
        var pathEta = path.concat('bunkershipEta').join('.');
        var pathEtd = path.concat('bunkershipEtd').join('.');
        if (datesAreEqual(DateTime.fromISO(delivery.bunkershipEta), DateTime.fromISO(delivery.bunkershipEtd))) {
            setWith(errors, pathEta, 'LBV ETA can not be at the same time as ETD', Object);
            setWith(errors, pathEtd, 'LBV ETD can not be at the same time as ETA', Object);
        }
    }
    if (isPromptEvent(delivery) && !isCustomer(userRoles)) {
        var promptDelivery = delivery;
        if (promptDelivery.hosesDisconnected) {
            if (promptDelivery.hosesConnected &&
                isBefore(DateTime.fromISO(promptDelivery.hosesDisconnected), DateTime.fromISO(promptDelivery.hosesConnected))) {
                setWith(errors, path.concat('hosesDisconnected').join('.'), 'Hoses disconnected must be after hoses connected', Object);
            }
        }
    }
    //
    // AMOUNTS VALIDATION
    //
    amountValidation('amount', delivery, path, errors, true);
    amountValidation('actualAmount', delivery, path, errors, false);
    return errors;
}
function validateNominationBST(delivery, userRoles) {
    function validateReceivingVessel() {
        if (delivery.bst) {
            // Receiving vessel
            if (delivery.eta && isBefore(DateTime.fromISO(delivery.bst), DateTime.fromISO(delivery.eta))) {
                return 'Warning: proposed BST is before receiving vessel ETA';
            }
            if (delivery.etd && isAfter(DateTime.fromISO(delivery.bst), DateTime.fromISO(delivery.etd))) {
                return 'Warning: proposed BST is after receiving vessel ETD';
            }
        }
    }
    function validateBunkerVessel() {
        if (delivery.bst && delivery.deliveryMode === 'SHIP') {
            // Bunker Vessel
            if (delivery.bunkershipEta &&
                isBefore(DateTime.fromISO(delivery.bst), DateTime.fromISO(delivery.bunkershipEta))) {
                return 'Warning: proposed BST is before bunker vessel ETA';
            }
            var allowedBunkeringTime = Duration.fromMillis((delivery.allowedBunkeringTime || 0) * 60 * 60 * 1000);
            var BSTPlusABT = DateTime.fromISO(delivery.bst).plus(allowedBunkeringTime);
            if (delivery.bunkershipEtd && isAfter(BSTPlusABT, DateTime.fromISO(delivery.bunkershipEtd))) {
                if (isAfter(DateTime.fromISO(delivery.bst), DateTime.fromISO(delivery.bunkershipEtd))) {
                    return 'Warning: proposed BST is after bunker vessel ETD';
                }
                return 'Warning: proposed BST plus Allowed bunker time is after bunker vessel ETD';
            }
        }
    }
    // return the right message depending on the user role, i.e. in case of
    // supplier you first want to see the BunkerVessel warning (if any)
    return isScheduler(userRoles) || isSchedulerCaptain(userRoles)
        ? validateBunkerVessel() || validateReceivingVessel()
        : validateReceivingVessel() || validateBunkerVessel();
}
function amountValidation(label, nomination, path, errors, required) {
    // Deliveries minimal
    if (!required && !nomination[label]) {
        return;
    }
    if (label in nomination && (nomination[label] < MINIMUM_QUANTITY || nomination[label] >= MAXIMUM_QUANTITY)) {
        var errorMessage = "Quantity must be between " + MINIMUM_QUANTITY + " and " + (MAXIMUM_QUANTITY - 1) + " MT";
        setWith(errors, path.concat(label).join('.'), errorMessage, Object);
    }
    if (!nomination[label] && required) {
        setWith(errors, path.concat(label).join('.'), 'This Field is Required', Object);
    }
}
function parseNominationValues(promptNomination) {
    var nominationToUpdate = cloneDeep(promptNomination);
    var FIELDS_TO_PARSE = ['amount', 'allowedBunkeringTime'];
    // loops through all the fields and checks if they have been filled in.
    FIELDS_TO_PARSE.forEach(function (field) {
        if (nominationToUpdate[field]) {
            nominationToUpdate[field] = parseFloat(nominationToUpdate[field]);
        }
    });
    return nominationToUpdate;
}

function validateEnquiry(nominationEnquiry, userProfile, isNewEnquiry, deliveryModesEnabled) {
    var errors = {};
    var REQUIRED_FIELDS_FOR_SCHEDULER = [
        'locationId',
        'amount',
        'price',
        'priceUnit',
        'energyUnit',
        'grossNet',
        'offerExpiration',
        'bst',
        'allowedBunkeringTime',
    ];
    var REQUIRED_FIELDS_FOR_CUSTOMER = [
        'receivingShipId',
        'locationId',
        'amount',
        'bst',
        'eta',
        'etd',
    ];
    if (deliveryModesEnabled) {
        REQUIRED_FIELDS_FOR_CUSTOMER.push('deliveryModes');
        REQUIRED_FIELDS_FOR_SCHEDULER.push('deliveryModes');
    }
    validateEventDate('bst', nominationEnquiry, [], errors);
    validateEventDate('eta', nominationEnquiry, [], errors);
    validateEventDate('etd', nominationEnquiry, [], errors);
    validateEventDate('offerExpiration', nominationEnquiry, [], errors);
    // Determines which fields to validate based on the user role.
    var requiredFieldsToValidate = isScheduler(userProfile.roles)
        ? REQUIRED_FIELDS_FOR_SCHEDULER
        : REQUIRED_FIELDS_FOR_CUSTOMER;
    // loops through all the fields and checks if they have been filled in.
    requiredFieldsToValidate.forEach(function (field) {
        if (!nominationEnquiry[field] ||
            nominationEnquiry[field] === '' ||
            (isArray(nominationEnquiry[field]) && nominationEnquiry[field].length === 0)) {
            errors[field] = 'This Field is Required';
        }
    });
    if (nominationEnquiry.eta) {
        if (nominationEnquiry.etd &&
            isAfter(DateTime.fromISO(nominationEnquiry.eta), DateTime.fromISO(nominationEnquiry.etd))) {
            errors['eta'] = 'ETA must be before ETD';
        }
    }
    if (nominationEnquiry.etd) {
        if (nominationEnquiry.eta &&
            isBefore(DateTime.fromISO(nominationEnquiry.etd), DateTime.fromISO(nominationEnquiry.eta))) {
            errors['etd'] = 'ETD must be after ETA';
        }
    }
    if (nominationEnquiry.eta && nominationEnquiry.etd) {
        if (datesAreEqual(DateTime.fromISO(nominationEnquiry.eta), DateTime.fromISO(nominationEnquiry.etd))) {
            errors['eta'] = 'ETA can not be at the same time as ETD';
            errors['etd'] = 'ETD can not be at the same time as ETA';
        }
    }
    return errors;
}
function parseEnquiryValues(nominationEnquiry) {
    var enquiryToUpdate = cloneDeep(nominationEnquiry);
    var FIELDS_TO_PARSE = ['amount', 'allowedBunkeringTime'];
    // loops through all the fields and checks if they have been filled in.
    FIELDS_TO_PARSE.forEach(function (field) {
        if (enquiryToUpdate[field]) {
            enquiryToUpdate[field] = parseFloat(enquiryToUpdate[field]);
        }
    });
    return enquiryToUpdate;
}
function validateEnquiryBST(nominationEnquiry) {
    if (nominationEnquiry.bst) {
        if (nominationEnquiry.eta &&
            isBefore(DateTime.fromISO(nominationEnquiry.bst), DateTime.fromISO(nominationEnquiry.eta))) {
            return 'Warning: BST is before ETA';
        }
        if (nominationEnquiry.etd &&
            isAfter(DateTime.fromISO(nominationEnquiry.bst), DateTime.fromISO(nominationEnquiry.etd))) {
            return 'Warning: BST is after ETD';
        }
    }
    return undefined;
}

function validatePromptForm(values) {
    var errors = {};
    if (!values.eta) {
        errors.eta = 'Required';
    }
    if (!values.etd) {
        errors.etd = 'Required';
    }
    if (values.eta) {
        if (values.etd && isAfter(parseDateOrStringToDateTime(values.eta), parseDateOrStringToDateTime(values.etd))) {
            errors.eta = 'ETA must be before ETD';
        }
    }
    if (values.etd) {
        if (values.eta && isBefore(parseDateOrStringToDateTime(values.etd), parseDateOrStringToDateTime(values.eta))) {
            errors.etd = 'ETD must be after ETA';
        }
    }
    if (values.eta && !isValidDate(values.eta)) {
        errors.eta = 'Fill in a valid date';
    }
    if (values.etd && !isValidDate(values.etd)) {
        errors.etd = 'Fill in a valid date';
    }
    return errors;
}
function validateTentativeNomination(values) {
    var errors = {};
    if (!values.locationId) {
        errors.locationId = 'Required';
    }
    if (!values.receivingShipId) {
        errors.receivingShipId = 'Required';
    }
    if (!values.amount) {
        errors.amount = 'Required';
    }
    if (!values.eta) {
        errors.eta = 'Required';
    }
    if (!values.etd) {
        errors.etd = 'Required';
    }
    if (values.eta) {
        if (values.etd && isAfter(parseDateOrStringToDateTime(values.eta), parseDateOrStringToDateTime(values.etd))) {
            errors.eta = 'ETA must be before ETD';
        }
    }
    if (values.etd) {
        if (values.eta && isBefore(parseDateOrStringToDateTime(values.etd), parseDateOrStringToDateTime(values.eta))) {
            errors.etd = 'ETD must be after ETA';
        }
    }
    if (values.eta && !isValidDate(values.eta)) {
        errors.eta = 'Fill in a valid date';
    }
    if (values.etd && !isValidDate(values.etd)) {
        errors.etd = 'Fill in a valid date';
    }
    return errors;
}
function validateSandboxPromptForm(values) {
    var errors = {};
    if (!values.eta) {
        errors.eta = 'Required';
    }
    if (!values.etd) {
        errors.etd = 'Required';
    }
    if (values.eta) {
        if (values.etd && isAfter(parseDateOrStringToDateTime(values.eta), parseDateOrStringToDateTime(values.etd))) {
            errors.eta = 'ETA must be before ETD';
        }
    }
    if (values.etd) {
        if (values.eta && isBefore(parseDateOrStringToDateTime(values.etd), parseDateOrStringToDateTime(values.eta))) {
            errors.etd = 'ETD must be after ETA';
        }
    }
    if (!values.sandboxId) {
        errors.sandboxId = 'Required';
    }
    if (values.eta && !isValidDate(values.eta)) {
        errors.eta = 'Fill in a valid date';
    }
    if (values.etd && !isValidDate(values.etd)) {
        errors.etd = 'Fill in a valid date';
    }
    return errors;
}

var SEARCH_MIN_LENGTH = 3;
var SEARCH_DEBOUNCE_DELAY = 500; // ms
var PRICE_UNITS = [
    { value: PriceUnit.EUR, text: 'EUR' },
    { value: PriceUnit.USD, text: 'USD' },
    { value: PriceUnit.GBP, text: 'GBP' }
];
var ENERGY_UNITS = [
    { value: EnergyUnit.MWH, text: 'MWh' },
    { value: EnergyUnit.MMBTU, text: 'MMBTu' },
    { value: EnergyUnit.THERM, text: 'Therm' },
    { value: EnergyUnit.MJ, text: 'MJ' }
];
var QUANTITY_UNITS = [
    { value: QuantityUnit.TONNES, text: 'mt' },
    { value: QuantityUnit.CUBIC_METERS, text: 'm³' },
    { value: QuantityUnit.KILOGRAMS, text: 'kg' }
];
function getQuantityUnitLabel(quantityUnit) {
    var _a;
    return quantityUnit
        ? ((_a = QUANTITY_UNITS.find(function (item) { return item.value === quantityUnit; })) === null || _a === void 0 ? void 0 : _a.text) || quantityUnit
        : 'Quantity not found';
}
var EBDN_TITLES = {
    ctmsData: 'CTMS Measurement Data',
    quantity: 'Quantity Delivered',
    details: 'eBDN Details & Overview',
    lngComposition: 'LNG Composition',
    lngProperties: 'LNG Properties',
    timestamps: '',
    configuration: '',
    _id: '',
    pdf: '',
    spreadsheet: '',
    flowType: '',
    externalSettings: ''
};
var IAPH_V2_A1_TABLE_TEXT = [
    [
        {
            title: 'Local and Site requirements:',
            items: [
                'Local regulations and approvals',
                'Site electrical equipment in the Hazardous zone',
                'Control zones and safety measures',
                'Controlled acces to safety- and hazardous zone',
                'Approved safety distance to public (external safety)'
            ]
        },
        {
            title: 'Mooring:',
            items: [
                'Mooring analyses',
                'Mooring points',
                'Mooring loads',
                'Mooring lines',
                'Mooring gear load limits (bollards, chocks, rollers etc.)',
                'Fendering',
                'Hull form flat side',
                'Overall dimensions',
                'Bridge wings',
                'Freeboard'
            ]
        },
        {
            title: 'Equipment:',
            items: [
                'Approved transfer equipment',
                'Electrical insulation',
                'International shore connection',
                'Crane and crane reach',
                'Loading arm and arm reach',
                'Boom',
                'Hoses',
                'Hose support equipment',
                'Manifold',
                'Deluge System',
                'Drip trays, gutters'
            ]
        }
    ],
    [
        {
            title: 'Manifold:',
            items: [
                'Distancing',
                'Spacing, orientation',
                'Height and strength',
                'Layout',
                'Instrumentation',
                'Connections size and design',
                'Cryogenic protection',
                'Spill containment'
            ]
        },
        {
            title: 'Connection:',
            items: [
                'Lifting arrangements',
                'Bunker hose configuration',
                'Distancing (between manifold and bunkerstation - height and length)',
                'ESD / (P)ERC, BSL, ERS, TRV'
            ]
        },
        {
            title: 'Bunkering and safety measures:',
            items: [
                'Freeboard differences during bunkering',
                'Draft and tidal changes',
                'Weather and Wave conditions',
                'Vessel separation detection with ESD function',
                'Bunkering procedures including cooling down, purging and tests',
                'Transfer data',
                'Maximum allowable parameters',
                'BOG / vapour management',
                'Hazardous area classification and control',
                'Exposure distances conform Industrial standards (IGC/EIGA), SIMOPS',
                'Responsibilities PIC and manifold crew in charge',
                'Supervision'
            ]
        }
    ],
    [
        {
            title: 'People:',
            items: [
                'Personnel Instruction',
                'Incident response instruction and training',
                'Familiarity of personnel with safety areas and safety measures during bunkering',
                'Emergency stop signal and shutdown procedures',
                'Organisation',
                'Roles and Responsibilities',
                'PIC appointment'
            ]
        },
        {
            title: 'Incident response:',
            items: ['Fire control plan', 'Emergency Response procedures', 'Contingency planning']
        },
        {
            title: 'Communication:',
            items: [
                'Joint Plan of Bunker Operations (JPBO)',
                'Means of communication',
                'Communication procedures and contact',
                'Details involved parties',
                'Language',
                'Communication PIC’s',
                'Data communication between safety- and ESD systems'
            ]
        }
    ]
];
var IAPH_V2_A2_TABLE_TEXT = [
    [
        {
            title: 'General',
            items: [
                'Unique Bunker Identification Number (BIN)',
                'Purpose and scope of the JPBO',
                'Report of the Compatibility check'
            ]
        },
        {
            title: 'Transfer system',
            items: ['ERS', 'ESD link', 'ESD test', 'Spill /gas detection and control systems']
        },
        {
            title: 'Roles and Responsibilities',
            items: [
                'Organization',
                'Responsibilities PIC vessels and manifold crew in charge',
                'Mandatory permissions'
            ]
        },
        {
            title: 'Bunker operation',
            items: [
                'Approach',
                'Mooring',
                'Checklist to be used, latest version',
                'Handling and connection of bunker hose and vapor return hose',
                'Hose Saddle, Deluge System, Manifold Connection, Drip trays, gutters.',
                'Connection, pressure test, purging, cooling down, gassing up',
                'Environmental Operating Limits',
                'Sequence of actions in case of a spill',
                'PPE, personal safety',
                'Draining, purging disconnecting, inerting',
                'Post transfer procedures',
                'Un-mooring'
            ]
        }
    ],
    [
        {
            title: 'Vessels details',
            items: [
                'Description of the involved vessels',
                'Specification of the ships',
                'Access to the vessel and access control of safety zones (including supervision)'
            ]
        },
        {
            title: 'Bunker preparation',
            items: [
                'Mooring analyses report, mooringplan',
                'Description of location, bunkering zones',
                'Description of safety zones',
                'Fendering / mooring',
                'Safety meeting',
                'Bunker transfer: equipment and procedures',
                'Energy carrier supply specification',
                'Volumes (Quantities and characteristics)',
                'Communication (e.g. language), contact details',
                'SIMOPS',
                'Control zones, safeguards'
            ]
        },
        {
            title: 'Emergencies',
            items: [
                'Emergency preparedness and response',
                'Hull protection, water screens.',
                'Emergency shutdown system'
            ]
        }
    ]
];

var FormFieldFuelSelector = function (props) {
    var percentage = props.percentage, previousPercentage = props.previousPercentage, readOnly = props.readOnly, onChangeAmount = props.onChangeAmount, onChangePercentage = props.onChangePercentage, amount = props.amount, quantityUnit = props.quantityUnit;
    var _a = useState(), userAmount = _a[0], setUserAmount = _a[1];
    var _b = useState(), userPercentage = _b[0], setUserPercentage = _b[1];
    useEffect(function () {
        setUserAmount(undefined);
    }, [amount]);
    useEffect(function () {
        setUserPercentage(undefined);
    }, [percentage]);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(FormElement, { className: "form-fuel-selector" },
            React__default.createElement(FormLabel, null,
                "Quantity LBG",
                React__default.createElement("div", { className: "label-unit" }, "(%)")),
            React__default.createElement(NumberInput, { name: 'percentage', value: userPercentage || percentage || '', disabled: readOnly, maxDecimals: 3, onChangeFormValue: function (label, value) {
                    var numberInput = value;
                    setUserPercentage(numberInput);
                }, onBlur: function () {
                    if (userPercentage !== undefined) {
                        onChangePercentage(userPercentage);
                    }
                } }),
            React__default.createElement("div", { className: "form-field-message" },
                React__default.createElement(FormLabel, { strikeThrough: true }, previousPercentage || ''))),
        React__default.createElement(FormElement, null,
            React__default.createElement(FormLabel, null, "Quantity LBG"),
            React__default.createElement(NumberInput, { name: 'amount', value: (userAmount || amount || '') + " " + (userAmount || amount ? getQuantityUnitLabel(quantityUnit) : ''), disabled: readOnly, maxDecimals: 3, onChangeFormValue: function (label, value) {
                    var numberInput = value;
                    setUserAmount(numberInput);
                }, onBlur: function () {
                    if (userAmount !== undefined) {
                        onChangeAmount(userAmount);
                    }
                } }))));
};

var SliderFuelSelector = function (props) {
    var percentage = props.percentage, previousPercentage = props.previousPercentage, readOnly = props.readOnly, onChangeAmount = props.onChangeAmount, onChangePercentage = props.onChangePercentage, amount = props.amount, quantityUnit = props.quantityUnit;
    var _a = useState(), userAmount = _a[0], setUserAmount = _a[1];
    var _b = useState(), userPercentage = _b[0], setUserPercentage = _b[1];
    var showPreviousPercentage = previousPercentage !== undefined && previousPercentage !== null && previousPercentage !== '';
    useEffect(function () {
        setUserAmount(undefined);
    }, [amount]);
    useEffect(function () {
        setUserPercentage(undefined);
    }, [percentage]);
    // const [alternativeFuelType, setAlternativeFuelType] = useState<null | 'LBG' | 'LSM'>(null)
    // const altFuelOptions: { value: 'LSM' | 'LBG'; text: string }[] = [
    //   { value: 'LBG', text: 'LBG' },
    //   { value: 'LSM', text: 'LSM' },
    // ]
    var percentageToShow = isNaN(percentage) || !percentage ? 0 : parseInt(percentage);
    return (React__default.createElement(FormFieldWrapper, { className: "slider-fuel-selector" },
        React__default.createElement("div", { className: "fuel-icon-cover" }),
        React__default.createElement("div", { className: "fuel-icon" },
            React__default.createElement("i", { className: "icon-lbg-icon-fb" })),
        React__default.createElement("div", { className: "fuel-selector-header" },
            React__default.createElement("div", null,
                React__default.createElement("h3", null, "Reduce my carbon footprint"),
                React__default.createElement("p", null, "This supplier can deliver any amount of liquefied biogas (LBG) as a drop in fuel, to significantly cut your carbon footprint."))),
        React__default.createElement("div", { className: "fuel-selection-box" },
            React__default.createElement(Slider, { min: 0, max: 100, value: percentageToShow, disabled: readOnly, onChange: function (e) {
                    var percentageNumber = parseFloat(e.toFixed());
                    onChangePercentage(percentageNumber);
                } }),
            React__default.createElement("div", { className: "inputs" },
                React__default.createElement(InlineFormElement, null,
                    React__default.createElement(FormElement, null,
                        React__default.createElement(NumberInput, { name: 'percentage', value: userPercentage || percentage || '', disabled: readOnly, maxDecimals: 3, onChangeFormValue: function (label, value) {
                                var numberInput = value;
                                setUserPercentage(numberInput);
                            }, onBlur: function () {
                                if (userPercentage !== undefined) {
                                    onChangePercentage(userPercentage);
                                }
                            } }),
                        showPreviousPercentage && React__default.createElement(FormLabel, { strikeThrough: true }, previousPercentage),
                        React__default.createElement("span", null, "%")),
                    React__default.createElement(FormElement, null,
                        React__default.createElement(NumberInput, { name: 'amount', value: (userAmount || amount || '') + " " + getQuantityUnitLabel(quantityUnit), disabled: readOnly, maxDecimals: 3, onChangeFormValue: function (label, value) {
                                var numberInput = value;
                                setUserAmount(numberInput);
                            }, onBlur: function () {
                                if (userAmount !== undefined) {
                                    onChangeAmount(userAmount);
                                }
                            } })))))));
};

var AlternativeFuelSelector = function (props) {
    var percentage = props.percentage, previousPercentage = props.previousPercentage;
    var amount = percentage ? Number((props.totalAmount * (percentage / 100)).toFixed(2)) : 0;
    if (props.type === 'FORMFIELDS') {
        return (React__default.createElement(FormFieldFuelSelector, { onChangeAmount: onChangeAmount, onChangePercentage: onChangePercentage, readOnly: props.readOnly, amount: amount, quantityUnit: props.quantityUnit, percentage: percentage, previousPercentage: previousPercentage }));
    }
    if (props.type === 'SLIDER') {
        return (React__default.createElement(FormElement, { className: "alternative-fuel-selector " + (props.className || '') },
            React__default.createElement("label", { className: "form-field-label" }),
            React__default.createElement(SliderFuelSelector, { onChangeAmount: onChangeAmount, onChangePercentage: onChangePercentage, readOnly: props.readOnly, amount: amount, quantityUnit: props.quantityUnit, percentage: percentage, previousPercentage: previousPercentage })));
    }
    return null;
    function onChangeAmount(amount) {
        if (!amount) {
            if (props.onChangeFormValue)
                props.onChangeFormValue('altFuelPercentage', undefined);
            return;
        }
        if (amount > props.totalAmount) {
            if (props.onChangeFormValue)
                props.onChangeFormValue('altFuelPercentage', 100);
            return;
        }
        var percentage = Number(((amount / props.totalAmount) * 100).toFixed(3));
        if (props.onChangeFormValue)
            props.onChangeFormValue('altFuelPercentage', percentage);
    }
    function onChangePercentage(percentage) {
        if (!percentage) {
            if (props.onChangeFormValue)
                props.onChangeFormValue('altFuelPercentage', undefined);
            return;
        }
        if (percentage >= 100) {
            if (props.onChangeFormValue)
                props.onChangeFormValue('altFuelPercentage', 100);
            return;
        }
        var percentageRounded = Number(Number(percentage).toFixed(3));
        if (props.onChangeFormValue)
            props.onChangeFormValue('altFuelPercentage', percentageRounded);
    }
};

var InputProblemMessage = function (props) {
    if (!props.message && !props.type)
        return null;
    return (React__default.createElement("span", { className: "form-field-error-message " + props.type.toLocaleLowerCase() }, props.message));
};

var LNGQualityRow = function (props) {
    var _a, _b, _c;
    return (React__default.createElement("tr", null,
        React__default.createElement("td", null, getLNGCompoundName(props.compound)),
        React__default.createElement("td", null, getLNGCompoundFormula(props.compound)),
        React__default.createElement("td", { className: "no-padding ebdn-input" },
            React__default.createElement("input", { className: props.problem
                    ? "input-validation input-" + ((_a = props.problem) === null || _a === void 0 ? void 0 : _a.problemType.toLocaleLowerCase())
                    : "", type: "number", value: parseBDNNumberValue(props.value, ''), disabled: props.readOnly, placeholder: props.placeholder, step: "0.01", onChange: function (e) {
                    props.onChange(e.target.value);
                } }),
            React__default.createElement(InputProblemMessage, { message: (_b = props.problem) === null || _b === void 0 ? void 0 : _b.message, type: (_c = props.problem) === null || _c === void 0 ? void 0 : _c.problemType })),
        React__default.createElement("td", null, props.customUnit || 'mol%')));
};

var LNGQualityTable = function (props) {
    var _a = useForm({
        initialValues: props.qualityValues,
        onValidSubmit: props.updateLNGQuality
    }), handleSubmit = _a.handleSubmit, values = _a.values, onChangeValue = _a.onChangeValue, isDifferentFromInitial = _a.isDifferentFromInitial;
    return (React__default.createElement("div", { className: "bdn-step" },
        React__default.createElement("table", { cellSpacing: "0", cellPadding: "0" },
            !props.hideTableHeaders && React__default.createElement(LNGQualityTableHeader, { qualityType: props.qualityType }),
            React__default.createElement("tbody", null,
                React__default.createElement(LNGQualitySubHeader, { qualityValues: values, onChangeValue: onChangeValue, readOnly: props.readOnly, qualityType: props.qualityType }),
                STANDARD_LNG_COMPOSITION_COMPOUNDS.map(function (compound, index) {
                    return (React__default.createElement(LNGQualityRow, { key: compound + "-" + index, compound: compound, value: getLNGCompositionValue(compound), readOnly: props.readOnly, onChange: function (value) {
                            onChangeValue("composition." + compound, value);
                        }, problem: undefined }));
                }),
                React__default.createElement(LNGQualityRow, { compound: 'sulphur', value: getLNGCompositionValue('sulphur'), readOnly: props.readOnly, onChange: function (value) {
                        onChangeValue('composition.sulphur', value);
                    }, problem: undefined }))),
        !props.readOnly && (React__default.createElement(Button, { preventDoubleClick: true, disabled: !isDifferentFromInitial, onClick: function () {
                handleSubmit();
            }, primary: true }, props.qualityType === 'heelQuality' ? 'Save heel values' : 'Save loaded values'))));
    function getLNGCompositionValue(field) {
        var value = values && values.composition ? values.composition[field] : '';
        if (isNaN(Number(value))) {
            return undefined;
        }
        else {
            return value;
        }
    }
};
var LNGQualityTableHeader = function (props) {
    var tableHeaderText = getLNGTableHeader(props.qualityType);
    return (React__default.createElement("thead", { className: "table-header" },
        React__default.createElement("tr", null,
            React__default.createElement("td", { colSpan: 4 }, tableHeaderText))));
    function getLNGTableHeader(type) {
        switch (type) {
            case 'heelQuality':
                return 'LNG Heel Quality';
            case 'loadedQuality':
                return 'LNG Loaded Quality';
            default:
                return '';
        }
    }
};
var LNGQualitySubHeader = function (props) {
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("tr", null,
            React__default.createElement("td", { className: "table-sub-header", colSpan: 4 }, getSubHeaderText(props.qualityType))),
        React__default.createElement("tr", null,
            React__default.createElement("td", { colSpan: 2 }, "Liquid Temperature"),
            React__default.createElement("td", { className: "no-padding" },
                React__default.createElement("input", { type: "number", value: props.qualityValues ? props.qualityValues.temperature : '', step: "0.01", disabled: props.readOnly, onChange: function (e) {
                        props.onChangeValue('temperature', e.target.value);
                    } })),
            React__default.createElement("td", null, "\u00B0C")),
        React__default.createElement("tr", null,
            React__default.createElement("td", { colSpan: 2 }, props.qualityType === 'heelQuality' ? 'Heel Volume' : 'Volume After Loading'),
            React__default.createElement("td", { className: "no-padding" },
                React__default.createElement("input", { type: "number", value: props.qualityValues ? props.qualityValues.volume : '', step: "0.01", disabled: props.readOnly, onChange: function (e) {
                        props.onChangeValue('volume', e.target.value);
                    } })),
            React__default.createElement("td", null,
                "m",
                React__default.createElement("sup", null, "3"))),
        React__default.createElement("tr", null,
            React__default.createElement("td", { className: "table-sub-header", colSpan: 4 }, getCompositionHeaderText(props.qualityType)))));
    function getSubHeaderText(type) {
        switch (type) {
            case 'heelQuality':
                return 'Measurement Data from CTMS Report Prior to Loading';
            case 'loadedQuality':
                return 'Measurement Data from CTMS Report After Loading';
            default:
                return '';
        }
    }
    function getCompositionHeaderText(type) {
        switch (type) {
            case 'heelQuality':
                return 'Composition of LNG Heel from PREVIOUS Certificate of Quality';
            case 'loadedQuality':
                return 'Composition of LNG Heel from CURRENT Certificate of Quality';
            default:
                return '';
        }
    }
};

var CalculateBDNStep = function (props) {
    var calculationLabel = props.type.toLowerCase();
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("div", { className: "calculate-values-wrapper" },
            React__default.createElement("div", null,
                React__default.createElement("h4", null,
                    "Calculate LNG ",
                    calculationLabel),
                React__default.createElement("p", null,
                    "The LNG ",
                    calculationLabel,
                    " can be automatically calculated. This calculation is based on ISO 6976:2016 and ISO 6578:2017 standards and uses a combustion reference temperature and metering reference temperature of 15\u00B0C. For calculating the methane number, the PKI method is used.")),
            React__default.createElement(Button, { success: true, onClick: props.calculate }, "Calculate")),
        props.showWarning && (React__default.createElement("span", { className: "warning" },
            React__default.createElement("b", null, "Note:"),
            " Are you sure you want to calculate the ",
            calculationLabel,
            "? This will override the currently filled in ",
            calculationLabel,
            " values."))));
};

var SelectOption = function (props) {
    return (React__default.createElement("div", { className: "shipsearch-select-option " + (props.className ? props.className : '') },
        props.renderer ? props.renderer(props.label) : React__default.createElement("b", null, props.label),
        props.children));
};

var FillFromPredefined = function (props) {
    var _a = useState(), selected = _a[0], setSelected = _a[1];
    return (React__default.createElement("div", { className: "quantity-calculation-form select-ebdn-data" },
        React__default.createElement(FormWrapper, null,
            React__default.createElement(FormElement, { style: { display: 'flex' } },
                React__default.createElement(FormLabel, { fieldName: "message" }, props.message ? props.message : 'Predefined LNG properties'),
                React__default.createElement("div", { className: "flex ebdn-asset-data-wrapper" },
                    React__default.createElement(SelectionBox, { fieldName: "predefined-" + props.fieldname, placeholder: 'Select predefined', value: selected ? formatData(selected).text : undefined, renderFieldValue: function (selectedItem) {
                            return "" + selectedItem.text;
                        }, valueKey: "text", displayKey: "text", onChangeValue: function (unit) {
                            if (unit) {
                                props.callback(unit.value);
                                setSelected(unit.value);
                            }
                        }, options: __spreadArrays([
                            { value: {}, text: 'None..' }
                        ], props.data.map(function (d) {
                            return formatData(d);
                        })), renderOption: function (option) { return (React__default.createElement(SelectOption, { label: option.text, className: "ebdn-asset-data-option", renderer: function (data) {
                                return data === 'None..' ? React__default.createElement("i", null, data) : React__default.createElement("b", null, data);
                            } })); } }))))));
    function formatData(d) {
        return {
            value: d,
            text: props.renderer
                ? props.renderer(d)
                : props.displayRule
                    .map(function (displayObj) {
                    return displayObj.render
                        ? displayObj.render(d[displayObj.key] || displayObj.fallback)
                        : d[displayObj.key] || displayObj.fallback;
                })
                    .join(', ')
        };
    }
};
var SelectingPredefinedWarning = function () {
    return (React__default.createElement("div", { className: "warning selecting-predefined-lng-asset-warning" },
        React__default.createElement("b", null, "Note:"),
        "Selecting predefined properties or calculating properties will overwrite the current values."));
};

function useDebounce(value, delay) {
    // State and setters for debounced value
    var _a = useState(value), debouncedValue = _a[0], setDebouncedValue = _a[1];
    useEffect(function () {
        // Update debounced value after delay
        var handler = setTimeout(function () {
            setDebouncedValue(value);
        }, delay);
        // Cancel the timeout if value changes (also on delay change or unmount)
        // This is how we prevent debounced value from updating if value is changed ...
        // .. within the delay period. Timeout gets cleared and restarted.
        return function () {
            clearTimeout(handler);
        };
    }, [value, delay] // Only re-call effect if value or delay changes
    );
    return debouncedValue;
}

var useFuncOnStopChanging = function (values, oldValue, func, runOnUnmount, debounceDelay, enabled) {
    if (runOnUnmount === void 0) { runOnUnmount = true; }
    if (debounceDelay === void 0) { debounceDelay = 1500; }
    if (enabled === void 0) { enabled = true; }
    var value = useDebounce(values, debounceDelay);
    useEffect(function () {
        if (enabled && !_.isEqual(value, oldValue)) {
            func();
        }
    }, [value]);
    useEffect(function () {
        return function () {
            enabled && runOnUnmount && values !== oldValue && func();
        };
    }, []);
};

var PropertiesTable = function (props) {
    var _a = useForm({
        initialValues: props.values,
        onValidSubmit: function (lngProperties) { return props.update(lngProperties); }
    }), handleSubmit = _a.handleSubmit, values = _a.values, onChangeValue = _a.onChangeValue, isDifferentFromInitial = _a.isDifferentFromInitial;
    function autoPopulate(data) {
        new Set(__spreadArrays(Object.keys(data.properties || {}), Object.keys(values || {}))).forEach(function (key) {
            var _a;
            props.configuration[key] && onChangeValue(key, ((_a = data.properties) === null || _a === void 0 ? void 0 : _a[key]) || null);
        });
    }
    useFuncOnStopChanging(values, props.values, handleSubmit, true, 1500, props.autoSave || false);
    return (React__default.createElement("div", { className: "bdn-step" },
        props.integrationData && (React__default.createElement(FillFromPredefined, { callback: autoPopulate, data: props.integrationData.filter(function (data) { return data.properties; }), displayRule: [
                { key: 'description', fallback: props.assetName },
                { key: 'created', render: formatDateTime }
            ], fieldname: 'PropertiesTable' })),
        !props.readOnly && props.showCalculationOption && props.calculateLNGProperties && (React__default.createElement(CalculateBDNStep, { type: 'PROPERTIES', calculate: props.calculateLNGProperties })),
        props.integrationData && React__default.createElement(SelectingPredefinedWarning, null),
        React__default.createElement("div", { className: "bdn-energy-unit-selection" },
            React__default.createElement("h5", null, "Energy Unit"),
            React__default.createElement(Button, { preventDoubleClick: true, switchButton: true, disabled: props.readOnly, className: "negotiation-toggle-button" },
                React__default.createElement("span", { onClick: function () {
                        if (!props.readOnly) {
                            onChangeValue('energyUnit', EnergyUnit.KWH);
                        }
                    }, className: (values === null || values === void 0 ? void 0 : values.energyUnit) === EnergyUnit.KWH ? 'active' : '' }, "kWh"),
                React__default.createElement("span", { onClick: function () {
                        if (!props.readOnly) {
                            onChangeValue('energyUnit', EnergyUnit.MMBTU);
                        }
                    }, className: (values === null || values === void 0 ? void 0 : values.energyUnit) === EnergyUnit.MMBTU ? 'active' : '' }, "MMBtu"),
                React__default.createElement("span", { onClick: function () {
                        if (!props.readOnly) {
                            onChangeValue('energyUnit', EnergyUnit.MJ);
                        }
                    }, className: (values === null || values === void 0 ? void 0 : values.energyUnit) === EnergyUnit.MJ ? 'active' : '' }, "MJ"))),
        React__default.createElement("table", null,
            !props.hideTableHeaders && (React__default.createElement("thead", { className: "" },
                React__default.createElement("tr", null,
                    React__default.createElement("td", { colSpan: 3 }, "LNG Properties")))),
            React__default.createElement("tbody", null, Object.entries(props.configuration).map(function (_a, index) {
                var key = _a[0], value = _a[1];
                if (!value) {
                    return null;
                }
                return (React__default.createElement("tr", { key: "bdn-properties-table-" + index },
                    React__default.createElement("td", null, PROPERTIES_LABELS[key] || key),
                    React__default.createElement("td", { className: "no-padding" },
                        React__default.createElement("input", { type: "number", value: key === 'density' || key === 'methaneNumber'
                                ? parseBDNNumberValue(values === null || values === void 0 ? void 0 : values[key], '')
                                : parseBDNNumberValue(showQuantityValue(values === null || values === void 0 ? void 0 : values[key]), ''), step: "0.01", disabled: props.readOnly, placeholder: index === 0 ? 'Please fill in the LNG properties here' : '', onChange: function (e) {
                                if (key === 'density' || key === 'methaneNumber') {
                                    onChangeValue(key, e.target.value);
                                }
                                else {
                                    fillFormNumberValue(e.target.value, key);
                                }
                            } })),
                    React__default.createElement("td", null, getPropertiesCompoundUnit(key, values === null || values === void 0 ? void 0 : values.energyUnit))));
            }))),
        !props.readOnly && !props.autoSave && (React__default.createElement(Button, { preventDoubleClick: true, onClick: handleSubmit, disabled: !isDifferentFromInitial, primary: true }, "Save LNG properties"))));
    function fillFormNumberValue(value, fieldName) {
        var parsedInput = parseFloat(value);
        var valueToConvert = convertSelectedEnergyUnitToMJ(parsedInput, (values === null || values === void 0 ? void 0 : values.energyUnit) || EnergyUnit.MJ);
        onChangeValue(fieldName, valueToConvert);
    }
    function showQuantityValue(value) {
        var parsedInput = parseFloat(value);
        if (isNaN(parsedInput)) {
            return '';
        }
        else {
            return roundDisplayNumber(convertMJToSelectedEnergyUnit(value, (values === null || values === void 0 ? void 0 : values.energyUnit) || EnergyUnit.MJ));
        }
    }
    function roundDisplayNumber(num) {
        if (num) {
            return Math.round(num * 1000) / 1000;
        }
        else {
            return '';
        }
    }
    function convertMJToSelectedEnergyUnit(mj, selectedUnit) {
        switch (selectedUnit) {
            case EnergyUnit.KWH:
                return (mj / MJ_FACTOR) * 1000;
            case EnergyUnit.MMBTU:
                return mj / MMBTU_FACTOR / MJ_FACTOR;
            case EnergyUnit.THERM:
                return mj / THERM_FACTOR / MJ_FACTOR;
            case EnergyUnit.MJ:
                return mj;
        }
    }
    function convertSelectedEnergyUnitToMJ(amount, selectedUnit) {
        switch (selectedUnit) {
            case EnergyUnit.KWH:
                return (amount * MJ_FACTOR) / 1000;
            case EnergyUnit.MMBTU:
                return amount * MMBTU_FACTOR * MJ_FACTOR;
            case EnergyUnit.THERM:
                return amount * THERM_FACTOR * MJ_FACTOR;
            case EnergyUnit.MJ:
                return amount;
        }
    }
};

var NotificationMessage = function (props) {
    return (React__default.createElement("div", { className: "notification-message " + (props.className || '') + " " + props.type.toLowerCase() + "-message" },
        showNotificationMessageIcon(props.type),
        props.children));
    function showNotificationMessageIcon(type) {
        switch (type) {
            case 'ERROR':
                return React__default.createElement(FontAwesomeIcon, { icon: faExclamationCircle });
            case 'WARNING':
                return React__default.createElement(FontAwesomeIcon, { icon: faExclamationTriangle });
            case 'SUCCESS':
                return React__default.createElement(FontAwesomeIcon, { icon: faCheckCircle });
        }
    }
};

var CompositionCalculationForm = function (props) {
    var _a = useState(), calculationError = _a[0], setCalculationError = _a[1];
    return (React__default.createElement("div", null,
        React__default.createElement("h4", null, "Instructions"),
        React__default.createElement("p", null, "Please make sure you have provided the following:"),
        React__default.createElement("ul", null,
            React__default.createElement("li", null, "All composition fields are filled in"),
            React__default.createElement("li", null, "The sum of the composition should be near 100%"),
            React__default.createElement("li", null, "The arrival LNG temperature ( CTMS ) has been provided"),
            React__default.createElement("li", null, "The Arrival LNG temperature is between -183.15\u00B0C and -143.15\u00B0C")),
        calculationError && (React__default.createElement(NotificationMessage, { type: 'ERROR' }, calculationError)),
        React__default.createElement(ButtonGroup, null,
            React__default.createElement(Button, { primary: true, preventDoubleClick: true, onClick: initiateCalculation }, "Calculate")),
        typeof props.warning === 'string' && (React__default.createElement("div", { className: "warning" },
            React__default.createElement("b", null, "Warning"),
            ": ",
            props.warning))));
    function initiateCalculation() {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, props.calculateComposition(props.bunkerAsset._id)];
                    case 1:
                        _a.sent();
                        props.closeDialog();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        setCalculationError(error_1.message);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
};

function calculateCombinedValue(values) {
    return STANDARD_LNG_COMPOSITION_COMPOUNDS.reduce(function (v, compound) {
        if (values) {
            var foundValue = values[compound];
            if (typeof foundValue === 'number') {
                return v + foundValue;
            }
            if (typeof foundValue === 'string') {
                if (!isNaN(foundValue)) {
                    // when a item is changed the function turn is
                    return v + Number(foundValue);
                }
            }
        }
        return v;
    }, 0);
}

var BSNStepStatus;
(function (BSNStepStatus) {
    BSNStepStatus["COMPLETED"] = "COMPLETED";
    BSNStepStatus["IN_COMPLETE"] = "INCOMPLETE";
    BSNStepStatus["ERROR"] = "ERROR";
    BSNStepStatus["WARNING"] = "WARNING";
    BSNStepStatus["UNKNOWN"] = "UNKNOWN";
})(BSNStepStatus || (BSNStepStatus = {}));
var generateStatusBasedOnProblems = function (status, problems) {
    var _a, _b;
    if (problems) {
        if ((_a = Object.values(problems)) === null || _a === void 0 ? void 0 : _a.some(function (p) { return (p === null || p === void 0 ? void 0 : p.problemType) === 'ERROR'; })) {
            return BSNStepStatus.ERROR;
        }
        if ((_b = Object.values(problems)) === null || _b === void 0 ? void 0 : _b.some(function (p) { return (p === null || p === void 0 ? void 0 : p.problemType) === 'WARNING'; })) {
            return BSNStepStatus.WARNING;
        }
    }
    return status || BSNStepStatus.UNKNOWN;
};
/**
 * A helper function to help with backward compatibility for the old status. (just a boolean if the status is completed)
 * @param completed boolean
 * @returns BSNStepStatus enum
 */
function generatePartStatus(completed) {
    if (completed)
        return BSNStepStatus.COMPLETED;
    return BSNStepStatus.UNKNOWN;
}
/**
 * A function to validate the input fields in the CTMSData
 * @param ctms CTMSData
 * @returns InputFieldProblem<CTMSData>[]
 */
var validateCTMSForm = function (ctms, configuration) {
    var problems = {};
    if (configuration === null || configuration === void 0 ? void 0 : configuration.temperatureBefore) {
        if (!ctms.temperatureBefore) {
            problems.temperatureBefore = {
                problemType: 'ERROR',
                message: "Field can not be empty"
            };
        }
        else if (Number(ctms.temperatureBefore) > -143.15 || Number(ctms.temperatureBefore) < -183.15)
            problems.temperatureBefore = {
                problemType: 'ERROR',
                message: "'" + CTMS_LABELS.temperatureBefore + "' must be between -183.15\u00B0C & -143.15\u00B0C"
            };
    }
    return problems;
};
var validateLNGCompositionForm = function (data, calculationEnabled) {
    var problems = {};
    if (!calculationEnabled)
        return problems;
    var calculatedValue = calculateCombinedValue(data);
    if (calculatedValue) {
        var calculatedValueRounded = round(calculatedValue, 3);
        if (calculatedValue > 110 || calculatedValue < 90) {
            problems.globalError = {
                problemType: 'ERROR',
                message: "The sum of LNG composition must be above 90%, below 110% and close to 100%. It is now " + calculatedValueRounded
            };
        }
    }
    return problems;
};
var warningsLNGComposition = function (data) {
    var problems = {};
    var calculatedValue = calculateCombinedValue(data);
    if (calculatedValue &&
        calculatedValue < 110 &&
        calculatedValue > 90 &&
        round(calculatedValue, 3) !== 100) {
        problems.globalError = {
            problemType: 'WARNING',
            message: "The sum of the composition should be near 100%, currently it is " + round(calculatedValue, 3) + "%"
        };
    }
    return problems;
};
var validateEBDN = function (data, hidePropertiesCalculation) {
    return {
        ctmsData: validateCTMSForm(data.ctmsData, data.configuration.ctmsDataFields),
        lngComposition: __assign(__assign({}, validateLNGCompositionForm(data.lngComposition, !hidePropertiesCalculation)), warningsLNGComposition(data.lngComposition))
    };
};
var findFirstErrorKey = function (data) {
    return Object.keys(data).find(function (key) { return !isValidOBJ(data[key]); });
};
var isValidNestedOBJ = function (data) {
    return !Object.values(data).some(function (problems) { return !isValidOBJ(problems); });
};
var isValidOBJ = function (data) {
    if (!data)
        return true;
    return !Object.values(data).some(function (problems) { return (problems === null || problems === void 0 ? void 0 : problems.problemType) === 'ERROR'; });
};
var objHasValues = function (data, ignoreKeys) {
    if (!data)
        return false;
    return Object.keys(data).some(function (k) { return (data[k] || data[k] === 0 || data[k] === '') && !(ignoreKeys === null || ignoreKeys === void 0 ? void 0 : ignoreKeys.includes(k)); });
};
/**
 * Function to wrap around a validation function like `validateCTMSForm`, will call the function and also return the result to a callback specified
 * @param data instance of T
 * @param validate function to validate form of type T
 * @param callback a callback in to inform a parent class, or other state of the warnings generated by the validate function
 * @returns result of validate function or a empty array
 */
var hookValidateForm = function (data, configuration, validate, warnings, callback) {
    var problems = validate(data, configuration) || {};
    var warning = (warnings && warnings(data)) || {};
    callback(__assign(__assign({}, problems), warning));
    return problems;
};
var constructProblems = function (original, field, InputFieldProblem) {
    var originalObj = original;
    originalObj[field] = InputFieldProblem;
    return __assign({}, originalObj);
};
var generateEbdnUnits = function (eBDN) {
    var KPA = 'kilopascal (a)';
    var CELCIUS = '°C';
    var MOL_PERCENT = 'mol%';
    var METRIC_TONS = 'Metric Tons';
    var CUBIC_METERS = 'Cubic Meters';
    var KG = 'kg';
    var m3 = 'm3';
    var quantityDeliveredUnit = eBDN.quantity.energyUnit;
    var LngPropertiesUnit = eBDN.lngProperties.energyUnit;
    return {
        _id: '',
        ctmsData: {
            pressureAfter: KPA,
            pressureBefore: KPA,
            vaporTemperature: CELCIUS,
            temperatureBefore: CELCIUS
        },
        pdf: undefined,
        quantity: {
            gcvVaporDisplaced: quantityDeliveredUnit,
            ncvVaporDisplaced: quantityDeliveredUnit,
            gcvGasConsumed: quantityDeliveredUnit,
            ncvGasConsumed: quantityDeliveredUnit,
            gcvGrossEnergy: quantityDeliveredUnit,
            gcvNetEnergy: quantityDeliveredUnit,
            mass: METRIC_TONS,
            ncvGrossEnergy: quantityDeliveredUnit,
            ncvNetEnergy: quantityDeliveredUnit,
            volume: CUBIC_METERS,
            energyUnit: quantityDeliveredUnit,
            altFuelPercentage: quantityDeliveredUnit,
            altFuelType: quantityDeliveredUnit
        },
        spreadsheet: undefined,
        details: {
            meteringReferenceTemperature: CELCIUS,
            combustionReferenceTemperature: CELCIUS,
            totalQuantityHydrogenKg: KG
        },
        lngComposition: {
            methane: MOL_PERCENT,
            ethane: MOL_PERCENT,
            propane: MOL_PERCENT,
            isoButane: MOL_PERCENT,
            nButane: MOL_PERCENT,
            isoPentane: MOL_PERCENT,
            neoPentane: MOL_PERCENT,
            nPentane: MOL_PERCENT,
            nHexane: MOL_PERCENT,
            nitrogen: MOL_PERCENT,
            sulphur: "mg/Nm\u00B3",
            blended: undefined
        },
        lngProperties: {
            methaneNumber: '-',
            grossHeatingMass: LngPropertiesUnit + "/" + KG,
            netHeatingMass: LngPropertiesUnit + "/" + KG,
            grossHeatingVol: LngPropertiesUnit + "/" + m3,
            netHeatingVol: LngPropertiesUnit + "/" + m3,
            grossWobbeIdx: LngPropertiesUnit + "/" + KG,
            netWobbeIdx: LngPropertiesUnit + "/" + KG,
            density: KG + "/" + m3,
            energyUnit: undefined,
            methaneNumberMethod: undefined
        },
        timestamps: undefined,
        flowType: undefined,
        configuration: undefined,
        externalSettings: {
            external: undefined,
            source: undefined,
            recalculatedFieldsKeys: undefined
        }
    };
};

var CompositionTable = function (props) {
    var _a;
    var _b = useState(false), show = _b[0], setShow = _b[1];
    var _c = useForm({
        initialValues: props.values,
        onValidSubmit: props.update,
        validate: function (data) {
            return hookValidateForm(data, undefined, function (data) { return validateLNGCompositionForm(data, props.fieldsMandatory); }, warningsLNGComposition, props.setProblems);
        }
    }), handleSubmit = _c.handleSubmit, values = _c.values, onChangeValue = _c.onChangeValue, isDifferentFromInitial = _c.isDifferentFromInitial, errors = _c.errors;
    var problem = __assign(__assign({}, errors), props.problems);
    useFuncOnStopChanging(values, props.values, handleSubmit, true, 1500, props.autoSave || false);
    function autoPopulate(data) {
        var options = new Set(__spreadArrays(Object.keys(data.composition || {}), Object.keys(values || {})));
        options.forEach(function (key) {
            var _a;
            onChangeValue(key, ((_a = data.composition) === null || _a === void 0 ? void 0 : _a[key]) || null);
        });
    }
    return (React__default.createElement("div", { className: "bdn-step" },
        props.integrationData && (React__default.createElement(FillFromPredefined, { callback: autoPopulate, data: props.integrationData, displayRule: [
                { key: 'description', fallback: props.assetName || ((_a = props.bunkerAsset) === null || _a === void 0 ? void 0 : _a.name) },
                { key: 'created', render: formatDateTime }
            ], fieldname: 'PropertiesTable', message: "Predefined LNG composition" })),
        !props.readOnly &&
            props.showCalculationOption &&
            props.bunkerAsset &&
            props.calculateComposition && (React__default.createElement(CalculateBDNStep, { type: 'COMPOSITION', calculate: function () { return setShow(true); } })),
        show && (React__default.createElement(CompositionCalculationForm
        // @ts-ignore
        , { 
            // @ts-ignore
            bunkerAsset: props.bunkerAsset, 
            // @ts-ignore
            calculateComposition: props.calculateComposition, closeDialog: function () { return setShow(false); } })),
        props.integrationData && React__default.createElement(SelectingPredefinedWarning, null),
        React__default.createElement("table", { cellSpacing: "0", cellPadding: "0" },
            !props.hideTableHeaders && (React__default.createElement("thead", { className: "table-header" },
                React__default.createElement("tr", null,
                    React__default.createElement("td", { colSpan: 4 }, "LNG Composition")))),
            React__default.createElement("tbody", null,
                React__default.createElement("tr", null,
                    React__default.createElement("td", { className: "table-sub-header", colSpan: 4 }, "Composition of LNG to be Delivered as Determined by Weighted Average Calculation")),
                STANDARD_LNG_COMPOSITION_COMPOUNDS.map(function (compound, index) {
                    return (React__default.createElement(LNGQualityRow, { key: compound + "-" + index, placeholder: index === 0 ? 'please fill the composition values in here' : undefined, compound: compound, value: values ? values[compound] : '', readOnly: props.readOnly, onChange: function (value) {
                            onChangeValue("" + compound, value);
                        }, problem: problem === null || problem === void 0 ? void 0 : problem[compound] }));
                }),
                React__default.createElement("tr", null,
                    React__default.createElement("td", { colSpan: 4 }, "*Neo-pentane content included in molar percent of iso-Pentane.")),
                React__default.createElement(LNGQualityRow, { compound: 'sulphur', value: values === null || values === void 0 ? void 0 : values.sulphur, readOnly: props.readOnly, onChange: function (value) {
                        onChangeValue('sulphur', value);
                    }, problem: problem === null || problem === void 0 ? void 0 : problem.sulphur, customUnit: "mg/Nm\u00B3" }))),
        !props.readOnly && !props.autoSave && (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(Button, { preventDoubleClick: true, disabled: !isDifferentFromInitial, onClick: handleSubmit, primary: true }, "Save LNG composition")))));
};

var BDNStepHeader = function (props) {
    var status = props.recalculateStatusOnProblems === false
        ? props.status
        : generateStatusBasedOnProblems(props.status, props.problems);
    return (React__default.createElement("div", { className: "bdn-step-header " + (props.stepInactive ? 'inactive-step' : '') },
        React__default.createElement("div", { className: "step-header-title" },
            props.stepNumber !== undefined && (React__default.createElement("span", { className: "step-number" },
                React__default.createElement(Icon, { key: "bdn-step-" + props.stepNumber + "-" + (props.status === BSNStepStatus.COMPLETED ? 'toggled' : 'untoggled'), className: "step-" + props.stepNumber + " " + (status || BSNStepStatus.UNKNOWN)
                        .toString()
                        .toLowerCase() + " bdn-step" },
                    React__default.createElement(FontAwesomeIcon, { icon: faCircle$1 })),
                "Step ",
                props.stepNumber)),
            React__default.createElement("h3", { className: "step-title" }, props.stepTitle)),
        React__default.createElement("div", { className: "step-header-problems" }, renderProblemByImortance(props.problems))));
};
function renderProblemByImortance(problems) {
    if (!problems)
        return null;
    var error = Object.values(problems).find(function (item) { return (item === null || item === void 0 ? void 0 : item.problemType) === 'ERROR'; });
    if (error)
        return (React__default.createElement("span", { id: "ebdn-error", className: error.problemType.toLocaleLowerCase() + " step-problem" }, error.message));
    var warning = Object.values(problems).find(function (item) { return (item === null || item === void 0 ? void 0 : item.problemType) === 'WARNING'; });
    if (warning)
        return (React__default.createElement("span", { className: warning.problemType.toLocaleLowerCase() + " step-problem" }, warning.message));
    return null;
}

var BunkerAssetLNGContents = function (props) {
    var userPermissions = useContext(UserPermissionContext).userPermissions;
    var allowedToEditLNGSpec = doesUserHavePermission(userPermissions, 'BUNKERSHIP_EDIT_LNG_SPEC') ||
        doesUserHavePermission(userPermissions, 'PIPELINE_EDIT_LNG_SPEC');
    var _a = useState({}), problems = _a[0], setProblems = _a[1];
    return (React__default.createElement("div", { className: "ebdn-wrapper chorus-component" },
        instanceOfBunkership(props.bunkerAsset) && (React__default.createElement("div", { className: "bunkership-bdn-block" },
            React__default.createElement(Collapse$1, { collapseHeaderContent: function () {
                    return React__default.createElement(BDNStepHeader, { stepTitle: "LNG Heel Quality", stepInactive: false });
                } },
                React__default.createElement(LNGQualityTable, { qualityType: 'heelQuality', qualityValues: props.bunkerAsset.heelQuality, updateLNGQuality: function (values) {
                        if (props.updateLNGQuality)
                            props.updateLNGQuality(props.bunkerAsset._id, values, 'heel');
                    }, hideTableHeaders: true, readOnly: !allowedToEditLNGSpec })))),
        instanceOfBunkership(props.bunkerAsset) && (React__default.createElement("div", { className: "bunkership-bdn-block" },
            React__default.createElement(Collapse$1, { collapseHeaderContent: function () {
                    return React__default.createElement(BDNStepHeader, { stepTitle: "LNG Loaded Quality", stepInactive: false });
                } },
                React__default.createElement(LNGQualityTable, { qualityType: 'loadedQuality', qualityValues: props.bunkerAsset.loadedQuality, updateLNGQuality: function (values) {
                        if (props.updateLNGQuality)
                            props.updateLNGQuality(props.bunkerAsset._id, values, 'loaded');
                    }, readOnly: !allowedToEditLNGSpec, hideTableHeaders: true })))),
        React__default.createElement("div", { className: "bunkership-bdn-block" },
            React__default.createElement(Collapse$1, { collapseHeaderContent: function () {
                    return (React__default.createElement(BDNStepHeader, { stepTitle: "LNG Composition", stepInactive: false, problems: problems === null || problems === void 0 ? void 0 : problems.lngComposition }));
                } },
                React__default.createElement(CompositionTable, { bunkerAsset: props.bunkerAsset, values: props.bunkerAsset.lngComposition, readOnly: !allowedToEditLNGSpec, showCalculationOption: instanceOfBunkership(props.bunkerAsset) && props.calculationsEnabled, calculateComposition: props.calculateComposition, update: function (composition) {
                        props.updateLNGCompositionData(props.bunkerAsset._id, composition);
                    }, hideTableHeaders: true, setProblems: function (v) {
                        return setProblems(function (oldValue) { return constructProblems(oldValue, 'lngComposition', v); });
                    }, problems: problems.lngComposition, integrationData: [], fieldsMandatory: false }))),
        React__default.createElement("div", { className: "bunkership-bdn-block" },
            React__default.createElement(Collapse$1, { collapseHeaderContent: function () {
                    return (React__default.createElement(BDNStepHeader, { stepTitle: "LNG Properties", stepInactive: false, problems: problems === null || problems === void 0 ? void 0 : problems.lngProperties }));
                } },
                React__default.createElement(PropertiesTable, { values: props.bunkerAsset.lngProperties, readOnly: !allowedToEditLNGSpec, update: function (properties) {
                        props.updateLNGPropertiesData(props.bunkerAsset._id, properties);
                    }, showCalculationOption: false, configuration: {
                        density: true,
                        grossHeatingMass: true,
                        grossHeatingVol: true,
                        grossWobbeIdx: true,
                        methaneNumber: true,
                        netHeatingMass: true,
                        netHeatingVol: true,
                        netWobbeIdx: true
                    }, hideTableHeaders: true, setProblems: function () { }, problems: undefined, integrationData: [] })))));
};

var BunkerShipDeleteFail = function (props) {
    var _a, _b;
    return (React__default.createElement(Dialog, { onCloseDialog: props.clearError, showDialog: ((_a = props.eventsLinkedToShip) === null || _a === void 0 ? void 0 : _a.length) ? true : false, type: "small", title: "Unable to delete Bunkership" },
        React__default.createElement("p", null, props === null || props === void 0 ? void 0 : props.errorMessage),
        React__default.createElement("ul", null, (_b = props.eventsLinkedToShip) === null || _b === void 0 ? void 0 : _b.map(function (event) {
            var eventType = formatEventTypeName(event._type);
            return (React__default.createElement("li", { key: event._id },
                eventType ? eventType + ' event' : 'Nomination',
                " on ",
                formatDate(event.eta || event.bst)));
        }))));
};
var BunkerShipDeleteFail$1 = React__default.memo(BunkerShipDeleteFail);
function formatEventTypeName(eventType) {
    if (eventType && eventType !== 'nomination' && eventType !== 'generic') {
        return capitalize(eventType);
    }
    return null;
}

var DEFAULT_FORM_VALUES = {
    _id: '',
    imoNumber: '',
    name: '',
    mmsi: '',
    active: true,
    planningHorizon: null,
    companyId: null,
    charterable: false,
    charterers: []
};
var BunkerShipForm = function (props) {
    // Set initial bunker ship when editing a bunker ship
    var edit = props.selectedBunkerShipId ? true : false;
    var _a = useState(), initialBunkerShipValues = _a[0], setInitialBunkerShipValues = _a[1];
    useEffect(function () {
        var _a;
        var matchingBunkerShip = (_a = props.bunkerShips) === null || _a === void 0 ? void 0 : _a.find(function (ship) {
            return ship._id === props.selectedBunkerShipId;
        });
        if (matchingBunkerShip) {
            setInitialBunkerShipValues(matchingBunkerShip);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.bunkerShips, props.selectedBunkerShipId]);
    var _b = useForm({
        initialValues: props.selectedBunkerShipId ? initialBunkerShipValues : DEFAULT_FORM_VALUES,
        validate: validate,
        onValidSubmit: submitChanges
    }), handleSubmit = _b.handleSubmit, values = _b.values, errors = _b.errors, onChange = _b.onChange, onChangeValue = _b.onChangeValue;
    var vendorCompaniesSorted = (props.vendorCompanies || []).sort(function (a, b) {
        return sortAlphabetically(a, b, 'name');
    });
    return (React__default.createElement("div", { className: "bunker-ship-form " + (props.className || '') },
        React__default.createElement(BunkerShipDeleteFail$1, { errorMessage: props.errorMessage, eventsLinkedToShip: props.eventsLinkedToShip, clearError: props.clearError }),
        React__default.createElement("div", { className: "page-title" },
            props.goBack && (React__default.createElement(Button$1, { preventDoubleClick: true, primary: true, outline: true, iconButton: true, className: "back-button", onClick: props.goBack },
                React__default.createElement(FontAwesomeIcon, { icon: faArrowLeft }))),
            edit ? React__default.createElement("h1", null,
                "Edit bunker ship ",
                (values === null || values === void 0 ? void 0 : values.name) || null) : React__default.createElement("h1", null, "New bunker ship")),
        React__default.createElement(Tabs, null,
            React__default.createElement(TabList, null,
                React__default.createElement(Tab, null, "Bunkership"),
                initialBunkerShipValues && props.showLNGTab !== false && React__default.createElement(Tab, null, "LNG Values")),
            React__default.createElement(TabPanel, null,
                React__default.createElement("form", { className: classNames('prompt-form') },
                    React__default.createElement("div", { className: "column" },
                        React__default.createElement("div", { className: "row" },
                            React__default.createElement(FormElement, null,
                                React__default.createElement(FormLabel, { fieldName: "name" }, "Name"),
                                React__default.createElement(TextField, { fieldName: "name", value: values ? values.name : '', onChange: onChange }),
                                React__default.createElement(FormErrorMessage, { errorMessage: errors === null || errors === void 0 ? void 0 : errors.name })),
                            props.showCompanySelect === true && (React__default.createElement(FormElement, null,
                                React__default.createElement(FormLabel, { fieldName: "companyId" }, "Company"),
                                React__default.createElement(SelectionBox, { fieldName: 'companyId', placeholder: 'Select Company...', value: (values === null || values === void 0 ? void 0 : values.companyId) || '', options: vendorCompaniesSorted.map(function (company) { return ({
                                        value: company._id,
                                        text: company.name
                                    }); }), sortOptions: true, valueKey: "value", displayKey: "text", renderFieldValue: function (selectedItem) {
                                        return "" + selectedItem.text;
                                    }, onChangeValue: function (selectedItem) {
                                        onChangeValue('companyId', selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value);
                                    }, renderOption: function (option) {
                                        return (React__default.createElement("div", null,
                                            React__default.createElement("span", null, option.text)));
                                    } }),
                                React__default.createElement(FormErrorMessage, null, errors === null || errors === void 0 ? void 0 : errors.companyId))),
                            React__default.createElement(FormElement, null,
                                React__default.createElement(FormLabel, { fieldName: "imoNumber" }, "IMO"),
                                React__default.createElement(TextField, { fieldName: "imoNumber", value: values && values.imoNumber ? values.imoNumber : '', onChange: onChange }),
                                React__default.createElement(FormErrorMessage, { errorMessage: errors === null || errors === void 0 ? void 0 : errors.imoNumber })),
                            React__default.createElement(FormElement, null,
                                React__default.createElement(FormLabel, { fieldName: "mmsi" }, "MMSI"),
                                React__default.createElement(TextField, { fieldName: "mmsi", value: values && values.mmsi ? values.mmsi : '', onChange: onChange }),
                                React__default.createElement(FormErrorMessage, { errorMessage: errors === null || errors === void 0 ? void 0 : errors.mmsi })),
                            React__default.createElement(FormElement, null,
                                React__default.createElement(FormLabel, { fieldName: "planningHorizon" }, "Visible planning horizon (days, blank for full visibility)"),
                                React__default.createElement(FormFieldWrapper, null,
                                    React__default.createElement("input", { value: values && values.planningHorizon ? values.planningHorizon : '', type: "number", name: 'planningHorizon', onChange: onChange })),
                                React__default.createElement(FormErrorMessage, { errorMessage: errors === null || errors === void 0 ? void 0 : errors.planningHorizon })),
                            React__default.createElement(ButtonGroup, null,
                                React__default.createElement(Button$1, { preventDoubleClick: true, primary: true, onClick: function () {
                                        handleSubmit();
                                    } }, "Submit"),
                                edit && (React__default.createElement(Button$1, { preventDoubleClick: true, danger: true, outline: true, onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            if (initialBunkerShipValues) {
                                                props.handleDeleteBunkerShip(initialBunkerShipValues._id);
                                            }
                                            return [2 /*return*/];
                                        });
                                    }); } }, "Remove bunkership"))))))),
            initialBunkerShipValues && props.showLNGTab !== false && (React__default.createElement(TabPanel, null,
                React__default.createElement(BunkerAssetLNGContents, { bunkerAsset: initialBunkerShipValues, updateLNGCompositionData: props.updateLNGCompositionData, updateLNGPropertiesData: props.updateLNGPropertiesData, updateLNGQuality: props.updateLNGQuality, calculateComposition: props.calculateComposition, calculationsEnabled: true }))))));
    function submitChanges(formValues) {
        var _a;
        // Make sure all entries have a companyId, corporate admin has to fill it in via the form
        var companyId = props.showCompanySelect === true
            ? formValues.companyId || vendorCompaniesSorted[0]._id
            : props.userCompanyId;
        if (edit && initialBunkerShipValues) {
            var updatedShip = Object.assign(cloneDeep(initialBunkerShipValues), __assign({}, formValues), { companyId: companyId });
            props.handleUpdateBunkerShip(updatedShip);
        }
        else {
            var newShip = Object.assign({}, formValues, {
                _id: '',
                heelQuality: null,
                loadedQuality: null,
                lngProperties: null,
                lngComposition: null,
                deleted: false,
                order: ((_a = props.bunkerShips) === null || _a === void 0 ? void 0 : _a.length) || 0,
                companyId: companyId,
                charterable: false,
                charterers: []
            });
            props.handleCreateBunkerShip(newShip);
        }
    }
};
function sortAlphabetically(a, b, propertyToSort) {
    if (a[propertyToSort] < b[propertyToSort]) {
        return -1;
    }
    if (a[propertyToSort] > b[propertyToSort]) {
        return 1;
    }
    return 0;
}
function validate(values) {
    var errors = {};
    if (!values.name) {
        errors.name = 'Required';
    }
    if (values.planningHorizon && values.planningHorizon < 0) {
        errors.planningHorizon = "Planning horizon can't be a negative number";
    }
    return errors;
}

var Comment = function (props) {
    var commentDateTime = DateTime.fromISO(props.comment.created);
    return (createElement("div", { className: "comment-item" },
        createElement("h3", { className: "comment-author" }, props.comment.author.name),
        createElement("span", { className: "comment-timestamp" },
            commentDateTime.toFormat('dd MMM yyyy HH:mm'),
            " - ",
            commentDateTime.toRelative()),
        props.comment.text.split('\n').map(function (text, idx) { return (createElement("p", { key: idx, className: "comment-text" }, text)); })));
};

var CommentList = function (props) {
    return (createElement("div", { className: "comment-conversation" },
        props.comments.map(function (comment, index) {
            return createElement(Comment, { key: 'comment' + index, comment: comment });
        }),
        props.comments.length === 0 ? (createElement("div", { className: "no-comments-message" }, "No comments have been made yet. You can start a conversation here.")) : null));
};

var CreateCommentForm = /** @class */ (function (_super) {
    __extends(CreateCommentForm, _super);
    function CreateCommentForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            commentValue: '',
        };
        _this.canSendComment = function () {
            return !isEmpty$1(_this.state.commentValue) && _this.props.canCreateComments;
        };
        _this.handleSend = function () {
            if (!_this.canSendComment()) {
                return;
            }
            _this.props.postNewComment(_this.state.commentValue);
            _this.setState({ commentValue: '' });
        };
        _this.handleCommentChange = function (event) {
            _this.setState({ commentValue: event.target.value });
        };
        return _this;
    }
    CreateCommentForm.prototype.render = function () {
        return (createElement("div", { className: "comment-create-form" },
            createElement("textarea", { className: "comment-textarea", value: this.state.commentValue || '', onChange: this.handleCommentChange, placeholder: 'Comment Text', disabled: !this.props.canCreateComments }),
            createElement(Button, { preventDoubleClick: true, primary: true, className: "comment-submit-button", disabled: !this.canSendComment(), onClick: this.handleSend }, "Send")));
    };
    return CreateCommentForm;
}(Component));

var CommentBox = /** @class */ (function (_super) {
    __extends(CommentBox, _super);
    function CommentBox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            comments: [],
        };
        _this.getAllComments = function (objectId) { return __awaiter(_this, void 0, void 0, function () {
            var comments, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, getComments(this.props.authenticationService, objectId)];
                    case 1:
                        comments = _a.sent();
                        this.setState({
                            comments: comments,
                        });
                        if (this.props.updateCommentCount) {
                            this.props.updateCommentCount(comments.length);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        handleFetchError(error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.postNewComment = function (comment) { return __awaiter(_this, void 0, void 0, function () {
            var objectId, newComments, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        objectId = this.props.objectId;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        if (!this.props.userProfile) return [3 /*break*/, 3];
                        return [4 /*yield*/, postComment(this.props.authenticationService, objectId, comment, this.props.userProfile)];
                    case 2:
                        newComments = _a.sent();
                        if (this.props.updateCommentCount) {
                            this.props.updateCommentCount(newComments.length);
                        }
                        _a.label = 3;
                    case 3:
                        this.getAllComments(objectId);
                        return [3 /*break*/, 5];
                    case 4:
                        error_2 = _a.sent();
                        handleFetchError(error_2);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    CommentBox.prototype.componentDidMount = function () {
        this.getAllComments(this.props.objectId);
    };
    CommentBox.prototype.render = function () {
        return (createElement("div", { className: "comments-section " + (this.props.className || '') },
            createElement("div", { className: "row" },
                createElement("div", { className: "column" },
                    createElement(CommentList, { comments: this.state.comments }),
                    createElement(CreateCommentForm, { canCreateComments: !this.props.readOnly && (this.props.userProfile ? true : false), postNewComment: this.postNewComment })))));
    };
    return CommentBox;
}(Component));

/**
 * Basic service hook for gathering information, can be used in more complex hooks to avoid rewriting this part.
 * Since most of our projects don't allow for AbortController's as a addition parameter this version is written with a variable to keep the state.
 * @returns function to cancel the request handling for when the component dismounts.
 */
var useBasicAPIDataService = function (APICall, defaultValue, autoLoad, customErrorHandler, thenCallback) {
    if (autoLoad === void 0) { autoLoad = true; }
    var _a = baseAPIDataHook(refresh, defaultValue, autoLoad), setLoading = _a.setLoading, setData = _a.setData, data = _a.data, loading = _a.loading;
    /**
     * refresh with cancelation in case a component dismounts before the request is done.
     * Since most of our projects don't allow for AbortController's as a addition parameter it's done like this.
     * @returns function to cancel the request handling for when the component dismounts.
     */
    function refresh() {
        setLoading(true);
        var cancelled = false;
        APICall()
            .then(function (d) {
            if (!cancelled) {
                setData(d);
                thenCallback && thenCallback(d);
            }
        })
            .catch(function (e) {
            if (!cancelled)
                customErrorHandler ? customErrorHandler(e) : handleFetchError(e);
        })
            .finally(function () {
            if (!cancelled)
                setLoading(false);
        });
        return function () {
            cancelled = true;
        };
    }
    return {
        loading: loading,
        data: data,
        setData: setData,
        refresh: refresh
    };
};
var baseAPIDataHook = function (refresh, defaultValue, autoLoad) {
    if (autoLoad === void 0) { autoLoad = true; }
    var _a = useState(true), loading = _a[0], setLoading = _a[1];
    var _b = useState(defaultValue), data = _b[0], setData = _b[1];
    useEffect(function () {
        if (autoLoad) {
            var r = refresh();
            return r;
        }
    }, []);
    return {
        loading: loading,
        setLoading: setLoading,
        data: data,
        setData: setData,
        refresh: refresh
    };
};

var useShipsService = function (companyId, authenticationService, getShipData, shipType) {
    var _a = useState([]), activeShips = _a[0], setActiveShips = _a[1];
    var _b = useBasicAPIDataService(function () { return getShipData(authenticationService, companyId, true); }, [], false, undefined, function (d) { return setActiveShips(d.filter(function (it) { return isActiveShip(it); })); }), ships = _b.data, loading = _b.loading, refresh = _b.refresh;
    useEffect(refresh, [companyId]);
    var setChartereble = function (shipId, charteble) {
        putCharterebleShip(authenticationService, shipType, shipId, charteble).finally(refresh);
    };
    var isActiveShip = function (ship) {
        if (ship.deleted)
            return false;
        if (ship.companyId !== companyId && ship.charterers && ship.charterers.length > 0) {
            var result = ship.charterers.find(function (charterer) { return charterer.companyId === companyId; });
            if (!result || !result.activeInFleet)
                return false;
        }
        return true;
    };
    return {
        ships: ships,
        activeShips: activeShips,
        loading: loading,
        setChartereble: setChartereble,
        setShipsData: refresh
    };
};
var useFleetService = function (companyId, authenticationService) {
    return useShipsService(companyId, authenticationService, getCompanyFleetList, SHIP_TYPE_REQUEST.CUSTOMERSHIP);
};
var useBunkershipService = function (companyId, authenticationService) {
    return useShipsService(companyId, authenticationService, getBunkerShips, SHIP_TYPE_REQUEST.BUNKERSHIP);
};

/**
 * Summary. This Hook allows for contextual roles, some roles. like RECEIVING_SCHEDULER_CAPTAIN are a captain but will be a CUSTOMER for his own ship.
 *
 * @param userProfile user object
 * @param promptNomination latest nomination object
 * @returns a object of UseContextualRole that contains a state array of the (new/contextual) user roles, and the setter of the state
 */
var useContextualRole = function (userProfile, promptNomination, customerShip) {
    var _a = useState(userProfile.roles || []), roles = _a[0], setRoles = _a[1];
    var _b = useState(userProfile.roles || []), originalRoles = _b[0], setOriginalRoles = _b[1];
    useEffect(function () {
        checkForRVSC(userProfile, promptNomination, customerShip);
        setOriginalRoles(userProfile.roles || []);
    }, [userProfile, promptNomination]);
    /**
     * An ROLE_RECEIVING_SCHEDULER_CAPTAIN (RVSC) is allowed to do the same as a ROLE_CUSTOMER IF the receiving ship is his
     * He is also allowed to create nominations but ONLY for his own ship
     *
     * The following if statement will check if the ROLE_RECEIVING_SCHEDULER_CAPTAIN meets those requirements and if so change the role to a ROLE_CUSTOMER
     * If for some reason he doesn't meet the requirements the user will be mapped to an normal ROLE_RECEIVING_CAPTAIN
     *
     * An additional case is added, when a RVSC's ship is chartered. There is a field on the ship object that will allow the captain to create nominations
     * on behalf of the chartering company.
     */
    var checkForRVSC = function (user, nomination, shipWithId) {
        var _a, _b, _c, _d;
        // The user or roles can be undefined if the hook is processed before the user.
        if (typeof (user === null || user === void 0 ? void 0 : user.roles) === 'undefined')
            return;
        var userRoles = user.roles;
        if (user.roles.includes('ROLE_RECEIVING_SCHEDULER_CAPTAIN')) {
            var captainIsConditionalCustomer_1 = user.receivingShipId !== null &&
                (typeof nomination === 'undefined' ||
                    (nomination.receivingShipId === user.receivingShipId &&
                        user.companyId === nomination.companyId));
            var captainIsCharteredCustomer_1 = user.receivingShipId !== null &&
                typeof nomination !== 'undefined' &&
                nomination.receivingShipId === user.receivingShipId &&
                (shipWithId === null || shipWithId === void 0 ? void 0 : shipWithId._id) === user.receivingShipId &&
                ((_b = (_a = shipWithId.charterers) === null || _a === void 0 ? void 0 : _a.find(function (it) { return it.companyId === nomination.companyId; })) === null || _b === void 0 ? void 0 : _b.allowShipOwnerToCreateNominations) === true &&
                ((_d = (_c = shipWithId.charterers) === null || _c === void 0 ? void 0 : _c.find(function (it) { return it.companyId === nomination.companyId; })) === null || _d === void 0 ? void 0 : _d.activeInFleet) ===
                    true;
            userRoles = userRoles.map(function (item) {
                return mapRVSCToContextualRole(item, captainIsConditionalCustomer_1, captainIsCharteredCustomer_1);
            });
        }
        setRoles(userRoles);
    };
    var mapRVSCToContextualRole = function (role, captainIsConditionalCustomer, captainIsCharteredCustomer) {
        if (role === 'ROLE_RECEIVING_SCHEDULER_CAPTAIN') {
            if (captainIsConditionalCustomer || captainIsCharteredCustomer)
                return 'ROLE_CUSTOMER';
            return 'ROLE_RECEIVING_CAPTAIN';
        }
        return role;
    };
    return { roles: roles, setRoles: setRoles, originalRoles: originalRoles };
};

var PermissionsWarning = function (props) {
    return React__default.createElement("div", { className: "permission-warning " + (props.className || '') }, props.children);
};

var CounterProposalDialog = function (props) {
    return (React__default.createElement(Dialog, { showDialog: props.counterProposalCandidate ? true : false, onCloseDialog: function () {
            props.clearCounterProposalCandidate();
        }, type: "small", title: "Counter Proposal Required", titleIcon: getNominationStatusIcon('PROPOSED') },
        React__default.createElement("p", null, "The changes to the event require a new proposal to be sent."),
        (props.ignoringApproveRequest === true) && React__default.createElement("p", null, "This counter proposal will not be approved."),
        React__default.createElement("p", null, "Do you wish to continue?"),
        React__default.createElement(ButtonGroup, null,
            React__default.createElement(Button, { primary: true, preventDoubleClick: true, onClick: function () {
                    if (props.counterProposalCandidate) {
                        props.amendOrCounterNegotiation('COUNTER', props.counterProposalCandidate);
                    }
                    props.clearCounterProposalCandidate();
                } }, "Send new proposal"),
            React__default.createElement(Button, { primary: true, preventDoubleClick: true, outline: true, onClick: function () {
                    props.clearCounterProposalCandidate();
                } }, "Cancel"))));
};

var DelegationHandler = function (props) {
    var nomination = props.nomination, companies = props.companies, userProfile = props.userProfile;
    var executingCompanyId = nomination.supplierId
        ? nomination.supplierId
        : nomination.vendorCompanyId;
    var _a = useState(executingCompanyId ? executingCompanyId : ''), executingPartyId = _a[0], setExecutingPartyId = _a[1];
    var _b = useState(false), delegationDialogActive = _b[0], setDelegationDialogActive = _b[1];
    var isDelegated = nomination.supplierId !== undefined &&
        nomination.supplierId !== null &&
        nomination.supplierId !== '';
    var nominationStateAllowsDelegation = !isOneOf(nomination.state, [
        'CANCELLED',
        'COMPLETED',
        'FINALISED'
    ]);
    var canDelegate = nominationStateAllowsDelegation &&
        !isDelegated &&
        userProfile.companyId === nomination.vendorCompanyId;
    if (!nomination || isDelegated) {
        return null;
    }
    return (React__default.createElement(React__default.Fragment, null,
        canDelegate && !isDelegated && (React__default.createElement(Button$1, { iconButton: true, preventDoubleClick: true, tooltipText: 'Delegate Nomination', primary: true, className: "delegate-button", onClick: function (e) {
                e.preventDefault();
                setDelegationDialogActive(true);
            } },
            React__default.createElement(Icon, null,
                React__default.createElement(FontAwesomeIcon, { icon: faShare })))),
        React__default.createElement(Dialog, { type: "small", title: 'Delegation', titleIcon: React__default.createElement(Icon, null,
                React__default.createElement(FontAwesomeIcon, { icon: faShare })), showDialog: delegationDialogActive, onCloseDialog: function () {
                setDelegationDialogActive(false);
            } },
            React__default.createElement("div", null,
                React__default.createElement("p", null, "Please select a company to which you want to delegate this nomination to."),
                React__default.createElement("div", null,
                    React__default.createElement(FormElement, null,
                        React__default.createElement(FormLabel, { fieldName: "executingCompany" }, "Executing party"),
                        React__default.createElement(SelectionBox, { dropUp: true, value: executingPartyId, fieldName: "executingCompany", placeholder: 'Select Executing Part...', onChangeValue: handleSelectDelegation, valueKey: "_id", displayKey: 'name', renderOption: function (company) {
                                return React__default.createElement("div", null, company.name);
                            }, options: companies.filter(function (x) { return x.companyType === 'SUPPLIER' || x.companyType === 'VENDOR'; }) }))),
                React__default.createElement(ButtonGroup, null,
                    React__default.createElement(Button$1, { primary: true, preventDoubleClick: true, onClick: saveDelegation }, "Delegate nomination"))))));
    function handleSelectDelegation(delegateCompany) {
        if (delegateCompany) {
            setExecutingPartyId(delegateCompany._id);
        }
    }
    function saveDelegation(event) {
        event.preventDefault();
        var nominationToDelegate = cloneDeep(nomination);
        props.delegatePromptNomination(nominationToDelegate, executingPartyId);
    }
};

function capitalizeFirstLetter(input) {
    return input.charAt(0).toUpperCase() + input.slice(1).toLowerCase();
}
function renderStatusText(statusType) {
    switch (statusType) {
        case 'COMPLETED':
            return 'Completed';
        case 'IN_PROGRESS':
            return 'In Progress';
        case 'NOT_STARTED':
            return 'Not Started';
        default:
            return 'Unknown';
    }
}
/**
 * Function to change cammelcase to sentence which can be used as a fallback.
 * examples:
 * HelloThere -> Hello there
 * someDBValue -> Some DB value
 * LetsSeeIfWeCanBreakItAtThe3theTry -> Lets see if we can break it at the 3the try
 */
var camelToSentence = function (camelCase) {
    return camelCase
        .replace(/([A-Z][a-z0-9])/g, function (match) { return " " + match.toLowerCase(); })
        .replace(/([0-9][a-z])/g, function (match) { return " " + match; })
        .replace(/([a-z0-9][A-Z])/g, function (match) { return match[0] + " " + match[1]; })
        .trim()
        .replace(/^./, function (match) { return match.toUpperCase(); });
};
/**
 * Function to change screaming snake case to sentence which can be used as a fallback.
 * examples:
 * HELLO_THERE -> Hello there
 * SOME_DB_VALUE -> Some db value
 * LETS_SEE_IF_WE_CAN_BreaK_IT_AT_THE_3the_TRY -> Lets see if we can break it at the 3the try
 */
var screamingSnakeCaseToSentence = function (screamingSnakeCase) {
    return capitalizeFirstLetter(screamingSnakeCase
        .replace(/^[_]*(.)/, function (_, c) { return c; }) // Initial char (after -/_)
        .replace(/[_]+(.)/g, function (_, c) { return ' ' + c; }) // First char after each -/_
        .toLowerCase() // lowercase everything
    );
};

var ButtonGroupWithCancel = function (props) {
    return (React__default.createElement(ButtonGroup, null,
        props.children,
        React__default.createElement(Button, { secondary: true, preventDoubleClick: true, outline: true, onClick: props.onCancel, className: "dialog-cancel" },
            "No, don't ",
            screamingSnakeCaseToSentence(props.action).toLowerCase())));
};
var ActionDialogContent = function (props) {
    var action = props.action, permissions = props.permissions, setActiveDialog = props.setActiveDialog;
    var eventDescriptionText = instanceOfINominationEnquiryEvent(props.selectedEvent)
        ? 'Enquiry'
        : 'Nomination';
    var _a = useState(), reasonForReject = _a[0], setReasonForReject = _a[1];
    var _b = useState(), selectedContract = _b[0], setSelectedContract = _b[1];
    if (action === 'ACCEPT') {
        var nominationHasPendingProposal_1 = props.selectedEvent.state === 'PENDING';
        if (instanceOfINominationEnquiryEvent(props.selectedEvent) &&
            props.selectedEvent.deliveryModes &&
            props.selectedEvent.deliveryModes.length > 1) {
            return (React__default.createElement("div", null,
                React__default.createElement("p", null, "A spot enquiry can not be approved until a single delivery mode is selected. Please select a single delivery mode before finalising the enquiry."),
                React__default.createElement(ButtonGroupWithCancel, { onCancel: function () { return props.setActiveDialog(undefined); }, action: action },
                    React__default.createElement(Button, { preventDoubleClick: true, primary: true, outline: true, onClick: function () {
                            setActiveDialog(undefined);
                        } }, "Return to enquiry"))));
        }
        else {
            return (React__default.createElement("div", null,
                React__default.createElement("p", null, "Are you sure you want to approve this " + eventDescriptionText.toLowerCase() + "?"),
                props.error && React__default.createElement("p", { className: "status error" }, props.error),
                React__default.createElement(ButtonGroupWithCancel, { onCancel: function () { return props.setActiveDialog(undefined); }, action: action }, permissions.canAccept && (React__default.createElement(Button, { primary: true, preventDoubleClick: true, onClick: function () {
                        if (instanceOfNominationTimelineItem(props.initialEvent) &&
                            nominationHasPendingProposal_1 &&
                            props.acceptPendingNomination) {
                            props.acceptPendingNomination(props.initialEvent);
                        }
                        else {
                            props.changeStateWhenValid('ACCEPTED', false);
                        }
                    } },
                    "Yes, ",
                    screamingSnakeCaseToSentence(action).toLowerCase())))));
        }
    }
    else if (action === 'REJECT') {
        return (React__default.createElement("div", null,
            React__default.createElement("p", null, "Are you sure you want to reject this " + eventDescriptionText.toLowerCase() + "?"),
            props.error && React__default.createElement("p", { className: "status error" }, props.error),
            React__default.createElement("label", null, "Reason for rejection"),
            React__default.createElement("textarea", { className: "input", onChange: function (e) {
                    setReasonForReject(e.target.value);
                } }),
            React__default.createElement(ButtonGroupWithCancel, { onCancel: function () { return props.setActiveDialog(undefined); }, action: action }, permissions.canReject && (React__default.createElement(Button, { preventDoubleClick: true, danger: true, onClick: function () {
                    props.changeStateWhenValid('REJECTED', false, reasonForReject);
                    setReasonForReject(undefined);
                } },
                "Yes, ",
                screamingSnakeCaseToSentence(action).toLowerCase())))));
    }
    else if (action === 'COMPLETE') {
        return (React__default.createElement("div", null,
            React__default.createElement("p", null, "Are you sure you want to complete this " + eventDescriptionText.toLowerCase() + "? This change can not be reverted."),
            props.error && React__default.createElement("p", { className: "status error" }, props.error),
            React__default.createElement(ButtonGroupWithCancel, { onCancel: function () { return props.setActiveDialog(undefined); }, action: action }, permissions.canComplete && (React__default.createElement(Button, { primary: true, preventDoubleClick: true, onClick: function () {
                    if (props.updateEvent && instanceOfNominationTimelineItem(props.initialEvent)) {
                        props.updateEvent('COMPLETE', props.initialEvent);
                    }
                    else {
                        console.warn('missing update function, or trying to complete a non nomination object');
                    }
                } }, "Complete " + eventDescriptionText)))));
    }
    else if (action === 'FINALISE') {
        if (instanceOfINominationEnquiryEvent(props.selectedEvent) &&
            props.selectedEvent.deliveryModes &&
            props.selectedEvent.deliveryModes.length > 1) {
            return (React__default.createElement("div", null,
                React__default.createElement("p", null, "A spot enquiry can not be finalised until a single delivery mode is selected. Please select a single delivery mode before finalising the enquiry."),
                React__default.createElement(ButtonGroupWithCancel, { onCancel: function () { return props.setActiveDialog(undefined); }, action: action }, permissions.canFinalise && (React__default.createElement(Button, { primary: true, outline: true, preventDoubleClick: true, onClick: function () {
                        setActiveDialog(undefined);
                    } }, "Return to enquiry")))));
        }
        else {
            return (React__default.createElement("div", null,
                React__default.createElement("p", null, "Are you sure you want to confirm and finalise this " + eventDescriptionText.toLowerCase() + "? This change can not be reverted."),
                props.error && React__default.createElement("p", { className: "status error" }, props.error),
                React__default.createElement(ButtonGroupWithCancel, { onCancel: function () { return props.setActiveDialog(undefined); }, action: action }, permissions.canFinalise && (React__default.createElement(Button, { primary: true, preventDoubleClick: true, onClick: function () {
                        props.changeStateWhenValid('FINALISED', false);
                    } }, "Finalise " + eventDescriptionText)))));
        }
    }
    else if (action === 'CANCEL_DELEGATION') {
        return (React__default.createElement("div", null,
            React__default.createElement("p", null, "You can un-delegate the bunker event."),
            props.error && React__default.createElement("p", { className: "status error" }, props.error),
            React__default.createElement("label", null, props.delegatedCompanyName
                ? "Message to " + props.delegatedCompanyName
                : 'Reason for cancelling'),
            React__default.createElement("textarea", { className: "input", onChange: function (e) {
                    setReasonForReject(e.target.value);
                } }),
            React__default.createElement(ButtonGroupWithCancel, { onCancel: function () { return props.setActiveDialog(undefined); }, action: action },
                React__default.createElement(Button, { preventDoubleClick: true, danger: true, onClick: function () {
                        if (props.cancelDelegatedNomination) {
                            props.cancelDelegatedNomination(reasonForReject);
                        }
                        setReasonForReject(undefined);
                    } }, "Un-delegate bunkering"))));
    }
    else if (action === 'CONTRACT_CHECK' && props.onContractCheck) {
        return (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(FormElement, { className: "contract-check-form-element" },
                React__default.createElement(FormLabel, { fieldName: "nomination-selection" }, "Select contract"),
                React__default.createElement(SelectionBox, { fieldName: 'integration-contractId', className: "contract-erp-check", value: selectedContract, options: props.contractsList.map(function (contract) { return ({
                        value: contract._id,
                        text: contract.name,
                        reference: contract.contractReference || null
                    }); }), valueKey: "value", displayKey: "text", renderFieldValue: function (selectedItem) {
                        return "" + selectedItem.text;
                    }, onChangeValue: function (selectedItem) {
                        setSelectedContract(selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value);
                    }, renderOption: function (option) {
                        return (React__default.createElement("div", null,
                            React__default.createElement("span", null, option.text)));
                    } })),
            React__default.createElement(ButtonGroupWithCancel, { onCancel: function () { return props.setActiveDialog(undefined); }, action: action },
                React__default.createElement(Button, { preventDoubleClick: true, danger: true, disabled: !selectedContract, onClick: function () {
                        if (selectedContract && props.onContractCheck)
                            props.onContractCheck(selectedContract);
                        props.setActiveDialog(undefined);
                    } }, "Submit"))));
    }
    else if (action === 'APPROVE_CONTRACT_CHECK' && props.onContractCheckApprove) {
        return (React__default.createElement("div", null,
            React__default.createElement("p", null, "Approving the supplier check will assign the contract to the nomination"),
            React__default.createElement(ButtonGroupWithCancel, { onCancel: function () { return props.setActiveDialog(undefined); }, action: action }, permissions.canEdit && (React__default.createElement(Button, { primary: true, outline: true, preventDoubleClick: true, onClick: function () {
                    props.onContractCheckApprove && props.onContractCheckApprove();
                    setActiveDialog(undefined);
                } }, "Yes, approve supplier check")))));
    }
    else {
        return (React__default.createElement("div", null,
            React__default.createElement("p", null, "Are you sure you want to cancel this " + eventDescriptionText.toLowerCase() + "?"),
            props.error && React__default.createElement("p", { className: "status error" }, props.error),
            React__default.createElement(ButtonGroupWithCancel, { onCancel: function () { return props.setActiveDialog(undefined); }, action: action }, permissions.canCancel && (React__default.createElement(Button, { preventDoubleClick: true, danger: true, onClick: function () {
                    props.changeStateWhenValid('CANCELLED', false);
                } }, "Yes, cancel")))));
    }
};

var OnBehalfDialogContent = function (props) {
    var permissions = props.permissions;
    var _a = useState(false), cancelOnBehalfActive = _a[0], setCancelOnBehalfActive = _a[1];
    return (React__default.createElement("div", { className: "onbehalf-dialog-content" },
        cancelOnBehalfActive && (React__default.createElement(React__default.Fragment, null,
            React__default.createElement("p", null, "Are you sure you want to cancel the nomination? This action can not be undone."),
            React__default.createElement("div", { className: "onbehalf-actions-wrapper" },
                React__default.createElement(Button, { danger: true, preventDoubleClick: true, outline: true, onClick: function () {
                        props.changeStateWhenValid('CANCELLED', true);
                    } },
                    getNominationStatusIcon('CANCELLED'),
                    "Cancel nomination")))),
        !cancelOnBehalfActive && (React__default.createElement(React__default.Fragment, null,
            React__default.createElement("p", null,
                "This function permits you to make changes to the buyer's (",
                props.customerCompanyName,
                ") nomination request. ",
                React__default.createElement("span", { className: "bold-underline" }, "It does not"),
                " create an agency relationship between you and your customer, and",
                ' ',
                React__default.createElement("span", { className: "bold-underline" }, "does not"),
                " bind your customer to these changes unless separately agreed by your customer."),
            React__default.createElement("span", null,
                React__default.createElement("b", null, "For your customer you can:")),
            React__default.createElement("div", { className: "onbehalf-actions-wrapper" },
                React__default.createElement(Button, { primary: true, preventDoubleClick: true, outline: true, className: "edit-onbehalf-button", onClick: function () {
                        props.activateEditMode('EDIT_ON_BEHALF');
                    } },
                    React__default.createElement(Icon, null,
                        React__default.createElement(FontAwesomeIcon, { icon: faPencil })),
                    "Edit nomination"),
                permissions.canAcceptOnBehalf && (React__default.createElement(Button, { primary: true, preventDoubleClick: true, className: "accept-onbehalf-button", outline: true, success: true, onClick: function () {
                        props.changeStateWhenValid('ACCEPTED', true);
                    } },
                    getNominationStatusIcon('ACCEPTED'),
                    "Accept nomination")),
                permissions.canRejectOnBehalf && (React__default.createElement(Button, { danger: true, preventDoubleClick: true, className: "reject-onbehalf-button", outline: true, onClick: function () {
                        props.changeStateWhenValid('REJECTED', true);
                    } },
                    getNominationStatusIcon('REJECTED'),
                    "Reject nomination")),
                permissions.canCancelOnBehalf && (React__default.createElement(Button, { danger: true, preventDoubleClick: true, outline: true, onClick: function () {
                        setCancelOnBehalfActive(true);
                    } },
                    getNominationStatusIcon('CANCELLED'),
                    "Yes, cancel nomination"))),
            props.error && React__default.createElement("p", { className: "status error" }, props.error))),
        React__default.createElement("div", { className: "exit-onbehalf", onClick: function () {
                props.setActiveDialog(undefined);
            } },
            React__default.createElement("p", null, "Exit and Return to prior view"))));
};

function userIsCharteredCaptainOnNomination(nomination, user) {
    // if the user company is part of the nomination he is not chartered
    if (isNominationBelongsToUsersCompany(nomination, user))
        return false;
    // if the bunkership is set, and the bunkership is the user's ship he is a captain. an thus a chartered captain.
    if (nomination.bunkerShipId && nomination.bunkerShipId === user.bunkerShipId)
        return true;
    // if the receiving ship is set, and the receiving ship is the user's ship he is a captain. an thus a chartered captain.
    if (nomination.receivingShipId && nomination.receivingShipId === user.receivingShipId)
        return true;
    return false;
}
function proposalMadeByChartererCompany(nomination, user) {
    var _a;
    if (!userIsCharteredCaptainOnNomination(nomination, user))
        return false;
    var userChartererCompanyId = getUserChartererCompanyId(nomination, user);
    if (!((_a = nomination.author) === null || _a === void 0 ? void 0 : _a.companyId) || nomination.author.companyId !== userChartererCompanyId)
        return false;
    return true;
}
function getUserChartererCompanyId(nomination, user) {
    // if user is chartered by bunker return bunker company id
    if (nomination.bunkerShipId && nomination.bunkerShipId === user.bunkerShipId)
        return nomination.vendorCompanyId;
    if (nomination.receivingShipId && nomination.receivingShipId === user.receivingShipId)
        return nomination.companyId;
    return undefined;
}

/**
 * Object is copied from ../../chorus-utility/ at 19 augustus 2022 commit
 */
var noActionsAllowed$1 = {
    canAccept: false,
    canAcceptOnBehalf: false,
    canCancel: false,
    canCancelOnBehalf: false,
    canReject: false,
    canRejectOnBehalf: false,
    canEdit: false,
    canComplete: false,
    canFinalise: false,
    canAssignEnquiryContract: false,
    canDelegate: false,
    canCancelDelegation: false
};
/**
 * Function is copied from ../../chorus-utility/ at 19 augustus 2022 commit
 */
/**
 * Function which returns the permissions for each of the possible actions in the negotiation phase of the event.
 *
 * @param event the event to check the permissions for.
 * @param eventIsLatest boolean value to indicate if the event is the last one in the negotiation or if it's a historic one.
 * @param userProfile the user to check the permissions for.
 * @param isEventInSandbox indicates if the event is present within a sandbox.
 * @param isGodMode it means that Corporate Admin can take any action regardless of ownership of the negotiation
 */
function getUserNegotiationPermissions$1(event, eventIsLatest, userProfile, isEventInSandbox, isGodMode) {
    var userCanAccessNegotiation = isUserAllowed([
        'ROLE_ADMIN',
        'ROLE_CUSTOMER',
        'ROLE_SCHEDULER',
        'ROLE_SCHEDULER_CAPTAIN',
        'ROLE_CORPORATE_ADMIN',
        'ROLE_THIRD_PARTY_SCHEDULER',
        'ROLE_CAPTAIN',
        'ROLE_RECEIVING_CAPTAIN',
        'ROLE_TERMINAL_OPERATOR'
    ], userProfile.roles);
    var eventIsCancelled = event.state === 'CANCELLED';
    var eventIsCompleted = event.state === 'FINALISED' || event.state === 'COMPLETED';
    // return no actions allowed if
    // the user doesn't have the correct role to negotiate
    // OR if the event is not the latest in the history
    // OR the user is indirectly related with the nomination
    if (!userCanAccessNegotiation || !eventIsLatest || eventIsCancelled || eventIsCompleted) {
        return noActionsAllowed$1;
    }
    else if (!isGodMode &&
        !isNominationBelongsToUsersCompany(event, userProfile) &&
        !userIsCharteredCaptainOnNomination(event, userProfile)) {
        return noActionsAllowed$1;
    }
    if (instanceOfNominationTimelineItem(event)) {
        return getNominationNegotiationPermissions$1(event, eventIsLatest, userProfile, isEventInSandbox);
    }
    else if (instanceOfINominationEnquiryEvent(event)) {
        return getEnquiryNegotiationPermissions$1(event, eventIsLatest, userProfile);
    }
    else {
        return noActionsAllowed$1;
    }
}
/**
 * Function is copied from ../../chorus-utility/ at 19 augustus 2022 commit
 */
function getNominationNegotiationPermissions$1(event, eventIsLatest, userProfile, iseventInSandbox) {
    // checks if the proposal was made by the users company
    var proposalMadeByCurrentUserCompany = proposalMadeByUserCompany(event, userProfile.companyId) ||
        proposalMadeByChartererCompany(event, userProfile);
    // The proposal was made by a other company than the users AND the event is not in sandbox mode.
    var counteringPossible = !proposalMadeByCurrentUserCompany && !iseventInSandbox;
    // The company to which the user belongs has made the last change AND the event is not in sandbox mode.
    var onBehalfPossible = proposalMadeByCurrentUserCompany && !iseventInSandbox;
    // Checks to see if various actions are possible based on the current state of the event.
    var hasAcceptOption = isOneOf(event.state, ['PROPOSED', 'COUNTERED', 'REJECTED']);
    var hasRejectOption = isOneOf(event.state, ['PROPOSED', 'COUNTERED']);
    var hasCancelOption = isOneOf(event.state, ['ACCEPTED', 'PROPOSED', 'COUNTERED', 'REJECTED']);
    var hasCompleteOption = isOneOf(event.state, ['ACCEPTED']);
    // Delegated nominations should not have complete allowed for contract holding
    var isContractHolder = userProfile.companyId === event.companyId;
    var isDelegatedNomination = !!event.delegationOriginEventId;
    var hasDelegatedNomination = !!event.delegatedNominationEventId;
    if (isScheduler(userProfile.roles) ||
        isSchedulerCaptain(userProfile.roles) ||
        isCorporateAdmin(userProfile.roles) ||
        isContractParty(userProfile, event)) {
        return __assign(__assign({}, noActionsAllowed$1), { 
            // If countering / accepting is possible -> Acceptance is possible.
            // If the event is in pending state, the user can accept the indirect communication.
            canAccept: (counteringPossible && hasAcceptOption) || event.state === 'PENDING', 
            // OnBehalf is possible if the users company made the proposal.
            canAcceptOnBehalf: onBehalfPossible && hasAcceptOption, 
            // The event can be cancelled if it is in one of the hasCancelOption states.
            canCancel: hasCancelOption && event.state !== 'PENDING' && !isDelegatedNomination, canCancelOnBehalf: hasCancelOption && event.state !== 'PENDING', 
            // opposing party made the proposal AND the event is in PROPOSED OR COUNTERED State.
            //  Rejection can also be done so the user can reject indirect communication.
            canReject: (counteringPossible && hasRejectOption) || event.state === 'PENDING', 
            // user company made the proposal AND the event is in PROPOSED OR COUNTERED State
            canEdit: event.state !== 'PENDING', canComplete: hasCompleteOption && !(isContractHolder && isDelegatedNomination), 
            // Note that getUserNegotiationPermissions checks against cancelled or finished nominations,
            // so no need to do that here too for canDelegate
            canDelegate: isScheduler(userProfile.roles) && !isDelegatedNomination && !hasDelegatedNomination, canCancelDelegation: isContractHolder && isDelegatedNomination });
    }
    else if (isThirdPartyScheduler(userProfile.roles)) {
        return __assign(__assign({}, noActionsAllowed$1), { 
            // opposing party made the proposal AND is in PROPOSED, COUNTERED OR REJECTED STATE
            canAccept: counteringPossible && hasAcceptOption, canCancel: hasCancelOption && event.state !== 'PENDING', 
            // opposing party made the proposal AND is in PROPOSED or COUNTERED STATE
            canReject: counteringPossible && hasRejectOption, canEdit: eventIsLatest, canComplete: hasCompleteOption });
    }
    else if (isCustomer(userProfile.roles)) {
        return __assign(__assign({}, noActionsAllowed$1), { 
            // opposing party made the proposal AND is in PROPOSED, COUNTERED OR REJECTED STATE.
            // acceptance is also not possible if the event already has a pending proposal ( means the party on the other side is making a indirect proposal to the vendor )
            canAccept: counteringPossible && hasAcceptOption, canCancel: hasCancelOption && event.state !== 'PENDING', canEdit: eventIsLatest });
    }
    else if (isCaptain(userProfile.roles)) {
        return __assign(__assign({}, noActionsAllowed$1), { canEdit: true });
    }
    else {
        return noActionsAllowed$1;
    }
}
/**
 * Function is copied from ../../chorus-utility/ at 19 augustus 2022 commit
 */
function getEnquiryNegotiationPermissions$1(event, eventIsLatest, userProfile) {
    var proposalMadeByCurrentUserCompany = proposalMadeByUserCompany(event, userProfile.companyId) ||
        proposalMadeByChartererCompany(event, userProfile);
    // The proposal was made by a other company than the users AND the event is not in sandbox mode.
    var counteringPossible = !proposalMadeByCurrentUserCompany;
    var hasAcceptOption = isOneOf(event.state, ['PROPOSED', 'COUNTERED', 'REJECTED']);
    var hasRejectOption = isOneOf(event.state, ['PROPOSED', 'COUNTERED']);
    var hasCancelOption = isOneOf(event.state, ['ACCEPTED', 'PROPOSED', 'COUNTERED', 'REJECTED']);
    var hasFinaliseOption = isOneOf(event.state, ['ACCEPTED']);
    var hasFinaliseProposedOption = !proposalMadeByCurrentUserCompany && event.state === 'PROPOSED';
    var requiresContract = isOneOf(event.state, ['NEEDS_CONTRACT']);
    if (isScheduler(userProfile.roles) || isCorporateAdmin(userProfile.roles)) {
        return __assign(__assign({}, noActionsAllowed$1), { 
            // If countering / accepting is possible-> Acceptance is possible.
            canAccept: counteringPossible && hasAcceptOption, 
            // Onbehalf never possible for inquiries
            canReject: counteringPossible && hasRejectOption, canEdit: eventIsLatest && !requiresContract, canAssignEnquiryContract: requiresContract });
    }
    else if (isThirdPartyScheduler(userProfile.roles)) {
        return __assign(__assign({}, noActionsAllowed$1), { 
            // opposing party made the proposal AND is in PROPOSED, COUNTERED OR REJECTED STATE
            canAccept: counteringPossible && hasAcceptOption, canCancel: hasCancelOption, canReject: counteringPossible && hasRejectOption, canEdit: eventIsLatest && !requiresContract });
    }
    else if (isCustomer(userProfile.roles)) {
        return __assign(__assign({}, noActionsAllowed$1), { canAccept: counteringPossible && hasAcceptOption && !hasFinaliseProposedOption, canCancel: hasCancelOption, canReject: hasRejectOption && !proposalMadeByCurrentUserCompany, canEdit: eventIsLatest && !requiresContract, canFinalise: hasFinaliseOption || hasFinaliseProposedOption });
    }
    else if (isCaptain(userProfile.roles)) {
        return noActionsAllowed$1;
    }
    else {
        return noActionsAllowed$1;
    }
}

var NegotiationActions = function (props) {
    var _a = useState(), activeDialog = _a[0], setActiveDialog = _a[1];
    var isLatestEvent = props.initialEvent._id === props.selectedEvent._id;
    var eventDescriptionText = instanceOfINominationEnquiryEvent(props.selectedEvent)
        ? 'Enquiry'
        : 'Nomination';
    var negotiationPermissions = getUserNegotiationPermissions$1(props.selectedEvent, isLatestEvent, props.userProfile, props.isNominationInSandbox);
    useUpdateEffect(function () {
        setActiveDialog(undefined);
    }, [props.initialEvent]);
    if (props.readOnly === true) {
        return null;
    }
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(ButtonGroup, null,
            negotiationPermissions.canEdit && (React__default.createElement(Button$1, { preventDoubleClick: true, iconButton: true, className: "edit-button", disabled: props.readOnly, onClick: enableEditMode, primary: true, tooltipText: 'Edit' },
                React__default.createElement(Icon, null,
                    React__default.createElement(FontAwesomeIcon, { icon: faPencil })))),
            isOrderConfirmationButtonVisible() && (React__default.createElement(Button$1, { preventDoubleClick: true, iconButton: true, className: "edit-button", disabled: props.readOnly, onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                    var _a;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                _a = props.generateAndSendOrderConfirmation;
                                if (!_a) return [3 /*break*/, 2];
                                return [4 /*yield*/, props.generateAndSendOrderConfirmation()];
                            case 1:
                                _a = (_b.sent());
                                _b.label = 2;
                            case 2:
                                // Callback function
                                props.onOrderPDFConfirmed && props.onOrderPDFConfirmed();
                                return [2 /*return*/];
                        }
                    });
                }); }, primary: true, tooltipText: 'Generate order confirmation PDF' },
                React__default.createElement(Icon, null,
                    React__default.createElement(FontAwesomeIcon, { icon: faFilePdf })))),
            negotiationPermissions.canEdit &&
                (isScheduler(props.userRoles) || isSchedulerCaptain(props.userRoles)) &&
                !props.delegationOriginEventId &&
                instanceOfNominationTimelineItem(props.selectedEvent) && (React__default.createElement(Button$1, { preventDoubleClick: true, iconButton: true, className: "on-behalf-button", disabled: props.readOnly, onClick: function () { return setActiveDialog('ON_BEHALF'); }, primary: true, tooltipText: 'Edit for customer' },
                React__default.createElement(Icon, null,
                    React__default.createElement(FontAwesomeIcon, { icon: faUsers })))),
            negotiationPermissions.canAccept && (React__default.createElement(Button$1, { preventDoubleClick: true, primary: true, iconButton: true, className: "approve-button", tooltipText: 'Approve', onClick: function () { return setActiveDialog('ACCEPT'); } }, getDialogTitleIcon('ACCEPT'))),
            negotiationPermissions.canEdit && props.showContractIntegration && (React__default.createElement(Button$1, { preventDoubleClick: true, primary: true, iconButton: true, className: "complete-button", tooltipText: 'Contract check', onClick: function () { return setActiveDialog('CONTRACT_CHECK'); } }, getDialogTitleIcon('CONTRACT_CHECK'))),
            negotiationPermissions.canEdit &&
                props.showContractIntegration &&
                isLatestEvent &&
                props.selectedEvent['creditCheckContractId'] && (React__default.createElement(Button$1, { preventDoubleClick: true, primary: true, iconButton: true, className: "complete-button", tooltipText: 'Approve contract check', onClick: function () { return setActiveDialog('APPROVE_CONTRACT_CHECK'); } }, getDialogTitleIcon('APPROVE_CONTRACT_CHECK'))),
            negotiationPermissions.canComplete && (React__default.createElement(Button$1, { preventDoubleClick: true, primary: true, iconButton: true, className: "complete-button", tooltipText: 'Complete', onClick: function () { return setActiveDialog('COMPLETE'); } }, getDialogTitleIcon('COMPLETE'))),
            negotiationPermissions.canFinalise && (React__default.createElement(Button$1, { preventDoubleClick: true, primary: true, iconButton: true, className: "finalise-button", tooltipText: 'Confirm and Finalise', onClick: function () { return setActiveDialog('FINALISE'); } }, getDialogTitleIcon('FINALISE'))),
            negotiationPermissions.canAssignEnquiryContract && props.setContractCandidateEvent && (React__default.createElement(Button$1, { primary: true, preventDoubleClick: true, iconButton: true, className: "add-contract-button", tooltipText: 'Add Contract', onClick: function () {
                    return props.setContractCandidateEvent
                        ? props.setContractCandidateEvent(props.selectedEvent)
                        : undefined;
                } }, getDialogTitleIcon('ADD_CONTRACT'))),
            negotiationPermissions.canReject && (React__default.createElement(Button$1, { preventDoubleClick: true, danger: true, iconButton: true, className: "reject-button", tooltipText: 'Reject', onClick: function () { return setActiveDialog('REJECT'); } }, getDialogTitleIcon('REJECT'))),
            negotiationPermissions.canCancel && (React__default.createElement(Button$1, { preventDoubleClick: true, danger: true, iconButton: true, className: "cancel-button", tooltipText: 'Cancel', onClick: function () { return setActiveDialog('CANCEL'); } }, getDialogTitleIcon('CANCEL'))),
            negotiationPermissions.canCancelDelegation && (React__default.createElement(Button$1, { preventDoubleClick: true, danger: true, iconButton: true, className: "cancel-button", tooltipText: 'Un-delegate', onClick: function () { return setActiveDialog('CANCEL_DELEGATION'); } }, getDialogTitleIcon('CANCEL_DELEGATION'))),
            negotiationPermissions.canDelegate &&
                props.setDelegationState &&
                props.delegationBtnEnabled && (React__default.createElement(Button$1, { preventDoubleClick: true, iconButton: true, className: "delegation-button", disabled: props.readOnly, onClick: startCreateDelegation, primary: true, tooltipText: 'Add delegation' }, getDialogTitleIcon('DELEGATE')))),
        activeDialog && (React__default.createElement(Dialog, { type: "medium", titleIcon: getDialogTitleIcon(activeDialog), contentClassName: "dialog-allow-overflow padded-content", title: activeDialog === 'CANCEL_DELEGATION'
                ? 'Un-delegate bunkering'
                : activeDialog === 'ON_BEHALF'
                    ? 'Submit for customer'
                    : activeDialog === 'CONTRACT_CHECK'
                        ? 'Supplier check'
                        : activeDialog === 'APPROVE_CONTRACT_CHECK'
                            ? 'Approve supplier check'
                            : capitalizeFirstLetter(screamingSnakeCaseToSentence(activeDialog) + " " + eventDescriptionText), onCloseDialog: function () {
                setActiveDialog(undefined);
            }, showDialog: activeDialog !== undefined }, renderDialogContent()))));
    function renderDialogContent() {
        if (!activeDialog)
            return;
        if (activeDialog === 'ON_BEHALF')
            return (React__default.createElement(OnBehalfDialogContent, { permissions: negotiationPermissions, changeStateWhenValid: props.changeStateWhenValid, error: props.error, activateEditMode: props.activateEditMode, setActiveDialog: setActiveDialog, customerCompanyName: props.customerCompanyName }));
        return (React__default.createElement(ActionDialogContent, { initialEvent: props.initialEvent, selectedEvent: props.selectedEvent, permissions: negotiationPermissions, setActiveDialog: setActiveDialog, acceptPendingNomination: props.acceptPendingNomination, error: props.error, updateEvent: props.updateEvent, action: activeDialog, changeStateWhenValid: props.changeStateWhenValid, delegatedCompanyName: props.delegatedCompanyName, cancelDelegatedNomination: props.cancelDelegatedNomination, contractsList: props.contractsList, onContractCheck: props.onContractCheck, onContractCheckApprove: props.onContractCheckApprove }));
    }
    function isOrderConfirmationButtonVisible() {
        // generateAndSendOrderConfirmation is a function provided by useNominationService
        if (!props.generateAndSendOrderConfirmation)
            return false;
        if (!props.selectedEvent.state)
            return false;
        if (!['ACCEPTED', 'FINALISED', 'COMPLETED'].includes(props.selectedEvent.state))
            return false;
        // Hide the orderConfirmation button if the user/company is the rhs on a delegation
        if (props.delegationOriginEventId &&
            props.delegationOriginEventId !== props.initialEvent.eventId)
            return false;
        // // Finally, check for user role
        if (isScheduler(props.userRoles) || isSchedulerCaptain(props.userRoles))
            return true;
        return false;
    }
    function getDialogTitleIcon(action) {
        switch (action) {
            case 'ACCEPT':
                return getNominationStatusIcon('ACCEPTED');
            case 'REJECT':
                return getNominationStatusIcon('REJECTED');
            case 'CANCEL':
                return getNominationStatusIcon('CANCELLED');
            case 'COMPLETE':
                return getNominationStatusIcon('COMPLETED');
            case 'FINALISE':
                return getNominationStatusIcon('FINALISED');
            case 'ADD_CONTRACT':
                return getNominationStatusIcon('NEEDS_CONTRACT');
            case 'ON_BEHALF':
                return React__default.createElement(FontAwesomeIcon, { icon: faUsers });
            case 'DELEGATE':
                return (React__default.createElement(Icon, null,
                    React__default.createElement(FontAwesomeIcon, { icon: faShare })));
            case 'CANCEL_DELEGATION':
                return (React__default.createElement(Icon, null,
                    React__default.createElement("span", { className: "stripe-through-icon" }),
                    React__default.createElement(FontAwesomeIcon, { icon: faShare })));
            case 'APPROVE_CONTRACT_CHECK':
                return (React__default.createElement(Icon, null,
                    React__default.createElement(FontAwesomeIcon, { icon: faFileCheck })));
            case 'CONTRACT_CHECK':
                return (React__default.createElement(Icon, null,
                    React__default.createElement(FontAwesomeIcon, { icon: faFileContract })));
            default:
                return null;
        }
    }
    function startCreateDelegation() {
        if (!props.setDelegationState)
            return;
        props.setDelegationState('CREATING_DELEGATION');
    }
    function enableEditMode() {
        props.activateEditMode('EDIT');
        if (!props.setDelegationState)
            return;
        if (props.nominationType === 'SELECTED_NOMINATION') {
            props.setDelegationState('EDITING_SN');
        }
        if (props.nominationType === 'ASSOCIATED_NOMINATION') {
            props.setDelegationState('EDITING_AN');
        }
    }
};
var NegotiationActions$1 = React__default.memo(NegotiationActions);

var Tag = function (props) {
    if (!props.tagText) {
        return null;
    }
    return (React__default.createElement("div", { className: "status-indicator-tag " + (props.className ? props.className : '') },
        props.children,
        props.tagText));
};

var SandBoxWarningMessage = function (props) {
    if (props.isNominationInSandbox && !isLiveNominationInSandbox(props.initialNomination)) {
        return React__default.createElement(Tag, { tagText: 'SANDBOX EVENT', className: "" });
    }
    if (isLiveNominationInSandbox(props.initialNomination)) {
        return React__default.createElement(Tag, { tagText: 'LIVE NOMINATION', className: "" });
    }
    return null;
    // return true if the nomination is in the live column of the sandbox
    function isLiveNominationInSandbox(nomination) {
        if (!props.isNominationInSandbox) {
            return false;
        }
        if (!nomination) {
            return false;
        }
        return nomination.sandboxId === null || nomination.sandboxId === undefined;
    }
};

var TitleBox = function (props) {
    return (React__default.createElement("div", { className: "title-box " + (props.className ? props.className : '') },
        React__default.createElement("span", { className: "title-box-title" }, props.titleText),
        props.valueText));
};

var ScheduleInformation = function (props) {
    var _a;
    var selectedNomination = props.selectedNomination, companies = props.companies;
    var customerCompanyId = getCustomerCompanyId();
    var customerCompanyName = customerCompanyId
        ? getCompanyDetails(props.companies, customerCompanyId).companyName
        : 'customer';
    var recipientCompanyId = selectedNomination && selectedNomination.recipient
        ? selectedNomination.recipient.companyId
        : undefined;
    var recipientCompanyName = recipientCompanyId && props.companies.find(function (c) { return c._id === recipientCompanyId; })
        ? getCompanyDetails(props.companies, recipientCompanyId).companyName
        : undefined; // FIXME: we can't resolve the company when we're a user
    var madeByText = ((_a = selectedNomination === null || selectedNomination === void 0 ? void 0 : selectedNomination.author) === null || _a === void 0 ? void 0 : _a.name) + " (" + getCompanyName(selectedNomination ? selectedNomination : null, companies) + ")" + (selectedNomination && selectedNomination.onBehalf ? " for customer " + customerCompanyName : '');
    var actionByText = "" + ((selectedNomination === null || selectedNomination === void 0 ? void 0 : selectedNomination.recipient) ? selectedNomination.recipient.name + " " + (recipientCompanyName ? "(" + recipientCompanyName + ")" : '')
        : '') + ((selectedNomination === null || selectedNomination === void 0 ? void 0 : selectedNomination.reactionOnBehalf) ? " for customer " + customerCompanyName : '');
    return (createElement(Fragment, null, createElement("div", { className: "proposal-info-wrapper" },
        selectedNomination && selectedNomination.author && selectedNomination.author.name && (createElement(TitleBox, { titleText: 'Submitted by', valueText: madeByText + ", " + (selectedNomination ? formatDateTime(selectedNomination.created) : '') })),
        selectedNomination &&
            selectedNomination.state &&
            !isOneOf(selectedNomination.state, ['COUNTERED', 'PROPOSED', 'PENDING']) && (createElement(TitleBox, { titleText: capitalize(selectedNomination.state) + " by", valueText: actionByText + ", " + (selectedNomination
                ? formatDateTime(selectedNomination.reactionTime)
                : '') })))));
    function getCustomerCompanyId() {
        var latestProposal = props.selectedNomination;
        return latestProposal ? latestProposal.companyId : undefined;
    }
};

var NegotiationStatusSummary = function (props) {
    var negotiationItem = props.negotiationItem;
    if (!negotiationItem) {
        return null;
    }
    var timeUntilDelivery = negotiationItem && negotiationItem.bst
        ? toRelativeTime(DateTime.fromISO(negotiationItem.bst).toMillis())
        : undefined;
    var showStateIcon = isOneOf(negotiationItem.state, ['CANCELLED', 'COMPLETED', 'FINALISED']);
    return (React__default.createElement("div", { className: "nomination-delivery-summary" },
        showStateIcon && React__default.createElement("div", null, getNominationStatusIcon(negotiationItem.state)),
        timeUntilDelivery !== undefined && !showStateIcon && (React__default.createElement(React__default.Fragment, null,
            React__default.createElement("span", null, timeUntilDelivery.value),
            timeUntilDelivery.unit)),
        timeUntilDelivery === undefined && !showStateIcon && React__default.createElement("div", null, "-")));
};

var NegotiationStatusHeader = function (props) {
    var _a;
    var negotiationItem = props.negotiationItem, receivingVesselName = props.receivingVesselName, isNominationInSandbox = props.isNominationInSandbox;
    var stateText = negotiationItem ? getStateText(negotiationItem) : undefined;
    var takeAction = getTakeAction(negotiationItem);
    var hideStateIcon = !isOneOf(negotiationItem === null || negotiationItem === void 0 ? void 0 : negotiationItem.state, ['CANCELLED', 'COMPLETED', 'FINALISED']);
    var isDelegatedNomination = ((_a = negotiationItem) === null || _a === void 0 ? void 0 : _a.delegationOriginEventId) ? true
        : false;
    if (!negotiationItem) {
        return null;
    }
    return (React__default.createElement("div", { className: "nomination-status-header" },
        React__default.createElement(NegotiationStatusSummary, { negotiationItem: negotiationItem }),
        React__default.createElement("div", { className: "nomination-delivery-info-box" },
            React__default.createElement(Tag, { tagText: stateText, className: "nomination-status " + (negotiationItem === null || negotiationItem === void 0 ? void 0 : negotiationItem.state) + " " + (takeAction ? 'TAKE_ACTION' : '') },
                React__default.createElement("div", { className: "status-icon nomination-status-color " + (negotiationItem === null || negotiationItem === void 0 ? void 0 : negotiationItem.state) + " " + (takeAction ? 'TAKE_ACTION' : '') }, hideStateIcon && getNominationStatusIcon(negotiationItem === null || negotiationItem === void 0 ? void 0 : negotiationItem.state, takeAction))),
            negotiationItem &&
                instanceOfNominationTimelineItem(negotiationItem) &&
                negotiationItem.hasPendingProposal &&
                negotiationItem.state !== 'PENDING' && (React__default.createElement(Tag, { tagText: 'AWAITING PENDING PROPOSAL', className: "nomination-status PENDING" })),
            React__default.createElement("h2", { className: "nomination-header" },
                isDelegatedNomination && (React__default.createElement(Icon, null,
                    React__default.createElement(FontAwesomeIcon, { icon: faShare }))),
                receivingVesselName
                    ? receivingVesselName
                    : instanceOfNominationTimelineItem(props.negotiationItem)
                        ? 'Bunker Nomination'
                        : 'Bunker Enquiry'),
            instanceOfNominationTimelineItem(negotiationItem) && (React__default.createElement(SandBoxWarningMessage, { isNominationInSandbox: isNominationInSandbox, initialNomination: negotiationItem })),
            React__default.createElement(ScheduleInformation, { selectedNomination: negotiationItem, companies: props.companies }))));
    function getStateText(nomination) {
        var _a;
        // if no state is present, the form is being edited and the state should be editing
        // Otherweise if the take action flag is active, the state should display a custom state message
        // Otherwise we can just use the state to display.
        if (!nomination.state) {
            return 'EDITING';
        }
        else {
            if (nomination.state === 'PROPOSED') {
                if (isCustomer(props.userProfile.roles) ||
                    isScheduler(props.userProfile.roles) ||
                    isSchedulerCaptain(props.userProfile.roles)) {
                    var isContractHolder = props.userProfile.companyId === nomination.companyId;
                    var opposingParty = isCustomer(props.userProfile.roles)
                        ? 'SUPPLIER'
                        : props.isDelegatedNomination === true
                            ? isContractHolder
                                ? 'EXECUTING SUPPLIER'
                                : 'CONTRACT-HOLDING SUPPLIER'
                            : 'CUSTOMER';
                    if (((_a = nomination.attributes) === null || _a === void 0 ? void 0 : _a.needsAction) === true) {
                        return "NEW PROPOSAL FROM " + opposingParty;
                    }
                    else {
                        return "PROPOSAL SENT TO " + opposingParty;
                    }
                }
                else {
                    return showNegotiationState(nomination, props.showFuelbossStates);
                }
            }
            else {
                return showNegotiationState(nomination, props.showFuelbossStates);
            }
        }
    }
    function showNegotiationState(negotiationEvent, showFuelBossStates) {
        var _a;
        var negotiationState = showFuelBossStates
            ? (_a = negotiationEvent === null || negotiationEvent === void 0 ? void 0 : negotiationEvent.attributes) === null || _a === void 0 ? void 0 : _a.fbStatus : negotiationEvent === null || negotiationEvent === void 0 ? void 0 : negotiationEvent.state;
        return negotiationState ? negotiationState : '';
    }
};
var NegotiationStatusHeader$1 = React__default.memo(NegotiationStatusHeader);
function getTakeAction(negotiationItem) {
    var _a, _b;
    return negotiationItem
        ? ((_a = negotiationItem.attributes) === null || _a === void 0 ? void 0 : _a.needsAction) ? (_b = negotiationItem.attributes) === null || _b === void 0 ? void 0 : _b.needsAction : false
        : false;
}

var ResizableBox = function (props) {
    var _a = useState(false), isExpanded = _a[0], setIsExpanded = _a[1];
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("div", { className: "resizable-box-content" }, props.children.length < 100 || isExpanded
            ? props.children
            : props.children.substr(0, 200) + "..."),
        props.children.length > 100 && (React__default.createElement(Button$1, { onClick: function () { return setIsExpanded(!isExpanded); }, className: "resizable-box__toggle-button" }, isExpanded ? "Show less" : "Show more..."))));
};

var ValidationWarning = function (props) {
    var warning = props.warning, className = props.className;
    if (!warning) {
        return null;
    }
    return (React__default.createElement("div", { className: classNames('validation-warning', className) }, warning));
};

var SummaryRow = function (props) {
    var currentValue = props.currentValue, previousValue = props.previousValue, label = props.label, formatAsDate = props.formatAsDate, formatTimezone = props.formatTimezone, hideNewIndicator = props.hideNewIndicator, isInitialValue = props.isInitialValue, warning = props.warning;
    var isNewValue = currentValue && (previousValue === undefined || previousValue === null);
    var showNewIndicator = hideNewIndicator !== true && isNewValue;
    var valueIsDifferentThenComparedNomination = props.shouldCompare && props.currentValue !== props.rowToCompareWith;
    return (React__default.createElement("div", { className: "summary-row " + (props.className || '') + " " + (valueIsDifferentThenComparedNomination ? 'delegated-is-different' : '') },
        React__default.createElement("div", { className: "summary-label" },
            React__default.createElement("span", { className: "summary-label-text" }, label)),
        React__default.createElement("div", { className: "summary-value" },
            !isEmpty(currentValue) ? (React__default.createElement("div", { className: "current-value" }, formatAsDate
                ? isoStringToFormat(currentValue, 'dd MMM yyyy | HH:mm', formatTimezone)
                : props.renderValue
                    ? props.renderValue(currentValue)
                    : currentValue)) : (React__default.createElement("div", { className: "default-value" }, props.emptyValueMessage)),
            !isInitialValue && (React__default.createElement(React__default.Fragment, null,
                !isEmpty(previousValue) && !_.isEqual(previousValue, currentValue) && (React__default.createElement("div", { className: "previous-value" }, formatAsDate
                    ? isoStringToFormat(previousValue, 'dd MMM yyyy | HH:mm', formatTimezone)
                    : props.renderValue
                        ? props.renderValue(previousValue)
                        : previousValue)),
                showNewIndicator ? React__default.createElement("div", { className: "new-value" }, "NEW") : null)),
            warning && React__default.createElement(ValidationWarning, { warning: warning }))));
};
var isEmpty = function (value) {
    if (typeof value === 'undefined')
        return true;
    if (value === null)
        return true;
    if (value === '')
        return true;
    if (Array.isArray(value) && value.length === 0)
        return true;
    return false;
};

var NominationSummary = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    var currentNomination = props.nominationSelection.selectedHistoricNomination || props.latestNomination;
    var previousNomination = props.nominationSelection.previousHistoricNomination;
    var currentLocation = useLocationName(currentNomination.locationId, props.locationService, formatPortCountry);
    var locationComparing = useLocationName((_a = props.nominationEventToCompareWith) === null || _a === void 0 ? void 0 : _a.locationId, props.locationService, formatPortCountry);
    var previousLocation = useLocationName(previousNomination === null || previousNomination === void 0 ? void 0 : previousNomination.locationId, props.locationService, formatPortCountry);
    // note that we only use the resolved port/country when both current and previous locationDetails are resolved,
    // else the UI will temporarily display that the locationDetails is changed
    var loading = currentLocation.loading || previousLocation.loading;
    var currentPortName = loading ? '(Loading...)' : currentLocation.text;
    var comparingPortName = (locationComparing === null || locationComparing === void 0 ? void 0 : locationComparing.loading) ? '(Loading...)'
        : locationComparing === null || locationComparing === void 0 ? void 0 : locationComparing.text;
    var previousPortName = (previousNomination === null || previousNomination === void 0 ? void 0 : previousNomination.locationId) ? loading
        ? '(Loading...)'
        : previousLocation.text
        : undefined;
    var currentBunkerVessel = props.bunkerShips.find(function (bunkership) { return bunkership._id === currentNomination.bunkerShipId; });
    var previousBunkerVessel = props.bunkerShips.find(function (bunkership) { return bunkership._id === (previousNomination === null || previousNomination === void 0 ? void 0 : previousNomination.bunkerShipId); });
    var currentPipeline = props.pipelines.find(function (pipeline) { return pipeline._id === currentNomination.pipelineId; });
    var previousPipeline = props.pipelines.find(function (pipeline) { return pipeline._id === (previousNomination === null || previousNomination === void 0 ? void 0 : previousNomination.pipelineId); });
    var currenLoadingTerminal = props.pipelines.find(function (pipeline) { return pipeline._id === currentNomination.loadingTerminalId; });
    var previousLoadingTerminal = props.pipelines.find(function (pipeline) { return pipeline._id === (previousNomination === null || previousNomination === void 0 ? void 0 : previousNomination.loadingTerminalId); });
    var currentContract = props.contractsList.find(function (contract) { return contract._id === currentNomination.contractId; });
    var previousContract = props.contractsList.find(function (contract) { return contract._id === (previousNomination === null || previousNomination === void 0 ? void 0 : previousNomination.contractId); });
    var currentContractCheck = props.contractsList.find(function (contract) { return contract._id === currentNomination.creditCheckContractId; });
    var previousContractCheck = props.contractsList.find(function (contract) { return contract._id === (previousNomination === null || previousNomination === void 0 ? void 0 : previousNomination.creditCheckContractId); });
    var timezone = useLocationTimeZone(currentNomination.locationId, props.locationService);
    var altFuelAmounts = getAltFuelNumbers(currentNomination, previousNomination);
    var isInitialValue = !previousNomination;
    var vendorCompanyName = (_b = props.companies.find(function (company) { return company._id === props.latestNomination.vendorCompanyId; })) === null || _b === void 0 ? void 0 : _b.name;
    var isContractHolder = props.currentUser.companyId === currentNomination.companyId;
    var counterCompanyName = (!isContractHolder && props.isDelegatedNomination === true) ||
        (props.isDelegatedNomination === false && isScheduler(props.currentUser.roles))
        ? currentNomination.companyId
            ? getCompanyDetails(props.companies, currentNomination.companyId).companyName
            : '-'
        : currentNomination.vendorCompanyId
            ? getCompanyDetails(props.companies, currentNomination.vendorCompanyId).companyName
            : '-';
    return (React__default.createElement("div", { className: "nomination-summary" },
        React__default.createElement("section", { className: "summary-section" },
            React__default.createElement("h4", { className: "summary-section-title" }, "General information"),
            isCustomer(props.currentUser.roles) && (React__default.createElement(SummaryRow, { label: 'Supplier', currentValue: "" + (vendorCompanyName || ''), hideNewIndicator: true, emptyValueMessage: '-', isInitialValue: isInitialValue })),
            (isScheduler(props.currentUser.roles) || isSchedulerCaptain(props.currentUser.roles)) && (React__default.createElement(SummaryRow, { label: props.isDelegatedNomination === true
                    ? isContractHolder
                        ? 'Executing supplier'
                        : 'Contract-holding supplier'
                    : isScheduler(props.currentUser.roles)
                        ? 'Buyer'
                        : 'Supplier', hideNewIndicator: true, currentValue: counterCompanyName, emptyValueMessage: '-', isInitialValue: isInitialValue })),
            React__default.createElement(SummaryRow, { label: 'Delivery port', currentValue: currentPortName, previousValue: previousPortName, emptyValueMessage: '-', isInitialValue: isInitialValue, shouldCompare: !!props.nominationEventToCompareWith, rowToCompareWith: comparingPortName }),
            React__default.createElement(SummaryRow, { label: 'Location', currentValue: currentNomination.location, previousValue: previousNomination === null || previousNomination === void 0 ? void 0 : previousNomination.location, emptyValueMessage: '-', isInitialValue: isInitialValue, shouldCompare: !!props.nominationEventToCompareWith, rowToCompareWith: (_c = props.nominationEventToCompareWith) === null || _c === void 0 ? void 0 : _c.location }),
            React__default.createElement(SummaryRow, { label: 'Excise fee/CO2 fee applicable', currentValue: currentNomination.co2TaxEnabled ? 'yes' : null, previousValue: (previousNomination === null || previousNomination === void 0 ? void 0 : previousNomination.co2TaxEnabled) ? 'yes' : null, emptyValueMessage: '-', isInitialValue: isInitialValue }),
            React__default.createElement(SummaryRow, { label: 'Next destination', currentValue: currentNomination.nextDestination, previousValue: previousNomination === null || previousNomination === void 0 ? void 0 : previousNomination.nextDestination, emptyValueMessage: '-', isInitialValue: isInitialValue }),
            React__default.createElement(SummaryRow, { label: 'Agent', currentValue: currentNomination.agent, previousValue: previousNomination === null || previousNomination === void 0 ? void 0 : previousNomination.agent, emptyValueMessage: '-', isInitialValue: isInitialValue }),
            React__default.createElement(SummaryRow, { label: props.isDelegatedNomination === true
                    ? 'Contract-holding supplier Reference'
                    : 'Buyer Reference', currentValue: currentNomination.buyerRef, previousValue: previousNomination === null || previousNomination === void 0 ? void 0 : previousNomination.buyerRef, emptyValueMessage: '-', isInitialValue: isInitialValue })),
        React__default.createElement("section", { className: "summary-section" },
            React__default.createElement("h4", { className: "summary-section-title" }, "Quantity and delivery"),
            React__default.createElement(SummaryRow, { label: 'Quantity total', currentValue: currentNomination.amount + " " + getQuantityUnitLabel(currentNomination.quantityUnit), previousValue: previousNomination &&
                    (previousNomination === null || previousNomination === void 0 ? void 0 : previousNomination.amount) + " " + getQuantityUnitLabel(previousNomination === null || previousNomination === void 0 ? void 0 : previousNomination.quantityUnit), emptyValueMessage: '-', isInitialValue: isInitialValue, shouldCompare: !!props.nominationEventToCompareWith, rowToCompareWith: props.nominationEventToCompareWith &&
                    ((_d = props.nominationEventToCompareWith) === null || _d === void 0 ? void 0 : _d.amount) + " " + getQuantityUnitLabel((_e = props.nominationEventToCompareWith) === null || _e === void 0 ? void 0 : _e.quantityUnit) }),
            React__default.createElement(SummaryRow, { label: 'Tolerance (%)', currentValue: currentNomination.tolerance, previousValue: previousNomination === null || previousNomination === void 0 ? void 0 : previousNomination.tolerance, emptyValueMessage: '-', isInitialValue: isInitialValue, shouldCompare: !!props.nominationEventToCompareWith, rowToCompareWith: (_f = props.nominationEventToCompareWith) === null || _f === void 0 ? void 0 : _f.tolerance }),
            altFuelAmounts && (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(SummaryRow, { label: 'LBG (%)', currentValue: currentNomination.altFuelPercentage, previousValue: previousNomination === null || previousNomination === void 0 ? void 0 : previousNomination.altFuelPercentage, emptyValueMessage: '-', isInitialValue: isInitialValue }),
                React__default.createElement(SummaryRow, { label: "Quantity LNG " + getQuantityUnitLabel(currentNomination.quantityUnit), currentValue: altFuelAmounts.currentLngAmount, previousValue: altFuelAmounts.previouslngAmount, emptyValueMessage: '-', isInitialValue: isInitialValue }),
                React__default.createElement(SummaryRow, { label: "Quantity LBG " + getQuantityUnitLabel(currentNomination.quantityUnit), currentValue: altFuelAmounts.currentLbgAmount, previousValue: altFuelAmounts.previousLbgAmount, emptyValueMessage: '-', isInitialValue: isInitialValue }))),
            React__default.createElement(SummaryRow, { label: 'Delivery by', currentValue: currentNomination.deliveryMode, previousValue: previousNomination === null || previousNomination === void 0 ? void 0 : previousNomination.deliveryMode, emptyValueMessage: '-', isInitialValue: isInitialValue }),
            currentNomination.deliveryMode === 'SHIP' && (React__default.createElement(SummaryRow, { label: 'Bunker vessel', currentValue: (currentBunkerVessel === null || currentBunkerVessel === void 0 ? void 0 : currentBunkerVessel.name) || ((_g = currentNomination.attributes) === null || _g === void 0 ? void 0 : _g.bunkerShipName), previousValue: (previousBunkerVessel === null || previousBunkerVessel === void 0 ? void 0 : previousBunkerVessel.name) || ((_h = previousNomination === null || previousNomination === void 0 ? void 0 : previousNomination.attributes) === null || _h === void 0 ? void 0 : _h.bunkerShipName), emptyValueMessage: 'entered by supplier', isInitialValue: isInitialValue })),
            currentNomination.deliveryMode === 'PIPE' && (React__default.createElement(SummaryRow, { label: 'Pipeline', currentValue: (currentPipeline === null || currentPipeline === void 0 ? void 0 : currentPipeline.name) || ((_j = currentNomination.attributes) === null || _j === void 0 ? void 0 : _j.pipelineName), previousValue: (previousPipeline === null || previousPipeline === void 0 ? void 0 : previousPipeline.name) || ((_k = previousNomination === null || previousNomination === void 0 ? void 0 : previousNomination.attributes) === null || _k === void 0 ? void 0 : _k.pipelineName), emptyValueMessage: 'entered by supplier', isInitialValue: isInitialValue })),
            currentNomination.deliveryMode === 'TRUCK' && (React__default.createElement(SummaryRow, { label: 'Loading terminal', currentValue: (currenLoadingTerminal === null || currenLoadingTerminal === void 0 ? void 0 : currenLoadingTerminal.name) || ((_l = currentNomination.attributes) === null || _l === void 0 ? void 0 : _l.loadingTerminalName), previousValue: (previousLoadingTerminal === null || previousLoadingTerminal === void 0 ? void 0 : previousLoadingTerminal.name) || ((_m = previousNomination === null || previousNomination === void 0 ? void 0 : previousNomination.attributes) === null || _m === void 0 ? void 0 : _m.loadingTerminalName), emptyValueMessage: 'entered by supplier', isInitialValue: isInitialValue }))),
        React__default.createElement("section", { className: "summary-section" },
            React__default.createElement("h4", { className: "summary-section-title" }, "Communication"),
            React__default.createElement(SummaryRow, { label: 'Contacts', currentValue: props.currentThirdPartyContacts, previousValue: props.previousThirdPartyContacts, emptyValueMessage: '-', renderValue: function (value) { return prepareThirdPartyMarkup(value); }, isInitialValue: isInitialValue })),
        React__default.createElement("section", { className: "summary-section" },
            React__default.createElement("h4", { className: "summary-section-title" }, "Schedule"),
            React__default.createElement("h5", { className: "timezone-title" },
                "Timezone: ",
                timezone.text),
            React__default.createElement("div", { className: "section-content" },
                React__default.createElement("div", { className: "split-rows receiving-vessel-section " + (currentNomination.deliveryMode !== 'SHIP' ? 'single-schedule' : '') },
                    React__default.createElement("h5", { className: "summary-section-sub-title right-align" }, "Receiving vessel"),
                    React__default.createElement("div", { className: "rows" },
                        React__default.createElement(SummaryRow, { className: "rv-row", label: 'ETA', formatAsDate: true, currentValue: currentNomination.eta, previousValue: previousNomination === null || previousNomination === void 0 ? void 0 : previousNomination.eta, formatTimezone: timezone.value, emptyValueMessage: 'entered by customer', isInitialValue: isInitialValue }),
                        React__default.createElement(SummaryRow, { className: "rv-row", label: 'BST', formatAsDate: true, currentValue: currentNomination.bst, previousValue: previousNomination === null || previousNomination === void 0 ? void 0 : previousNomination.bst, formatTimezone: timezone.value, emptyValueMessage: '-', isInitialValue: isInitialValue, warning: validateNominationBST(currentNomination, props.currentUser.roles), shouldCompare: !!props.nominationEventToCompareWith, rowToCompareWith: (_o = props.nominationEventToCompareWith) === null || _o === void 0 ? void 0 : _o.bst }),
                        React__default.createElement(SummaryRow, { className: "rv-row", label: 'ETD', formatAsDate: true, currentValue: currentNomination.etd, previousValue: previousNomination === null || previousNomination === void 0 ? void 0 : previousNomination.etd, formatTimezone: timezone.value, emptyValueMessage: 'entered by customer', isInitialValue: isInitialValue }))),
                currentNomination.deliveryMode === 'SHIP' && (React__default.createElement("div", { className: "split-rows bunker-vessel-section" },
                    React__default.createElement("h5", { className: "summary-section-sub-title" }, "Bunker vessel"),
                    React__default.createElement("div", { className: "rows" },
                        React__default.createElement(SummaryRow, { label: 'ETA', formatAsDate: true, currentValue: currentNomination.bunkershipEta, previousValue: previousNomination === null || previousNomination === void 0 ? void 0 : previousNomination.bunkershipEta, formatTimezone: timezone.value, emptyValueMessage: 'entered by supplier', isInitialValue: isInitialValue }),
                        React__default.createElement(SummaryRow, { label: 'Allowed bunkering time', formatTimezone: timezone.value, currentValue: currentNomination.allowedBunkeringTime, previousValue: previousNomination === null || previousNomination === void 0 ? void 0 : previousNomination.allowedBunkeringTime, emptyValueMessage: 'entered by supplier', isInitialValue: isInitialValue }),
                        React__default.createElement(SummaryRow, { label: 'ETD', formatAsDate: true, formatTimezone: timezone.value, currentValue: currentNomination.bunkershipEtd, previousValue: previousNomination === null || previousNomination === void 0 ? void 0 : previousNomination.bunkershipEtd, emptyValueMessage: 'entered by supplier', isInitialValue: isInitialValue })))))),
        userCanEditContract(currentNomination, props.currentUser, false) && (React__default.createElement("section", { className: "summary-section" },
            React__default.createElement("h4", { className: "summary-section-title" }, "Contract"),
            props.showContractCheckIntegration && (React__default.createElement(SummaryRow, { label: 'Contract check', currentValue: currentContractCheck === null || currentContractCheck === void 0 ? void 0 : currentContractCheck.name, previousValue: previousContractCheck === null || previousContractCheck === void 0 ? void 0 : previousContractCheck.name, emptyValueMessage: '-', isInitialValue: isInitialValue })),
            React__default.createElement(SummaryRow, { label: 'Contract reference', currentValue: currentNomination.vendorReference, previousValue: previousNomination === null || previousNomination === void 0 ? void 0 : previousNomination.vendorReference, emptyValueMessage: '-', isInitialValue: isInitialValue }),
            !props.isDelegatedNomination && (React__default.createElement(SummaryRow, { label: 'Contract', currentValue: currentContract === null || currentContract === void 0 ? void 0 : currentContract.name, previousValue: previousContract === null || previousContract === void 0 ? void 0 : previousContract.name, emptyValueMessage: 'entered by supplier', isInitialValue: isInitialValue })),
            (isScheduler(props.currentUser.roles) || isCustomer(props.currentUser.roles)) && (currentNomination === null || currentNomination === void 0 ? void 0 : currentNomination.priceEnabled) && (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(SummaryRow, { label: 'Price', currentValue: formatPrice(currentNomination), previousValue: formatPrice(previousNomination), emptyValueMessage: 'entered by supplier', isInitialValue: isInitialValue }))),
            !isSchedulerCaptain(props.currentUser.roles) && (React__default.createElement(SummaryRow, { className: "summary-row__additional-terms", label: props.isDelegatedNomination ? 'Executing Supplier Terms' : 'Supplier Terms', currentValue: currentNomination.supplierTerms, previousValue: previousNomination === null || previousNomination === void 0 ? void 0 : previousNomination.supplierTerms, emptyValueMessage: '-', isInitialValue: isInitialValue, renderValue: function (value) { return React__default.createElement(ResizableBox, null, value); } })),
            !isSchedulerCaptain(props.currentUser.roles) && (React__default.createElement(SummaryRow, { className: "summary-row__additional-terms", label: props.isDelegatedNomination ? 'Contract-holding Supplier Terms' : 'Customer Terms', currentValue: currentNomination.buyerTerms, previousValue: previousNomination === null || previousNomination === void 0 ? void 0 : previousNomination.buyerTerms, renderValue: function (value) { return React__default.createElement(ResizableBox, null, value); }, emptyValueMessage: '-', isInitialValue: isInitialValue }))))));
    function getAltFuelNumbers(currentNomination, previousNomination) {
        var currentLbgAmount = 0;
        var currentLngAmount = 0;
        var previousLbgAmount = 0;
        var previouslngAmount = 0;
        var currentNominationLBGEnabled = currentNomination.altFuelPercentage && currentNomination.altFuelPercentage > 0;
        var previousNominationLBGEnabled = previousNomination &&
            previousNomination.altFuelPercentage &&
            previousNomination.altFuelPercentage > 0;
        if (!currentNominationLBGEnabled && !previousNominationLBGEnabled) {
            return;
        }
        if (currentNominationLBGEnabled) {
            currentLbgAmount = currentNomination.altFuelPercentage
                ? currentNomination.amount * (currentNomination.altFuelPercentage / 100)
                : 0;
            currentLngAmount = currentNomination.amount - currentLbgAmount;
        }
        if (previousNominationLBGEnabled && previousNomination) {
            previousLbgAmount = previousNomination.altFuelPercentage
                ? previousNomination.amount * (previousNomination.altFuelPercentage / 100)
                : 0;
            previouslngAmount = previousNomination.amount - previousLbgAmount;
        }
        return {
            currentLbgAmount: currentLbgAmount.toFixed(2),
            currentLngAmount: currentLngAmount.toFixed(2),
            previousLbgAmount: previousLbgAmount.toFixed(2),
            previouslngAmount: previouslngAmount.toFixed(2)
        };
    }
    function formatPrice(nomination) {
        var _a, _b;
        if (!nomination || !nomination.priceEnabled) {
            return null;
        }
        var price = nomination.price || '<price undefined>';
        var priceUnit = (nomination.priceUnit != null
            ? ((_a = PRICE_UNITS.find(function (item) { return item.value === nomination.priceUnit; })) === null || _a === void 0 ? void 0 : _a.text) ||
                nomination.priceUnit
            : undefined) || '<price unit undefined>';
        var energyUnit = (nomination.energyUnit != null
            ? ((_b = ENERGY_UNITS.find(function (item) { return item.value === nomination.energyUnit; })) === null || _b === void 0 ? void 0 : _b.text) ||
                nomination.energyUnit ||
                ''
            : undefined) || '<energy unit undefined>';
        return price + " " + priceUnit + " / " + energyUnit;
    }
    function prepareThirdPartyMarkup(contacts) {
        return contacts.length > 0 ? (React__default.createElement(React__default.Fragment, null, contacts
            .sort(function (a, b) { return (a.name > b.name ? 1 : -1); })
            .map(function (contact) { return (React__default.createElement(React__default.Fragment, null,
            React__default.createElement("span", null, contact.name + " <" + contact.email + ">"),
            React__default.createElement("br", null))); }))) : ('');
    }
};

var HistoryButton = /** @class */ (function (_super) {
    __extends(HistoryButton, _super);
    function HistoryButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HistoryButton.prototype.render = function () {
        var _a = this.props, selectedItemIndex = _a.selectedItemIndex, eventHistory = _a.eventHistory, seePreviousProposal = _a.seePreviousProposal, seeNextProposal = _a.seeNextProposal, editFormActive = _a.editFormActive, sandbox = _a.sandbox, latestItemIsSelected = _a.latestItemIsSelected;
        if (editFormActive) {
            return null;
        }
        var proposalsAmount = eventHistory ? eventHistory.length : 0;
        var buttonText = sandbox
            ? selectedItemIndex === 0
                ? 'Original'
                : 'Sandbox edit'
            : selectedItemIndex + 1 === proposalsAmount
                ? 'Latest Proposal'
                : 'Previous Proposal';
        var stepToShow = "(" + (editFormActive && latestItemIsSelected ? proposalsAmount : selectedItemIndex + 1) + " / " + proposalsAmount + ")";
        return (createElement(NavigationButton, { className: "proposal-history large", buttonText: buttonText + " " + stepToShow, disablePreviousButton: !eventHistory || selectedItemIndex === 0, disableNextButton: sandbox || !eventHistory || eventHistory.length === selectedItemIndex + 1, onClickNext: seeNextProposal, onClickPrevious: seePreviousProposal }));
    };
    return HistoryButton;
}(PureComponent));

/**
 * Check if any fields are different on one nomination then the other nomination
 * Return the keys that have a different value in both nominations
 */
function comparingNominationFields(initialNomination, comparingNomination) {
    if (!comparingNomination) {
        return [];
    }
    var allKeys = Object.keys(initialNomination);
    return allKeys.filter(function (key) {
        if (typeof initialNomination[key] === 'string' || typeof initialNomination[key] === 'number') {
            return initialNomination[key] !== comparingNomination[key];
        }
        return !isEqual(initialNomination[key], comparingNomination[key]);
    });
}

var ShipSearchSelectOption = function (props) {
    var _a;
    var companyId = props.onBehalfCompanyId || ((_a = props.currentUser) === null || _a === void 0 ? void 0 : _a.companyId);
    return (React__default.createElement(SelectOption, { label: props.ship.name },
        props.children,
        companyId &&
            props.ship.companyId !== companyId &&
            props.ship.charterers &&
            props.ship.charterers.some(function (it) { return props.currentUser && it.companyId === companyId && it.activeInFleet; }) && React__default.createElement(CharteredTag, null)));
};
var CharteredTag = function () {
    return React__default.createElement("span", { className: "select-chartered-tag" }, " Chartered");
};

var LocationSearch = function (_a) {
    var disabled = _a.disabled, error = _a.error, label = _a.label, fieldName = _a.fieldName, value = _a.value, prevValue = _a.prevValue, hideLocations = _a.hideLocations, locationService = _a.locationService, onChange = _a.onChange, comparingNominationIsDifferent = _a.comparingNominationIsDifferent;
    var _b = useState(value), searchValue = _b[0], setSearchValue = _b[1];
    var debouncedSearchValue = useDebounce(searchValue, SEARCH_DEBOUNCE_DELAY);
    useEffect(function () {
        setSearchValue(value);
    }, [value]);
    var _c = useFindLocation(debouncedSearchValue, locationService, SEARCH_MIN_LENGTH), locations = _c.locations, loadingLocations = _c.loading, loadingError = _c.error;
    var options = locations
        .filter(function (location) { return !location.deleted; })
        .filter(function (location) { return location.port && location.type.includes('GENERAL'); })
        .filter(function (bunkerLoc) {
        return hideLocations
            ? bunkerLoc._id === value || !hideLocations.find(function (locId) { return locId === bunkerLoc._id; })
            : true;
    });
    var previousValue = prevValue !== value ? options.find(function (x) { return x._id === prevValue; }) : undefined;
    var _d = useLocation(value, locationService), selectedLocation = _d.location, selectedError = _d.error;
    // adds the selectedLocation to the options so it can be shown in the selectbox
    var allOptions = selectedLocation
        ? options.concat([selectedLocation])
        : value
            ? options.concat([tempSelectedLocation(value, selectedError)])
            : options;
    var sortedOptions = sortBy$1(allOptions, [function (option) { return option.port; }, function (option) { return option.country; }]);
    var noOptionsMessage = loadingLocations
        ? 'Loading...'
        : loadingError
            ? loadingError.toString()
            : debouncedSearchValue.length < SEARCH_MIN_LENGTH
                ? 'Search for port name'
                : undefined;
    return (React__default.createElement(FormElement, { className: comparingNominationIsDifferent ? 'delegated-is-different' : '' },
        React__default.createElement(FormLabel, { fieldName: fieldName }, label || ''),
        React__default.createElement(FormFieldWrapper, null,
            React__default.createElement(SelectionBox, { fieldName: "shipImo", value: value, valueKey: "_id", displayKey: "text", sortOptions: true, disabled: disabled, renderFieldValue: formatPortCountry, onChangeValue: function (option) {
                    handleChange(option);
                }, onChangeText: handleInputChange, options: sortedOptions, filterOptions: false, noOptionsMessage: noOptionsMessage, showClearButton: true, renderOption: function (option) {
                    return React__default.createElement("div", null, formatPortCountry(option));
                } })),
        React__default.createElement("div", { className: "form-field-message" },
            React__default.createElement(FormLabel, { fieldName: fieldName }, previousValue ? formatPortCountry(previousValue) : undefined),
            React__default.createElement(FormErrorMessage, null, error))));
    function handleInputChange(inputValue) {
        setSearchValue(inputValue);
    }
    function handleChange(selectedOption) {
        if (onChange) {
            onChange((selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption._id) || null);
        }
    }
    function tempSelectedLocation(locationId, error) {
        return {
            _id: locationId,
            type: [],
            purpose: null,
            port: error ? '(Error loading location)' : '(Loading...)',
            country: undefined,
            terminal: null,
            deleted: false,
            timezone: ''
        };
    }
};
var LocationSearch$1 = React__default.memo(LocationSearch);

var DeliveryModeSelection = function (props) {
    var allDeliveryModes = ['SHIP', 'TRUCK', 'PIPE', 'CONTAINER'];
    return (React__default.createElement("div", { className: "delivery-mode-buttons" }, props.readOnly ? (props.selectedDeliveryModes) : (React__default.createElement(ButtonGroup, null, allDeliveryModes.map(function (mode) {
        var _a;
        var modeAvailable = (_a = props.availableDeliveryModes) === null || _a === void 0 ? void 0 : _a.includes(mode);
        return (React__default.createElement(Button$1, { key: mode, primary: isDeliveryModeActive(props.selectedDeliveryModes, mode), onClick: function () {
                if (!props.readOnly) {
                    toggleDeliveryMode(props.selectedDeliveryModes, mode);
                }
            }, outline: true, iconButton: true, preventDoubleClick: true, disabled: !modeAvailable },
            getDeliveryModeIcon(mode),
            mode.toLowerCase()));
    })))));
    function isDeliveryModeActive(selectedDeliveryModes, deliveryMode) {
        if (!selectedDeliveryModes) {
            return false;
        }
        if (Array.isArray(selectedDeliveryModes)) {
            return selectedDeliveryModes.includes(deliveryMode);
        }
        else {
            return selectedDeliveryModes === deliveryMode;
        }
    }
    function toggleDeliveryMode(selectedDeliveryModes, deliveryMode) {
        if (Array.isArray(selectedDeliveryModes)) {
            if (selectedDeliveryModes.includes(deliveryMode)) {
                props.changeDeliveryMode(selectedDeliveryModes.filter(function (mode) { return mode !== deliveryMode; }));
            }
            else {
                var updatedDeliverModes = __spreadArrays(selectedDeliveryModes);
                updatedDeliverModes.push(deliveryMode);
                props.changeDeliveryMode(updatedDeliverModes);
            }
        }
        else {
            props.changeDeliveryMode(deliveryMode);
        }
    }
};

var AddThirdPartyContactDialog = function (props) {
    var _a = useForm({
        initialValues: props.formValues,
        onValidSubmit: initiateQuantityCalculation,
        validate: validateQuantityInput
    }), handleSubmit = _a.handleSubmit, values = _a.values, onChangeValue = _a.onChangeValue, isDifferentFromInitial = _a.isDifferentFromInitial, errors = _a.errors;
    return (React__default.createElement(Dialog, { title: props.title, onCloseDialog: props.onCloseDialog, showDialog: props.showDialog, type: "medium", className: "dialog-box__add-contact" },
        React__default.createElement(FormWrapper, null,
            React__default.createElement(InlineFormElement, null,
                React__default.createElement(FormElement, null,
                    React__default.createElement(FormLabel, { fieldName: "name" }, "Contact person"),
                    React__default.createElement(TextField, { fieldName: "name", value: values === null || values === void 0 ? void 0 : values.name, onChange: function (e) {
                            onChangeValue(e.target.name, e.target.value);
                        } }),
                    React__default.createElement(FormErrorMessage, { errorMessage: errors === null || errors === void 0 ? void 0 : errors.name })),
                React__default.createElement(FormElement, null,
                    React__default.createElement(FormLabel, { fieldName: "email" }, "Email address"),
                    React__default.createElement(TextField, { fieldName: "email", type: "email", value: values === null || values === void 0 ? void 0 : values.email, onChange: function (e) {
                            onChangeValue(e.target.name, e.target.value);
                        } }),
                    React__default.createElement(FormErrorMessage, { errorMessage: errors === null || errors === void 0 ? void 0 : errors.email }))),
            React__default.createElement(InlineFormElement, null,
                React__default.createElement(FormElement, null,
                    React__default.createElement(FormLabel, { fieldName: "email" }, "Company name"),
                    React__default.createElement(TextField, { fieldName: "companyName", value: values === null || values === void 0 ? void 0 : values.companyName, onChange: function (e) {
                            onChangeValue(e.target.name, e.target.value);
                        } }),
                    React__default.createElement(FormErrorMessage, { errorMessage: errors === null || errors === void 0 ? void 0 : errors.companyName })),
                React__default.createElement(FormElement, null,
                    React__default.createElement(FormLabel, { fieldName: "role" }, "Company type"),
                    React__default.createElement(React__default.Fragment, null,
                        React__default.createElement(SelectionBox, { valueKey: "value", displayKey: "text", fieldName: 'role', placeholder: 'Select...', value: values === null || values === void 0 ? void 0 : values.role, onChangeValue: function (selectedItem) {
                                onChangeValue('role', (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value) || '');
                            }, options: props.allowedThirdPartyRoleOptions }),
                        React__default.createElement(FormErrorMessage, { errorMessage: errors === null || errors === void 0 ? void 0 : errors.role })))),
            React__default.createElement(InlineFormElement, null,
                React__default.createElement(Button$1, { preventDoubleClick: true, iconButton: true, className: "edit-button", disabled: !isDifferentFromInitial, onClick: handleSubmit, primary: true },
                    React__default.createElement(Icon, null,
                        React__default.createElement(FontAwesomeIcon, { icon: faUserPlus })),
                    ' ',
                    "Add person"),
                React__default.createElement(Button$1, { preventDoubleClick: true, onClick: function () { return props.callback(false); }, secondary: true }, "Cancel")))));
    function initiateQuantityCalculation(recordInput) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    props.saveThirdPartyContact(recordInput);
                    props.callback(false);
                }
                catch (error) {
                    console.error(error.message);
                }
                return [2 /*return*/];
            });
        });
    }
    function validateQuantityInput(recordInput) {
        var errors = {};
        if (recordInput.name === '') {
            errors.name = 'This field is required';
        }
        if (recordInput.companyName === '') {
            errors.companyName = 'This field is required';
        }
        if (recordInput.email === '') {
            errors.email = 'This field is required';
        }
        if (recordInput.role === '') {
            errors.role = 'This field is required';
        }
        return errors;
    }
};

var CustomerNominationForm = function (props) {
    var getPreviousValueLabel = props.getPreviousValueLabel, currentNomination = props.currentNomination, onChangeDateTimeValue = props.onChangeDateTimeValue, onChangeFormValue = props.onChangeFormValue, setMultipleValues = props.setMultipleValues, currentUser = props.currentUser, previousNomination = props.previousNomination, errors = props.errors, selectedVendor = props.selectedVendor, enableAlternativeFuelSelector = props.enableAlternativeFuelSelector, editingOnBehalf = props.editingOnBehalf, nominationEventToCompareWith = props.nominationEventToCompareWith, disabled = props.disabled;
    var appliedUserRoles = editingOnBehalf ? ['ROLE_CUSTOMER'] : currentUser.roles;
    var timezone = useLocationTimeZone(currentNomination.locationId, props.locationService);
    var fieldPermissions = getNominationNegotiationFieldPermissions(currentNomination, currentUser, appliedUserRoles, props.creatingNewNomination);
    var previousReceivingVessel = props.customerFleet.find(function (fleetShip) {
        return fleetShip._id ===
            getPreviousValueLabel('receivingShipId', currentNomination, previousNomination);
    });
    var supplierOffersAltFuels = !isEmpty$1(selectedVendor ? selectedVendor.altFuelTypes : []);
    var _a = useState(false), isActiveAddContactFormDialog = _a[0], setIsActiveAddContactFormDialog = _a[1];
    var allowedThirdPartyRoleOptions = getAllowedThirdPartyContactRoles(currentUser.roles);
    var _b = useState([]), thirdPartyOptions = _b[0], setThirdPartyOptions = _b[1];
    var _c = useState(), multiSelectItems = _c[0], setMultiSelectitems = _c[1];
    useEffect(function () {
        !!multiSelectItems &&
            props.onChangeFormValue('customerThirdPartyContactIds', __spreadArrays(Object.values(multiSelectItems).map(function (_) { return _.value; })));
    }, [multiSelectItems]);
    var _d = useState({
        _id: '',
        companyId: currentUser.companyId,
        companyName: '',
        email: '',
        name: '',
        role: ''
    }), newContactFormValues = _d[0], setNewContactFormValues = _d[1];
    useEffect(function () {
        setNewContactFormValues({
            _id: '',
            companyId: currentUser.companyId,
            companyName: '',
            email: '',
            name: '',
            role: ''
        });
    }, [isActiveAddContactFormDialog]);
    useEffect(function () {
        setThirdPartyOptions(props.thirdPartyContacts.map(function (contact) { return ({
            text: contact.name + ", " + contact.companyName + " <" + contact.email + ">",
            value: contact._id
        }); }));
    }, [props.thirdPartyContacts]);
    useEffect(function () {
        if (props.nominationContacts.length > 0) {
            setMultiSelectitems(props.nominationContacts.map(function (contact) { return ({
                text: contact.name + ", " + contact.companyName + " <" + contact.email + ">",
                value: contact._id
            }); }));
        }
    }, [props.nominationContacts]);
    var fieldsThatAreDifferent = comparingNominationFields(currentNomination, nominationEventToCompareWith);
    return (React__default.createElement("div", { className: 'prompt-form nomination-form customer-form' },
        editingOnBehalf && (React__default.createElement("div", { className: "onbehalf-warning" },
            "This function permits you to make changes to the buyer's (",
            props.customerCompanyName,
            ") nomination request. ",
            React__default.createElement("span", { className: "bold-underline" }, "It does not"),
            " create an agency relationship between you and your customer, and",
            ' ',
            React__default.createElement("span", { className: "bold-underline" }, "does not"),
            " bind your customer to these changes unless separately agreed by your customer.")),
        props.children,
        React__default.createElement("section", { className: "form-section" },
            React__default.createElement("div", { className: "form-header" },
                React__default.createElement("div", { className: "step-header" },
                    React__default.createElement("div", { className: "step-indicator" }, "1"),
                    React__default.createElement("h2", { className: "" }, "General information"))),
            editingOnBehalf && (React__default.createElement("section", { className: "summary-section" },
                React__default.createElement("div", { className: "section-content" },
                    React__default.createElement("div", { className: "single-row" },
                        React__default.createElement("div", { className: "rows" },
                            React__default.createElement(SummaryRow, { label: 'Buyer', hideNewIndicator: true, currentValue: "" + (props.customerCompanyName || ''), emptyValueMessage: '-', isInitialValue: false })))))),
            React__default.createElement(FormWrapper, null,
                props.creatingNewNomination && (React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(FormElement, null,
                        React__default.createElement(FormLabel, { fieldName: "receivingShipId" }, "Receiving vessel *"),
                        React__default.createElement(SelectionBox, { fieldName: 'receivingShipId', placeholder: 'Select Vessel...', value: !fieldPermissions.receivingVessel && !currentNomination.receivingShipId
                                ? '-'
                                : currentNomination.receivingShipId || '', valueKey: "_id", displayKey: "name", sortOptions: true, disabled: disabled || !fieldPermissions.receivingVessel, onChangeValue: function (option) {
                                onChangeFormValue('receivingShipId', (option === null || option === void 0 ? void 0 : option._id) || null);
                            }, options: props.customerFleet, renderOption: function (option) { return (React__default.createElement(ShipSearchSelectOption, { ship: option, currentUser: props.currentUser, onBehalfCompanyId: props.onBehalfCompanyId })); } }),
                        React__default.createElement("div", { className: "form-field-message" },
                            React__default.createElement(FormLabel, { fieldName: "receivingShipId" }, previousReceivingVessel ? previousReceivingVessel.name : undefined),
                            React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'receivingShipId') : undefined }))),
                    !props.editingOnBehalf && (React__default.createElement(FormElement, null,
                        React__default.createElement(FormLabel, { fieldName: "vendorCompanyId" }, "Supplier *"),
                        React__default.createElement(SelectionBox, { fieldName: 'vendorCompanyId', placeholder: 'Select Supplier...', value: !fieldPermissions.vendorCompanyId && !currentNomination.vendorCompanyId
                                ? '-'
                                : currentNomination.vendorCompanyId
                                    ? currentNomination.vendorCompanyId
                                    : '', options: props.vendorCompanies
                                .map(function (company) { return ({
                                value: company._id,
                                text: company.name
                            }); })
                                .sort(function (a, b) { return a.text.localeCompare(b.text); }), disabled: disabled || !fieldPermissions.vendorCompanyId, valueKey: "value", displayKey: "text", renderFieldValue: function (selectedItem) {
                                return "" + selectedItem.text;
                            }, onChangeValue: function (selectedItem) {
                                setMultipleValues([
                                    { field: 'vendorCompanyId', value: (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value) || null },
                                    { field: 'deliveryMode', value: '' }
                                ]);
                            }, renderOption: function (option) {
                                return (React__default.createElement("div", null,
                                    React__default.createElement("span", null, option.text)));
                            } }),
                        React__default.createElement("div", { className: "form-field-message" },
                            React__default.createElement(FormLabel, { fieldName: "vendorCompanyId" }, getPreviousValueLabel('vendorCompanyId', currentNomination, previousNomination)),
                            React__default.createElement(FormErrorMessage, { errorMessage: errors === null || errors === void 0 ? void 0 : errors.vendorCompanyId })))))),
                React__default.createElement(LocationSearch$1, { locationService: props.locationService, onChange: function (value) {
                        props.onChangeFormValue('locationId', value);
                    }, label: "Delivery point *", placeholder: 'Select Port...', disabled: disabled || !fieldPermissions.location, fieldName: "locationId", error: errors ? get(errors, 'locationId') : undefined, value: !fieldPermissions.location && !currentNomination.locationId
                        ? ''
                        : currentNomination.locationId || '', prevValue: previousNomination ? previousNomination.locationId : undefined, comparingNominationIsDifferent: fieldsThatAreDifferent.includes('locationId') }),
                React__default.createElement(FormElement, { className: fieldsThatAreDifferent.includes('location') ? 'delegated-is-different' : '' },
                    React__default.createElement(FormLabel, { fieldName: "location" }, "Location"),
                    React__default.createElement(TextField, { fieldName: "location", disabled: disabled || !fieldPermissions.location, placeholder: 'Detailed description, e.g. berth, terminal, anchorage etc.', value: !fieldPermissions.location && !currentNomination.location
                            ? '-'
                            : currentNomination.location
                                ? currentNomination.location
                                : '', onChange: function (event) {
                            props.onChangeFormValue('location', event.target.value);
                        } }),
                    React__default.createElement("div", { className: "form-field-message" },
                        React__default.createElement(FormLabel, { fieldName: "prevlocation", strikeThrough: true }, getPreviousValueLabel('location', currentNomination, previousNomination)),
                        React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'location') : undefined }))),
                React__default.createElement(FormElement, null,
                    React__default.createElement(FormLabel, { fieldName: "co2TaxEnabled" },
                        "Excise fee/",
                        React__default.createElement("br", null),
                        "CO2 fee applicable"),
                    React__default.createElement(Checkbox, { disabled: disabled || !fieldPermissions.co2Tax, field: 'co2TaxEnabled', value: currentNomination.co2TaxEnabled || false, className: "co2TaxEnabled", onChange: function () { return onChangeFormValue('co2TaxEnabled', !currentNomination.co2TaxEnabled); } })),
                currentNomination.co2TaxEnabled && (React__default.createElement(FormElement, null,
                    React__default.createElement(FormLabel, { fieldName: "nextDestination" }, "Next destination"),
                    React__default.createElement(TextField, { fieldName: "nextDestination", disabled: disabled || !fieldPermissions.agent, value: !fieldPermissions.agent && !currentNomination.nextDestination
                            ? '-'
                            : currentNomination.nextDestination
                                ? currentNomination.nextDestination
                                : '', onChange: function (event) {
                            props.onChangeFormValue('nextDestination', event.target.value);
                        } }),
                    React__default.createElement("div", { className: "form-field-message" },
                        React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'nextDestination') : undefined })))),
                React__default.createElement(FormElement, null,
                    React__default.createElement(FormLabel, { fieldName: "agent" }, "Agent"),
                    React__default.createElement(TextField, { fieldName: "agent", disabled: disabled || !fieldPermissions.agent, value: !fieldPermissions.agent && !currentNomination.agent
                            ? '-'
                            : currentNomination.agent
                                ? currentNomination.agent
                                : '', onChange: function (event) {
                            onChangeFormValue('agent', event.target.value);
                        } }),
                    React__default.createElement("div", { className: "form-field-message" },
                        React__default.createElement(FormLabel, { fieldName: "prevAgent", strikeThrough: true }, getPreviousValueLabel('agent', currentNomination, previousNomination)),
                        React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'agent') : undefined }))),
                React__default.createElement(FormElement, null,
                    React__default.createElement(FormLabel, { fieldName: "buyerRef" }, "Buyer reference"),
                    React__default.createElement(TextField, { fieldName: "buyerRef", disabled: disabled || !fieldPermissions.buyerRef, placeholder: 'E.g. PO no. or similar', value: !fieldPermissions.buyerRef && !currentNomination.buyerRef
                            ? '-'
                            : currentNomination.buyerRef
                                ? currentNomination.buyerRef
                                : '', onChange: function (event) {
                            onChangeFormValue('buyerRef', event.target.value);
                        } }),
                    React__default.createElement("div", { className: "form-field-message" },
                        React__default.createElement(FormLabel, { fieldName: "prevBuyer", strikeThrough: true }, getPreviousValueLabel('buyerRef', currentNomination, previousNomination)),
                        React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'buyerRef') : undefined }))))),
        React__default.createElement("section", { className: "form-section" },
            React__default.createElement("div", { className: "form-header" },
                React__default.createElement("div", { className: "step-header" },
                    React__default.createElement("div", { className: "step-indicator" }, "2"),
                    React__default.createElement("h2", { className: "" }, "Quantity and delivery"))),
            React__default.createElement(FormWrapper, null,
                React__default.createElement(FormElement, { className: fieldsThatAreDifferent.includes('amount') ? 'delegated-is-different' : '' },
                    React__default.createElement(FormLabel, { fieldName: "amount" }, "Total quantity *"),
                    React__default.createElement("div", { className: "flex amount-and-quantityUnit-container" },
                        React__default.createElement(FormFieldWrapper, null,
                            React__default.createElement(NumberInput, { name: 'amount', maxDecimals: 3, value: !fieldPermissions.amount && !currentNomination.amount
                                    ? '-'
                                    : currentNomination.amount
                                        ? currentNomination.amount
                                        : '', disabled: disabled || !fieldPermissions.amount, onChangeFormValue: onChangeFormValue })),
                        React__default.createElement(SelectionBox, { fieldName: 'quantityUnit', placeholder: 'Select quantity', value: currentNomination === null || currentNomination === void 0 ? void 0 : currentNomination.quantityUnit, renderFieldValue: function (selectedItem) {
                                return "" + selectedItem.text;
                            }, valueKey: "value", displayKey: "text", disabled: disabled || !fieldPermissions.quantityUnit, onChangeValue: function (unit) {
                                onChangeFormValue('quantityUnit', unit === null || unit === void 0 ? void 0 : unit.value);
                            }, options: QUANTITY_UNITS, renderOption: function (option) { return React__default.createElement(SelectOption, { label: option.text }); } })),
                    React__default.createElement("div", { className: "form-field-message" },
                        React__default.createElement(FormLabel, { fieldName: "prevAmount", strikeThrough: true }, getPreviousValueLabel('amount', currentNomination, previousNomination)),
                        React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'amount') : undefined }))),
                React__default.createElement(FormElement, { className: fieldsThatAreDifferent.includes('tolerance') ? 'delegated-is-different' : '' },
                    React__default.createElement(FormLabel, { fieldName: "tolerance" },
                        "Tolerance ",
                        React__default.createElement("div", { className: "label-unit" }, "(%)")),
                    React__default.createElement(NumberInput, { name: 'tolerance', maxDecimals: 3, disabled: disabled || !fieldPermissions.tolerance, value: !fieldPermissions.tolerance && !(currentNomination === null || currentNomination === void 0 ? void 0 : currentNomination.tolerance)
                            ? '-'
                            : (currentNomination === null || currentNomination === void 0 ? void 0 : currentNomination.tolerance) ? currentNomination.tolerance
                                : '', onChangeFormValue: props.onChangeFormValue }),
                    React__default.createElement("div", { className: "form-field-message" },
                        React__default.createElement(FormLabel, { fieldName: "prevTolerance", strikeThrough: true }, getPreviousValueLabel('tolerance', currentNomination, previousNomination)),
                        React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'tolerance') : undefined }))),
                props.showDeliveryModeSelection && (React__default.createElement(FormElement, null,
                    React__default.createElement(FormLabel, { fieldName: "deliveryMode" }, "Delivery by *"),
                    React__default.createElement(DeliveryModeSelection, { fieldName: "deliveryMode", availableDeliveryModes: selectedVendor === null || selectedVendor === void 0 ? void 0 : selectedVendor.deliveryModes, selectedDeliveryModes: currentNomination.deliveryMode, readOnly: disabled || !fieldPermissions.deliveryMode, changeDeliveryMode: function (deliveryMode) {
                            if (props.onChangeFormValue) {
                                props.onChangeFormValue('deliveryMode', deliveryMode);
                            }
                        } }),
                    React__default.createElement("div", { className: "form-field-message" },
                        React__default.createElement(FormLabel, { fieldName: "prevDeliveryMode", strikeThrough: true }, getPreviousValueLabel('deliveryMode', currentNomination, previousNomination)),
                        React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'deliveryMode') : undefined })))),
                supplierOffersAltFuels && enableAlternativeFuelSelector && (React__default.createElement(AlternativeFuelSelector, { totalAmount: currentNomination.amount, quantityUnit: currentNomination === null || currentNomination === void 0 ? void 0 : currentNomination.quantityUnit, onChangeFormValue: props.onChangeFormValue, percentage: currentNomination.altFuelPercentage, readOnly: disabled || !fieldPermissions.altFuelPercentage, type: 'SLIDER', previousPercentage: getPreviousValueLabel('altFuelPercentage', currentNomination, previousNomination) })))),
        React__default.createElement("section", { className: "form-section form-section__third-party-communication" },
            React__default.createElement("div", { className: "form-header" },
                React__default.createElement("div", { className: "step-header" },
                    React__default.createElement("div", { className: "step-indicator" }, "3"),
                    React__default.createElement("h2", null, "Communication"))),
            React__default.createElement("h5", { className: "third_party-title" }, "Third party contacts added here will receive notifications about updates to this nomination"),
            React__default.createElement(FormWrapper, null,
                React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(FormElement, null,
                        React__default.createElement(FormLabel, { fieldName: "customerThirdPartyContactIds" }, "Third party contacts"),
                        React__default.createElement(MultiSelectionBox, { disabled: disabled, fieldName: "customerThirdPartyContactIds", values: multiSelectItems, placeholder: 'Ports, agents, etc.', valueKey: "value", searchKey: "text", searchKeys: ['text', 'value'], sortOptions: true, showClearButton: !disabled, renderFieldValue: function (selectedItem, removeItem) {
                                return (React__default.createElement(MultiSelectOption, { optionText: selectedItem.text, removeItem: function () {
                                        removeItem(selectedItem);
                                    } }));
                            }, onChangeValue: function (selectedItems) {
                                setMultiSelectitems(selectedItems);
                            }, options: thirdPartyOptions, renderOption: function (option) {
                                return (React__default.createElement("div", null,
                                    React__default.createElement("div", null, option.text)));
                            } })),
                    React__default.createElement(FormElement, { className: "justify-center" },
                        React__default.createElement(Button$1, { disabled: disabled, preventDoubleClick: true, primary: true, onClick: function (e) {
                                setIsActiveAddContactFormDialog(true);
                            } },
                            "Add a ",
                            React__default.createElement("strong", null, "new"),
                            " contact to the list")))),
            isActiveAddContactFormDialog && (React__default.createElement(AddThirdPartyContactDialog, { onCloseDialog: function () { return setIsActiveAddContactFormDialog(false); }, showDialog: isActiveAddContactFormDialog, title: "Add contact person", formValues: newContactFormValues, allowedThirdPartyRoleOptions: allowedThirdPartyRoleOptions, onInputChange: setNewContactFormValues, saveThirdPartyContact: props.saveThirdPartyContact, callback: setIsActiveAddContactFormDialog }))),
        React__default.createElement("section", { className: "form-section" },
            React__default.createElement("div", { className: "form-header" },
                React__default.createElement("div", { className: "step-header" },
                    React__default.createElement("div", { className: "step-indicator" }, "4"),
                    React__default.createElement("h2", { className: "" }, "Schedule"))),
            React__default.createElement("h5", { className: "timezone-title" },
                "Timezone: ",
                timezone.text),
            !props.creatingNewNomination && currentNomination.deliveryMode === 'SHIP' && (React__default.createElement("section", { className: "summary-section" },
                React__default.createElement("div", { className: "section-content" },
                    React__default.createElement("div", { className: "single-row" },
                        React__default.createElement("h5", { className: "summary-section-sub-title" }, "Bunker Vessel"),
                        React__default.createElement("div", { className: "rows" },
                            React__default.createElement(SummaryRow, { className: "rv-row", label: 'ETA', formatAsDate: true, formatTimezone: timezone.value, currentValue: currentNomination === null || currentNomination === void 0 ? void 0 : currentNomination.bunkershipEta, hideNewIndicator: true, emptyValueMessage: 'entered by supplier', isInitialValue: false }),
                            React__default.createElement(SummaryRow, { className: "rv-row", label: 'Allowed bunkering time (hours)', currentValue: currentNomination === null || currentNomination === void 0 ? void 0 : currentNomination.allowedBunkeringTime, hideNewIndicator: true, emptyValueMessage: 'entered by supplier', isInitialValue: false }),
                            React__default.createElement(SummaryRow, { formatAsDate: true, formatTimezone: timezone.value, className: "rv-row", label: 'ETD', currentValue: currentNomination === null || currentNomination === void 0 ? void 0 : currentNomination.bunkershipEtd, hideNewIndicator: true, emptyValueMessage: 'entered by supplier', isInitialValue: false })))))),
            React__default.createElement(FormWrapper, null,
                React__default.createElement("h5", { className: "summary-section-sub-title center-align" }, "Receiving vessel"),
                React__default.createElement("div", null,
                    React__default.createElement("div", { className: "times-field-wrapper" },
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: 'eta' }, "ETA *"),
                            React__default.createElement(FormFieldWrapper, null,
                                React__default.createElement(DateTimePicker, { key: (currentNomination === null || currentNomination === void 0 ? void 0 : currentNomination._id) + " eta", name: 'eta', onDateTimeChange: onChangeDateTimeValue, disabled: disabled || !fieldPermissions.eta, icon: React__default.createElement("i", { className: "icon-calendar-1" }), placeholder: "dd/mm/yyyy hh:mm", value: !fieldPermissions.eta && !currentNomination.eta
                                        ? '-'
                                        : currentNomination.eta || '', timeZone: timezone.value, hideDialogHeader: true, useInitialStart: 'hour' })),
                            React__default.createElement("div", { className: "form-field-message" },
                                React__default.createElement(FormLabel, { fieldName: "prevEta", strikeThrough: true }, formatDateTime(getPreviousValueLabel('eta', currentNomination, previousNomination), timezone.value)),
                                React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'eta') : undefined })))),
                    React__default.createElement("div", { className: "times-field-wrapper" },
                        React__default.createElement(FormElement, { className: fieldsThatAreDifferent.includes('bst') ? 'delegated-is-different' : '' },
                            React__default.createElement(FormLabel, { fieldName: 'bst' }, "Bunkering Start Time (BST) *"),
                            React__default.createElement(FormFieldWrapper, null,
                                React__default.createElement(DateTimePicker, { key: (currentNomination === null || currentNomination === void 0 ? void 0 : currentNomination._id) + " bst", name: 'bst', onDateTimeChange: onChangeDateTimeValue, disabled: disabled || !fieldPermissions.bst, icon: React__default.createElement("i", { className: "icon-calendar-1" }), placeholder: "dd/mm/yyyy hh:mm", value: !fieldPermissions.bst && !currentNomination.bst
                                        ? '-'
                                        : currentNomination.bst || '', timeZone: timezone.value, hideDialogHeader: true, useInitialStart: 'hour' })),
                            React__default.createElement("div", { className: "form-field-message" },
                                React__default.createElement(FormLabel, { fieldName: "prevBst", strikeThrough: true }, formatDateTime(getPreviousValueLabel('bst', currentNomination, previousNomination), timezone.value)),
                                React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'bst') : undefined }),
                                React__default.createElement(ValidationWarning, { warning: validateNominationBST(currentNomination, props.currentUser.roles), className: "form-field-error-message warning" })))),
                    React__default.createElement("div", { className: "times-field-wrapper" },
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: 'etd' }, "ETD *"),
                            React__default.createElement(FormFieldWrapper, null,
                                React__default.createElement(DateTimePicker, { key: (currentNomination === null || currentNomination === void 0 ? void 0 : currentNomination._id) + " etd", name: 'etd', onDateTimeChange: onChangeDateTimeValue, disabled: disabled || !fieldPermissions.etd, icon: React__default.createElement("i", { className: "icon-calendar-1" }), placeholder: "dd/mm/yyyy hh:mm", value: !fieldPermissions.etd && !currentNomination.etd
                                        ? '-'
                                        : currentNomination.etd || '', timeZone: timezone.value, hideDialogHeader: true, useInitialStart: 'hour' })),
                            React__default.createElement("div", { className: "form-field-message" },
                                React__default.createElement(FormLabel, { fieldName: "prevEtd", strikeThrough: true }, formatDateTime(getPreviousValueLabel('etd', currentNomination, previousNomination), timezone.value)),
                                React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'etd') : undefined }))))))),
        userCanEditContract(currentNomination, props.currentUser, props.creatingNewNomination) && (React__default.createElement("section", { className: "form-section" },
            React__default.createElement("div", { className: "form-header" },
                React__default.createElement("div", { className: "step-header" },
                    React__default.createElement("div", { className: "step-indicator" }, "5"),
                    React__default.createElement("h2", { className: "" }, "Contract"))),
            React__default.createElement(FormWrapper, null,
                isCustomer(appliedUserRoles) && currentNomination.priceEnabled && (React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(FormElement, null,
                        React__default.createElement(FormLabel, { fieldName: "price" }, "Price"),
                        React__default.createElement(FormFieldWrapper, null,
                            React__default.createElement(TextField, { fieldName: "price", disabled: disabled || !fieldPermissions.price, value: currentNomination.price || '', onChange: function (event) {
                                    props.onChangeFormValue('price', event.target.value);
                                } })),
                        React__default.createElement("div", { className: "form-field-message" },
                            React__default.createElement(FormLabel, { strikeThrough: true, fieldName: "prevPrice" }, getPreviousValueLabel('price', currentNomination, previousNomination)),
                            React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'price') : undefined }))),
                    React__default.createElement(FormElement, null,
                        React__default.createElement(FormLabel, null, "Unit"),
                        React__default.createElement("div", { className: "form-field-wrapper" },
                            React__default.createElement(SelectionBox, { disableSearch: true, fieldName: "priceUnit", value: currentNomination.priceUnit, valueKey: "value", displayKey: "text", disabled: disabled || !fieldPermissions.priceUnit, className: "price-unit-selection-box", renderFieldValue: function (selectedItem) {
                                    return "" + selectedItem.text;
                                }, onChangeValue: function (selectedItem) {
                                    props.onChangeFormValue('priceUnit', selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value);
                                }, options: PRICE_UNITS, renderOption: function (option) {
                                    return (React__default.createElement("div", null,
                                        React__default.createElement("span", null, option.text)));
                                } }),
                            React__default.createElement(SelectionBox, { disableSearch: true, fieldName: "energyUnit", value: currentNomination.energyUnit, valueKey: "value", displayKey: "text", disabled: disabled || !fieldPermissions.energyUnit, renderFieldValue: function (selectedItem) {
                                    return "" + selectedItem.text;
                                }, onChangeValue: function (selectedItem) {
                                    props.onChangeFormValue('energyUnit', selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value);
                                }, options: ENERGY_UNITS, renderOption: function (option) {
                                    return (React__default.createElement("div", null,
                                        React__default.createElement("span", null, option.text)));
                                } })),
                        React__default.createElement("div", { className: "form-field-message" },
                            React__default.createElement(FormLabel, { fieldName: "prevPriceUnit", strikeThrough: true }, getPreviousValueLabel('priceUnit', currentNomination, previousNomination)),
                            React__default.createElement(FormLabel, { fieldName: "prevEnergyUnit", strikeThrough: true }, getPreviousValueLabel('energyUnit', currentNomination, previousNomination)),
                            React__default.createElement(FormErrorMessage, { errorMessage: get(errors, 'energyUnit') }),
                            React__default.createElement(FormErrorMessage, { errorMessage: get(errors, 'priceUnit') }))))),
                React__default.createElement(FormElement, null,
                    React__default.createElement(FormLabel, { fieldName: "buyerTerms" }, "Customer's additional terms"),
                    React__default.createElement(TextArea, { disabled: disabled, fieldName: "buyerTerms", placeholder: 'E.g. legal requirements or similar', value: currentNomination.buyerTerms || '', onChange: function (e) {
                            return props.onChangeFormValue(e.target.name, e.target.value);
                        } })))))));
};

var SupplierNominationForm = function (props) {
    var _a, _b, _c, _d;
    var getPreviousValueLabel = props.getPreviousValueLabel, currentNomination = props.currentNomination, onChangeDateTimeValue = props.onChangeDateTimeValue, currentUser = props.currentUser, previousNomination = props.previousNomination, errors = props.errors, selectedVendor = props.selectedVendor, contracts = props.contracts, enableAlternativeFuelSelector = props.enableAlternativeFuelSelector, nominationEventToCompareWith = props.nominationEventToCompareWith, isDelegatedNomination = props.isDelegatedNomination, disabled = props.disabled;
    var _e = useState(false), isActiveAddContactFormDialog = _e[0], setIsActiveAddContactFormDialog = _e[1];
    var _f = useState([]), thirdPartyOptions = _f[0], setThirdPartyOptions = _f[1];
    var _g = useState(), multiSelectItems = _g[0], setMultiSelectitems = _g[1];
    useEffect(function () {
        !!multiSelectItems &&
            props.onChangeFormValue('vendorThirdPartyContactIds', __spreadArrays(Object.values(multiSelectItems).map(function (_) { return _.value; })));
    }, [multiSelectItems]);
    var _h = useState({
        _id: '',
        companyId: currentUser.companyId,
        companyName: '',
        email: '',
        name: '',
        role: ''
    }), newContactFormValues = _h[0], setNewContactFormValues = _h[1];
    useEffect(function () {
        setThirdPartyOptions(props.thirdPartyContacts.map(function (contact) { return ({
            text: contact.name + " <" + contact.email + ">",
            value: contact._id
        }); }));
    }, [props.thirdPartyContacts]);
    useEffect(function () {
        if (props.nominationContacts.length > 0) {
            setMultiSelectitems(props.nominationContacts.map(function (contact) { return ({
                text: contact.name + " <" + contact.email + ">",
                value: contact._id
            }); }));
        }
    }, [props.nominationContacts]);
    var timezone = useLocationTimeZone(currentNomination.locationId, props.locationService);
    var fieldPermissions = getNominationNegotiationFieldPermissions(currentNomination, currentUser, currentUser.roles, false);
    var previousBunkerShip = props.bunkerShips.find(function (bunkerShip) {
        return bunkerShip._id ===
            getPreviousValueLabel('bunkerShipId', currentNomination, previousNomination);
    });
    var previousPipeline = props.pipelines.find(function (pipe) { return pipe._id === getPreviousValueLabel('pipelineId', currentNomination, previousNomination); });
    var previousLoadingTerminalName = props.pipelines.find(function (pipe) {
        return pipe._id === getPreviousValueLabel('loadingTerminalId', currentNomination, previousNomination);
    });
    var previousContract = props.contracts.find(function (contract) {
        return contract._id === getPreviousValueLabel('contractId', currentNomination, previousNomination);
    });
    var supplierOffersAltFuels = !isEmpty$1(selectedVendor ? selectedVendor.altFuelTypes : []);
    var allowedThirdPartyRoleOptions = getAllowedThirdPartyContactRoles(currentUser.roles);
    function togglePriceEnabled() {
        if (currentNomination.priceEnabled) {
            props.setAllValues(__assign(__assign({}, currentNomination), { priceEnabled: false, price: undefined, priceUnit: undefined, energyUnit: undefined }));
        }
        else {
            props.onChangeFormValue('priceEnabled', true);
        }
    }
    function toggleAddContactDialog(isDialogActive) {
        setNewContactFormValues({
            _id: '',
            companyId: currentUser.companyId,
            companyName: '',
            email: '',
            name: '',
            role: ''
        });
        setIsActiveAddContactFormDialog(isDialogActive);
    }
    var isContractHolder = currentUser.companyId === currentNomination.companyId;
    var counterCompanyName = (!isContractHolder && props.isDelegatedNomination === true) ||
        (props.isDelegatedNomination === false && isScheduler(props.currentUser.roles))
        ? currentNomination.companyId
            ? getCompanyDetails(props.companies, currentNomination.companyId).companyName
            : '-'
        : currentNomination.vendorCompanyId
            ? getCompanyDetails(props.companies, currentNomination.vendorCompanyId).companyName
            : '-';
    var contactIdFieldName = props.isDelegatedNomination && isContractHolder
        ? 'customerThirdPartyContactIds'
        : 'vendorThirdPartyContactIds';
    var contractTermsFieldName = props.isDelegatedNomination && isContractHolder ? 'buyerTerms' : 'supplierTerms';
    var fieldsThatAreDifferent = comparingNominationFields(currentNomination, nominationEventToCompareWith);
    return (React__default.createElement("div", { className: 'prompt-form nomination-form supplier-form' },
        props.children,
        React__default.createElement("section", { className: "form-section" },
            React__default.createElement("div", { className: "form-header" },
                React__default.createElement("div", { className: "step-header" },
                    React__default.createElement("div", { className: "step-indicator" }, "1"),
                    React__default.createElement("h2", { className: "" }, "General information"))),
            React__default.createElement("section", { className: "summary-section" },
                React__default.createElement("div", { className: "section-content" },
                    React__default.createElement("div", { className: "single-row" },
                        React__default.createElement("div", { className: "rows" },
                            React__default.createElement(SummaryRow, { label: props.isDelegatedNomination === true
                                    ? isContractHolder
                                        ? 'Executing supplier'
                                        : 'Contract-holding supplier'
                                    : isScheduler(props.currentUser.roles)
                                        ? 'Buyer'
                                        : 'Supplier', hideNewIndicator: true, currentValue: counterCompanyName, emptyValueMessage: '-', isInitialValue: false }))))),
            React__default.createElement(FormWrapper, null,
                React__default.createElement(FormElement, { style: { display: 'flex' } },
                    React__default.createElement(LocationSearch$1, { locationService: props.locationService, onChange: function (value) {
                            props.onChangeFormValue('locationId', value);
                        }, label: "Delivery point *", placeholder: 'Select Port...', disabled: disabled || !fieldPermissions.location, fieldName: "locationId", error: errors ? get(errors, 'locationId') : undefined, value: !fieldPermissions.location && !currentNomination.locationId
                            ? ''
                            : currentNomination.locationId || '', prevValue: previousNomination ? previousNomination.locationId : undefined, comparingNominationIsDifferent: fieldsThatAreDifferent.includes('locationId') })),
                React__default.createElement(FormElement, { className: fieldsThatAreDifferent.includes('location') ? 'delegated-is-different' : '' },
                    React__default.createElement(FormLabel, { fieldName: "location" }, "Location"),
                    React__default.createElement(TextField, { fieldName: "location", disabled: disabled || !fieldPermissions.location, placeholder: 'Detailed description, e.g. berth, terminal, anchorage etc.', value: !fieldPermissions.location && !currentNomination.location
                            ? '-'
                            : currentNomination.location
                                ? currentNomination.location
                                : '', onChange: function (event) {
                            props.onChangeFormValue('location', event.target.value);
                        } }),
                    React__default.createElement("div", { className: "form-field-message" },
                        React__default.createElement(FormLabel, { fieldName: "prevlocation", strikeThrough: true }, getPreviousValueLabel('location', currentNomination, previousNomination)),
                        React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'location') : undefined }))),
                React__default.createElement(FormElement, null,
                    React__default.createElement(FormLabel, { fieldName: "agent" }, "Agent"),
                    React__default.createElement(TextField, { fieldName: "agent", disabled: disabled || !fieldPermissions.agent, value: !fieldPermissions.agent && !currentNomination.agent
                            ? '-'
                            : currentNomination.agent
                                ? currentNomination.agent
                                : '', onChange: function (event) {
                            props.onChangeFormValue('agent', event.target.value);
                        } }),
                    React__default.createElement("div", { className: "form-field-message" },
                        React__default.createElement(FormLabel, { fieldName: "prevAgent", strikeThrough: true }, getPreviousValueLabel('agent', currentNomination, previousNomination)),
                        React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'agent') : undefined }))),
                isDelegatedNomination && isContractHolder && (React__default.createElement(FormElement, null,
                    React__default.createElement(FormLabel, { fieldName: "buyerRef" }, "Contract-holding reference"),
                    React__default.createElement(TextField, { fieldName: "buyerRef", disabled: disabled || !fieldPermissions.buyerRef, placeholder: 'E.g. PO no. or similar', value: !fieldPermissions.buyerRef && !currentNomination.buyerRef
                            ? '-'
                            : currentNomination.buyerRef
                                ? currentNomination.buyerRef
                                : '', onChange: function (event) {
                            props.onChangeFormValue('buyerRef', event.target.value);
                        } }),
                    React__default.createElement("div", { className: "form-field-message" },
                        React__default.createElement(FormLabel, { fieldName: "prevBuyer", strikeThrough: true }, getPreviousValueLabel('buyerRef', currentNomination, previousNomination)),
                        React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'buyerRef') : undefined })))))),
        React__default.createElement("section", { className: "form-section" },
            React__default.createElement("div", { className: "form-header" },
                React__default.createElement("div", { className: "step-header" },
                    React__default.createElement("div", { className: "step-indicator" }, "2"),
                    React__default.createElement("h2", { className: "" }, "Quantity & delivery"))),
            React__default.createElement(FormWrapper, null,
                React__default.createElement(FormElement, { className: fieldsThatAreDifferent.includes('amount') ? 'delegated-is-different' : '' },
                    React__default.createElement(FormLabel, { fieldName: "amount" }, "Total quantity *"),
                    React__default.createElement("div", { className: "flex amount-and-quantityUnit-container" },
                        React__default.createElement(FormFieldWrapper, null,
                            React__default.createElement(NumberInput, { name: 'amount', maxDecimals: 3, value: !fieldPermissions.amount && !currentNomination.amount
                                    ? '-'
                                    : currentNomination.amount
                                        ? currentNomination.amount
                                        : '', disabled: disabled || !fieldPermissions.amount, onChangeFormValue: props.onChangeFormValue })),
                        React__default.createElement(SelectionBox, { fieldName: 'quantityUnit', placeholder: 'Select quantity', value: currentNomination === null || currentNomination === void 0 ? void 0 : currentNomination.quantityUnit, renderFieldValue: function (selectedItem) {
                                return "" + selectedItem.text;
                            }, valueKey: "value", displayKey: "text", disabled: disabled || !fieldPermissions.quantityUnit, onChangeValue: function (unit) {
                                props.onChangeFormValue('quantityUnit', unit === null || unit === void 0 ? void 0 : unit.value);
                            }, options: QUANTITY_UNITS, renderOption: function (option) { return React__default.createElement(SelectOption, { label: option.text }); } })),
                    React__default.createElement("div", { className: "form-field-message" },
                        React__default.createElement(FormLabel, { fieldName: "prevAmount", strikeThrough: true }, getPreviousValueLabel('amount', currentNomination, previousNomination)),
                        React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'amount') : undefined }))),
                React__default.createElement(FormElement, { className: fieldsThatAreDifferent.includes('tolerance') ? 'delegated-is-different' : '' },
                    React__default.createElement(FormLabel, { fieldName: "tolerance" },
                        "Tolerance",
                        React__default.createElement("div", { className: "label-unit" }, "(%)")),
                    React__default.createElement(NumberInput, { key: (currentNomination === null || currentNomination === void 0 ? void 0 : currentNomination._id) + "_tolerance", name: 'tolerance', maxDecimals: 3, value: !fieldPermissions.tolerance && !(currentNomination === null || currentNomination === void 0 ? void 0 : currentNomination.tolerance)
                            ? '-'
                            : (currentNomination === null || currentNomination === void 0 ? void 0 : currentNomination.tolerance) ? currentNomination.tolerance
                                : '', disabled: disabled || !fieldPermissions.tolerance, onChangeFormValue: props.onChangeFormValue }),
                    React__default.createElement("div", { className: "form-field-message" },
                        React__default.createElement(FormLabel, { fieldName: "prevTolerance", strikeThrough: true }, getPreviousValueLabel('tolerance', currentNomination, previousNomination)),
                        React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'tolerance') : undefined }))),
                supplierOffersAltFuels && enableAlternativeFuelSelector && (React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(AlternativeFuelSelector, { totalAmount: currentNomination.amount, quantityUnit: currentNomination.quantityUnit, onChangeFormValue: props.onChangeFormValue, percentage: currentNomination.altFuelPercentage, previousPercentage: getPreviousValueLabel('altFuelPercentage', currentNomination, previousNomination), readOnly: disabled || !fieldPermissions.altFuelPercentage, type: 'FORMFIELDS' }))),
                props.showDeliveryModeSelection && (React__default.createElement(FormElement, null,
                    React__default.createElement(FormLabel, { fieldName: "deliveryMode" }, "Delivery by *"),
                    React__default.createElement(DeliveryModeSelection, { fieldName: "deliveryMode", availableDeliveryModes: selectedVendor === null || selectedVendor === void 0 ? void 0 : selectedVendor.deliveryModes, selectedDeliveryModes: currentNomination.deliveryMode, readOnly: disabled || !fieldPermissions.deliveryMode, changeDeliveryMode: function (deliveryMode) {
                            if (props.onChangeFormValue) {
                                props.onChangeFormValue('deliveryMode', deliveryMode);
                            }
                        } }),
                    React__default.createElement("div", { className: "form-field-message" },
                        React__default.createElement(FormLabel, { fieldName: "prevDeliveryMode", strikeThrough: true }, getPreviousValueLabel('deliveryMode', currentNomination, previousNomination)),
                        React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'deliveryMode') : undefined })))),
                currentNomination.deliveryMode === 'SHIP' && (React__default.createElement(FormElement, null,
                    React__default.createElement(FormLabel, { fieldName: "bunkerShipId" }, "Bunker vessel"),
                    React__default.createElement(SelectionBox, { fieldName: 'bunkerShipId', value: !fieldPermissions.bunkerShip && !currentNomination.bunkerShipId
                            ? '-'
                            : currentNomination.bunkerShipId || '', valueKey: "_id", displayKey: "name", sortOptions: true, disabled: disabled || !fieldPermissions.bunkerShip, onChangeValue: function (option) {
                            props.onChangeFormValue('bunkerShipId', (option === null || option === void 0 ? void 0 : option._id) || null);
                        }, options: props.bunkerShips.concat(
                        // Add the attribute bunkerShipName, in case the bunker ship is not in the options
                        // Only for read only, cause it should not be selectable
                        (disabled || !fieldPermissions.bunkerShip) &&
                            currentNomination.bunkerShipId && ((_a = currentNomination.attributes) === null || _a === void 0 ? void 0 : _a.bunkerShipName)
                            ? [
                                {
                                    _id: currentNomination.bunkerShipId,
                                    imoNumber: '',
                                    name: currentNomination.attributes.bunkerShipName,
                                    companyId: currentNomination.supplierId || null
                                }
                            ]
                            : []), renderOption: function (option) { return (React__default.createElement(ShipSearchSelectOption, { ship: option, currentUser: currentUser })); } }),
                    React__default.createElement("div", { className: "form-field-message" },
                        React__default.createElement(FormLabel, { fieldName: "bunkerShipId" }, (previousBunkerShip ? previousBunkerShip.name : undefined) || ((_b = previousNomination === null || previousNomination === void 0 ? void 0 : previousNomination.attributes) === null || _b === void 0 ? void 0 : _b.bunkerShipName)),
                        React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'bunkerShipId') : undefined })))),
                currentNomination.deliveryMode === 'PIPE' && (React__default.createElement(FormElement, null,
                    React__default.createElement(FormLabel, { fieldName: "pipelineId" }, "Pipeline"),
                    React__default.createElement(SelectionBox, { fieldName: 'pipelineId', value: !fieldPermissions.bunkerShip && !currentNomination.pipelineId
                            ? '-'
                            : currentNomination.pipelineId || '', valueKey: "_id", displayKey: "name", sortOptions: true, disabled: disabled || !fieldPermissions.bunkerShip, onChangeValue: function (option) {
                            props.onChangeFormValue('pipelineId', (option === null || option === void 0 ? void 0 : option._id) || null);
                        }, options: props.pipelines.concat(
                        // Add the attribute pipelineName, in case pipeline is not in the options
                        // Only for read only, cause it should not be selectable
                        (disabled || !fieldPermissions.bunkerShip) &&
                            currentNomination.pipelineId && ((_c = currentNomination.attributes) === null || _c === void 0 ? void 0 : _c.pipelineName)
                            ? [
                                getEmptyPipeline(currentNomination.pipelineId, currentNomination.attributes.pipelineName)
                            ]
                            : []), renderOption: function (option) { return React__default.createElement(SelectOption, { label: option.name }); } }),
                    React__default.createElement("div", { className: "form-field-message" },
                        React__default.createElement(FormLabel, { fieldName: "pipelineId" }, previousPipeline ? previousPipeline.name : undefined),
                        React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'pipelineId') : undefined })))),
                currentNomination.deliveryMode === 'TRUCK' && (React__default.createElement(FormElement, null,
                    React__default.createElement(FormLabel, { fieldName: "loadingTerminalId" }, "Loading terminal"),
                    React__default.createElement(SelectionBox, { fieldName: 'loadingTerminalId', value: !fieldPermissions.bunkerShip && !currentNomination.loadingTerminalId
                            ? '-'
                            : currentNomination.loadingTerminalId || '', valueKey: "_id", displayKey: "name", sortOptions: true, disabled: disabled || !fieldPermissions.bunkerShip, onChangeValue: function (option) {
                            props.onChangeFormValue('loadingTerminalId', (option === null || option === void 0 ? void 0 : option._id) || null);
                        }, options: props.pipelines.concat(
                        // Add the attribute pipelineName, in case pipeline is not in the options
                        // Only for read only, cause it should not be selectable
                        (disabled || !fieldPermissions.bunkerShip) &&
                            currentNomination.loadingTerminalId && ((_d = currentNomination.attributes) === null || _d === void 0 ? void 0 : _d.loadingTerminalName)
                            ? [
                                getEmptyPipeline(currentNomination.loadingTerminalId, currentNomination.attributes.loadingTerminalName)
                            ]
                            : []), renderOption: function (option) { return React__default.createElement(SelectOption, { label: option.name }); } }),
                    React__default.createElement("div", { className: "form-field-message" },
                        React__default.createElement(FormLabel, { fieldName: "loadingTerminalId" }, previousLoadingTerminalName ? previousLoadingTerminalName.name : undefined),
                        React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'loadingTerminalId') : undefined })))))),
        React__default.createElement("section", { className: "form-section form-section__third-party-communication" },
            React__default.createElement("div", { className: "form-header" },
                React__default.createElement("div", { className: "step-header" },
                    React__default.createElement("div", { className: "step-indicator" }, "3"),
                    React__default.createElement("h2", null, "Communication"))),
            React__default.createElement("h5", { className: "third_party-title" }, "Third party contacts added here will receive notifications about updates to this nomination"),
            React__default.createElement(FormWrapper, null,
                React__default.createElement(FormElement, null,
                    React__default.createElement(FormLabel, { fieldName: contactIdFieldName }, "Ports, Agents, etc."),
                    React__default.createElement(MultiSelectionBox, { fieldName: contactIdFieldName, values: multiSelectItems, placeholder: 'Ports, agents, etc.', valueKey: "value", searchKey: "text", searchKeys: ['text', 'value'], sortOptions: true, showClearButton: true, renderFieldValue: function (selectedItem, removeItem) {
                            return (React__default.createElement(MultiSelectOption, { optionText: selectedItem.text, removeItem: function () {
                                    removeItem(selectedItem);
                                } }));
                        }, onChangeValue: function (selectedItems) {
                            setMultiSelectitems(selectedItems);
                        }, options: thirdPartyOptions, renderOption: function (option) {
                            return (React__default.createElement("div", null,
                                React__default.createElement("div", null, option.text)));
                        }, disabled: disabled })),
                React__default.createElement(FormElement, { className: "justify-center" },
                    React__default.createElement(Button$1, { disabled: disabled, preventDoubleClick: true, primary: true, onClick: function (e) {
                            setIsActiveAddContactFormDialog(true);
                        } },
                        "Add a ",
                        React__default.createElement("strong", null, "new"),
                        " contact to the list"))),
            isActiveAddContactFormDialog && (React__default.createElement(AddThirdPartyContactDialog, { onCloseDialog: function () { return toggleAddContactDialog(false); }, showDialog: isActiveAddContactFormDialog, title: "Add contact person", formValues: newContactFormValues, allowedThirdPartyRoleOptions: allowedThirdPartyRoleOptions, onInputChange: setNewContactFormValues, saveThirdPartyContact: props.saveThirdPartyContact, callback: toggleAddContactDialog }))),
        React__default.createElement("section", { className: "form-section" },
            React__default.createElement("div", { className: "form-header" },
                React__default.createElement("div", { className: "step-header" },
                    React__default.createElement("div", { className: "step-indicator" }, "4"),
                    React__default.createElement("h2", { className: "" }, "Schedule"))),
            React__default.createElement("h5", { className: "timezone-title" },
                "Timezone: ",
                timezone.text),
            React__default.createElement("section", { className: "summary-section" },
                React__default.createElement("div", { className: "section-content" },
                    React__default.createElement("div", { className: "single-row" },
                        React__default.createElement("h5", { className: "summary-section-sub-title" }, "Receiving vessel"),
                        React__default.createElement("div", { className: "rows" },
                            React__default.createElement(SummaryRow, { className: "rv-row", label: 'ETA', formatAsDate: true, currentValue: currentNomination === null || currentNomination === void 0 ? void 0 : currentNomination.eta, formatTimezone: timezone.value, hideNewIndicator: true, emptyValueMessage: 'entered by customer', isInitialValue: false }),
                            React__default.createElement(SummaryRow, { className: "rv-row", label: 'ETD', formatAsDate: true, currentValue: currentNomination === null || currentNomination === void 0 ? void 0 : currentNomination.etd, formatTimezone: timezone.value, hideNewIndicator: true, emptyValueMessage: 'entered by customer', isInitialValue: false }))))),
            React__default.createElement(FormWrapper, null,
                React__default.createElement("h5", { className: "summary-section-sub-title center-align" }, "Bunker asset"),
                currentNomination.deliveryMode === 'SHIP' && (React__default.createElement(FormElement, null,
                    React__default.createElement(FormLabel, { fieldName: "bunkershipEta" }, "ETA"),
                    React__default.createElement(FormFieldWrapper, null,
                        React__default.createElement(DateTimePicker, { key: (currentNomination === null || currentNomination === void 0 ? void 0 : currentNomination._id) + " bunkershipEta", name: 'bunkershipEta', onDateTimeChange: onChangeDateTimeValue, disabled: disabled || !fieldPermissions.bunkershipEta, icon: React__default.createElement("i", { className: "icon-calendar-1" }), placeholder: "dd/mm/yyyy hh:mm", value: !fieldPermissions.bunkershipEta && !currentNomination.bunkershipEta
                                ? '-'
                                : currentNomination.bunkershipEta || '', timeZone: timezone.value, hideDialogHeader: true, useInitialStart: 'hour' })),
                    React__default.createElement("div", { className: "form-field-message" },
                        React__default.createElement(FormLabel, { fieldName: "prevbunkershipEta", strikeThrough: true }, formatDateTime(getPreviousValueLabel('bunkershipEta', currentNomination, previousNomination), timezone.value)),
                        React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'bunkershipEta') : undefined })))),
                React__default.createElement(FormElement, { className: fieldsThatAreDifferent.includes('bst') ? 'delegated-is-different' : '' },
                    React__default.createElement(FormLabel, { fieldName: 'bst' }, "Bunkering Start Time (BST) *"),
                    React__default.createElement(FormFieldWrapper, null,
                        React__default.createElement(DateTimePicker, { key: (currentNomination === null || currentNomination === void 0 ? void 0 : currentNomination._id) + " bst", name: 'bst', onDateTimeChange: onChangeDateTimeValue, disabled: disabled || !fieldPermissions.bst, icon: React__default.createElement("i", { className: "icon-calendar-1" }), placeholder: "dd/mm/yyyy hh:mm", value: !fieldPermissions.bst && !currentNomination.bst
                                ? '-'
                                : currentNomination.bst || '', timeZone: timezone.value, hideDialogHeader: true, useInitialStart: 'hour' })),
                    React__default.createElement("div", { className: "form-field-message" },
                        React__default.createElement(FormLabel, { fieldName: "prevBst", strikeThrough: true }, formatDateTime(getPreviousValueLabel('bst', currentNomination, previousNomination), timezone.value)),
                        React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'bst') : undefined }),
                        React__default.createElement(ValidationWarning, { warning: validateNominationBST(currentNomination, props.currentUser.roles), className: "form-field-error-message warning" }))),
                React__default.createElement(FormElement, null,
                    React__default.createElement(FormLabel, { fieldName: "allowedBunkeringTime" }, "Allowed bunkering time (hours) *"),
                    React__default.createElement(FormFieldWrapper, null,
                        React__default.createElement("div", { className: "label-unit in-form-field" }, "(hours)"),
                        React__default.createElement(NumberInput, { key: (currentNomination === null || currentNomination === void 0 ? void 0 : currentNomination._id) + " allowedBunkeringTime", name: 'allowedBunkeringTime', maxDecimals: 3, value: !fieldPermissions.allowedBunkeringTime && !(currentNomination === null || currentNomination === void 0 ? void 0 : currentNomination.allowedBunkeringTime)
                                ? '-'
                                : (currentNomination === null || currentNomination === void 0 ? void 0 : currentNomination.allowedBunkeringTime) ? currentNomination.allowedBunkeringTime
                                    : '', disabled: disabled || !fieldPermissions.allowedBunkeringTime, onChangeFormValue: props.onChangeFormValue })),
                    React__default.createElement("div", { className: "form-field-message" },
                        React__default.createElement(FormLabel, { fieldName: "prevAllowedBunkeringTime", strikeThrough: true }, getPreviousValueLabel('allowedBunkeringTime', currentNomination, previousNomination)),
                        React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'allowedBunkeringTime') : undefined }))),
                currentNomination.deliveryMode === 'SHIP' && (React__default.createElement(FormElement, null,
                    React__default.createElement(FormLabel, { fieldName: 'bunkershipEtd' }, "ETD"),
                    React__default.createElement(FormFieldWrapper, null,
                        React__default.createElement(DateTimePicker, { key: (currentNomination === null || currentNomination === void 0 ? void 0 : currentNomination._id) + " bunkershipEtd", name: 'bunkershipEtd', onDateTimeChange: onChangeDateTimeValue, disabled: disabled || !fieldPermissions.bunkershipEtd, icon: React__default.createElement("i", { className: "icon-calendar-1" }), placeholder: "dd/mm/yyyy hh:mm", value: !fieldPermissions.bunkershipEtd && !currentNomination.bunkershipEtd
                                ? '-'
                                : currentNomination.bunkershipEtd || '', timeZone: timezone.value, hideDialogHeader: true, useInitialStart: 'hour' })),
                    React__default.createElement("div", { className: "form-field-message" },
                        React__default.createElement(FormLabel, { fieldName: "prevbunkershipEtd", strikeThrough: true }, formatDateTime(getPreviousValueLabel('bunkershipEtd', currentNomination, previousNomination), timezone.value)),
                        React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'bunkershipEtd') : undefined })))))),
        userCanEditContract(currentNomination, props.currentUser, props.creatingNewNomination) && (React__default.createElement("section", { className: "form-section" },
            React__default.createElement("div", { className: "form-header" },
                React__default.createElement("div", { className: "step-header" },
                    React__default.createElement("div", { className: "step-indicator" }, "5"),
                    React__default.createElement("h2", { className: "" }, "Contract"))),
            React__default.createElement(FormWrapper, null,
                React__default.createElement(FormElement, null,
                    React__default.createElement(FormLabel, { fieldName: "vendorReference" }, "Contract reference *"),
                    React__default.createElement(TextField, { fieldName: "vendorReference", disabled: disabled || !fieldPermissions.vendorReference, placeholder: 'E.g. customer no., voyage no. or similar', value: !fieldPermissions.vendorReference && !currentNomination.vendorReference
                            ? '-'
                            : currentNomination.vendorReference
                                ? currentNomination.vendorReference
                                : '', onChange: function (event) {
                            props.onChangeFormValue('vendorReference', event.target.value);
                        } }),
                    React__default.createElement("div", { className: "form-field-message" },
                        React__default.createElement(FormLabel, { fieldName: "prevVendorReference", strikeThrough: true }, getPreviousValueLabel('vendorReference', currentNomination, previousNomination)),
                        React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'vendorReference') : undefined }))),
                isDelegatedNomination === false && (React__default.createElement(FormElement, null,
                    React__default.createElement(FormLabel, { fieldName: "contractId" }, "Contract *"),
                    React__default.createElement(SelectionBox, { fieldName: 'contractId', className: "hodor", value: !fieldPermissions.contractId && !currentNomination.contractId
                            ? '-'
                            : currentNomination.contractId || '', options: contracts.map(function (contract) { return ({
                            value: contract._id,
                            text: contract.name,
                            reference: contract.contractReference || null
                        }); }), disabled: disabled || !fieldPermissions.contractId, valueKey: "value", displayKey: "text", renderFieldValue: function (selectedItem) {
                            return "" + selectedItem.text;
                        }, onChangeValue: function (selectedItem) {
                            props.setMultipleValues([
                                { field: 'contractId', value: (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value) || null },
                                { field: 'vendorReference', value: (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.reference) || null }
                            ]);
                        }, renderOption: function (option) {
                            return (React__default.createElement("div", null,
                                React__default.createElement("span", null, option.text)));
                        } }),
                    React__default.createElement("div", { className: "form-field-message" },
                        React__default.createElement(FormLabel, { fieldName: "prevContractId", strikeThrough: true }, previousContract === null || previousContract === void 0 ? void 0 : previousContract.name),
                        React__default.createElement(FormErrorMessage, { errorMessage: errors === null || errors === void 0 ? void 0 : errors.contractId })))),
                !isSchedulerCaptain(props.currentUser.roles) && (React__default.createElement(FormElement, null,
                    React__default.createElement(FormLabel, { fieldName: "priceEnabled" },
                        "Specify price ",
                        React__default.createElement("br", null),
                        React__default.createElement("span", { className: "sub-label" }, "(Will show on the order confirmation)")),
                    React__default.createElement(Checkbox, { field: 'priceEnabled', value: currentNomination.priceEnabled || false, disabled: disabled || !fieldPermissions.priceEnabled, className: "price-checkbox", onChange: togglePriceEnabled }))),
                currentNomination.priceEnabled && !isSchedulerCaptain(props.currentUser.roles) && (React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(FormElement, null,
                        React__default.createElement(FormLabel, { fieldName: "price" }, "Price"),
                        React__default.createElement(FormFieldWrapper, null,
                            React__default.createElement(TextField, { fieldName: "price", disabled: disabled || !fieldPermissions.price, value: currentNomination.price || '', onChange: function (event) {
                                    props.onChangeFormValue('price', event.target.value);
                                } })),
                        React__default.createElement("div", { className: "form-field-message" },
                            React__default.createElement(FormLabel, { strikeThrough: true, fieldName: "prevPrice" }, getPreviousValueLabel('price', currentNomination, previousNomination)),
                            React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'price') : undefined }))),
                    React__default.createElement(FormElement, null,
                        React__default.createElement(FormLabel, null, "Unit"),
                        React__default.createElement("div", { className: "form-field-wrapper" },
                            React__default.createElement(SelectionBox, { disableSearch: true, fieldName: "priceUnit", value: currentNomination.priceUnit, valueKey: "value", displayKey: "text", disabled: disabled || !fieldPermissions.priceUnit, className: "price-unit-selection-box", renderFieldValue: function (selectedItem) {
                                    return "" + selectedItem.text;
                                }, onChangeValue: function (selectedItem) {
                                    props.onChangeFormValue('priceUnit', selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value);
                                }, options: PRICE_UNITS, renderOption: function (option) {
                                    return (React__default.createElement("div", null,
                                        React__default.createElement("span", null, option.text)));
                                } }),
                            React__default.createElement(SelectionBox, { disableSearch: true, fieldName: "energyUnit", value: currentNomination.energyUnit, valueKey: "value", displayKey: "text", disabled: disabled || !fieldPermissions.energyUnit, renderFieldValue: function (selectedItem) {
                                    return "" + selectedItem.text;
                                }, onChangeValue: function (selectedItem) {
                                    props.onChangeFormValue('energyUnit', selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value);
                                }, options: ENERGY_UNITS, renderOption: function (option) {
                                    return (React__default.createElement("div", null,
                                        React__default.createElement("span", null, option.text)));
                                } })),
                        React__default.createElement("div", { className: "form-field-message" },
                            React__default.createElement(FormLabel, { fieldName: "prevPriceUnit", strikeThrough: true }, getPreviousValueLabel('priceUnit', currentNomination, previousNomination)),
                            React__default.createElement(FormLabel, { fieldName: "prevEnergyUnit", strikeThrough: true }, getPreviousValueLabel('energyUnit', currentNomination, previousNomination)),
                            React__default.createElement(FormErrorMessage, { errorMessage: get(errors, 'energyUnit') }),
                            React__default.createElement(FormErrorMessage, { errorMessage: get(errors, 'priceUnit') }))))),
                !isSchedulerCaptain(props.currentUser.roles) && (React__default.createElement(FormElement, null,
                    React__default.createElement(FormLabel, { fieldName: contractTermsFieldName },
                        isDelegatedNomination
                            ? contractTermsFieldName === 'buyerTerms'
                                ? "Contract-holding supplier's"
                                : "Executing supplier's"
                            : "Supplier's",
                        React__default.createElement("br", null),
                        " Additional terms"),
                    React__default.createElement(TextArea, { disabled: disabled, fieldName: contractTermsFieldName, placeholder: 'E.g. legal requirements or similar. These will appear on the order confirmation', value: currentNomination[contractTermsFieldName] || '', onChange: function (e) {
                            return props.onChangeFormValue(e.target.name, e.target.value);
                        } }))))))));
};
function getEmptyPipeline(_id, name) {
    return {
        _id: _id,
        name: name,
        companyId: '',
        order: 1,
        active: true,
        deleted: false,
        lngComposition: null,
        lngProperties: null
    };
}

var PromptNominationForm = function (props) {
    var roles = useContextualRole(props.currentUser, undefined, undefined).roles;
    var currentUser = __assign(__assign({}, props.currentUser), { roles: roles });
    // Hooks
    var _a = useState(props.values), currentNomination = _a[0], setCurrentNomination = _a[1];
    var _b = useState([]), companyContacts = _b[0], setCompanyContacts = _b[1];
    var _c = useThirdPartyContactService(props.authenticationService, props.currentUser.companyId, props.currentUser.roles), allowedContacts = _c.allowedContacts, saveThirdPartyContact = _c.saveThirdPartyContact;
    useEffect(function () {
        setCompanyContacts(allowedContacts);
        setNominationContacts(getNominationContacts(allowedContacts, props.editType === 'EDIT_ON_BEHALF'));
    }, [allowedContacts]);
    useEffect(function () {
        setCurrentNomination(props.values);
    }, [props.values]);
    useEffect(function () {
        var timeout = setTimeout(function () {
            var _a;
            (_a = document.getElementsByClassName("form-field-error-message")[0]) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        }, 100);
        return function () { return clearTimeout(timeout); };
    }, []);
    // Get filtered 3rd party contacts according to the company type (Supplier | Customer)
    var _d = useState([]), nominationContacts = _d[0], setNominationContacts = _d[1];
    // Properties
    var errors = props.errors, editType = props.editType, disabled = props.disabled;
    var previousNomination = props.prevValues;
    var userRoles = currentUser.roles;
    var vendorCompanies = props.companies.filter(function (company) { return company.companyType === 'VENDOR'; });
    var selectedVendor = currentNomination.vendorCompanyId
        ? props.companies.find(function (company) { return company._id === currentNomination.vendorCompanyId; })
        : props.creatingNominationOnBehalf // if onbehalf company is set, we use our company to determine the available delivery mode
            ? props.companies.find(function (company) { return company._id === props.currentUser.companyId; })
            : undefined;
    // filters the contracts to make sure it's only contracts associated with the nomination company
    var companyContracts = props.contractsList.filter(props.creatingNominationOnBehalf || props.editType === 'EDIT_ON_BEHALF'
        ? function (contract) {
            return contract.companyId === props.onBehalfCompany &&
                contract.vendorCompanyId === props.currentUser.companyId;
        }
        : function (contract) {
            return contract.companyId === currentNomination.companyId &&
                contract.vendorCompanyId === currentNomination.vendorCompanyId;
        });
    // filter the vendor companies so only the companies with whom you have a contract appear.
    var vendorCompaniesFilteredByContract = vendorCompanies === null || vendorCompanies === void 0 ? void 0 : vendorCompanies.filter(function (company) {
        return props.vendorsWithContract.has(company._id);
    });
    // sort the companies alphabetically to look more pleasing in the selectbox
    var vendorCompaniesSorted = (vendorCompaniesFilteredByContract || []).sort(function (a, b) {
        return sortAlphabetically$1(a, b, 'name');
    });
    return (React__default.createElement(React__default.Fragment, null,
        (isScheduler(userRoles) || isBunkerCaptain(userRoles)) && editType === 'EDIT' && (React__default.createElement(SupplierNominationForm, { bunkerShips: props.bunkerShips, contracts: companyContracts, currentNomination: currentNomination, creatingNewNomination: props.creatingNewNomination, currentUser: currentUser, getPreviousValueLabel: getPreviousValueLabel, locationService: props.locationService, onChangeDateTimeValue: onChangeDateTimeValue, onChangeFormValue: props.onChangeFormValue, setAllValues: props.setAllValues, setMultipleValues: setMultipleValues, pipelines: props.pipelines, showDeliveryModeSelection: props.showDeliveryModeSelection, errors: errors, previousNomination: previousNomination, selectedVendor: selectedVendor, enableAlternativeFuelSelector: props.enableAlternativeFuelSelector, customerCompanyName: props.customerCompanyName, thirdPartyContacts: companyContacts, nominationContacts: nominationContacts, saveThirdPartyContact: saveThirdPartyContact, nominationEventToCompareWith: props.nominationEventToCompareWith, disabled: disabled, isDelegatedNomination: props.isDelegatedNomination, companies: props.companies }, props.children)),
        (isCustomer(userRoles) ||
            isReceivingCaptain(userRoles) ||
            ((isScheduler(userRoles) || isSchedulerCaptain(userRoles)) &&
                editType === 'EDIT_ON_BEHALF')) && (React__default.createElement(CustomerNominationForm, { editingOnBehalf: (isScheduler(userRoles) || isSchedulerCaptain(userRoles)) &&
                editType === 'EDIT_ON_BEHALF', creatingNewNomination: props.creatingNewNomination, currentNomination: currentNomination, currentUser: currentUser, getPreviousValueLabel: getPreviousValueLabel, locationService: props.locationService, onChangeDateTimeValue: onChangeDateTimeValue, onChangeFormValue: props.onChangeFormValue, showDeliveryModeSelection: props.showDeliveryModeSelection, errors: errors, previousNomination: previousNomination, selectedVendor: selectedVendor, customerFleet: props.customerFleet, setMultipleValues: setMultipleValues, vendorCompanies: vendorCompaniesSorted, enableAlternativeFuelSelector: props.enableAlternativeFuelSelector, customerCompanyName: props.customerCompanyName, thirdPartyContacts: companyContacts, nominationContacts: nominationContacts, saveThirdPartyContact: saveThirdPartyContact, nominationEventToCompareWith: props.nominationEventToCompareWith, onBehalfCompanyId: props.onBehalfCompany, disabled: disabled }, props.children))));
    function getPreviousValueLabel(field, nominationValues, prevNominationValues) {
        if (nominationValues && prevNominationValues) {
            if (nominationValues[field] !== prevNominationValues[field]) {
                return prevNominationValues[field];
            }
        }
        return undefined;
    }
    function onChangeDateTimeValue(isoDate, inputValue, isValid, fieldName) {
        if (fieldName && props.onChangeFormValue) {
            var valueToUpdate = isoDate || inputValue;
            props.onChangeFormValue(fieldName, valueToUpdate);
        }
    }
    function setMultipleValues(fieldsToUpdate) {
        return __awaiter(this, void 0, void 0, function () {
            var newValues;
            return __generator(this, function (_a) {
                newValues = cloneDeep(currentNomination);
                fieldsToUpdate.forEach(function (fieldUpdate) {
                    newValues[fieldUpdate.field] = fieldUpdate.value;
                });
                if (props.setAllValues) {
                    props.setAllValues(newValues);
                }
                setCurrentNomination(newValues);
                return [2 /*return*/];
            });
        });
    }
    function getNominationContacts(allowedCompanyContacts, onBehalf) {
        var contactType = isSupplier(props.currentUser.roles)
            ? 'vendorThirdPartyContactIds'
            : 'customerThirdPartyContactIds';
        if (onBehalf) {
            return props.currentThirdPartyContacts.filter(function (contact) { var _a; return (_a = currentNomination.customerThirdPartyContactIds) === null || _a === void 0 ? void 0 : _a.find(function (contactId) { return contact._id === contactId; }); });
        }
        return allowedCompanyContacts.filter(function (contact) { var _a; return (_a = currentNomination[contactType]) === null || _a === void 0 ? void 0 : _a.find(function (contactId) { return contact._id === contactId; }); });
    }
};
function sortAlphabetically$1(a, b, propertyToSort) {
    if (a[propertyToSort] < b[propertyToSort]) {
        return -1;
    }
    if (a[propertyToSort] > b[propertyToSort]) {
        return 1;
    }
    return 0;
}

var LAST_SUBMIT_ACTION;
(function (LAST_SUBMIT_ACTION) {
    LAST_SUBMIT_ACTION[LAST_SUBMIT_ACTION["SUBMIT"] = 0] = "SUBMIT";
    LAST_SUBMIT_ACTION[LAST_SUBMIT_ACTION["SUBMIT_AND_APPROVE"] = 1] = "SUBMIT_AND_APPROVE";
})(LAST_SUBMIT_ACTION || (LAST_SUBMIT_ACTION = {}));
var NominationNegotiation = function (props) {
    var _a, _b;
    var initialNomination = props.initialNomination, nominationSelection = props.nominationSelection, delegationState = props.delegationState, nominationType = props.nominationType, cancelDelegatedNomination = props.cancelDelegatedNomination;
    var selectedNomination = nominationSelection.selectedHistoricNomination
        ? nominationSelection.selectedHistoricNomination
        : initialNomination;
    var customerFleetCompanyId = (selectedNomination === null || selectedNomination === void 0 ? void 0 : selectedNomination.companyId) ? selectedNomination.companyId
        : props.userProfile.companyId;
    var customerFleet = useFleetService(customerFleetCompanyId, props.authenticationService).activeShips;
    var receivingVessel = customerFleet.find(function (ship) { return ship._id === (selectedNomination === null || selectedNomination === void 0 ? void 0 : selectedNomination.receivingShipId); });
    var roles = useContextualRole(props.userProfile, initialNomination, receivingVessel).roles;
    var userProfile = __assign(__assign({}, props.userProfile), { roles: roles });
    // State variables
    var _c = useState('SUMMARY'), formState = _c[0], setFormState = _c[1];
    var _d = useState(false), runContractCheckSubmit = _d[0], setRunContractCheckSubmit = _d[1];
    var _e = useState(), counterProposalCandidate = _e[0], setCounterProposalCandidate = _e[1];
    var _f = useState(props.initialNomination ? props.initialNomination : getNewPromptNomination()), initialNominationValues = _f[0], setInitialNominationValues = _f[1];
    var _g = useState(LAST_SUBMIT_ACTION.SUBMIT), lastSubmitAction = _g[0], setLastSubmitAction = _g[1];
    var _h = useState(false), inActiveNomination = _h[0], setInActiveNomination = _h[1];
    var allowedContacts = useThirdPartyContactService(props.authenticationService, userProfile.companyId, roles).allowedContacts;
    var _j = useState([]), companyContacts = _j[0], setCompanyContacts = _j[1];
    //TODO: This useEffect is not needed.. Remove it
    useEffect(function () {
        setCompanyContacts(allowedContacts);
    }, [allowedContacts]);
    useEffect(function () {
        if (delegationState === 'OVERVIEW' && formState !== 'SUMMARY') {
            return setFormState('SUMMARY'), setInActiveNomination(false);
        }
        if ((delegationState === 'EDITING_SN' && nominationType === 'ASSOCIATED_NOMINATION') ||
            (delegationState === 'EDITING_AN' && nominationType === 'SELECTED_NOMINATION')) {
            return setFormState('EDIT'), setInActiveNomination(true);
        }
    }, [delegationState]);
    useEffect(function () {
        if (props.initialNomination) {
            setInitialNominationValues(props.initialNomination);
        }
        else {
            setInitialNominationValues(getNewPromptNomination());
        }
    }, [props.initialNomination]);
    var vendorsWithContract = useContractService(props.authenticationService).vendorsWithContract;
    var userRoles = userProfile ? roles : undefined;
    var sandboxId = initialNomination ? initialNomination.sandboxId : undefined;
    // Form Logic Manager
    var _k = useForm({
        initialValues: initialNominationValues,
        validate: validateNomination,
        onValidSubmit: submitPromptNomination
    }), handleSubmit = _k.handleSubmit, values = _k.values, errors = _k.errors, onChangeValue = _k.onChangeValue, triggerValidation = _k.triggerValidation, isDifferentFromInitial = _k.isDifferentFromInitial, setAllValues = _k.setAllValues;
    var timezone = useLocationTimeZone(values === null || values === void 0 ? void 0 : values.locationId, props.locationService);
    var errorMessage = 'Please fill in all fields correctly.';
    var latestNominationIsSelected = props.nominationSelection.selectedNominationIndex + 1 === ((_a = props.nominationHistory) === null || _a === void 0 ? void 0 : _a.length);
    var userPermissions = useContext(UserPermissionContext).userPermissions;
    var editFormActive = formState === 'EDIT' || formState === 'EDIT_ON_BEHALF';
    var customerCompanyName = selectedNomination && selectedNomination.companyId
        ? getCompanyDetails(props.companies, selectedNomination.companyId).companyName
        : 'your customer';
    var delegatedCompanyName = selectedNomination && selectedNomination.vendorCompanyId
        ? getCompanyDetails(props.companies, selectedNomination.vendorCompanyId).companyName
        : undefined;
    var isDelegatedNomination = initialNomination.delegationOriginEventId ? true : false;
    var hasDelegatedNomination = initialNomination.delegatedNominationEventId
        ? true
        : false;
    var delegationBtnEnabled = !initialNomination.delegationOriginEventId &&
        !initialNomination.delegatedNominationEventId &&
        selectedNomination.latest === true;
    var isContractHolder = userProfile.companyId === initialNomination.companyId;
    var _l = useSharedThirdPartyContactsService(isDelegatedNomination, isContractHolder, userProfile, props.nominationSelection.selectedHistoricNomination || props.initialNomination, props.nominationSelection.previousHistoricNomination, props.authenticationService, companyContacts), currentThirdPartyContacts = _l.currentThirdPartyContacts, previousThirdPartyContacts = _l.previousThirdPartyContacts;
    var companyContracts = props.contractsList.filter(function (contract) {
        return contract.companyId === initialNomination.companyId &&
            contract.vendorCompanyId === initialNomination.vendorCompanyId;
    });
    useEffect(function () {
        if (runContractCheckSubmit && (values === null || values === void 0 ? void 0 : values.contractId) && (values === null || values === void 0 ? void 0 : values.vendorReference)) {
            var onBehalf = formState === 'EDIT_ON_BEHALF';
            handleSubmit(undefined, {
                onBehalf: onBehalf,
                amendAndAccept: false
            });
            setRunContractCheckSubmit(false);
            setLastSubmitAction(LAST_SUBMIT_ACTION.SUBMIT);
        }
    }, [runContractCheckSubmit, values === null || values === void 0 ? void 0 : values.contractId, values === null || values === void 0 ? void 0 : values.vendorReference, formState]);
    var showContractCheckIntegration = props.showContractCheckIntegration && !isDelegatedNomination;
    if (!doesUserHavePermission(userPermissions, 'NOMINATION_READ')) {
        return React__default.createElement(PermissionsWarning, null, "You are not allowed to view this Nomination'");
    }
    if (typeof props.setEditingMode !== 'undefined') {
        if (editFormActive) {
            props.setEditingMode(true);
        }
        else {
            props.setEditingMode(false);
        }
    }
    return (React__default.createElement("div", { className: "prompt-negotiation-wrapper " + (props.className || '') + " " + (!inActiveNomination && (formState === 'EDIT' || formState === 'EDIT_ON_BEHALF')
            ? 'active-nomination'
            : 'inactive-nomination') },
        React__default.createElement("div", { className: (initialNomination ? 'negotiation-header-wrapper' : '') + " " + (((isDelegatedNomination && isContractHolder) ||
                (isScheduler(roles) && hasDelegatedNomination)) &&
                !formState.includes('EDIT')
                ? 'delegated-nomination'
                : '') },
            React__default.createElement(NegotiationStatusHeader$1, { receivingVesselName: (receivingVessel === null || receivingVessel === void 0 ? void 0 : receivingVessel.name) || ((_b = selectedNomination === null || selectedNomination === void 0 ? void 0 : selectedNomination.attributes) === null || _b === void 0 ? void 0 : _b.receivingShipName), negotiationItem: selectedNomination, isNominationInSandbox: props.isNominationInSandbox, userProfile: userProfile, showFuelbossStates: props.showFuelbossStates, companies: props.companies, isDelegatedNomination: isDelegatedNomination }),
            React__default.createElement(HistoryButton, { selectedItemIndex: props.nominationSelection.selectedNominationIndex, eventHistory: props.nominationHistory, seeNextProposal: function () {
                    props.nominationSelection.selectNextHistoricNomination();
                    setFormState('SUMMARY');
                }, seePreviousProposal: function () {
                    props.nominationSelection.selectPreviousHistoricNomination();
                    setFormState('SUMMARY');
                }, editFormActive: formState === 'EDIT' || formState === 'EDIT_ON_BEHALF', sandbox: props.isNominationInSandbox, latestItemIsSelected: latestNominationIsSelected }),
            React__default.createElement("div", { className: "prompt-negotiation-actions" },
                formState === 'SUMMARY' && (React__default.createElement(React__default.Fragment, null,
                    props.delegatePromptNomination &&
                        latestNominationIsSelected &&
                        doesUserHavePermission(userPermissions, 'NOMINATION_DELEGATE') && (React__default.createElement(DelegationHandler, { userProfile: userProfile, companies: props.companies, nomination: initialNomination, delegatePromptNomination: props.delegatePromptNomination })),
                    React__default.createElement(NegotiationActions$1, { updateEvent: function (action, event) {
                            props.updatePromptNomination(action, event);
                        }, activateEditMode: activateEditMode, changeStateWhenValid: changeStateWhenValid, isDifferentFromInitial: isDifferentFromInitial, isNominationInSandbox: props.isNominationInSandbox, readOnly: props.readOnly, userProfile: userProfile, userRoles: userRoles, initialEvent: initialNomination, selectedEvent: selectedNomination, acceptPendingNomination: props.acceptPendingNomination, error: errors && !isEmpty$1(errors) ? errorMessage : undefined, customerCompanyName: customerCompanyName, delegatedCompanyName: delegatedCompanyName, generateAndSendOrderConfirmation: props.generateAndSendOrderConfirmation, onOrderPDFConfirmed: props.onOrderPDFConfirmed, delegationOriginEventId: props.initialNomination.delegationOriginEventId, setDelegationState: props.setDelegationState, nominationType: nominationType, delegationBtnEnabled: delegationBtnEnabled, cancelDelegatedNomination: cancelDelegation, showContractIntegration: showContractCheckIntegration, contractsList: companyContracts, onContractCheck: handleContractCheck, onContractCheckApprove: function () {
                            handleApproveCreditCheck();
                        } }))),
                editFormActive && !inActiveNomination && (React__default.createElement(ButtonGroup, null,
                    formState === 'EDIT' && React__default.createElement(React__default.Fragment, null, submitButtons()),
                    formState === 'EDIT_ON_BEHALF' && React__default.createElement(React__default.Fragment, null, submitButtons(true)),
                    React__default.createElement(Button$1, { className: "discard-button", preventDoubleClick: true, onClick: function () {
                            setFormState('SUMMARY');
                            if (props.setDelegationState) {
                                props.setDelegationState('OVERVIEW');
                            }
                        } }, "Discard"))))),
        React__default.createElement(CounterProposalDialog, { amendOrCounterNegotiation: function (action, event) {
                amendOrCounterNomination(action, event, false);
            }, counterProposalCandidate: counterProposalCandidate, ignoringApproveRequest: lastSubmitAction === LAST_SUBMIT_ACTION.SUBMIT_AND_APPROVE, clearCounterProposalCandidate: function () {
                setCounterProposalCandidate(undefined);
            } }),
        React__default.createElement("div", null,
            (formState === 'EDIT' || formState === 'EDIT_ON_BEHALF') && latestNominationIsSelected && (React__default.createElement("form", { noValidate: true, className: "form-wrapper-prompt" }, values && (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(PromptNominationForm, { currentUser: userProfile, creatingNewNomination: false, values: values, prevValues: nominationSelection.previousHistoricNomination, authenticationService: props.authenticationService, locationService: props.locationService, errors: errors, bunkerShips: props.bunkerShips, customerFleet: customerFleet, onChangeFormValue: onChangeValue, companies: props.companies, creatingNominationOnBehalf: false, showDeliveryModeSelection: props.showDeliveryModeSelection, vendorsWithContract: vendorsWithContract, contractsList: props.contractsList, setAllValues: setAllValues, pipelines: props.pipelines, enableAlternativeFuelSelector: props.enableAlternativeFuelSelector, editType: formState, customerCompanyName: customerCompanyName, nominationEventToCompareWith: props.nominationEventToCompareWith, isDelegatedNomination: isDelegatedNomination, disabled: inActiveNomination, currentThirdPartyContacts: currentThirdPartyContacts }),
                !inActiveNomination && (React__default.createElement(React__default.Fragment, null, isScheduler(userRoles) || isSchedulerCaptain(userRoles) ? (React__default.createElement("div", { className: "form-action-bar" },
                    React__default.createElement(ButtonGroup, null,
                        formState === 'EDIT' && React__default.createElement(React__default.Fragment, null, submitButtons()),
                        formState === 'EDIT_ON_BEHALF' && React__default.createElement(React__default.Fragment, null, submitButtons(true)),
                        React__default.createElement(Button$1, { preventDoubleClick: true, className: "discard-button", onClick: function () {
                                setFormState('SUMMARY');
                                if (props.setDelegationState) {
                                    props.setDelegationState('OVERVIEW');
                                }
                            } }, "Discard")))) : (React__default.createElement("div", { className: "form-action-bar" },
                    React__default.createElement(ButtonGroup, null,
                        submitButtons(),
                        React__default.createElement(Button$1, { className: "discard-button", preventDoubleClick: true, onClick: function () {
                                setFormState('SUMMARY');
                                if (props.setDelegationState) {
                                    props.setDelegationState('OVERVIEW');
                                }
                            } }, "Discard")))))))))),
            (!editFormActive || !latestNominationIsSelected) && (React__default.createElement(React__default.Fragment, null, selectedNomination && (React__default.createElement(NominationSummary, { currentUser: userProfile, latestNomination: props.initialNomination, nominationSelection: props.nominationSelection, locationService: props.locationService, pipelines: props.pipelines, companies: props.companies, bunkerShips: props.bunkerShips, contractsList: props.contractsList, companyContacts: companyContacts, nominationEventToCompareWith: props.nominationEventToCompareWith, isDelegatedNomination: isDelegatedNomination, currentThirdPartyContacts: currentThirdPartyContacts, previousThirdPartyContacts: previousThirdPartyContacts || null, showContractCheckIntegration: showContractCheckIntegration })))))));
    function handleApproveCreditCheck() {
        var contract = companyContracts.filter(function (contract) { var _a; return contract._id === ((_a = props.initialNomination) === null || _a === void 0 ? void 0 : _a.creditCheckContractId); });
        if (contract.length > 0) {
            activateEditMode('EDIT');
            onChangeValue('contractId', contract[0]._id);
            onChangeValue('vendorReference', contract[0].contractReference);
            setRunContractCheckSubmit(true);
        }
    }
    function submitButtons(onBehalf) {
        if (onBehalf === void 0) { onBehalf = false; }
        var isProposalOfCustomer = values &&
            values.author &&
            values.state === 'PROPOSED' &&
            (isCustomer(values.author.roles) || values.onBehalf);
        var isEditedBySupplier = (isScheduler(roles) || isSchedulerCaptain(roles) || isAdmin(roles)) && !onBehalf;
        return (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(Button$1, { preventDoubleClick: true, primary: true, title: isDifferentFromInitial ? '' : 'No changes detected', disabled: sandboxId === SANDBOX_ID_LIVE, onClick: function (e) {
                    setLastSubmitAction(LAST_SUBMIT_ACTION.SUBMIT);
                    handleSubmit(e, {
                        onBehalf: onBehalf,
                        amendAndAccept: false
                    });
                } }, onBehalf ? 'Submit for customer' : 'Submit'),
            isProposalOfCustomer && isEditedBySupplier && (React__default.createElement(Button$1, { preventDoubleClick: true, primary: true, title: isDifferentFromInitial ? '' : 'No changes detected', disabled: sandboxId === SANDBOX_ID_LIVE, onClick: function (e) {
                    setLastSubmitAction(LAST_SUBMIT_ACTION.SUBMIT_AND_APPROVE);
                    handleSubmit(e, {
                        onBehalf: onBehalf,
                        amendAndAccept: true
                    });
                } }, onBehalf ? 'Submit and approve for customer' : 'Submit and approve'))));
    }
    function validateNomination(nominationToValidate) {
        var roleOrOnBehalfRole = formState === 'EDIT_ON_BEHALF' ? ['ROLE_CUSTOMER'] : roles;
        var errors = validatePromptNominationForm(nominationToValidate, userProfile, roleOrOnBehalfRole, props.showDeliveryModeSelection, timezone.value);
        if (timezone.loading && !errors['locationId']) {
            errors['locationId'] = 'Location is still loading. Submit again once loaded';
        }
        return errors;
    }
    function submitPromptNomination(promptNomination, options) {
        return __awaiter(this, void 0, void 0, function () {
            var parsedNomination, sandboxId, nomination;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        parsedNomination = parseNominationValues(promptNomination);
                        sandboxId = props.initialNomination ? props.initialNomination.sandboxId : undefined;
                        if (!sandboxId) return [3 /*break*/, 2];
                        return [4 /*yield*/, props.updateSandboxPromptNomination(parsedNomination, sandboxId)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        nomination = cloneDeep(parsedNomination);
                        nomination.onBehalf = options.onBehalf;
                        return [4 /*yield*/, amendOrCounterNomination('AMEND', nomination, options.amendAndAccept)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        if (props.setDelegationState) {
                            props.setDelegationState('OVERVIEW');
                        }
                        return [2 /*return*/];
                }
            });
        });
    }
    function amendOrCounterNomination(action, nominationToUpdate, amendAndAccept) {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, props.updatePromptNomination(action, nominationToUpdate, false, amendAndAccept)];
                    case 1:
                        _a.sent();
                        setFormState('SUMMARY');
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        // 422 => Unprocessable Entity code from the backend which tells us a amend request is not possible.
                        // Therefore a counter should be done.
                        // the 422 specifically will be thrown by the updatePromptNomination function to handle in the UI here
                        // Other errors will be handled by the service, but there's a fallback in place here just to be sure.
                        if (error_1.status && error_1.status === 422) {
                            setCounterProposalCandidate(nominationToUpdate);
                        }
                        else {
                            handleFetchError(error_1);
                            setFormState('SUMMARY');
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    function changeStateWhenValid(state, onBehalf, reason) {
        return __awaiter(this, void 0, void 0, function () {
            var latestPromptNomination, schedulerIsChangingDelegatedProposal, validateData;
            return __generator(this, function (_a) {
                try {
                    latestPromptNomination = values;
                    // check if the latest nomination is present and if it's state is not pending
                    if (latestPromptNomination !== null && latestPromptNomination._id) {
                        schedulerIsChangingDelegatedProposal = isScheduler(roles) && latestPromptNomination.state === 'PENDING';
                        triggerValidation();
                        validateData = schedulerIsChangingDelegatedProposal || state !== 'ACCEPTED'
                            ? {}
                            : validatePromptNominationForm(latestPromptNomination, userProfile, roles, props.showDeliveryModeSelection, timezone.value);
                        if (!validateData || isEmpty$1(validateData)) {
                            props.updatePromptNominationState(state, onBehalf, reason);
                        }
                        else {
                            // Data is not valid, activate the edit mode
                            activateEditMode('EDIT');
                        }
                    }
                    else {
                        console.error('No latestPromptNomination, cannot update state');
                    }
                }
                catch (err) {
                    handleFetchError(err);
                }
                return [2 /*return*/];
            });
        });
    }
    function activateEditMode(type) {
        // only allow edit mode for non-cancelled and non-finalized events
        if (!props.readOnly) {
            setFormState(type);
        }
    }
    function cancelDelegation(reason) {
        if (!initialNomination.eventId) {
            console.error('No initial nomination eventId found');
            return;
        }
        if (!cancelDelegatedNomination) {
            console.error('Something went wrong in cancelDelegation, delegation button should not have been here');
            return;
        }
        try {
            cancelDelegatedNomination(initialNomination.eventId, reason);
        }
        catch (err) {
            handleFetchError(err);
        }
    }
    function handleContractCheck(contractId) {
        var options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                eventId: props.initialNomination.eventId,
                contractId: contractId
            })
        };
        props.authenticationService
            .fetchApiCall("/event/export/contract", options)
            .then(props.refetchNominationData);
    }
};
var NominationNegotiation$1 = React__default.memo(NominationNegotiation);

var DelegationContainer = function (props) {
    var _a, _b;
    var _c = props.originalNomination, latestNomination = _c.latestNomination, nominationHistory = _c.nominationHistory, nominationSelection = _c.nominationSelection, updatePromptNomination = _c.updatePromptNomination, updatePromptNominationState = _c.updatePromptNominationState, updateSandboxPromptNomination = _c.updateSandboxPromptNomination, refetchNominationData = _c.refetchNominationData;
    useEffect(function () {
        retrieveSuppliers();
    }, []);
    // Should never be the case
    if (!latestNomination) {
        return null;
    }
    var eventId = latestNomination.eventId;
    var _d = useState(), supplierList = _d[0], setSupplierList = _d[1];
    var _e = useState(), selectedSupplier = _e[0], setSelectedSupplier = _e[1];
    // Selected nomination = SN, Associated NominationBlock = AN //
    var _f = useState('OVERVIEW'), delegationState = _f[0], setDelegationState = _f[1];
    return (React__default.createElement("div", { className: "delegation-container" },
        React__default.createElement("div", { className: "selected-nomination" }, latestNomination && (React__default.createElement(NominationNegotiation$1, { showDeliveryModeSelection: true, readOnly: false, isNominationInSandbox: false, initialNomination: latestNomination, nominationHistory: nominationHistory, nominationSelection: nominationSelection, updatePromptNomination: updatePromptNomination, updateSandboxPromptNomination: updateSandboxPromptNomination, updatePromptNominationState: updatePromptNominationState, authenticationService: props.authenticationService, showProposalInformation: true, showFuelbossStates: true, userProfile: props.user, companies: props.companies, locationService: props.locationService, bunkerShips: props.bunkerShips, pipelines: props.pipelines, enableAlternativeFuelSelector: true, contractsList: props.contractsList, onOrderPDFConfirmed: function () { return props.onOrderPDFConfirmed && props.onOrderPDFConfirmed(); }, nominationType: 'SELECTED_NOMINATION', delegationState: delegationState, setDelegationState: setDelegationState, cancelDelegatedNomination: cancelDelegatedNomination, nominationEventToCompareWith: (_a = props.delegatedNomination) === null || _a === void 0 ? void 0 : _a.latestNomination, setEditingMode: props.setEditingModeLHS, generateAndSendOrderConfirmation: props.originalNomination.generateAndSendOrderConfirmation, showContractCheckIntegration: props.showContractCheckIntegration, refetchNominationData: refetchNominationData }))),
        ((_b = props.delegatedNomination) === null || _b === void 0 ? void 0 : _b.latestNomination) && (React__default.createElement("div", { className: "associated-nomination" },
            React__default.createElement(NominationNegotiation$1, { showDeliveryModeSelection: true, readOnly: false, isNominationInSandbox: false, initialNomination: props.delegatedNomination.latestNomination, nominationHistory: props.delegatedNomination.nominationHistory, nominationSelection: props.delegatedNomination.nominationSelection, updatePromptNomination: props.delegatedNomination.updatePromptNomination, updateSandboxPromptNomination: props.delegatedNomination.updateSandboxPromptNomination, updatePromptNominationState: props.delegatedNomination.updatePromptNominationState, authenticationService: props.authenticationService, showProposalInformation: true, showFuelbossStates: true, userProfile: props.user, companies: props.companies, locationService: props.locationService, bunkerShips: props.bunkerShips, pipelines: props.pipelines, enableAlternativeFuelSelector: true, contractsList: props.contractsList, onOrderPDFConfirmed: function () { return props.onOrderPDFConfirmed && props.onOrderPDFConfirmed(); }, nominationEventToCompareWith: latestNomination, nominationType: 'ASSOCIATED_NOMINATION', delegationState: delegationState, cancelDelegatedNomination: cancelDelegatedNomination, setEditingMode: props.setEditingModeRHS, generateAndSendOrderConfirmation: props.delegatedNomination.generateAndSendOrderConfirmation, showContractCheckIntegration: props.showContractCheckIntegration, refetchNominationData: props.delegatedNomination.refetchNominationData }))),
        eventId && (React__default.createElement(Dialog, { onCloseDialog: function () {
                setDelegationState('OVERVIEW');
            }, showDialog: delegationState === 'CREATING_DELEGATION', contentClassName: "dialog-allow-overflow padded-content", title: 'Delegate bunkering', titleIcon: React__default.createElement(Icon, null,
                React__default.createElement(FontAwesomeIcon, { icon: faShare })) },
            React__default.createElement(FormWrapper, null,
                supplierList && (React__default.createElement(FormElement, null,
                    React__default.createElement(FormLabel, { fieldName: "supplier-selection" }, "Select supplier"),
                    React__default.createElement(SelectionBox, { fieldName: 'companyId', id: "supplier-selector", value: selectedSupplier ? selectedSupplier : '', options: supplierList
                            .map(function (supplier) { return ({
                            value: supplier.id,
                            text: supplier.name
                        }); })
                            .sort(function (a, b) { return a.text.localeCompare(b.text); }), valueKey: "value", displayKey: "text", renderFieldValue: function (selectedItem) {
                            return "" + selectedItem.text;
                        }, onChangeValue: function (selectedItem) {
                            setSelectedSupplier(selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value);
                        }, renderOption: function (option) {
                            return (React__default.createElement("div", null,
                                React__default.createElement("span", { className: "delegation-supplier-span" }, option.text)));
                        } }))),
                React__default.createElement(FormElement, { className: "justify-center" },
                    React__default.createElement(Button, { disabled: !selectedSupplier ? true : false, preventDoubleClick: true, primary: true, onClick: function () {
                            createNewDelegation(eventId);
                            setDelegationState('OVERVIEW');
                        }, style: { marginRight: '10px' } }, "Create delegation"),
                    React__default.createElement(Button, { preventDoubleClick: true, secondary: true, onClick: function () {
                            setDelegationState('OVERVIEW');
                        } }, "Cancel")))))));
    function retrieveSuppliers() {
        return __awaiter(this, void 0, void 0, function () {
            var companyArray, suppliers, newSupplierList, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, getAllCompanies(props.authenticationService)];
                    case 1:
                        companyArray = _a.sent();
                        suppliers = companyArray.filter(function (company) {
                            return (company._id !== (latestNomination === null || latestNomination === void 0 ? void 0 : latestNomination.vendorCompanyId) &&
                                company.companyType === 'VENDOR' &&
                                !company.deleted);
                        });
                        newSupplierList = suppliers.map(function (supplier) {
                            return { id: supplier._id, name: supplier.name };
                        });
                        if (newSupplierList.length <= 0)
                            return [2 /*return*/];
                        setSupplierList(newSupplierList);
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        handleFetchError(err_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    function createNewDelegation(eventId) {
        return __awaiter(this, void 0, void 0, function () {
            var err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!selectedSupplier)
                            return [2 /*return*/];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, createDelegation(props.authenticationService, eventId, selectedSupplier)];
                    case 2:
                        _a.sent();
                        props.originalNomination.refetchNominationData();
                        return [3 /*break*/, 4];
                    case 3:
                        err_2 = _a.sent();
                        handleFetchError(err_2);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    function cancelDelegatedNomination(eventId, reason) {
        return __awaiter(this, void 0, void 0, function () {
            var err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, cancelDelegation(props.authenticationService, eventId, reason)];
                    case 1:
                        _a.sent();
                        props.originalNomination.refetchNominationData();
                        return [3 /*break*/, 3];
                    case 2:
                        err_3 = _a.sent();
                        handleFetchError(err_3);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
};

function renderSigningIcon(status) {
    if (status === 'UNSIGNED') {
        return (React__default.createElement(Icon, { className: "signing-icon " + status },
            React__default.createElement(FontAwesomeIcon, { icon: faPencil })));
    }
    else if (status === 'REQUESTED' || status === 'PROCESSING' || status === 'REQUEST_SENT') {
        return (React__default.createElement(Icon, { className: "signing-icon " + status },
            React__default.createElement(FontAwesomeIcon, { icon: faHourglassHalf })));
    }
    else if (status === 'VIEWED') {
        return (React__default.createElement(Icon, { className: "signing-icon " + status },
            React__default.createElement(FontAwesomeIcon, { icon: faEye })));
    }
    else if (status === 'SIGNED') {
        return (React__default.createElement(Icon, { className: "signing-icon " + status },
            React__default.createElement(FontAwesomeIcon, { icon: faSignature })));
    }
    else if (status === 'CANCELLED' || status === 'DECLINED' || status === 'ERROR') {
        return (React__default.createElement(Icon, { className: "signing-icon " + status },
            React__default.createElement(FontAwesomeIcon, { icon: faBan })));
    }
    else {
        return (React__default.createElement(Icon, { className: "signing-icon " + status },
            React__default.createElement(FontAwesomeIcon, { icon: faSignature })));
    }
}
function getReadableDocumentType(type) {
    switch (type) {
        case 'OTHER':
            return 'Document';
        case 'IMAGE':
            return 'Image';
        case 'STATEMENT_OF_FACTS':
            return 'Statement of Facts';
        case 'VOYAGE_ORDERS':
            return 'Voyage Order';
        case 'SAFETY_CHECKLIST_CDE':
            return 'checklist CDE';
        case 'SAFETY_CHECKLIST_IAPH_AB':
            return 'IAPH checklist AB';
        case 'SAFETY_CHECKLIST_IAPH_CD':
            return 'IAPH checklist CD';
        case 'SAFETY_CHECKLIST_IAPH_E':
            return 'IAPH checklist E';
        case 'SAFETY_CHECKLIST_IAPH_F':
            return 'IAPH checklist F';
        case 'SAFETY_CHECKLIST_GOTHENBURG_AB':
            return 'Gothenburg checklist AB';
        case 'SAFETY_CHECKLIST_GOTHENBURG_CDEF':
            return 'Gothenburg checklist CDEF';
        case 'SAFETY_CHECKLIST_GOTHENBURG_G':
            return 'Gothenburg checklist G';
        case 'SAFETY_CHECKLIST_TR56_AB':
            return 'TR56 checklist AB';
        case 'SAFETY_CHECKLIST_TR56_CD':
            return 'TR56 checklist CD';
        case 'SAFETY_CHECKLIST_TR56_E':
            return 'TR56 checklist E';
        case 'DELIVERY_NOTE':
            return 'Delivery Note';
        case 'EBDN':
            return 'eBDN';
        default:
            return 'Document';
    }
}
function getReadableSigningStatus(status) {
    switch (status) {
        case 'CANCELLED':
            return 'Signing Cancelled';
        case 'DECLINED':
            return 'Signing Declined';
        case 'ERROR':
            return 'Signing Error';
        case 'PROCESSING':
            return 'Processing sign request';
        case 'REQUESTED':
            return 'Signing Requested';
        case 'REQUEST_SENT':
            return 'Signing Requested';
        case 'SIGNED':
            return 'Signed';
        case 'UNSIGNED':
            return 'Unsigned';
        case 'VIEWED':
            return 'Signing Viewed';
        default:
            return 'Unknown Signing Status';
    }
}
function editDocument(updatedFile, authenticationService, refetchEvent) {
    return __awaiter(this, void 0, void 0, function () {
        var err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, updateDocument(authenticationService, updatedFile)];
                case 1:
                    _a.sent();
                    refetchEvent();
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _a.sent();
                    handleFetchError(err_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
function deleteDocument(file, eventWithDocuments, refetchEvent, updateItem, userProfile) {
    return __awaiter(this, void 0, void 0, function () {
        var companyId, eventToDeleteFileFrom, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!userProfile || userProfile._id !== file.userId) {
                        toast.error('You are not allowed to delete a file that is not uploaded by you', {
                            autoClose: 20000
                        });
                    }
                    companyId = instanceOfNominationTimelineItem(eventWithDocuments)
                        ? eventWithDocuments.companyId
                        : userProfile
                            ? userProfile.companyId
                            : undefined;
                    if (!userProfile || !eventWithDocuments || !companyId) {
                        toast.error("This file can't be deleted", { autoClose: 20000 });
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, , 6]);
                    if (!file._id) return [3 /*break*/, 3];
                    eventToDeleteFileFrom = cloneDeep(eventWithDocuments);
                    if (!eventToDeleteFileFrom.documents) {
                        eventToDeleteFileFrom.documents = [];
                    }
                    eventToDeleteFileFrom.documents = eventToDeleteFileFrom.documents.filter(function (doc) { return doc._id !== file._id; });
                    return [4 /*yield*/, updateItem(eventToDeleteFileFrom)];
                case 2:
                    _a.sent();
                    refetchEvent();
                    return [3 /*break*/, 4];
                case 3:
                    console.warn('Cannot delete file: file id is undefined');
                    _a.label = 4;
                case 4: return [3 /*break*/, 6];
                case 5:
                    err_2 = _a.sent();
                    handleFetchError(err_2);
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    });
}
function attachDocuments(authenticationService, eventId, documentIds) {
    var options = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(documentIds)
    };
    return authenticationService.fetchApiCall("/prompt/event/" + eventId + "/attachDocuments", options);
}
function removeDocuments(authenticationService, eventId, documentIds) {
    var options = {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(documentIds)
    };
    return authenticationService.fetchApiCall("/prompt/event/" + eventId + "/removeDocuments", options);
}

var TerminalSigning = function (props) {
    var _a = useForm({
        initialValues: undefined,
        validate: validateSigningRequest,
        onValidSubmit: props.initiateSigningFlow
    }), handleSubmit = _a.handleSubmit, values = _a.values, errors = _a.errors, onChange = _a.onChange, isDifferentFromInitial = _a.isDifferentFromInitial;
    return (React__default.createElement(FormWrapper, null,
        React__default.createElement(InlineFormElement, null,
            React__default.createElement(FormElement, null,
                React__default.createElement(FormLabel, { fieldName: "name" }, "Name"),
                React__default.createElement(TextField, { fieldName: "name", value: (values === null || values === void 0 ? void 0 : values.name) || '', onChange: onChange, disabled: props.readOnly }),
                React__default.createElement(FormErrorMessage, null, errors ? errors.name : '')),
            React__default.createElement(FormElement, null,
                React__default.createElement(FormLabel, { fieldName: "email" }, "Terminal email"),
                React__default.createElement(TextField, { fieldName: "email", value: (values === null || values === void 0 ? void 0 : values.email) || '', onChange: onChange, disabled: props.readOnly }),
                React__default.createElement(FormErrorMessage, null, errors ? errors.email : ''))),
        React__default.createElement(Button, { primary: true, className: "initiate-signing-button", preventDoubleClick: true, disabled: !isDifferentFromInitial, onClick: function (e) {
                e.preventDefault();
                handleSubmit();
            } }, "Initiate signing")));
    function validateSigningRequest(signingInfo) {
        var errors = {};
        if (!signingInfo.name || signingInfo.name === '') {
            errors['name'] = 'Please fill in a name';
        }
        if (!signingInfo.email || signingInfo.email === '') {
            errors['email'] = 'Please fill in a email address';
        }
        if (!isValidEmail(signingInfo.email)) {
            errors['email'] = 'Please fill in a valid email address';
        }
        return errors;
    }
};

var ShipToShipSigning = function (props) {
    var _a, _b, _c, _d;
    var _e = useState(props.optionalOfficial), portOfficial = _e[0], setPortOfficial = _e[1];
    var _f = useForm({
        initialValues: undefined,
        validate: validateSigningRequest,
        onValidSubmit: submitSignRequest
    }), handleSubmit = _f.handleSubmit, values = _f.values, errors = _f.errors, onChangeValue = _f.onChangeValue, isDifferentFromInitial = _f.isDifferentFromInitial;
    var customerSigningLabel = props.eventType === 'nomination' ? 'Receiving Vessel' : 'Loading Master';
    var officialName = screamingSnakeCaseToSentence(props.externalSignerType);
    return (React__default.createElement(FormWrapper, null,
        React__default.createElement(InlineFormElement, null,
            props.showBunkerShip !== false && (React__default.createElement(FormElement, null,
                React__default.createElement(FormLabel, null, props.assetName),
                React__default.createElement(SelectionBox, { fieldName: 'supplierUserId', placeholder: 'Select Signer...', valueKey: "value", displayKey: "text", renderOption: function (option) {
                        return React__default.createElement("div", null, option.text);
                    }, dropUp: true, onChangeValue: function (bunkershipCaptain) {
                        onChangeValue('supplierUserId', bunkershipCaptain === null || bunkershipCaptain === void 0 ? void 0 : bunkershipCaptain.value);
                    }, value: (values === null || values === void 0 ? void 0 : values.supplierUserId) || undefined, options: props.bunkerShipProfiles.map(function (captain) {
                        return { text: captain.email, value: captain._id };
                    }), disabled: props.readOnly }),
                React__default.createElement(FormErrorMessage, null, errors ? errors.supplierUserId : ''))),
            props.showReceivingShip !== false && (React__default.createElement(FormElement, null,
                React__default.createElement(FormLabel, { fieldName: 'customerUserId' }, customerSigningLabel),
                React__default.createElement(SelectionBox, { fieldName: 'customerUserId', valueKey: "value", displayKey: "text", placeholder: 'Select Signer...', renderOption: function (option) {
                        return React__default.createElement("div", null, option.text);
                    }, dropUp: true, onChangeValue: function (counterSigner) {
                        onChangeValue('customerUserId', counterSigner === null || counterSigner === void 0 ? void 0 : counterSigner.value);
                    }, value: (values === null || values === void 0 ? void 0 : values.customerUserId) || undefined, options: props.counterSigningProfiles.map(function (signers) {
                        return { text: signers.email, value: signers._id };
                    }), disabled: props.readOnly }),
                React__default.createElement(FormErrorMessage, null, errors ? errors.customerUserId : '')))),
        props.optionalOfficial && !props.terminalOperator && (React__default.createElement(InlineFormElement, null,
            React__default.createElement(FormElement, null,
                React__default.createElement(Checkbox, { label: officialName, value: portOfficial, field: "Port-officer-checkbox-" + props.documentId, onChange: function (event) {
                        setPortOfficial(event.target.checked);
                    } })))),
        (portOfficial || props.terminalOperator) && (React__default.createElement(InlineFormElement, null,
            React__default.createElement(FormElement, null,
                React__default.createElement(FormLabel, { fieldName: "name" }, officialName + " name"),
                React__default.createElement(TextField, { fieldName: "name", value: ((_b = (_a = values === null || values === void 0 ? void 0 : values.otherExternalSigners) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.name) || '', onChange: function (e) {
                        onChangeValue('otherExternalSigners[0].name', e.target.value);
                    }, disabled: props.readOnly }),
                React__default.createElement(FormErrorMessage, null, errors ? errors.name : '')),
            React__default.createElement(FormElement, null,
                React__default.createElement(FormLabel, { fieldName: "email" }, officialName + " email"),
                React__default.createElement(TextField, { fieldName: "email", value: ((_d = (_c = values === null || values === void 0 ? void 0 : values.otherExternalSigners) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.email) || '', onChange: function (e) {
                        onChangeValue('otherExternalSigners[0].email', e.target.value);
                    }, onBlur: function () { return onChangeValue('otherExternalSigners[0].role', props.externalSignerType); }, disabled: props.readOnly }),
                React__default.createElement(FormErrorMessage, null, errors ? errors.email : '')))),
        React__default.createElement(Button, { primary: true, className: "initiate-signing-button", preventDoubleClick: true, disabled: !isDifferentFromInitial, onClick: function (e) {
                e.preventDefault();
                handleSubmit();
            } }, "Initiate signing")));
    function validateSigningRequest(signingInfo) {
        var _a, _b, _c, _d;
        var errors = {};
        if (!signingInfo.supplierUserId && props.showBunkerShip !== false) {
            errors['supplierUserId'] = 'Please choose a user to sign';
        }
        if (!signingInfo.customerUserId && props.showReceivingShip !== false) {
            errors['customerUserId'] = 'Please choose a user to sign';
        }
        if (portOfficial && !((_b = (_a = signingInfo.otherExternalSigners) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.email)) {
            errors['email'] = 'Please type a email for the Port officer';
        }
        if (portOfficial && !((_d = (_c = signingInfo.otherExternalSigners) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.email)) {
            errors['name'] = 'Please type a name for the Port officer';
        }
        return errors;
    }
    function submitSignRequest(internalSigners) {
        props.initiateSigningFlow(internalSigners, undefined);
    }
};

var ExternalSigning = function (props) {
    var _a, _b, _c, _d, _e, _f;
    var _g = useState(props.optionalOfficial), portOfficial = _g[0], setPortOfficial = _g[1];
    var _h = useForm({
        initialValues: undefined,
        validate: validateSigningRequest,
        onValidSubmit: submitSignRequest
    }), handleSubmit = _h.handleSubmit, values = _h.values, errors = _h.errors, onChangeValue = _h.onChangeValue, isDifferentFromInitial = _h.isDifferentFromInitial;
    var officialName = screamingSnakeCaseToSentence(props.externalSignerType);
    return (React__default.createElement(FormWrapper, null,
        React__default.createElement(InlineFormElement, null,
            React__default.createElement(FormElement, null,
                React__default.createElement(FormLabel, { fieldName: "name" }, "Supplier name"),
                React__default.createElement(TextField, { fieldName: "name", value: ((_a = values === null || values === void 0 ? void 0 : values.externalSupplier) === null || _a === void 0 ? void 0 : _a.name) || '', onChange: function (e) {
                        onChangeValue('externalSupplier.name', e.target.value);
                    }, disabled: props.readOnly }),
                React__default.createElement(FormErrorMessage, null, errors ? errors.name : '')),
            React__default.createElement(FormElement, null,
                React__default.createElement(FormLabel, { fieldName: "email" }, "Supplier email"),
                React__default.createElement(TextField, { fieldName: "email", value: ((_b = values === null || values === void 0 ? void 0 : values.externalSupplier) === null || _b === void 0 ? void 0 : _b.email) || '', onChange: function (e) {
                        onChangeValue('externalSupplier.email', e.target.value);
                    }, disabled: props.readOnly }),
                React__default.createElement(FormErrorMessage, null, errors ? errors.email : ''))),
        React__default.createElement(InlineFormElement, null,
            React__default.createElement(FormElement, null,
                React__default.createElement(FormLabel, { fieldName: 'customerUserId' }, "Receiving vessel"),
                React__default.createElement(SelectionBox, { fieldName: 'customerUserId', valueKey: "value", displayKey: "text", placeholder: 'Select Signer...', renderOption: function (option) {
                        return React__default.createElement("div", null, option.text);
                    }, dropUp: true, onChangeValue: function (counterSigner) {
                        onChangeValue('customerUserId', counterSigner === null || counterSigner === void 0 ? void 0 : counterSigner.value);
                    }, value: (values === null || values === void 0 ? void 0 : values.customerUserId) || undefined, options: props.counterSigningProfiles.map(function (signers) {
                        return { text: signers.email, value: signers._id };
                    }), disabled: props.readOnly }),
                React__default.createElement(FormErrorMessage, null, errors ? errors.customerUserId : ''))),
        props.optionalOfficial && (React__default.createElement(InlineFormElement, null,
            React__default.createElement(FormElement, null,
                React__default.createElement(Checkbox, { label: officialName, value: portOfficial, field: "Port-officer-checkbox-" + props.documentId, onChange: function (event) {
                        setPortOfficial(event.target.checked);
                    } })))),
        portOfficial && (React__default.createElement(InlineFormElement, null,
            React__default.createElement(FormElement, null,
                React__default.createElement(FormLabel, { fieldName: "name" }, officialName + " name"),
                React__default.createElement(TextField, { fieldName: "name", value: ((_d = (_c = values === null || values === void 0 ? void 0 : values.otherExternalSigners) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.name) || '', onChange: function (e) {
                        onChangeValue('otherExternalSigners[0].name', e.target.value);
                    }, onBlur: function () { return onChangeValue('otherExternalSigners[0].role', props.externalSignerType); }, disabled: props.readOnly }),
                React__default.createElement(FormErrorMessage, null, errors ? errors.name : '')),
            React__default.createElement(FormElement, null,
                React__default.createElement(FormLabel, { fieldName: "email" }, officialName + " email"),
                React__default.createElement(TextField, { fieldName: "email", value: ((_f = (_e = values === null || values === void 0 ? void 0 : values.otherExternalSigners) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.email) || '', onChange: function (e) {
                        onChangeValue('otherExternalSigners[0].email', e.target.value);
                    }, disabled: props.readOnly }),
                React__default.createElement(FormErrorMessage, null, errors ? errors.email : '')))),
        React__default.createElement(Button, { primary: true, className: "initiate-signing-button", preventDoubleClick: true, disabled: !isDifferentFromInitial, onClick: function (e) {
                e.preventDefault();
                handleSubmit();
            } }, "Initiate signing")));
    function validateSigningRequest(signingInfo) {
        var _a, _b, _c, _d;
        var errors = {};
        if (!signingInfo.customerUserId) {
            errors['customerUserId'] = 'Please choose a user to sign';
        }
        if (!signingInfo.externalSupplier.name || signingInfo.externalSupplier.name === '') {
            errors['name'] = 'Please fill in a name';
        }
        if (!signingInfo.externalSupplier.email || signingInfo.externalSupplier.email === '') {
            errors['email'] = 'Please fill in a email address';
        }
        if (portOfficial && !((_b = (_a = signingInfo.otherExternalSigners) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.email)) {
            errors['email'] = 'Please type a email for the Port officer';
        }
        if (portOfficial && !((_d = (_c = signingInfo.otherExternalSigners) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.email)) {
            errors['name'] = 'Please type a name for the Port officer';
        }
        return errors;
    }
    function submitSignRequest(externalSignRequest) {
        props.initiateSigningFlow(undefined, externalSignRequest);
    }
};

var PressureTemperatureTableItems = [
    {
        label: 'LNG tank start temperature',
        unitType: 'temperature',
        field: 'temperature'
    },
    {
        label: 'LNG tank start pressure',
        unitType: 'pressure',
        field: 'pressure'
    },
    {
        label: 'LNG tank available (rest) capacity',
        unitType: 'quantity',
        field: 'restCapacity'
    }
];
var MinMaxTableItems = [
    {
        label: 'Pressure during bunkering',
        field: 'pressure',
        unitType: 'pressure'
    },
    {
        label: 'Pressures in the LNG bunker tanks',
        field: 'tankPressure',
        unitType: 'pressure'
    },
    {
        label: 'Temperatures of the LNG',
        field: 'temperature',
        unitType: 'temperature'
    },
    {
        label: 'Filling limit of the LNG bunker tanks',
        field: 'fillingLimit',
        additionalUnit: '%'
    }
];
var TR56MinMaxTableItems = [
    {
        label: 'Pressure during bunkering at manifold',
        field: 'pressure',
        unitType: 'pressure',
        additionalUnit: '(gauge)'
    },
    {
        label: 'Pressures in the LNG bunker tanks',
        field: 'tankPressure',
        unitType: 'pressure',
        additionalUnit: '(gauge)',
        disable: { max: false, min: true }
    },
    {
        label: 'Temperatures of the LNG',
        field: 'temperature',
        unitType: 'temperature'
    },
    {
        label: 'Filling limit of the LNG bunker tanks',
        field: 'fillingLimit',
        additionalUnit: '%',
        disable: { max: false, min: true }
    }
];
var getTankFieldName = function (index) {
    switch (index) {
        case 1:
            return 'tank1';
        case 2:
            return 'tank2';
        case 3:
            return 'tank3';
        case 4:
            return 'tank4';
        default:
            throw Error('Unknown tank number');
    }
};
var TR56BunkerOperationsTableItems = [
    {
        label: 'Agreed quantity to be transferred',
        field: 'quantity',
        unitType: 'quantity'
    },
    {
        label: 'Starting pressure at the manifold',
        field: 'pressure',
        unitType: 'pressure'
    },
    {
        label: 'Starting rate',
        field: 'startRate',
        additionalUnit: 'per hour',
        unitType: 'quantity'
    },
    {
        label: 'Max transfer rate',
        field: 'maxRate',
        additionalUnit: 'per hour',
        unitType: 'quantity'
    },
    {
        label: 'Topping up rate',
        field: 'topUpRate',
        additionalUnit: 'per hour',
        unitType: 'quantity'
    }
];
var BunkerOperationsTableItems = __spreadArrays(TR56BunkerOperationsTableItems, [
    {
        label: 'Max pressure at manifold',
        field: 'maxPressure',
        unitType: 'pressure'
    }
]);
//general
function getTransferDataUnit(unitType, transferData) {
    if (unitType === 'temperature') {
        return renderTransferDataUnit(transferData.temperatureUnit);
    }
    else if (unitType === 'pressure') {
        return renderTransferDataUnit(transferData.pressureUnit);
    }
    else {
        return renderTransferDataUnit(transferData.quantityUnit);
    }
}
function renderTransferDataUnit(unit) {
    switch (unit) {
        case 'CELSIUS':
            return React__default.createElement(React__default.Fragment, null, "\u00B0C");
        case 'FAHRENHEIT':
            return React__default.createElement(React__default.Fragment, null, "\u00B0F");
        case 'BAR':
            return React__default.createElement(React__default.Fragment, null, "bar");
        case 'PSI':
            return React__default.createElement(React__default.Fragment, null, "psi");
        case 'CUBIC_METERS':
            return (React__default.createElement(React__default.Fragment, null,
                "m",
                React__default.createElement("sup", null, "3")));
        case 'TONNES':
            return React__default.createElement(React__default.Fragment, null, "mt");
        default:
            return React__default.createElement(React__default.Fragment, null);
    }
}
function getBackendSimOpsType(simOpsType) {
    switch (simOpsType) {
        case 'bunkerSimops':
            return 'BUNKER';
        case 'cargoSimops':
            return 'CARGO';
        case 'simopsRestrictions':
            return 'RESTRICTIONS';
        default:
            return 'BUNKER';
    }
}
var safetyChecklistOptions = [
    {
        id: SafetyChecklistType.IAPH,
        value: SafetyChecklistType.IAPH,
        text: SafetyChecklistType.IAPH + " v3.7"
    },
    {
        id: SafetyChecklistType.IAPH_V2_A,
        value: SafetyChecklistType.IAPH_V2_A,
        text: SafetyChecklistType.IAPH + " v4.0 A"
    },
    {
        id: SafetyChecklistType.IAPH_V2_B,
        value: SafetyChecklistType.IAPH_V2_B,
        text: SafetyChecklistType.IAPH + " v4.0 B"
    },
    {
        id: SafetyChecklistType.GOTHENBURG,
        value: SafetyChecklistType.GOTHENBURG,
        text: SafetyChecklistType.GOTHENBURG
    },
    {
        id: SafetyChecklistType.TR56,
        value: SafetyChecklistType.TR56,
        text: SafetyChecklistType.TR56
    }
];
var TABS_IAPH = [
    {
        tabLabel: 'Part AB',
        parts: [SafetyChecklistIndividualPart.A, SafetyChecklistIndividualPart.B],
        checklistItemNames: ['checklistA', 'checklistB'],
        documentType: 'SAFETY_CHECKLIST_IAPH_AB',
        checklistPart: SafetyChecklistPart.AB
    },
    {
        tabLabel: 'Part CD',
        parts: [SafetyChecklistIndividualPart.C, SafetyChecklistIndividualPart.D],
        checklistItemNames: ['checklistC', 'checklistD'],
        documentType: 'SAFETY_CHECKLIST_IAPH_CD',
        checklistPart: SafetyChecklistPart.CD
    },
    {
        tabLabel: 'Part E',
        parts: [SafetyChecklistIndividualPart.E],
        checklistItemNames: ['checklistE'],
        documentType: 'SAFETY_CHECKLIST_IAPH_E',
        checklistPart: SafetyChecklistPart.E
    },
    {
        tabLabel: 'Part F',
        parts: [SafetyChecklistIndividualPart.F],
        checklistItemNames: ['checklistF'],
        documentType: 'SAFETY_CHECKLIST_IAPH_F',
        checklistPart: SafetyChecklistPart.F
    }
];
var TABS_IAPH_V2_A = [
    {
        tabLabel: 'Part A',
        parts: [SafetyChecklistIndividualPart.A],
        checklistItemNames: ['checklistA'],
        documentType: 'SAFETY_CHECKLIST_IAPH_V2_A_A',
        checklistPart: SafetyChecklistPart.A
    },
    {
        tabLabel: 'Part BCD',
        parts: [
            SafetyChecklistIndividualPart.B,
            SafetyChecklistIndividualPart.C,
            SafetyChecklistIndividualPart.D
        ],
        checklistItemNames: ['checklistB', 'checklistC', 'checklistD'],
        documentType: 'SAFETY_CHECKLIST_IAPH_V2_A_BCD',
        checklistPart: SafetyChecklistPart.BCD
    },
    {
        tabLabel: 'Part E',
        parts: [SafetyChecklistIndividualPart.E],
        checklistItemNames: ['checklistE'],
        documentType: 'SAFETY_CHECKLIST_IAPH_V2_A_E',
        checklistPart: SafetyChecklistPart.E
    },
    {
        tabLabel: 'Part F',
        parts: [SafetyChecklistIndividualPart.F],
        checklistItemNames: ['checklistF'],
        documentType: 'SAFETY_CHECKLIST_IAPH_V2_A_F',
        checklistPart: SafetyChecklistPart.F
    }
];
var TABS_IAPH_V2_B = [
    {
        tabLabel: 'Part A',
        parts: [SafetyChecklistIndividualPart.A],
        checklistItemNames: ['checklistA'],
        documentType: 'SAFETY_CHECKLIST_IAPH_V2_B_A',
        checklistPart: SafetyChecklistPart.A
    },
    {
        tabLabel: 'Part BCD',
        parts: [
            SafetyChecklistIndividualPart.B,
            SafetyChecklistIndividualPart.C,
            SafetyChecklistIndividualPart.D
        ],
        checklistItemNames: ['checklistB', 'checklistC', 'checklistD'],
        documentType: 'SAFETY_CHECKLIST_IAPH_V2_B_BCD',
        checklistPart: SafetyChecklistPart.BCD
    },
    {
        tabLabel: 'Part E',
        parts: [SafetyChecklistIndividualPart.E],
        checklistItemNames: ['checklistE'],
        documentType: 'SAFETY_CHECKLIST_IAPH_V2_B_E',
        checklistPart: SafetyChecklistPart.E
    },
    {
        tabLabel: 'Part F',
        parts: [SafetyChecklistIndividualPart.F],
        checklistItemNames: ['checklistF'],
        documentType: 'SAFETY_CHECKLIST_IAPH_V2_B_F',
        checklistPart: SafetyChecklistPart.F
    }
];
var TABS_TR56 = [
    {
        tabLabel: 'Part AB',
        parts: [SafetyChecklistIndividualPart.A, SafetyChecklistIndividualPart.B],
        checklistItemNames: ['checklistA', 'checklistB'],
        documentType: 'SAFETY_CHECKLIST_TR56_AB',
        checklistPart: SafetyChecklistPart.AB
    },
    {
        tabLabel: 'Part CD',
        parts: [SafetyChecklistIndividualPart.C, SafetyChecklistIndividualPart.D],
        checklistItemNames: ['checklistC', 'checklistD'],
        documentType: 'SAFETY_CHECKLIST_TR56_CD',
        checklistPart: SafetyChecklistPart.CD
    },
    {
        tabLabel: 'Part E',
        parts: [SafetyChecklistIndividualPart.E],
        checklistItemNames: ['checklistE'],
        documentType: 'SAFETY_CHECKLIST_TR56_E',
        checklistPart: SafetyChecklistPart.E
    }
];
var TABS_GOTHENBURG = [
    {
        tabLabel: 'Part AB',
        parts: [SafetyChecklistIndividualPart.A, SafetyChecklistIndividualPart.B],
        checklistItemNames: ['checklistA', 'checklistB'],
        documentType: 'SAFETY_CHECKLIST_GOTHENBURG_AB',
        checklistPart: SafetyChecklistPart.AB
    },
    {
        tabLabel: 'Part CDEF',
        parts: [
            SafetyChecklistIndividualPart.C,
            SafetyChecklistIndividualPart.D,
            SafetyChecklistIndividualPart.E,
            SafetyChecklistIndividualPart.F
        ],
        checklistItemNames: ['checklistC', 'checklistD', 'checklistE', 'checklistF'],
        documentType: 'SAFETY_CHECKLIST_GOTHENBURG_CDEF',
        checklistPart: SafetyChecklistPart.CDEF
    },
    {
        tabLabel: 'Part G',
        parts: [SafetyChecklistIndividualPart.G],
        checklistItemNames: ['checklistG'],
        documentType: 'SAFETY_CHECKLIST_GOTHENBURG_G',
        checklistPart: SafetyChecklistPart.G
    }
];
var getTransferDataTableInformation = function (PQU) {
    return [
        {
            label: 'Temperature of the fuel during bunkering:',
            field: 'temperature',
            unitType: 'temperature'
        },
        {
            label: 'Volume of fuel to be bunkered:',
            field: 'volume',
            additionalUnit: 'm3'
        },
        {
            label: 'Filling limit bunker tanks:',
            field: 'fillingLimit',
            additionalUnit: '%'
        },
        {
            label: 'Available tank capacity is sufficient for bunker volume:',
            field: 'sufficientCapacityCheckBunker'
        },
        {
            label: 'Starting rate:',
            field: 'startingRate',
            additionalUnit: (PQU || 'PQU') + " per hour"
        },
        {
            label: 'Max transfer rate:',
            field: 'maxTransferRate',
            additionalUnit: (PQU || 'PQU') + " per hour"
        },
        {
            label: 'Topping up rate:',
            field: 'toppingUpRate',
            additionalUnit: (PQU || 'PQU') + " per hour"
        },
        {
            label: 'Work pressure at manifold:',
            field: 'workPressure',
            unitType: 'pressure',
            additionalUnit: '(rel)'
        },
        {
            label: 'Max pressure at manifold:',
            field: 'maxPressure',
            unitType: 'pressure',
            additionalUnit: '(rel)'
        },
        {
            label: 'Bunker line work pressure:',
            field: 'bunkerLinePressure',
            unitType: 'pressure',
            additionalUnit: '(rel)'
        },
        {
            label: 'Max pressure bunker line:',
            field: 'maxBunkerLinePressure',
            unitType: 'pressure',
            additionalUnit: '(rel)'
        },
        {
            label: 'Max pressure bunker tank:',
            field: 'maxBunkerTankPressure',
            unitType: 'pressure',
            additionalUnit: '(rel)'
        }
    ];
};
var IAPH_V2_TANK_FACT_SHEET = [
    { label: 'Quantity per tank', field: 'presentQuantity', unitType: 'quantity' },
    { label: 'Temperature', field: 'temperature', unitType: 'temperature' },
    { label: 'Pressure', field: 'pressure', unitType: 'pressure' }
];
var IAPH_V2_TANK_FACT_SHEET_RECEIVING = [
    { label: 'Present fuel quantity bunker tank(s)', field: 'presentQuantity', unitType: 'quantity' },
    { label: 'Remaining capacity for bunkering', field: 'restCapacity', unitType: 'quantity' },
    { label: 'Temperature', field: 'temperature', unitType: 'temperature' },
    { label: 'Pressure', field: 'pressure', unitType: 'pressure' }
];
var externalSignerTypeIAPHv2 = function (type) {
    return type === SafetyChecklistType.IAPH_V2_A
        ? ExternalSignerRole.SITE_OPERATOR
        : ExternalSignerRole.TERMINAL_OPERATOR;
};
var namingIAPHv2Externalparty = function (type) {
    return screamingSnakeCaseToSentence(externalSignerTypeIAPHv2(type));
};

var JpboExternalSigning = function (props) {
    var _a, _b;
    var _c = useForm({
        initialValues: undefined,
        validate: validateSigningRequest,
        onValidSubmit: submitSignRequest
    }), handleSubmit = _c.handleSubmit, values = _c.values, errors = _c.errors, onChangeValue = _c.onChangeValue, isDifferentFromInitial = _c.isDifferentFromInitial;
    var officialName = screamingSnakeCaseToSentence(props.externalSignerType);
    return (React__default.createElement(FormWrapper, null,
        React__default.createElement(InlineFormElement, null,
            React__default.createElement(FormElement, null,
                React__default.createElement(FormLabel, null, "Party that drafted the JPBO"),
                React__default.createElement(SelectionBox, { fieldName: 'jpboPartyUserId', placeholder: 'Select signer...', valueKey: "value", displayKey: "text", renderOption: function (option) {
                        return React__default.createElement("div", null, option.text);
                    }, dropUp: true, onChangeValue: function (captain) {
                        onChangeValue('jpboPartyUserId', captain === null || captain === void 0 ? void 0 : captain.value);
                    }, value: (values === null || values === void 0 ? void 0 : values.jpboPartyUserId) || undefined, options: __spreadArrays(props.bunkerShipProfiles, props.counterSigningProfiles).map(function (captain) {
                        return { text: captain.email, value: captain._id };
                    }), disabled: props.readOnly }),
                React__default.createElement(FormErrorMessage, null, errors ? errors.jpboPartyUserId : ''))),
        React__default.createElement(InlineFormElement, null,
            React__default.createElement(FormElement, null,
                React__default.createElement(FormLabel, { fieldName: "name" }, officialName + " name"),
                React__default.createElement(TextField, { fieldName: "name", value: ((_a = values === null || values === void 0 ? void 0 : values.terminalUser) === null || _a === void 0 ? void 0 : _a.name) || '', onChange: function (e) {
                        onChangeValue('terminalUser.name', e.target.value);
                    }, disabled: props.readOnly }),
                React__default.createElement(FormErrorMessage, null, errors ? errors.name : '')),
            React__default.createElement(FormElement, null,
                React__default.createElement(FormLabel, { fieldName: "email" }, officialName + " email"),
                React__default.createElement(TextField, { fieldName: "email", value: ((_b = values === null || values === void 0 ? void 0 : values.terminalUser) === null || _b === void 0 ? void 0 : _b.email) || '', onChange: function (e) {
                        onChangeValue('terminalUser.email', e.target.value);
                    }, onBlur: function () { return onChangeValue('terminalUser.role', props.externalSignerType); }, disabled: props.readOnly }),
                React__default.createElement(FormErrorMessage, null, errors ? errors.email : ''))),
        React__default.createElement(Button, { primary: true, className: "initiate-signing-button", preventDoubleClick: true, disabled: !isDifferentFromInitial, onClick: function (e) {
                e.preventDefault();
                handleSubmit();
            } }, "Initiate signing")));
    function validateSigningRequest(jpboExternalSignRequest) {
        var errors = {};
        if (!jpboExternalSignRequest.jpboPartyUserId) {
            errors['jpboPartyUserId'] = 'Please choose a user to sign';
        }
        if (!jpboExternalSignRequest.terminalUser.email) {
            errors['email'] = "Please provide a email for the " + officialName;
        }
        if (!jpboExternalSignRequest.terminalUser.name) {
            errors['name'] = "Please provide a name for the " + officialName;
        }
        return errors;
    }
    function submitSignRequest(jpboExternalSignRequest) {
        props.initiateSigningFlow(jpboExternalSignRequest);
    }
};

var DocumentSigning = function (props) {
    var _a = useState(props.document), file = _a[0], setFile = _a[1];
    var _b = useState([]), bunkerShipProfiles = _b[0], setBunkerShipProfiles = _b[1];
    var _c = useState([]), counterSigningProfiles = _c[0], setCounterSigningProfiles = _c[1];
    var _d = useState([]), pipelineProfiles = _d[0], setPipelineProfiles = _d[1];
    var _e = useState(true), externalSupplier = _e[0], setExternalSupplier = _e[1];
    var userPermissions = useContext(UserPermissionContext).userPermissions;
    useEffect(function () {
        fetchShipUserProfiles(props.itemWithDocuments);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.itemWithDocuments]);
    useEffect(function () {
        setFile(props.document);
    }, [props.document]);
    useEffect(function () {
        var timeout = setTimeout(function () {
            var _a;
            if (!props.disableScrollInView)
                (_a = document.getElementById("signing-wrapper-" + file._id)) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
                    behavior: 'smooth',
                    block: 'end'
                });
        }, props.scrollInFocusTimeout || 0);
        return function () { return clearTimeout(timeout); };
    }, []);
    if (file.signingStatus === 'UNSIGNED') {
        var isSafetyChecklist = file.type.startsWith('SAFETY_CHECKLIST_');
        if ((file.type === 'EBDN' && !doesUserHavePermission(userPermissions, 'EBDN_INITIATE_SIGNING')) ||
            (isSafetyChecklist && !doesUserHavePermission(userPermissions, 'IAPH_INITIATE_SIGNING')) ||
            (file.type === 'STATEMENT_OF_FACTS' &&
                !doesUserHavePermission(userPermissions, 'SOF_INITIATE_SIGNING')) ||
            (['NOR_BUNKERSHIP', 'NOR_RECEIVINGSHIP'].includes(file.type) &&
                !doesUserHavePermission(userPermissions, 'NOR_INITIATE_SIGNING'))) {
            return null;
        }
        if (!SIGNED_DOCUMENT_TYPES.includes(file.type)) {
            return null;
        }
        var isTerminalChecklist = file.type === 'SAFETY_CHECKLIST_IAPH_F';
        var optionalOfficialGothenburg = [
            'SAFETY_CHECKLIST_GOTHENBURG_AB',
            'SAFETY_CHECKLIST_GOTHENBURG_CDEF'
        ].includes(file.type);
        var optionalOfficialTR56 = file.type.startsWith('SAFETY_CHECKLIST_TR56_');
        var terminalOperator = file.type.startsWith('SAFETY_CHECKLIST_IAPH_V2_A');
        var optionOfficial = optionalOfficialGothenburg ||
            optionalOfficialTR56 ||
            props.document.type.startsWith('SAFETY_CHECKLIST_IAPH_V2_B');
        var showBunkerShip = props.document.type !== 'NOR_BUNKERSHIP' && props.document.type !== 'MASTERS_REQUISITION_FORM';
        var hasExternalSigner = instanceOfNominationTimelineItem(props.itemWithDocuments) &&
            props.itemWithDocuments.deliveryMode !== 'SHIP' &&
            showBunkerShip &&
            props.document.type !== 'NOR_BUNKERSHIP';
        var externalSignerType = optionalOfficialGothenburg
            ? ExternalSignerRole.PORT_OFFICIAL
            : externalSignerTypeIAPHv2(terminalOperator ? SafetyChecklistType.IAPH_V2_A : undefined);
        var terminalInformationSheetIAPHv2B = props.document.type === 'SAFETY_CHECKLIST_IAPH_V2_B_A';
        return (React__default.createElement("div", { className: "signing-wrapper", id: "signing-wrapper-" + file._id },
            React__default.createElement("h3", { className: "title" }, "Document Signing"),
            React__default.createElement("p", null, "Select the parties responsible for signing the document to start the signing process. All parties will get an email with signing instructions."),
            terminalInformationSheetIAPHv2B && (React__default.createElement(JpboExternalSigning, { readOnly: props.readOnly, initiateSigningFlow: initiateJpboSigningFlow, bunkerShipProfiles: hasExternalSigner ? pipelineProfiles : bunkerShipProfiles, counterSigningProfiles: counterSigningProfiles, externalSignerType: ExternalSignerRole.TERMINAL_OPERATOR })),
            !terminalInformationSheetIAPHv2B && hasExternalSigner && (React__default.createElement(InlineFormElement, null,
                React__default.createElement(FormElement, null,
                    React__default.createElement(Checkbox, { label: 'External supplier', value: externalSupplier, field: "external-supplier-checkbox-" + props.document._id, onChange: function () {
                            setExternalSupplier(function (old) { return !old; });
                        } })))),
            !terminalInformationSheetIAPHv2B && isTerminalChecklist && (React__default.createElement(TerminalSigning, { readOnly: props.readOnly, initiateSigningFlow: initiatePartFSigningFlow })),
            !terminalInformationSheetIAPHv2B &&
                !isTerminalChecklist &&
                (!hasExternalSigner || !externalSupplier) && (React__default.createElement(ShipToShipSigning, { readOnly: props.readOnly, initiateSigningFlow: initiateSigningFlow, bunkerShipProfiles: hasExternalSigner ? pipelineProfiles : bunkerShipProfiles, assetName: hasExternalSigner ? 'Supplier' : 'Bunker vessel', counterSigningProfiles: counterSigningProfiles, eventType: props.itemWithDocuments._type, optionalOfficial: optionOfficial, externalSignerType: externalSignerType, documentId: props.document._id || '', showBunkerShip: showBunkerShip, showReceivingShip: props.document.type !== 'NOR_RECEIVINGSHIP', terminalOperator: terminalOperator })),
            !terminalInformationSheetIAPHv2B &&
                !isTerminalChecklist &&
                hasExternalSigner &&
                externalSupplier && (React__default.createElement(ExternalSigning, { readOnly: props.readOnly, counterSigningProfiles: counterSigningProfiles, initiateSigningFlow: initiateSigningFlow, optionalOfficial: optionOfficial, externalSignerType: externalSignerType, documentId: props.document._id || '' }))));
    }
    else if (!props.onlyShowInitiate) {
        return (React__default.createElement("div", { className: "signing-wrapper" },
            React__default.createElement("h3", { className: "title" }, "Document Signing"),
            React__default.createElement("p", null, "Signing process has been initiated. You can find the status of each users signature below."),
            React__default.createElement("div", { className: "signing-overview" },
                Object.keys(file.signerStatus).map(function (signerId, index) {
                    var signingUser = file.signers.find(function (x) { return x._id === signerId; });
                    var signingStatus = file.signerStatus[signerId];
                    if (signingUser) {
                        return (React__default.createElement("div", { className: "user-sign", key: 'user-signature' + signerId + index },
                            React__default.createElement("div", { className: "inner-wrapper" },
                                React__default.createElement("div", { className: "status signing-status " + signingStatus },
                                    renderSigningIcon(signingStatus),
                                    signingStatus.replace(/[_-]/g, ' ')),
                                React__default.createElement("div", { className: "user-info" },
                                    React__default.createElement("h3", null, signingUser.name),
                                    React__default.createElement("h4", null, signingUser.email)))));
                    }
                    else {
                        return null;
                    }
                }),
                Object.keys(file.externalSignerStatus).map(function (signerEmail, index) {
                    var signingStatus = file.externalSignerStatus[signerEmail];
                    return (React__default.createElement("div", { className: "user-sign", key: 'user-signature' + signerEmail + index },
                        React__default.createElement("div", { className: "inner-wrapper" },
                            React__default.createElement("div", { className: "status signing-status " + signingStatus },
                                renderSigningIcon(signingStatus),
                                signingStatus.replace(/[_-]/g, ' ')),
                            React__default.createElement("div", { className: "user-info" },
                                React__default.createElement("h3", null, signerEmail)))));
                }))));
    }
    else {
        return null;
    }
    function initiateJpboSigningFlow(jpboExternalSignRequest) {
        return __awaiter(this, void 0, void 0, function () {
            var documentWithSigning, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(props.eventId && file._id)) return [3 /*break*/, 5];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, signIAPHPartATIS(props.authenticationService, props.eventId, file._id, jpboExternalSignRequest)];
                    case 2:
                        documentWithSigning = _a.sent();
                        if (documentWithSigning) {
                            setFile(documentWithSigning);
                            if (props.fetchItem) {
                                props.fetchItem();
                            }
                            toast.success('Signing Initiated');
                        }
                        else {
                            toast.error('Document signing could not be started.');
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        handleFetchError(error_1);
                        return [3 /*break*/, 4];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        toast.error('PartF signing could not be started.');
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    }
    function initiateSigningFlow(internalSigners, externalSigners) {
        return __awaiter(this, void 0, void 0, function () {
            var documentWithSigning, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(props.eventId && file._id)) return [3 /*break*/, 5];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, signDocument(props.authenticationService, props.itemWithDocuments, file._id, file.type, internalSigners === null || internalSigners === void 0 ? void 0 : internalSigners.supplierUserId, (internalSigners === null || internalSigners === void 0 ? void 0 : internalSigners.customerUserId) || (externalSigners === null || externalSigners === void 0 ? void 0 : externalSigners.customerUserId), externalSigners === null || externalSigners === void 0 ? void 0 : externalSigners.externalSupplier, (internalSigners === null || internalSigners === void 0 ? void 0 : internalSigners.otherExternalSigners) || (externalSigners === null || externalSigners === void 0 ? void 0 : externalSigners.otherExternalSigners))];
                    case 2:
                        documentWithSigning = _a.sent();
                        if (documentWithSigning) {
                            setFile(documentWithSigning);
                            if (props.fetchItem) {
                                props.fetchItem();
                            }
                            toast.success('Signing Initiated');
                        }
                        else {
                            toast.error('Document signing could not be started.');
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        handleFetchError(error_2);
                        return [3 /*break*/, 4];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        toast.error('Document signing could not be started.');
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    }
    function initiatePartFSigningFlow(externalSigner) {
        return __awaiter(this, void 0, void 0, function () {
            var documentWithSigning, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(props.eventId && file._id)) return [3 /*break*/, 5];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, signIAPHPartF(props.authenticationService, props.eventId, file._id, externalSigner)];
                    case 2:
                        documentWithSigning = _a.sent();
                        if (documentWithSigning) {
                            setFile(documentWithSigning);
                            if (props.fetchItem) {
                                props.fetchItem();
                            }
                            toast.success('Signing Initiated');
                        }
                        else {
                            toast.error('Document signing could not be started.');
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_3 = _a.sent();
                        handleFetchError(error_3);
                        return [3 /*break*/, 4];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        toast.error('PartF signing could not be started.');
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    }
    function fetchShipUserProfiles(itemWithDocuments) {
        return __awaiter(this, void 0, void 0, function () {
            var bunkerVesselProfiles, counterSigners, pipelineProfiles_1, pipelineId, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 9, , 10]);
                        bunkerVesselProfiles = [];
                        counterSigners = [];
                        pipelineProfiles_1 = [];
                        if (!(instanceOfNominationTimelineItem(itemWithDocuments) &&
                            itemWithDocuments.receivingShipId)) return [3 /*break*/, 2];
                        return [4 /*yield*/, getProfilesByShipId(props.authenticationService, itemWithDocuments.receivingShipId)];
                    case 1:
                        counterSigners = _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, getProfilesByLocationId(props.authenticationService, itemWithDocuments.locationId)];
                    case 3:
                        counterSigners = _a.sent();
                        _a.label = 4;
                    case 4:
                        if (!itemWithDocuments.bunkerShipId) return [3 /*break*/, 6];
                        return [4 /*yield*/, getProfilesByBunkerShipId(props.authenticationService, itemWithDocuments.bunkerShipId)];
                    case 5:
                        bunkerVesselProfiles = _a.sent();
                        _a.label = 6;
                    case 6:
                        pipelineId = itemWithDocuments.pipelineId || itemWithDocuments.loadingTerminalId;
                        if (!pipelineId) return [3 /*break*/, 8];
                        return [4 /*yield*/, getProfilesByPipelineId(pipelineId)];
                    case 7:
                        pipelineProfiles_1 = _a.sent();
                        if (pipelineProfiles_1.length > 0)
                            setExternalSupplier(false);
                        _a.label = 8;
                    case 8:
                        setBunkerShipProfiles(bunkerVesselProfiles.filter(function (profile) { return profile.active; }));
                        setCounterSigningProfiles(counterSigners.filter(function (profile) { return profile.active; }));
                        setPipelineProfiles(pipelineProfiles_1.filter(function (profile) { return profile.active; }));
                        return [3 /*break*/, 10];
                    case 9:
                        error_4 = _a.sent();
                        handleFetchError(error_4);
                        return [3 /*break*/, 10];
                    case 10: return [2 /*return*/];
                }
            });
        });
    }
    function getProfilesByPipelineId(id) {
        var options = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        return props.authenticationService.fetchApiCall("/profiles/byPipeline/" + id, options);
    }
};
var DocumentSigning$1 = React__default.memo(DocumentSigning);

var DocumentBlock = function (props) {
    var document = props.document;
    var _a = useState(false), showSigningProcess = _a[0], setShowSigningProcess = _a[1];
    var userPermissions = useContext(UserPermissionContext).userPermissions;
    var _b = useSignRequestUrlService(document, props.userProfile, props.authenticationService), signRequestURL = _b.signRequestURL, loading = _b.loading, error = _b.error, alreadySignedByCurrentUser = _b.alreadySignedByCurrentUser, canCurrentUserSign = _b.canCurrentUserSign, signerStatus = _b.signerStatus;
    var readableDocumentType = getReadableDocumentType(document.type);
    var ItemPromptNomination = props.itemWithDocuments;
    var userIsOperatorOrScheduler = props.userProfile &&
        (isOperator(props.userProfile.roles) || isScheduler(props.userProfile.roles))
        ? true
        : false;
    var singableDocument = SIGNED_DOCUMENT_TYPES.includes(document.type) &&
        userIsOperatorOrScheduler &&
        ItemPromptNomination.eventId &&
        document.signingStatus === 'UNSIGNED';
    var userCanInitateSigning = (document.type === 'EBDN' &&
        doesUserHavePermission(userPermissions, 'EBDN_INITIATE_SIGNING')) ||
        (document.type.startsWith('SAFETY_CHECKLIST_') &&
            doesUserHavePermission(userPermissions, 'IAPH_INITIATE_SIGNING')) ||
        (document.type === 'STATEMENT_OF_FACTS' &&
            doesUserHavePermission(userPermissions, 'SOF_INITIATE_SIGNING'));
    var allowInitiateSigning = singableDocument && userCanInitateSigning;
    var documentStatusProblem = signerStatus === 'CANCELLED' || signerStatus === 'DECLINED' || signerStatus === 'ERROR';
    return (React__default.createElement("div", { className: "document-wrapper " + (props.className || '') + " " + (props.showLatestNotification ? 'highlight' : '') },
        React__default.createElement("div", { className: "document-title" },
            React__default.createElement("div", null,
                React__default.createElement("h3", null, props.document.filename ? props.document.filename : readableDocumentType),
                SIGNED_DOCUMENT_TYPES.includes(props.document.type) && (React__default.createElement("div", { className: "document-type  " + document.signingStatus },
                    React__default.createElement("div", { className: "signing-indicator signing-status " + document.signingStatus }),
                    getReadableSigningStatus(document.signingStatus))),
                props.showLatestNotification && (React__default.createElement("span", { className: "latest-version-notification" }, "Latest version")))),
        React__default.createElement("div", { className: "document-details" },
            React__default.createElement("div", { className: "document-name word-wrap" }, readableDocumentType),
            React__default.createElement("div", { className: "document-creation" },
                React__default.createElement("span", null, props.getUserNameFromFile(document.userId)),
                " -",
                ' ',
                React__default.createElement("span", null, formatDateTime(document.uploadDate)))),
        React__default.createElement("div", { className: "document-buttons" },
            renderInitiateSigningButton(),
            canCurrentUserSign && renderSignRequestButton(),
            React__default.createElement(Button$1, { className: "view", onClick: startEditingDocument }, "View"),
            React__default.createElement(Button$1, { className: "download", onClick: function () {
                    return props.downloadFile(props.authenticationService, props.document, props.itemWithDocuments['eventId'] || props.itemWithDocuments._id || undefined);
                } }, "Download")),
        error && React__default.createElement("div", { className: "error" },
            "Fetch error: ",
            error),
        documentStatusProblem && (React__default.createElement("div", { className: "error" },
            "Document status is ",
            documentStatusProblem)),
        showSigningProcess && allowInitiateSigning && (React__default.createElement("div", { className: "inner-content" },
            React__default.createElement(DocumentSigning$1, { itemWithDocuments: ItemPromptNomination, document: document, eventId: ItemPromptNomination.eventId, userProfile: props.userProfile, readOnly: false, authenticationService: props.authenticationService, onlyShowInitiate: true, fetchItem: props.refetchDocument })))));
    function renderInitiateSigningButton() {
        if (allowInitiateSigning) {
            return (React__default.createElement(Button$1, { secondary: true, className: "state-assign-signers", onClick: function () { return setShowSigningProcess(!showSigningProcess); } }, "Assign signers"));
        }
    }
    function renderSignRequestButton() {
        if (signerStatus === 'PROCESSING' || signerStatus === 'AWAITING_CALLBACK') {
            return (React__default.createElement(Button$1, { className: "state-processing" },
                React__default.createElement(FontAwesomeIcon, { icon: faSpinner, pulse: true }),
                " Processing"));
        }
        if (loading) {
            return (React__default.createElement(Button$1, { className: "state-loading" },
                React__default.createElement(FontAwesomeIcon, { icon: faSpinner, pulse: true })));
        }
        if (error || documentStatusProblem) {
            return (React__default.createElement(Button$1, { className: "state-error" },
                React__default.createElement(FontAwesomeIcon, { icon: faExclamationCircle })));
        }
        if (signRequestURL) {
            if (!alreadySignedByCurrentUser) {
                return (React__default.createElement(Button$1, { secondary: true, className: "state-sign", onClick: function () { return window.location.replace(signRequestURL); } }, "Sign"));
            }
            else {
                return (React__default.createElement(Button$1, { success: true, className: "state-signed" }, "Signed"));
            }
        }
    }
    function startEditingDocument() {
        props.editDocumentDetails({
            active: true,
            document: document
        });
    }
};

var DocumentDetails = function (props) {
    var document = props.document;
    var documentToSign = props.itemWithDocuments;
    var _a = useState(props.document.filename), fileName = _a[0], setFileName = _a[1];
    var canDocumentBeDeleted = document.signingStatus !== 'SIGNED';
    var canUserDeleteFile = canDocumentBeDeleted && props.userProfile && props.userProfile._id === document.userId
        ? // doesUserHavePermission(userPermissions, 'DOCUMENT_DELETE')
            true
        : false;
    var userIsOperatorOrScheduler = props.userProfile &&
        (isOperator(props.userProfile.roles) || isScheduler(props.userProfile.roles))
        ? true
        : false;
    var creationDate = formatDateTime(document.uploadDate);
    return (React__default.createElement("div", null,
        props.getUserNameFromFile && (React__default.createElement("span", { className: "subtitle" }, "Created by " + props.getUserNameFromFile(document.userId) + " - " + creationDate)),
        React__default.createElement(FormWrapper, null,
            React__default.createElement(FormElement, null,
                React__default.createElement(FormLabel, { fieldName: "name" }, "Document name"),
                React__default.createElement(FormFieldButtonWrapper, null,
                    React__default.createElement(TextField, { fieldName: "name", value: fileName, onChange: function (e) {
                            setFileName(e.target.value);
                        } }),
                    React__default.createElement(Button, { preventDoubleClick: true, primary: true, onClick: function () {
                            updateFile(fileName);
                        }, disabled: props.readOnly }, "Save changes")),
                React__default.createElement(FormErrorMessage, { errorMessage: undefined }))),
        SIGNED_DOCUMENT_TYPES.includes(document.type) &&
            userIsOperatorOrScheduler &&
            documentToSign.eventId && (React__default.createElement("div", { className: "inner-content" },
            React__default.createElement(DocumentSigning$1, { itemWithDocuments: props.itemWithDocuments, document: document, eventId: documentToSign.eventId, fetchItem: props.refetchEvent, userProfile: props.userProfile, readOnly: props.readOnly !== undefined ? props.readOnly : false, authenticationService: props.authenticationService }))),
        React__default.createElement(ButtonGroup, null,
            React__default.createElement(Button, { preventDoubleClick: true, primary: true, disabled: props.readOnly, onClick: function () {
                    props.downloadFile(props.authenticationService, document, props.itemWithDocuments['eventId'] || props.itemWithDocuments._id || undefined);
                } }, "Download document"),
            canUserDeleteFile && (React__default.createElement(Button, { preventDoubleClick: true, danger: true, disabled: props.readOnly, outline: true, onClick: function () {
                    props.deleteDocument(document);
                } }, "Delete document")))));
    function updateFile(updatedFileName) {
        if (updatedFileName) {
            var documentToUpdate = cloneDeep(props.document);
            documentToUpdate.filename = updatedFileName;
            props.editDocument(documentToUpdate);
            toast.success('Document Saved');
        }
    }
};

function downloadFile(authenticationService, file, eventId) {
    if (file._id) {
        downloadFileFromBackend(authenticationService, file._id, file.filename, eventId);
    }
    else {
        toast.error('Cannot download file: file id is undefined');
    }
}

var DocumentViewer = function (props) {
    var _a = useState({
        active: false,
        document: undefined
    }), documentDetailsActive = _a[0], setDocumentDetailsActive = _a[1];
    useEffect(function () {
        if (documentDetailsActive.active === true) {
            var activeDocument_1 = documentDetailsActive.document;
            var updatedDocuments = props.eventWithDocuments.documents;
            if (updatedDocuments && activeDocument_1) {
                var foundDocument = updatedDocuments.find(function (x) { return x._id === activeDocument_1._id; });
                if (foundDocument) {
                    setDocumentDetailsActive({
                        active: true,
                        document: foundDocument
                    });
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.eventWithDocuments]);
    var documents = props.eventWithDocuments.documents || [];
    var filteredDocuments = documents.filter(function (document) {
        return props.allowedDocumentTypes.includes(document.type);
    });
    return (React__default.createElement(React__default.Fragment, null,
        props.title && React__default.createElement("h4", null, props.title),
        React__default.createElement("div", { className: "document-viewer-wrapper " + (props.withWrapper ? 'bg-wrapper' : '') }, filteredDocuments.map(function (document, index) {
            var isLatestSignableDocument = SIGNED_DOCUMENT_TYPES.includes(document.type) && filteredDocuments.length === index + 1;
            return (React__default.createElement(DocumentBlock, { key: 'documentblock' + index, document: document, showLatestNotification: isLatestSignableDocument, getUserNameFromFile: props.getUserNameFromFile, editDocumentDetails: setDocumentDetailsActive, downloadFile: downloadFile, userProfile: props.userProfile, authenticationService: props.authenticationService, itemWithDocuments: props.eventWithDocuments, refetchDocument: props.refetchEvent }));
        })),
        documentDetailsActive.document && (React__default.createElement(Dialog, { type: "medium", title: getReadableDocumentType(documentDetailsActive.document.type), titleIcon: React__default.createElement(Icon, null,
                React__default.createElement(FontAwesomeIcon, { icon: faFile })), 
            // className="chorus-component default-modal small"
            showDialog: documentDetailsActive.active && documentDetailsActive.document ? true : false, onCloseDialog: function () {
                setDocumentDetailsActive({ active: false, document: undefined });
            } },
            React__default.createElement(DocumentDetails, { authenticationService: props.authenticationService, readOnly: props.readOnly, document: documentDetailsActive.document, editDocument: props.editDocument, deleteDocument: function (document) {
                    props.deleteDocument(document);
                    setDocumentDetailsActive({ active: false, document: undefined });
                }, userProfile: props.userProfile, downloadFile: downloadFile, itemWithDocuments: props.eventWithDocuments, refetchEvent: props.refetchEvent, getUserNameFromFile: props.getUserNameFromFile })))));
};

var ALLOWED_FILE_MIME_TYPES = [
    'image/jpeg',
    'image/png',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/pdf',
    'application/msword'
];
var FileDrop = /** @class */ (function (_super) {
    __extends(FileDrop, _super);
    function FileDrop(props) {
        var _this = _super.call(this, props) || this;
        _this.handleFileDrop = function (e) {
            e.preventDefault();
            e.stopPropagation();
            var fileList = getDataTransferItems(e);
            if (fileList[0]) {
                if (_this.isFileWithinMaximumSize(fileList[0])) {
                    _this.setState({ dragOver: false, fileList: fileList, timesUploaded: _this.state.timesUploaded + 1 });
                    _this.fillInTitle(fileList[0]);
                }
            }
        };
        _this.onFileUpload = function (e) {
            if (e.target.files[0] && _this.isFileWithinMaximumSize(e.target.files[0])) {
                _this.setState({ fileList: e.target.files, timesUploaded: _this.state.timesUploaded + 1 });
                _this.fillInTitle(e.target.files[0]);
            }
        };
        _this.isFileWithinMaximumSize = function (file) {
            if (file.size && _this.props.maxFileSize && file.size > _this.props.maxFileSize) {
                var maxMB = Math.round(_this.props.maxFileSize / 1000000);
                toast.error('The file size exceeds the limit allowed and cannot be saved. The maximum file size is ' +
                    maxMB +
                    ' MB', { autoClose: 5000 });
                return false;
            }
            return true;
        };
        _this.fillInTitle = function (file) {
            if (file) {
                // eslint-disable-next-line
                var fileExtension = file.name.split(/\.(?=[^\.]+$)/)[0];
                _this.setState({ fileExtension: fileExtension, title: file.name });
            }
        };
        _this.clearUpload = function () {
            _this.setState({ dragOver: false, fileList: undefined, timesUploaded: 0 });
        };
        _this.handleDragOver = function (e, status) {
            e.preventDefault();
            e.stopPropagation();
            _this.setState({ dragOver: status });
        };
        _this.onFormSubmit = function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (_this.state.fileList && _this.state.fileList[0]) {
                var fileToUpload = _this.state.fileList[0];
                var fileTitle = _this.state.title ? _this.state.title : fileToUpload.name;
                // eslint-disable-next-line
                var titleExtension = fileTitle.split(/\.(?=[^\.]+$)/)[0];
                if (titleExtension !== _this.state.fileExtension) {
                    fileTitle += '.' + _this.state.fileExtension;
                }
                // fileToUpload.name = fileTitle
                var type = fileToUpload.type;
                var blob = fileToUpload.slice(0, -1, type);
                _this.props.fileUpdated(blob, fileTitle);
                _this.setState({ fileList: undefined, title: '' });
            }
        };
        _this.state = {
            dragOver: false,
            title: '',
            fileExtension: undefined,
            timesUploaded: 0 // needed to make sure the component rerenders after saving and uploading a file
        };
        return _this;
    }
    FileDrop.prototype.render = function () {
        var _this = this;
        var _a;
        var formStatusClass = '';
        formStatusClass += this.state.dragOver ? 'active-dragover' : '';
        var fileTypeAllowed = ((_a = this.state.fileList) === null || _a === void 0 ? void 0 : _a[0]) && ALLOWED_FILE_MIME_TYPES.includes(this.state.fileList[0].type);
        return (createElement("div", { className: "FileDrop" },
            createElement("form", { onDrop: this.handleFileDrop, onDragOver: function (e) { return _this.handleDragOver(e, true); }, onDragLeave: function (e) { return _this.handleDragOver(e, false); } },
                createElement("div", { className: 'box file-drop-wrapper ' + formStatusClass },
                    createElement("input", { key: this.state.timesUploaded, className: "box__file", type: "file", accept: this.props.acceptedFileType || '', name: "files[]", id: this.props.fileDropId, onChange: this.onFileUpload, "data-multiple-caption": "{count} files selected", multiple: false, size: this.props.maxFileSize }),
                    createElement("label", { htmlFor: this.props.fileDropId }, this.state.fileList && this.state.fileList.length ? (createElement("div", null,
                        createElement(Icon, null,
                            createElement(FontAwesomeIcon, { icon: faFileAlt })),
                        createElement("span", null,
                            createElement("strong", null, this.state.fileList[0].name),
                            ' ',
                            fileTypeAllowed ? 'is selected' : 'has an unsupported file type'),
                        fileTypeAllowed ? (createElement(Button, { onClick: this.onFormSubmit, preventDoubleClick: true, primary: true, disabled: isEmpty$1(this.state.fileList) || isEmpty$1(this.state.title) }, this.props.loadingFileUpload ? (createElement(FontAwesomeIcon, { icon: faSpinner, spin: true })) : ('Upload'))) : (createElement(Button, { onClick: this.clearUpload, preventDoubleClick: true, danger: true, disabled: isEmpty$1(this.state.fileList) || isEmpty$1(this.state.title) }, "Clear file")))) : (createElement("span", { className: "box__dragndrop" },
                        createElement("strong", null, "Choose a file "),
                        " or drag it here")))))));
    };
    return FileDrop;
}(PureComponent));
function getDataTransferItems(event) {
    var dataTransferItemsList = [];
    if (event.dataTransfer) {
        var dt = event.dataTransfer;
        if (dt.files && dt.files.length) {
            dataTransferItemsList = dt.files;
        }
        else if (dt.items && dt.items.length) {
            // During the drag even the dataTransfer.files is null
            // but Chrome implements some drag store, which is accesible via dataTransfer.items
            dataTransferItemsList = dt.items;
        }
    }
    else if (event.target && event.target.files) {
        dataTransferItemsList = event.target.files;
    }
    // Convert from DataTransferItemsList to the native Array
    return Array.prototype.slice.call(dataTransferItemsList);
}

var DocumentUpload = function (props) {
    var _a = useState(false), uploading = _a[0], setUploading = _a[1];
    var _b = useState(100), maxFileSize = _b[0], setMaxFileSize = _b[1];
    useEffect(function () {
        fetchtMaxDocumentSize();
    }, []);
    return (React__default.createElement("div", { className: "document-upload-wrapper" },
        props.title && React__default.createElement("h4", null, props.title),
        React__default.createElement(FileDrop, { fileUpdated: handleFileUpload, loadingFileUpload: uploading, fileDropId: props.fileDropId, acceptedFileType: props.acceptedFileType, maxFileSize: maxFileSize })));
    /**
     * Handles the uploading of a file with the supplied uploadFile function
     * Requires the uploadFile function passed through the props so every component can handle the saving itself.
     */
    function handleFileUpload(file, fileName) {
        return __awaiter(this, void 0, void 0, function () {
            var userProfile, itemWithDocuments, companyId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setUploading(true);
                        userProfile = props.userProfile;
                        itemWithDocuments = props.eventWithDocuments;
                        companyId = itemWithDocuments && instanceOfNominationTimelineItem(itemWithDocuments)
                            ? itemWithDocuments.companyId
                            : userProfile
                                ? userProfile.companyId
                                : undefined;
                        if (!userProfile || !companyId) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, props.uploadFile(file, props.uploadFileType, itemWithDocuments, companyId, fileName)];
                    case 1:
                        _a.sent();
                        setUploading(false);
                        return [2 /*return*/];
                }
            });
        });
    }
    function fetchtMaxDocumentSize() {
        return __awaiter(this, void 0, void 0, function () {
            var maxFileSize_1, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, getMaxDocumentSize(props.authenticationService)];
                    case 1:
                        maxFileSize_1 = _a.sent();
                        setMaxFileSize(maxFileSize_1);
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        handleFetchError(err_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
};

var DocumentHandler = function (props) {
    var _a = useState([]), userProfiles = _a[0], setUserProfiles = _a[1];
    var userPermissions = useContext(UserPermissionContext).userPermissions;
    useEffect(function () {
        getAllUserProfiles();
    }, []);
    var documents = props.eventWithDocuments.documents ? props.eventWithDocuments.documents : [];
    var documentsAmount = documents.filter(function (document) {
        return props.allowedDocumentTypes.includes(document.type);
    }).length;
    return (React__default.createElement("div", { className: props.className || '' },
        props.uploadActive && doesUserHavePermission(userPermissions, 'DOCUMENT_CREATE') && (React__default.createElement(DocumentUpload, { authenticationService: props.authenticationService, eventWithDocuments: props.eventWithDocuments, uploadFile: props.uploadFile, fileDropId: props.uploadId, userProfile: props.userProfile, uploadFileType: props.uploadFileType, title: props.uploadTitle, acceptedFileType: props.acceptedFileType })),
        documentsAmount > 0 &&
            props.viewerActive !== false &&
            doesUserHavePermission(userPermissions, 'DOCUMENT_VIEW') && (React__default.createElement(DocumentViewer, { authenticationService: props.authenticationService, documents: documents, getUserNameFromFile: getUserNameFromFile, allowedDocumentTypes: props.allowedDocumentTypes, editDocument: editDocumentValues, deleteDocument: deleteDocumentFromEvent, userProfile: props.userProfile, eventWithDocuments: props.eventWithDocuments, refetchEvent: props.refetchEvent, withWrapper: props.withWrapper, title: props.viewerTitle, readOnly: props.readOnly })),
        props.hideEmptyMessage !== true && documentsAmount === 0 && props.viewerActive !== false && (React__default.createElement("h3", { className: "no-document-message" }, "No documents have been uploaded here yet."))));
    function editDocumentValues(updatedFile) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                editDocument(updatedFile, props.authenticationService, props.refetchEvent);
                return [2 /*return*/];
            });
        });
    }
    function deleteDocumentFromEvent(file) {
        return __awaiter(this, void 0, void 0, function () {
            var isNomination, removeDocumentFromNomination;
            return __generator(this, function (_a) {
                if (!file._id)
                    return [2 /*return*/];
                isNomination = !!props.eventWithDocuments['eventId'];
                removeDocumentFromNomination = function () {
                    return removeDocuments(props.authenticationService, props.eventWithDocuments['eventId'], [
                        file._id
                    ]);
                };
                deleteDocument(file, props.eventWithDocuments, props.refetchEvent, isNomination ? removeDocumentFromNomination : props.updateItem, props.userProfile);
                return [2 /*return*/];
            });
        });
    }
    function getAllUserProfiles() {
        return __awaiter(this, void 0, void 0, function () {
            var usersList, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, getAllProfiles(props.authenticationService)];
                    case 1:
                        usersList = _a.sent();
                        setUserProfiles(usersList);
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        handleFetchError(err_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    function getUserNameFromFile(userId) {
        if (userProfiles) {
            var matchingUser = userProfiles.find(function (user) { return user._id === userId; });
            if (matchingUser) {
                return matchingUser.name;
            }
        }
        return 'Unknown User';
    }
};

var CustomerEnquiryForm = function (props) {
    // Properties
    var currentUser = props.currentUser, errors = props.errors, values = props.values, prevValues = props.prevValues, getPreviousDeliveryMode = props.getPreviousDeliveryMode, getPreviousValueLabel = props.getPreviousValueLabel, onChangeDateTimeValue = props.onChangeDateTimeValue, onChangeFormValue = props.onChangeFormValue, onChangeDeliveryMode = props.onChangeDeliveryMode;
    var timezone = useLocationTimeZone(values === null || values === void 0 ? void 0 : values.locationId, props.locationService);
    var previousReceivingVessel = props.customerFleet.find(function (fleetShip) { return fleetShip._id === getPreviousValueLabel('receivingShipId', values, prevValues); });
    var fieldPermissions = getEnquiryNegotiationFieldPermissions(currentUser.roles);
    // nastyness to show the summary values without ts complaining
    var summaryValues = values;
    return (React__default.createElement("div", { className: "prompt-form nomination-form" },
        React__default.createElement("section", { className: "form-section" },
            React__default.createElement(FormWrapper, null,
                React__default.createElement("div", { className: "form-header" },
                    React__default.createElement("div", { className: "step-header" },
                        React__default.createElement("div", { className: "step-indicator" }, "1"),
                        React__default.createElement("h2", { className: "" }, "General Information"))),
                props.children,
                props.creatingNewEnquiry && (React__default.createElement(FormElement, null,
                    React__default.createElement(FormLabel, { fieldName: "receivingShipId" }, "Receiving Vessel"),
                    React__default.createElement(SelectionBox, { fieldName: 'receivingShipId', value: !fieldPermissions.receivingVessel && !(values === null || values === void 0 ? void 0 : values.receivingShipId)
                            ? '-'
                            : values === null || values === void 0 ? void 0 : values.receivingShipId, valueKey: "_id", displayKey: "name", placeholder: "Select Vessel...", sortOptions: true, disabled: !fieldPermissions.receivingVessel, onChangeValue: function (option) {
                            onChangeFormValue('receivingShipId', option ? option._id : null);
                        }, options: props.customerFleet, renderOption: function (option) { return (React__default.createElement(ShipSearchSelectOption, { ship: option, currentUser: props.currentUser })); } }),
                    React__default.createElement("div", { className: "form-field-message" },
                        React__default.createElement(FormLabel, { fieldName: "receivingShipId" }, previousReceivingVessel ? previousReceivingVessel.name : undefined),
                        React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'receivingShipId') : undefined })))),
                React__default.createElement(LocationSearch$1, { locationService: props.locationService, onChange: function (value) {
                        props.onChangeFormValue('locationId', value);
                    }, label: "Delivery point *", placeholder: 'Select Port...', disabled: !fieldPermissions.location, fieldName: "locationId", error: errors ? get(errors, 'locationId') : undefined, value: !fieldPermissions.location && !(values === null || values === void 0 ? void 0 : values.locationId) ? '-' : (values === null || values === void 0 ? void 0 : values.locationId) || '', prevValue: prevValues ? prevValues.locationId : undefined }),
                React__default.createElement(FormElement, null,
                    React__default.createElement(FormLabel, { fieldName: "location" }, "Location"),
                    React__default.createElement(TextField, { fieldName: "location", disabled: !fieldPermissions.location, value: !fieldPermissions.location && !(values === null || values === void 0 ? void 0 : values.location)
                            ? '-'
                            : (values === null || values === void 0 ? void 0 : values.location) ? values.location
                                : '', onChange: function (event) {
                            props.onChangeFormValue('location', event.target.value);
                        } }),
                    React__default.createElement("div", { className: "form-field-message" },
                        React__default.createElement(FormLabel, { fieldName: "prevlocation", strikeThrough: true }, getPreviousValueLabel('location', values, prevValues)),
                        React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'location') : undefined }))),
                React__default.createElement(FormElement, null,
                    React__default.createElement(FormLabel, { fieldName: "agent" }, "Agent"),
                    React__default.createElement(TextField, { fieldName: "agent", disabled: !fieldPermissions.agent, value: !fieldPermissions.agent && !(values === null || values === void 0 ? void 0 : values.agent) ? '-' : (values === null || values === void 0 ? void 0 : values.agent) ? values.agent : '', onChange: function (event) {
                            onChangeFormValue('agent', event.target.value);
                        } }),
                    React__default.createElement("div", { className: "form-field-message" },
                        React__default.createElement(FormLabel, { fieldName: "prevAgent", strikeThrough: true }, getPreviousValueLabel('agent', values, prevValues)),
                        React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'agent') : undefined }))),
                values && instanceOfINominationEnquiryEvent(values) && (React__default.createElement(FormElement, null,
                    React__default.createElement(FormLabel, { fieldName: "buyerRef" }, "Buyer reference"),
                    React__default.createElement(TextField, { fieldName: "buyerRef", disabled: !fieldPermissions.buyerRef, value: !fieldPermissions.buyerRef && !(values === null || values === void 0 ? void 0 : values.buyerRef)
                            ? '-'
                            : (values === null || values === void 0 ? void 0 : values.buyerRef) ? values.buyerRef
                                : '', onChange: function (event) {
                            onChangeFormValue('buyerRef', event.target.value);
                        } }),
                    React__default.createElement("div", { className: "form-field-message" },
                        React__default.createElement(FormLabel, { fieldName: "prevBuyer", strikeThrough: true }, getPreviousValueLabel('buyerRef', values, prevValues)),
                        React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'buyerRef') : undefined })))))),
        React__default.createElement("section", { className: "form-section" },
            React__default.createElement("div", { className: "form-header" },
                React__default.createElement("div", { className: "step-header" },
                    React__default.createElement("div", { className: "step-indicator" }, "2"),
                    React__default.createElement("h2", { className: "" }, "Quantity and delivery"))),
            React__default.createElement(FormWrapper, null,
                React__default.createElement(FormElement, null,
                    React__default.createElement(FormLabel, { fieldName: "amount" },
                        "Total quantity *",
                        React__default.createElement("div", { className: "label-unit" })),
                    React__default.createElement("div", { className: "flex amount-and-quantityUnit-container" },
                        React__default.createElement(FormFieldWrapper, null,
                            React__default.createElement(NumberInput, { key: (values === null || values === void 0 ? void 0 : values._id) + " amount", name: 'amount', maxDecimals: 3, value: !fieldPermissions.amount && !(values === null || values === void 0 ? void 0 : values.amount)
                                    ? '-'
                                    : (values === null || values === void 0 ? void 0 : values.amount) ? values.amount
                                        : '', disabled: !fieldPermissions.amount, onChangeFormValue: onChangeFormValue })),
                        React__default.createElement(SelectionBox, { fieldName: 'quantityUnit', placeholder: 'Select quantity', value: values === null || values === void 0 ? void 0 : values.quantityUnit, renderFieldValue: function (selectedItem) {
                                return "" + selectedItem.text;
                            }, valueKey: "value", displayKey: "text", disabled: !fieldPermissions.quantityUnit, onChangeValue: function (unit) {
                                onChangeFormValue('quantityUnit', unit === null || unit === void 0 ? void 0 : unit.value);
                            }, options: QUANTITY_UNITS, renderOption: function (option) { return React__default.createElement(SelectOption, { label: option.text }); } })),
                    React__default.createElement("div", { className: "form-field-message" },
                        React__default.createElement(FormLabel, { strikeThrough: true, fieldName: "prevAmount" }, getPreviousValueLabel('amount', values, prevValues)),
                        React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'amount') : undefined }))),
                React__default.createElement(FormElement, null,
                    React__default.createElement(FormLabel, { fieldName: "tolerance" },
                        "Tolerance ",
                        React__default.createElement("div", { className: "label-unit" }, "(%)")),
                    React__default.createElement(NumberInput, { name: 'tolerance', maxDecimals: 3, disabled: !fieldPermissions.tolerance, value: !fieldPermissions.tolerance && !(values === null || values === void 0 ? void 0 : values.tolerance)
                            ? '-'
                            : (values === null || values === void 0 ? void 0 : values.tolerance) ? values.tolerance
                                : '', onChangeFormValue: props.onChangeFormValue }),
                    React__default.createElement("div", { className: "form-field-message" },
                        React__default.createElement(FormLabel, { fieldName: "prevTolerance", strikeThrough: true }, getPreviousValueLabel('tolerance', values, prevValues)),
                        React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'tolerance') : undefined }))),
                props.showDeliveryModeSelection && (React__default.createElement(FormElement, null,
                    React__default.createElement(FormLabel, { fieldName: "deliveryMode" }, "Delivery by *"),
                    React__default.createElement(DeliveryModeSelection, { fieldName: "deliveryModes", availableDeliveryModes: props.availableDeliveryModes, selectedDeliveryModes: (values === null || values === void 0 ? void 0 : values.deliveryModes) || [], readOnly: !fieldPermissions.deliveryModes, changeDeliveryMode: onChangeDeliveryMode }),
                    React__default.createElement("div", { className: "form-field-message" },
                        React__default.createElement(FormLabel, { fieldName: "prevDeliveryMode", strikeThrough: true }, getPreviousDeliveryMode(values, prevValues)),
                        React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'deliveryModes') : undefined })))))),
        !props.creatingNewEnquiry && (React__default.createElement("section", { className: "form-section" },
            React__default.createElement("div", { className: "form-header" },
                React__default.createElement("div", { className: "step-header" },
                    React__default.createElement("div", { className: "step-indicator" }, "3"),
                    React__default.createElement("h2", { className: "" }, "Pricing"))),
            React__default.createElement("section", { className: "summary-section" },
                React__default.createElement(SummaryRow, { label: 'Price', currentValue: summaryValues === null || summaryValues === void 0 ? void 0 : summaryValues.price, emptyValueMessage: '-', isInitialValue: false }),
                summaryValues.priceUnit && summaryValues.energyUnit && summaryValues.grossNet && (React__default.createElement(SummaryRow, { isInitialValue: false, emptyValueMessage: '-', label: 'Unit', currentValue: (summaryValues.priceUnit || '') + "/" + (summaryValues.energyUnit || '') + " " + (summaryValues.grossNet ? (summaryValues.grossNet === 'GROSS' ? 'GCV' : 'NCV') : '') })),
                React__default.createElement(SummaryRow, { isInitialValue: false, label: 'Offer valid', currentValue: summaryValues === null || summaryValues === void 0 ? void 0 : summaryValues.offerExpiration, formatAsDate: true, emptyValueMessage: '-' })))),
        React__default.createElement("section", { className: "form-section" },
            React__default.createElement("div", { className: "form-header" },
                React__default.createElement("div", { className: "step-header" },
                    React__default.createElement("div", { className: "step-indicator" }, props.creatingNewEnquiry ? '3' : '4'),
                    React__default.createElement("h2", { className: "" }, "Schedule"))),
            React__default.createElement("h5", { className: "timezone-title" },
                "Timezone: ",
                timezone.text),
            !props.creatingNewEnquiry && (React__default.createElement("section", { className: "summary-section" },
                React__default.createElement("div", { className: "section-content" },
                    React__default.createElement("div", { className: "single-row" },
                        React__default.createElement("h5", { className: "summary-section-sub-title" }, "Bunker Vessel"),
                        React__default.createElement("div", { className: "rows" },
                            React__default.createElement(SummaryRow, { className: "rv-row", label: 'Allowed bunkering time (hours)', currentValue: values === null || values === void 0 ? void 0 : values.allowedBunkeringTime, hideNewIndicator: true, emptyValueMessage: '-', isInitialValue: false })))))),
            React__default.createElement(FormWrapper, null,
                React__default.createElement("h5", { className: "summary-section-sub-title center-align" }, "Receiving vessel"),
                React__default.createElement(FormElement, null,
                    React__default.createElement(FormLabel, { fieldName: "eta" }, "ETA *"),
                    React__default.createElement(FormFieldWrapper, null,
                        React__default.createElement(DateTimePicker, { key: (values === null || values === void 0 ? void 0 : values._id) + " eta", hideDialogHeader: true, name: 'eta', onDateTimeChange: onChangeDateTimeValue, disabled: !fieldPermissions.eta, icon: React__default.createElement("i", { className: "icon-calendar-1" }), placeholder: "dd/mm/yyyy hh:mm", value: !fieldPermissions.eta && !(values === null || values === void 0 ? void 0 : values.eta) ? '' : values === null || values === void 0 ? void 0 : values.eta, timeZone: timezone.value, useInitialStart: 'hour' })),
                    React__default.createElement("div", { className: "form-field-message" },
                        React__default.createElement(FormLabel, { strikeThrough: true, fieldName: "prevEta" }, formatDateTime(getPreviousValueLabel('eta', values, prevValues), timezone.value)),
                        React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'eta') : undefined }))),
                React__default.createElement(FormElement, null,
                    React__default.createElement(FormLabel, { fieldName: "bst" }, "Bunkering Start Time (BST) *"),
                    React__default.createElement(FormFieldWrapper, null,
                        React__default.createElement(DateTimePicker, { key: (values === null || values === void 0 ? void 0 : values._id) + " bst", name: 'bst', onDateTimeChange: onChangeDateTimeValue, disabled: !fieldPermissions.bst, icon: React__default.createElement("i", { className: "icon-calendar-1" }), placeholder: "dd/mm/yyyy hh:mm", value: !fieldPermissions.bst && !(values === null || values === void 0 ? void 0 : values.bst) ? '' : values === null || values === void 0 ? void 0 : values.bst, timeZone: timezone.value, hideDialogHeader: true, useInitialStart: 'hour' })),
                    React__default.createElement("div", { className: "form-field-message" },
                        React__default.createElement(FormLabel, { fieldName: "prevBst", strikeThrough: true }, formatDateTime(getPreviousValueLabel('bst', values, prevValues), timezone.value)),
                        React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'bst') : undefined }),
                        React__default.createElement(ValidationWarning, { warning: values ? validateEnquiryBST(values) : undefined, className: "form-field-error-message warning" }))),
                React__default.createElement(FormElement, null,
                    React__default.createElement(FormLabel, { fieldName: "etd" }, "ETD *"),
                    React__default.createElement(FormFieldWrapper, null,
                        React__default.createElement(DateTimePicker, { key: (values === null || values === void 0 ? void 0 : values._id) + " etd", name: 'etd', onDateTimeChange: onChangeDateTimeValue, disabled: !fieldPermissions.etd, icon: React__default.createElement("i", { className: "icon-calendar-1" }), placeholder: "dd/mm/yyyy hh:mm", value: !fieldPermissions.etd && !(values === null || values === void 0 ? void 0 : values.etd) ? '' : values === null || values === void 0 ? void 0 : values.etd, timeZone: timezone.value, hideDialogHeader: true, useInitialStart: 'hour' })),
                    React__default.createElement("div", { className: "form-field-message" },
                        React__default.createElement(FormLabel, { fieldName: "prevEtd", strikeThrough: true }, formatDateTime(getPreviousValueLabel('etd', values, prevValues), timezone.value)),
                        React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'etd') : undefined })))))));
};

var SupplierEnquiryForm = function (props) {
    // Properties
    var currentUser = props.currentUser, errors = props.errors, values = props.values, prevValues = props.prevValues, getPreviousDeliveryMode = props.getPreviousDeliveryMode, getPreviousValueLabel = props.getPreviousValueLabel, onChangeDateTimeValue = props.onChangeDateTimeValue, onChangeFormValue = props.onChangeFormValue, onChangeDeliveryMode = props.onChangeDeliveryMode, companyContracts = props.companyContracts;
    var timezone = useLocationTimeZone(values === null || values === void 0 ? void 0 : values.locationId, props.locationService);
    var previousBunkerVessel = props.bunkerShips.find(function (bunkerShip) { return bunkerShip._id === getPreviousValueLabel('bunkershipId', values, prevValues); });
    var previousContract = props.companyContracts.find(function (contract) { return contract._id === getPreviousValueLabel('contractId', values, prevValues); });
    var fieldPermissions = getEnquiryNegotiationFieldPermissions(currentUser.roles);
    return (React__default.createElement("div", { className: "prompt-form nomination-form" },
        React__default.createElement("section", { className: "form-section" },
            React__default.createElement("div", { className: "form-header" },
                React__default.createElement("div", { className: "step-header" },
                    React__default.createElement("div", { className: "step-indicator" }, "1"),
                    React__default.createElement("h2", { className: "" }, "General information"))),
            React__default.createElement(FormWrapper, null,
                props.children,
                React__default.createElement(LocationSearch$1, { locationService: props.locationService, onChange: function (value) {
                        props.onChangeFormValue('locationId', value);
                    }, label: "Delivery point *", placeholder: 'Select Port...', disabled: !fieldPermissions.location, fieldName: "locationId", error: errors ? get(errors, 'locationId') : undefined, value: !fieldPermissions.location && !(values === null || values === void 0 ? void 0 : values.locationId) ? '-' : (values === null || values === void 0 ? void 0 : values.locationId) || '', prevValue: prevValues ? prevValues.locationId : undefined }),
                React__default.createElement(FormElement, null,
                    React__default.createElement(FormLabel, { fieldName: "location" }, "Location"),
                    React__default.createElement(TextField, { fieldName: "location", disabled: !fieldPermissions.location, value: !fieldPermissions.location && !(values === null || values === void 0 ? void 0 : values.location)
                            ? '-'
                            : (values === null || values === void 0 ? void 0 : values.location) ? values.location
                                : '', onChange: function (event) {
                            props.onChangeFormValue('location', event.target.value);
                        } }),
                    React__default.createElement("div", { className: "form-field-message" },
                        React__default.createElement(FormLabel, { fieldName: "prevlocation", strikeThrough: true }, getPreviousValueLabel('location', values, prevValues)),
                        React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'location') : undefined }))),
                React__default.createElement(FormElement, null,
                    React__default.createElement(FormLabel, { fieldName: "agent" }, "Agent"),
                    React__default.createElement(TextField, { fieldName: "agent", disabled: !fieldPermissions.agent, value: !fieldPermissions.agent && !(values === null || values === void 0 ? void 0 : values.agent) ? '-' : (values === null || values === void 0 ? void 0 : values.agent) ? values.agent : '', onChange: function (event) {
                            onChangeFormValue('agent', event.target.value);
                        } }),
                    React__default.createElement("div", { className: "form-field-message" },
                        React__default.createElement(FormLabel, { fieldName: "prevAgent", strikeThrough: true }, getPreviousValueLabel('agent', values, prevValues)),
                        React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'agent') : undefined }))))),
        React__default.createElement("section", { className: "form-section" },
            React__default.createElement("div", { className: "form-header" },
                React__default.createElement("div", { className: "step-header" },
                    React__default.createElement("div", { className: "step-indicator" }, "2"),
                    React__default.createElement("h2", { className: "" }, "Quantity and delivery"))),
            React__default.createElement(FormWrapper, null,
                React__default.createElement(FormElement, null,
                    React__default.createElement(FormLabel, { fieldName: "amount" }, "Total quantity *"),
                    React__default.createElement("div", { className: "flex amount-and-quantityUnit-container" },
                        React__default.createElement(FormFieldWrapper, null,
                            React__default.createElement(NumberInput, { key: (values === null || values === void 0 ? void 0 : values._id) + " amount", name: 'amount', maxDecimals: 3, value: !fieldPermissions.amount && !(values === null || values === void 0 ? void 0 : values.amount)
                                    ? '-'
                                    : (values === null || values === void 0 ? void 0 : values.amount) ? values.amount
                                        : '', disabled: !fieldPermissions.amount, onChangeFormValue: onChangeFormValue })),
                        React__default.createElement(SelectionBox, { fieldName: 'quantityUnit', placeholder: 'Select quantity', value: values === null || values === void 0 ? void 0 : values.quantityUnit, renderFieldValue: function (selectedItem) {
                                return "" + selectedItem.text;
                            }, valueKey: "value", displayKey: "text", disabled: !fieldPermissions.quantityUnit, onChangeValue: function (unit) {
                                props.onChangeFormValue('quantityUnit', unit === null || unit === void 0 ? void 0 : unit.value);
                            }, options: QUANTITY_UNITS, renderOption: function (option) { return React__default.createElement(SelectOption, { label: option.text }); } })),
                    React__default.createElement("div", { className: "form-field-message" },
                        React__default.createElement(FormLabel, { strikeThrough: true, fieldName: "prevAmount" }, getPreviousValueLabel('amount', values, prevValues)),
                        React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'amount') : undefined }))),
                React__default.createElement(FormElement, null,
                    React__default.createElement(FormLabel, { fieldName: "tolerance" },
                        "Tolerance ",
                        React__default.createElement("div", { className: "label-unit" }, "(%)")),
                    React__default.createElement(NumberInput, { name: 'tolerance', maxDecimals: 3, disabled: !fieldPermissions.tolerance, value: !fieldPermissions.tolerance && !(values === null || values === void 0 ? void 0 : values.tolerance)
                            ? '-'
                            : (values === null || values === void 0 ? void 0 : values.tolerance) ? values.tolerance
                                : '', onChangeFormValue: props.onChangeFormValue }),
                    React__default.createElement("div", { className: "form-field-message" },
                        React__default.createElement(FormLabel, { fieldName: "prevTolerance", strikeThrough: true }, getPreviousValueLabel('tolerance', values, prevValues)),
                        React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'tolerance') : undefined }))),
                props.showDeliveryModeSelection && (React__default.createElement(FormElement, null,
                    React__default.createElement(FormLabel, { fieldName: "deliveryMode" }, "Delivery by"),
                    React__default.createElement(DeliveryModeSelection, { fieldName: "deliveryModes", availableDeliveryModes: props.availableDeliveryModes, selectedDeliveryModes: (values === null || values === void 0 ? void 0 : values.deliveryModes) || [], readOnly: !fieldPermissions.deliveryModes, changeDeliveryMode: onChangeDeliveryMode }),
                    React__default.createElement("div", { className: "form-field-message" },
                        React__default.createElement(FormLabel, { fieldName: "prevDeliveryMode", strikeThrough: true }, getPreviousDeliveryMode(values, prevValues)),
                        React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'deliveryModes') : undefined })))),
                values && instanceOfINominationEnquiryEvent(values) && (React__default.createElement(React__default.Fragment, null, values.deliveryModes.includes('SHIP') &&
                    values.deliveryModes.includes('PIPE') ? null : (React__default.createElement(React__default.Fragment, null,
                    values.deliveryModes.includes('SHIP') && (React__default.createElement(FormElement, null,
                        React__default.createElement(FormLabel, { fieldName: "bunkerShipId" }, "Bunker Vessel *"),
                        React__default.createElement(SelectionBox, { fieldName: 'bunkerShipId', value: !fieldPermissions.bunkerShipId && !(values === null || values === void 0 ? void 0 : values.bunkerShipId)
                                ? '-'
                                : (values === null || values === void 0 ? void 0 : values.bunkerShipId) || '', valueKey: "_id", placeholder: 'Select Bunker Vessel...', displayKey: "name", sortOptions: true, disabled: !fieldPermissions.bunkerShipId, onChangeValue: function (option) {
                                onChangeFormValue('bunkerShipId', option ? option._id : null);
                            }, options: props.bunkerShips, renderOption: function (option) { return (React__default.createElement(ShipSearchSelectOption, { ship: option, currentUser: props.currentUser })); } }),
                        React__default.createElement("div", { className: "form-field-message" },
                            React__default.createElement(FormLabel, { fieldName: "bunkerShipId" }, previousBunkerVessel ? previousBunkerVessel.name : undefined),
                            React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'bunkerShipId') : undefined })))),
                    values.deliveryModes.includes('PIPE') && (React__default.createElement(FormElement, null,
                        React__default.createElement(FormLabel, { fieldName: "pipelineId" }, "Pipeline *"),
                        React__default.createElement(SelectionBox, { fieldName: 'pipelineId', value: !fieldPermissions.pipelineId && !(values === null || values === void 0 ? void 0 : values.pipelineId)
                                ? '-'
                                : (values === null || values === void 0 ? void 0 : values.pipelineId) || '', valueKey: "_id", placeholder: 'Select Pipeline...', displayKey: "name", sortOptions: true, disabled: !fieldPermissions.pipelineId, onChangeValue: function (option) {
                                onChangeFormValue('pipelineId', option ? option._id : null);
                            }, options: props.pipelines, renderOption: function (option) { return React__default.createElement(SelectOption, { label: option.name }); } }),
                        React__default.createElement("div", { className: "form-field-message" },
                            React__default.createElement(FormLabel, { fieldName: "pipelineId" }, previousBunkerVessel ? previousBunkerVessel.name : undefined),
                            React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'pipelineId') : undefined })))))))))),
        React__default.createElement("section", { className: "form-section" },
            React__default.createElement("div", { className: "form-header" },
                React__default.createElement("div", { className: "step-header" },
                    React__default.createElement("div", { className: "step-indicator" }, "3"),
                    React__default.createElement("h2", { className: "" }, "Pricing"))),
            React__default.createElement(FormWrapper, null,
                values && instanceOfINominationEnquiryEvent(values) && (React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(FormElement, null,
                        React__default.createElement(FormLabel, { fieldName: "price" }, "Price *"),
                        React__default.createElement(FormFieldWrapper, null,
                            React__default.createElement(TextField, { fieldName: "price *", disabled: !fieldPermissions.price, value: !fieldPermissions.price && !(values === null || values === void 0 ? void 0 : values.price)
                                    ? '-'
                                    : (values === null || values === void 0 ? void 0 : values.price) ? values.price
                                        : '', onChange: function (event) {
                                    onChangeFormValue('price', event.target.value);
                                } })),
                        React__default.createElement("div", { className: "form-field-message" },
                            React__default.createElement(FormLabel, { strikeThrough: true, fieldName: "prevPrice" }, getPreviousValueLabel('price', values, prevValues)),
                            React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'price') : undefined }))),
                    React__default.createElement(FormElement, null,
                        React__default.createElement(FormLabel, null, "Unit *"),
                        React__default.createElement("div", { className: "form-field-wrapper" },
                            React__default.createElement(SelectionBox, { disableSearch: true, fieldName: "priceUnit", value: values.priceUnit, valueKey: "value", displayKey: "text", className: "price-unit-selection-box", renderFieldValue: function (selectedItem) {
                                    return "" + selectedItem.text;
                                }, onChangeValue: function (selectedItem) {
                                    onChangeFormValue('priceUnit', selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value);
                                }, options: PRICE_UNITS, renderOption: function (option) {
                                    return (React__default.createElement("div", null,
                                        React__default.createElement("span", null, option.text)));
                                } }),
                            React__default.createElement(SelectionBox, { disableSearch: true, fieldName: "energyUnit", value: values.energyUnit, valueKey: "value", displayKey: "text", renderFieldValue: function (selectedItem) {
                                    return "" + selectedItem.text;
                                }, onChangeValue: function (selectedItem) {
                                    onChangeFormValue('energyUnit', selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value);
                                }, options: ENERGY_UNITS, renderOption: function (option) {
                                    return (React__default.createElement("div", null,
                                        React__default.createElement("span", null, option.text)));
                                } })),
                        React__default.createElement("div", { className: "form-field-message" },
                            React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'energyUnit') : get(errors, 'priceUnit') }))),
                    React__default.createElement("div", { className: "toggle-wrapper" },
                        React__default.createElement("div", { className: "toggle", onClick: function () {
                                onChangeFormValue('grossNet', 'GROSS');
                            } },
                            React__default.createElement(FontAwesomeIcon, { icon: values.grossNet === 'GROSS' ? faCheckCircle : faCircle }),
                            ' ',
                            "GCV"),
                        React__default.createElement("div", { className: "toggle", onClick: function () {
                                onChangeFormValue('grossNet', 'NET');
                            } },
                            React__default.createElement(FontAwesomeIcon, { icon: values.grossNet === 'NET' ? faCheckCircle : faCircle }),
                            ' ',
                            "NCV")))),
                values && instanceOfINominationEnquiryEvent(values) && (React__default.createElement(FormElement, null,
                    React__default.createElement(FormLabel, { fieldName: "offerExpiration" }, "Offer valid *"),
                    React__default.createElement(FormFieldWrapper, null,
                        React__default.createElement(DateTimePicker, { key: (values === null || values === void 0 ? void 0 : values._id) + " offerExpiration", name: 'offerExpiration', onDateTimeChange: onChangeDateTimeValue, disabled: !fieldPermissions.offerExpiration, icon: React__default.createElement("i", { className: "icon-calendar-1" }), placeholder: "dd/mm/yyyy hh:mm", value: !fieldPermissions.offerExpiration && !(values === null || values === void 0 ? void 0 : values.offerExpiration)
                                ? ''
                                : values === null || values === void 0 ? void 0 : values.offerExpiration, timeZone: timezone.value, hideDialogHeader: true, useInitialStart: 'hour' })),
                    React__default.createElement("div", { className: "form-field-message" },
                        React__default.createElement(FormLabel, { strikeThrough: true, fieldName: "prevOfferExpiration" }, getPreviousValueLabel('offerExpiration', values, prevValues)),
                        React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'offerExpiration') : undefined })))))),
        React__default.createElement("section", { className: "form-section" },
            React__default.createElement("div", { className: "form-header" },
                React__default.createElement("div", { className: "step-header" },
                    React__default.createElement("div", { className: "step-indicator" }, "4"),
                    React__default.createElement("h2", { className: "" }, "Schedule"))),
            React__default.createElement("h5", { className: "timezone-title" },
                "Timezone: ",
                timezone.text),
            React__default.createElement("section", { className: "summary-section" },
                React__default.createElement("div", { className: "section-content" },
                    React__default.createElement("div", { className: "single-row" },
                        React__default.createElement("h5", { className: "summary-section-sub-title" }, "Receiving Vessel"),
                        React__default.createElement("div", { className: "rows" },
                            React__default.createElement(SummaryRow, { className: "rv-row", label: 'ETA', formatAsDate: true, currentValue: values === null || values === void 0 ? void 0 : values.eta, formatTimezone: timezone.value, hideNewIndicator: true, emptyValueMessage: '-', isInitialValue: false }),
                            React__default.createElement(SummaryRow, { className: "rv-row", label: 'ETD', formatAsDate: true, currentValue: values === null || values === void 0 ? void 0 : values.etd, formatTimezone: timezone.value, hideNewIndicator: true, emptyValueMessage: '-', isInitialValue: false }))))),
            React__default.createElement(FormWrapper, null,
                React__default.createElement("h5", { className: "summary-section-sub-title center-align" }, "Bunker vessel"),
                React__default.createElement(FormElement, null,
                    React__default.createElement(FormLabel, { fieldName: "bst" }, "Bunkering Start Time (BST) *"),
                    React__default.createElement(FormFieldWrapper, null,
                        React__default.createElement(DateTimePicker, { key: (values === null || values === void 0 ? void 0 : values._id) + " bst", name: 'bst', onDateTimeChange: onChangeDateTimeValue, disabled: !fieldPermissions.bst, icon: React__default.createElement("i", { className: "icon-calendar-1" }), placeholder: "dd/mm/yyyy hh:mm", value: !fieldPermissions.bst && !(values === null || values === void 0 ? void 0 : values.bst) ? '' : values === null || values === void 0 ? void 0 : values.bst, timeZone: timezone.value, hideDialogHeader: true, useInitialStart: 'hour' })),
                    React__default.createElement("div", { className: "form-field-message" },
                        React__default.createElement(FormLabel, { fieldName: "prevBst", strikeThrough: true }, formatDateTime(getPreviousValueLabel('bst', values, prevValues), timezone.value)),
                        React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'bst') : undefined }),
                        React__default.createElement(ValidationWarning, { warning: values ? validateEnquiryBST(values) : undefined, className: "form-field-error-message warning" }))),
                React__default.createElement(FormElement, null,
                    React__default.createElement(FormLabel, { fieldName: "allowedBunkeringTime" }, "Allowed bunkering time *"),
                    React__default.createElement(FormFieldWrapper, null,
                        React__default.createElement("div", { className: "label-unit in-form-field" }, "(hours)"),
                        React__default.createElement(NumberInput, { key: (values === null || values === void 0 ? void 0 : values._id) + " allowedBunkeringTime", name: 'allowedBunkeringTime', maxDecimals: 3, value: !fieldPermissions.allowedBunkeringTime && !(values === null || values === void 0 ? void 0 : values.allowedBunkeringTime)
                                ? '-'
                                : (values === null || values === void 0 ? void 0 : values.allowedBunkeringTime) ? values.allowedBunkeringTime
                                    : '', disabled: !fieldPermissions.allowedBunkeringTime, onChangeFormValue: onChangeFormValue })),
                    React__default.createElement("div", { className: "form-field-message" },
                        React__default.createElement(FormLabel, { fieldName: "prevAllowedBunkeringTime", strikeThrough: true }, getPreviousValueLabel('allowedBunkeringTime', values, prevValues)),
                        React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'allowedBunkeringTime') : undefined }))))),
        React__default.createElement("section", { className: "form-section" },
            React__default.createElement("div", { className: "form-header" },
                React__default.createElement("div", { className: "step-header" },
                    React__default.createElement("div", { className: "step-indicator" }, "5"),
                    React__default.createElement("h2", { className: "" }, "Contract"))),
            React__default.createElement(FormWrapper, null, values && instanceOfINominationEnquiryEvent(values) && (React__default.createElement(FormElement, null,
                React__default.createElement(FormLabel, { fieldName: "contractId" }, "Contract"),
                React__default.createElement(SelectionBox, { fieldName: 'contractId', dropUp: true, value: values.contractId, disabled: !fieldPermissions.contractId, options: companyContracts.map(function (contract) { return ({
                        value: contract._id,
                        text: contract.name
                    }); }), placeholder: 'Select Contract...', valueKey: "value", displayKey: "text", renderFieldValue: function (selectedItem) {
                        return "" + selectedItem.text;
                    }, onChangeValue: function (selectedItem) {
                        if (selectedItem) {
                            onChangeFormValue('contractId', selectedItem ? selectedItem.value : null);
                        }
                    }, renderOption: function (option) {
                        return (React__default.createElement("div", null,
                            React__default.createElement("span", null, option.text)));
                    } }),
                React__default.createElement("div", { className: "form-field-message" },
                    React__default.createElement(FormLabel, { fieldName: "prevBst", strikeThrough: true }, previousContract ? previousContract.name : undefined),
                    React__default.createElement(FormErrorMessage, { errorMessage: errors === null || errors === void 0 ? void 0 : errors.contractId }))))))));
};

var EnquiryForm = function (props) {
    // Properties
    var values = props.values;
    var companyContracts = values && instanceOfINominationEnquiryEvent(values)
        ? props.contractsList.filter(function (contract) {
            return contract.companyId === (values === null || values === void 0 ? void 0 : values.companyId) &&
                contract.vendorCompanyId === (values === null || values === void 0 ? void 0 : values.vendorCompanyId);
        })
        : [];
    return (React__default.createElement(React__default.Fragment, null,
        isScheduler(props.currentUser.roles) && (React__default.createElement(SupplierEnquiryForm, { values: props.values, errors: props.errors, currentUser: props.currentUser, bunkerShips: props.bunkerShips, pipelines: props.pipelines, locationService: props.locationService, customerFleet: props.customerFleet, onChangeFormValue: props.onChangeFormValue, showDeliveryModeSelection: props.showDeliveryModeSelection, availableDeliveryModes: props.availableDeliveryModes, prevValues: props.prevValues, showHeader: props.showHeader, 
            // altered / derived / function props
            companyContracts: companyContracts, getPreviousDeliveryMode: getPreviousDeliveryMode, getPreviousValueLabel: getPreviousValueLabel, onChangeDateTimeValue: onChangeDateTimeValue, onChangeDeliveryMode: onChangeDeliveryMode }, props.children)),
        isCustomer(props.currentUser.roles) && (React__default.createElement(CustomerEnquiryForm, { values: props.values, errors: props.errors, currentUser: props.currentUser, bunkerShips: props.bunkerShips, pipelines: props.pipelines, locationService: props.locationService, customerFleet: props.customerFleet, onChangeFormValue: props.onChangeFormValue, showDeliveryModeSelection: props.showDeliveryModeSelection, availableDeliveryModes: props.availableDeliveryModes, prevValues: props.prevValues, showHeader: props.showHeader, 
            // altered / derived / function props
            getPreviousDeliveryMode: getPreviousDeliveryMode, getPreviousValueLabel: getPreviousValueLabel, onChangeDateTimeValue: onChangeDateTimeValue, onChangeDeliveryMode: onChangeDeliveryMode, creatingNewEnquiry: props.creatingNewEnquiry }, props.children))));
    function onChangeDeliveryMode(selectedDeliveryModes) {
        var newValues = cloneDeep(props.values);
        if (newValues && Array.isArray(selectedDeliveryModes)) {
            newValues.deliveryModes = selectedDeliveryModes;
            // if the delivery mode was changed, we set the column back to unsassigned.
            if (instanceOfINominationEnquiryEvent(newValues)) {
                newValues.column = 'UNASSIGNED';
            }
            props.setAllValues(newValues);
        }
        else {
            props.onChangeFormValue('deliveryModes', selectedDeliveryModes);
        }
    }
    function getPreviousDeliveryMode(nominationValues, prevNominationValues) {
        if (nominationValues && prevNominationValues) {
            if (nominationValues.deliveryModes.toString() !== prevNominationValues.deliveryModes.toString()) {
                return prevNominationValues.deliveryModes.toString();
            }
        }
        return undefined;
    }
    function onChangeDateTimeValue(isoDate, inputValue, isValid, fieldName) {
        if (fieldName) {
            var valueToUpdate = isoDate || inputValue;
            props.onChangeFormValue(fieldName, valueToUpdate);
        }
    }
    function getPreviousValueLabel(field, nominationValues, prevNominationValues) {
        if (nominationValues && prevNominationValues) {
            if (nominationValues[field] !== prevNominationValues[field]) {
                return prevNominationValues[field];
            }
        }
        return undefined;
    }
};

var CreateEnquiry = function (props) {
    var _a;
    var _b = useForm({
        initialValues: undefined,
        validate: validateNewEnquiry,
        onValidSubmit: submitNominationEnquiry
    }), values = _b.values, errors = _b.errors, onChangeValue = _b.onChangeValue, handleSubmit = _b.handleSubmit, isDifferentFromInitial = _b.isDifferentFromInitial, setAllValues = _b.setAllValues;
    var _c = useState(false), creatingEnquiry = _c[0], setCreatingEnquiry = _c[1];
    var _d = useState([]), selectedVendorCompanies = _d[0], setSelectedVendorCompanies = _d[1];
    var _e = useState(), companySelectError = _e[0], setCompanySelectError = _e[1];
    var suppliers = props.companies
        .filter(function (company) { return company.companyType === 'VENDOR' && company.deleted !== true; })
        .sort(function (a, b) { return a.name.localeCompare(b.name); });
    var customerFleet = useFleetService(props.user.companyId, props.authenticationService).activeShips;
    // These are the delivery modes that will be available to the user when creating an enquiry.
    // This can be all modes for now as all modes should be available when making an enquiry for multiple companies.
    var availableDeliveryModes = ['SHIP', 'TRUCK', 'CONTAINER', 'PIPE'];
    var userPermissions = useContext(UserPermissionContext).userPermissions;
    useEffect(function () {
        setSelectedVendorCompanies((props.preselectedSuppliers || []).map(function (company) {
            return {
                value: company._id,
                text: company.name
            };
        }));
    }, [(_a = props.preselectedSuppliers) === null || _a === void 0 ? void 0 : _a.length]);
    if (!doesUserHavePermission(userPermissions, 'SPOT_ENQUIRY_CREATE')) {
        return React__default.createElement(PermissionsWarning, null, "You are not allowed to create a new Enquiry");
    }
    return (React__default.createElement("div", { className: props.className || '' },
        React__default.createElement("div", { className: "prompt-negotiation-wrapper" },
            React__default.createElement(EnquiryForm, { readOnly: false, authenticationService: props.authenticationService, values: values ? values : undefined, errors: errors, bunkerShips: props.bunkerShips, pipelines: props.pipelines, currentUser: props.user, customerFleet: customerFleet, onChangeFormValue: onChangeValue, locationService: props.locationService, contractsList: [], availableDeliveryModes: availableDeliveryModes, showDeliveryModeSelection: props.showDeliveryModeSelection, creatingNewEnquiry: true, 
                // @ts-ignore -> otherwise it keeps moaning about the type of the function input
                setAllValues: setAllValues },
                React__default.createElement(FormElement, null,
                    React__default.createElement(FormLabel, { fieldName: "supplier" }, "Supplier *"),
                    React__default.createElement(MultiSelectionBox, { fieldName: "supplier", values: selectedVendorCompanies, valueKey: "value", searchKey: "text", sortOptions: true, placeholder: 'Select Supplier...', selectAllOption: {
                            active: true,
                            optionText: 'Open to all suppliers'
                        }, renderFieldValue: function (selectedItem, removeItem) {
                            return (React__default.createElement(MultiSelectOption, { optionText: selectedItem.text, removeItem: function () {
                                    removeItem(selectedItem);
                                } }));
                        }, onChangeValue: function (selectedItems) {
                            setSelectedVendorCompanies(selectedItems);
                        }, options: suppliers.map(function (company) { return ({
                            value: company._id,
                            text: company.name
                        }); }), renderOption: function (option) {
                            return (React__default.createElement("div", null,
                                React__default.createElement("div", null, option.text)));
                        } }),
                    React__default.createElement("div", { className: "form-field-message" },
                        React__default.createElement(FormErrorMessage, null, companySelectError)))),
            React__default.createElement("div", { className: "form-action-bar centered" },
                React__default.createElement("p", { className: "create-message" }, "To share additional information, please click \u201CCreate Enquiry and use the chat"),
                React__default.createElement("div", { className: "action-bar-buttons" },
                    React__default.createElement(Button, { preventDoubleClick: true, disabled: !isDifferentFromInitial, onClick: function (e) {
                            e.preventDefault();
                            handleSubmit();
                        } }, "Create enquiry"))))));
    function validateNewEnquiry(newEnquiry) {
        var vendorError = validateVendorSelection();
        var enquiryErrors = validateEnquiry(newEnquiry, props.user, true, props.showDeliveryModeSelection);
        if (vendorError) {
            enquiryErrors['supplier'] = vendorError;
        }
        return enquiryErrors;
    }
    function validateVendorSelection() {
        if (selectedVendorCompanies.length === 0) {
            var errorMessage = 'Please select one or more companies to send the enquiry to';
            setCompanySelectError(errorMessage);
            return errorMessage;
        }
        else {
            setCompanySelectError(undefined);
            return undefined;
        }
    }
    function submitNominationEnquiry(nominationEnquiry) {
        return __awaiter(this, void 0, void 0, function () {
            var vendorSelectionError, vendorCompanyIds;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        vendorSelectionError = validateVendorSelection();
                        if (creatingEnquiry) {
                            return [2 /*return*/];
                        }
                        if (vendorSelectionError || !nominationEnquiry) {
                            return [2 /*return*/];
                        }
                        if (props.user.companyId) {
                            nominationEnquiry.companyId = props.user.companyId;
                        }
                        vendorCompanyIds = selectedVendorCompanies.map(function (company) {
                            return company.value;
                        });
                        setCreatingEnquiry(true);
                        return [4 /*yield*/, props.createNewEnquiry(nominationEnquiry, vendorCompanyIds)];
                    case 1:
                        _a.sent();
                        setCreatingEnquiry(false);
                        return [2 /*return*/];
                }
            });
        });
    }
};

var ContractsDialog = function (props) {
    var event = props.event;
    var companyContracts = event
        ? props.contractsList.filter(function (contract) {
            return contract.companyId === event.companyId &&
                contract.vendorCompanyId === event.vendorCompanyId;
        })
        : [];
    var _a = useState(), selectedContract = _a[0], setSelectedContract = _a[1];
    return (React__default.createElement(Dialog, { showDialog: props.event ? true : false, onCloseDialog: function () {
            props.clearContractSelection();
        }, type: "small", title: "Finalise Enquiry - Add Contract", titleIcon: getNominationStatusIcon('NEEDS_CONTRACT') },
        React__default.createElement("p", null, "To finalise this enquiry, a contract needs to be assigned. Please select a contract to be assigned to the enquiry."),
        React__default.createElement(FormElement, null,
            React__default.createElement(FormLabel, { fieldName: "contractId" }, "Contract"),
            React__default.createElement(SelectionBox, { fieldName: 'contractId', placeholder: 'Select Contract...', value: selectedContract, options: companyContracts.map(function (contract) { return ({
                    value: contract._id,
                    text: contract.name
                }); }), valueKey: "value", displayKey: "text", renderFieldValue: function (selectedItem) {
                    return "" + selectedItem.text;
                }, onChangeValue: function (selectedItem) {
                    if (selectedItem) {
                        setSelectedContract(selectedItem.value);
                    }
                    else {
                        setSelectedContract(undefined);
                    }
                }, dropUp: true, renderOption: function (option) {
                    return (React__default.createElement("div", null,
                        React__default.createElement("span", null, option.text)));
                } })),
        React__default.createElement(ButtonGroup, null,
            React__default.createElement(Button, { preventDoubleClick: true, primary: true, disabled: !event || selectedContract === undefined || selectedContract === '', onClick: function () {
                    if (event && selectedContract && selectedContract !== '') {
                        props.addContractAndFinaliseEnquiry(event, selectedContract);
                    }
                    props.clearContractSelection();
                } }, "Confirm enquiry"),
            React__default.createElement(Button, { preventDoubleClick: true, primary: true, outline: true, onClick: function () {
                    props.clearContractSelection();
                } }, "Cancel"))));
};

var EnquirySummary = function (props) {
    var _a, _b, _c, _d;
    var currentEnquiry = props.enquirySelection.selectedHistoricEnquiry || props.latestEnquiry;
    var previousEnquiry = props.enquirySelection.previousHistoricEnquiry;
    var currentLocation = useLocationName(currentEnquiry.locationId, props.locationService, formatPortCountry);
    var previousLocation = useLocationName(previousEnquiry === null || previousEnquiry === void 0 ? void 0 : previousEnquiry.locationId, props.locationService, formatPortCountry);
    // note that we only use the resolved port/country when both current and previous locationDetails are resolved,
    // else the UI will temporarily display that the locationDetails is changed
    var loading = currentLocation.loading || previousLocation.loading;
    var currentPortName = loading ? '(Loading...)' : currentLocation.text;
    var previousPortName = (previousEnquiry === null || previousEnquiry === void 0 ? void 0 : previousEnquiry.locationId) ? loading
        ? '(Loading...)'
        : previousLocation.text
        : undefined;
    var currentBunkerVessel = props.bunkerShips.find(function (bunkership) { return bunkership._id === currentEnquiry.bunkerShipId; });
    var previousBunkerVessel = props.bunkerShips.find(function (bunkership) { return bunkership._id === (previousEnquiry === null || previousEnquiry === void 0 ? void 0 : previousEnquiry.bunkerShipId); });
    var currentContract = props.contractsList.find(function (contract) { return contract._id === currentEnquiry.contractId; });
    var previousContract = props.contractsList.find(function (contract) { return contract._id === (previousEnquiry === null || previousEnquiry === void 0 ? void 0 : previousEnquiry.contractId); });
    var currentCompanyName = (_a = props.companies.find(function (company) { return company._id === currentEnquiry.companyId; })) === null || _a === void 0 ? void 0 : _a.name;
    var previousCompanyName = (_b = props.companies.find(function (company) { return company._id === (previousEnquiry === null || previousEnquiry === void 0 ? void 0 : previousEnquiry.companyId); })) === null || _b === void 0 ? void 0 : _b.name;
    var currentSupplierName = (_c = props.companies.find(function (company) { return company._id === currentEnquiry.vendorCompanyId; })) === null || _c === void 0 ? void 0 : _c.name;
    var previousSupplierName = (_d = props.companies.find(function (company) { return company._id === (previousEnquiry === null || previousEnquiry === void 0 ? void 0 : previousEnquiry.vendorCompanyId); })) === null || _d === void 0 ? void 0 : _d.name;
    var timezone = useLocationTimeZone(currentEnquiry.locationId, props.locationService);
    var isInitialValue = !previousEnquiry;
    return (React__default.createElement("div", { className: "nomination-summary" },
        React__default.createElement("section", { className: "summary-section" },
            React__default.createElement("h4", { className: "summary-section-title" }, "General Information"),
            isCustomer(props.currentUser.roles) && (React__default.createElement(SummaryRow, { label: 'Supplier', currentValue: currentSupplierName, previousValue: previousSupplierName, emptyValueMessage: '-', isInitialValue: isInitialValue })),
            isScheduler(props.currentUser.roles) && (React__default.createElement(SummaryRow, { label: 'Buyer', currentValue: currentCompanyName, previousValue: previousCompanyName, emptyValueMessage: '-', isInitialValue: isInitialValue })),
            React__default.createElement(SummaryRow, { label: 'Delivery port', currentValue: currentPortName, previousValue: previousPortName, emptyValueMessage: '-', isInitialValue: isInitialValue }),
            React__default.createElement(SummaryRow, { label: 'Location', currentValue: currentEnquiry.location, previousValue: previousEnquiry === null || previousEnquiry === void 0 ? void 0 : previousEnquiry.location, emptyValueMessage: '-', isInitialValue: isInitialValue }),
            React__default.createElement(SummaryRow, { label: 'Agent', currentValue: currentEnquiry.agent, previousValue: previousEnquiry === null || previousEnquiry === void 0 ? void 0 : previousEnquiry.agent, emptyValueMessage: '-', isInitialValue: isInitialValue }),
            React__default.createElement(SummaryRow, { label: 'Buyer reference', currentValue: currentEnquiry.buyerRef, previousValue: previousEnquiry === null || previousEnquiry === void 0 ? void 0 : previousEnquiry.buyerRef, emptyValueMessage: '-', isInitialValue: isInitialValue })),
        React__default.createElement("section", { className: "summary-section" },
            React__default.createElement("h4", { className: "summary-section-title" }, "Quantity and delivery"),
            React__default.createElement(SummaryRow, { label: 'Quantity total', currentValue: currentEnquiry.amount + " " + getQuantityUnitLabel(currentEnquiry.quantityUnit), previousValue: (previousEnquiry === null || previousEnquiry === void 0 ? void 0 : previousEnquiry.amount) + " " + getQuantityUnitLabel(previousEnquiry === null || previousEnquiry === void 0 ? void 0 : previousEnquiry.quantityUnit), emptyValueMessage: '-', isInitialValue: isInitialValue }),
            React__default.createElement(SummaryRow, { label: 'Tolerance', currentValue: currentEnquiry.tolerance, previousValue: previousEnquiry === null || previousEnquiry === void 0 ? void 0 : previousEnquiry.tolerance, emptyValueMessage: '-', isInitialValue: isInitialValue }),
            React__default.createElement(SummaryRow, { label: 'Delivery by', currentValue: currentEnquiry.deliveryModes.toString(), previousValue: previousEnquiry === null || previousEnquiry === void 0 ? void 0 : previousEnquiry.deliveryModes.toString(), emptyValueMessage: '-', isInitialValue: isInitialValue }),
            currentEnquiry.deliveryModes.includes('SHIP') && (React__default.createElement(SummaryRow, { label: 'Bunker vessel', currentValue: currentBunkerVessel === null || currentBunkerVessel === void 0 ? void 0 : currentBunkerVessel.name, previousValue: previousBunkerVessel === null || previousBunkerVessel === void 0 ? void 0 : previousBunkerVessel.name, emptyValueMessage: 'entered by supplier', isInitialValue: isInitialValue }))),
        React__default.createElement("section", { className: "summary-section" },
            React__default.createElement("h4", { className: "summary-section-title" }, "Pricing"),
            React__default.createElement(SummaryRow, { label: 'Price', currentValue: currentEnquiry.price, previousValue: previousEnquiry === null || previousEnquiry === void 0 ? void 0 : previousEnquiry.price, emptyValueMessage: '-', isInitialValue: isInitialValue }),
            currentEnquiry.priceUnit && currentEnquiry.energyUnit && currentEnquiry.grossNet && (React__default.createElement(SummaryRow, { label: 'Unit', currentValue: currentEnquiry.priceUnit + "/" + currentEnquiry.energyUnit + " " + (currentEnquiry.grossNet === 'GROSS' ? 'GCV' : 'NCV'), emptyValueMessage: '-', isInitialValue: isInitialValue, previousValue: (previousEnquiry === null || previousEnquiry === void 0 ? void 0 : previousEnquiry.priceUnit) && previousEnquiry.energyUnit && previousEnquiry.grossNet
                    ? (previousEnquiry === null || previousEnquiry === void 0 ? void 0 : previousEnquiry.priceUnit) + "/" + (previousEnquiry === null || previousEnquiry === void 0 ? void 0 : previousEnquiry.energyUnit) + " " + ((previousEnquiry === null || previousEnquiry === void 0 ? void 0 : previousEnquiry.grossNet) === 'GROSS' ? 'GCV' : 'NCV')
                    : undefined })),
            React__default.createElement(SummaryRow, { label: 'Offer valid', currentValue: currentEnquiry.offerExpiration, previousValue: previousEnquiry === null || previousEnquiry === void 0 ? void 0 : previousEnquiry.offerExpiration, formatAsDate: true, emptyValueMessage: '-', isInitialValue: isInitialValue })),
        React__default.createElement("section", { className: "summary-section" },
            React__default.createElement("h4", { className: "summary-section-title" }, "Schedule"),
            React__default.createElement("h5", { className: "timezone-title" },
                "Timezone: ",
                timezone.text),
            React__default.createElement("div", { className: "section-content" },
                React__default.createElement("div", { className: "split-rows receiving-vessel-section" },
                    React__default.createElement("h5", { className: "summary-section-sub-title right-align" }, "Receiving Vessel"),
                    React__default.createElement("div", { className: "rows" },
                        React__default.createElement(SummaryRow, { className: "rv-row", label: 'ETA', formatAsDate: true, currentValue: currentEnquiry.eta, previousValue: previousEnquiry === null || previousEnquiry === void 0 ? void 0 : previousEnquiry.eta, formatTimezone: timezone.value, emptyValueMessage: 'entered by customer', isInitialValue: isInitialValue }),
                        React__default.createElement(SummaryRow, { className: "rv-row", label: 'BST', formatAsDate: true, currentValue: currentEnquiry.bst, previousValue: previousEnquiry === null || previousEnquiry === void 0 ? void 0 : previousEnquiry.bst, formatTimezone: timezone.value, emptyValueMessage: '-', isInitialValue: isInitialValue, warning: validateEnquiryBST(currentEnquiry) }),
                        React__default.createElement(SummaryRow, { className: "rv-row", label: 'ETD', formatAsDate: true, currentValue: currentEnquiry.etd, previousValue: previousEnquiry === null || previousEnquiry === void 0 ? void 0 : previousEnquiry.etd, formatTimezone: timezone.value, emptyValueMessage: 'entered by customer', isInitialValue: isInitialValue }))),
                React__default.createElement("div", { className: "split-rows bunker-vessel-section" },
                    React__default.createElement("h5", { className: "summary-section-sub-title" }, "Bunker Asset"),
                    React__default.createElement("div", { className: "rows" },
                        React__default.createElement(SummaryRow, { label: 'Allowed bunkering time', formatTimezone: timezone.value, currentValue: currentEnquiry.allowedBunkeringTime, previousValue: previousEnquiry === null || previousEnquiry === void 0 ? void 0 : previousEnquiry.allowedBunkeringTime, emptyValueMessage: 'entered by supplier', isInitialValue: isInitialValue }))))),
        React__default.createElement("section", { className: "summary-section" },
            React__default.createElement("h4", { className: "summary-section-title" }, "Contract"),
            React__default.createElement(SummaryRow, { label: 'Supplier reference', currentValue: currentEnquiry.vendorReference, previousValue: previousEnquiry === null || previousEnquiry === void 0 ? void 0 : previousEnquiry.vendorReference, emptyValueMessage: '-', isInitialValue: isInitialValue }),
            React__default.createElement(SummaryRow, { label: 'Contract', currentValue: currentContract === null || currentContract === void 0 ? void 0 : currentContract.name, previousValue: previousContract === null || previousContract === void 0 ? void 0 : previousContract.name, emptyValueMessage: '-', isInitialValue: isInitialValue }))));
};

var EnquiryNegotiation = function (props) {
    var _a, _b;
    var _c = useForm({
        initialValues: props.latestEnquiry,
        validate: validateEnquiryEvent,
        onValidSubmit: submitNominationEnquiry
    }), values = _c.values, errors = _c.errors, onChangeValue = _c.onChangeValue, setAllValues = _c.setAllValues, triggerValidation = _c.triggerValidation, isDifferentFromInitial = _c.isDifferentFromInitial, handleSubmit = _c.handleSubmit;
    var _d = useState(false), editFormActive = _d[0], setEditFormActive = _d[1];
    var _e = useState(), contractCandidateEvent = _e[0], setContractCandidateEvent = _e[1];
    var selectedEnquiry = props.enquirySelection.selectedHistoricEnquiry
        ? props.enquirySelection.selectedHistoricEnquiry
        : props.latestEnquiry;
    var customerFleetCompanyId = (selectedEnquiry === null || selectedEnquiry === void 0 ? void 0 : selectedEnquiry.companyId) ? selectedEnquiry.companyId
        : props.user.companyId;
    var customerFleet = useFleetService(customerFleetCompanyId, props.authenticationService).activeShips;
    var latestEnquiryIsSelected = props.enquirySelection.selectedEnquiryIndex + 1 === ((_a = props.enquiryHistory) === null || _a === void 0 ? void 0 : _a.length);
    var receivingVessel = customerFleet.find(function (ship) { return ship._id === (selectedEnquiry === null || selectedEnquiry === void 0 ? void 0 : selectedEnquiry.receivingShipId); });
    var latestEnquirysSelected = props.enquirySelection.selectedEnquiryIndex + 1 === props.enquiryHistory.length;
    var _f = useState(), counterProposalCandidate = _f[0], setCounterProposalCandidate = _f[1];
    var userPermissions = useContext(UserPermissionContext).userPermissions;
    var customerCompanyName = selectedEnquiry && selectedEnquiry.companyId
        ? getCompanyDetails(props.companies, selectedEnquiry.companyId).companyName
        : 'your customer';
    var selectedVendor = (values === null || values === void 0 ? void 0 : values.vendorCompanyId) ? (_b = props.companies) === null || _b === void 0 ? void 0 : _b.find(function (company) { return company._id === values.vendorCompanyId; }) : undefined;
    if (!props.latestEnquiry || !selectedEnquiry) {
        return null;
    }
    if (!doesUserHavePermission(userPermissions, 'SPOT_EVENT_READ')) {
        return React__default.createElement(PermissionsWarning, null, "You are not allowed to view this enquiry");
    }
    return (React__default.createElement("div", { className: "prompt-negotiation-wrapper " + (props.className || '') },
        React__default.createElement("div", { className: "negotiation-header-wrapper" },
            React__default.createElement(NegotiationStatusHeader$1, { receivingVesselName: receivingVessel === null || receivingVessel === void 0 ? void 0 : receivingVessel.name, negotiationItem: selectedEnquiry, userProfile: props.user, isNominationInSandbox: false, showFuelbossStates: props.showFuelbossStates, companies: props.companies }),
            React__default.createElement(HistoryButton, { selectedItemIndex: props.enquirySelection.selectedEnquiryIndex, eventHistory: props.enquiryHistory, seeNextProposal: function () {
                    props.enquirySelection.selectNextHistoricEnquiry();
                    setEditFormActive(false);
                }, seePreviousProposal: function () {
                    props.enquirySelection.selectPreviousHistoricEnquiry();
                    setEditFormActive(false);
                }, editFormActive: editFormActive, sandbox: false, latestItemIsSelected: latestEnquirysSelected }),
            React__default.createElement(CounterProposalDialog, { amendOrCounterNegotiation: amendOrCounterEnquiry, counterProposalCandidate: counterProposalCandidate, clearCounterProposalCandidate: function () {
                    setCounterProposalCandidate(undefined);
                } }),
            React__default.createElement(ContractsDialog, { authenticationService: props.authenticationService, clearContractSelection: function () {
                    setContractCandidateEvent(undefined);
                }, event: contractCandidateEvent, addContractAndFinaliseEnquiry: props.addContractAndFinaliseEnquiry, contractsList: props.contractsList }),
            React__default.createElement("div", { className: "prompt-negotiation-actions" },
                !editFormActive && (React__default.createElement(NegotiationActions$1, { activateEditMode: function () {
                        setEditFormActive(true);
                    }, changeStateWhenValid: changeStateWhenValid, isDifferentFromInitial: isDifferentFromInitial, isNominationInSandbox: false, readOnly: props.readOnly, userProfile: props.user, userRoles: props.user.roles, initialEvent: props.latestEnquiry, selectedEvent: selectedEnquiry, setContractCandidateEvent: function (event) {
                        // can only be used with enquiry events. Mostly to make typescript happy
                        if (instanceOfINominationEnquiryEvent(event)) {
                            setContractCandidateEvent(event);
                        }
                    }, customerCompanyName: customerCompanyName, error: errors && !isEmpty$1(errors) ? 'Please fill in all fields correctly.' : undefined, delegationOriginEventId: undefined, showContractIntegration: false, contractsList: [] })),
                editFormActive && (React__default.createElement(ButtonGroup, null,
                    React__default.createElement(Button, { preventDoubleClick: true, primary: true, title: isDifferentFromInitial ? '' : 'No changes detected', disabled: !isDifferentFromInitial, onClick: function (e) {
                            handleSubmit();
                        } }, "Submit"),
                    React__default.createElement(Button, { className: "discard-button", preventDoubleClick: true, onClick: function () {
                            setEditFormActive(false);
                        } }, "Discard"))))),
        editFormActive && latestEnquiryIsSelected && (React__default.createElement(EnquiryForm, { readOnly: editFormActive ? false : true, authenticationService: props.authenticationService, values: editFormActive && latestEnquiryIsSelected
                ? values
                    ? values
                    : undefined
                : selectedEnquiry, prevValues: props.enquirySelection.previousHistoricEnquiry, errors: errors, bunkerShips: props.bunkerShips, pipelines: props.pipelines, currentUser: props.user, customerFleet: customerFleet, locationService: props.locationService, onChangeFormValue: onChangeValue, contractsList: props.contractsList, showHeader: true, availableDeliveryModes: selectedVendor === null || selectedVendor === void 0 ? void 0 : selectedVendor.deliveryModes, showDeliveryModeSelection: props.showDeliveryModeSelection, creatingNewEnquiry: false, 
            // @ts-ignore
            setAllValues: setAllValues })),
        (!editFormActive || !latestEnquiryIsSelected) && (React__default.createElement(EnquirySummary, { bunkerShips: props.bunkerShips, companies: props.companies, contractsList: props.contractsList, enquirySelection: props.enquirySelection, latestEnquiry: props.latestEnquiry, locationService: props.locationService, pipelines: props.pipelines, currentUser: props.user })),
        editFormActive && (React__default.createElement("div", { className: "form-action-bar" },
            React__default.createElement(ButtonGroup, null,
                React__default.createElement(Button, { preventDoubleClick: true, primary: true, title: isDifferentFromInitial ? '' : 'No changes detected', disabled: !isDifferentFromInitial, onClick: function (e) {
                        handleSubmit();
                    } }, "Submit"),
                React__default.createElement(Button, { className: "discard-button", preventDoubleClick: true, onClick: function () {
                        setEditFormActive(false);
                    } }, "Discard"))))));
    function submitNominationEnquiry(nominationEnquiry) {
        var parsedEnquiry = parseEnquiryValues(nominationEnquiry);
        amendOrCounterEnquiry('AMEND', parsedEnquiry);
    }
    function validateEnquiryEvent(nominationEnquiryEvent) {
        return validateEnquiry(nominationEnquiryEvent, props.user, false, props.showDeliveryModeSelection);
    }
    function amendOrCounterEnquiry(action, enquiryToUpdate) {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        // make sure to await this function, otherwise the error won't be caught correctly.
                        return [4 /*yield*/, props.updateSpotEnquiry(action, enquiryToUpdate)];
                    case 1:
                        // make sure to await this function, otherwise the error won't be caught correctly.
                        _a.sent();
                        setEditFormActive(false);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        // 422 => Unprocessable Entity code from the backend which tells us a amend request is not possible.
                        // Therefore a counter should be done.
                        // the 422 specifically will be thrown by the updatePromptNomination function to handle in the UI here
                        // Other errors will be handled by the service, but there's a fallback in place here just to be sure.
                        if (error_1.status && error_1.status === 422) {
                            setCounterProposalCandidate(enquiryToUpdate);
                        }
                        else {
                            handleFetchError(error_1);
                            setEditFormActive(false);
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    function activateEditMode(e) {
        // only allow edit mode for non-cancelled and non-finalized events
        if (!props.readOnly) {
            setEditFormActive(true);
        }
    }
    function changeStateWhenValid(state, onBehalf, reason) {
        return __awaiter(this, void 0, void 0, function () {
            var validateData;
            return __generator(this, function (_a) {
                try {
                    // check if the latest nomination is present and if it's state is not pending
                    if (props.latestEnquiry && props.latestEnquiry._id) {
                        // trigger the form validation
                        triggerValidation();
                        validateData = validateEnquiry(props.latestEnquiry, props.user, false, props.showDeliveryModeSelection);
                        if (!validateData || isEmpty$1(validateData) || state === 'REJECTED') {
                            props.updateEnquiryState(state, reason);
                        }
                        else {
                            // Data is not valid, activate the edit mode
                            activateEditMode();
                        }
                    }
                    else {
                        console.error('No latestPromptNomination, cannot update state');
                    }
                }
                catch (err) {
                    handleFetchError(err);
                }
                return [2 /*return*/];
            });
        });
    }
};

var DateCell = function (calendarDate, bunkerShipPlanningHorizon) {
    return /** @class */ (function (_super) {
        __extends(BaseToolbar, _super);
        function BaseToolbar() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        BaseToolbar.prototype.render = function () {
            if (this.props.value && bunkerShipPlanningHorizon) {
                var isCellToday = isToday(DateTime.fromJSDate(this.props.value));
                var inSameMonthAndYear = isSameDayAndMonth(DateTime.fromJSDate(this.props.value), DateTime.fromJSDate(calendarDate));
                if (isAfter(DateTime.fromJSDate(this.props.value), DateTime.local().plus({ days: bunkerShipPlanningHorizon }))) {
                    return createElement("div", { className: "custom-date-cell fog-of-war" }, this.props.children);
                }
                return (createElement("div", { className: "custom-date-cell " + (isCellToday ? 'today' : '') + " " + (!inSameMonthAndYear ? 'outside-month' : '') }, this.props.children));
            }
            return createElement("div", { className: "custom-date-cell" }, this.props.children);
        };
        return BaseToolbar;
    }(PureComponent));
};

var CalendarEvent = function (props) {
    var event = props.event;
    var eventAny = event;
    var eventType = getTimelineItemDisplayName(eventAny._type);
    var receivingShipName = getShipName(eventAny.receivingShipId, props.shipList) || '-';
    var bunkerShipOrPipelineName = eventAny.bunkerShipId
        ? getShipName(eventAny.bunkerShipId, props.bunkerShips)
        : eventAny.pipelineId
            ? getPipelineName(eventAny.pipelineId, props.pipelines)
            : '';
    var locationName = useLocationName(eventAny.locationId, props.locationService, formatTerminalCountry).text;
    if (props.viewType === 'day' || props.viewType === 'week') {
        return (createElement("div", { className: "calendar-event-content" },
            (eventAny._type === 'spot' || eventAny._type === 'nomination') && (createElement("div", { className: "icons" },
                eventAny._type === 'spot' && (createElement(Fragment, null,
                    createElement(Icon, null,
                        createElement(FontAwesomeIcon, { icon: faBullseye })))),
                eventAny.deliveryModes &&
                    eventAny.deliveryModes.map(function (mode) {
                        return getDeliveryModeIcon(mode);
                    }))),
            createElement("div", { className: "locationName" }, locationName),
            eventType && createElement("div", { className: "type" }, eventType),
            createElement("div", { className: "receivingShip" }, receivingShipName),
            createElement("div", { className: "amount" }, (eventAny.amount || '0') + " MT"),
            createElement("div", { className: "bunkerShip" }, bunkerShipOrPipelineName)));
    }
    return (createElement("div", { className: "calendar-event-content month-event" },
        createElement("div", { className: "locationName" }, locationName),
        eventType && createElement("div", { className: "type" }, eventType),
        createElement("div", { className: "amount" }, (eventAny.amount || '0') + " MT"),
        (isCustomer(props.currentUser.roles) || isOperator(props.currentUser.roles)) && (createElement("div", { className: "receivingShip" }, receivingShipName)),
        isScheduler(props.currentUser.roles) ||
            (isReceivingCaptain(props.currentUser.roles) && (createElement("div", { className: "bunkerShip" }, bunkerShipOrPipelineName)))));
    function getShipName(shipId, shipList) {
        var matchingShip = shipList && shipList.find(function (ship) { return ship._id === shipId; });
        return matchingShip ? matchingShip.name : shipId;
    }
    function getPipelineName(pipelineId, pipelines) {
        var matchingPipeline = pipelines && pipelines.find(function (pipeline) { return pipeline._id === pipelineId; });
        return matchingPipeline ? matchingPipeline.name : pipelineId;
    }
};

var CalendarLegend = /** @class */ (function (_super) {
    __extends(CalendarLegend, _super);
    function CalendarLegend() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Get color for this event
         */
        _this.getColor = function (event) {
            var _a = _this.props, fleet = _a.fleet, companies = _a.companies, isCaptain = _a.isCaptain;
            if (!isCaptain && fleet && fleet.length) {
                // Customer
                if (!event.receivingShipId) {
                    return '#eeeff3';
                }
                var fleetShipColor = getFleetShipColor(fleet, event.receivingShipId);
                if (fleetShipColor) {
                    return fleetShipColor;
                }
            }
            else {
                // Captain
                var eventPrompt = event;
                if (eventPrompt.companyId) {
                    var companyColor = getCompanyDetails(companies, eventPrompt.companyId).companyColor;
                    return companyColor;
                }
                else {
                    return getEventColor(event._type).background;
                }
            }
            return '#eeeff3';
        };
        _this.getShipName = function (fleet, shipId) {
            var matchingShip = fleet && fleet.find(function (ship) { return ship._id === shipId; });
            return matchingShip ? matchingShip.name : 'UNPLANNED';
        };
        return _this;
    }
    CalendarLegend.prototype.render = function () {
        var _this = this;
        var _a = this.props, allEvents = _a.allEvents, activeWindow = _a.activeWindow, fleet = _a.fleet, companies = _a.companies, isCaptain = _a.isCaptain;
        var eventsWithinWindow = allEvents.filter(function (event) {
            if (!event) {
                return false;
            }
            var eventStart = DateTime.fromJSDate(event.start);
            var eventEnd = DateTime.fromJSDate(event.end);
            var windowStart = DateTime.fromJSDate(activeWindow.start);
            var windowEnd = DateTime.fromJSDate(activeWindow.end);
            return (isBefore(eventStart, eventEnd) && // Event start is before end
                ((isAfter(eventStart, windowStart) && isBefore(eventStart, windowEnd)) || // Start is between start and end window
                    (isAfter(eventEnd, windowStart) && isBefore(eventEnd, windowEnd)) || // End is between start and end window
                    (isBefore(eventStart, windowStart) && isAfter(eventEnd, windowEnd)))); // Start and end are around window
        });
        var uniqEvents = isCaptain
            ? uniqBy(eventsWithinWindow, function (event) { return [event.companyId, event._type].join(); })
            : uniqBy(eventsWithinWindow, 'receivingShipId');
        return (createElement("div", { className: "calendar-legend" }, uniqEvents.map(function (event, key) {
            return (createElement("div", { key: key },
                createElement("span", { style: { background: _this.getColor(event) } }),
                !isCaptain && fleet
                    ? _this.getShipName(fleet, event.receivingShipId)
                    : event.companyId
                        ? getCompanyName(null, companies, event.companyId)
                        : getTimelineItemDisplayName(event._type)));
        })));
    };
    return CalendarLegend;
}(PureComponent));

var CalendarToolbar = function (props) {
    var emptyTimezoneValue = props.emptyTimezoneValue, onChangeTimezone = props.onChangeTimezone, activeTimezone = props.activeTimezone, onDateChange = props.onDateChange, views = props.views, onNavigate = props.onNavigate, label = props.label, view = props.view;
    var currentView = view;
    var _a = useState(false), datepickerActive = _a[0], setDatepickerActive = _a[1];
    return (React__default.createElement("div", null,
        props.toolbarSettings.showToolbar && (React__default.createElement("div", { className: "rbc-custom-toolbar chorus-components" },
            React__default.createElement("div", null,
                React__default.createElement("div", null, props.toolbarSettings.showDateNavigation && (React__default.createElement(ButtonGroup, null,
                    React__default.createElement(Button$1, { preventDoubleClick: true, iconButton: true, primary: true, onClick: function () { return onNavigate('PREV'); }, disabled: isPrevDisabled() },
                        React__default.createElement(Icon, null,
                            React__default.createElement(FontAwesomeIcon, { icon: faChevronLeft }))),
                    !isTodayDisabled() && (React__default.createElement(Button$1, { preventDoubleClick: true, iconButton: true, primary: true, onClick: function () { return onNavigate('TODAY'); } },
                        React__default.createElement(Icon, null,
                            React__default.createElement(FontAwesomeIcon, { icon: faClock })))),
                    React__default.createElement(Button$1, { preventDoubleClick: true, iconButton: true, primary: true, onClick: function () { return onNavigate('NEXT'); }, disabled: isNextDisabled() },
                        React__default.createElement(Icon, null,
                            React__default.createElement(FontAwesomeIcon, { icon: faChevronRight }))),
                    React__default.createElement("div", { className: "go-to-button-wrapper" },
                        React__default.createElement(Button$1, { preventDoubleClick: true, primary: true, onClick: function () {
                                setDatepickerActive(!datepickerActive);
                            } },
                            React__default.createElement(Icon, null,
                                React__default.createElement(FontAwesomeIcon, { icon: faCalendarDay }),
                                "Go to")),
                        React__default.createElement("div", { className: "go-to-datepicker" },
                            React__default.createElement(DateDialog, { onDateSave: onDateChange, showDateDialog: datepickerActive, closeDateDialog: function () { return setDatepickerActive(false); }, dateSelectDialogTitle: '' }))))))),
            React__default.createElement("h2", null, label),
            React__default.createElement("div", null,
                props.toolbarSettings.showAddNominationButton && isTrampCompany(props.companies, props.userCompanyId) && (React__default.createElement(Button$1, { preventDoubleClick: true, onClick: goToAddNomationPage }, "Add new nomination")),
                React__default.createElement(InlineFormElement, null,
                    props.toolbarSettings.showViewSelect && (React__default.createElement(React__default.Fragment, null, views.length > 1 && (React__default.createElement(FormElement, null,
                        React__default.createElement(SelectionBox, { disableSearch: true, fieldName: "view", value: currentView, valueKey: "value", displayKey: "text", renderFieldValue: function (selectedItem) {
                                return "" + selectedItem.text;
                            }, onChangeValue: function (selectedItem) {
                                if (selectedItem) {
                                    props.onView(selectedItem.value);
                                }
                            }, options: views.map(function (view) { return ({ value: view, text: view }); }), renderOption: function (option) {
                                return (React__default.createElement("div", null,
                                    React__default.createElement("span", null, option.text)));
                            } }))))),
                    props.toolbarSettings.showTimezoneSelect && (React__default.createElement(FormElement, null,
                        React__default.createElement(SelectionBox, { disableSearch: true, fieldName: "timezone", value: activeTimezone, valueKey: "value", displayKey: "text", renderFieldValue: function (selectedItem) {
                                return "" + selectedItem.text;
                            }, onChangeValue: function (selectedItem) {
                                if (selectedItem) {
                                    onChangeTimezone(selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value);
                                }
                            }, options: __spreadArrays([emptyTimezoneValue], TIMEZONE_NAMES).map(function (view) { return ({ value: view, text: view }); }), renderOption: function (option) {
                                return (React__default.createElement("div", null,
                                    React__default.createElement("span", null, option.text)));
                            } }))))))),
        props.renderEventFilter ? props.renderEventFilter(props.filteredStates || []) : null));
    function goToAddNomationPage() {
        var monthNumber = props.date.getMonth() + 1;
        var month = monthNumber < 10 ? '0' + monthNumber : monthNumber.toString();
        var year = props.date.getFullYear().toString();
        if (props.onClickAddNomination) {
            props.onClickAddNomination(year, month);
        }
    }
    function isTrampCompany(companies, userCompanyId) {
        var company = companies.find(function (comp) { return comp._id === userCompanyId; });
        var companyType = company === null || company === void 0 ? void 0 : company.companyType;
        var isTramp = companyType === 'TRAMP';
        return isTramp;
    }
    function isPrevDisabled() {
        if (!props.minDate) {
            return false;
        }
        var monthEarlier = DateTime.fromJSDate(props.date).minus({ month: 1 });
        return isBefore(monthEarlier, DateTime.fromISO(props.minDate));
    }
    function isNextDisabled() {
        if (!props.maxDate) {
            return false;
        }
        var monthLater = DateTime.fromJSDate(props.date).plus({ month: 1 });
        return isAfter(monthLater, DateTime.fromISO(props.maxDate));
    }
    function isTodayDisabled() {
        if (!props.maxDate && !props.minDate) {
            return false;
        }
        var todayDate = DateTime.fromJSDate(new Date());
        var todayIsBeforeMin = props.minDate && isBefore(todayDate, DateTime.fromISO(props.minDate));
        var todayIsAfterMax = props.maxDate && isAfter(todayDate, DateTime.fromISO(props.maxDate));
        return todayIsBeforeMin || todayIsAfterMax ? true : false;
    }
};

var emptyTimezoneValue = 'Local time';
var EventsCalendar = function (props) {
    var _a;
    var userRoles = props.userProfile.roles;
    var savedViewType = loadFromLocalStorage('BC_VIEW_TYPE', undefined);
    var calendarStartEnd = getCalendarStartAndEnd();
    var _b = useState([]), promptEvents = _b[0], setPromptEvents = _b[1];
    var _c = useState([]), shipList = _c[0], setShipList = _c[1];
    var _d = useState(props.initialTimeSelection), initialTimeSelection = _d[0], setInitialTimeSelection = _d[1];
    var _e = useState(props.initialCalendarViewType
        ? props.initialCalendarViewType
        : savedViewType
            ? savedViewType
            : 'month'), viewType = _e[0], setViewType = _e[1];
    var _f = useState({
        start: calendarStartEnd.start.toJSDate(),
        end: calendarStartEnd.end.toJSDate()
    }), calendarActiveWindow = _f[0], setCalendarActiveWindow = _f[1];
    var _g = useState({
        start: calendarStartEnd.start.minus({ months: 1 }).toJSDate(),
        end: calendarStartEnd.end.plus({ months: 1 }).toJSDate()
    }), fetchedDataWindow = _g[0], setFetchedDataWindow = _g[1];
    var _h = useState(loadFromLocalStorage('ACTIVE_TIMEZONE', undefined)), activeTimezone = _h[0], setActiveTimezone = _h[1];
    var userCompany = props.companies.find(function (company) { return company._id === props.userProfile.companyId; });
    var companyType = userCompany === null || userCompany === void 0 ? void 0 : userCompany.companyType;
    var isTramp = companyType === 'TRAMP';
    var _j = useState(calendarStartEnd.start.toJSDate()), calendarDate = _j[0], setActiveDate = _j[1];
    // PromptEvents with filters
    var filteredPromptEvents = isScheduler(userRoles)
        ? promptEvents.filter(function (x) { return x._type !== 'travel'; })
        : promptEvents; // filters out any travel events ( if scheduler )
    //  filter out the spot events from the calendar for every role who is not a scheduler.
    var eventsWithSpotFilter = !isScheduler(userRoles)
        ? filteredPromptEvents.filter(function (x) { return x._type !== 'spot'; })
        : filterSpotEventStates(filteredPromptEvents);
    var eventsWithFilterApplied = props.filteredStates
        ? eventsWithSpotFilter.filter(function (event) {
            var _a, _b;
            if (instanceOfNominationTimelineItem(event) && ((_a = event === null || event === void 0 ? void 0 : event.attributes) === null || _a === void 0 ? void 0 : _a.fbStatus)) {
                if ((_b = props.filteredStates) === null || _b === void 0 ? void 0 : _b.includes(event.attributes.fbStatus)) {
                    return true;
                }
                else {
                    return false;
                }
            }
            else {
                return true;
            }
        })
        : eventsWithSpotFilter;
    var calendarEvents = formatEventsToCalendarFormat(eventsWithFilterApplied).filter(function (event) { return event; });
    var calendarViews = ['month', 'week', 'day'];
    var captainBunkership = props.bunkerShips.find(function (x) { return x._id === props.userProfile.bunkerShipId; });
    useEffect(function () {
        fetchAll(fetchedDataWindow.start, fetchedDataWindow.end);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fetchedDataWindow]);
    useEffect(function () {
        if (!isEqual(props.initialTimeSelection, initialTimeSelection)) {
            var calendarStartEnd_1 = getCalendarStartAndEnd();
            setActiveDate(calendarStartEnd_1.start.toJSDate());
            setCalendarActiveWindow({
                start: calendarStartEnd_1.start.toJSDate(),
                end: calendarStartEnd_1.end.toJSDate()
            });
            setInitialTimeSelection(props.initialTimeSelection);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.initialTimeSelection]);
    useEffect(function () {
        // When user clicks through the calendar check if new data needs to be fetched
        if (isBefore(DateTime.fromJSDate(calendarActiveWindow.start), DateTime.fromJSDate(fetchedDataWindow.start)) ||
            isAfter(DateTime.fromJSDate(calendarActiveWindow.end), DateTime.fromJSDate(fetchedDataWindow.end))) {
            // When the end time is after the fetched end time
            var newStart = DateTime.fromJSDate(calendarActiveWindow.start)
                .minus({ months: 1 })
                .toJSDate();
            var newEnd = DateTime.fromJSDate(calendarActiveWindow.end).plus({ months: 1 }).toJSDate();
            setFetchedDataWindow({ start: newStart, end: newEnd });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [calendarActiveWindow]);
    return (React__default.createElement("div", { className: (props.className || '') + " events-calendar-wrapper" },
        React__default.createElement(Refresher, { onRefresh: fetchEvents, onRefreshCallback: props.onRefetchData, interval: DATA_REFRESH_INTERVAL, refreshOnMount: false }),
        React__default.createElement(Calendar, { className: "events-calendar " + (((_a = props.toolbarSettings) === null || _a === void 0 ? void 0 : _a.showToolbar) ? 'with-toolbar' : ''), events: calendarEvents, views: calendarViews, localizer: momentLocalizer(moment), popup: true, popupOffset: { x: 250, y: 250 }, components: {
                dateCellWrapper: DateCell(calendarDate, isCaptain(userRoles) && captainBunkership && captainBunkership.planningHorizon
                    ? captainBunkership.planningHorizon
                    : undefined),
                toolbar: function (toolbarProps) {
                    return CalendarToolbar(__assign({ onChangeTimezone: handleChangeTimezone, emptyTimezoneValue: emptyTimezoneValue, activeTimezone: activeTimezone, companies: props.companies, userCompanyId: props.userProfile.companyId, userRoles: props.userProfile.roles, onDateChange: onDateChange, onClickAddNomination: props.onClickAddNomination
                            ? props.onClickAddNomination
                            : function () { return null; }, minDate: props.minDate, maxDate: props.maxDate, renderEventFilter: props.renderEventFilter, toolbarSettings: props.toolbarSettings, filteredStates: props.filteredStates }, toolbarProps));
                }
            }, defaultView: viewType, date: calendarDate, onView: function (view) {
                saveToLocalStorage('BC_VIEW_TYPE', view);
                setViewType(view);
            }, getNow: getNow, step: 60, showMultiDayTimes: true, onNavigate: setNewActiveDate, formats: getCalendarDateFormats(), onSelectEvent: props.onSelectEvent, eventPropGetter: eventPropGetter, tooltipAccessor: function (event) {
                return isPromptEvent(event) ? event._type : 'Nomination from year or month schedule';
            }, selectable: isTramp, toolbar: props.toolbarSettings.showToolbar }),
        !isScheduler(userRoles) && !isReceivingCaptain(userRoles) ? (React__default.createElement(CalendarLegend, { activeWindow: calendarActiveWindow, allEvents: calendarEvents, fleet: props.userCompanyFleet, companies: props.companies, isCaptain: isCaptain(userRoles) })) : null));
    function getNow() {
        var now = new Date();
        var userRoles = props.userProfile.roles;
        return isCaptain(userRoles) ? dateStringToZonedJSDate(now.toISOString(), activeTimezone) : now;
    }
    function handleChangeTimezone(timezone) {
        if (activeTimezone !== timezone) {
            if (timezone) {
                setActiveTimezone(timezone);
            }
            if (timezone) {
                saveToLocalStorage('ACTIVE_TIMEZONE', timezone);
            }
            else {
                removeFromLocalStorage('ACTIVE_TIMEZONE');
            }
        }
    }
    function setNewActiveDate(date) {
        saveToLocalStorage('BC_START_DATE', date.toISOString());
        setActiveDate(date);
        var dateTime = DateTime.fromJSDate(date);
        var startCalendar = viewType === 'week'
            ? dateTime.startOf('week').toJSDate()
            : dateTime.startOf('month').toJSDate();
        var endCalendar = viewType === 'week' ? dateTime.endOf('week').toJSDate() : dateTime.endOf('month').toJSDate();
        setCalendarActiveWindow({ start: startCalendar, end: endCalendar });
    }
    function onDateChange(date) {
        var dateToNavigate = DateTime.fromISO(date);
        var isvalid = dateToNavigate.isValid;
        if (dateToNavigate && isvalid) {
            setNewActiveDate(dateToNavigate.toJSDate());
        }
    }
    function fetchAll(start, end) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all([fetchEvents(start, end)])];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    function fetchEvents(start, end) {
        return __awaiter(this, void 0, void 0, function () {
            var startTime, endTime, userProfile, promptEvents_1, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        startTime = start ? start.toISOString() : fetchedDataWindow.start.toISOString();
                        endTime = end ? end.toISOString() : fetchedDataWindow.end.toISOString();
                        userProfile = props.userProfile;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, getPromptEventsForUser(props.authenticationService, userProfile, startTime, endTime, undefined, props.activeCompanyId)];
                    case 2:
                        promptEvents_1 = _a.sent();
                        setPromptEvents(promptEvents_1);
                        return [4 /*yield*/, getShipsDerivedFromEvents(promptEvents_1)];
                    case 3:
                        _a.sent();
                        return [2 /*return*/, { promptEvents: promptEvents_1 }];
                    case 4:
                        err_1 = _a.sent();
                        handleFetchError(err_1);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/, []];
                }
            });
        });
    }
    function getShipsDerivedFromEvents(promptEvents) {
        return __awaiter(this, void 0, void 0, function () {
            var shipIdList, shipList;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        shipIdList = [];
                        // Add ships from the prompt events
                        promptEvents.forEach(function (event) {
                            if (event.receivingShipId) {
                                shipIdList.push(event.receivingShipId);
                            }
                        });
                        return [4 /*yield*/, getShipsById(props.authenticationService, shipIdList)];
                    case 1:
                        shipList = _a.sent();
                        setShipList(shipList);
                        return [2 /*return*/];
                }
            });
        });
    }
    function formatEventsToCalendarFormat(promptEvents) {
        return promptEvents.map(function (event) { return getCalendarEvent(event); }).filter(function (event) { return event; });
    }
    function filterSpotEventStates(promptEvents) {
        return promptEvents.filter(function (event) {
            if (instanceOfINominationEnquiryEvent(event)) {
                if (event.state === 'FINALISED' || event.state === 'CANCELLED') {
                    return false;
                }
                else {
                    return true;
                }
            }
            else {
                return true;
            }
        });
    }
    function getCalendarEvent(event) {
        var userProfile = props.userProfile;
        var startCaptain = event.bunkershipAta || event.bunkershipEta || event.bst || event.eta;
        var startCustomer = event.ata || event.eta || event.bst;
        var endCaptain = event.bunkershipAtd || event.bunkershipEtd || event.etd;
        var endCustomer = event.atd || event.etd;
        var endCaptainDate = endCaptain
            ? getEventEndDate(endCaptain)
            : getEventEndDate(DateTime.fromISO(startCaptain).plus({ hours: DEFAULT_TRANSFER_DURATION_HOURS }).toISO());
        var endCustomerDate = endCustomer
            ? getEventEndDate(endCustomer)
            : getEventEndDate(DateTime.fromISO(startCustomer).plus({ hours: DEFAULT_TRANSFER_DURATION_HOURS }).toISO());
        if (isBunkerCaptain(userProfile.roles)
            ? !startCaptain || !endCaptain
            : !startCustomer || !endCustomer) {
            return;
        }
        var start = isBunkerCaptain(userProfile.roles) ? startCaptain : startCustomer;
        var end = isBunkerCaptain(userProfile.roles) ? endCaptainDate : endCustomerDate;
        return Object.assign({}, event, {
            start: isCaptain(userProfile.roles)
                ? dateStringToZonedJSDate(start, activeTimezone)
                : new Date(start),
            end: isCaptain(userProfile.roles)
                ? dateStringToZonedJSDate(end, activeTimezone)
                : new Date(end),
            id: event._id,
            allDay: false,
            title: (React__default.createElement(CalendarEvent, { viewType: viewType, event: event, shipList: shipList, bunkerShips: props.bunkerShips, locationService: props.locationService, currentUser: props.userProfile, pipelines: props.pipelines }))
        });
    }
    function eventPropGetter(event) {
        var _a, _b;
        var companies = props.companies, userProfile = props.userProfile, userCompanyFleet = props.userCompanyFleet;
        var defaultColor = '#e8e8e8';
        var fontColor = '#000';
        var promptEvent = event;
        var eventNomination = event;
        if (isCustomer(userProfile.roles) && props.useCompanyColors) {
            // As customer set the event colors on matching ships (from company fleet)
            if (!isEmpty$1(userCompanyFleet) && eventNomination.receivingShipId) {
                var fleetShipColor = getFleetShipColor(userCompanyFleet, eventNomination.receivingShipId);
                if (fleetShipColor) {
                    defaultColor = fleetShipColor;
                    fontColor = '#fff';
                }
            }
        }
        else if ((!isPromptEvent(event) || isPromptNomination(promptEvent)) &&
            props.useCompanyColors) {
            if (eventNomination.companyId) {
                var companyColor = getCompanyDetails(companies, eventNomination.companyId).companyColor;
                defaultColor = companyColor;
                fontColor = '#fff';
            }
        }
        else if (promptEvent._type) {
            var _c = getEventColor(promptEvent._type), background = _c.background, color = _c.color;
            defaultColor = background;
            fontColor = color;
        }
        return {
            className: instanceOfNominationTimelineItem(promptEvent) ||
                instanceOfINominationEnquiryEvent(promptEvent)
                ? '' + ((_a = promptEvent.attributes) === null || _a === void 0 ? void 0 : _a.fbStatus)
                : promptEvent._type
                    ? promptEvent._type + "-event"
                    : '',
            style: {
                background: instanceOfNominationTimelineItem(event) && ((_b = event.attributes) === null || _b === void 0 ? void 0 : _b.needsAction) === true
                    ? '#ffe2e3'
                    : defaultColor,
                color: fontColor,
                borderRadius: '0px',
                padding: '5px'
            }
        };
    }
    function getCalendarStartAndEnd() {
        var initialTimeSelection = props.initialTimeSelection;
        var savedCalendarDate = loadFromLocalStorage('BC_START_DATE', undefined)
            ? DateTime.fromISO(loadFromLocalStorage('BC_START_DATE', undefined))
            : undefined;
        // if a date is saved in local storage we take that year and month
        // if if a initial time selection was supplied we use that
        // if none of the above applies we use the current year and month
        var initialTime = initialTimeSelection
            ? {
                year: initialTimeSelection.year,
                month: initialTimeSelection.month ? initialTimeSelection.month : DateTime.local().month,
                day: initialTimeSelection.day ? initialTimeSelection.day : DateTime.local().day
            }
            : !props.disableUsePreviousSelection && savedCalendarDate
                ? { year: savedCalendarDate.year, month: savedCalendarDate.month, day: DateTime.local().day }
                : { year: DateTime.local().year, month: DateTime.local().month, day: DateTime.local().day };
        return {
            start: DateTime.fromObject({
                year: initialTime.year,
                month: initialTime.month,
                day: initialTime.day
            }).startOf(props.initialCalendarViewType ? props.initialCalendarViewType : 'month'),
            end: DateTime.fromObject({ year: initialTime.year, month: initialTime.month, day: 1 }).endOf(props.initialCalendarViewType ? props.initialCalendarViewType : 'month')
        };
    }
};
var EventsCalendar$1 = React__default.memo(EventsCalendar);
function getCalendarDateFormats() {
    return {
        dateFormat: 'DD',
        dayRangeHeaderFormat: function (_a) {
            var start = _a.start, end = _a.end;
            return formatDateWithoutYear(start) + ' — ' + formatDate(end);
        }
    };
}
function getEventEndDate(date) {
    if (!date) {
        return '';
    }
    var parsedDate = DateTime.fromISO(date);
    if (parsedDate.toFormat('HHmm') === '0000') {
        // Needed to prevent event showing in the allDay row
        return parsedDate.minus({ milliseconds: 1 }).toISO();
    }
    else {
        return date;
    }
}

function copyFieldsFromPreviousNomination(previous) {
    var valuesToCopy = {};
    if (previous) {
        var fieldsToCopy = [
            'receivingShipId',
            'vendorCompanyId',
            'locationId',
            'location',
            'co2TaxEnabled',
            'agent',
            'buyerRef',
            'deliveryMode',
            'customerThirdPartyContactIds',
            'buyerTerms',
            'tolerance',
            'quantityUnit',
            'amount',
            'nextDestination'
        ];
        fieldsToCopy.forEach(function (key) {
            valuesToCopy[key] = previous[key];
        });
    }
    return valuesToCopy;
}
function getInitialValues(userProfile, createNominationOnBehalf, copyFromNomination) {
    var baseNomination = __assign(__assign({}, getNewPromptNomination()), copyFieldsFromPreviousNomination(copyFromNomination));
    if (createNominationOnBehalf) {
        // if onbehalf, we attach the users companyId as the vendor companyId of the nomination
        if (isSchedulerCaptain(userProfile.roles)) {
            // if it's onbehalf and a schedulerCaptain add some extra static props
            return __assign(__assign({}, baseNomination), { vendorCompanyId: userProfile.companyId, deliveryMode: 'SHIP', bunkerShipId: userProfile.bunkerShipId });
        }
        return __assign(__assign({}, baseNomination), { vendorCompanyId: userProfile.companyId });
    }
    // if it's on behalf but not by a schedulerCaptain, only fill in the vendorCompanyId
    if (userProfile.receivingShipId) {
        return __assign(__assign({}, baseNomination), { receivingShipId: userProfile.receivingShipId });
    }
    return baseNomination;
}

var CreateNomination = function (props) {
    var _a, _b, _c;
    var _d = useContextualRole(props.userProfile, undefined, undefined), roles = _d.roles, originalRoles = _d.originalRoles;
    var userProfile = __assign(__assign({}, props.userProfile), { roles: roles });
    var userPermissions = useContext(UserPermissionContext).userPermissions;
    var _e = useState(undefined), onBehalfCompany = _e[0], setOnBehalfCompany = _e[1];
    var _f = useState(undefined), errorFillCompany = _f[0], setErrorFillCompany = _f[1];
    var _g = useState(false), creatingNomination = _g[0], setCreatingNomination = _g[1];
    var _h = useState(getInitialValues(props.userProfile, props.creatingNominationOnBehalf, props.copyFromNomination)), initialNominationValues = _h[0], setInitialNominationValues = _h[1];
    var _j = useContractService(props.authenticationService), vendorsWithContract = _j.vendorsWithContract, customersWithContract = _j.customersWithContract;
    var userRoles = props.userProfile && userProfile ? userProfile.roles : undefined;
    var customerCompanyName = onBehalfCompany
        ? getCompanyDetails(props.companies, onBehalfCompany).companyName
        : 'your customer';
    var debouncedSubmit = debounce(submitPromptNomination, 500, { leading: true, trailing: false });
    var _k = useForm({
        initialValues: initialNominationValues,
        validate: validateNomination,
        onValidSubmit: debouncedSubmit
    }), handleSubmit = _k.handleSubmit, values = _k.values, errors = _k.errors, onChangeValue = _k.onChangeValue, isDifferentFromInitial = _k.isDifferentFromInitial, setAllValues = _k.setAllValues;
    useEffect(function () {
        if (props.creatingNominationOnBehalf && props.copyFromNomination) {
            setOnBehalfCompany(props.copyFromNomination.companyId);
        }
        setInitialNominationValues(getInitialValues(props.userProfile, props.creatingNominationOnBehalf, props.copyFromNomination));
    }, [(_a = props.copyFromNomination) === null || _a === void 0 ? void 0 : _a._id]);
    var timezone = useLocationTimeZone(values === null || values === void 0 ? void 0 : values.locationId, props.locationService);
    var fleetCompanyId = onBehalfCompany ? onBehalfCompany : userProfile.companyId;
    var companyFleet = useFleetService(fleetCompanyId, props.authenticationService).activeShips;
    var userFleet = originalRoles.includes('ROLE_RECEIVING_SCHEDULER_CAPTAIN')
        ? companyFleet.filter(function (item) { return item._id === userProfile.receivingShipId; })
        : companyFleet;
    var errorMessage = 'Please fill in all fields correctly.';
    if (!doesUserHavePermission(userPermissions, 'NOMINATION_CREATE')) {
        return React__default.createElement(PermissionsWarning, null, "You are not allowed to Create a new nomination'");
    }
    var customerCompaniesFilteredByContract = props.companies
        .filter(function (company) { return company.companyType === 'TRAMP' && !company.deleted; })
        .filter(function (company) {
        return customersWithContract.has(company._id);
    });
    var rvscOptions = (_c = (_b = userFleet[0]) === null || _b === void 0 ? void 0 : _b.charterers) === null || _c === void 0 ? void 0 : _c.filter(function (it) { return it.activeInFleet && it.allowShipOwnerToCreateNominations; });
    var rvscCreatingOptions = originalRoles.includes('ROLE_RECEIVING_SCHEDULER_CAPTAIN') && rvscOptions
        ? __spreadArrays(rvscOptions, props.companies
            .filter(function (it) { return it._id === userProfile.companyId && it.companyType === 'TRAMP'; })
            .map(function (it) {
            return { companyName: it.name, companyId: it._id };
        })) : undefined;
    return (React__default.createElement("div", { className: "prompt-negotiation-wrapper " + (props.className || '') },
        React__default.createElement("div", null,
            React__default.createElement("form", { noValidate: true, className: "form-wrapper-prompt" }, values && (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(PromptNominationForm, { currentUser: userProfile, creatingNewNomination: true, values: values, authenticationService: props.authenticationService, locationService: props.locationService, errors: errors, bunkerShips: props.bunkerShips, customerFleet: userFleet, onChangeFormValue: onChangeValue, companies: props.companies, creatingNominationOnBehalf: props.creatingNominationOnBehalf, onBehalfCompany: onBehalfCompany, showDeliveryModeSelection: props.showDeliveryModeSelection, vendorsWithContract: vendorsWithContract, contractsList: props.contractsList, setAllValues: setAllValues, pipelines: props.pipelines, enableAlternativeFuelSelector: props.enableAlternativeFuelSelector, editType: props.creatingNominationOnBehalf ? 'EDIT_ON_BEHALF' : 'EDIT', customerCompanyName: customerCompanyName, isDelegatedNomination: false, currentThirdPartyContacts: [] },
                    props.creatingNominationOnBehalf && (React__default.createElement(React__default.Fragment, null,
                        React__default.createElement("div", { className: "form-section" },
                            React__default.createElement(FormWrapper, null,
                                React__default.createElement(FormElement, null,
                                    React__default.createElement(FormLabel, { fieldName: "onBehalfCompany" }, "Customer"),
                                    React__default.createElement(SelectionBox, { value: onBehalfCompany || '', fieldName: "onBehalfCompany", onChangeValue: handleSelectOnBehalfCompany, options: customerCompaniesFilteredByContract, valueKey: '_id', placeholder: 'Select customer...', displayKey: "name", sortOptions: true, renderOption: function (option) {
                                            return React__default.createElement("div", null, option.name);
                                        } }),
                                    React__default.createElement(FormErrorMessage, null, errorFillCompany)))))),
                    rvscCreatingOptions && (React__default.createElement(React__default.Fragment, null,
                        React__default.createElement("div", { className: "form-section" },
                            React__default.createElement(FormWrapper, null,
                                React__default.createElement(FormElement, null,
                                    React__default.createElement(FormLabel, { fieldName: "rvsc-company-selection" }, "Company"),
                                    React__default.createElement(SelectionBox, { value: onBehalfCompany || '', fieldName: "rvsc-company-selection", onChangeValue: handleSelectCharterer, options: rvscCreatingOptions, valueKey: 'companyId', placeholder: 'Select customer...', displayKey: "companyName", renderOption: function (option) {
                                            return React__default.createElement("div", null, option.companyName || option.companyId);
                                        } }),
                                    React__default.createElement(FormErrorMessage, null, errorFillCompany))))))),
                errors && !isEmpty$1(errors) && React__default.createElement("div", { className: "error block" }, errorMessage),
                React__default.createElement("div", { className: "form-action-bar centered" },
                    React__default.createElement("p", { className: "create-message" }, "To share additional information, please click \u201CCreate nomination\u201C and use the chat"),
                    React__default.createElement("div", { className: "action-bar-buttons" }, (isScheduler(userRoles) || isSchedulerCaptain(userRoles)) &&
                        doesUserHavePermission(userPermissions, 'ACT_ON_BEHALF')
                        ? submitButton(true)
                        : submitButton()))))))));
    function handleSelectCharterer(charterer) {
        if (charterer) {
            setOnBehalfCompany(charterer.companyId);
        }
    }
    function handleSelectOnBehalfCompany(company) {
        if (company) {
            setOnBehalfCompany(company._id);
            // sets the receivingShipId to null when a company is being selected
            onChangeValue('receivingShipId', null);
        }
    }
    function submitButton(onBehalf) {
        if (onBehalf === void 0) { onBehalf = false; }
        return (React__default.createElement(Button$1, { preventDoubleClick: true, primary: true, title: isDifferentFromInitial ? '' : 'No changes detected', onClick: function (e) {
                handleSubmit(e, onBehalf);
            } }, onBehalf ? 'Create nomination for customer' : 'Create new Nomination'));
    }
    function validateNomination(nominationToValidate) {
        var roles = props.creatingNominationOnBehalf
            ? ['ROLE_CUSTOMER']
            : userProfile.roles;
        var errors = validatePromptNominationForm(nominationToValidate, userProfile, roles, props.showDeliveryModeSelection, timezone.value);
        if (timezone.loading && !errors['locationId']) {
            errors['locationId'] = 'Location is still loading. Submit again once loaded';
        }
        return errors;
    }
    function submitPromptNomination(promptNomination, onBehalfOf) {
        return __awaiter(this, void 0, void 0, function () {
            var parsedNomination, nomination;
            return __generator(this, function (_a) {
                parsedNomination = parseNominationValues(promptNomination);
                nomination = cloneDeep(parsedNomination);
                // set correct onbehalf
                nomination.onBehalf = onBehalfOf !== undefined ? onBehalfOf : false;
                createNewNomination(nomination);
                return [2 /*return*/];
            });
        });
    }
    function createNewNomination(nominationToCreate) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (creatingNomination) {
                            return [2 /*return*/];
                        }
                        if (props.creatingNominationOnBehalf) {
                            if (isEmpty$1(onBehalfCompany)) {
                                setErrorFillCompany('Please select a company');
                                return [2 /*return*/];
                            }
                            else {
                                nominationToCreate.companyId = onBehalfCompany;
                            }
                        }
                        else if (rvscCreatingOptions && onBehalfCompany) {
                            nominationToCreate.companyId = onBehalfCompany;
                        }
                        else {
                            // means we are creating a nomination ( not on behalf )
                            if (userProfile.companyId) {
                                nominationToCreate.companyId = userProfile.companyId;
                            }
                            else {
                                Raven.captureMessage('Submitting nomination without companyID', {
                                    userProfile: userProfile
                                });
                            }
                        }
                        setCreatingNomination(true);
                        return [4 /*yield*/, props.updatePromptNomination('CREATE', nominationToCreate)];
                    case 1:
                        _a.sent();
                        setOnBehalfCompany(undefined); // reset the onBehalfCompany to make sure the nomination doesn't stay in 'onbehalf' mode after it's been created
                        setCreatingNomination(true);
                        return [2 /*return*/];
                }
            });
        });
    }
};
var CreateNomination$1 = React__default.memo(CreateNomination);

var ToggleBox = function (_a) {
    var toggled = _a.toggled, onClick = _a.onClick, children = _a.children;
    return (React__default.createElement("div", { className: "toggle-box " + (toggled ? 'toggled' : 'inactive'), onClick: function (event) {
            // prevent default here else the text can be selected due to the
            // animation which shifts the text under the pressed down mouse
            event.preventDefault();
            if (onClick) {
                onClick();
            }
        } }, children(toggled)));
};

var FieldConfiguration = function (props) {
    return (React__default.createElement("div", { className: "template-configuration-fields-selection" }, Object.entries(props.fields)
        .sort()
        .map(function (_a, index) {
        var key = _a[0], value = _a[1];
        if (props.filteredFields && props.filteredFields.includes(key)) {
            return null;
        }
        return (React__default.createElement(ToggleBox, { key: "fieldSelection-overview-" + index + "-" + key, onClick: function () {
                toggleSelectedField(key);
            }, toggled: value }, function (toggled) {
            return (React__default.createElement("div", { className: "sof-toggle-content" },
                React__default.createElement(FontAwesomeIcon, { icon: toggled ? faCheck : faMinus }),
                React__default.createElement("span", { className: "toggle-title" }, props.labels[key] || key)));
        }));
    })));
    function toggleSelectedField(field) {
        var _a;
        var newSofSelection = cloneDeep(props.fields);
        newSofSelection[field] = !newSofSelection[field];
        var linkedField = ((_a = props.linkedFields) === null || _a === void 0 ? void 0 : _a[field]) || null;
        if (linkedField !== null && newSofSelection[field] === true) {
            newSofSelection[linkedField] = true;
        }
        props.setSelectedFields(newSofSelection);
    }
};

// done so we do not display those field in chorus
var defaultBdnConfigurationFuelBoss = {
    _id: '',
    name: '',
    eventLogFields: DEFAULT_EVENT_LOG_FIELDS,
    deliveredFields: DEFAULT_DELIVERED_FIELDS,
    overviewFields: __assign(__assign({}, DEFAULT_OVERVIEW_FIELDS), { loadingTerminalName: false, totalQuantityHydrogenKg: false, trailer1SerialNumber: false, trailer1PressureBeforeTransfer: false, trailer1PressureAfterTransfer: false, trailer2SerialNumber: false, trailer2PressureBeforeTransfer: false, trailer2PressureAfterTransfer: false, vesselBank1PressureBeforeTransfer: false, vesselBank1PressureAfterTransfer: false, vesselBank2PressureBeforeTransfer: false, vesselBank2PressureAfterTransfer: false, agpLicenseNumber: false, agpLicenseHolder: false, agpLicenseHolderAddress: false, receivingVesselOwner: false, totalQuantityOrdered: false }),
    propertiesFields: DEFAULT_PROPERTIES_FIELDS,
    ctmsDataFields: DEFAULT_CTMS_FIELDS,
    flowType: 'ONLINE',
    showComposition: true
};
function useBdnConfigurationService$1(authenticationService, vendorCompanyId, selectedConfig, onError, onActionSuccess) {
    return useBdnConfigurationService(authenticationService, vendorCompanyId, selectedConfig, onError, onActionSuccess, defaultBdnConfigurationFuelBoss);
}

var BdnConfigurationForm = function (props) {
    var _a = useForm({
        initialValues: props.configuration || defaultBdnConfigurationFuelBoss,
        validate: validateBdnConfiguration,
        onValidSubmit: props.createOrUpdateBdnConfiguration
    }), values = _a.values, errors = _a.errors, onChangeValue = _a.onChangeValue, handleSubmit = _a.handleSubmit, isDifferentFromInitial = _a.isDifferentFromInitial;
    return (React__default.createElement("div", { className: "bdn-configuration" },
        React__default.createElement("div", { className: "template-configuration" },
            React__default.createElement("section", null,
                React__default.createElement("h3", { className: "template-config-title" }, "Create BDN template"),
                React__default.createElement("p", null, "Create a custom BDN template to be used while executing any of the nominations associated with your company. Everyone within your organisation will be able to see this template and use it to create a bdn for your nominations.")),
            React__default.createElement("section", null,
                React__default.createElement("div", { className: "template-name-selection" },
                    React__default.createElement("h4", null, "Template name"),
                    React__default.createElement(FormElement, null,
                        React__default.createElement(TextField, { fieldName: "name", placeholder: "Template name...", value: (values === null || values === void 0 ? void 0 : values.name) || '', onChange: function (event) {
                                onChangeValue('name', event.target.value);
                            } }),
                        React__default.createElement(FormErrorMessage, null, errors === null || errors === void 0 ? void 0 : errors.name)))),
            React__default.createElement("section", null,
                React__default.createElement("div", { className: "template-field-selection" },
                    React__default.createElement("h4", null, "Overview fields"),
                    React__default.createElement("p", null, "Choose the overview fields which you would like to have available in the BDN's overview."),
                    React__default.createElement(FieldConfiguration, { fields: (values === null || values === void 0 ? void 0 : values.overviewFields) || DEFAULT_OVERVIEW_FIELDS, labels: OVERVIEW_LABELS, setSelectedFields: function (fields) {
                            onChangeValue('overviewFields', fields);
                        } }))),
            React__default.createElement("section", null,
                React__default.createElement("div", { className: "template-field-selection" },
                    React__default.createElement("h4", null, "CTMS fields"),
                    React__default.createElement("p", null, "Choose the CTMS fields which you would like to have available in the BDN's CTMS section."),
                    React__default.createElement(FieldConfiguration, { fields: (values === null || values === void 0 ? void 0 : values.ctmsDataFields) || DEFAULT_CTMS_FIELDS, labels: CTMS_LABELS, setSelectedFields: function (fields) {
                            onChangeValue('ctmsDataFields', fields);
                        } }))),
            React__default.createElement("section", null,
                React__default.createElement("div", { className: "template-field-selection" },
                    React__default.createElement("h4", null, "Event Log Fields ( SOF )"),
                    React__default.createElement("p", null, "Choose the fields from the statement of facts which you would like to have available in the EBDN Documents."),
                    React__default.createElement(FieldConfiguration, { fields: (values === null || values === void 0 ? void 0 : values.eventLogFields) || DEFAULT_EVENT_LOG_FIELDS, labels: EVENT_LOG_LABELS, setSelectedFields: function (fields) {
                            onChangeValue('eventLogFields', fields);
                        } }))),
            React__default.createElement("section", null,
                React__default.createElement("div", { className: "template-field-selection" },
                    React__default.createElement("h4", null, "Properties fields"),
                    React__default.createElement("p", null, "Choose which LNG properties you would like to have available in the EBDN Documents."),
                    React__default.createElement(FieldConfiguration, { fields: (values === null || values === void 0 ? void 0 : values.propertiesFields) || DEFAULT_PROPERTIES_FIELDS, labels: PROPERTIES_LABELS, setSelectedFields: function (fields) {
                            onChangeValue('propertiesFields', fields);
                        } }))),
            React__default.createElement("section", null,
                React__default.createElement("div", { className: "template-field-selection" },
                    React__default.createElement("h4", null, "Delivered fields"),
                    React__default.createElement("p", null, "Choose the delivery fields which you would like to have available in the EBDN Documents."),
                    React__default.createElement("h5", null, "Total quantity"),
                    React__default.createElement(FieldConfiguration, { fields: (values === null || values === void 0 ? void 0 : values.deliveredFields) || DEFAULT_DELIVERED_FIELDS, filteredFields: __spreadArrays(DELIVERED_FIELDS_GROUPING.altFuel, DELIVERED_FIELDS_GROUPING.lng), labels: DELIVERED_LABELS, setSelectedFields: function (fields) {
                            onChangeValue('deliveredFields', fields);
                        } }),
                    React__default.createElement("h5", null, "LNG quantity"),
                    React__default.createElement(FieldConfiguration, { fields: (values === null || values === void 0 ? void 0 : values.deliveredFields) || DEFAULT_DELIVERED_FIELDS, filteredFields: __spreadArrays(DELIVERED_FIELDS_GROUPING.altFuel, DELIVERED_FIELDS_GROUPING.total), linkedFields: DELIVERED_FIELDS_LINKS, labels: DELIVERED_LABELS, setSelectedFields: function (fields) {
                            onChangeValue('deliveredFields', fields);
                        } }),
                    React__default.createElement("h5", null, "LBG quantity"),
                    React__default.createElement(FieldConfiguration, { fields: (values === null || values === void 0 ? void 0 : values.deliveredFields) || DEFAULT_DELIVERED_FIELDS, filteredFields: __spreadArrays(DELIVERED_FIELDS_GROUPING.total, DELIVERED_FIELDS_GROUPING.lng), linkedFields: DELIVERED_FIELDS_LINKS, labels: DELIVERED_LABELS, setSelectedFields: function (fields) {
                            onChangeValue('deliveredFields', fields);
                        } }))),
            React__default.createElement("section", { className: "initialisation-section" },
                React__default.createElement("h4", { className: "" }, "LNG composition"),
                React__default.createElement("div", { className: "bdn-flow-selection" },
                    React__default.createElement(ToggleBox, { onClick: function () {
                            onChangeValue('showComposition', true);
                        }, toggled: (values === null || values === void 0 ? void 0 : values.showComposition) === true }, function (toggled) {
                        return (React__default.createElement("div", { className: "sof-toggle-content" },
                            React__default.createElement(FontAwesomeIcon, { icon: toggled ? faFileImport : faMinus }),
                            React__default.createElement("span", { className: "toggle-title" }, "Use composition"),
                            React__default.createElement("p", null, "Turning this setting on enables the LNG composition to be available in the BDN Document.")));
                    }),
                    React__default.createElement(ToggleBox, { onClick: function () {
                            onChangeValue('showComposition', false);
                        }, toggled: (values === null || values === void 0 ? void 0 : values.showComposition) === false }, function (toggled) {
                        return (React__default.createElement("div", { className: "sof-toggle-content" },
                            React__default.createElement(FontAwesomeIcon, { icon: toggled ? faEyeSlash : faMinus }),
                            React__default.createElement("span", { className: "toggle-title" }, "Hide composition"),
                            React__default.createElement("p", null, "Turning this setting on hides the LNG composition in the BDN Document.")));
                    }))),
            errors && errors.fieldSelection && React__default.createElement("div", { className: "error" }, errors.fieldSelection),
            React__default.createElement(ButtonGroup, null,
                React__default.createElement(Button, { preventDoubleClick: true, disabled: !isDifferentFromInitial, primary: true, onClick: handleSubmit }, (values === null || values === void 0 ? void 0 : values._id) ? 'Update Template' : 'Create Template')))));
    function validateBdnConfiguration(bdnConfig) {
        var errors = {};
        if (!bdnConfig || !bdnConfig.name || bdnConfig.name === '') {
            errors['name'] = 'Name is Required';
        }
        return errors;
    }
};

var ReplaceDialog = function (props) {
    return (React__default.createElement(Dialog, { className: "replace-form-warning-dialog", showDialog: props.show, onCloseDialog: function () { return props.setShow(false); }, title: props.title ? props.title : "Work on " + props.formName + " is in progress." },
        React__default.createElement("div", { className: "warning-text" }, props.children
            ? props.children
            : 'If you change the template all current data will be lost.'),
        React__default.createElement("div", { style: { justifyContent: 'space-between', display: 'flex' } },
            React__default.createElement(Button, { className: "replace-button", onClick: function () {
                    props.replace();
                    props.setShow(false);
                } }, "Yes, change template"),
            React__default.createElement(Button, { className: "cancel-button", onClick: function () {
                    props.onCancel();
                    props.setShow(false);
                } }, "Cancel"))));
};

var NewFormTypeSelector = function (props) {
    var _a = useState(false), enable = _a[0], setEnable = _a[1];
    function renderSelectionBox() {
        var _a;
        if ((enable && props.editButton) || (!props.readOnly && !props.editButton)) {
            return (React__default.createElement(SelectionBox, { fieldName: "selectionbox-dropdown", value: props.value, valueKey: "id", displayKey: "", sortOptions: true, renderFieldValue: function (selectedItem) {
                    return selectedItem.text;
                }, onChangeValue: function (selectedItem) {
                    props.setValue(selectedItem !== null ? selectedItem.value : undefined);
                }, options: props.options, renderOption: function (option) {
                    return React__default.createElement("span", null, option.text);
                }, placeholder: props.placeholder ? props.placeholder : 'Select template', disabled: props.readOnly || (!enable && props.editButton) }));
        }
        else {
            return (React__default.createElement("div", { className: "value-mode" }, ((_a = props.options.find(function (it) { return it.id === props.value; })) === null || _a === void 0 ? void 0 : _a.text) || 'No template found'));
        }
    }
    return (React__default.createElement(FormElement, { className: "new-form-selector " + (props.editButton ? (enable ? 'editing-enabled' : 'editing-mode') : 'new-mode') },
        React__default.createElement(FormFieldButtonWrapper, null,
            renderSelectionBox(),
            props.editButton && !props.readOnly && (React__default.createElement(EditSaveButton, { save: props.save, enable: enable, setEnable: setEnable })))));
};
var NewFormMultipleTypeSelector = function (props) {
    var _a = useState(false), enable = _a[0], setEnable = _a[1];
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(FormElement, { className: "new-form-selector " + (props.editButton ? (enable ? 'editing-enabled' : 'editing-mode') : 'new-mode') },
            React__default.createElement(FormFieldButtonWrapper, { className: "new-form-selector-field-wrapper" },
                React__default.createElement(MultipleSelectionBox, { value: props.value, setValue: props.setValue, options: props.options, readonly: props.readOnly || (!enable && props.editButton), renderText: props.renderText, placeholder: props.readOnly ? "No extra service selected" : "Select extra services" }),
                props.editButton && !props.readOnly && (React__default.createElement(EditSaveButton, { save: props.save, enable: enable, setEnable: setEnable }))))));
};
var MultipleSelectionBox = function (props) {
    var _a = useState(false), showOptions = _a[0], setShowOptions = _a[1];
    var searchRef = useRef(null);
    useOnClickOutside(searchRef, function () {
        if (showOptions) {
            setShowOptions(false);
        }
    });
    function handleValueClick(value) {
        if (props.value.includes(value)) {
            props.setValue(props.value.filter(function (v) { return v !== value; }));
        }
        else {
            props.setValue(__spreadArrays(props.value, [value]));
        }
    }
    function renderOptions() {
        return (React__default.createElement("div", { className: "selectionbox-options-wrapper ", onBlur: function () { return setShowOptions(false); } }, props.options.map(function (option) {
            var _a;
            var selected = (_a = props.value) === null || _a === void 0 ? void 0 : _a.includes(option);
            return (React__default.createElement("div", { className: "selectionbox-option checkbox", onClick: function () { return handleValueClick(option); } },
                React__default.createElement("div", { className: "custom-checkbox" },
                    React__default.createElement("input", { type: "checkbox", id: "select-option-" + option, name: "select-option-" + option, disabled: true, checked: selected, onClick: function () { return handleValueClick(option); } }),
                    React__default.createElement("label", { htmlFor: "select-option-" + option }, props.renderText ? props.renderText(option) : option))));
        })));
    }
    function renderSelectionBox() {
        if (!props.readonly) {
            return (React__default.createElement(React__default.Fragment, null,
                React__default.createElement("div", { className: "multiselect-options-wrapper" },
                    React__default.createElement("div", { className: "input" }, props.value.length > 0 ? (props.value.map(function (item) { return (React__default.createElement(MultiSelectOption, { removeItem: function () { return !props.readonly && handleValueClick(item); }, optionText: props.renderText ? props.renderText(item) : item })); })) : (React__default.createElement("span", { className: "placeholder" }, props.placeholder || 'No option(s) selected')))),
                React__default.createElement("div", { className: "dropdown" }, !props.readonly && (React__default.createElement("button", { type: "button", onClick: function () { return setShowOptions(!showOptions); }, className: "button-component icon-button new-form-selector-button" },
                    React__default.createElement("i", { className: "icon-down-open" }))))));
        }
        else {
            return (React__default.createElement("div", { className: "multiselect-options-wrapper" },
                React__default.createElement("div", { className: "value-mode" }, props.value.length > 0 ? (React__default.createElement(React__default.Fragment, null,
                    React__default.createElement("span", { className: "options-Text" },
                        React__default.createElement("b", null, "Extras:")),
                    props.value.map(function (item, i) { return (React__default.createElement("span", { className: "options-value" },
                        props.renderText ? props.renderText(item) : item,
                        i < props.value.length - 1 && ', ')); }))) : (React__default.createElement("span", { className: "placeholder" }, props.placeholder || 'No option(s) selected')))));
        }
    }
    return (React__default.createElement("div", { className: "multiple-selector" },
        React__default.createElement("div", { className: "multiple-selector-wrapper" },
            renderSelectionBox(),
            !props.readonly && showOptions && renderOptions())));
};
var EditSaveButton = function (props) {
    if (props.enable)
        return (React__default.createElement(Button$1, { onClick: function () {
                if (props.save) {
                    props.save();
                    props.setEnable(false);
                }
            }, iconButton: true },
            React__default.createElement(FontAwesomeIcon, { icon: faSave })));
    return (React__default.createElement("div", { className: "button-pen", onClick: function () { return props.setEnable(!props.enable); } },
        React__default.createElement(FontAwesomeIcon, { icon: faPen, onClick: function () { return props.setEnable(!props.enable); } })));
};

var BDNInitialisation = function (props) {
    var _a;
    var _b = useState(false), replaceDialog = _b[0], setReplaceDialog = _b[1];
    var userPermissions = useContext(UserPermissionContext).userPermissions;
    var _c = useState(), selectedConfiguration = _c[0], setSelectedConfiguration = _c[1];
    // const [initialiseError, setInitialiseError] = useState<string>()
    var userCanCreate = doesUserHavePermission(userPermissions, 'EBDN_CREATE');
    if (!userCanCreate && !props.currentBDN) {
        return React__default.createElement(PermissionsWarning, null, "You are not allowed to create a new BDN.");
    }
    return (React__default.createElement("div", { className: "bdn-initialisation" },
        React__default.createElement(ReplaceDialog, { replace: function () { return props.initialiseNewBDN(selectedConfiguration); }, onCancel: function () { var _a; return setSelectedConfiguration((_a = props.currentBDN) === null || _a === void 0 ? void 0 : _a.configuration); }, formName: "eBDN", show: replaceDialog, setShow: setReplaceDialog }),
        typeof props.currentBDN === 'undefined' && (React__default.createElement("div", null,
            React__default.createElement("div", { className: "bdn-explanation-block" },
                React__default.createElement("p", null, "The data in the nomination and statement of facts are required to complete the eBDN. Please make sure all values are filled in correctly.")))),
        userCanCreate ? (React__default.createElement(NewFormTypeSelector, { value: (selectedConfiguration === null || selectedConfiguration === void 0 ? void 0 : selectedConfiguration._id) || ((_a = props.currentBDN) === null || _a === void 0 ? void 0 : _a.configuration._id), setValue: setSelectedConfiguration, editButton: typeof props.currentBDN !== 'undefined', readOnly: !userCanCreate, save: saveEBDN, options: props.bdnConfigurationsList.map(function (item) {
                return { id: item._id, value: item, text: item.name };
            }) })) : (React__default.createElement(React__default.Fragment, null, doesUserHavePermission(userPermissions, 'EBDN_READ') && !props.currentBDN ? (React__default.createElement("div", null, "No BDN Documents have been created yet.")) : null)),
        typeof props.currentBDN === 'undefined' && (React__default.createElement(Button, { preventDoubleClick: true, primary: true, onClick: function () {
                props.initialiseNewBDN(selectedConfiguration);
            }, disabled: typeof selectedConfiguration === 'undefined' }, "Create new BDN"))));
    function saveEBDN() {
        if (typeof props.currentBDN === 'undefined') {
            props.initialiseNewBDN(selectedConfiguration);
        }
        else {
            setReplaceDialog(true);
        }
    }
};

var LoadingIndicator = function (props) {
    if (props.loading) {
        if (props.withBackgroundBlur === true) {
            return (React__default.createElement("div", { className: "loading-background" },
                React__default.createElement("div", { className: "loading-ring" })));
        }
        else {
            return React__default.createElement("div", { className: "loading-ring" });
        }
    }
    else {
        return null;
    }
};

var ebdnDetailsFields = {
    agent: 'string',
    bunkerShipImoNumber: 'string',
    bunkerShipName: 'string',
    date: 'string',
    deliveryPoint: 'string',
    driver: 'string',
    licenseNumbers: 'string',
    tankerLicenseNumbers: 'string',
    nextDestination: 'string',
    portOfLoading: 'string',
    receiver: 'string',
    receiverReference: 'string',
    receivingShipImoNumber: 'string',
    receivingShipName: 'string',
    supplier: 'string',
    vendorReference: 'string',
    co2TaxEnabled: 'boolean',
    combustionReferenceTemperature: 'string',
    meteringReferenceTemperature: 'string',
    totalQuantityHydrogenKg: 'number',
    trailer1SerialNumber: 'number',
    trailer1PressureBeforeTransfer: 'number',
    trailer1PressureAfterTransfer: 'number',
    trailer2SerialNumber: 'number',
    trailer2PressureBeforeTransfer: 'number',
    trailer2PressureAfterTransfer: 'number',
    vesselBank1PressureBeforeTransfer: 'number',
    vesselBank1PressureAfterTransfer: 'number',
    vesselBank2PressureBeforeTransfer: 'number',
    vesselBank2PressureAfterTransfer: 'number',
    loadingTerminalName: 'string',
    pipelineName: 'string',
    supplierAddress: 'string',
    bdnLicense: 'string',
    supplierOrganisation: 'string',
    buyerOrganisation: 'string',
    bdnId: 'string',
    agpLicenseNumber: 'string',
    agpLicenseHolder: 'string',
    agpLicenseHolderAddress: 'string',
    receivingVesselOwner: 'string'
};

var BDNNominationSummary = function (props) {
    var _a = useForm({
        initialValues: props.values,
        onValidSubmit: props.update
    }), handleSubmit = _a.handleSubmit, values = _a.values, onChangeValue = _a.onChangeValue, isDifferentFromInitial = _a.isDifferentFromInitial;
    return (React__default.createElement("div", { className: "bdn-step" },
        React__default.createElement("table", null,
            React__default.createElement("colgroup", null,
                React__default.createElement("col", { span: 2 }),
                React__default.createElement("col", null)),
            React__default.createElement("tbody", null, Object.entries(props.configuration.overviewFields).map(function (_a, index) {
                var key = _a[0], value = _a[1];
                if (!value) {
                    return null;
                }
                if (key === 'totalQuantityOrdered') {
                    return (React__default.createElement(BDNField, { objectKey: key, index: index },
                        React__default.createElement("input", { type: "text", value: 'Filled in by system when generating PDF', disabled: true })));
                }
                if (ebdnDetailsFields[key] === 'boolean') {
                    return (React__default.createElement(BDNField, { objectKey: key, index: index, tdStyle: { display: 'flex', paddingLeft: '15px', backgroundColor: '#fbfbfb' } },
                        React__default.createElement(Checkbox, { field: key, value: values && values[key] !== null ? values[key] : '', disabled: props.readOnly, className: key, onChange: function (e) {
                                onChangeValue(key, values && values[key] !== null ? !values[key] : '');
                            } })));
                }
                if (ebdnDetailsFields[key] === 'number') {
                    return (React__default.createElement(BDNField, { objectKey: key, index: index },
                        React__default.createElement("input", { type: "number", value: values && values[key] ? values[key] : '', disabled: props.readOnly, onChange: function (e) {
                                onChangeValue(key, Number(e.target.value) || null);
                            } })));
                }
                return (React__default.createElement(BDNField, { objectKey: key, index: index },
                    React__default.createElement("input", { type: "text", value: values && values[key] ? values[key] : '', disabled: props.readOnly, onChange: function (e) {
                            onChangeValue(key, e.target.value);
                        } })));
            }))),
        !props.readOnly && (React__default.createElement(Button$1, { preventDoubleClick: true, primary: true, onClick: handleSubmit, disabled: !isDifferentFromInitial }, "Save nomination data"))));
};
var BDNField = function (props) {
    return (React__default.createElement("tr", { key: "nomination-overview-table-" + props.index },
        React__default.createElement("td", null, OVERVIEW_LABELS[props.objectKey] || props.objectKey),
        React__default.createElement("td", { className: "no-padding", style: props.tdStyle }, props.children)));
};

var CTMSTable = function (props) {
    var _a = useForm({
        initialValues: props.values,
        onValidSubmit: props.update,
        validate: function (data) {
            return hookValidateForm(data, props.configuration.ctmsDataFields, validateCTMSForm, undefined, props.setProblems);
        }
    }), handleSubmit = _a.handleSubmit, values = _a.values, onChangeValue = _a.onChangeValue, isDifferentFromInitial = _a.isDifferentFromInitial, errors = _a.errors;
    var problem = __assign(__assign({}, errors), props.problems);
    return (React__default.createElement("div", { className: "bdn-step" },
        React__default.createElement("table", null,
            !props.hideTableHeaders && (React__default.createElement("thead", { className: "" },
                React__default.createElement("tr", null,
                    React__default.createElement("td", { colSpan: 3 }, "Measurement Data from CTMS Reports")))),
            React__default.createElement("tbody", null, Object.entries(props.configuration.ctmsDataFields).map(function (_a, index) {
                var key = _a[0], value = _a[1];
                var _b, _c, _d;
                if (!value) {
                    return null;
                }
                return (React__default.createElement("tr", { key: "bdn-ctms-table-" + index },
                    React__default.createElement("td", null, CTMS_LABELS[key] || key),
                    React__default.createElement("td", { className: "no-padding ebdn-input" },
                        React__default.createElement("input", { className: (problem === null || problem === void 0 ? void 0 : problem[key]) ? "input-validation input-" + ((_b = problem === null || problem === void 0 ? void 0 : problem[key]) === null || _b === void 0 ? void 0 : _b.problemType.toLocaleLowerCase())
                                : "", type: "number", value: parseBDNNumberValue(values === null || values === void 0 ? void 0 : values[key], ''), step: "0.01", disabled: props.readOnly, onChange: function (e) {
                                onChangeValue(key, e.target.value);
                            } }),
                        React__default.createElement(InputProblemMessage, { message: (_c = problem === null || problem === void 0 ? void 0 : problem[key]) === null || _c === void 0 ? void 0 : _c.message, type: (_d = problem === null || problem === void 0 ? void 0 : problem[key]) === null || _d === void 0 ? void 0 : _d.problemType })),
                    React__default.createElement("td", null, getCTMSCompountUnit(key))));
            }))),
        !props.readOnly && (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(Button, { preventDoubleClick: true, disabled: !isDifferentFromInitial, onClick: function () {
                    handleSubmit();
                }, primary: true }, "Save CTMS measurements")))));
};

function formatFixedNumber(value, digits) {
    var num = typeof value === 'string' ? Number(value) : value;
    return num.toFixed(digits);
}

var CustomNumberInput = function (_a) {
    var onChangeFormValue = _a.onChangeFormValue, value = _a.value, digits = _a.digits, props = __rest(_a, ["onChangeFormValue", "value", "digits"]);
    var _b = useState(formatValue(value)), activeValue = _b[0], setActiveValue = _b[1];
    var _c = useState(false), focus = _c[0], setFocus = _c[1];
    useEffect(function () {
        if (!focus) {
            setActiveValue(formatValue(value));
        }
    }, [value, focus, setActiveValue]);
    function formatValue(value) {
        return value != null && String(value).trim().length !== 0
            ? formatFixedNumber(String(value), digits)
            : '';
    }
    function onFocus() {
        setFocus(true);
    }
    function onBlur() {
        setFocus(false);
        if (!isValidNumberOrBlank(activeValue)) {
            // revert to the latest valid value
            setActiveValue(formatValue(value));
        }
    }
    function onChange(event) {
        var newActiveValue = event.target.value;
        setActiveValue(newActiveValue);
        if (isValidNumberOrBlank(newActiveValue)) {
            var parsedValue = parseValue(newActiveValue);
            onChangeFormValue(props.name || '', parsedValue);
        }
    }
    var className = classNames(props.className, {
        error: !isValidNumberOrBlank(activeValue)
    });
    return (React__default.createElement("input", __assign({ type: "tel" // we use tel, this makes sure the input behaves like a type of text, but shows a numeric keyboard on mobile devices.
     }, props, { className: className, value: activeValue ? activeValue : '', onFocus: onFocus, onBlur: onBlur, onChange: onChange })));
};
function parseValue(value) {
    if (value == null) {
        return null;
    }
    if (typeof value === 'number') {
        return value;
    }
    return isValidNumber(String(value)) ? Number(value) : null;
}
function isValidNumberOrBlank(value) {
    return value === null || String(value).trim() === '' || isValidNumber(value);
}
function isValidNumber(value) {
    return value != null && !isNaN(Number(value)) && !isNaN(parseFloat(value));
}

var AltFuelCalculationDialog = function (props) {
    var _a = useState(), altFuelMassValue = _a[0], setAltFuelMassValue = _a[1];
    var _b = useState(), altFuelPercentage = _b[0], setAltFuelPercentage = _b[1];
    var bdnHasMass = props.mass !== undefined && props.mass !== '';
    return (React__default.createElement(Dialog, { onCloseDialog: function () {
            props.setCalculateAltFuelPopupActive(false);
        }, type: "small", showDialog: true, title: "Calculate LBG Percentage" },
        React__default.createElement("div", { className: "alt-fuel-calculation-dialog" },
            altFuelPercentage && (React__default.createElement("div", { className: "calculation-info-box" },
                React__default.createElement("div", null,
                    React__default.createElement("h3", null, "LBG percentage"),
                    React__default.createElement("div", { className: "calculation-info-value" },
                        altFuelPercentage,
                        " %")),
                React__default.createElement(Button, { primary: true, onClick: function () {
                        props.setPercentageInBDN(altFuelPercentage);
                    } }, "Add to BDN"))),
            !altFuelPercentage && (React__default.createElement("div", null,
                React__default.createElement("div", { className: "calculation-info-box" }, bdnHasMass ? (React__default.createElement("div", null,
                    React__default.createElement("h3", null, "Total mass"),
                    React__default.createElement("div", null,
                        props.mass,
                        " MT"))) : (React__default.createElement("div", null,
                    React__default.createElement("h3", null, "Unable to calculate"),
                    React__default.createElement("div", null, "Please add mass to the bdn first.")))),
                bdnHasMass && (React__default.createElement(FormElement, { className: "alt-calculation-form" },
                    React__default.createElement(FormLabel, null, "LBG mass ( MT )"),
                    React__default.createElement(FormFieldButtonWrapper, null,
                        React__default.createElement(NumberInput, { onChangeFormValue: function (field, value) {
                                var numberInput = value;
                                setAltFuelMassValue(numberInput);
                            }, value: altFuelMassValue || '', maxDecimals: 3 }),
                        React__default.createElement(Button, { primary: true, onClick: calculateAlternativeFuelPercentage }, "Calculate percentage")))))))));
    function calculateAlternativeFuelPercentage() {
        if (props.mass !== undefined && altFuelMassValue !== undefined) {
            var percentage = ((altFuelMassValue / toNumber(props.mass)) * 100).toFixed(3);
            setAltFuelPercentage(toNumber(percentage));
        }
    }
};

// source: https://codesandbox.io/s/qxkr4mplv6
function useLocalStorage(key, initialValue) {
    // State to store our value
    // Pass initial state function to useState so logic is only executed once
    var _a = useState(function () {
        try {
            // Get from local storage by key
            var item = window.localStorage.getItem(key);
            // Parse stored json or if none return initialValue
            return item ? JSON.parse(item) : initialValue;
        }
        catch (error) {
            // If error also return initialValue
            console.error(error);
            return initialValue;
        }
    }), storedValue = _a[0], setStoredValue = _a[1];
    // Return a wrapped version of useState's setter function that ...
    // ... persists the new value to localStorage.
    var setValue = function (value) {
        try {
            // Allow value to be a function so we have same API as useState
            var valueToStore = value instanceof Function ? value(storedValue) : value;
            // Save state
            setStoredValue(valueToStore);
            // Save to local storage
            window.localStorage.setItem(key, JSON.stringify(valueToStore));
        }
        catch (error) {
            // A more advanced implementation would handle the error case
            console.error(error);
        }
    };
    return [storedValue, setValue];
}

var CalculationUnit;
(function (CalculationUnit) {
    CalculationUnit["VOLUME"] = "VOLUME";
    CalculationUnit["MASS"] = "MASS";
})(CalculationUnit || (CalculationUnit = {}));
var QuantityCalculationForm = function (props) {
    var _a = useState(), calculationError = _a[0], setCalculationError = _a[1];
    var _b = useLocalStorage('QuantityCalculationForm.calculationUnit', CalculationUnit.VOLUME), calculationUnit = _b[0], setCalculationUnit = _b[1];
    var _c = useForm({
        initialValues: undefined,
        onValidSubmit: initiateQuantityCalculation,
        validate: validateQuantityInput
    }), handleSubmit = _c.handleSubmit, values = _c.values, onChangeValue = _c.onChangeValue, isDifferentFromInitial = _c.isDifferentFromInitial, errors = _c.errors;
    return (React__default.createElement("div", { className: "quantity-calculation-form" },
        React__default.createElement(React__default.Fragment, null,
            React__default.createElement("h4", null, "Calculate quantity delivered"),
            React__default.createElement("p", null, "Please provided us with the following information so we can complete the quantity calculations for you."),
            React__default.createElement(FormWrapper, null,
                React__default.createElement(FormElement, null,
                    React__default.createElement(FormLabel, null, "Calculation unit"),
                    React__default.createElement(Button, { preventDoubleClick: true, switchButton: true, className: "negotiation-toggle-button" },
                        React__default.createElement("span", { onClick: function () {
                                setCalculationUnit(CalculationUnit.VOLUME);
                                onChangeValue('mass', undefined);
                            }, className: calculationUnit === CalculationUnit.VOLUME ? 'active' : '' }, "Volume"),
                        React__default.createElement("span", { onClick: function () {
                                setCalculationUnit(CalculationUnit.MASS);
                                onChangeValue('volume', undefined);
                            }, className: calculationUnit === CalculationUnit.MASS ? 'active' : '' }, "Mass"))),
                calculationUnit === CalculationUnit.MASS ? (React__default.createElement(FormElement, null,
                    React__default.createElement(FormLabel, null, "Mass ( Metric Tons )"),
                    React__default.createElement(NumberInput, { onChangeFormValue: onChangeValue, value: (values === null || values === void 0 ? void 0 : values.mass) || '', name: 'mass', maxDecimals: 3 }),
                    React__default.createElement(FormErrorMessage, { errorMessage: errors === null || errors === void 0 ? void 0 : errors.mass }))) : (React__default.createElement(FormElement, null,
                    React__default.createElement(FormLabel, null,
                        "Volume ( m",
                        React__default.createElement("sup", null, "3"),
                        " )"),
                    React__default.createElement(NumberInput, { onChangeFormValue: onChangeValue, value: (values === null || values === void 0 ? void 0 : values.volume) || '', name: 'volume', maxDecimals: 3 }),
                    React__default.createElement(FormErrorMessage, { errorMessage: errors === null || errors === void 0 ? void 0 : errors.volume }))),
                React__default.createElement(FormElement, null,
                    React__default.createElement(FormLabel, null, "Gas consumed ( kg )"),
                    React__default.createElement(NumberInput, { onChangeFormValue: onChangeValue, value: (values === null || values === void 0 ? void 0 : values.gasConsumed) || '', name: 'gasConsumed', maxDecimals: 3 }),
                    React__default.createElement(FormErrorMessage, { errorMessage: errors === null || errors === void 0 ? void 0 : errors.gasConsumed })),
                React__default.createElement(FormElement, null,
                    React__default.createElement(FormLabel, null, "Vapor displaced"),
                    React__default.createElement(ToggleBox, { toggled: (values === null || values === void 0 ? void 0 : values.includeVaporDisplaced) || false, onClick: function () {
                            onChangeValue('includeVaporDisplaced', !(values === null || values === void 0 ? void 0 : values.includeVaporDisplaced));
                        } }, function (toggled) {
                        return (React__default.createElement("div", { className: "sof-toggle-content" },
                            React__default.createElement(FontAwesomeIcon, { icon: toggled ? faCheck : faMinus }),
                            React__default.createElement("span", { className: "toggle-title" }, "Include vapor displaced"),
                            React__default.createElement("p", null, "By turning this option on, the calculation will take the vapor displaced into account.")));
                    })),
                calculationError && (React__default.createElement(NotificationMessage, { type: 'ERROR', className: "quantity-calculation-error" }, calculationError)),
                React__default.createElement(ButtonGroup, null,
                    React__default.createElement(Button, { primary: true, disabled: !isDifferentFromInitial && !calculationError, onClick: handleSubmit }, "Calculate"),
                    React__default.createElement(Button, { onClick: props.closeDialog }, "Cancel"))))));
    function initiateQuantityCalculation(quantityInput) {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, props.calculateLNGQuantity(quantityInput)];
                    case 1:
                        _a.sent();
                        props.closeDialog();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        setCalculationError(error_1.message);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    function validateQuantityInput(quantityInput) {
        var errors = {};
        if (calculationUnit === CalculationUnit.MASS) {
            if (quantityInput.mass === undefined) {
                errors.mass = 'This field is required';
            }
        }
        else {
            if (quantityInput.volume === undefined) {
                errors.volume = 'This field is required';
            }
        }
        if (quantityInput.gasConsumed === undefined) {
            errors.gasConsumed = 'This field is required';
        }
        return errors;
    }
};

var NON_QUANTITY = function (key) {
    return key === 'mass' || key === 'volume' || key === 'altFuelPercentage';
};
var QuantityDeliveredTable = function (props) {
    var _a = useState(false), show = _a[0], setShow = _a[1];
    var _b = useForm({
        initialValues: props.values,
        onValidSubmit: props.update
    }), handleSubmit = _b.handleSubmit, values = _b.values, onChangeValue = _b.onChangeValue, isDifferentFromInitial = _b.isDifferentFromInitial;
    var _c = useState(false), calculateAltFuelPopupActive = _c[0], setCalculateAltFuelPopupActive = _c[1];
    function autoPopulate(data) {
        new Set(__spreadArrays(Object.keys(data.quantity || {}), Object.keys(values || {}))).forEach(function (key) {
            onChangeValue(key, data.quantity[key] || null);
        });
    }
    return (React__default.createElement("div", { className: "bdn-step" },
        React__default.createElement(FillFromPredefined, { callback: autoPopulate, data: props.integrationData, displayRule: [
                { key: 'description', fallback: props.assetName },
                { key: 'created', render: formatDateTime }
            ], fieldname: 'QuantityDeliveredTable', message: "Predefined LNG mass" }),
        !props.readOnly && props.showCalculationOption && !show && (React__default.createElement(CalculateBDNStep, { type: 'QUANTITY', calculate: function () { return setShow(true); } })),
        show && (React__default.createElement(QuantityCalculationForm, { calculateLNGQuantity: props.calculateLNGQuantity, closeDialog: function () { return setShow(false); } })),
        calculateAltFuelPopupActive && (React__default.createElement(AltFuelCalculationDialog, { setCalculateAltFuelPopupActive: setCalculateAltFuelPopupActive, mass: values === null || values === void 0 ? void 0 : values.mass, setPercentageInBDN: function (percentage) {
                onChangeValue('altFuelPercentage', percentage);
                setCalculateAltFuelPopupActive(false);
            } })),
        props.integrationData && React__default.createElement(SelectingPredefinedWarning, null),
        React__default.createElement("div", { className: "bdn-energy-unit-selection" },
            React__default.createElement("h5", null, "Energy Unit"),
            React__default.createElement(Button$1, { preventDoubleClick: true, switchButton: true, disabled: props.readOnly, className: "negotiation-toggle-button" },
                React__default.createElement("span", { onClick: function () {
                        if (!props.readOnly) {
                            onChangeValue('energyUnit', EnergyUnit.MWH);
                        }
                    }, className: (values === null || values === void 0 ? void 0 : values.energyUnit) === EnergyUnit.MWH ? 'active' : '' }, "MWh"),
                React__default.createElement("span", { onClick: function () {
                        if (!props.readOnly) {
                            onChangeValue('energyUnit', EnergyUnit.THERM);
                        }
                    }, className: (values === null || values === void 0 ? void 0 : values.energyUnit) === EnergyUnit.THERM ? 'active' : '' }, "Therm"),
                React__default.createElement("span", { onClick: function () {
                        if (!props.readOnly) {
                            onChangeValue('energyUnit', EnergyUnit.MMBTU);
                        }
                    }, className: (values === null || values === void 0 ? void 0 : values.energyUnit) === EnergyUnit.MMBTU ? 'active' : '' }, "MMBtu"),
                React__default.createElement("span", { onClick: function () {
                        if (!props.readOnly) {
                            onChangeValue('energyUnit', EnergyUnit.MJ);
                        }
                    }, className: (values === null || values === void 0 ? void 0 : values.energyUnit) === EnergyUnit.MJ ? 'active' : '' }, "MJ"))),
        React__default.createElement("table", null,
            !props.hideTableHeaders && (React__default.createElement("thead", { className: "" },
                React__default.createElement("tr", null,
                    React__default.createElement("td", { colSpan: 3 }, "Quantity Delivered")))),
            React__default.createElement("tbody", null, Object.entries(props.configuration.deliveredFields).map(function (_a, index) {
                var key = _a[0], value = _a[1];
                if (!value) {
                    return null;
                }
                // Filter out various altfuel/lngfuel related fields which are present on the backend model, but not filled in by the user.
                if ((DELIVERED_FIELDS_GROUPING.altFuel.includes(key) ||
                    DELIVERED_FIELDS_GROUPING.lng.includes(key)) &&
                    key !== 'altFuelPercentage') {
                    return null;
                }
                // filter out the altFuelPercentage -> we always show this, regardless of configuration -> see <tr></tr> above.
                if (key === 'altFuelPercentage') {
                    return null;
                }
                return (React__default.createElement(Fragment, { key: "bdn-deliverd-table-" + key + "-" + index },
                    React__default.createElement("tr", null,
                        React__default.createElement("td", null, DELIVERED_LABELS[key] || key),
                        React__default.createElement("td", { className: "no-padding" },
                            React__default.createElement(CustomNumberInput, { value: NON_QUANTITY(key) ? values === null || values === void 0 ? void 0 : values[key] : convertQuantityValue(values === null || values === void 0 ? void 0 : values[key]), name: DELIVERED_LABELS[key] || key, step: "0.001", digits: 3, disabled: props.readOnly, onChangeFormValue: function (field, val) {
                                    if (NON_QUANTITY(key)) {
                                        onChangeValue(key, val);
                                    }
                                    else {
                                        convertFormNumberValue(val, key);
                                    }
                                } })),
                        React__default.createElement("td", null, key === 'volume'
                            ? 'Cubic Meters'
                            : key === 'mass'
                                ? 'Metric Tons'
                                : key === 'altFuelPercentage'
                                    ? '%'
                                    : showEnergyUnitLabel(values === null || values === void 0 ? void 0 : values.energyUnit))),
                    key === 'mass' && (React__default.createElement("tr", { key: "bdn-deliverd-table-" + 'altFuelPercentage' + "-field" },
                        React__default.createElement("td", null, DELIVERED_LABELS['altFuelPercentage']),
                        React__default.createElement("td", { className: "no-padding" },
                            React__default.createElement(CustomNumberInput, { value: values === null || values === void 0 ? void 0 : values['altFuelPercentage'], step: "0.001", digits: 3, disabled: props.readOnly, onChangeFormValue: function (field, value) {
                                    onChangeValue('altFuelPercentage', value);
                                } })),
                        React__default.createElement("td", { className: "button-td" },
                            "%",
                            ' ',
                            React__default.createElement(Button$1, { primary: true, onClick: function () {
                                    setCalculateAltFuelPopupActive(true);
                                } }, "Calculate percentage"))))));
            }))),
        !props.readOnly && (React__default.createElement(Button$1, { preventDoubleClick: true, primary: true, onClick: handleSubmit, disabled: !isDifferentFromInitial }, "Save LNG quantity"))));
    function convertFormNumberValue(value, fieldName) {
        if (value === null) {
            onChangeValue(fieldName, null);
            return;
        }
        var parsedInput = parseFloat(value.toString());
        var valueToConvert = convertSelectedEnergyUnitToMWh(parsedInput, (values === null || values === void 0 ? void 0 : values.energyUnit) || EnergyUnit.MWH);
        onChangeValue(fieldName, valueToConvert !== undefined ? valueToConvert.toString() : valueToConvert);
    }
    function convertQuantityValue(value) {
        var parsedInput = parseFloat(typeof value === 'string' ? value : String(value));
        if (isNaN(parsedInput)) {
            return null;
        }
        else {
            return convertMWhToSelectedEnergyUnit(typeof value === 'string' ? parseFloat(value) : value, (values === null || values === void 0 ? void 0 : values.energyUnit) || EnergyUnit.MWH);
        }
    }
    function convertMWhToSelectedEnergyUnit(mwh, selectedUnit) {
        switch (selectedUnit) {
            case EnergyUnit.MMBTU:
                return mwh / MMBTU_FACTOR;
            case EnergyUnit.THERM:
                return mwh / THERM_FACTOR;
            case EnergyUnit.MJ:
                return mwh * MJ_FACTOR;
            case EnergyUnit.MWH:
                return mwh;
        }
    }
    function convertSelectedEnergyUnitToMWh(amount, selectedUnit) {
        switch (selectedUnit) {
            case EnergyUnit.MMBTU:
                return amount * MMBTU_FACTOR;
            case EnergyUnit.THERM:
                return amount * THERM_FACTOR;
            case EnergyUnit.MJ:
                return amount / MJ_FACTOR;
            case EnergyUnit.MWH:
                return amount;
        }
    }
    function showEnergyUnitLabel(selectedUnit) {
        switch (selectedUnit) {
            case EnergyUnit.MMBTU:
                return 'MMBtu';
            case EnergyUnit.THERM:
                return 'Therm';
            case EnergyUnit.MWH:
                return 'MWh';
            case EnergyUnit.MJ:
                return 'MJ';
            default:
                return '';
        }
    }
};

var DocumentBlockHorizontal = function (props) {
    var document = props.document;
    var _a = useState(false), showSigningProcess = _a[0], setShowSigningProcess = _a[1];
    var _b = useState(5), refreshCounter = _b[0], setRefreshCounter = _b[1];
    var userPermissions = useContext(UserPermissionContext).userPermissions;
    var _c = useSignRequestUrlService(document, props.userProfile, props.authenticationService), signRequestURL = _c.signRequestURL, loading = _c.loading, error = _c.error, alreadySignedByCurrentUser = _c.alreadySignedByCurrentUser, canCurrentUserSign = _c.canCurrentUserSign, signerStatus = _c.signerStatus;
    /** ToDO: Fix this dirty refresh mechanism with a hook */
    useEffect(function () {
        var timeout;
        if (signerStatus === 'PROCESSING' || signerStatus === 'AWAITING_CALLBACK') {
            // refresh for status
            if (refreshCounter > 0) {
                timeout = setTimeout(function () {
                    setRefreshCounter(refreshCounter - 1);
                    props.refetchDocument();
                }, 5000);
            }
        }
        return function () { return timeout && clearTimeout(timeout); };
    }, [signerStatus, refreshCounter]);
    var readableDocumentType = getReadableDocumentType(document.type);
    var ItemPromptNomination = props.itemWithDocuments;
    var userIsOperatorOrScheduler = props.userProfile &&
        (isOperator(props.userProfile.roles) || isScheduler(props.userProfile.roles))
        ? true
        : false;
    var singableDocument = SIGNED_DOCUMENT_TYPES.includes(document.type) &&
        ItemPromptNomination.eventId &&
        document.signingStatus === 'UNSIGNED';
    var userCanInitateSigning = (document.type === 'EBDN' &&
        doesUserHavePermission(userPermissions, 'EBDN_INITIATE_SIGNING')) ||
        (document.type.startsWith('SAFETY_CHECKLIST_') &&
            doesUserHavePermission(userPermissions, 'IAPH_INITIATE_SIGNING')) ||
        (document.type === 'STATEMENT_OF_FACTS' &&
            doesUserHavePermission(userPermissions, 'SOF_INITIATE_SIGNING')) ||
        (['NOR_BUNKERSHIP', 'NOR_RECEIVINGSHIP'].includes(document.type) &&
            doesUserHavePermission(userPermissions, 'NOR_INITIATE_SIGNING')) ||
        (document.type === 'MASTERS_REQUISITION_FORM' &&
            doesUserHavePermission(userPermissions, 'MRF_INITIATE_SIGNING'));
    var allowInitiateSigningOperatorOrScheduler = singableDocument && userCanInitateSigning && !props.readOnly && userIsOperatorOrScheduler;
    var allowInitiateSigningOther = ['MASTERS_REQUISITION_FORM', 'NOR_RECEIVINGSHIP', 'NOR_BUNKERSHIP'].includes(document.type) &&
        singableDocument &&
        userCanInitateSigning &&
        !props.readOnly;
    var allowInitiateSigning = allowInitiateSigningOperatorOrScheduler || allowInitiateSigningOther;
    var documentStatusProblem = signerStatus === 'CANCELLED' || signerStatus === 'DECLINED' || signerStatus === 'ERROR';
    return (React__default.createElement("div", null,
        React__default.createElement("div", { className: "document-wrapper " + (props.className || '') + " " + (props.showLatestNotification ? 'highlight' : '') },
            React__default.createElement("div", { className: "status" },
                props.showLatestNotification && (React__default.createElement("span", { className: "latest-version-notification" }, "Latest version")),
                React__default.createElement("span", { className: "sign-status  " + document.signingStatus }, getReadableSigningStatus(document.signingStatus))),
            React__default.createElement("div", { className: "pdf-body" },
                React__default.createElement("div", { className: "information" },
                    React__default.createElement("h3", { className: "title" },
                        React__default.createElement(Icon, null,
                            React__default.createElement(FontAwesomeIcon, { icon: faFilePdf })),
                        props.document.filename ? props.document.filename : 'Unknown Filename'),
                    React__default.createElement("div", null,
                        React__default.createElement("span", { className: "upload-date" }, formatDateTime(document.uploadDate)),
                        ",",
                        React__default.createElement("span", { className: "document-type" }, readableDocumentType),
                        ",",
                        React__default.createElement("span", { className: "document-creator" }, props.getUserNameFromFile(document.userId)))),
                React__default.createElement("div", { className: "actions" },
                    React__default.createElement(Button$1, { className: "view", onClick: startEditingDocument, hidden: props.readOnly }, "View"),
                    React__default.createElement(Button$1, { className: "download", onClick: function () {
                            return props.downloadFile(props.authenticationService, props.document, props.itemWithDocuments['eventId'] || props.itemWithDocuments._id || undefined);
                        } }, "Download"),
                    renderInitiateSigningButton(),
                    canCurrentUserSign && renderSignRequestButton()))),
        error && React__default.createElement("div", { className: "error" },
            "Fetch error: ",
            error),
        documentStatusProblem && (React__default.createElement("div", { className: "error" },
            "Document status is ",
            documentStatusProblem)),
        showSigningProcess && allowInitiateSigning && (React__default.createElement("div", { className: "inner-content" },
            React__default.createElement(DocumentSigning$1, { itemWithDocuments: ItemPromptNomination, document: document, eventId: ItemPromptNomination.eventId, userProfile: props.userProfile, readOnly: false, authenticationService: props.authenticationService, onlyShowInitiate: true, fetchItem: props.refetchDocument, scrollInFocusTimeout: props.scrollInFocusTimeout })))));
    function renderInitiateSigningButton() {
        if (allowInitiateSigning) {
            return (React__default.createElement(Button$1, { secondary: true, className: "state-assign-signers", onClick: function () { return setShowSigningProcess(!showSigningProcess); } }, "Assign signers"));
        }
    }
    function renderSignRequestButton() {
        if (signerStatus === 'PROCESSING' || signerStatus === 'AWAITING_CALLBACK') {
            return (React__default.createElement(Button$1, { className: "state-processing" }, refreshCounter > 0 ? (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(FontAwesomeIcon, { icon: faSpinner, pulse: true }),
                "Processing")) : ('Signed')));
        }
        if (loading) {
            return (React__default.createElement(Button$1, { className: "state-loading" },
                React__default.createElement(FontAwesomeIcon, { icon: faSpinner, pulse: true })));
        }
        if (error || documentStatusProblem) {
            return (React__default.createElement(Button$1, { className: "state-error" },
                React__default.createElement(FontAwesomeIcon, { icon: faExclamationCircle })));
        }
        if (signRequestURL) {
            if (!alreadySignedByCurrentUser) {
                return (React__default.createElement(Button$1, { secondary: true, className: "state-sign", onClick: function () { return window.location.replace(signRequestURL); } }, "Sign"));
            }
            else {
                return (React__default.createElement(Button$1, { success: true, className: "state-signed" }, "Signed"));
            }
        }
    }
    function startEditingDocument() {
        props.editDocumentDetails({
            active: true,
            document: document
        });
    }
};

var CollapsibleDocumentViewer = function (props) {
    var _a = useState(false), showCollapseFiles = _a[0], setShowCollapseFiles = _a[1];
    var _b = useState({
        active: false,
        document: undefined
    }), documentDetailsActive = _b[0], setDocumentDetailsActive = _b[1];
    useEffect(function () {
        if (documentDetailsActive.active === true) {
            var activeDocument_1 = documentDetailsActive.document;
            var updatedDocuments = props.eventWithDocuments.documents;
            if (updatedDocuments && activeDocument_1) {
                var foundDocument = updatedDocuments.find(function (x) { return x._id === activeDocument_1._id; });
                if (foundDocument) {
                    setDocumentDetailsActive({
                        active: true,
                        document: foundDocument
                    });
                }
                else {
                    setDocumentDetailsActive({
                        active: false,
                        document: undefined
                    });
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.eventWithDocuments]);
    //sorting the documents to set the newest first.
    var documents = __spreadArrays(props.documents).reverse();
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("div", { className: "stacked-document-viewer-wrapper " + (props.withWrapper ? 'bg-wrapper' : '') },
            documents.length > 0 && (React__default.createElement(DocumentBlockHorizontal, { key: 'documentblock-first-0', document: documents.shift(), showLatestNotification: true, getUserNameFromFile: props.getUserNameFromFile, editDocumentDetails: setDocumentDetailsActive, downloadFile: downloadFile, userProfile: props.userProfile, authenticationService: props.authenticationService, itemWithDocuments: props.eventWithDocuments, refetchDocument: props.refetchEvent, scrollInFocusTimeout: props.scrollInFocusTimeout, readOnly: props.readOnly })),
            documents.length > 0 && (React__default.createElement("div", { className: "document-collapse", onClick: function () { return setShowCollapseFiles(!showCollapseFiles); } },
                React__default.createElement(Icon, null,
                    React__default.createElement(FontAwesomeIcon, { icon: showCollapseFiles ? faAngleDown : faAngleRight })), (showCollapseFiles ? 'Hide' : 'Show') + " older files")),
            showCollapseFiles &&
                documents.map(function (document, index) {
                    return (React__default.createElement(DocumentBlockHorizontal, { key: 'documentblock' + index, document: document, showLatestNotification: false, getUserNameFromFile: props.getUserNameFromFile, editDocumentDetails: setDocumentDetailsActive, downloadFile: downloadFile, userProfile: props.userProfile, authenticationService: props.authenticationService, itemWithDocuments: props.eventWithDocuments, refetchDocument: props.refetchEvent, scrollInFocusTimeout: props.scrollInFocusTimeout, readOnly: props.readOnly }));
                })),
        documentDetailsActive.document && (React__default.createElement(Dialog, { type: "medium", title: getReadableDocumentType(documentDetailsActive.document.type), titleIcon: React__default.createElement(Icon, null,
                React__default.createElement(FontAwesomeIcon, { icon: faFile })), showDialog: documentDetailsActive.active && documentDetailsActive.document ? true : false, onCloseDialog: function () {
                setDocumentDetailsActive({ active: false, document: undefined });
            } },
            React__default.createElement(DocumentDetails, { authenticationService: props.authenticationService, readOnly: props.readOnly, document: documentDetailsActive.document, editDocument: props.editDocument, deleteDocument: function (document) {
                    props.deleteDocument(document);
                    setDocumentDetailsActive({ active: false, document: undefined });
                }, userProfile: props.userProfile, downloadFile: downloadFile, itemWithDocuments: props.eventWithDocuments, refetchEvent: props.refetchEvent, getUserNameFromFile: props.getUserNameFromFile })))));
};

var PDFDocumentHandler = function (props) {
    var _a = useState([]), userProfiles = _a[0], setUserProfiles = _a[1];
    var userPermissions = useContext(UserPermissionContext).userPermissions;
    useEffect(function () {
        getAllUserProfiles();
    }, []);
    var documents = props.eventWithDocuments.documents
        ? props.allowedDocumentTypes === 'ALL'
            ? props.eventWithDocuments.documents
            : props.eventWithDocuments.documents.filter(function (document) {
                return props.allowedDocumentTypes.includes(document.type);
            })
        : [];
    return (React__default.createElement("div", { className: props.className || '' }, documents.length > 0 ? (doesUserHavePermission(userPermissions, 'DOCUMENT_VIEW') ? (React__default.createElement(CollapsibleDocumentViewer, { authenticationService: props.authenticationService, documents: documents, getUserNameFromFile: getUserNameFromFile, editDocument: editDocumentValues, deleteDocument: deleteDocumentFromEvent, userProfile: props.userProfile, eventWithDocuments: props.eventWithDocuments, refetchEvent: props.refetchEvent, withWrapper: props.withWrapper, readOnly: props.readOnly, scrollInFocusTimeout: props.scrollInFocusTimeout })) : (React__default.createElement("div", { className: "document-message no-permission" }, "You do not have permission to view files"))) : (React__default.createElement("div", { className: "document-message no-pdf-yet" }, props.noDocumentMessage ? props.noDocumentMessage : 'No PDF created yet'))));
    function editDocumentValues(updatedFile) {
        editDocument(updatedFile, props.authenticationService, props.refetchEvent);
    }
    function deleteDocumentFromEvent(file) {
        return __awaiter(this, void 0, void 0, function () {
            var isNomination, removeDocumentFromNomination;
            return __generator(this, function (_a) {
                if (!file._id)
                    return [2 /*return*/];
                isNomination = !!props.eventWithDocuments['eventId'];
                removeDocumentFromNomination = function () {
                    return removeDocuments(props.authenticationService, props.eventWithDocuments['eventId'], [
                        file._id
                    ]);
                };
                deleteDocument(file, props.eventWithDocuments, props.refetchEvent, isNomination ? removeDocumentFromNomination : props.updateItem, props.userProfile);
                return [2 /*return*/];
            });
        });
    }
    function getAllUserProfiles() {
        return __awaiter(this, void 0, void 0, function () {
            var usersList, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, getAllProfiles(props.authenticationService)];
                    case 1:
                        usersList = _a.sent();
                        setUserProfiles(usersList);
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        handleFetchError(err_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    function getUserNameFromFile(userId) {
        if (userProfiles) {
            var matchingUser = userProfiles.find(function (user) { return user._id === userId; });
            if (matchingUser) {
                return matchingUser.name;
            }
        }
        return '';
    }
};

var DocumentStatusBlock = function (props) {
    var status = props.statusArray || [];
    var renderGenereatePDFButton = function () {
        if (!props.canGeneratePDF)
            return null;
        return (React__default.createElement("button", { className: "generate-button", onClick: props.generatePDF, disabled: props.isDifferentFromInitial || props.readOnly },
            React__default.createElement(Icon, null,
                React__default.createElement(FontAwesomeIcon, { icon: faFilePdf }),
                "Create PDF")));
    };
    return (React__default.createElement("div", { className: "safety-checklist-status-block" },
        React__default.createElement("div", { className: "block-header" },
            React__default.createElement("h3", { className: "title" }, props.title),
            React__default.createElement(StatusList, { statusArray: status }),
            React__default.createElement("div", { className: "actions" }, renderGenereatePDFButton())),
        props.children));
};
var StatusList = function (props) {
    if (!props.statusArray || props.statusArray.length < 1)
        return null;
    return (React__default.createElement("div", { className: "block-status-wrapper" }, props.statusArray.map(function (status) { return (React__default.createElement("div", { className: "status-wrapper" },
        React__default.createElement("span", { className: "status-name" }, status.user),
        React__default.createElement(StatusTag, { status: status.status }))); })));
};
var StatusTag = function (props) {
    return React__default.createElement("span", { className: "status " + props.status }, renderStatusText(props.status));
};

var BDNSigning = function (props) {
    var userPermissions = useContext(UserPermissionContext).userPermissions;
    return (React__default.createElement("div", { className: "bdn-step" },
        React__default.createElement("p", null, "After filling in all the BDN Values you can create a BDN Document. This document can then be signed."),
        React__default.createElement(DocumentStatusBlock, { title: undefined, isDifferentFromInitial: false, readOnly: false, statusArray: undefined, generatePDF: props.createSignableBDN, canGeneratePDF: doesUserHavePermission(userPermissions, 'EBDN_INITIATE_SIGNING') },
            React__default.createElement(PDFDocumentHandler, { authenticationService: props.authenticationService, eventWithDocuments: props.nomination, userProfile: props.userProfile, allowedDocumentTypes: ['EBDN'], readOnly: false, refetchEvent: props.refetchEvent, updateItem: function (updatedNomination) { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, props.updateNomination(updatedNomination)];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                }); }, scrollInFocusTimeout: props.scrollInFocusTimeout }))));
};

function getLNGSpecification(authenticationService, type, deliverAssetId, limit, offset) {
    if (!type || !deliverAssetId)
        return Promise.resolve([]);
    var options = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    };
    var params = stringifyParams({ limit: limit, offset: offset });
    return authenticationService.fetchApiCall("/bunkerdeliverydata/" + resolveDeliveryModeToAPI(type) + "/" + deliverAssetId + "/composition" + (params ? '?' + params : ''), options);
}
function getAllLNGSpecification(authenticationService, type, limit, offset) {
    if (!type)
        return Promise.resolve([]);
    var options = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    };
    var params = stringifyParams({ limit: limit, offset: offset });
    return authenticationService.fetchApiCall("/bunkerdeliverydata/" + resolveDeliveryModeToAPI(type) + "s/compositions" + (params ? '?' + params : ''), options);
}
function getQuantity(authenticationService, type, deliverAssetId, limit, offset) {
    if (!type || !deliverAssetId)
        return Promise.resolve([]);
    var options = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    };
    var params = stringifyParams({ limit: limit, offset: offset });
    return authenticationService.fetchApiCall("/bunkerdeliverydata/" + resolveDeliveryModeToAPI(type) + "/" + deliverAssetId + "/quantity" + (params ? '?' + params : ''), options);
}
function getAllQuantity(authenticationService, type, limit, offset) {
    if (!type)
        return Promise.resolve([]);
    var options = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    };
    var params = stringifyParams({ limit: limit, offset: offset });
    return authenticationService.fetchApiCall("/bunkerdeliverydata/" + resolveDeliveryModeToAPI(type) + "s/quantities" + (params ? '?' + params : ''), options);
}
function postQuantity(authenticationService, type, id, data) {
    var options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    };
    return authenticationService.fetchApiCall("/bunkerdeliverydata/" + resolveDeliveryModeToAPI(type) + "/" + id + "/quantity", options);
}
function postLNGSpecification(authenticationService, type, id, data) {
    var options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    };
    return authenticationService.fetchApiCall("/bunkerdeliverydata/" + resolveDeliveryModeToAPI(type) + "/" + id + "/composition", options);
}
function resolveDeliveryModeToAPI(mode) {
    if (mode === 'PIPE' || mode === 'TRUCK')
        return 'pipeline';
    return 'bunkership';
}

var Collapse = function (_a) {
    var isOpen = _a.isOpen, children = _a.children, className = _a.className, collapseHeaderContent = _a.collapseHeaderContent, props = __rest(_a, ["isOpen", "children", "className", "collapseHeaderContent"]);
    var _b = useState(isOpen ? isOpen : false), collapsed = _b[0], setCollapsed = _b[1];
    var _c = useMeasure(), ref = _c[0], height = _c[1].height;
    var toggleProps = useSpring({
        height: collapsed ? height + "px" : '0px',
        config: { duration: props.expandDuration || 300 }
    });
    useEffect(function () {
        if ((collapsed !== isOpen && isOpen === false) || isOpen) {
            setCollapsed(isOpen);
        }
    }, [isOpen]);
    return (React__default.createElement("div", __assign({}, props, { className: "collapse-element " + (className || '') + " " + (collapsed ? 'collapsed-element' : '') }),
        React__default.createElement("div", { className: "collapse-bar " + (collapsed ? 'collapsed' : ''), onClick: function () {
                setCollapsed(!collapsed);
            } },
            React__default.createElement("div", { className: "collapse-bar-content" }, collapseHeaderContent && collapseHeaderContent()),
            React__default.createElement("div", { className: "collapse-control-icon " + (collapsed ? 'collapsed-icon' : '') },
                React__default.createElement("i", { className: "icon-down-open" }))),
        React__default.createElement(animated.div, { className: "collapse-content " + (collapsed ? 'visible-content' : ''), style: toggleProps },
            React__default.createElement("div", { ref: ref }, children))));
};

var OnlineBDNFlow = function (props) {
    var _a, _b, _c, _d, _e;
    var _f = useState({}), problems = _f[0], setProblems = _f[1];
    var userPermissions = useContext(UserPermissionContext).userPermissions;
    var assetId = props.nomination.bunkerShipId ||
        props.nomination.pipelineId ||
        props.nomination.loadingTerminalId ||
        undefined;
    var _g = useBasicAPIDataService(function () { return getLNGSpecification(props.authenticationService, props.nomination.deliveryMode, assetId); }, []), lngSpecification = _g.data, refetchSpecification = _g.refresh;
    var _h = useBasicAPIDataService(function () { return getQuantity(props.authenticationService, props.nomination.deliveryMode, assetId); }, []), quantity = _h.data, refetchQuantity = _h.refresh;
    useEffect(function () {
        setProblems({});
    }, [props.currentBDN.configuration._id]);
    useEffect(function () {
        refetchQuantity();
        refetchSpecification();
    }, [props.nomination._id]);
    // if some of the ctms fields or the composition are disabled in the configuration, we hide the calculation option
    var hidePropertiesCalculation = props.calculationsEnabled === false ||
        props.currentBDN.configuration.showComposition === false ||
        Object.values(props.currentBDN.configuration.ctmsDataFields).some(function (value) { return value === false; });
    // if some of the quantity delviered fields are disabled in the configuration, we hide the calculation option
    var hideQuantityCalculation = props.calculationsEnabled === false ||
        props.currentBDN.configuration.propertiesFields.density === false ||
        props.currentBDN.configuration.propertiesFields.grossHeatingMass === false ||
        props.currentBDN.configuration.propertiesFields.netHeatingMass === false;
    function calculateLNGProperties() {
        var _a;
        var ebdnProblems = validateEBDN(props.currentBDN, hidePropertiesCalculation);
        setProblems(ebdnProblems);
        if (isValidNestedOBJ(ebdnProblems)) {
            return props.calculateLNGProperties();
        }
        (_a = document.getElementById("eBDN-step-" + findFirstErrorKey(ebdnProblems))) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
            behavior: 'smooth'
        });
        return Promise.resolve();
    }
    var bunkerAssetName = ((_a = props.nomination.attributes) === null || _a === void 0 ? void 0 : _a.bunkerShipName) || ((_b = props.nomination.attributes) === null || _b === void 0 ? void 0 : _b.pipelineName) || ((_c = props.nomination.attributes) === null || _c === void 0 ? void 0 : _c.loadingTerminalName) ||
        'unknown';
    return (React__default.createElement(React__default.Fragment, null,
        props.enabledBdnSteps.overViewFieldsEnabled && (React__default.createElement(Collapse, { id: "eBDN-step-details", isOpen: !props.bdnProgress.nominationDataCompleted, collapseHeaderContent: function () {
                return (React__default.createElement(BDNStepHeader, { status: generatePartStatus(props.bdnProgress.nominationDataCompleted), stepNumber: 1, stepTitle: "eBDN Details & Overview", stepInactive: false, problems: problems.details }));
            } },
            React__default.createElement(BDNNominationSummary, { update: props.updateBDNDetailsData, readOnly: props.readOnly, values: (_d = props.currentBDN) === null || _d === void 0 ? void 0 : _d.details, configuration: props.currentBDN.configuration, setProblems: function (v) { return setProblems(function (oldValue) { return constructProblems(oldValue, 'details', v); }); }, problems: problems.details }))),
        props.enabledBdnSteps.ctmsFieldsEnabled && (React__default.createElement(Collapse, { id: "eBDN-step-ctmsData", isOpen: !props.bdnProgress.ctmsCompleted, collapseHeaderContent: function () {
                return (React__default.createElement(BDNStepHeader, { status: generatePartStatus(props.bdnProgress.ctmsCompleted), stepNumber: getStepNumber(props.enabledBdnSteps, ['overViewFieldsEnabled']), stepTitle: "CTMS Measurement Data", stepInactive: false, problems: problems.ctmsData }));
            } },
            React__default.createElement(CTMSTable, { values: props.currentBDN.ctmsData, readOnly: props.readOnly, update: props.updateBDNCTMSData, hideTableHeaders: true, setProblems: function (v) { return setProblems(function (old) { return constructProblems(old, 'ctmsData', v); }); }, configuration: props.currentBDN.configuration, problems: problems.ctmsData }))),
        props.enabledBdnSteps.compositionFieldsEnabled && (React__default.createElement(Collapse, { id: "eBDN-step-lngComposition", isOpen: !props.bdnProgress.compositionCompleted, collapseHeaderContent: function () {
                return (React__default.createElement(BDNStepHeader, { status: generatePartStatus(props.bdnProgress.compositionCompleted), stepNumber: getStepNumber(props.enabledBdnSteps, [
                        'overViewFieldsEnabled',
                        'ctmsFieldsEnabled'
                    ]), stepTitle: "LNG Composition", stepInactive: false, problems: problems.lngComposition }));
            } },
            React__default.createElement(CompositionTable, { readOnly: props.readOnly, update: props.updateLNGCompositionData, hideTableHeaders: true, showCalculationOption: false, setProblems: function (v) {
                    return setProblems(function (oldValue) { return constructProblems(oldValue, 'lngComposition', v); });
                }, values: props.currentBDN.lngComposition, key: "eBDN-step-table-lngComposition", problems: problems.lngComposition, integrationData: lngSpecification, assetName: bunkerAssetName, fieldsMandatory: !hidePropertiesCalculation }))),
        props.enabledBdnSteps.propertyFieldsEnabled && (React__default.createElement(Collapse, { isOpen: !props.bdnProgress.propertiesCompleted, id: "eBDN-step-lngProperties", collapseHeaderContent: function () {
                return (React__default.createElement(BDNStepHeader, { status: generatePartStatus(props.bdnProgress.propertiesCompleted), stepNumber: getStepNumber(props.enabledBdnSteps, [
                        'overViewFieldsEnabled',
                        'ctmsFieldsEnabled',
                        'compositionFieldsEnabled'
                    ]), stepTitle: "LNG Properties", stepInactive: false, problems: problems.lngProperties }));
            } },
            React__default.createElement(PropertiesTable, { readOnly: props.readOnly, update: props.updateLNGPropertiesData, values: props.currentBDN.lngProperties, hideTableHeaders: true, configuration: props.currentBDN.configuration.propertiesFields, showCalculationOption: !hidePropertiesCalculation, calculateLNGProperties: calculateLNGProperties, setProblems: function (v) {
                    return setProblems(function (oldValue) { return constructProblems(oldValue, 'lngProperties', v); });
                }, problems: problems.lngProperties, integrationData: lngSpecification, assetName: bunkerAssetName }))),
        props.enabledBdnSteps.deliveredFieldsEnabled && (React__default.createElement(Collapse, { id: "eBDN-step-quantity", isOpen: !props.bdnProgress.quantityCompleted, collapseHeaderContent: function () {
                return (React__default.createElement(BDNStepHeader, { status: generatePartStatus(props.bdnProgress.quantityCompleted), stepNumber: getStepNumber(props.enabledBdnSteps, [
                        'overViewFieldsEnabled',
                        'ctmsFieldsEnabled',
                        'compositionFieldsEnabled',
                        'propertyFieldsEnabled'
                    ]), stepTitle: "Quantity Delivered", stepInactive: false, problems: problems.quantity }));
            } },
            React__default.createElement(QuantityDeliveredTable, { update: props.updateLNGQuantityData, readOnly: props.readOnly, values: props.currentBDN.quantity, hideTableHeaders: true, showCalculationOption: !hideQuantityCalculation, calculateLNGQuantity: props.calculateLNGQuantity, configuration: props.currentBDN.configuration, setProblems: function (v) { return setProblems(function (oldValue) { return constructProblems(oldValue, 'quantity', v); }); }, problems: problems.quantity, integrationData: quantity, assetName: bunkerAssetName }))),
        doesUserHavePermission(userPermissions, 'EBDN_READ_DOCUMENT') && (React__default.createElement(Collapse, { isOpen: ((_e = props.bdnDocument) === null || _e === void 0 ? void 0 : _e.signingStatus) !== 'SIGNED', expandDuration: 200, collapseHeaderContent: function () {
                var _a;
                return (React__default.createElement(BDNStepHeader, { status: generatePartStatus(((_a = props.bdnDocument) === null || _a === void 0 ? void 0 : _a.signingStatus) === 'SIGNED'), stepNumber: getStepNumber(props.enabledBdnSteps, [
                        'overViewFieldsEnabled',
                        'ctmsFieldsEnabled',
                        'compositionFieldsEnabled',
                        'propertyFieldsEnabled',
                        'deliveredFieldsEnabled'
                    ]), stepTitle: "eBDN Signing", stepInactive: false }));
            } },
            React__default.createElement(BDNSigning, { authenticationService: props.authenticationService, nomination: props.nomination, refetchEvent: props.refetchEvent, updateNomination: props.updateNomination, userProfile: props.userProfile, createSignableBDN: props.createBDNDocument, scrollInFocusTimeout: 210 })))));
    function getStepNumber(enabledBdnSteps, previousSteps) {
        var currentStep = 1;
        previousSteps.forEach(function (step) {
            if (enabledBdnSteps[step] === true) {
                currentStep += 1;
            }
        });
        return currentStep;
    }
};

var SpreadsheetBDNFlow = function (props) {
    var hasUploadedSpreadsheet = props.currentBDN.spreadsheet ? true : false;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Collapse$1, { collapseHeaderContent: function () {
                return (React__default.createElement(BDNStepHeader, { status: generatePartStatus(hasUploadedSpreadsheet), stepNumber: 1, stepTitle: "The BDN Spreadsheet", stepInactive: false }));
            } },
            React__default.createElement("div", { className: "bdn-step" },
                React__default.createElement("div", { className: "step-content" },
                    React__default.createElement("h3", { className: "bdn-sub-header" }, "1.1 Download the spreadsheet"),
                    React__default.createElement("p", null, "Chorus fills in known properties for the eBDN based on the nomination and statement of facts data. Download the spreadsheet, fill in additional details and then upload it here. After uploading the eBDN can be signed."),
                    React__default.createElement("div", { className: "ebdn-download", onClick: generatePrefilledEBDN },
                        React__default.createElement("div", { className: "spreadsheet-title" },
                            React__default.createElement(Icon, null,
                                React__default.createElement(FontAwesomeIcon, { icon: faFileExcel })),
                            React__default.createElement("div", null,
                                React__default.createElement("h3", null, "EBDN"),
                                React__default.createElement("span", null, "Spreadsheet"))),
                        React__default.createElement("div", { className: "download-icon" },
                            React__default.createElement(Icon, null,
                                React__default.createElement(FontAwesomeIcon, { icon: faDownload }))))),
                React__default.createElement("div", { className: "step-content" },
                    React__default.createElement("h3", { className: "bdn-sub-header" }, "1.2 Fill in the spreadsheet details"),
                    React__default.createElement("p", null, "The spreadsheet comes with values prefilled from the nomination and statement of facts data. Check the values and add missing values where applicable. Once finished, upload the spreadsheet in step 6 to convert it into a signable pdf document.")),
                React__default.createElement("div", { className: "step-content" },
                    React__default.createElement("div", { className: "bdn-explanation-block" },
                        React__default.createElement("h3", { className: "bdn-sub-header" }, "1.3 Upload filled in spreadsheet"),
                        React__default.createElement("p", null, "Upload the BDN spreadsheet which is completely filled in. The spreadsheet values are stored in the system and can be used to create a signable document.")),
                    React__default.createElement(DocumentHandler, { authenticationService: props.authenticationService, eventWithDocuments: props.nomination, acceptedFileType: '.xlsx', uploadTitle: '', uploadActive: !props.readOnly, userProfile: props.userProfile, uploadFile: function (file) {
                            props.attachEBDNToNomination(file);
                        }, allowedDocumentTypes: ['EBDN'], uploadId: 'NominationPage-EBDN', uploadFileType: 'EBDN_SPREADSHEET', readOnly: props.readOnly, viewerActive: false, refetchEvent: props.refetchEvent, updateItem: function (updatedNomination) { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, props.updateNomination(updatedNomination)];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); } })))),
        React__default.createElement(Collapse$1, { collapseHeaderContent: function () {
                var _a;
                return (React__default.createElement(BDNStepHeader, { status: generatePartStatus(((_a = props.bdnDocument) === null || _a === void 0 ? void 0 : _a.signingStatus) === 'SIGNED'), stepNumber: 2, stepTitle: "EBDN Signing", stepInactive: !hasUploadedSpreadsheet }));
            } },
            React__default.createElement(BDNSigning, { authenticationService: props.authenticationService, nomination: props.nomination, refetchEvent: props.refetchEvent, updateNomination: props.updateNomination, userProfile: props.userProfile, createSignableBDN: props.createBDNDocument }))));
    function generatePrefilledEBDN() {
        if (props.nomination.eventId) {
            try {
                getPrefilledEBDN(props.authenticationService, props.nomination.eventId);
            }
            catch (error) {
                handleFetchError(error);
            }
        }
    }
};

var ImportedEbdn = function (props) {
    var _a;
    var ebdn = props.ebdn, unit = props.unit;
    var _b = useState(false), recalculationDialog = _b[0], setRecalculationDialog = _b[1];
    var warningItems = ((_a = ebdn.externalSettings) === null || _a === void 0 ? void 0 : _a.recalculatedFieldsKeys) || [];
    var getRowName = function (ebdnItem, key) {
        switch (ebdnItem) {
            case 'details':
                return OVERVIEW_LABELS[key];
            case 'ctmsData':
                return CTMS_LABELS[key];
            case 'lngProperties':
                return PROPERTIES_LABELS[key];
            case 'lngComposition':
                return getLNGCompoundName(key);
            case 'quantity':
                return DELIVERED_LABELS[key];
            default:
                return undefined;
        }
    };
    var renderRow = function (obj, unit, trailingKey) {
        var hasUnit = props.unit && objHasValues(props.unit);
        var renderWarnings = warningItems.filter(function (key) { return key.startsWith(trailingKey || ''); });
        return Object.keys(obj).map(function (k) {
            if (k !== 'energyUnit' && obj[k]) {
                return (React__default.createElement("tr", { className: "imported-ebdn-row" },
                    React__default.createElement("td", { className: "imported-ebdn-td field-name" }, getRowName(trailingKey, k) || camelToSentence(k)),
                    trailingKey === 'lngComposition' && (React__default.createElement("td", { className: "imported-ebdn-td formula" }, getLNGCompoundFormula(k))),
                    React__default.createElement("td", { className: "imported-ebdn-td value" }, k === 'date' ? formatDateTime(obj[k]) : String(obj[k])),
                    hasUnit && React__default.createElement("td", { className: "imported-ebdn-td unit" }, (unit === null || unit === void 0 ? void 0 : unit[k]) || ''),
                    renderWarnings.length > 0 && (React__default.createElement("td", { className: "imported-ebdn-td info-box" }, renderWarnings.includes(trailingKey + "." + k) ? (React__default.createElement(FontAwesomeIcon, { onClick: function () {
                            setRecalculationDialog(true);
                        }, icon: faInfoCircle })) : ('')))));
            }
        });
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Dialog, { title: "Unit has been converted", titleIcon: React__default.createElement(Icon, null,
                React__default.createElement(FontAwesomeIcon, { icon: faInfoCircle })), showDialog: recalculationDialog, onCloseDialog: function () { return setRecalculationDialog(false); } }, "A unit conversion has been done for this data point. Please refer to the signed BDN for the official figure"),
        Object.keys(ebdn).map(function (key) {
            if (typeof ebdn[key] === 'boolean')
                return;
            if (ebdn[key]) {
                if (typeof ebdn[key] === 'object' &&
                    key !== 'configuration' &&
                    key !== 'externalSettings' &&
                    objHasValues(ebdn[key], ['energyUnit'])) {
                    return (React__default.createElement(Collapse$1, { isOpen: true, collapseHeaderContent: function () {
                            return (React__default.createElement(BDNStepHeader, { stepTitle: EBDN_TITLES[key] || camelToSentence(key), stepInactive: true }));
                        } },
                        React__default.createElement("table", { className: "imported-ebdn-table" }, renderRow(ebdn[key], unit === null || unit === void 0 ? void 0 : unit[key], key))));
                }
            }
        })));
};

/**
 * time used to timeout scrolling into a view and expand it. Time should be the same to avoid flacky scrolling
 */
var animationWindow = 200;
var BDNOverview = function (props) {
    var _a, _b, _c, _d;
    var _e = useBdnService(props.nomination, props.authenticationService), currentBDN = _e.currentBDN, loadingBDNData = _e.loadingBDNData, initialiseNewBDN = _e.initialiseNewBDN, updateBDNDetailsData = _e.updateBDNDetailsData, updateBDNCTMSData = _e.updateBDNCTMSData, updateLNGPropertiesData = _e.updateLNGPropertiesData, updateLNGQuantityData = _e.updateLNGQuantityData, updateLNGCompositionData = _e.updateLNGCompositionData, calculateLNGProperties = _e.calculateLNGProperties, calculateLNGQuantity = _e.calculateLNGQuantity;
    // TODO: cleanup this backward compatibility message one day (added 2021-11-19)
    var vendorCompanyIdProp = props.vendorCompanyId;
    useEffect(function () {
        if (vendorCompanyIdProp) {
            console.warn('Property vendorCompanyId in component BNDOverview is deprecated. ' +
                "It is not needed at all anymore. Please don't pass this property.");
        }
    }, [vendorCompanyIdProp]);
    // in case of a delegated nomination, we must not only use the eBDN configuration of the executing party
    // but the contract holding supplier aswell
    var isDelegatedNomination = !!props.nomination.delegationOriginEventId;
    var userIsVendor = props.userProfile.companyId === props.nomination.vendorCompanyId;
    var vendorBdnConfigurationList = useBdnConfigurationService(props.authenticationService, props.nomination.vendorCompanyId || undefined).bdnConfigurationsList;
    var companyBdnConfigurationList = useBdnConfigurationService(props.authenticationService, isDelegatedNomination && userIsVendor ? props.nomination.companyId : undefined).bdnConfigurationsList;
    var bdnConfigurationsList = vendorBdnConfigurationList.concat(companyBdnConfigurationList);
    var userPermissions = useContext(UserPermissionContext).userPermissions;
    var enabledBdnSteps = getEnabledBDNSteps(currentBDN === null || currentBDN === void 0 ? void 0 : currentBDN.configuration);
    var bdnProgress = getBDNProgress(currentBDN, enabledBdnSteps);
    var latestBDNDocument = getLatestBdnDocument();
    if (!doesUserHavePermission(userPermissions, 'EBDN_READ')) {
        return React__default.createElement(PermissionsWarning, null, "You are not allowed to view this eBDN");
    }
    var renderExternalEbdn = function (obj) {
        var customUnits = generateEbdnUnits(obj);
        return (React__default.createElement(React__default.Fragment, null,
            currentBDN && React__default.createElement(ImportedEbdn, { ebdn: currentBDN, unit: customUnits }),
            React__default.createElement(Collapse, { isOpen: true, expandDuration: animationWindow, collapseHeaderContent: function () {
                    return React__default.createElement(BDNStepHeader, { stepTitle: "eBDN Signing", stepInactive: false });
                } },
                React__default.createElement(PDFDocumentHandler, { authenticationService: props.authenticationService, eventWithDocuments: props.nomination, userProfile: props.userProfile, allowedDocumentTypes: ['EBDN'], readOnly: true, refetchEvent: function () { }, updateItem: function () { }, scrollInFocusTimeout: animationWindow }))));
    };
    return (React__default.createElement("div", { className: "ebdn-wrapper " + (props.className || '') + " " + (((_a = currentBDN === null || currentBDN === void 0 ? void 0 : currentBDN.externalSettings) === null || _a === void 0 ? void 0 : _a.external) ? 'external-ebdn-wrapper' : '') },
        React__default.createElement(LoadingIndicator, { loading: loadingBDNData }),
        React__default.createElement(BDNInitialisation, { currentBDN: currentBDN, initialiseNewBDN: initialiseNewBDN, nomination: props.nomination, bdnConfigurationsList: bdnConfigurationsList }),
        currentBDN && (React__default.createElement(React__default.Fragment, null,
            ((_b = currentBDN === null || currentBDN === void 0 ? void 0 : currentBDN.externalSettings) === null || _b === void 0 ? void 0 : _b.external) && (React__default.createElement(React__default.Fragment, null,
                React__default.createElement("b", { className: "external-ebdn-message-text" },
                    "External eBDN provided from ", (_c = currentBDN.externalSettings) === null || _c === void 0 ? void 0 :
                    _c.source),
                renderExternalEbdn(currentBDN))),
            !((_d = currentBDN === null || currentBDN === void 0 ? void 0 : currentBDN.externalSettings) === null || _d === void 0 ? void 0 : _d.external) && currentBDN.flowType === 'ONLINE' && (React__default.createElement(OnlineBDNFlow, { authenticationService: props.authenticationService, bdnProgress: bdnProgress, createBDNDocument: props.createBDNDocument, currentBDN: currentBDN, nomination: props.nomination, refetchEvent: props.refetchEvent, updateBDNCTMSData: updateBDNCTMSData, updateBDNDetailsData: updateBDNDetailsData, updateLNGCompositionData: updateLNGCompositionData, updateLNGPropertiesData: updateLNGPropertiesData, updateLNGQuantityData: updateLNGQuantityData, updateNomination: props.updateNomination, userProfile: props.userProfile, readOnly: !doesUserHavePermission(userPermissions, 'EBDN_UPDATE'), bdnDocument: latestBDNDocument, enabledBdnSteps: enabledBdnSteps, calculateLNGProperties: calculateLNGProperties, calculateLNGQuantity: calculateLNGQuantity, calculationsEnabled: props.calculationsEnabled })),
            currentBDN.flowType === 'SPREADSHEET' && (React__default.createElement(SpreadsheetBDNFlow, { authenticationService: props.authenticationService, bdnProgress: bdnProgress, createBDNDocument: props.createBDNDocument, currentBDN: currentBDN, nomination: props.nomination, readOnly: !doesUserHavePermission(userPermissions, 'EBDN_UPDATE'), refetchEvent: props.refetchEvent, updateBDNDetailsData: updateBDNDetailsData, updateNomination: props.updateNomination, userProfile: props.userProfile, attachEBDNToNomination: props.attachEBDNToNomination, bdnDocument: latestBDNDocument }))))));
    function getLatestBdnDocument() {
        var _a, _b;
        var BDNDocuments = (_b = (_a = props.nomination) === null || _a === void 0 ? void 0 : _a.documents) === null || _b === void 0 ? void 0 : _b.filter(function (document) { return document.type === 'EBDN'; });
        // sorts the bdns by their uploaddate. Last bdn in the array is the newest created.
        var sortedDocuments = BDNDocuments
            ? BDNDocuments.sort(function (a, b) {
                return a.uploadDate < b.uploadDate ? -1 : a.uploadDate > b.uploadDate ? 1 : 0;
            })
            : undefined;
        var latestBDNDocument = sortedDocuments
            ? sortedDocuments[sortedDocuments.length - 1]
            : undefined;
        return latestBDNDocument;
    }
};

var SafetyChecklistCodeGuidelines = function () {
    return (React__default.createElement("div", null,
        React__default.createElement("h4", null, "Coding of Items"),
        React__default.createElement("p", null, "The presence of the letters \u2018A\u2019, \u2018P\u2019 or \u2018R\u2019 in the column entitled \u2018Code\u2019 indicates the following:"),
        React__default.createElement("table", null,
            React__default.createElement("tbody", null,
                React__default.createElement("tr", null,
                    React__default.createElement("td", { className: "item-code" }, "A"),
                    React__default.createElement("td", null, "\u2018Agreement\u2019 - This indicates that the referenced consideration should be addressed by an agreement or procedure that should be identified in the \u2018Remarks\u2019 column of the checklist or communicated in some other mutually acceptable form.")),
                React__default.createElement("tr", null,
                    React__default.createElement("td", { className: "item-code" }, "P"),
                    React__default.createElement("td", null, "\u2018Permission\u2019 - In the case of a negative answer to the statements coded \u2018P\u2019, no operations are to be conducted without the written permission from the appropriate authority")),
                React__default.createElement("tr", null,
                    React__default.createElement("td", { className: "item-code" }, "R"),
                    React__default.createElement("td", null, "\u2018Re-check\u2019 - This indicates items to be re-checked at appropriate intervals, as agreed between both parties and stated in the declaration.")))),
        React__default.createElement("p", null, "The joint declaration should not be signed until all parties have checked and accepted their assigned responsibilities and accountabilities.")));
};

function updateChecklistValue(authenticationService, value, checklistType, checkListId, nominationId) {
    return __awaiter(this, void 0, void 0, function () {
        var checkListValueUpdate, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    checkListValueUpdate = {
                        checklistType: checklistType,
                        id: checkListId,
                        value: value
                    };
                    return [4 /*yield*/, setSafetyChecklistValue(authenticationService, nominationId, checkListValueUpdate)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    handleFetchError(error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
function updateRemarkValue(authenticationService, remark, checklistType, checkListId, nominationId, remarksInput) {
    return __awaiter(this, void 0, void 0, function () {
        var checkListValueUpdate, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    checkListValueUpdate = {
                        checklistType: checklistType,
                        id: checkListId,
                        remark: remark,
                        remarksInput: remarksInput
                    };
                    return [4 /*yield*/, setSafetyChecklistRemarkValue(authenticationService, nominationId, checkListValueUpdate)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _a.sent();
                    handleFetchError(error_2);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
function updateAlignmentAgreement(authenticationService, agreement, checklistType, checkListId, nominationId, agreementInput) {
    return __awaiter(this, void 0, void 0, function () {
        var checkListValueUpdate, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    checkListValueUpdate = {
                        checklistType: checklistType,
                        id: checkListId,
                        agreementInput: agreementInput,
                        agreement: agreement
                    };
                    return [4 /*yield*/, setSafetyChecklistAgreementValue(authenticationService, nominationId, checkListValueUpdate)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    error_3 = _a.sent();
                    handleFetchError(error_3);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
function setNotApplicable(authenticationService, eventId, checklistItemId, value, checklistType) {
    return __awaiter(this, void 0, void 0, function () {
        var error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, setSafetyChecklistItemNotApplicable(authenticationService, eventId, checklistItemId, value, checklistType)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    error_4 = _a.sent();
                    handleFetchError(error_4);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
/** Should checklist item be readonly */
function shouldFieldBeReadOnly(readOnly, checkboxFieldFor, userRoles) {
    if (readOnly || isScheduler(userRoles)) {
        return true;
    }
    else {
        if ((isBunkerCaptain(userRoles) || isUserAllowed(['ROLE_TERMINAL_OPERATOR'], userRoles)) &&
            checkboxFieldFor === 'bunkerShip') {
            return false;
        }
        if (isReceivingCaptain(userRoles) && checkboxFieldFor === 'receivingShip') {
            return false;
        }
    }
    return true;
}

var SafetyChecklistCheckBox = function (props) {
    var _a = useState(props.checkboxValue), checkboxValue = _a[0], setCheckboxValue = _a[1];
    useEffect(function () {
        setCheckboxValue(props.checkboxValue);
    }, [props.checkboxValue]);
    if (checkboxValue === 'NOT_APPLICABLE') {
        return React__default.createElement("td", { className: "grayed-out-cell" });
    }
    return (React__default.createElement("td", { className: "centered-table-box safety-checklist-checkbox " + (props.readOnly ? 'readonly-checkbox' : ''), onClick: function () {
            if (!props.readOnly) {
                var newValue = checkboxValue === ChecklistValue.BLANK ? ChecklistValue.CHECKED : ChecklistValue.BLANK;
                setCheckboxValue(newValue);
                props.onChange(newValue);
            }
        } }, checkboxValue === ChecklistValue.BLANK ? (React__default.createElement("div", { className: "grayed-out-text" },
        React__default.createElement(FontAwesomeIcon, { icon: faCheck }))) : (React__default.createElement("div", { className: "checked-text" },
        React__default.createElement(FontAwesomeIcon, { icon: faCheck })))));
};

var SafetyChecklistRemark = function (props) {
    var remarkArray = props.remark.split(/_{2,}/);
    var wrapperRef = useRef(null);
    var remarkValues = props.remarkValues || [];
    var handleRemarkChange = function (index, remark) {
        remarkValues[index] = remark;
        props.setRemarkValues(remarkValues);
    };
    var handleTextareaBlur = function (e) {
        remarkValues[remarkArray.length - 1 || 0] = e.target.value;
        props.setRemarkValues(remarkValues);
        props.setEditingChecklistValue(false);
    };
    return (React__default.createElement("div", { className: "safetyChecklist-remark", ref: wrapperRef },
        React__default.createElement("div", null, remarkArray.map(function (text, index) {
            var _a;
            return (React__default.createElement(React__default.Fragment, { key: index },
                text,
                remarkArray.length - 1 > index && (React__default.createElement(ResizingInput, { initialValue: remarkValues[index] || '', maxWidth: (_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth, setEditingChecklistValue: props.setEditingChecklistValue, setRemarkValues: function (remark) { return handleRemarkChange(index, remark); } }))));
        })),
        props.notApplicable !== null && props.notApplicable !== undefined && (React__default.createElement("div", null,
            React__default.createElement(Checkbox, { field: props.uniqueIdPrefix + "-not-applicable", label: "Not applicable", className: "not-applicable-checklist-checkbox", value: props.notApplicable, onChange: function (e) {
                    props.setNotApplicable(e.target.checked);
                } }))),
        React__default.createElement("div", null,
            React__default.createElement("textarea", { className: "additional-remark", onChange: function () { return props.setEditingChecklistValue(true); }, onBlur: function (e) { return handleTextareaBlur(e); }, defaultValue: remarkValues[remarkArray.length - 1 || 0] || '' }))));
};
var ResizingInput = function (_a) {
    var _b = _a.minWidth, minWidth = _b === void 0 ? 30 : _b, initialValue = _a.initialValue, _c = _a.maxWidth, maxWidth = _c === void 0 ? 1000 : _c, setEditingChecklistValue = _a.setEditingChecklistValue, setRemarkValues = _a.setRemarkValues;
    var refSpan = useRef(null);
    var _d = useState(minWidth), size = _d[0], setSize = _d[1];
    var _e = useState(16), height = _e[0], setHeight = _e[1];
    var _f = useState(initialValue), value = _f[0], setValue = _f[1];
    useEffect(function () {
        if (refSpan.current) {
            var width = refSpan.current.offsetWidth + 10;
            var newWidth = Math.max(width, minWidth);
            setSize(Math.min(newWidth, maxWidth));
            var newHeight = refSpan.current.offsetHeight;
            setHeight(newHeight < 16 ? 16 : newHeight);
        }
    }, [value]);
    var onChange = function (text) {
        setEditingChecklistValue(true);
        setValue(text);
    };
    var onBlur = function () {
        setRemarkValues(value);
        setEditingChecklistValue(false);
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("span", { className: "resizing-input-span", ref: refSpan, style: { maxWidth: maxWidth + "px" } }, value),
        React__default.createElement("textarea", { className: "resizing-input-input", style: {
                height: height + "px",
                width: size + "px",
                minWidth: minWidth + "px"
            }, onChange: function (e) { return onChange(e.target.value); }, value: value, onBlur: onBlur })));
};

var SafetyChecklistCodeGuidelinesIAPHv2 = function () {
    return (React__default.createElement("div", null,
        React__default.createElement("h4", null, "Checklist code"),
        React__default.createElement("p", null, "The codes that are used in the checklist columns indicate:"),
        React__default.createElement("table", null,
            React__default.createElement("tbody", null,
                React__default.createElement("tr", null,
                    React__default.createElement("td", { className: "item-code" }, "A"),
                    React__default.createElement("td", null, "To be entered in the agreement sheet: Part C2")),
                React__default.createElement("tr", null,
                    React__default.createElement("td", { className: "item-code" }, "R"),
                    React__default.createElement("td", null, "Subject to a repetitive check: Part E1, E2, E3")),
                React__default.createElement("tr", null,
                    React__default.createElement("td", { className: "item-code" }, "JPBO"),
                    React__default.createElement("td", null, "See the Joint Bunker Management Plan for details")))),
        React__default.createElement("p", null, "The joint declaration should not be signed until all parties have checked and accepted their assigned responsibilities and accountabilities.")));
};

var ChecklistItemComponent = function (props) {
    var item = props.item, itemNumber = props.itemNumber, nominationId = props.nominationId;
    var _a = useState(false), dialogActive = _a[0], setDialogActive = _a[1];
    var helpTexts = useContext(SafetyChecklistHelpTextContext).helpTexts;
    return (React__default.createElement(React__default.Fragment, null,
        dialogActive && (React__default.createElement(Dialog, { showDialog: dialogActive, title: item.text, className: "info-dialog", onCloseDialog: function () {
                setDialogActive(false);
            } },
            React__default.createElement("p", { dangerouslySetInnerHTML: { __html: helpTexts[item.idx] } }),
            props.safetyChecklistType === SafetyChecklistType.IAPH_V2_A ||
                props.safetyChecklistType === SafetyChecklistType.IAPH_V2_B ? (React__default.createElement(SafetyChecklistCodeGuidelinesIAPHv2, null)) : (React__default.createElement(SafetyChecklistCodeGuidelines, null)))),
        React__default.createElement("tr", null,
            React__default.createElement("td", { className: "number-box" }, item.idx),
            React__default.createElement("td", { className: "checklist-question padded-td" }, item.text),
            props.disableReceivingship !== true && (React__default.createElement(SafetyChecklistCheckBox, { checkboxValue: item.receivingShip, readOnly: shouldFieldBeReadOnly(props.readOnly, 'receivingShip', props.userRoles), onChange: function (checkValue) {
                    props.changeValue('receivingShip', checkValue, itemNumber, props.checklistName);
                    updateChecklistValue(props.authenticationService, checkValue, getBackendChecklistTypeValue(props.checklistName), item._id, nominationId);
                } })),
            props.disableBunkership !== true && (React__default.createElement(SafetyChecklistCheckBox, { checkboxValue: item.bunkerShip, readOnly: shouldFieldBeReadOnly(props.readOnly, 'bunkerShip', props.userRoles), onChange: function (checkValue) {
                    props.changeValue('bunkerShip', checkValue, itemNumber, props.checklistName);
                    updateChecklistValue(props.authenticationService, checkValue, getBackendChecklistTypeValue(props.checklistName), item._id, nominationId);
                } })),
            React__default.createElement("td", { className: "code-box" }, item.code),
            React__default.createElement("td", null,
                React__default.createElement(SafetyChecklistRemark, { remark: item.remarks, setEditingChecklistValue: props.setEditingChecklistValue, remarkValues: item.remarksInput, setRemarkValues: function (remarksInput) {
                        updateRemarkValue(props.authenticationService, item.remarks, getBackendChecklistTypeValue(props.checklistName), item._id, nominationId, remarksInput);
                        props.setEditingChecklistValue(false);
                    }, readonly: props.readOnly || isScheduler(props.userRoles), notApplicable: item.notApplicable, uniqueIdPrefix: item._id, setNotApplicable: function (v) {
                        props.changeValue('notApplicable', v, itemNumber, props.checklistName);
                        setNotApplicable(props.authenticationService, nominationId, item._id, v, getBackendChecklistTypeValue(props.checklistName));
                    } })),
            React__default.createElement("td", { className: "info-box" },
                React__default.createElement(FontAwesomeIcon, { onClick: function () {
                        setDialogActive(true);
                    }, icon: faInfoCircle })))));
};
function getBackendChecklistTypeValue(checklistName) {
    switch (checklistName) {
        case 'checklistA':
            return ChecklistType.A;
        case 'checklistB':
            return ChecklistType.B;
        case 'checklistC':
            return ChecklistType.C;
        case 'checklistD':
            return ChecklistType.D;
        case 'checklistE':
            return ChecklistType.E;
        case 'checklistF':
            return ChecklistType.F;
        case 'checklistG':
            return ChecklistType.G;
        default:
            // should never happen, just so ts is happy
            return ChecklistType.A;
    }
}

var ChecklistTable = function (props) {
    var bunkerEntityName = props.safetyChecklist.type === SafetyChecklistType.TR56 ? 'Bunker facility' : 'Bunker Vessel';
    return (React__default.createElement("table", { className: props.className },
        React__default.createElement("thead", null,
            React__default.createElement("tr", null,
                React__default.createElement("th", null, "No."),
                React__default.createElement("th", null, "Check"),
                React__default.createElement("th", null, "Receiving Vessel"),
                React__default.createElement("th", null, bunkerEntityName),
                React__default.createElement("th", null, "Code"),
                React__default.createElement("th", null, "Remarks"),
                React__default.createElement("th", null))),
        React__default.createElement("tbody", null, props.safetyChecklist[props.checkListName].map(function (checkItem, index) {
            return (React__default.createElement(ChecklistItemComponent, { authenticationService: props.authenticationService, key: 'checklist-item' + index, item: checkItem, changeValue: props.changeValueFunction || changeValue, itemNumber: index, checklistName: props.checkListName, readOnly: props.readOnly, nominationId: props.nominationId, userRoles: props.userRoles, setEditingChecklistValue: props.setEditingChecklistValue, safetyChecklistType: props.safetyChecklist.type }));
        }))));
    function changeValue(fieldName, value, itemNumber, checklistName) {
        var path = checklistName + "[" + itemNumber + "]." + fieldName;
        props.onChangeFormValue(path, value);
    }
};

var ChecklistWrapper = function (props) {
    return (React__default.createElement("div", { className: "table-wrapper" },
        React__default.createElement("div", null,
            props.title && React__default.createElement("h3", { className: "checklist-header" }, props.title),
            props.subTitle && React__default.createElement("b", { className: "checklist-subtitle" }, props.subTitle),
            props.description && React__default.createElement("div", { className: "title-description" }, props.description)),
        props.children));
};

var ChecklistPartA = function (props) {
    return (React__default.createElement(ChecklistWrapper, { title: props.title ? props.title : 'Part A - Planning stage checklist', description: props.description
            ? props.description
            : 'This part of the checklist should be completed in the planning stage of an LNG bunker' +
                'operation. It is a recommended guideline for the, in advance, exchange of information' +
                'necessary for the preparation of the actual operation.', subTitle: props.subTitle },
        React__default.createElement(ChecklistTable, __assign({ className: "checklist-IAPH-gothenburg-a", checkListName: "checklistA", changeValueFunction: changeValue }, props))));
    function changeValue(fieldName, value, itemNumber, checklistName) {
        if (props.useSectionB2) {
            //b2 should only be shown if, bunker or receving is checked (new value is checked) or hidden if the new values are all unchecked
            var checkItem = props.safetyChecklist[checklistName][itemNumber];
            if (checkItem.idx === 'A2-4' &&
                (value === 'CHECKED' ||
                    (checkItem.bunkerShip !== checkItem.receivingShip && value !== 'CHECKED'))) {
                props.useSectionB2(value === 'CHECKED');
            }
        }
        var path = checklistName + "[" + itemNumber + "]." + fieldName;
        props.onChangeFormValue(path, value);
    }
};

var IAPHChecklistPartB = function (props) {
    return (React__default.createElement(ChecklistWrapper, { title: "Part B - Planned simultaneous activities", subTitle: "", description: "(If applicable this part should be completed before actual transfer operations start)" },
        React__default.createElement(Button, { preventDoubleClick: true, disabled: props.readOnly || !isCaptain(props.userRoles), switchButton: true, onClick: function (event) {
                event.preventDefault();
                var newSimOpsValue = !props.simopsEnabled;
                props.onChangeFormValue("simopsEnabled", newSimOpsValue);
                toggleSimops(newSimOpsValue);
            } },
            React__default.createElement("span", { className: props.simopsEnabled ? 'active' : '' }, props.simopsEnabled ? 'SimOps enabled' : 'Enable SimOps'),
            React__default.createElement("span", { className: props.simopsEnabled ? '' : 'active' }, props.simopsEnabled ? 'Disable Simops' : 'SimOps disabled')),
        React__default.createElement(ChecklistTable, __assign({ className: "flexeble-checklist checklist-IAPH-b " + (!props.simopsEnabled && ' disabled'), checkListName: "checklistB" }, props))));
    function toggleSimops(enabled) {
        useSafetyChecklistSimops(props.authenticationService, props.nominationId, enabled).catch(function (error) { return handleFetchError(error); });
    }
};

var unitTypes = {
    mt: 'MT',
    m3: 'm³'
};
var PQUField = function (props) {
    var units = Object.values(unitTypes);
    var isCustomUnit = !units.includes(props.unit);
    var _a = useState(isCustomUnit ? props.unit : ''), custom = _a[0], setCustom = _a[1];
    return (React__default.createElement("div", { className: "title-description physical-quantity" },
        "Physical Quantity Unit (PQU)",
        React__default.createElement("div", { className: "physical-quantity-checkboxes" },
            React__default.createElement(Checkbox, { label: unitTypes.mt, value: props.unit === unitTypes.mt, field: "qubicmeter-check", onChange: function (event) {
                    event.target.checked && props.updateUnitValue(unitTypes.mt);
                } }),
            React__default.createElement(Checkbox, { label: unitTypes.m3, value: props.unit === unitTypes.m3, field: "metricton-check", onChange: function (event) {
                    event.target.checked && props.updateUnitValue(unitTypes.m3);
                } }),
            React__default.createElement("div", { className: "checkbox-with-input-field" },
                React__default.createElement(FormElement, null,
                    React__default.createElement(Checkbox, { label: "", value: isCustomUnit, field: "customUnit-check", onChange: function (event) {
                            event.target.checked && props.updateUnitValue(isCustomUnit ? props.unit : '');
                        } }),
                    React__default.createElement(TextField, { fieldName: "testfield", placeholder: "Custom unit..", value: custom, disabled: props.readOnly, onChange: function (e) { return setCustom(e.target.value); }, onBlur: function () { return props.updateUnitValue(custom); } }))))));
};

var GothenburgChecklistPartB = function (props) {
    var endOfPartOne = props.safetyChecklist.checklistB.findIndex(function (item) { return item.idx.startsWith('B2-'); }) | 0;
    return (React__default.createElement(ChecklistWrapper, { title: "Part B1 - Planned simultaneous activities" },
        React__default.createElement(Button$1, { preventDoubleClick: true, disabled: props.readOnly || !isCaptain(props.userRoles), switchButton: true, onClick: function (event) {
                event.preventDefault();
                var newSimOpsValue = !props.simopsEnabled;
                props.onChangeFormValue("simopsEnabled", newSimOpsValue);
                toggleSimops(newSimOpsValue);
            } },
            React__default.createElement("span", { className: props.simopsEnabled ? 'active' : '' }, props.simopsEnabled ? 'SimOps enabled' : 'Enable SimOps'),
            React__default.createElement("span", { className: props.simopsEnabled ? '' : 'active' }, props.simopsEnabled ? 'Disable Simops' : 'SimOps disabled')),
        React__default.createElement("table", { className: "flexeble-checklist checklist-gothenburg-b1 " + (!props.simopsEnabled && ' disabled') },
            React__default.createElement("thead", null,
                React__default.createElement("tr", null,
                    React__default.createElement("th", null, "No."),
                    React__default.createElement("th", null, "Check"),
                    React__default.createElement("th", null, "Receiving Vessel"),
                    React__default.createElement("th", null, "Bunker Vessel"),
                    React__default.createElement("th", null, "Code"),
                    React__default.createElement("th", null, "Remarks"),
                    React__default.createElement("th", null))),
            React__default.createElement("tbody", null, props.safetyChecklist.checklistB.slice(0, endOfPartOne).map(function (checkItem, index) {
                return (React__default.createElement(ChecklistItemComponent, { authenticationService: props.authenticationService, key: 'checklist-item' + index, item: checkItem, changeValue: changeValue, itemNumber: index, checklistName: 'checklistB', readOnly: props.readOnly || !props.simopsEnabled, nominationId: props.nominationId, userRoles: props.userRoles, setEditingChecklistValue: props.setEditingChecklistValue, safetyChecklistType: props.safetyChecklist.type }));
            }))),
        React__default.createElement("h3", { className: "checklist-header" }, "Part B2 - Checks at the planning stage for the receiving ship, bunkering during low flashpoint (below 30\u00B0C) cargo handling."),
        !props.useSectionB2 && (React__default.createElement("div", { className: "title-description" }, "Section B2 can only be answerd if question A2-4 is checked.")),
        React__default.createElement("table", { className: "flexeble-checklist checklist-gothenburg-b2 " + (!props.useSectionB2 && ' disabled') },
            React__default.createElement("thead", null,
                React__default.createElement("tr", null,
                    React__default.createElement("th", null, "No."),
                    React__default.createElement("th", null, "Check"),
                    React__default.createElement("th", null, "Receiving Vessel"),
                    React__default.createElement("th", null, "Bunker Vessel"),
                    React__default.createElement("th", null, "Code"),
                    React__default.createElement("th", null, "Remarks"),
                    React__default.createElement("th", null))),
            React__default.createElement("tbody", null, props.safetyChecklist.checklistB
                .slice(endOfPartOne, props.safetyChecklist.checklistB.length)
                .map(function (checkItem, index) {
                return (React__default.createElement(ChecklistItemComponent, { authenticationService: props.authenticationService, key: 'checklist-item' + (index + endOfPartOne), item: checkItem, changeValue: changeValue, itemNumber: index + endOfPartOne, checklistName: 'checklistB', readOnly: props.readOnly || !props.useSectionB2, nominationId: props.nominationId, userRoles: props.userRoles, setEditingChecklistValue: props.setEditingChecklistValue, safetyChecklistType: props.safetyChecklist.type }));
            }))),
        React__default.createElement("h3", { className: "checklist-header" }, "Bunker and cargo operations plan"),
        React__default.createElement(PQUField, { unit: props.gothenburgOpsPlan.unit, readOnly: props.readOnly, updateUnitValue: updateUnitValue }),
        React__default.createElement("table", { className: "checklist-gothenburg-bunker-and-cargo-operations-plan" },
            React__default.createElement("thead", null,
                React__default.createElement("tr", null,
                    React__default.createElement("th", null),
                    React__default.createElement("th", null, "Oil bunker"),
                    React__default.createElement("th", null, "Cargo"),
                    React__default.createElement("th", null, "LNG"),
                    React__default.createElement("th", null))),
            React__default.createElement("tbody", null,
                renderOilCargoLNGItem('Product', 'product', props.gothenburgOpsPlan.unit),
                renderOilCargoLNGItem('Volume to be transfered', 'volume', 'PQU'),
                renderOilCargoLNGItem('Starting rate', 'startingRate', 'm³ per hour'),
                renderOilCargoLNGItem('Max transfer rate', 'maxTransferRate', 'm³ per hour'),
                renderOilCargoLNGItem('Topping of rate', 'toppingRate', 'm³ per hour'),
                renderOilCargoLNGItem('Max pressure at manifold', 'maxPressureManifold', 'bar')))));
    function updateUnitValue(unit) {
        return __awaiter(this, void 0, void 0, function () {
            var path;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = "gothenburgOpsPlan.unit";
                        props.setEditingChecklistValue(true);
                        props.onChangeFormValue(path, unit);
                        props.gothenburgOpsPlan.unit = unit;
                        return [4 /*yield*/, setGothenburgOpsPlanData(props.authenticationService, props.nominationId, props.gothenburgOpsPlan)];
                    case 1:
                        _a.sent();
                        props.setEditingChecklistValue(false);
                        return [2 /*return*/];
                }
            });
        });
    }
    function renderOilCargoLNGItem(name, key, unit) {
        return (React__default.createElement("tr", null,
            React__default.createElement("td", { className: "checklist-question padded-td" }, name),
            renderChangebleItem('oil', key),
            renderChangebleItem('cargo', key),
            renderChangebleItem('lng', key),
            React__default.createElement("td", null, unit)));
    }
    function renderChangebleItem(type, key) {
        var _this = this;
        var _a, _b;
        var value = (_b = (_a = props.gothenburgOpsPlan) === null || _a === void 0 ? void 0 : _a[type]) === null || _b === void 0 ? void 0 : _b[key];
        return (React__default.createElement("td", null,
            React__default.createElement("input", { type: "text", className: "table-text-input padded-td", value: value ? value : '', disabled: props.readOnly, onChange: function (e) {
                    props.setEditingChecklistValue(true);
                    changeValueOperationsPlan(type, key, e.target.value);
                }, onBlur: function (e) { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, setGothenburgOpsPlanData(props.authenticationService, props.nominationId, props.gothenburgOpsPlan)];
                            case 1:
                                _a.sent();
                                props.setEditingChecklistValue(false);
                                return [2 /*return*/];
                        }
                    });
                }); } })));
    }
    function changeValueOperationsPlan(type, fieldName, value) {
        var path = "gothenburgOpsPlan." + type + "." + fieldName;
        props.onChangeFormValue(path, value);
    }
    function changeValue(fieldName, value, itemNumber, checklistName) {
        var path = checklistName + "[" + itemNumber + "]." + fieldName;
        props.onChangeFormValue(path, value);
    }
    function toggleSimops(enabled) {
        useSafetyChecklistSimops(props.authenticationService, props.nominationId, enabled).catch(function (error) { return handleFetchError(error); });
    }
};

var SimOpsComponent = function (props) {
    return (React__default.createElement("div", { className: "table-wrapper" },
        React__default.createElement("h4", { className: "checklist-section-header" }, props.simOpsTitle),
        props.description && React__default.createElement("div", { className: "title-description" }, props.description),
        React__default.createElement("table", null,
            React__default.createElement("thead", null,
                React__default.createElement("tr", null,
                    React__default.createElement("th", null, props.activityTitle),
                    React__default.createElement("th", null, "Receiving Vessel"),
                    React__default.createElement("th", null, "Bunker Vessel"))),
            React__default.createElement("tbody", null,
                props.simOpsValues.map(function (simOp, index) {
                    return (React__default.createElement("tr", { key: props.simOpsType + "-" + index },
                        React__default.createElement("td", null,
                            React__default.createElement("input", { type: "text", className: "table-text-input padded-td", value: simOp.text !== null ? simOp.text : '', disabled: props.readOnly, onChange: function (e) {
                                    props.setEditingChecklistValue(true);
                                    props.changeSimOpsData(props.simOpsType, 'text', index, e.target.value);
                                }, onBlur: function (e) {
                                    updateRemarkValue(props.authenticationService, e.target.value, getBackendSimOpsTypeValue(props.simOpsType), simOp._id, props.nominationId, null);
                                    props.setEditingChecklistValue(false);
                                } })),
                        React__default.createElement(SafetyChecklistCheckBox, { checkboxValue: simOp.receivingShip, onChange: function (checkValue) {
                                props.changeSimOpsData(props.simOpsType, 'receivingShip', index, checkValue);
                                updateChecklistValue(props.authenticationService, checkValue, getBackendSimOpsTypeValue(props.simOpsType), simOp._id, props.nominationId);
                            }, readOnly: shouldFieldBeReadOnly(props.readOnly, 'receivingShip', props.userRoles) }),
                        React__default.createElement(SafetyChecklistCheckBox, { checkboxValue: simOp.bunkerShip, onChange: function (checkValue) {
                                props.changeSimOpsData(props.simOpsType, 'bunkerShip', index, checkValue);
                                updateChecklistValue(props.authenticationService, checkValue, getBackendSimOpsTypeValue(props.simOpsType), simOp._id, props.nominationId);
                            }, readOnly: shouldFieldBeReadOnly(props.readOnly, 'bunkerShip', props.userRoles) })));
                }),
                !props.readOnly && (React__default.createElement("tr", { onClick: function () {
                        var indexToCreateNewSimopsFor = props.simOpsValues.length;
                        props.addNewSimOpRow(props.simOpsType, indexToCreateNewSimopsFor);
                    } },
                    React__default.createElement("td", { className: "padded-td create-new-row", colSpan: 3 },
                        React__default.createElement(Icon, null,
                            React__default.createElement(FontAwesomeIcon, { icon: faPlus }),
                            "Add Simultaneous Operation"))))))));
    function getBackendSimOpsTypeValue(simOpsType) {
        switch (simOpsType) {
            case 'bunkerSimops':
                return ChecklistType.BUNKER;
            case 'cargoSimops':
                return ChecklistType.CARGO;
            case 'simopsRestrictions':
                return ChecklistType.RESTRICTIONS;
            default:
                // should never happen, just so ts is happy
                return ChecklistType.BUNKER;
        }
    }
};

var ChecklistPartD = function (props) {
    return (React__default.createElement(ChecklistWrapper, { title: "Part B \u2013 Planned simultaneous activities", subTitle: "(This part should be completed before actual bunker transfer operations start)", description: "This checklist is applicable for concurrentbunker, cargo or other operations that may pose\nadditional risk during the LNG bunkering. Simultaneous activities are only allowed if such\nactivities were pre-approved and conform to the ship\u2019s operational documentation. The risk\nassessment, including the applicable mitigation measures, should be recorded in the ship\u2019s\noperational documentation." },
        React__default.createElement(ChecklistTable, __assign({ className: "checklist-TR56-b", checkListName: "checklistB" }, props)),
        React__default.createElement(SimOpsComponent, { authenticationService: props.authenticationService, simOpsTitle: 'Agreed simultaneous operations', description: 'The risk assessment, including the applicable mitigation measures, should be recorded in the ship’s operational  documentation  and  revised  in  light  of  the  current  situation.  The  necessary  mitigation measures should be in place. ', simOpsType: 'bunkerSimops', activityTitle: 'Activity', changeSimOpsData: changeSimOpsData, simOpsValues: props.safetyChecklist.bunkerSimops, addNewSimOpRow: addNewSimOpRow, readOnly: props.readOnly, nominationId: props.nominationId, setEditingChecklistValue: props.setEditingChecklistValue, userRoles: props.userRoles }),
        React__default.createElement(SimOpsComponent, { authenticationService: props.authenticationService, simOpsTitle: 'Restrictions in LNG bunker/cargo operations', simOpsType: 'simopsRestrictions', activityTitle: 'Activity', changeSimOpsData: changeSimOpsData, simOpsValues: props.safetyChecklist.simopsRestrictions, addNewSimOpRow: addNewSimOpRow, readOnly: props.readOnly, nominationId: props.nominationId, setEditingChecklistValue: props.setEditingChecklistValue, userRoles: props.userRoles })));
    function changeSimOpsData(simOpsType, fieldName, itemNumber, value) {
        var path = simOpsType + "[" + itemNumber + "]." + fieldName;
        props.onChangeFormValue(path, value);
    }
    function addNewSimOpRow(simOpscheckListType, itemNumber) {
        return __awaiter(this, void 0, void 0, function () {
            var backendSimOpsType, newSimOpsRow, path, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        backendSimOpsType = getBackendSimOpsType(simOpscheckListType);
                        return [4 /*yield*/, addSafetyChecklistSimOpsCheck(props.authenticationService, props.nominationId, backendSimOpsType)];
                    case 1:
                        newSimOpsRow = _a.sent();
                        path = simOpscheckListType + "[" + itemNumber + "]";
                        props.onChangeFormValue(path, newSimOpsRow);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        handleFetchError(error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    function getBackendSimOpsType(simOpsType) {
        switch (simOpsType) {
            case 'bunkerSimops':
                return 'BUNKER';
            case 'cargoSimops':
                return 'CARGO';
            case 'simopsRestrictions':
                return 'RESTRICTIONS';
            default:
                return 'BUNKER';
        }
    }
};

var IAPHv2ChecklistTable = function (props) {
    var _a;
    var chunkedPart = (_a = props.safetyChecklist) === null || _a === void 0 ? void 0 : _a[props.checklist].reduce(function (resultArray, item, index) {
        if (item.idx === '1') {
            resultArray[resultArray.length] = []; // start a new chunk
        }
        resultArray[resultArray.length - 1].push(item);
        return resultArray;
    }, []);
    var totalItemsMapped = 0;
    return (React__default.createElement(React__default.Fragment, null, chunkedPart.map(function (checklist, i) {
        var isForBunkership = checklist.find(function (it) { return it.bunkerShip !== ChecklistValue.NOT_APPLICABLE; });
        var isForReceivingship = checklist.find(function (it) { return it.receivingShip !== ChecklistValue.NOT_APPLICABLE; });
        var titleSubject = isForBunkership
            ? 'bunker vessel'
            : isForReceivingship
                ? 'receiving vessel'
                : namingIAPHv2Externalparty(props.safetyChecklist.type);
        return (React__default.createElement(ChecklistWrapper, { title: "" + props.part + (i + 1) + " " + props.title + " - PIC " + titleSubject }, !isForBunkership && !isForReceivingship ? (React__default.createElement("span", { className: "span-message-no-user-in-system" },
            "Filled in by the ",
            titleSubject)) : (React__default.createElement("table", { className: "flexeble-checklist checklist-gothenburg-b1" },
            React__default.createElement("thead", null,
                React__default.createElement("tr", null,
                    React__default.createElement("th", null, "No."),
                    React__default.createElement("th", null, "Check"),
                    isForReceivingship && React__default.createElement("th", null, "Receiving Vessel"),
                    isForBunkership && React__default.createElement("th", null, "Bunker Vessel"),
                    React__default.createElement("th", null, "Code"),
                    React__default.createElement("th", null, "Remarks"),
                    React__default.createElement("th", null))),
            React__default.createElement("tbody", null, checklist.map(function (checkItem) {
                totalItemsMapped++;
                return (React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(ChecklistItemComponent, { authenticationService: props.authenticationService, key: "checklist-item-" + checkItem._id, item: checkItem, changeValue: changeValue, itemNumber: totalItemsMapped - 1, checklistName: props.checklist, readOnly: false, nominationId: props.nominationId, userRoles: props.userRoles, setEditingChecklistValue: props.setEditingChecklistValue, disableBunkership: !isForBunkership, disableReceivingship: !isForReceivingship, safetyChecklistType: props.safetyChecklist.type })));
            }))))));
    })));
    function changeValue(fieldName, value, itemNumber, checklistName) {
        var path = checklistName + "[" + itemNumber + "]." + fieldName;
        props.onChangeFormValue(path, value);
    }
};

var ChecklistPartB = function (props) {
    return (React__default.createElement(IAPHv2ChecklistTable, __assign({}, props, { part: "Part B", title: "Pre-operation", checklist: "checklistB" })));
};

var ChecklistPartC = function (props) {
    return (React__default.createElement(ChecklistWrapper, { title: "Part C - Pre transfer checklist", description: "(If applicable this part should be completed before actual transfer operations start)" },
        React__default.createElement(ChecklistTable, __assign({ className: "checklist-TR56-c", checkListName: "checklistC" }, props))));
};

var UnitSelection = function (props) {
    var pressureUnit = props.transferData.pressureUnit || SafetyChecklistPressureUnit.BAR;
    var quantityUnit = props.transferData.quantityUnit || QuantityUnit.CUBIC_METERS;
    var temperatureUnit = props.transferData.temperatureUnit || TemperatureUnit.CELSIUS;
    return (React__default.createElement("div", { className: "unit-selection-wrapper" },
        React__default.createElement("div", { className: "unit-select" },
            React__default.createElement("div", { className: "select-title" }, "Pressure Unit:"),
            React__default.createElement(Checkbox, { label: 'bar', field: 'bar', value: pressureUnit === SafetyChecklistPressureUnit.BAR, onChange: function () {
                    changeBunkerOperationsTransferUnit('pressureUnit', SafetyChecklistPressureUnit.BAR);
                }, disabled: props.readOnly }),
            React__default.createElement(Checkbox, { label: 'psi', field: 'psi', value: pressureUnit === SafetyChecklistPressureUnit.PSI, onChange: function () {
                    changeBunkerOperationsTransferUnit('pressureUnit', SafetyChecklistPressureUnit.PSI);
                }, disabled: props.readOnly })),
        React__default.createElement("div", { className: "unit-select" },
            React__default.createElement("div", { className: "select-title" }, "Quantity Unit:"),
            React__default.createElement(Checkbox, { label: "m3", field: 'm3', value: quantityUnit === QuantityUnit.CUBIC_METERS, onChange: function () {
                    changeBunkerOperationsTransferUnit('quantityUnit', QuantityUnit.CUBIC_METERS);
                }, disabled: props.readOnly }),
            React__default.createElement(Checkbox, { label: "mt", field: 'mt', value: quantityUnit === QuantityUnit.TONNES, onChange: function () {
                    changeBunkerOperationsTransferUnit('quantityUnit', QuantityUnit.TONNES);
                }, disabled: props.readOnly })),
        React__default.createElement("div", { className: "unit-select" },
            React__default.createElement("div", { className: "select-title" }, "Temperature Unit:"),
            React__default.createElement(Checkbox, { label: String.fromCharCode(176) + "C", field: 'c', value: temperatureUnit === TemperatureUnit.CELSIUS, onChange: function () {
                    changeBunkerOperationsTransferUnit('temperatureUnit', TemperatureUnit.CELSIUS);
                }, disabled: props.readOnly }),
            React__default.createElement(Checkbox, { label: String.fromCharCode(176) + "F", field: 'f', value: temperatureUnit === TemperatureUnit.FAHRENHEIT, onChange: function () {
                    changeBunkerOperationsTransferUnit('temperatureUnit', TemperatureUnit.FAHRENHEIT);
                }, disabled: props.readOnly }))));
    function changeBunkerOperationsTransferUnit(key, value) {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        props.changeTransferUnit(key, value);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, setSafetyChecklisTransferData(props.authenticationService, props.nominationId, (_a = {},
                                _a[key] = value,
                                _a))];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _b.sent();
                        handleFetchError(error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
};

var TankFactsheet = function (props) {
    var tanks = props.tanks || 4;
    if (tanks > 4) {
        return React__default.createElement("div", null, "Can not have more than 4 tanks");
    }
    var renderField = function (index, field) {
        var _a, _b, _c, _d;
        return (React__default.createElement("td", null,
            React__default.createElement("input", { type: "text", className: "table-text-input padded-td", value: ((_d = (_c = (_b = (_a = props.safetyChecklist) === null || _a === void 0 ? void 0 : _a[props.dataLocation]) === null || _b === void 0 ? void 0 : _b[props.field.toString()]) === null || _c === void 0 ? void 0 : _c[index]) === null || _d === void 0 ? void 0 : _d[field]) || '', onChange: function (e) {
                    props.setEditingChecklistValue(true);
                    props.onChangeFormValue(props.dataLocation + "." + props.field.toString() + ".[" + index + "]." + field.toString(), e.target.value);
                }, disabled: props.readOnly, onBlur: function () {
                    props.handleSubmit();
                    props.setEditingChecklistValue(false);
                } })));
    };
    return (React__default.createElement("div", { className: "table-wrapper" },
        React__default.createElement("h4", { className: "checklist-section-header" }, props.title),
        React__default.createElement("table", null,
            React__default.createElement("thead", null,
                React__default.createElement("tr", null,
                    React__default.createElement("th", null),
                    __spreadArrays(Array(tanks)).map(function (_, i) { return (React__default.createElement("th", { key: "bunkering-operations-th-" + i },
                        "Tank ",
                        i + 1)); }),
                    React__default.createElement("th", null))),
            React__default.createElement("tbody", null, props.tableItems.map(function (item) { return (React__default.createElement("tr", null,
                React__default.createElement("td", { className: "padded-td checklist-question" }, item.label),
                __spreadArrays(Array(tanks)).map(function (_, i) { return renderField(i, item.field); }),
                React__default.createElement("td", { className: "padded-td physical-unit" },
                    item.unitType &&
                        props.getTransferDataUnit(item.unitType, props.safetyChecklist.transferData),
                    item.additionalUnit))); })))));
};

var AgreedTransferData = function (props) {
    var handleAgreedTransferDataBooleanChange = function (field, value) {
        var _a;
        props.changeValue("agreedTransferData." + field, value);
        props.handleSubmit(__assign(__assign({}, props.safetyChecklist.transferData), { agreedTransferData: __assign(__assign({}, props.safetyChecklist.transferData.agreedTransferData), (_a = {}, _a[field] = value, _a)) }));
    };
    var renderInput = function (item) {
        var _a, _b, _c, _d;
        if (item.field === 'sufficientCapacityCheckBunker')
            return (React__default.createElement(React__default.Fragment, null,
                React__default.createElement("td", { className: "centered-table-box safety-checklist-checkbox " },
                    React__default.createElement(SafetyChecklistCheckBox, { checkboxValue: ((_a = props.safetyChecklist.transferData.agreedTransferData) === null || _a === void 0 ? void 0 : _a.sufficientCapacityReceiving) ? ChecklistValue.CHECKED
                            : ChecklistValue.BLANK, readOnly: shouldFieldBeReadOnly(props.readOnly, 'receivingShip', props.userRoles), onChange: function (value) {
                            handleAgreedTransferDataBooleanChange('sufficientCapacityReceiving', value === ChecklistValue.CHECKED ? true : false);
                        } })),
                React__default.createElement("td", { className: "centered-table-box safety-checklist-checkbox " },
                    React__default.createElement(SafetyChecklistCheckBox, { checkboxValue: ((_b = props.safetyChecklist.transferData.agreedTransferData) === null || _b === void 0 ? void 0 : _b.sufficientCapacityCheckBunker) ? ChecklistValue.CHECKED
                            : ChecklistValue.BLANK, readOnly: shouldFieldBeReadOnly(props.readOnly, 'bunkerShip', props.userRoles), onChange: function (value) {
                            handleAgreedTransferDataBooleanChange('sufficientCapacityCheckBunker', value === ChecklistValue.CHECKED ? true : false);
                        } }))));
        return (React__default.createElement("td", { colSpan: 2 },
            React__default.createElement("textarea", { className: "additional-remark", onChange: function (e) {
                    props.setEditingChecklistValue(true);
                    props.changeValue("agreedTransferData." + item.field, e.target.value);
                }, defaultValue: ((_d = (_c = props.safetyChecklist.transferData.agreedTransferData) === null || _c === void 0 ? void 0 : _c[item.field]) === null || _d === void 0 ? void 0 : _d.toString()) || '', onBlur: function (e) {
                    var _a;
                    var newTransferData = props.safetyChecklist.transferData;
                    newTransferData.agreedTransferData = __assign(__assign({}, newTransferData.agreedTransferData), (_a = {}, _a[item.field] = e.target.value, _a));
                    props.handleSubmit(newTransferData);
                    props.setEditingChecklistValue(false);
                } })));
    };
    return (React__default.createElement("table", null,
        React__default.createElement("thead", null,
            React__default.createElement("tr", null,
                React__default.createElement("th", null),
                React__default.createElement("th", null, "Agreed transfer data"),
                React__default.createElement("th", null, "Receiving vessel"),
                React__default.createElement("th", null, "Bunker vessel"),
                React__default.createElement("th", null))),
        React__default.createElement("tbody", null, props.tableItems.map(function (item, index) { return (React__default.createElement("tr", null,
            React__default.createElement("td", { className: "number-box" }, index + 2),
            React__default.createElement("td", { className: "checklist-question padded-td" }, item.label),
            renderInput(item),
            React__default.createElement("td", { className: "padded-td physical-unit" },
                item.unitType
                    ? getTransferDataUnit(item.unitType, props.safetyChecklist.transferData)
                    : '',
                item.additionalUnit))); }))));
};

var ChecklistPartC$1 = function (props) {
    var agreedTransferData = getTransferDataTableInformation(props.safetyChecklist.transferData.physicalQuantityUnit || '');
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(ChecklistWrapper, { title: "Part C1\n      Alignment and Agreement -\n      PICs bunker vessel, receiving vessel, " + namingIAPHv2Externalparty(props.safetyChecklist.type), description: "(If applicable this part should be completed before actual transfer operations start)" },
            React__default.createElement(ChecklistTable, __assign({ className: "checklist-iaph-v1-c", checkListName: "checklistC" }, props))),
        React__default.createElement(ChecklistWrapper, { title: "Part C2\n      Alignment and Agreement - PICs bunker and receiving vessel", description: "(If applicable this part should be completed before actual transfer operations start)" },
            React__default.createElement("table", { className: "flexeble-checklist" },
                React__default.createElement("thead", null,
                    React__default.createElement("tr", null,
                        React__default.createElement("th", null, "C2"),
                        React__default.createElement("th", null, "Reference to check"),
                        React__default.createElement("th", null, "Description"),
                        React__default.createElement("th", null, "Agreement"))),
                React__default.createElement(PartC2AgreementTd, __assign({}, props)))),
        React__default.createElement(ChecklistWrapper, { title: "Part C3\n        Alignment and Agreement - PIC bunker vessel", description: "Tank factsheet bunker vessel" },
            React__default.createElement(UnitSelection, { readOnly: props.readOnly, changeTransferUnit: changeTransferUnit, transferData: props.safetyChecklist.transferData, authenticationService: props.authenticationService, nominationId: props.nominationId }),
            React__default.createElement(TankFactsheet, __assign({}, props, { dataLocation: "transferData", field: "bunkerStartData", title: "Status prior to bunker operations", tableItems: IAPH_V2_TANK_FACT_SHEET, getTransferDataUnit: getTransferDataUnit, handleSubmit: props.handleSubmit }))),
        React__default.createElement(ChecklistWrapper, { title: "Part C4\n        Alignment and Agreement - PIC receiving vessel", description: "Tank factsheet receiving vessel" },
            React__default.createElement(TankFactsheet, __assign({}, props, { dataLocation: "transferData", field: "shipStartData", title: "Status prior to bunker operations", tableItems: IAPH_V2_TANK_FACT_SHEET_RECEIVING, getTransferDataUnit: getTransferDataUnit, handleSubmit: props.handleSubmit }))),
        React__default.createElement(ChecklistWrapper, { title: "Part C5\n        Alignment and Agreement - PICs bunker and receiving vessel", description: "Transfer Data" },
            React__default.createElement(PQUField, { unit: props.safetyChecklist.transferData.physicalQuantityUnit || '', readOnly: props.readOnly, updateUnitValue: function (v) {
                    changeTransferUnit('physicalQuantityUnit', v);
                    // TODO: Add correct endpoint for this
                    var newTransferData = __assign(__assign({}, props.safetyChecklist.transferData), { physicalQuantityUnit: v });
                    handleTransferDataSubmit(newTransferData);
                } }),
            React__default.createElement(AgreedTransferData, { tableItems: agreedTransferData, changeValue: changeTransferUnit, safetyChecklist: props.safetyChecklist, setEditingChecklistValue: props.setEditingChecklistValue, handleSubmit: handleTransferDataSubmit, userRoles: props.userRoles, readOnly: props.readOnly }),
            React__default.createElement(SimOpsComponent, { authenticationService: props.authenticationService, simOpsTitle: 'Agreed simultaneous LNG bunker / Oil bunker operations', simOpsType: 'bunkerSimops', activityTitle: 'Oil bunker activity', changeSimOpsData: changeSimOpsData, simOpsValues: props.safetyChecklist.bunkerSimops, addNewSimOpRow: addNewSimOpRow, readOnly: props.readOnly, nominationId: props.nominationId, setEditingChecklistValue: props.setEditingChecklistValue, userRoles: props.userRoles }),
            React__default.createElement(SimOpsComponent, { authenticationService: props.authenticationService, simOpsTitle: 'Agreed simultaneous bunker / Cargo operations', simOpsType: 'cargoSimops', activityTitle: 'Cargo activity', changeSimOpsData: changeSimOpsData, simOpsValues: props.safetyChecklist.cargoSimops, addNewSimOpRow: addNewSimOpRow, readOnly: props.readOnly, nominationId: props.nominationId, setEditingChecklistValue: props.setEditingChecklistValue, userRoles: props.userRoles }),
            React__default.createElement(SimOpsComponent, { authenticationService: props.authenticationService, simOpsTitle: 'Restrictions in LNG bunker / Cargo operations', simOpsType: 'simopsRestrictions', activityTitle: 'Restricted activity', changeSimOpsData: changeSimOpsData, simOpsValues: props.safetyChecklist.simopsRestrictions, addNewSimOpRow: addNewSimOpRow, readOnly: props.readOnly, nominationId: props.nominationId, setEditingChecklistValue: props.setEditingChecklistValue, userRoles: props.userRoles }))));
    function handleTransferDataSubmit(transferData) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, setSafetyChecklisTransferData(props.authenticationService, props.nominationId, transferData)];
                    case 1:
                        _a.sent();
                        props.setEditingChecklistValue(false);
                        return [2 /*return*/];
                }
            });
        });
    }
    function changeTransferUnit(fieldName, value) {
        var path = "transferData." + fieldName;
        props.onChangeFormValue(path, value);
    }
    function changeSimOpsData(simOpsType, fieldName, itemNumber, value) {
        var path = simOpsType + "[" + itemNumber + "]." + fieldName;
        props.onChangeFormValue(path, value);
    }
    function addNewSimOpRow(simOpscheckListType, itemNumber) {
        return __awaiter(this, void 0, void 0, function () {
            var backendSimOpsType, newSimOpsRow, path, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        backendSimOpsType = getBackendSimOpsType(simOpscheckListType);
                        return [4 /*yield*/, addSafetyChecklistSimOpsCheck(props.authenticationService, props.nominationId, backendSimOpsType)];
                    case 1:
                        newSimOpsRow = _a.sent();
                        path = simOpscheckListType + "[" + itemNumber + "]";
                        props.onChangeFormValue(path, newSimOpsRow);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        handleFetchError(error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
};
var PartC2AgreementTd = function (props) {
    var _a;
    return (React__default.createElement("tbody", null, (_a = props.safetyChecklist.alignmentC) === null || _a === void 0 ? void 0 : _a.map(function (item) { return (React__default.createElement("tr", { key: "c2-key-tr-" + item._id },
        React__default.createElement("td", { className: "number-box" }, item.idx),
        React__default.createElement("td", { className: "code-box" }, item.reference),
        React__default.createElement("td", { className: "checklist-question padded-td" }, item.description),
        React__default.createElement("td", null,
            React__default.createElement(SafetyChecklistRemark, { remark: item.agreement, setEditingChecklistValue: function () { }, remarkValues: item.agreementInput, setRemarkValues: function (remarksInput) {
                    updateAlignmentAgreement(props.authenticationService, item.agreement, getBackendChecklistTypeValue('checklistC'), item._id, props.nominationId, remarksInput);
                    props.setEditingChecklistValue(false);
                }, readonly: false, notApplicable: null, uniqueIdPrefix: item._id, setNotApplicable: function () { return []; } })))); })));
};

var ChecklistPartD$1 = function (props) {
    return (React__default.createElement(IAPHv2ChecklistTable, __assign({}, props, { part: "Part D", title: "Connection Testing", checklist: "checklistD" })));
};

var ChecklistPartF = function (props) {
    return (React__default.createElement(IAPHv2ChecklistTable, __assign({}, props, { part: "Part F", title: "Post-operation", checklist: "checklistF" })));
};

var GothenburgChecklistPartC = function (props) {
    return (React__default.createElement(ChecklistWrapper, { title: "Part C - Pre berthing" },
        React__default.createElement(ChecklistTable, __assign({ className: "checklist-gothenburg-c", checkListName: "checklistC" }, props))));
};

var ChecklistPartC$2 = function (props) {
    return (React__default.createElement(ChecklistWrapper, { title: "PART C \u2013 Pre-transfer checklist", subTitle: "(This mandatory part should be completed before actual transfer operations start)", description: "This checklist identifies the required physical checks and elements that are verified\nverbally before the LNG bunkering commences. The safety of operations requires that all\nrelevant statements are considered and the associated responsibility and accountability for\ncompliance is accepted, either jointly or singly as agreed to by the parties.Where either\nparty is not prepared to accept an assigned accountability, a comment must be made in the\nRemarks column and due consideration should be given to assessing whether operations can\nproceed.Where a particular item is considered to be not applicable to the any one party, a\nnote to this effect should be entered in the Remarks column." },
        React__default.createElement(ChecklistTable, __assign({ className: "checklist-TR56-c", checkListName: "checklistC" }, props))));
};

var BunkerOperationsTable = function (props) {
    var tanks = props.tanks || 4;
    if (tanks > 4) {
        return React__default.createElement("div", null, "Can not have more than 4 tanks");
    }
    var renderField = function (index, field) {
        var _a, _b;
        var tank = getTankFieldName(index + 1);
        return (React__default.createElement("td", null,
            React__default.createElement("input", { type: "text", className: "table-text-input padded-td", value: ((_b = (_a = props.transferData) === null || _a === void 0 ? void 0 : _a[tank]) === null || _b === void 0 ? void 0 : _b[field]) || '', onChange: function (e) {
                    props.setEditingChecklistValue(true);
                    props.changeTransferData(tank, field, e.target.value);
                }, disabled: props.readOnly, onBlur: function () {
                    saveBunkerOperationsData(tank);
                } })));
    };
    return (React__default.createElement("div", { className: "table-wrapper" },
        React__default.createElement("h4", { className: "checklist-section-header" }, "Agreed bunker operations"),
        React__default.createElement("table", null,
            React__default.createElement("thead", null,
                React__default.createElement("tr", null,
                    React__default.createElement("th", null),
                    __spreadArrays(Array(tanks)).map(function (_, i) { return (React__default.createElement("th", { key: "bunkering-operations-th-" + i },
                        "Tank ",
                        i + 1)); }),
                    React__default.createElement("th", null))),
            React__default.createElement("tbody", null, props.tableItems.map(function (item) { return (React__default.createElement("tr", null,
                React__default.createElement("td", { className: "padded-td checklist-question" }, item.label),
                __spreadArrays(Array(tanks)).map(function (_, i) { return renderField(i, item.field); }),
                React__default.createElement("td", { className: "padded-td physical-unit" },
                    item.unitType && props.getTransferDataUnit(item.unitType, props.transferData),
                    item.additionalUnit))); })))));
    function saveBunkerOperationsData(tank) {
        return __awaiter(this, void 0, void 0, function () {
            var tankData, error_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        tankData = get(props.transferData, [tank], '');
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, setSafetyChecklisTransferData(props.authenticationService, props.nominationId, (_a = {},
                                _a[tank] = tankData,
                                _a))];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _b.sent();
                        handleFetchError(error_1);
                        return [3 /*break*/, 4];
                    case 4:
                        props.setEditingChecklistValue(false);
                        return [2 /*return*/];
                }
            });
        });
    }
};

var MinMaxTable = function (props) {
    var renderField = function (minMax, field, disable) {
        var _a, _b;
        return (React__default.createElement("td", null,
            React__default.createElement("input", { type: "text", className: "table-text-input padded-td " + ((props.readOnly || disable) && 'grayed-out-input'), value: ((_b = (_a = props.transferData) === null || _a === void 0 ? void 0 : _a[minMax]) === null || _b === void 0 ? void 0 : _b[field]) || '', onChange: function (e) {
                    props.setEditingChecklistValue(true);
                    props.changeTransferData(minMax, field, e.target.value);
                }, readOnly: props.readOnly || disable, onBlur: function () {
                    saveMinMaxValues(minMax);
                } })));
    };
    return (React__default.createElement("div", { className: "table-wrapper" },
        React__default.createElement("h4", { className: "checklist-section-header" }, "Agreed maximums and minimums"),
        React__default.createElement("table", null,
            React__default.createElement("thead", null,
                React__default.createElement("tr", null,
                    React__default.createElement("th", null),
                    React__default.createElement("th", null, "Maximum"),
                    React__default.createElement("th", null, "Minimum"),
                    React__default.createElement("th", null))),
            React__default.createElement("tbody", null, props.tableItems.map(function (item) {
                var _a, _b;
                return (React__default.createElement("tr", null,
                    React__default.createElement("td", { className: "padded-td checklist-question" }, item.label),
                    renderField('max', item.field, (_a = item.disable) === null || _a === void 0 ? void 0 : _a.max),
                    renderField('min', item.field, (_b = item.disable) === null || _b === void 0 ? void 0 : _b.min),
                    React__default.createElement("td", { className: "padded-td physical-unit" },
                        item.unitType && props.getTransferDataUnit(item.unitType, props.transferData),
                        item.additionalUnit)));
            })))));
    function saveMinMaxValues(limitsField) {
        return __awaiter(this, void 0, void 0, function () {
            var tankData, error_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        tankData = get(props.transferData, [limitsField], '');
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, setSafetyChecklisTransferData(props.authenticationService, props.nominationId, (_a = {},
                                _a[limitsField] = tankData,
                                _a))];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _b.sent();
                        handleFetchError(error_1);
                        return [3 /*break*/, 4];
                    case 4:
                        props.setEditingChecklistValue(false);
                        return [2 /*return*/];
                }
            });
        });
    }
};

var PressureTemperatureTable = function (props) {
    var renderField = function (transferDataType, index, StartDataKey) {
        var _a, _b, _c;
        return (React__default.createElement("td", null,
            React__default.createElement("input", { type: "text", className: "table-text-input padded-td", value: ((_c = (_b = (_a = props.transferData) === null || _a === void 0 ? void 0 : _a[transferDataType]) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c[StartDataKey]) || '', onChange: function (e) {
                    props.setEditingChecklistValue(true);
                    props.changeTransferData(transferDataType, index, StartDataKey, e.target.value);
                }, disabled: props.readOnly, onBlur: function () {
                    savePressureAndTemperatureData();
                } })));
    };
    return (React__default.createElement("div", { className: "table-wrapper" },
        React__default.createElement("h4", { className: "checklist-section-header" }, "Agreed starting temperatures and pressures"),
        React__default.createElement("table", { className: "pressure-temperature-table" },
            React__default.createElement("thead", null,
                React__default.createElement("tr", null,
                    React__default.createElement("th", { className: "item-name" }),
                    React__default.createElement("th", { className: "item-receiving-vessel", colSpan: props.receivingVesselColumn || 1 }, "Receiving Vessel"),
                    React__default.createElement("th", { className: "item-bunker-vessel", colSpan: props.bunkerVesselColumn || 1 }, "LNG Bunker Vessel"),
                    React__default.createElement("th", null))),
            React__default.createElement("tbody", null, props.tableItems.map(function (item) { return (React__default.createElement("tr", null,
                React__default.createElement("td", { className: "padded-td checklist-question" }, item.label),
                __spreadArrays(Array(props.receivingVesselColumn || 1)).map(function (_, i) {
                    return renderField('shipStartData', i, item.field);
                }),
                __spreadArrays(Array(props.bunkerVesselColumn || 1)).map(function (_, i) {
                    return renderField('bunkerStartData', i, item.field);
                }),
                React__default.createElement("td", { className: "padded-td physical-unit" }, props.getTransferDataUnit(item.unitType, props.transferData)))); })))));
    function savePressureAndTemperatureData() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, setSafetyChecklisTransferData(props.authenticationService, props.nominationId, {
                                bunkerStartData: (_a = props.transferData) === null || _a === void 0 ? void 0 : _a.bunkerStartData,
                                shipStartData: (_b = props.transferData) === null || _b === void 0 ? void 0 : _b.shipStartData
                            })];
                    case 1:
                        _c.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _c.sent();
                        handleFetchError(error_1);
                        return [3 /*break*/, 3];
                    case 3:
                        props.setEditingChecklistValue(false);
                        return [2 /*return*/];
                }
            });
        });
    }
};

var ChecklistPartD$2 = function (props) {
    return (React__default.createElement(ChecklistWrapper, { title: "Part D - LNG transfer data and simultaneous operations", description: "(If applicable this part should be completed before actual transfer operations start)" },
        React__default.createElement(UnitSelection, { readOnly: props.readOnly, changeTransferUnit: changeTransferUnit, transferData: props.safetyChecklist.transferData, authenticationService: props.authenticationService, nominationId: props.nominationId }),
        React__default.createElement(PressureTemperatureTable, { authenticationService: props.authenticationService, transferData: props.safetyChecklist.transferData, changeTransferData: changeTransferArrayData, readOnly: props.readOnly, setEditingChecklistValue: props.setEditingChecklistValue, nominationId: props.nominationId, getTransferDataUnit: getTransferDataUnit, tableItems: PressureTemperatureTableItems }),
        React__default.createElement(BunkerOperationsTable, { authenticationService: props.authenticationService, transferData: props.safetyChecklist.transferData, changeTransferData: changeTransferData, readOnly: props.readOnly, nominationId: props.nominationId, setEditingChecklistValue: props.setEditingChecklistValue, getTransferDataUnit: getTransferDataUnit, tableItems: BunkerOperationsTableItems }),
        React__default.createElement(MinMaxTable, { authenticationService: props.authenticationService, transferData: props.safetyChecklist.transferData, changeTransferData: changeTransferData, readOnly: props.readOnly, nominationId: props.nominationId, setEditingChecklistValue: props.setEditingChecklistValue, getTransferDataUnit: getTransferDataUnit, tableItems: MinMaxTableItems }),
        props.simOpsEnabled !== false && (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(SimOpsComponent, { authenticationService: props.authenticationService, simOpsTitle: 'Agreed simultaneous LNG bunker / Oil bunker operations', simOpsType: 'bunkerSimops', activityTitle: 'Oil bunker activity', changeSimOpsData: changeSimOpsData, simOpsValues: props.safetyChecklist.bunkerSimops, addNewSimOpRow: addNewSimOpRow, readOnly: props.readOnly, nominationId: props.nominationId, setEditingChecklistValue: props.setEditingChecklistValue, userRoles: props.userRoles }),
            React__default.createElement(SimOpsComponent, { authenticationService: props.authenticationService, simOpsTitle: 'Agreed simultaneous bunker / Cargo operations', simOpsType: 'cargoSimops', activityTitle: 'Cargo activity', changeSimOpsData: changeSimOpsData, simOpsValues: props.safetyChecklist.cargoSimops, addNewSimOpRow: addNewSimOpRow, readOnly: props.readOnly, nominationId: props.nominationId, setEditingChecklistValue: props.setEditingChecklistValue, userRoles: props.userRoles }),
            React__default.createElement(SimOpsComponent, { authenticationService: props.authenticationService, simOpsTitle: 'Restrictions in LNG bunker / Cargo operations', simOpsType: 'simopsRestrictions', activityTitle: 'Restricted activity', changeSimOpsData: changeSimOpsData, simOpsValues: props.safetyChecklist.simopsRestrictions, addNewSimOpRow: addNewSimOpRow, readOnly: props.readOnly, nominationId: props.nominationId, setEditingChecklistValue: props.setEditingChecklistValue, userRoles: props.userRoles })))));
    function changeTransferArrayData(transferDateType, index, fieldName, value) {
        var path = "transferData." + transferDateType + "[" + index + "]." + fieldName;
        props.onChangeFormValue(path, value);
    }
    function changeTransferData(transferDateType, fieldName, value) {
        var path = "transferData." + transferDateType + "." + fieldName;
        props.onChangeFormValue(path, value);
    }
    function changeTransferUnit(fieldName, value) {
        var path = "transferData." + fieldName;
        props.onChangeFormValue(path, value);
    }
    function changeSimOpsData(simOpsType, fieldName, itemNumber, value) {
        var path = simOpsType + "[" + itemNumber + "]." + fieldName;
        props.onChangeFormValue(path, value);
    }
    function addNewSimOpRow(simOpscheckListType, itemNumber) {
        return __awaiter(this, void 0, void 0, function () {
            var backendSimOpsType, newSimOpsRow, path, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        backendSimOpsType = getBackendSimOpsType(simOpscheckListType);
                        return [4 /*yield*/, addSafetyChecklistSimOpsCheck(props.authenticationService, props.nominationId, backendSimOpsType)];
                    case 1:
                        newSimOpsRow = _a.sent();
                        path = simOpscheckListType + "[" + itemNumber + "]";
                        props.onChangeFormValue(path, newSimOpsRow);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        handleFetchError(error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
};

var GothenburgChecklistPartD = function (props) {
    return (React__default.createElement(ChecklistWrapper, { title: "Part D - Checks after arrival pre LNG bunkering" },
        React__default.createElement(ChecklistTable, __assign({ className: "checklist-gothenburg-d", checkListName: "checklistD" }, props))));
};

var ChecklistPartD$3 = function (props) {
    var _a = useState(props.safetyChecklist.transferData.density || ''), density = _a[0], setDensity = _a[1];
    var _b = useState(false), densityUpdating = _b[0], setDensityUpdating = _b[1];
    useEffect(function () {
        if (!densityUpdating && props.safetyChecklist.transferData.density) {
            setDensity(props.safetyChecklist.transferData.density);
        }
    }, [props.safetyChecklist.transferData.density]);
    return (React__default.createElement(ChecklistWrapper, { title: "PART D \u2013 LNG transfer data", subTitle: "(This part should be completed before actual transfer operations start)", description: " LNG transfer data contains the transfer data to be agreed upon. In this section the\ninformation over temperature, density, volume, transfer rate, pressure and the physical\nquantity unit to be used for the LNG bunkering, are exchanged and agreed upon by the\nparties." },
        React__default.createElement("div", { className: "title-description physical-quantity" },
            React__default.createElement("div", { className: "density-field" },
                React__default.createElement(FormElement, null,
                    React__default.createElement(FormLabel, { fieldName: "Density" }, "Density"),
                    React__default.createElement(TextField, { fieldName: "Density", placeholder: "____________________", value: density || '', disabled: props.readOnly, onChange: function (e) {
                            setDensity(e.target.value);
                            setDensityUpdating(true);
                        }, onBlur: function (e) { return changeBunkerOperationsTransferDensity("density", e.target.value); } })))),
        React__default.createElement(UnitSelection, { readOnly: props.readOnly, changeTransferUnit: changeTransferUnit, transferData: props.safetyChecklist.transferData, authenticationService: props.authenticationService, nominationId: props.nominationId }),
        React__default.createElement(PressureTemperatureTable, { authenticationService: props.authenticationService, transferData: props.safetyChecklist.transferData, changeTransferData: changeTransferArrayData, readOnly: props.readOnly, setEditingChecklistValue: props.setEditingChecklistValue, nominationId: props.nominationId, getTransferDataUnit: getTransferDataUnit, receivingVesselColumn: 2, tableItems: PressureTemperatureTableItems }),
        React__default.createElement(BunkerOperationsTable, { authenticationService: props.authenticationService, transferData: props.safetyChecklist.transferData, changeTransferData: changeTransferData, readOnly: props.readOnly, nominationId: props.nominationId, setEditingChecklistValue: props.setEditingChecklistValue, getTransferDataUnit: getTransferDataUnit, tableItems: TR56BunkerOperationsTableItems, tanks: 2 }),
        React__default.createElement(MinMaxTable, { authenticationService: props.authenticationService, transferData: props.safetyChecklist.transferData, changeTransferData: changeTransferData, readOnly: props.readOnly, nominationId: props.nominationId, setEditingChecklistValue: props.setEditingChecklistValue, getTransferDataUnit: getTransferDataUnit, tableItems: TR56MinMaxTableItems })));
    function changeTransferArrayData(transferDateType, index, fieldName, value) {
        var path = "transferData." + transferDateType + "[" + index + "]." + fieldName;
        props.onChangeFormValue(path, value);
    }
    function changeTransferUnit(fieldName, value) {
        var path = "transferData." + fieldName;
        props.onChangeFormValue(path, value);
    }
    function changeTransferData(transferDateType, fieldName, value) {
        var path = "transferData." + transferDateType + "." + fieldName;
        props.onChangeFormValue(path, value);
    }
    function changeBunkerOperationsTransferDensity(key, value) {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, setSafetyChecklisTransferData(props.authenticationService, props.nominationId, (_a = {},
                                _a[key] = value,
                                _a))];
                    case 1:
                        _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _b.sent();
                        handleFetchError(error_1);
                        return [3 /*break*/, 3];
                    case 3:
                        setDensityUpdating(false);
                        return [2 /*return*/];
                }
            });
        });
    }
};

var ChecklistPartE = function (props) {
    return (React__default.createElement(ChecklistWrapper, { title: props.title
            ? props.title
            : "Part E - " + (props.safetyChecklist.type === SafetyChecklistType.GOTHENBURG
                ? 'Checks pre LNG bunkering'
                : 'After LNG transfer checklist'), description: props.description
            ? props.description
            : '(This part should be completed after transfer operations have been completed)', subTitle: props.subTitle },
        React__default.createElement(ChecklistTable, __assign({ className: "checklist-IAPH-gothenburg-e", checkListName: "checklistE" }, props))));
};

var GothenburgChecklistPartF = function (props) {
    return (React__default.createElement(ChecklistWrapper, { title: "Part F - LNG transfer data" },
        React__default.createElement("table", { className: "checklist-gothenburg-f" },
            React__default.createElement("thead", null,
                React__default.createElement("tr", null,
                    React__default.createElement("th", null),
                    React__default.createElement("th", { colSpan: 5 }, "LNG receiving ship"),
                    React__default.createElement("th", { colSpan: 4 }, "LNG bunker vessel"),
                    React__default.createElement("th", null))),
            React__default.createElement("tbody", null,
                React__default.createElement("tr", null,
                    React__default.createElement("td", { className: "checklist-question padded-td" }, "LNG tank temperature"),
                    renderChangebleItem('shipStartData', 0, 'temperature'),
                    renderChangebleItem('shipStartData', 1, 'temperature'),
                    renderChangebleItem('shipStartData', 2, 'temperature'),
                    renderChangebleItem('shipStartData', 3, 'temperature'),
                    renderChangebleItem('shipStartData', 4, 'temperature'),
                    renderChangebleItem('bunkerStartData', 0, 'temperature'),
                    renderChangebleItem('bunkerStartData', 1, 'temperature'),
                    renderChangebleItem('bunkerStartData', 2, 'temperature'),
                    renderChangebleItem('bunkerStartData', 3, 'temperature'),
                    React__default.createElement("td", null, props.transferData.temperatureUnit || '°C')),
                React__default.createElement("tr", null,
                    React__default.createElement("td", { className: "checklist-question padded-td" }, "LNG tank presure"),
                    renderChangebleItem('shipStartData', 0, 'pressure'),
                    renderChangebleItem('shipStartData', 1, 'pressure'),
                    renderChangebleItem('shipStartData', 2, 'pressure'),
                    renderChangebleItem('shipStartData', 3, 'pressure'),
                    renderChangebleItem('shipStartData', 4, 'pressure'),
                    renderChangebleItem('bunkerStartData', 0, 'pressure'),
                    renderChangebleItem('bunkerStartData', 1, 'pressure'),
                    renderChangebleItem('bunkerStartData', 2, 'pressure'),
                    renderChangebleItem('bunkerStartData', 3, 'pressure'),
                    React__default.createElement("td", null, props.transferData.pressureUnit || 'bar'))))));
    function renderChangebleItem(type, index, key) {
        var _this = this;
        var _a, _b, _c;
        var value = (_c = (_b = (_a = props.transferData) === null || _a === void 0 ? void 0 : _a[type]) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c[key];
        return (React__default.createElement("td", null,
            React__default.createElement("input", { type: "text", className: "table-text-input padded-td", value: value ? value : '', disabled: props.readOnly, onChange: function (e) {
                    props.setEditingChecklistValue(true);
                    changeValueOperationsPlan(type, index, key, e.target.value);
                }, onBlur: function (e) { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, setSafetyChecklisTransferData(props.authenticationService, props.nominationId, props.transferData)];
                            case 1:
                                _a.sent();
                                props.setEditingChecklistValue(false);
                                return [2 /*return*/];
                        }
                    });
                }); } })));
    }
    function changeValueOperationsPlan(type, index, fieldName, value) {
        var path = "transferData." + type + "[" + index + "]." + fieldName;
        props.onChangeFormValue(path, value);
    }
};

var PartFGuidelines = function (props) {
    return (React__default.createElement("div", null,
        React__default.createElement("p", null, "This information sheet is used to inform the terminal on the date and time of the LNG bunkering, the involved ships and information with respect to safety."),
        React__default.createElement("p", null, "The appropriate risk mitigation during LNG bunkering should be documented in the Terminal Information Sheet. In the information sheet is stated the terminal should comply with the requirements for risk mitigation during LNG bunkering in the ship\u2019s approved operational documentation."),
        React__default.createElement("p", null, "The PIC of the LNG bunkering and the responsible officer of the LNG receiving vessel should on forehand check the terminal can comply with the required and stated risk mitigation during the LNG bunkering. Appropriate actions should be taken in case the terminal is noncompliant with the required risk mitigation during LNG bunkering."),
        React__default.createElement("p", null, "The terminal should have appropriate procedures in place to comply with the requirements in the ship\u2019s approved operational documentation for incident prevention and mitigation during LNG bunkering. The terminal should also control the terminal activities within the defined control zones as defined in the Terminal Information Sheet. The PIC of the LNG bunkering should be warned by the terminal to take appropriate action if inappropriate activities are performed on the terminal that cannot be avoided or stopped by the terminal."),
        React__default.createElement("p", null, "The terminal should report all unintended events to the competent authorities.")));
};

var ChecklistPartF$1 = function (props) {
    var _a = useState(false), infoDialogActive = _a[0], setInfoDialogActive = _a[1];
    return (React__default.createElement(React__default.Fragment, null,
        infoDialogActive && (React__default.createElement(Dialog, { showDialog: infoDialogActive, title: 'Part F – Terminal information sheet', className: "info-dialog", onCloseDialog: function () {
                setInfoDialogActive(false);
            } },
            React__default.createElement(PartFGuidelines, null))),
        React__default.createElement(ChecklistWrapper, { title: React__default.createElement(React__default.Fragment, null,
                "Part F - Terminal information sheet",
                React__default.createElement(FontAwesomeIcon, { className: "info-icon ", onClick: function () {
                        setInfoDialogActive(true);
                    }, icon: faInfoCircle })), subTitle: "", description: "" },
            React__default.createElement("table", { className: "checklist-IAPH-F" },
                React__default.createElement("thead", null,
                    React__default.createElement("tr", null,
                        React__default.createElement("th", { colSpan: 2 }, "Controlled zones to be established"))),
                React__default.createElement("tbody", null,
                    React__default.createElement("tr", null,
                        React__default.createElement("td", { className: "padded-td checklist-question" },
                            "Hazardous zone description",
                            React__default.createElement("div", { className: "question-description" }, "(Exclusion zone for ignition sources, un-authorized persons and simultaneous operations)")),
                        React__default.createElement("td", null,
                            React__default.createElement("textarea", { className: "full-width-textarea", defaultValue: props.safetyChecklist.hazardousZone, onChange: function (e) {
                                    changePartFValues('hazardousZone', e.target.value);
                                }, disabled: props.readOnly, onBlur: props.handleSubmit }))),
                    React__default.createElement("tr", null,
                        React__default.createElement("td", { className: "padded-td checklist-question" },
                            "Safety Zone description",
                            React__default.createElement("div", { className: "question-description" }, "(During LNG-bunkering are only controlled ignition sources, authorized persons and controlled simultaneous operations permitted)")),
                        React__default.createElement("td", null,
                            React__default.createElement("textarea", { className: "full-width-textarea", defaultValue: props.safetyChecklist.safetyZone, onChange: function (e) {
                                    changePartFValues('safetyZone', e.target.value);
                                }, disabled: props.readOnly, onBlur: props.handleSubmit }))),
                    React__default.createElement("tr", null,
                        React__default.createElement("td", { className: "padded-td checklist-question" },
                            "Marine Exclusion Zone description:",
                            React__default.createElement("div", { className: "question-description" }, "(During LNG-bunkering Port specific actions)")),
                        React__default.createElement("td", null,
                            React__default.createElement("textarea", { className: "full-width-textarea", defaultValue: props.safetyChecklist.marineExclusionZone, onChange: function (e) {
                                    changePartFValues('marineExclusionZone', e.target.value);
                                }, disabled: props.readOnly, onBlur: props.handleSubmit }))),
                    React__default.createElement("tr", null,
                        React__default.createElement("td", { className: "padded-td checklist-question" },
                            "Monitoring & Security Area description",
                            React__default.createElement("div", { className: "question-description" }, "(During LNG-bunkering awareness of actions of others not involved in the LNG bunker process to prevent impact on the process)")),
                        React__default.createElement("td", null,
                            React__default.createElement("textarea", { className: "full-width-textarea", defaultValue: props.safetyChecklist.monitoringArea, onChange: function (e) {
                                    changePartFValues('monitoringArea', e.target.value);
                                }, disabled: props.readOnly, onBlur: props.handleSubmit })))))),
        React__default.createElement("div", { className: "table-wrapper" },
            React__default.createElement("table", null,
                React__default.createElement("thead", null,
                    React__default.createElement("tr", null,
                        React__default.createElement("th", null, "Agreed simultaneous operations in the safety zone during LNG-bunkering"))),
                React__default.createElement("tbody", null,
                    React__default.createElement("tr", null,
                        React__default.createElement("td", null,
                            React__default.createElement("textarea", { className: "full-width-textarea", defaultValue: props.safetyChecklist.agreedSimOps, onChange: function (e) {
                                    changePartFValues('agreedSimOps', e.target.value);
                                }, disabled: props.readOnly, onBlur: props.handleSubmit })))))),
        React__default.createElement("div", { className: "table-wrapper" },
            React__default.createElement("table", null,
                React__default.createElement("thead", null,
                    React__default.createElement("tr", null,
                        React__default.createElement("th", null, "Restrictions for simultaneous operations in the safety zone during LNG-bunkering"))),
                React__default.createElement("tbody", null,
                    React__default.createElement("tr", null,
                        React__default.createElement("td", null,
                            React__default.createElement("textarea", { className: "full-width-textarea", defaultValue: props.safetyChecklist.simOpsRestrictions, onChange: function (e) {
                                    changePartFValues('simOpsRestrictions', e.target.value);
                                }, disabled: props.readOnly, onBlur: props.handleSubmit })))))),
        React__default.createElement("div", { className: "table-wrapper" },
            React__default.createElement("table", null,
                React__default.createElement("thead", null,
                    React__default.createElement("tr", null,
                        React__default.createElement("th", null, "Required control and communication for simultaneous operations in the safety zone during LNG-bunkering"))),
                React__default.createElement("tbody", null,
                    React__default.createElement("tr", null,
                        React__default.createElement("td", null,
                            React__default.createElement("textarea", { className: "full-width-textarea", defaultValue: props.safetyChecklist.controlMeasures, onChange: function (e) {
                                    changePartFValues('controlMeasures', e.target.value);
                                }, disabled: props.readOnly, onBlur: props.handleSubmit })))))),
        React__default.createElement("div", { className: "table-wrapper" },
            React__default.createElement("table", null,
                React__default.createElement("thead", null,
                    React__default.createElement("tr", null,
                        React__default.createElement("th", null, "Person in charge"),
                        React__default.createElement("th", null, "Name"),
                        React__default.createElement("th", null, "Contact By"))),
                React__default.createElement("tbody", null,
                    React__default.createElement("tr", null,
                        React__default.createElement("td", { className: "padded-td checklist-question" }, "Person in charge terminal"),
                        React__default.createElement("td", null,
                            React__default.createElement("textarea", { className: "full-width-textarea", defaultValue: props.safetyChecklist.personInCharge.name, onChange: function (e) {
                                    changePartFContactPerson('personInCharge', 'name', e.target.value);
                                }, disabled: props.readOnly, onBlur: props.handleSubmit })),
                        React__default.createElement("td", null,
                            React__default.createElement("textarea", { className: "full-width-textarea", defaultValue: props.safetyChecklist.personInCharge.contactBy, onChange: function (e) {
                                    changePartFContactPerson('personInCharge', 'contactBy', e.target.value);
                                }, disabled: props.readOnly, onBlur: props.handleSubmit }))))))));
    function changePartFValues(fieldName, value) {
        var path = "" + fieldName;
        props.onChangeFormValue(path, value);
    }
    function changePartFContactPerson(contactType, fieldName, value) {
        var path = contactType + "." + fieldName;
        props.onChangeFormValue(path, value);
    }
};

var ChecklistPartG = function (props) {
    return (React__default.createElement(ChecklistWrapper, { title: "Part G - After completion of LNG bunkering checklist" },
        React__default.createElement(ChecklistTable, __assign({ className: "checklist-IAPH-gothenburg-g", checkListName: "checklistG" }, props))));
};

var PreparationTableItem = function (props) {
    return (React__default.createElement("div", { className: "checklist-preparation-table-item" },
        React__default.createElement("b", null, props.title),
        React__default.createElement("ul", null, props.items.map(function (item, i) { return (
        /**
         * Normally a index as a key would be a no go, however the data is static and hard coded in the frontend.
         * Because of this there is no risk of ever changing the order of the items. Using the index in this case is not a issue.
         */
        React__default.createElement("li", { key: "PreparationTableItem-" + i + "-" + item }, item)); }))));
};
var PreparationTable = function (props) {
    return (React__default.createElement("div", { className: "checklist-preparation-table" }, props.items.map(function (rows, i) {
        return (React__default.createElement("div", { className: "checklist-preparation-table-row", key: "preperation-tabble-row-" + i + "-" + props.part }, rows.map(function (item, i) { return (React__default.createElement(PreparationTableItem, __assign({}, item, { key: "PreparationTable-" + i + "-" + props.part }))); })));
    })));
};

var AgreedControlZones = function (props) {
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("b", { className: "checklist-subtitle" }, "Agreed control zones"),
        React__default.createElement("table", { className: "flexeble-checklist tis-table control-zones" },
            React__default.createElement("thead", { className: "tis-table-head" },
                React__default.createElement("tr", null,
                    React__default.createElement("th", null, "Control zones"))),
            React__default.createElement("tbody", { className: "tis-table-body" },
                React__default.createElement("tr", null,
                    React__default.createElement("td", null,
                        React__default.createElement(FormElement, { className: "tis-form-element" },
                            React__default.createElement(FormLabel, { className: "tis-form-element-label", fieldName: "numberField" }, "Hazardous zone:"),
                            React__default.createElement(TextField, { fieldName: "tis-Hazardous zone", value: props.safetyChecklist.hazardousZone, onChange: function (e) { return props.onChangeFormValue('hazardousZone', e.target.value); }, className: "tis-form-element-input", onBlur: props.handleSubmit })))),
                React__default.createElement("tr", null,
                    React__default.createElement("td", null,
                        React__default.createElement(FormElement, { className: "tis-form-element" },
                            React__default.createElement(FormLabel, { className: "tis-form-element-label", fieldName: "numberField" }, "Safety zone:"),
                            React__default.createElement(TextField, { fieldName: "tis-Safety zone", value: props.safetyChecklist.safetyZone, onChange: function (e) { return props.onChangeFormValue('safetyZone', e.target.value); }, className: "tis-form-element-input", onBlur: props.handleSubmit })))),
                React__default.createElement("tr", null,
                    React__default.createElement("td", null,
                        React__default.createElement(FormElement, { className: "tis-form-element" },
                            React__default.createElement(FormLabel, { className: "tis-form-element-label", fieldName: "numberField" }, "Monitoring and security area:"),
                            React__default.createElement(TextField, { fieldName: "tis-Monitoring and Security Area:", value: props.safetyChecklist.monitoringArea, onChange: function (e) { return props.onChangeFormValue('monitoringArea', e.target.value); }, className: "tis-form-element-input", onBlur: props.handleSubmit })))),
                React__default.createElement("tr", null,
                    React__default.createElement("td", null,
                        React__default.createElement(FormElement, { className: "tis-form-element" },
                            React__default.createElement(FormLabel, { className: "tis-form-element-label", fieldName: "numberField" }, "Marine exclusion zone:"),
                            React__default.createElement(TextField, { fieldName: "tis-Marine Exclusion Zone", value: props.safetyChecklist.marineExclusionZone, onChange: function (e) { return props.onChangeFormValue('marineExclusionZone', e.target.value); }, className: "tis-form-element-input", onBlur: props.handleSubmit })))),
                React__default.createElement("tr", null,
                    React__default.createElement("td", null,
                        React__default.createElement(FormElement, { className: "tis-form-element" },
                            React__default.createElement(FormLabel, { className: "tis-form-element-label", fieldName: "numberField" }, "Drawing added:"),
                            React__default.createElement(Checkbox, { label: "Yes", field: "drawing-check", value: props.safetyChecklist.drawingAdded, onChange: function (e) { return props.onChangeFormValue('drawingAdded', e.target.checked); }, onBlur: props.handleSubmit }))))))));
};

var AgreedListInput = function (props) {
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("b", { className: "checklist-subtitle" }, props.title),
        React__default.createElement("table", { className: "flexeble-checklist tis-table oil-bunker-activities" },
            React__default.createElement("thead", { className: "tis-table-head" },
                React__default.createElement("tr", null,
                    React__default.createElement("th", null, props.tableName))),
            React__default.createElement("tbody", { className: "tis-table-body" },
                props.data.length > 0 &&
                    props.data.map(function (item, index) { return (React__default.createElement("tr", { key: "tis-table-body-" + props.tableName + "-" + index },
                        React__default.createElement("td", null,
                            React__default.createElement(FormElement, { className: "tis-form-element" },
                                React__default.createElement(TextField, { fieldName: "tis-table-body-" + props.tableName + "-" + index, value: item, onChange: function (e) {
                                        var update = __spreadArrays(props.data);
                                        update[index] = e.target.value || '';
                                        props.onChange(update);
                                    }, className: "tis-form-element-input", onBlur: props.handleSubmit }))))); }),
                React__default.createElement("tr", { onClick: function () {
                        props.onChange(__spreadArrays(props.data, ['']));
                    } },
                    React__default.createElement("td", { className: "padded-td create-new-row" },
                        React__default.createElement(Icon, null,
                            React__default.createElement(FontAwesomeIcon, { icon: faPlus }),
                            "Add ",
                            props.tableName)))))));
};

var TerminalInformationSheet = function (props) {
    var _a;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(ChecklistWrapper, { title: 'Terminal Information Sheet', subTitle: "Page 1 of 3" },
            React__default.createElement(FormElement, null,
                React__default.createElement(FormLabel, { fieldName: "numberField" }, "Planned date and time bunkering"),
                React__default.createElement(TextField, { fieldName: "bst", disabled: true, value: formatDateTime(props.nomination.bst || undefined), className: "bst-input-field" })),
            React__default.createElement(FormElement, null,
                React__default.createElement(FormLabel, { fieldName: "numberField" }, "Terminal"),
                React__default.createElement(TextField, { fieldName: "overview-terminal-iaph-v2", disabled: true, value: (_a = props.safetyChecklist.overview) === null || _a === void 0 ? void 0 : _a.terminal, className: "contact-input-field" })),
            React__default.createElement(FormElement, null,
                React__default.createElement(FormLabel, { fieldName: "numberField" }, "Port and berth"),
                React__default.createElement(TextField, { fieldName: "port-and-port-combined", disabled: true, value: props.safetyChecklist.overview.port + " " + props.safetyChecklist.overview.berth, className: "contact-input-field" })),
            React__default.createElement(FormElement, null,
                React__default.createElement(FormLabel, { fieldName: "numberField" }, "Energy carrier"),
                React__default.createElement(TextField, { fieldName: "fuel-type-iaph-v2", disabled: true, value: 'Liquefied Natural Gas', className: "contact-input-field" })),
            React__default.createElement(FormElement, null,
                React__default.createElement(FormLabel, { fieldName: "numberField" }, "Liquefied gas bunker vessel"),
                React__default.createElement(TextField, { fieldName: "bunker-vessel-tis", disabled: true, value: props.safetyChecklist.overview.bunkerShip, className: "contact-input-field" })),
            React__default.createElement(FormElement, null,
                React__default.createElement(FormLabel, { fieldName: "numberField" }, "Liquefied gas receiving vessel"),
                React__default.createElement(TextField, { disabled: true, fieldName: "Receiving-vessel-tis", value: props.safetyChecklist.overview.receivingShip, className: "contact-input-field" })),
            React__default.createElement("ul", null,
                React__default.createElement("li", null, "Competent authorities have granted permission for liquefied gas transfer operations for the specific location and time."),
                React__default.createElement("li", null, "The terminal will be notified of the start and completion time of liquefied gas bunker operations."),
                React__default.createElement("li", null, "The ship-to-ship liquefied gas bunkering will not affect the mooring or fendering of the primary ship moored at the terminal."),
                React__default.createElement("li", null, "The restricted areas on board of the ships are marked and appropriated signed. Unauthorized persons, objects and ignition sources are not allowed within the restricted areas without authorization of a responsible ship officer."),
                React__default.createElement("li", null, "Planned simultaneous cargo operations during liquefied gas bunkering will be in accordance with the ship\u2019s approved operational documentation."),
                React__default.createElement("li", null, "The terminal should comply with the requirements in the ship\u2019s approved operational documentation for risk mitigation during liquefied gas bunkering as specified on page two of the Terminal Information Sheet."),
                React__default.createElement("li", null,
                    "Precautions should be made to prevent falling objects or any other impact on the liquefied gas bunkering due to terminal activities.",
                    ' '),
                React__default.createElement("li", null, "The ships engaged in the liquefied gas bunkering are provided with an International Shore Connection."))),
        React__default.createElement(ChecklistWrapper, { title: 'Terminal Information Sheet', subTitle: "Page 2 of 3" },
            React__default.createElement(AgreedControlZones, __assign({}, props)),
            React__default.createElement(AgreedListInput, { key: "iaph-v2-oil-bunkering-AgreedListInput", title: "Agreed simultaneous liquefied gas bunker / oil bunker operations", tableName: "Oil bunker activities", data: props.safetyChecklist.oilBunkerActivities, handleSubmit: props.handleSubmit, onChange: function (value) { return props.onChangeFormValue('oilBunkerActivities', value); } }),
            React__default.createElement(AgreedListInput, { key: "iaph-v2-agreed-simops-AgreedListInput", title: "Agreed simultaneous liquefied gas bunker / cargo operations", tableName: "Cargo activities", data: props.safetyChecklist.cargoActivities, handleSubmit: props.handleSubmit, onChange: function (value) { return props.onChangeFormValue('cargoActivities', value); } }),
            React__default.createElement(AgreedListInput, { key: "iaph-v2-restricted-activities-AgreedListInput", title: "Restricted activities", tableName: "Restricted activities", data: props.safetyChecklist.restrictedActivities, handleSubmit: props.handleSubmit, onChange: function (value) { return props.onChangeFormValue('restrictedActivities', value); } })),
        React__default.createElement(ChecklistWrapper, { title: 'Terminal Information Sheet', subTitle: "Page 3 of 3" }, "Generated on signing part A")));
};

var ChecklistPartA$1 = function (props) {
    var _a, _b, _c, _d;
    var onChangePreparation = function (value, field) {
        var path = "preparationInfo." + field;
        onChange(path, value);
    };
    var onChangeOverview = function (value, field) {
        var path = "overview." + field;
        onChange(path, value);
    };
    var onChange = function (field, value) {
        props.onChangeFormValue(field, value);
        props.setEditingChecklistValue(true);
    };
    var onBlurHandler = function () {
        props.handleSubmit();
        props.setEditingChecklistValue(false);
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(ChecklistWrapper, { title: "Part A1\n    Preparation - Compatibility assessment topics" },
            React__default.createElement(PreparationTable, { items: IAPH_V2_A1_TABLE_TEXT, part: "a1" })),
        React__default.createElement(ChecklistWrapper, { title: "Part A2\n      Preparation - Joint Plan of Bunker Operations topic" },
            React__default.createElement(PreparationTable, { items: IAPH_V2_A2_TABLE_TEXT, part: "a2" })),
        React__default.createElement(ChecklistWrapper, { title: "Part A3\n      General information and bunkering identification number" },
            React__default.createElement(FormElement, null,
                React__default.createElement(FormLabel, { fieldName: "numberField" }, "Bunker Identification Number (BIN)"),
                React__default.createElement(TextField, { fieldName: "BIN", disabled: false, value: (_a = props.safetyChecklist.preparationInfo) === null || _a === void 0 ? void 0 : _a.bunkerIdentificationNumber, onChange: function (e) { return onChangePreparation(e.target.value, 'bunkerIdentificationNumber'); }, className: "contact-input-field", onBlur: onBlurHandler })),
            React__default.createElement(FormElement, null,
                React__default.createElement(FormLabel, { fieldName: "numberField" }, "JPBO version number"),
                React__default.createElement(TextField, { fieldName: "JPBDO", disabled: false, value: (_b = props.safetyChecklist.preparationInfo) === null || _b === void 0 ? void 0 : _b.jpboVersionNumber, onChange: function (e) { return onChangePreparation(e.target.value, 'jpboVersionNumber'); }, className: "contact-input-field", onBlur: onBlurHandler })),
            React__default.createElement(FormElement, null,
                React__default.createElement(FormLabel, { fieldName: "numberField" }, "Port"),
                React__default.createElement(TextField, { fieldName: "port-and-berth", disabled: false, value: props.safetyChecklist.overview.port, onChange: function (e) { return onChangeOverview(e.target.value, 'port'); }, className: "contact-input-field", onBlur: onBlurHandler })),
            React__default.createElement(FormElement, null,
                React__default.createElement(FormLabel, { fieldName: "numberField" }, "Berth"),
                React__default.createElement(TextField, { fieldName: "port-and-berth", disabled: false, value: props.safetyChecklist.overview.berth, onChange: function (e) { return onChangeOverview(e.target.value, 'berth'); }, className: "contact-input-field", onBlur: onBlurHandler })),
            React__default.createElement(FormElement, null,
                React__default.createElement(FormLabel, { fieldName: "numberField" }, "Applicable fuel"),
                React__default.createElement(TextField, { fieldName: "fuel-type-iaph-v2", disabled: true, value: 'Liquefied Natural Gas', className: "contact-input-field", onBlur: onBlurHandler })),
            React__default.createElement(FormElement, null,
                React__default.createElement(FormLabel, { fieldName: "numberField" }, "Bunker vessel"),
                React__default.createElement(TextField, { fieldName: "bunker-vessel-iaph-v2", disabled: false, value: props.safetyChecklist.overview.bunkerShip, onChange: function (e) { return onChangeOverview(e.target.value, 'bunkerShip'); }, className: "contact-input-field", onBlur: onBlurHandler })),
            React__default.createElement(FormElement, null,
                React__default.createElement(FormLabel, { fieldName: "numberField" }, "Receiving vessel"),
                React__default.createElement(TextField, { fieldName: "Receiving-vessel-iph-v2", value: props.safetyChecklist.overview.receivingShip, onChange: function (e) { return onChangeOverview(e.target.value, 'receivingShip'); }, className: "contact-input-field", onBlur: onBlurHandler })),
            props.safetyChecklist.type === SafetyChecklistType.IAPH_V2_A && (React__default.createElement(FormElement, null,
                React__default.createElement(FormLabel, { fieldName: "numberField" }, "Site operator"),
                React__default.createElement(TextField, { fieldName: "Site-operator-iaph-v2", value: (_c = props.safetyChecklist.preparationInfo) === null || _c === void 0 ? void 0 : _c.siteOperator, onChange: function (e) { return onChangePreparation(e.target.value, 'siteOperator'); }, className: "contact-input-field", onBlur: onBlurHandler }))),
            props.safetyChecklist.type === SafetyChecklistType.IAPH_V2_B && (React__default.createElement(FormElement, null,
                React__default.createElement(FormLabel, { fieldName: "numberField" }, "Terminal"),
                React__default.createElement(TextField, { fieldName: "overview-terminal-iaph-v2", value: (_d = props.safetyChecklist.overview) === null || _d === void 0 ? void 0 : _d.terminal, onChange: function (e) { return onChangeOverview(e.target.value, 'terminal'); }, className: "contact-input-field", onBlur: onBlurHandler })))),
        props.safetyChecklist.type === SafetyChecklistType.IAPH_V2_B && (React__default.createElement(TerminalInformationSheet, __assign({}, props, { onChangeFormValue: onChange })))));
};

function safetyChecklistFilter(safetyChecklist, checkListPart) {
    var fields = flatMap(checkListPart, function (key) { return safetyChecklist[key]; });
    if (safetyChecklist.type === SafetyChecklistType.GOTHENBURG)
        return gothenburgChecklistFilter(fields, checkListPart.includes('checklistA') && checkListPart.includes('checklistB'), safetyChecklist.simopsEnabled, safetyChecklist.gothenburgOptions.useSectionB2);
    return fields;
}
function gothenburgChecklistFilter(checkListPart, partAB, simOpsEnabled, b2Eabled) {
    var tempCheckListPart = checkListPart;
    if (partAB) {
        if (!simOpsEnabled) {
            tempCheckListPart = tempCheckListPart.filter(function (item) { return !item.idx.startsWith('B1-'); });
        }
        if (!b2Eabled) {
            tempCheckListPart = tempCheckListPart.filter(function (item) { return !item.idx.startsWith('B2-'); });
        }
        tempCheckListPart = tempCheckListPart.filter(function (item) { return item.idx !== 'A2-4'; });
    }
    return tempCheckListPart;
}
function getChecklistPartProgress(checkListPart) {
    // first check for blank values, then check for checked values.
    // Based on these we can determine if the checklist is in progress, completed or not started
    var hasBlankBunkerValues = checkListPart.find(function (x) { return x.bunkerShip === 'BLANK'; });
    var hasCheckedBunkerValues = checkListPart.find(function (x) { return x.bunkerShip === 'CHECKED'; });
    var bunkerShipStatus = hasBlankBunkerValues && hasCheckedBunkerValues
        ? 'IN_PROGRESS'
        : hasBlankBunkerValues && !hasCheckedBunkerValues
            ? 'NOT_STARTED'
            : 'COMPLETED';
    var hasBlankReceivingValues = checkListPart.find(function (x) { return x.receivingShip === 'BLANK'; });
    var hasCheckedReceivingValues = checkListPart.find(function (x) { return x.receivingShip === 'CHECKED'; });
    var receivingShipStatus = hasBlankReceivingValues && hasCheckedReceivingValues
        ? 'IN_PROGRESS'
        : hasBlankReceivingValues && !hasCheckedReceivingValues
            ? 'NOT_STARTED'
            : 'COMPLETED';
    return {
        bunkerVessel: bunkerShipStatus,
        receivingVessel: receivingShipStatus
    };
}
/// helper functions
function statusDTO(safetyChecklistStatus) {
    if (!safetyChecklistStatus)
        return [];
    return Object.keys(safetyChecklistStatus).map(function (key) {
        return { user: camelToSentence(key), status: safetyChecklistStatus[key] };
    });
}
function statusDTOTr56(safetyChecklistStatus) {
    if (!safetyChecklistStatus)
        return [];
    return Object.keys(safetyChecklistStatus).map(function (key) {
        return {
            user: key === 'bunkerVessel' ? 'Bunker facility' : camelToSentence(key),
            status: safetyChecklistStatus[key]
        };
    });
}

function useInterval(callback, delay) {
    var savedCallback = useRef();
    // Remember the latest callback.
    useEffect(function () {
        savedCallback.current = callback;
    });
    // Set up the interval.
    useEffect(function () {
        function tick() {
            if (savedCallback && typeof (savedCallback === null || savedCallback === void 0 ? void 0 : savedCallback.current) !== 'undefined') {
                savedCallback.current();
            }
        }
        if (delay !== null) {
            var id_1 = setInterval(tick, delay);
            return function () { return clearInterval(id_1); };
        }
        return undefined;
    }, [delay]);
}

/**
 * Copied from shared utility library
 */
function useSafetyChecklistService(authenticationService, nomination, refreshIntervalMs, editIsActive, refetchEvent) {
    var _a = useState(null), safetyChecklist = _a[0], setSafetyChecklist = _a[1];
    useEffect(function () {
        fetchChecklist().catch(handleFetchError);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [nomination]);
    // Refresh the checklist regularly
    useInterval(function () {
        if (!editIsActive) {
            fetchChecklist().catch(handleFetchError);
        }
    }, refreshIntervalMs);
    function fetchChecklist() {
        return __awaiter(this, void 0, void 0, function () {
            var safetyChecklist_1, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!nomination.eventId) {
                            setSafetyChecklist(null);
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, getSafetyChecklist(authenticationService, nomination.eventId)];
                    case 2:
                        safetyChecklist_1 = _a.sent();
                        if (safetyChecklist_1) {
                            setSafetyChecklist(safetyChecklist_1);
                        }
                        else {
                            setSafetyChecklist(null);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        setSafetyChecklist(null);
                        if (error_1.status !== 404) {
                            handleFetchError(error_1);
                        }
                        else {
                            return [2 /*return*/];
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    function saveChecklist(checklist) {
        return __awaiter(this, void 0, void 0, function () {
            var updatedChecklist, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!nomination.eventId) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, updateSafetyChecklist(authenticationService, nomination.eventId, checklist)];
                    case 2:
                        updatedChecklist = _a.sent();
                        setSafetyChecklist(updatedChecklist);
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        handleFetchError(error_2);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    function generateChecklist(part) {
        return __awaiter(this, void 0, void 0, function () {
            var error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!nomination.eventId) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, generateSafetyChecklistDocument(authenticationService, nomination.eventId, part)];
                    case 2:
                        _a.sent();
                        toast.success("Safety checklist " + part + " Generated");
                        refetchEvent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_3 = _a.sent();
                        handleFetchError(error_3);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    function createChecklist(safetyChecklistType) {
        return __awaiter(this, void 0, void 0, function () {
            var createdSafetyChecklist, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!nomination.eventId) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, createSafetyChecklist(authenticationService, nomination.eventId, safetyChecklistType)];
                    case 2:
                        createdSafetyChecklist = _a.sent();
                        setSafetyChecklist(createdSafetyChecklist);
                        return [3 /*break*/, 4];
                    case 3:
                        error_4 = _a.sent();
                        handleFetchError(error_4);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    function generateRepetitiveChecks() {
        return __awaiter(this, void 0, void 0, function () {
            var error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!nomination.eventId) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, downloadSafetyChecklistsRepetitiveChecks(authenticationService, nomination.eventId, (safetyChecklist === null || safetyChecklist === void 0 ? void 0 : safetyChecklist.type) ? safetyChecklist.type + "-repetitive-checks.pdf" : undefined)];
                    case 2:
                        _a.sent();
                        toast.success("Repetitive Checks Generated");
                        return [3 /*break*/, 4];
                    case 3:
                        error_5 = _a.sent();
                        handleFetchError(error_5);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    return {
        safetyChecklist: safetyChecklist,
        saveChecklist: saveChecklist,
        createChecklist: createChecklist,
        generateChecklist: generateChecklist,
        generateRepetitiveChecks: generateRepetitiveChecks,
        tabs: useMemo(function () { return getChecklistConfiguration(safetyChecklist); }, [safetyChecklist === null || safetyChecklist === void 0 ? void 0 : safetyChecklist.type])
    };
}
function getChecklistConfiguration(safetyChecklist) {
    switch (safetyChecklist === null || safetyChecklist === void 0 ? void 0 : safetyChecklist.type) {
        case SafetyChecklistType.GOTHENBURG:
            return TABS_GOTHENBURG;
        case SafetyChecklistType.TR56:
            return TABS_TR56;
        case SafetyChecklistType.IAPH_V2_A:
            return TABS_IAPH_V2_A;
        case SafetyChecklistType.IAPH_V2_B:
            return TABS_IAPH_V2_B;
        default:
            return TABS_IAPH;
    }
}

var exceptedDocuments = [
    'SAFETY_CHECKLIST_IAPH_V2_B_E',
    'SAFETY_CHECKLIST_IAPH_V2_A_E'
];
var SafetyChecklistStatusComponent = function (props) {
    var userPermissions = useContext(UserPermissionContext).userPermissions;
    var canGeneratePDF = doesUserHavePermission(userPermissions, 'IAPH_GENERATE_DOCUMENT');
    var checklistConfiguration = getChecklistConfiguration(props.safetyChecklist);
    return (React__default.createElement("div", { className: "safety-checklist-status-wrapper" },
        React__default.createElement("div", { className: "status-block-wrapper" }, checklistConfiguration.map(function (configuration) {
            var isExceptionDocument = exceptedDocuments.includes(configuration.documentType);
            return (React__default.createElement(DocumentStatusBlock, { title: configuration.tabLabel, isDifferentFromInitial: props.isDifferentFromInitial, readOnly: props.readOnly, statusArray: switchStatus(configuration.checklistItemNames), generatePDF: function () {
                    props.generateChecklist(configuration.checklistPart);
                }, canGeneratePDF: canGeneratePDF && !isExceptionDocument }, props.renderDocumentViewer(configuration.documentType)));
        }))));
    function switchStatus(checklistItemNames) {
        var status = getChecklistPartProgress(safetyChecklistFilter(props.safetyChecklist, checklistItemNames).filter(function (item) { return item.notApplicable !== true; }));
        if (props.safetyChecklist.type === SafetyChecklistType.TR56)
            return statusDTOTr56(status);
        return statusDTO(status);
    }
};

var RepetitiveChecks = function (props) {
    var _a, _b;
    var _c = useState(), error = _c[0], setIntervalError = _c[1];
    var fieldReadOnly = function (intervalField) {
        switch (intervalField) {
            case 'bunkerShipCheckInterval':
                return !isBunkerCaptain(props.userRoles);
            case 'receivingShipCheckInterval':
                return !isCaptain(props.userRoles);
            case 'shipCheckInterval':
                return !isBunkerCaptain(props.userRoles) && !isCaptain(props.userRoles);
        }
    };
    var fieldText = function (intervalField) {
        switch (intervalField) {
            case 'bunkerShipCheckInterval':
                return 'Bunkership';
            case 'receivingShipCheckInterval':
                return 'Receiving vessel';
            case 'shipCheckInterval':
                return '';
        }
    };
    var renderCheckInterval = function (intervalField) { return (React__default.createElement(FormElement, null,
        React__default.createElement(FormLabel, { fieldName: intervalField },
            fieldText(intervalField),
            " check interval ( hours )"),
        React__default.createElement(FormFieldButtonWrapper, null,
            React__default.createElement(FormFieldWrapper, null,
                React__default.createElement("input", { name: intervalField, type: "number", value: props.safetyChecklist[intervalField] === undefined
                        ? ''
                        : props.safetyChecklist[intervalField], onChange: function (e) {
                        changeIntervalValue(intervalField, e.target.value, false);
                    }, onBlur: function (e) {
                        props.changeRepetitiveInterval(intervalField, parseInt(e.target.value), true);
                        changeIntervalValue(intervalField, e.target.value, true);
                    }, disabled: props.readOnly || fieldReadOnly(intervalField) }))),
        React__default.createElement(FormErrorMessage, { errorMessage: props.safetyChecklist[intervalField] === undefined
                ? 'Please fill in a valid interval'
                : undefined }))); };
    return (React__default.createElement("div", { className: "table-wrapper" },
        React__default.createElement("h4", { className: "checklist-section-header" }, "Repetitive checks"),
        React__default.createElement(FormWrapper, null,
            React__default.createElement("p", null, "The repetitive checklist can be downloaded and filled in. Once completed upload it again in the documents tab."),
            ((_a = props.renderFields) === null || _a === void 0 ? void 0 : _a.includes('bunkerShipCheckInterval')) &&
                renderCheckInterval('bunkerShipCheckInterval'),
            ((_b = props.renderFields) === null || _b === void 0 ? void 0 : _b.includes('receivingShipCheckInterval')) &&
                renderCheckInterval('receivingShipCheckInterval'),
            typeof props.renderFields === 'undefined' && renderCheckInterval('shipCheckInterval'),
            error && React__default.createElement("div", { className: "error" }, error),
            !props.readOnly && (React__default.createElement(FormElement, null,
                React__default.createElement(Button, { preventDoubleClick: true, primary: true, onClick: generateDocument }, "Download repetetive check document"))))));
    function generateDocument() {
        var intervalError = validateIntervals();
        if (intervalError) {
            setIntervalError(intervalError);
        }
        else {
            setIntervalError(undefined);
            props.generateRepetitiveChecks();
        }
    }
    function validateIntervals() {
        var _a, _b;
        if (((_a = props.renderFields) === null || _a === void 0 ? void 0 : _a.includes('bunkerShipCheckInterval')) &&
            (props.safetyChecklist.bunkerShipCheckInterval === '' ||
                isNaN(props.safetyChecklist.bunkerShipCheckInterval))) {
            return 'Please fill in a valid interval';
        }
        if (((_b = props.renderFields) === null || _b === void 0 ? void 0 : _b.includes('receivingShipCheckInterval')) &&
            (props.safetyChecklist.receivingShipCheckInterval === '' ||
                isNaN(props.safetyChecklist.receivingShipCheckInterval))) {
            return 'Please fill in a valid interval';
        }
        if (typeof props.renderFields === 'undefined' &&
            (props.safetyChecklist.shipCheckInterval === '' ||
                isNaN(props.safetyChecklist.shipCheckInterval))) {
            return 'Please fill in a valid interval';
        }
        return;
    }
    function changeIntervalValue(intervalType, value, persistToBackend) {
        var newValue = isNaN(value) ? '' : parseInt(value);
        props.changeRepetitiveInterval(intervalType, newValue, persistToBackend);
    }
};

var SafetyChecklistForms = function (props) {
    var _a, _b;
    var _c = useState(false), editingCheckListValue = _c[0], setEditingChecklistValue = _c[1];
    var _d = useState(false), replaceDialog = _d[0], setReplaceDialog = _d[1];
    var _e = useState(0), selectedTab = _e[0], setSelectedTab = _e[1];
    var userRoles = props.userProfile.roles;
    var _f = useSafetyChecklistService(props.authenticationService, props.nomination, props.refreshIntervalMs, editingCheckListValue, props.refetchEvent), safetyChecklist = _f.safetyChecklist, saveChecklist = _f.saveChecklist, createChecklist = _f.createChecklist, generateChecklist = _f.generateChecklist, generateRepetitiveChecks = _f.generateRepetitiveChecks, tabs = _f.tabs;
    var _g = useState(safetyChecklist === null || safetyChecklist === void 0 ? void 0 : safetyChecklist.type), selectedType = _g[0], setSelectedType = _g[1];
    var _h = useForm({
        initialValues: safetyChecklist,
        onValidSubmit: saveChecklist
    }), handleSubmit = _h.handleSubmit, onChangeFormValue = _h.onChangeValue, isDifferentFromInitial = _h.isDifferentFromInitial, values = _h.values;
    var simOpsEnabled = values === null || values === void 0 ? void 0 : values.simopsEnabled;
    var userPermissions = useContext(UserPermissionContext).userPermissions;
    var _j = useState(((_a = values === null || values === void 0 ? void 0 : values.gothenburgOptions) === null || _a === void 0 ? void 0 : _a.useSectionB2) || false), sectionB2 = _j[0], setSectionB2 = _j[1];
    var readOnlySafetyChecklist = !doesUserHavePermission(userPermissions, 'IAPH_UPDATE');
    useEffect(function () {
        var _a;
        setSectionB2(((_a = values === null || values === void 0 ? void 0 : values.gothenburgOptions) === null || _a === void 0 ? void 0 : _a.useSectionB2) || false);
    }, [(_b = values === null || values === void 0 ? void 0 : values.gothenburgOptions) === null || _b === void 0 ? void 0 : _b.useSectionB2]);
    if (!props.nomination.eventId) {
        return null;
    }
    var terminalOperatorForTR56 = props.nomination.deliveryMode &&
        ['TRUCK', 'PIPE', 'CONTAINER'].includes(props.nomination.deliveryMode) &&
        props.userProfile.roles.includes('ROLE_TERMINAL_OPERATOR');
    var userCanCreateChecklist = doesUserHavePermission(userPermissions, 'IAPH_CREATE') || terminalOperatorForTR56;
    var checklistOptions = terminalOperatorForTR56
        ? safetyChecklistOptions.filter(function (item) { return item.value == SafetyChecklistType.TR56; })
        : safetyChecklistOptions;
    var renderRepetitiveChecks = values && (React__default.createElement(RepetitiveChecks, { changeRepetitiveInterval: changeRepetitiveInterval, readOnly: readOnlySafetyChecklist, safetyChecklist: values, generateRepetitiveChecks: generateRepetitiveChecks, userRoles: props.userProfile.roles, renderFields: (safetyChecklist === null || safetyChecklist === void 0 ? void 0 : safetyChecklist.type) === 'IAPH_V2_A' || (safetyChecklist === null || safetyChecklist === void 0 ? void 0 : safetyChecklist.type) === 'IAPH_V2_B'
            ? undefined
            : ['bunkerShipCheckInterval', 'receivingShipCheckInterval'] }));
    if (safetyChecklist === null || values === null) {
        if (!userCanCreateChecklist) {
            return (React__default.createElement("div", { className: "safety-checklist-container " + (props.className || '') },
                React__default.createElement("div", { className: "new-checklist-container" },
                    React__default.createElement("p", null, "There is no safety checklist available yet."))));
        }
        else {
            return (React__default.createElement("div", { className: "safety-checklist-container " + (props.className || '') },
                React__default.createElement("div", { className: "new-checklist-container" },
                    React__default.createElement("div", { className: "new-checklist-create" },
                        React__default.createElement("p", null, "No safety checklist has been created yet. You can do so by selecting a template and pressing the create button."),
                        React__default.createElement(NewFormTypeSelector, { value: selectedType || (safetyChecklist === null || safetyChecklist === void 0 ? void 0 : safetyChecklist.type), setValue: setSelectedType, editButton: false, readOnly: !userCanCreateChecklist, options: checklistOptions }),
                        React__default.createElement(Button, { preventDoubleClick: true, primary: true, onClick: function () { return handleCreateChecklist(); }, disabled: typeof selectedType === 'undefined' }, "Create safety checklist")))));
        }
    }
    if (!values || !doesUserHavePermission(userPermissions, 'IAPH_READ')) {
        return null;
    }
    return (React__default.createElement("div", { className: "safety-checklist-container " + (props.className || '') },
        React__default.createElement(SafetyChecklistHelpTextProvider, { authenticationService: props.authenticationService, eventId: props.nomination.eventId },
            React__default.createElement(Tabs, { className: "tabs-wrapper", forceRenderTabPanel: true, onSelect: handleTabSwitch },
                React__default.createElement(TabList, { className: "sticky-tab-list" },
                    React__default.createElement(Tab, null, "Overview"),
                    tabs.map(function (_a) {
                        var tabLabel = _a.tabLabel;
                        return React__default.createElement(Tab, { key: tabLabel }, tabLabel);
                    }),
                    React__default.createElement("li", { className: "react-tabs__tab safetychecklist-select" },
                        React__default.createElement(NewFormTypeSelector, { value: typeof selectedType === 'undefined' ? safetyChecklist.type : selectedType, setValue: setSelectedType, editButton: true, readOnly: !userCanCreateChecklist, save: handleCreateChecklist, options: checklistOptions }))),
                React__default.createElement(TabPanel, null,
                    React__default.createElement("div", null,
                        React__default.createElement(SafetyChecklistStatusComponent, { safetyChecklist: values, generateChecklist: generateChecklist, isDifferentFromInitial: isDifferentFromInitial, readOnly: readOnlySafetyChecklist, renderDocumentViewer: function (documentType) {
                                return renderDocumentViewer(props.nomination, props.userProfile, [documentType]);
                            } }),
                        React__default.createElement("div", { className: "safety-checklist-documents" }, props.children))),
                tabs.map(function (_a, index) {
                    var tabLabel = _a.tabLabel, parts = _a.parts;
                    return (React__default.createElement(TabPanel, { key: tabLabel }, selectedTab === index + 1 && parts.map(function (part) { return renderChecklistPart(part, values); })));
                }))),
        React__default.createElement(ReplaceDialog, { replace: function () {
                if (selectedType) {
                    createChecklist(selectedType);
                }
            }, onCancel: function () { return setSelectedType(safetyChecklist === null || safetyChecklist === void 0 ? void 0 : safetyChecklist.type); }, formName: 'checklist', show: replaceDialog, setShow: setReplaceDialog })));
    function handleTabSwitch(index, last, event) {
        if (index !== last && index === 0) {
            props.refetchEvent();
        }
        setSelectedTab(index);
    }
    function renderChecklistPart(part, values) {
        if (!props.nomination.eventId) {
            return null;
        }
        if (part === SafetyChecklistIndividualPart.A) {
            return renderPartA(part, values);
        }
        if (part === SafetyChecklistIndividualPart.B) {
            return renderPartB(part, values);
        }
        if (part === SafetyChecklistIndividualPart.C) {
            return renderPartC(part, values);
        }
        if (part === SafetyChecklistIndividualPart.D) {
            return renderPartD(part, values);
        }
        if (part === SafetyChecklistIndividualPart.E) {
            return renderPartE(part, values);
        }
        if (part === SafetyChecklistIndividualPart.F) {
            return renderPartF(part, values);
        }
        if (part === SafetyChecklistIndividualPart.G) {
            return (React__default.createElement(ChecklistPartG, { key: part, authenticationService: props.authenticationService, safetyChecklist: values, onChangeFormValue: onChangeFormValue, readOnly: readOnlySafetyChecklist, nominationId: props.nomination.eventId, userRoles: userRoles, setEditingChecklistValue: setEditingChecklistValue }));
        }
        return React__default.createElement("span", null,
            "Something went wrong, we could not find a safety checklist ",
            part);
    }
    function renderPartA(part, values) {
        var checklistPartAProps = {
            key: part,
            authenticationService: props.authenticationService,
            safetyChecklist: values,
            onChangeFormValue: onChangeFormValue,
            readOnly: readOnlySafetyChecklist,
            nominationId: props.nomination.eventId || '',
            userRoles: userRoles,
            setEditingChecklistValue: setEditingChecklistValue
        };
        if (values.type === SafetyChecklistType.GOTHENBURG) {
            return React__default.createElement(ChecklistPartA, __assign({}, checklistPartAProps, { useSectionB2: setSectionB2 }));
        }
        if (values.type === SafetyChecklistType.TR56) {
            return (React__default.createElement(ChecklistPartA, __assign({}, checklistPartAProps, { title: 'PART A –PLANNING STAGE CHECKLIST', subTitle: '(Planning stage checklist addresses the considerations to be made during the planning stage of LNG bunker operations)', description: 'This checklist can be used for an exchange of knowledge and agreements on safety items during the planning stage of an LNG bunkering to be conducted during the order placement for the bunkering operation' })));
        }
        if (values.type === SafetyChecklistType.IAPH_V2_A ||
            values.type === SafetyChecklistType.IAPH_V2_B) {
            return (React__default.createElement(ChecklistPartA$1, __assign({}, checklistPartAProps, { handleSubmit: handleSubmit, nomination: props.nomination })));
        }
        return React__default.createElement(ChecklistPartA, __assign({}, checklistPartAProps));
    }
    function renderPartB(part, values) {
        if (!props.nomination.eventId)
            return null;
        var ChecklistPartBProps = {
            key: part,
            authenticationService: props.authenticationService,
            safetyChecklist: values,
            onChangeFormValue: onChangeFormValue,
            readOnly: readOnlySafetyChecklist,
            nominationId: props.nomination.eventId,
            userRoles: userRoles,
            setEditingChecklistValue: setEditingChecklistValue,
            simopsEnabled: values === null || values === void 0 ? void 0 : values.simopsEnabled
        };
        if (values.type === SafetyChecklistType.IAPH)
            return React__default.createElement(IAPHChecklistPartB, __assign({}, ChecklistPartBProps));
        if (values.type === SafetyChecklistType.GOTHENBURG)
            return (React__default.createElement(GothenburgChecklistPartB, __assign({}, ChecklistPartBProps, { gothenburgOpsPlan: values.gothenburgOpsPlan, useSectionB2: sectionB2 !== values.gothenburgOptions.useSectionB2
                    ? sectionB2
                    : values.gothenburgOptions.useSectionB2 })));
        if (values.type === SafetyChecklistType.TR56)
            return (React__default.createElement(ChecklistPartD, __assign({}, ChecklistPartBProps, { generateRepetitiveChecks: generateRepetitiveChecks })));
        if (values.type === SafetyChecklistType.IAPH_V2_A ||
            values.type === SafetyChecklistType.IAPH_V2_B)
            return React__default.createElement(ChecklistPartB, __assign({}, ChecklistPartBProps));
        return React__default.createElement("div", null,
            "No Checklist for type ",
            values.type);
    }
    function renderPartC(part, values) {
        if (!props.nomination.eventId)
            return null;
        var ChecklistPartCProps = {
            key: part,
            authenticationService: props.authenticationService,
            safetyChecklist: values,
            onChangeFormValue: onChangeFormValue,
            readOnly: readOnlySafetyChecklist,
            nominationId: props.nomination.eventId,
            userRoles: userRoles,
            setEditingChecklistValue: setEditingChecklistValue
        };
        if (values.type === SafetyChecklistType.IAPH)
            return React__default.createElement(ChecklistPartC, __assign({}, ChecklistPartCProps));
        if (values.type === SafetyChecklistType.GOTHENBURG)
            return React__default.createElement(GothenburgChecklistPartC, __assign({}, ChecklistPartCProps));
        if (values.type === SafetyChecklistType.TR56)
            return React__default.createElement(ChecklistPartC$2, __assign({}, ChecklistPartCProps));
        if (values.type === SafetyChecklistType.IAPH_V2_A ||
            values.type === SafetyChecklistType.IAPH_V2_B)
            return React__default.createElement(ChecklistPartC$1, __assign({}, ChecklistPartCProps, { handleSubmit: handleSubmit }));
        return React__default.createElement("div", null,
            "No Checklist for type ",
            values.type);
    }
    function renderPartD(part, values) {
        if (!props.nomination.eventId)
            return null;
        var ChecklistPartDProps = {
            key: part,
            authenticationService: props.authenticationService,
            safetyChecklist: values,
            onChangeFormValue: onChangeFormValue,
            readOnly: readOnlySafetyChecklist,
            nominationId: props.nomination.eventId,
            userRoles: userRoles,
            setEditingChecklistValue: setEditingChecklistValue,
            saveChecklist: saveChecklist,
            generateRepetitiveChecks: generateRepetitiveChecks,
            simOpsEnabled: simOpsEnabled,
            checklistD: values === null || values === void 0 ? void 0 : values.checklistD
        };
        if (values.type === SafetyChecklistType.IAPH)
            return (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(ChecklistPartD$2, __assign({}, ChecklistPartDProps)),
                renderRepetitiveChecks));
        if (values.type === SafetyChecklistType.GOTHENBURG)
            return React__default.createElement(GothenburgChecklistPartD, __assign({}, ChecklistPartDProps));
        if (values.type === SafetyChecklistType.TR56)
            return (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(ChecklistPartD$3, __assign({}, ChecklistPartDProps)),
                renderRepetitiveChecks));
        if (values.type === SafetyChecklistType.IAPH_V2_A ||
            values.type === SafetyChecklistType.IAPH_V2_B)
            return React__default.createElement(ChecklistPartD$1, __assign({}, ChecklistPartDProps));
        return React__default.createElement("div", null,
            "No Checklist for type ",
            values.type);
    }
    function renderPartE(part, values) {
        var checklistPartEProps = {
            key: part,
            authenticationService: props.authenticationService,
            safetyChecklist: values,
            onChangeFormValue: onChangeFormValue,
            readOnly: readOnlySafetyChecklist,
            nominationId: props.nomination.eventId,
            userRoles: userRoles,
            setEditingChecklistValue: setEditingChecklistValue
        };
        if (values.type === SafetyChecklistType.TR56) {
            return (React__default.createElement(ChecklistPartE, __assign({}, checklistPartEProps, { title: 'PART E –LNG BUNKER OPERATION COMPLETION CHECKLIST', subTitle: '(This part should be completed after transfer operations have been completed)', description: 'The after LNG transfer checklistcontains the considerations to be made after the LNG bunker operations for the disconnecting of the bunker connections and finishing the total operations.' })));
        }
        if (values.type === SafetyChecklistType.IAPH_V2_A ||
            values.type === SafetyChecklistType.IAPH_V2_B)
            return React__default.createElement(ChecklistWrapper, { title: "Part E - Transfer" }, renderRepetitiveChecks);
        return React__default.createElement(ChecklistPartE, __assign({}, checklistPartEProps));
    }
    function renderPartF(part, values) {
        if (!props.nomination.eventId)
            return null;
        var ChecklistPartFProps = {
            key: part,
            authenticationService: props.authenticationService,
            safetyChecklist: values,
            onChangeFormValue: onChangeFormValue,
            readOnly: readOnlySafetyChecklist,
            nominationId: props.nomination.eventId,
            userRoles: userRoles,
            setEditingChecklistValue: setEditingChecklistValue,
            saveChecklist: saveChecklist,
            generateRepetitiveChecks: generateRepetitiveChecks,
            simOpsEnabled: simOpsEnabled,
            checklistF: values === null || values === void 0 ? void 0 : values.checklistF,
            transferData: values === null || values === void 0 ? void 0 : values.transferData,
            isDifferentFromInitial: isDifferentFromInitial,
            handleSubmit: handleSubmit
        };
        if (values.type === SafetyChecklistType.IAPH) {
            return React__default.createElement(ChecklistPartF$1, __assign({}, ChecklistPartFProps));
        }
        else if (values.type === SafetyChecklistType.GOTHENBURG) {
            return (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(GothenburgChecklistPartF, __assign({}, ChecklistPartFProps)),
                renderRepetitiveChecks));
        }
        if (values.type === SafetyChecklistType.IAPH_V2_A ||
            values.type === SafetyChecklistType.IAPH_V2_B)
            return React__default.createElement(ChecklistPartF, __assign({}, ChecklistPartFProps));
        return React__default.createElement("div", null,
            "No Checklist for type ",
            values.type);
    }
    function renderDocumentViewer(nomination, user, allowedDocTypes) {
        if (!doesUserHavePermission(userPermissions, 'IAPH_READ_DOCUMENT')) {
            return null;
        }
        return (React__default.createElement(PDFDocumentHandler, { authenticationService: props.authenticationService, eventWithDocuments: nomination, userProfile: user, allowedDocumentTypes: allowedDocTypes, readOnly: readOnlySafetyChecklist, refetchEvent: props.refetchEvent, updateItem: props.updateEvent }));
    }
    function handleCreateChecklist() {
        if (safetyChecklist === null) {
            if (selectedType)
                createChecklist(selectedType);
        }
        else {
            setReplaceDialog(true);
        }
    }
    function changeRepetitiveInterval(interval, value, persistToBackend) {
        return __awaiter(this, void 0, void 0, function () {
            var path, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = "" + interval;
                        onChangeFormValue(path, value);
                        if (!persistToBackend) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, setSafetyChecklistIntervals(props.authenticationService, props.nomination.eventId, interval, value)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        handleFetchError(error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
};

var SofFieldSelection = function (props) {
    var _a = useState(props.selectedSofFields || getEmptySofSelection()), selectedSofFields = _a[0], setSelectedSofFields = _a[1];
    useEffect(function () {
        if (props.selectedSofFields) {
            setSelectedSofFields(props.selectedSofFields);
        }
        else {
            setSelectedSofFields(getEmptySofSelection());
        }
    }, [props.selectedSofFields]);
    return (React__default.createElement("div", { className: "template-configuration-fields-selection" }, SOF_FORM_FIELDS.map(function (formField, index) {
        if (formField.eventTypes.includes('nomination') || formField.eventTypes.includes('allEvents')) {
            return (React__default.createElement(ToggleBox, { key: "fieldSelection-" + index, onClick: function () {
                    toggleSelectedSofFields(formField.fieldName);
                }, toggled: selectedSofFields[formField.fieldName] }, function (toggled) {
                return (React__default.createElement("div", { className: "sof-toggle-content" },
                    React__default.createElement(FontAwesomeIcon, { icon: toggled ? faCheck : faMinus }),
                    React__default.createElement("span", { className: "toggle-title" }, formField.labels['allEvents'] || formField.labels['nomination'])));
            }));
        }
        else {
            return null;
        }
    })));
    function toggleSelectedSofFields(sofField) {
        var newSofSelection = cloneDeep(selectedSofFields);
        newSofSelection[sofField] = !newSofSelection[sofField];
        setSelectedSofFields(newSofSelection);
        props.onSelectSofFields(newSofSelection);
    }
};

var SofConfiguration = function (props) {
    var _a;
    var _b = useForm({
        initialValues: props.configuration,
        validate: validateSofConfiguration,
        onValidSubmit: props.createOrUpdateSofConfig
    }), values = _b.values, errors = _b.errors, onChangeValue = _b.onChangeValue, handleSubmit = _b.handleSubmit, isDifferentFromInitial = _b.isDifferentFromInitial;
    return (React__default.createElement("div", { className: "sof-configuration" },
        React__default.createElement("div", { className: "template-configuration" },
            React__default.createElement("h3", { className: "template-config-title" }, "Create Statement of Facts Template"),
            React__default.createElement("p", null, "Create a custom Statement of Facts template to be used while executing any of the nominations associated with your company. Everyone within your organisation will be able to see this template and use it to create a statement of facts for your nominations."),
            React__default.createElement("div", { className: "template-name-selection" },
                React__default.createElement("h4", null, "Choose template name"),
                React__default.createElement(FormElement, null,
                    React__default.createElement(TextField, { fieldName: "sofName", placeholder: "Template name...", value: (values === null || values === void 0 ? void 0 : values.name) || '', onChange: function (event) {
                            onChangeValue('name', event.target.value);
                        } }),
                    React__default.createElement(FormErrorMessage, { errorMessage: errors === null || errors === void 0 ? void 0 : errors.name }))),
            React__default.createElement("div", { className: "template-field-selection" },
                React__default.createElement("h4", null, "Choose template fields"),
                React__default.createElement("p", null, "Select the fields you wish to appear in the statement of facts template."),
                React__default.createElement(SofFieldSelection, { selectedSofFields: (_a = props.configuration) === null || _a === void 0 ? void 0 : _a.fieldSelection, onSelectSofFields: onSelectSofFields })),
            errors && errors.fieldSelection && React__default.createElement("div", { className: "error" }, errors.fieldSelection),
            React__default.createElement(ButtonGroup, null,
                React__default.createElement(Button, { preventDoubleClick: true, disabled: !isDifferentFromInitial, primary: true, onClick: handleSubmit }, (values === null || values === void 0 ? void 0 : values._id) ? 'Update Template' : 'Create Template')))));
    function onSelectSofFields(fields) {
        onChangeValue('fieldSelection', fields);
    }
    function validateSofConfiguration(sofConfig) {
        var errors = {};
        if (!sofConfig || !sofConfig.name || sofConfig.name === '') {
            errors['name'] = 'Name is Required';
        }
        if (!sofConfig ||
            !sofConfig.fieldSelection ||
            !Object.values(sofConfig.fieldSelection).some(function (x) { return x === true; })) {
            errors['fieldSelection'] = 'Please select atleast one field to create this template.';
        }
        return errors;
    }
};

var SofForm = function (props) {
    var _a = useForm({
        initialValues: props.sofTimestamps,
        validate: validateSofValues,
        onValidSubmit: props.saveStatementOfFactsTimestamps
    }), values = _a.values, onChangeValue = _a.onChangeValue, errors = _a.errors, handleSubmit = _a.handleSubmit;
    useFuncOnStopChanging(values, props.sofTimestamps, handleSubmit);
    return (React__default.createElement("div", { className: "sof-timestamps" },
        React__default.createElement("h4", { className: "subtitle" }, "All times are in " + (props.timezone ? props.timezone : 'local time')),
        SOF_FORM_FIELDS.map(function (sofFormField, index) {
            var _a;
            var fieldInSof = (_a = props.configuration) === null || _a === void 0 ? void 0 : _a.fieldSelection[sofFormField.fieldName];
            if (!sofFormField.eventTypes.includes('allEvents') &&
                !sofFormField.eventTypes.includes(props.eventType)) {
                return null;
            }
            if (!fieldInSof) {
                return null;
            }
            var label = sofFormField.labels['allEvents']
                ? sofFormField.labels['allEvents']
                : sofFormField.labels[props.eventType];
            if (sofFormField.type === 'Date') {
                return (React__default.createElement("div", { className: "form-row", key: "sof-row-" + label + "-" + index },
                    React__default.createElement("span", { className: "field-label" }, label),
                    React__default.createElement(FormElement, null,
                        React__default.createElement(FormFieldButtonWrapper, null,
                            React__default.createElement(FormFieldWrapper, null,
                                React__default.createElement(DateTimePicker, { dialogTitle: '', name: sofFormField.fieldName, onDateTimeChange: function (isoDate, inputValue) {
                                        onChangeValue(sofFormField.fieldName, isoDate || inputValue);
                                    }, disabled: props.readOnly, icon: React__default.createElement("i", { className: "icon-calendar-1" }), placeholder: "Start time...", value: values && values[sofFormField.fieldName]
                                        ? values[sofFormField.fieldName]
                                        : undefined, timeZone: props.timezone, hideDialogHeader: true })),
                            !props.readOnly && (React__default.createElement(Button, { preventDoubleClick: true, onClick: function () {
                                    setCurrentTime(sofFormField.fieldName);
                                }, primary: true, iconButton: true },
                                React__default.createElement(FontAwesomeIcon, { icon: faClock }),
                                " Now"))),
                        React__default.createElement(FormErrorMessage, { errorMessage: get(errors, "" + sofFormField.fieldName) }))));
            }
            else {
                return (React__default.createElement("div", { className: "form-row", key: "sof-row-" + label + "-" + index },
                    React__default.createElement("span", { className: "field-label" }, label),
                    React__default.createElement(InlineFormElement, null,
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormFieldButtonWrapper, null,
                                React__default.createElement(FormFieldWrapper, null,
                                    React__default.createElement(DateTimePicker, { name: sofFormField.fieldName + ".start", onDateTimeChange: function (isoDate, inputValue) {
                                            onChangeValue(sofFormField.fieldName + ".start", isoDate || inputValue);
                                        }, disabled: props.readOnly, icon: React__default.createElement("i", { className: "icon-calendar-1" }), placeholder: "Start time...", value: values &&
                                            values[sofFormField.fieldName] &&
                                            values[sofFormField.fieldName].start
                                            ? values[sofFormField.fieldName].start
                                            : undefined, timeZone: props.timezone, hideDialogHeader: true })),
                                !props.readOnly && (React__default.createElement(Button, { preventDoubleClick: true, primary: true, iconButton: true, onClick: function () {
                                        setCurrentTime("" + sofFormField.fieldName, 'start');
                                    } },
                                    React__default.createElement(FontAwesomeIcon, { icon: faClock }),
                                    " Now"))),
                            React__default.createElement(FormErrorMessage, { errorMessage: get(errors, sofFormField.fieldName + ".start") })),
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormFieldButtonWrapper, null,
                                React__default.createElement(FormFieldWrapper, null,
                                    React__default.createElement(DateTimePicker, { name: sofFormField.fieldName + ".end", onDateTimeChange: function (isoDate, inputValue) {
                                            onChangeValue(sofFormField.fieldName + ".end", isoDate || inputValue);
                                        }, disabled: props.readOnly, icon: React__default.createElement("i", { className: "icon-calendar-1" }), placeholder: "End time...", value: values &&
                                            values[sofFormField.fieldName] &&
                                            values[sofFormField.fieldName].end
                                            ? values[sofFormField.fieldName].end
                                            : undefined, timeZone: props.timezone, hideDialogHeader: true })),
                                !props.readOnly && (React__default.createElement(Button, { primary: true, preventDoubleClick: true, iconButton: true, onClick: function () {
                                        setCurrentTime("" + sofFormField.fieldName, 'end');
                                    } },
                                    React__default.createElement(FontAwesomeIcon, { icon: faClock }),
                                    " Now"))),
                            React__default.createElement(FormErrorMessage, { errorMessage: get(errors, sofFormField.fieldName + ".end") })))));
            }
        })));
    function validateSofValues(sof) {
        var sofErrors = {};
        SOF_FORM_FIELDS.forEach(function (formField) {
            if (formField.eventTypes.includes(props.eventType) ||
                formField.eventTypes.includes('allEvents')) {
                if (formField.type === 'Date') {
                    var valueToValidate = sof[formField.fieldName];
                    if (valueToValidate !== '' &&
                        !isEmpty$1(valueToValidate) &&
                        !isValidDate(valueToValidate)) {
                        set(sofErrors, "" + formField.fieldName, 'Invalid Date');
                    }
                }
                else {
                    var startDateToValidate = sof[formField.fieldName].start;
                    if (!isEmpty$1(startDateToValidate) && !isValidDate(startDateToValidate)) {
                        set(sofErrors, formField.fieldName + ".start", 'Invalid Date');
                    }
                    var endDateToValidate = sof[formField.fieldName].end;
                    if (!isEmpty$1(endDateToValidate) && !isValidDate(endDateToValidate)) {
                        set(sofErrors, formField.fieldName + ".end", 'Invalid Date');
                    }
                }
            }
        });
        return sofErrors;
    }
    function setCurrentTime(fieldName, type) {
        var now = new Date().toISOString();
        if (type) {
            onChangeValue(fieldName + "." + type, now);
        }
        else {
            onChangeValue("" + fieldName, now);
        }
    }
};
var SofForm$1 = React__default.memo(SofForm);

var NOMINATION_CHECKBOXES = [
    'pilotUtilised',
    'gasUp',
    'coolDown',
    'gcuUsed',
    'tugsUtilised',
    'vapourHoseConnected'
];
var LOADING_DISCHARGE_CHECKBOXES = [
    'pilotUtilised',
    'gasUp',
    'coolDown',
    'heelOut',
    'tugsUtilised'
];
function getCheckboxesForEvent(event) {
    var currentlyActiveCheckboxes = event === 'nomination' ? NOMINATION_CHECKBOXES : LOADING_DISCHARGE_CHECKBOXES;
    return currentlyActiveCheckboxes;
}
function getCheckboxLabel(checkboxType) {
    switch (checkboxType) {
        case 'pilotUtilised':
            return 'Pilot';
        case 'gasUp':
            return 'Gas up';
        case 'coolDown':
            return 'Cool down';
        case 'gcuUsed':
            return 'GCU';
        case 'tugsUtilised':
            return 'Tugs ';
        case 'vapourHoseConnected':
            return 'Vapour hoses';
        case 'heelOut':
            return 'Heel out';
        default:
            return '';
    }
}

var InitialiseSofDialog = function (props) {
    var checkboxes = getCheckboxesForEvent('nomination');
    var _a = useState(), selectedConfiguration = _a[0], setSelectedConfiguration = _a[1];
    var _b = useState({
        gcuUsed: false,
        tugsUtilised: false,
        gasUp: false,
        coolDown: false,
        vapourHoseConnected: false,
        heelOut: false,
        pilotUtilised: false,
    }), selectedOptions = _b[0], setSelectedOptions = _b[1];
    // const [initialiseError, setInitialiseError] = useState<string>()
    useEffect(function () {
        if (!selectedConfiguration && props.sofConfigurationsList.length > 0) {
            setSelectedConfiguration(props.sofConfigurationsList[0]);
        }
    }, [props.sofConfigurationsList]);
    return (React__default.createElement(Dialog, { showDialog: true, onCloseDialog: function () {
            props.setSofDialogActive(false);
        }, type: "medium", title: "Create Statement of Facts" },
        React__default.createElement("p", null, "Select a template and choose additional services to create a new statement of facts document."),
        React__default.createElement("section", { className: "initialisation-section" },
            React__default.createElement("h3", { className: "sof-init-header" }, "Choose a Template"),
            React__default.createElement("div", { className: "sof-template-selection" },
                props.sofConfigurationsList.length === 0 && (React__default.createElement("p", null, "There are no Statement of Facts Templates available for your company.")),
                props.sofConfigurationsList.map(function (configuration) {
                    return (React__default.createElement(ToggleBox, { key: configuration._id, onClick: function () {
                            toggleSelectedConfiguration(configuration);
                        }, toggled: (selectedConfiguration === null || selectedConfiguration === void 0 ? void 0 : selectedConfiguration._id) === configuration._id }, function (toggled) {
                        return (React__default.createElement("div", { className: "sof-toggle-content" },
                            React__default.createElement(FontAwesomeIcon, { icon: toggled ? faCheck : faMinus }),
                            React__default.createElement("span", { className: "toggle-title" }, configuration.name)));
                    }));
                }))),
        React__default.createElement("section", { className: "initialisation-section requirements-section" },
            React__default.createElement("h3", { className: "sof-init-header" }, "Additional Services Used"),
            React__default.createElement("div", { className: "sof-checkbox-selection" }, checkboxes.map(function (checkbox) {
                return (React__default.createElement(ToggleBox, { key: "sof-check-" + checkbox, toggled: selectedOptions[checkbox], onClick: function () {
                        toggleSelectedUtilities(checkbox);
                    } }, function (toggled) {
                    return (React__default.createElement("div", { className: "sof-toggle-content" },
                        React__default.createElement(FontAwesomeIcon, { icon: toggled ? faCheck : faMinus }),
                        React__default.createElement("span", { className: "toggle-title" }, getCheckboxLabel(checkbox))));
                }));
            }))),
        React__default.createElement(ButtonGroup, null,
            React__default.createElement(Button, { preventDoubleClick: true, primary: true, onClick: initialiseSof }, "Create Statement of Facts"))));
    function toggleSelectedUtilities(optionName) {
        var newOptions = cloneDeep(selectedOptions);
        newOptions[optionName] = !newOptions[optionName];
        setSelectedOptions(newOptions);
    }
    // function validateSofSettings(configuration?: StatementOfFactsConfiguration) {
    //   if (!configuration) {
    //     const errorMessage = 'Please select one of the available templates to create a Statement of Facts'
    //     setInitialiseError(errorMessage)
    //     return errorMessage
    //   } else {
    //     setInitialiseError(undefined)
    //     return
    //   }
    // }
    function toggleSelectedConfiguration(configuration) {
        if ((selectedConfiguration === null || selectedConfiguration === void 0 ? void 0 : selectedConfiguration._id) === configuration._id) {
            setSelectedConfiguration(undefined);
        }
        else {
            setSelectedConfiguration(configuration);
        }
    }
    function initialiseSof() {
        // const error = validateSofSettings(selectedConfiguration)
        // if (!error && selectedConfiguration) {
        props.initialiseStatementOfFacts(selectedOptions, selectedConfiguration);
        props.setSofDialogActive(false);
        // }
    }
};

var SofInitialisation = function (props) {
    var _a, _b, _c, _d;
    var userPermissions = useContext(UserPermissionContext).userPermissions;
    var isAllowedToCreateSOF = doesUserHavePermission(userPermissions, 'SOF_CREATE');
    var _e = useState(false), sofDialogActive = _e[0], setSofDialogActive = _e[1];
    var checkboxes = getCheckboxesForEvent('nomination');
    var _f = useState(false), replaceDialog = _f[0], setReplaceDialog = _f[1];
    var _g = useState((_a = props.statementOfFacts) === null || _a === void 0 ? void 0 : _a.configuration), selectedSOF = _g[0], setSelectedSOF = _g[1];
    var _h = useState(getEnabledFiledsInObject((_b = props.statementOfFacts) === null || _b === void 0 ? void 0 : _b.options)), selectedCheckboxes = _h[0], setSelectedCheckboxes = _h[1];
    if (props.statementOfFacts && !isAllowedToCreateSOF) {
        return null;
    }
    return (React__default.createElement(React__default.Fragment, null,
        isAllowedToCreateSOF && (React__default.createElement("div", { className: "sof-initialisation" },
            React__default.createElement(ReplaceDialog, { replace: saveSOF, onCancel: function () {
                    var _a, _b;
                    setSelectedSOF((_a = props.statementOfFacts) === null || _a === void 0 ? void 0 : _a.configuration);
                    setSelectedCheckboxes(getEnabledFiledsInObject((_b = props.statementOfFacts) === null || _b === void 0 ? void 0 : _b.options));
                }, formName: "SoF", show: replaceDialog, setShow: setReplaceDialog }),
            React__default.createElement("div", null,
                !props.statementOfFacts && (React__default.createElement("p", null, "If you want to reset the statement of facts or change the settings you can do so by creating a new statement of facts. This resets any progress already made and creates a new blank statement of facts for you to use.")),
                React__default.createElement(NewFormTypeSelector, { key: ((_c = props.statementOfFacts) === null || _c === void 0 ? void 0 : _c._id) + "-NewFormTypeSelector", value: selectedSOF === null || selectedSOF === void 0 ? void 0 : selectedSOF._id, setValue: setSelectedSOF, editButton: typeof props.statementOfFacts !== 'undefined', readOnly: !isAllowedToCreateSOF, save: save, options: props.sofConfigurationsList.map(function (item) {
                        return { id: item._id, value: item, text: item.name };
                    }) }),
                React__default.createElement(NewFormMultipleTypeSelector, { key: ((_d = props.statementOfFacts) === null || _d === void 0 ? void 0 : _d._id) + "-NewFormMultipleTypeSelector", value: selectedCheckboxes, setValue: setSelectedCheckboxes, editButton: typeof props.statementOfFacts !== 'undefined', readOnly: !isAllowedToCreateSOF, options: checkboxes, save: save, renderText: getCheckboxLabel }),
                !props.statementOfFacts && (React__default.createElement(Button, { primary: true, preventDoubleClick: true, onClick: save }, "Create new SOF"))))),
        !props.statementOfFacts && !isAllowedToCreateSOF && (React__default.createElement("div", { className: "sof-initialisation" }, "The statement of facts has not been created yet.")),
        sofDialogActive && (React__default.createElement(InitialiseSofDialog, { authenticationService: props.authenticationService, initialiseStatementOfFacts: props.initialiseStatementOfFacts, setSofDialogActive: setSofDialogActive, sofConfigurationsList: props.sofConfigurationsList }))));
    function saveSOF() {
        var _a, _b;
        var selectedOptions = {
            gcuUsed: false,
            tugsUtilised: false,
            gasUp: false,
            coolDown: false,
            vapourHoseConnected: false,
            heelOut: false,
            pilotUtilised: false
        };
        var options = selectedCheckboxes
            ? selectedCheckboxes
            : getEnabledFiledsInObject((_a = props.statementOfFacts) === null || _a === void 0 ? void 0 : _a.options);
        options === null || options === void 0 ? void 0 : options.forEach(function (item) {
            selectedOptions[item] = true;
        });
        props.initialiseStatementOfFacts(selectedOptions, selectedSOF ? selectedSOF : (_b = props.statementOfFacts) === null || _b === void 0 ? void 0 : _b.configuration);
    }
    function save() {
        if (typeof props.statementOfFacts === 'undefined') {
            saveSOF();
        }
        else {
            setReplaceDialog(true);
        }
    }
};
function getEnabledFiledsInObject(object) {
    if (typeof object === 'undefined')
        return [];
    return Object.keys(object).filter(function (key) { return typeof object[key] === 'boolean' && object[key]; });
}

var SOFOverview = function (props) {
    var eventId = instanceOfNominationTimelineItem(props.event)
        ? props.event.eventId
        : props.event._id;
    var _a = useSofService(props.authenticationService, eventId, props.onGenerateDocument), statementOfFacts = _a.statementOfFacts, initialiseStatementOfFacts = _a.initialiseStatementOfFacts, updateStatementOfFactsTimestamps = _a.updateStatementOfFactsTimestamps, generateStatementOfFactsDocument = _a.generateStatementOfFactsDocument, loading = _a.loading;
    // TODO: cleanup this backward compatibility message one day (added 2021-11-19)
    var vendorCompanyIdProp = props.vendorCompanyId;
    useEffect(function () {
        if (vendorCompanyIdProp) {
            console.warn('Property vendorCompanyId in component SOFOverview is deprecated. ' +
                "It is not needed at all anymore. Please don't pass this property.");
        }
    }, [vendorCompanyIdProp]);
    // in case of a delegated nomination, we must not only use the SOF configuration of the executing party
    // but the contract holding supplier aswell
    var eventAsNomination = props.event;
    var isDelegatedNomination = !!eventAsNomination.delegationOriginEventId;
    var userIsVendor = props.userProfile.companyId === eventAsNomination.vendorCompanyId;
    var vendorSofConfigurationList = useSofConfigurationService(props.authenticationService, eventAsNomination.vendorCompanyId || undefined).sofConfigurationsList;
    var companySofConfigurationList = useSofConfigurationService(props.authenticationService, isDelegatedNomination && userIsVendor ? eventAsNomination.companyId : undefined).sofConfigurationsList;
    var sofConfigurationsList = vendorSofConfigurationList.concat(companySofConfigurationList);
    // permissions
    var userPermissions = useContext(UserPermissionContext).userPermissions;
    var canViewSof = doesUserHavePermission(userPermissions, 'SOF_READ');
    var canEditSof = doesUserHavePermission(userPermissions, 'SOF_UPDATE');
    var timezone = useLocationTimeZone(props.event.locationId, props.locationService);
    if (!canViewSof) {
        return (React__default.createElement(PermissionsWarning, null, "You are not allowed to view the statement of facts."));
    }
    return (React__default.createElement("div", { className: "statement-of-facts-section " + (props.className || '') },
        React__default.createElement(LoadingIndicator, { loading: loading }),
        React__default.createElement(SofInitialisation, { statementOfFacts: statementOfFacts, authenticationService: props.authenticationService, sofConfigurationsList: sofConfigurationsList, initialiseStatementOfFacts: initialiseStatementOfFacts, key: (statementOfFacts === null || statementOfFacts === void 0 ? void 0 : statementOfFacts._id) + "-SofInitialisation" }),
        statementOfFacts && (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(SofForm$1, { timezone: timezone.value, sofTimestamps: statementOfFacts.timestamps, configuration: statementOfFacts.configuration, readOnly: !canEditSof, eventType: "nomination", saveStatementOfFactsTimestamps: updateStatementOfFactsTimestamps }),
            React__default.createElement(DocumentStatusBlock, { title: undefined, isDifferentFromInitial: false, readOnly: false, statusArray: undefined, generatePDF: generateStatementOfFactsDocument, canGeneratePDF: canEditSof },
                React__default.createElement(PDFDocumentHandler, { authenticationService: props.authenticationService, eventWithDocuments: props.event, userProfile: props.userProfile, allowedDocumentTypes: ['STATEMENT_OF_FACTS'], readOnly: false, refetchEvent: props.refetchEvent, updateItem: props.updateItem }))))));
};

var DEFAULT_FORM_VALUES$1 = {
    _type: 'bunkering',
    amount: 0,
    quantityUnit: QuantityUnit.TONNES,
    eta: '',
    etd: '',
    locationId: '',
    vendorReference: '',
    remark: '',
    supplier: '',
    bunkerShipId: null,
    pipelineId: null,
    ncomments: 0
};
var PromptBunkeringForm = function (props) {
    useEffect(function () {
        setupForm();
    }, [props.activeEvent]);
    var _a = useState(DEFAULT_FORM_VALUES$1), initialFormValue = _a[0], setInitialFormValue = _a[1];
    var _b = useState(false), removeDialogActive = _b[0], setRemoveDialogActive = _b[1];
    var readOnly = props.readOnly;
    var _c = useForm({
        initialValues: initialFormValue,
        onValidSubmit: onSubmit,
        validate: validatePromptForm
    }), handleSubmit = _c.handleSubmit, onChange = _c.onChange, onChangeValue = _c.onChangeValue, isDifferentFromInitial = _c.isDifferentFromInitial, values = _c.values, errors = _c.errors;
    var timezone = useLocationTimeZone(values === null || values === void 0 ? void 0 : values.locationId, props.locationService);
    return (React__default.createElement("form", { className: classNames('prompt-event-form', { 'not-edit': props.readOnly }) },
        React__default.createElement(Prompt, { when: isDifferentFromInitial, message: 'You have unsaved changes. Would you like to continue?' }),
        React__default.createElement(Dialog, { showDialog: removeDialogActive, onCloseDialog: function () {
                setRemoveDialogActive(false);
            }, type: "small", title: "Remove Event" },
            React__default.createElement("p", null, "Are you sure you want to delete this event? This action can not be undone."),
            React__default.createElement(ButtonGroup, null,
                React__default.createElement(Button, { danger: true, preventDoubleClick: true, onClick: function () {
                        if (props.handleRemoveEvent) {
                            props.handleRemoveEvent();
                        }
                        setRemoveDialogActive(false);
                    } }, "Remove event"))),
        React__default.createElement("div", { className: "prompt-event-content" },
            React__default.createElement("div", { className: "prompt-event-row" },
                React__default.createElement("div", { className: "prompt-event-column" },
                    React__default.createElement(FormWrapper, null,
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "bunkerShipId" }, "Bunker vessel *"),
                            React__default.createElement(SelectionBox, { fieldName: 'bunkerShipId', placeholder: 'Select Bunker Vessel...', value: (values === null || values === void 0 ? void 0 : values.bunkerShipId) || undefined, valueKey: "_id", displayKey: "name", sortOptions: true, disabled: readOnly, onChangeValue: function (option) {
                                    onChangeValue('bunkerShipId', option === null || option === void 0 ? void 0 : option._id);
                                }, options: props.bunkerShips, renderOption: function (option) { return (React__default.createElement(ShipSearchSelectOption, { ship: option, currentUser: props.userProfile })); } }),
                            React__default.createElement(FormErrorMessage, null, errors ? get(errors, 'bunkerShipId') : undefined)),
                        React__default.createElement(LocationSearch$1, { locationService: props.locationService, onChange: function (value) {
                                onChangeValue('locationId', value);
                            }, label: "Location *", disabled: readOnly, fieldName: "locationId", error: errors ? get(errors, 'locationId') : undefined, value: (values === null || values === void 0 ? void 0 : values.locationId) || '' }),
                        React__default.createElement(InlineFormElement, null,
                            React__default.createElement(FormElement, null,
                                React__default.createElement(FormLabel, { fieldName: "eta" }, "ETA *"),
                                React__default.createElement(FormFieldWrapper, null,
                                    React__default.createElement(DateTimePicker, { key: (values === null || values === void 0 ? void 0 : values._id) + " eta", name: 'eta', onDateTimeChange: function (date) { return onChangeValue('eta', date); }, disabled: readOnly, icon: React__default.createElement("i", { className: "icon-calendar-1" }), placeholder: "dd/mm/yyyy hh:mm", value: (values === null || values === void 0 ? void 0 : values.eta) || '', timeZone: timezone.value, hideDialogHeader: true, useInitialStart: 'hour' })),
                                React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'eta') : undefined })),
                            React__default.createElement(FormElement, null,
                                React__default.createElement(FormLabel, { fieldName: "etd" }, "ETD *"),
                                React__default.createElement(FormFieldWrapper, null,
                                    React__default.createElement(DateTimePicker, { key: (values === null || values === void 0 ? void 0 : values._id) + " etd", name: 'etd', onDateTimeChange: function (date) { return onChangeValue('etd', date); }, disabled: readOnly, icon: React__default.createElement("i", { className: "icon-calendar-1" }), placeholder: "dd/mm/yyyy hh:mm", value: (values === null || values === void 0 ? void 0 : values.etd) || '', timeZone: timezone.value, hideDialogHeader: true, useInitialStart: 'hour' })),
                                React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'etd') : undefined }))),
                        props.sandboxList && !props.activeEvent && (
                        // only rendering the sandbox select if it's in sandbox mode and we are creating a new event
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "sandboxId" }, "Sandbox"),
                            React__default.createElement(SelectionBox, { fieldName: 'sandboxId', placeholder: 'Select Sandbox...', value: (values === null || values === void 0 ? void 0 : values.sandboxId) || '', valueKey: "_id", displayKey: "name", sortOptions: true, disabled: readOnly, onChangeValue: function (sandbox) {
                                    onChangeValue('sandboxId', sandbox === null || sandbox === void 0 ? void 0 : sandbox._id);
                                }, options: props.sandboxList, renderOption: function (option) { return React__default.createElement(SelectOption, { label: option.name }); } }),
                            React__default.createElement(FormErrorMessage, null, errors ? get(errors, 'sandboxId') : undefined))),
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "amount" }, "Quantity"),
                            React__default.createElement("div", { className: "flex amount-and-quantityUnit-container" },
                                React__default.createElement(FormFieldWrapper, null,
                                    React__default.createElement("input", { value: values === null || values === void 0 ? void 0 : values.amount, type: "number", name: 'amount', disabled: readOnly, step: 1, min: 1, onChange: onChange })),
                                React__default.createElement(SelectionBox, { fieldName: 'quantityUnit', placeholder: 'Select quantity', value: values === null || values === void 0 ? void 0 : values.quantityUnit, renderFieldValue: function (selectedItem) {
                                        return "" + selectedItem.text;
                                    }, valueKey: "value", displayKey: "text", disabled: readOnly, onChangeValue: function (unit) {
                                        onChangeValue('quantityUnit', unit === null || unit === void 0 ? void 0 : unit.value);
                                    }, options: QUANTITY_UNITS, renderOption: function (option) { return React__default.createElement(SelectOption, { label: option.text }); } })),
                            React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'amount') : undefined })),
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "supplier" }, "Supplier"),
                            React__default.createElement(TextField, { fieldName: "supplier", disabled: readOnly, value: (values === null || values === void 0 ? void 0 : values.supplier) || '', onChange: onChange }),
                            React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'supplier') : undefined })),
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "vendorReference" }, "Reference"),
                            React__default.createElement(TextField, { fieldName: "vendorReference", disabled: readOnly, value: (values === null || values === void 0 ? void 0 : values.vendorReference) || '', onChange: onChange }),
                            React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'vendorReference') : undefined })),
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "remark" }, "Additional information"),
                            React__default.createElement("textarea", { className: "textarea", id: 'remark', name: 'remark', value: (values === null || values === void 0 ? void 0 : values.remark) || '', disabled: props.readOnly, onChange: onChange }))))),
            !readOnly && (React__default.createElement(ButtonGroup, null,
                React__default.createElement(Button, { primary: true, preventDoubleClick: true, onClick: function () {
                        handleSubmit();
                    }, disabled: !isDifferentFromInitial && !props.mergeForm, title: isDifferentFromInitial || props.mergeForm ? '' : 'No changes detected' }, props.submitText || (React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(Icon, null,
                        React__default.createElement(FontAwesomeIcon, { icon: faCalendarCheck })),
                    ' ',
                    !!props.activeEvent ? 'Save changes' : 'Add event'))),
                props.handleRemoveEvent && props.activeEvent !== undefined ? (React__default.createElement(Button, { danger: true, preventDoubleClick: true, outline: true, className: "secondary danger", onClick: function () {
                        setRemoveDialogActive(true);
                    } }, "Remove event")) : (React__default.createElement(Button, { secondary: true, preventDoubleClick: true, onClick: function () {
                        props.handleCancelForm();
                    }, disabled: false }, "Cancel")))))));
    function onSubmit(event) {
        submitChanges(event, props.handleFormEditComplete, 'bunkering', props.activeEvent, props.vendorCompanyId);
    }
    function setupForm() {
        if (props.activeEvent) {
            setInitialFormValue(props.activeEvent);
        }
        else {
            setInitialFormValue(DEFAULT_FORM_VALUES$1);
        }
    }
    function validatePromptForm(values) {
        var errors = {};
        if (!values.sandboxId && props.sandboxList && !props.activeEvent) {
            errors.sandboxId = 'Required';
        }
        if (!values.bunkerShipId) {
            errors.bunkerShipId = 'Required';
        }
        if (!values.eta) {
            errors.eta = 'Required';
        }
        if (!values.etd) {
            errors.etd = 'Required';
        }
        if (!values.locationId) {
            errors.locationId = 'Required';
        }
        if (values.eta) {
            if (values.etd &&
                isAfter(parseDateOrStringToDateTime(values.eta), parseDateOrStringToDateTime(values.etd))) {
                errors.eta = 'ETA must be before ETD';
            }
        }
        if (values.etd) {
            if (values.eta &&
                isBefore(parseDateOrStringToDateTime(values.etd), parseDateOrStringToDateTime(values.eta))) {
                errors.etd = 'ETD must be after ETA';
            }
        }
        if (values.eta && !isValidDate(values.eta)) {
            errors.eta = 'Fill in a valid date';
        }
        if (values.etd && !isValidDate(values.etd)) {
            errors.etd = 'Fill in a valid date';
        }
        return errors;
    }
};

var DEFAULT_FORM_VALUES$2 = {
    _type: 'charterout',
    eta: '',
    etd: '',
    locationId: '',
    vendorReference: '',
    remark: '',
    charterer: '',
    bunkerShipId: null,
    ncomments: 0,
    pipelineId: null
};
var PromptCharterOutForm = function (props) {
    var _a = useState(DEFAULT_FORM_VALUES$2), initialFormValue = _a[0], setInitialFormValue = _a[1];
    useEffect(function () {
        setupForm();
    }, [props.activeEvent]);
    var readOnly = props.readOnly;
    var _b = useState(false), removeDialogActive = _b[0], setRemoveDialogActive = _b[1];
    var _c = useForm({
        initialValues: initialFormValue,
        onValidSubmit: onSubmit,
        validate: validate
    }), handleSubmit = _c.handleSubmit, onChange = _c.onChange, onChangeValue = _c.onChangeValue, isDifferentFromInitial = _c.isDifferentFromInitial, values = _c.values, errors = _c.errors;
    var timezone = useLocationTimeZone(values === null || values === void 0 ? void 0 : values.locationId, props.locationService);
    return (React__default.createElement("form", { className: classNames('prompt-event-form', { 'not-edit': readOnly }), onSubmit: handleSubmit },
        React__default.createElement(Prompt, { when: isDifferentFromInitial, message: 'You have unsaved changes. Would you like to continue?' }),
        React__default.createElement(Dialog, { showDialog: removeDialogActive, onCloseDialog: function () {
                setRemoveDialogActive(false);
            }, type: "small", title: "Remove Event" },
            React__default.createElement("p", null, "Are you sure you want to delete this event? This action can not be undone."),
            React__default.createElement(ButtonGroup, null,
                React__default.createElement(Button, { danger: true, preventDoubleClick: true, onClick: function () {
                        if (props.handleRemoveEvent) {
                            props.handleRemoveEvent();
                        }
                        setRemoveDialogActive(false);
                    } }, "Remove Event"))),
        React__default.createElement("div", { className: "prompt-event-content" },
            React__default.createElement("div", { className: "prompt-event-row" },
                React__default.createElement("div", { className: "prompt-event-column" },
                    React__default.createElement(FormWrapper, null,
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "vendorReference" }, "Vendor reference"),
                            React__default.createElement(TextField, { fieldName: "vendorReference", disabled: readOnly, value: (values === null || values === void 0 ? void 0 : values.vendorReference) || '', onChange: onChange }),
                            React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'vendorReference') : undefined }))),
                    props.sandboxList && !props.activeEvent && (
                    // only rendering the sandbox select if it's in sandbox mode and we are creating a new event
                    React__default.createElement(FormElement, null,
                        React__default.createElement(FormLabel, { fieldName: "sandboxId" }, "Sandbox"),
                        React__default.createElement(SelectionBox, { fieldName: 'sandboxId', placeholder: 'Select Sandbox...', value: (values === null || values === void 0 ? void 0 : values.sandboxId) || '', valueKey: "_id", displayKey: "name", sortOptions: true, disabled: readOnly, onChangeValue: function (sandbox) {
                                onChangeValue('sandboxId', sandbox === null || sandbox === void 0 ? void 0 : sandbox._id);
                            }, options: props.sandboxList, renderOption: function (option) { return React__default.createElement(SelectOption, { label: option.name }); } }),
                        React__default.createElement(FormErrorMessage, null, errors ? get(errors, 'sandboxId') : undefined))),
                    React__default.createElement(FormElement, null,
                        React__default.createElement(FormLabel, { fieldName: "bunkerShipId" }, "Bunker vessel"),
                        React__default.createElement(SelectionBox, { fieldName: 'bunkerShipId', placeholder: 'Select Bunker Vessel...', value: (values === null || values === void 0 ? void 0 : values.bunkerShipId) || undefined, valueKey: "_id", displayKey: "name", sortOptions: true, disabled: readOnly, onChangeValue: function (option) {
                                onChangeValue('bunkerShipId', option === null || option === void 0 ? void 0 : option._id);
                            }, options: props.bunkerShips, renderOption: function (option) { return React__default.createElement(ShipSearchSelectOption, { ship: option }); } }),
                        React__default.createElement(FormErrorMessage, null, errors ? get(errors, 'bunkerShipId') : undefined)),
                    React__default.createElement(FormElement, null,
                        React__default.createElement(FormLabel, { fieldName: "charterer" }, "Charterer"),
                        React__default.createElement(TextField, { fieldName: "charterer", disabled: readOnly, value: (values === null || values === void 0 ? void 0 : values.charterer) || '', onChange: onChange }),
                        React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'charterer') : undefined })),
                    React__default.createElement(LocationSearch$1, { locationService: props.locationService, onChange: function (value) {
                            onChangeValue('locationId', value);
                        }, label: "Delivery Point", disabled: readOnly, fieldName: "locationId", error: errors ? get(errors, 'locationId') : undefined, value: (values === null || values === void 0 ? void 0 : values.locationId) || '' }),
                    React__default.createElement(InlineFormElement, null,
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "eta" }, "ETA"),
                            React__default.createElement(FormFieldWrapper, null,
                                React__default.createElement(DateTimePicker, { key: (values === null || values === void 0 ? void 0 : values._id) + " eta", name: 'eta', onDateTimeChange: function (date) { return onChangeValue('eta', date); }, disabled: readOnly, icon: React__default.createElement("i", { className: "icon-calendar-1" }), placeholder: "dd/mm/yyyy hh:mm", value: (values === null || values === void 0 ? void 0 : values.eta) || '', timeZone: timezone.value, hideDialogHeader: true, useInitialStart: 'hour' })),
                            React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'eta') : undefined })),
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "etd" }, "ETD"),
                            React__default.createElement(FormFieldWrapper, null,
                                React__default.createElement(DateTimePicker, { key: (values === null || values === void 0 ? void 0 : values._id) + " etd", name: 'etd', onDateTimeChange: function (date) { return onChangeValue('etd', date); }, disabled: readOnly, icon: React__default.createElement("i", { className: "icon-calendar-1" }), placeholder: "dd/mm/yyyy hh:mm", value: (values === null || values === void 0 ? void 0 : values.etd) || '', timeZone: timezone.value, hideDialogHeader: true, useInitialStart: 'hour' })),
                            React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'etd') : undefined }))),
                    React__default.createElement(FormElement, null,
                        React__default.createElement(FormLabel, { fieldName: "remark" }, "Additional information"),
                        React__default.createElement("textarea", { className: "textarea", id: 'remark', name: 'remark', value: (values === null || values === void 0 ? void 0 : values.remark) || '', disabled: props.readOnly, onChange: onChange })))),
            !readOnly && (React__default.createElement(ButtonGroup, null,
                React__default.createElement(Button, { primary: true, preventDoubleClick: true, onClick: function () {
                        handleSubmit();
                    }, disabled: !isDifferentFromInitial && !props.mergeForm, title: isDifferentFromInitial || props.mergeForm ? '' : 'No changes detected' }, props.submitText || (React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(Icon, null,
                        React__default.createElement(FontAwesomeIcon, { icon: faCalendarCheck })),
                    ' ',
                    !!props.activeEvent ? 'Save changes' : 'Add event'))),
                props.handleRemoveEvent && props.activeEvent !== undefined ? (React__default.createElement(Button, { danger: true, preventDoubleClick: true, outline: true, className: "secondary danger", onClick: function () {
                        setRemoveDialogActive(true);
                    } }, "Remove event")) : (React__default.createElement(Button, { secondary: true, preventDoubleClick: true, onClick: function () {
                        props.handleCancelForm();
                    }, disabled: false }, "Cancel")))))));
    function validate(event) {
        return props.sandboxList ? validateSandboxPromptForm(event) : validatePromptForm(event);
    }
    function onSubmit(event) {
        submitChanges(event, props.handleFormEditComplete, 'charterout', props.activeEvent, props.vendorCompanyId);
    }
    function setupForm() {
        if (props.activeEvent) {
            setInitialFormValue(props.activeEvent);
        }
        else {
            setInitialFormValue(DEFAULT_FORM_VALUES$2);
        }
    }
};

var DEFAULT_FORM_VALUES$3 = {
    _type: 'conditioning',
    amount: 0,
    quantityUnit: QuantityUnit.TONNES,
    eta: '',
    etd: '',
    locationId: '',
    vendorReference: '',
    remark: '',
    supplier: '',
    bunkerShipId: null,
    ncomments: 0,
    pipelineId: null
};
var PromptConditioningForm = function (props) {
    var _a = useState(DEFAULT_FORM_VALUES$3), initialFormValue = _a[0], setInitialFormValue = _a[1];
    var _b = useState(false), removeDialogActive = _b[0], setRemoveDialogActive = _b[1];
    useEffect(function () {
        setupForm();
    }, [props.activeEvent]);
    var readOnly = props.readOnly;
    var _c = useForm({
        initialValues: initialFormValue,
        onValidSubmit: onSubmit,
        validate: validatePromptForm
    }), handleSubmit = _c.handleSubmit, onChange = _c.onChange, onChangeValue = _c.onChangeValue, isDifferentFromInitial = _c.isDifferentFromInitial, values = _c.values, errors = _c.errors;
    var timezone = useLocationTimeZone(values === null || values === void 0 ? void 0 : values.locationId, props.locationService);
    return (React__default.createElement("form", { className: classNames('prompt-event-form', { 'not-edit': readOnly }), onSubmit: handleSubmit },
        React__default.createElement(Prompt, { when: isDifferentFromInitial, message: 'You have unsaved changes. Would you like to continue?' }),
        React__default.createElement(Dialog, { showDialog: removeDialogActive, onCloseDialog: function () {
                setRemoveDialogActive(false);
            }, type: "small", title: "Remove Event" },
            React__default.createElement("p", null, "Are you sure you want to delete this event? This action can not be undone."),
            React__default.createElement(ButtonGroup, null,
                React__default.createElement(Button, { danger: true, preventDoubleClick: true, onClick: function () {
                        if (props.handleRemoveEvent) {
                            props.handleRemoveEvent();
                        }
                        setRemoveDialogActive(false);
                    } }, "Remove Event"))),
        React__default.createElement("div", { className: "prompt-event-content" },
            React__default.createElement("div", { className: "prompt-event-row" },
                React__default.createElement("div", { className: "prompt-event-column" },
                    React__default.createElement(FormWrapper, null,
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "bunkerShipId" }, "Bunker vessel *"),
                            React__default.createElement(SelectionBox, { fieldName: 'bunkerShipId', placeholder: 'Select Bunker Vessel...', value: (values === null || values === void 0 ? void 0 : values.bunkerShipId) || undefined, valueKey: "_id", displayKey: "name", sortOptions: true, disabled: readOnly, onChangeValue: function (option) {
                                    onChangeValue('bunkerShipId', option === null || option === void 0 ? void 0 : option._id);
                                }, options: props.bunkerShips, renderOption: function (option) { return React__default.createElement(ShipSearchSelectOption, { ship: option }); } }),
                            React__default.createElement(FormErrorMessage, null, errors ? get(errors, 'bunkerShipId') : undefined)),
                        React__default.createElement(LocationSearch$1, { locationService: props.locationService, onChange: function (value) {
                                onChangeValue('locationId', value);
                            }, label: "Location *", disabled: readOnly, fieldName: "locationId", error: errors ? get(errors, 'locationId') : undefined, value: (values === null || values === void 0 ? void 0 : values.locationId) || '' }),
                        React__default.createElement(InlineFormElement, null,
                            React__default.createElement(FormElement, null,
                                React__default.createElement(FormLabel, { fieldName: "eta" }, "ETA *"),
                                React__default.createElement(FormFieldWrapper, null,
                                    React__default.createElement(DateTimePicker, { key: (values === null || values === void 0 ? void 0 : values._id) + " eta", name: 'eta', onDateTimeChange: function (date) { return onChangeValue('eta', date); }, disabled: readOnly, icon: React__default.createElement("i", { className: "icon-calendar-1" }), placeholder: "dd/mm/yyyy hh:mm", value: (values === null || values === void 0 ? void 0 : values.eta) || '', timeZone: timezone.value, hideDialogHeader: true, useInitialStart: 'hour' })),
                                React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'eta') : undefined })),
                            React__default.createElement(FormElement, null,
                                React__default.createElement(FormLabel, { fieldName: "etd" }, "ETD *"),
                                React__default.createElement(FormFieldWrapper, null,
                                    React__default.createElement(DateTimePicker, { key: (values === null || values === void 0 ? void 0 : values._id) + " etd", name: 'etd', onDateTimeChange: function (date) { return onChangeValue('etd', date); }, disabled: readOnly, icon: React__default.createElement("i", { className: "icon-calendar-1" }), placeholder: "dd/mm/yyyy hh:mm", value: (values === null || values === void 0 ? void 0 : values.etd) || '', timeZone: timezone.value, hideDialogHeader: true, useInitialStart: 'hour' })),
                                React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'etd') : undefined }))),
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "amount" }, "Quantity"),
                            React__default.createElement("div", { className: "flex amount-and-quantityUnit-container" },
                                React__default.createElement(FormFieldWrapper, null,
                                    React__default.createElement("input", { value: values === null || values === void 0 ? void 0 : values.amount, type: "number", name: 'amount', disabled: readOnly, step: 1, min: 1, onChange: onChange })),
                                React__default.createElement(SelectionBox, { fieldName: 'quantityUnit', placeholder: 'Select quantity', value: values === null || values === void 0 ? void 0 : values.quantityUnit, renderFieldValue: function (selectedItem) {
                                        return "" + selectedItem.text;
                                    }, valueKey: "value", displayKey: "text", disabled: readOnly, onChangeValue: function (unit) {
                                        onChangeValue('quantityUnit', unit === null || unit === void 0 ? void 0 : unit.value);
                                    }, options: QUANTITY_UNITS, renderOption: function (option) { return React__default.createElement(SelectOption, { label: option.text }); } })),
                            React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'amount') : undefined })),
                        props.sandboxList && !props.activeEvent && (
                        // only rendering the sandbox select if it's in sandbox mode and we are creating a new event
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "sandboxId" }, "Sandbox"),
                            React__default.createElement(SelectionBox, { fieldName: 'sandboxId', placeholder: 'Select Sandbox...', value: (values === null || values === void 0 ? void 0 : values.sandboxId) || '', valueKey: "_id", displayKey: "name", sortOptions: true, disabled: readOnly, onChangeValue: function (sandbox) {
                                    onChangeValue('sandboxId', sandbox === null || sandbox === void 0 ? void 0 : sandbox._id);
                                }, options: props.sandboxList, renderOption: function (option) { return React__default.createElement(SelectOption, { label: option.name }); } }),
                            React__default.createElement(FormErrorMessage, null, errors ? get(errors, 'sandboxId') : undefined))),
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "supplier" }, "Supplier"),
                            React__default.createElement(TextField, { fieldName: "supplier", disabled: readOnly, value: (values === null || values === void 0 ? void 0 : values.supplier) || '', onChange: onChange }),
                            React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'supplier') : undefined })),
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "vendorReference" }, "Reference"),
                            React__default.createElement(TextField, { fieldName: "vendorReference", disabled: readOnly, value: (values === null || values === void 0 ? void 0 : values.vendorReference) || '', onChange: onChange }),
                            React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'vendorReference') : undefined })),
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "remark" }, "Additional information"),
                            React__default.createElement("textarea", { className: "textarea", id: 'remark', name: 'remark', value: (values === null || values === void 0 ? void 0 : values.remark) || '', disabled: props.readOnly, onChange: onChange }))))),
            !readOnly && (React__default.createElement(ButtonGroup, null,
                React__default.createElement(Button, { primary: true, preventDoubleClick: true, onClick: function () {
                        handleSubmit();
                    }, disabled: !isDifferentFromInitial && !props.mergeForm, title: isDifferentFromInitial || props.mergeForm ? '' : 'No changes detected' }, props.submitText || (React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(Icon, null,
                        React__default.createElement(FontAwesomeIcon, { icon: faCalendarCheck })),
                    ' ',
                    !!props.activeEvent ? 'Save changes' : 'Add event'))),
                props.handleRemoveEvent && props.activeEvent !== undefined ? (React__default.createElement(Button, { danger: true, preventDoubleClick: true, outline: true, className: "secondary danger", onClick: function () {
                        setRemoveDialogActive(true);
                    } }, "Remove event")) : (React__default.createElement(Button, { secondary: true, preventDoubleClick: true, onClick: function () {
                        props.handleCancelForm();
                    }, disabled: false }, "Cancel")))))));
    function onSubmit(event) {
        submitChanges(event, props.handleFormEditComplete, 'conditioning', props.activeEvent, props.vendorCompanyId);
    }
    function setupForm() {
        if (props.activeEvent) {
            setInitialFormValue(props.activeEvent);
        }
        else {
            setInitialFormValue(DEFAULT_FORM_VALUES$3);
        }
    }
    function validatePromptForm(values) {
        var errors = {};
        if (!values.sandboxId && props.sandboxList && !props.activeEvent) {
            errors.sandboxId = 'Required';
        }
        if (!values.bunkerShipId) {
            errors.bunkerShipId = 'Required';
        }
        if (!values.eta) {
            errors.eta = 'Required';
        }
        if (!values.etd) {
            errors.etd = 'Required';
        }
        if (!values.locationId) {
            errors.locationId = 'Required';
        }
        if (values.eta) {
            if (values.etd &&
                isAfter(parseDateOrStringToDateTime(values.eta), parseDateOrStringToDateTime(values.etd))) {
                errors.eta = 'ETA must be before ETD';
            }
        }
        if (values.etd) {
            if (values.eta &&
                isBefore(parseDateOrStringToDateTime(values.etd), parseDateOrStringToDateTime(values.eta))) {
                errors.etd = 'ETD must be after ETA';
            }
        }
        if (values.eta && !isValidDate(values.eta)) {
            errors.eta = 'Fill in a valid date';
        }
        if (values.etd && !isValidDate(values.etd)) {
            errors.etd = 'Fill in a valid date';
        }
        return errors;
    }
};

var DEFAULT_FORM_VALUES$4 = {
    _type: 'discharge',
    amount: 0,
    quantityUnit: QuantityUnit.TONNES,
    eta: '',
    etd: '',
    ata: '',
    atd: '',
    windowStart: '',
    windowEnd: '',
    locationId: '',
    vendorReference: '',
    receiver: '',
    supplier: '',
    remark: '',
    bunkerShipId: null,
    ncomments: 0,
    pipelineId: null
};
var PromptDischargeForm = function (props) {
    var _a = useState(DEFAULT_FORM_VALUES$4), initialFormValue = _a[0], setInitialFormValue = _a[1];
    var _b = useState(false), removeDialogActive = _b[0], setRemoveDialogActive = _b[1];
    useEffect(function () {
        setupForm();
    }, [props.activeEvent]);
    var _c = useForm({
        initialValues: initialFormValue,
        onValidSubmit: onSubmit,
        validate: validate
    }), handleSubmit = _c.handleSubmit, onChange = _c.onChange, onChangeValue = _c.onChangeValue, isDifferentFromInitial = _c.isDifferentFromInitial, values = _c.values, errors = _c.errors;
    var readOnly = props.readOnly;
    var timezone = useLocationTimeZone(values === null || values === void 0 ? void 0 : values.locationId, props.locationService);
    return (React__default.createElement("form", { className: classNames('prompt-event-form', { 'not-edit': readOnly }) },
        React__default.createElement(Prompt, { when: isDifferentFromInitial, message: 'You have unsaved changes. Would you like to continue?' }),
        React__default.createElement(Dialog, { showDialog: removeDialogActive, onCloseDialog: function () {
                setRemoveDialogActive(false);
            }, type: "small", title: "Remove Event" },
            React__default.createElement("p", null, "Are you sure you want to delete this event? This action can not be undone."),
            React__default.createElement(ButtonGroup, null,
                React__default.createElement(Button, { preventDoubleClick: true, danger: true, onClick: function () {
                        if (props.handleRemoveEvent) {
                            props.handleRemoveEvent();
                        }
                        setRemoveDialogActive(false);
                    } }, "Remove event"))),
        React__default.createElement("div", { className: "prompt-event-content" },
            React__default.createElement("div", { className: "prompt-event-row" },
                React__default.createElement("div", { className: "prompt-event-column" },
                    React__default.createElement(FormWrapper, null,
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "bunkerShipId" }, "Bunker vessel *"),
                            React__default.createElement(SelectionBox, { fieldName: 'bunkerShipId', placeholder: 'Select Bunker Vessel...', value: (values === null || values === void 0 ? void 0 : values.bunkerShipId) || undefined, valueKey: "_id", displayKey: "name", sortOptions: true, disabled: readOnly, onChangeValue: function (option) {
                                    onChangeValue('bunkerShipId', option === null || option === void 0 ? void 0 : option._id);
                                }, options: props.bunkerShips, renderOption: function (option) { return React__default.createElement(ShipSearchSelectOption, { ship: option }); } }),
                            React__default.createElement(FormErrorMessage, null, errors ? get(errors, 'bunkerShipId') : undefined)),
                        React__default.createElement(LocationSearch$1, { locationService: props.locationService, onChange: function (value) {
                                onChangeValue('locationId', value);
                            }, label: "Location *", disabled: readOnly, fieldName: "locationId", error: errors ? get(errors, 'locationId') : undefined, value: (values === null || values === void 0 ? void 0 : values.locationId) || '' }),
                        React__default.createElement(InlineFormElement, null,
                            React__default.createElement(FormElement, null,
                                React__default.createElement(FormLabel, { fieldName: "eta" }, "ETA *"),
                                React__default.createElement(FormFieldWrapper, null,
                                    React__default.createElement(DateTimePicker, { key: (values === null || values === void 0 ? void 0 : values._id) + " eta", name: 'eta', onDateTimeChange: function (date) { return onChangeValue('eta', date); }, disabled: readOnly, icon: React__default.createElement("i", { className: "icon-calendar-1" }), placeholder: "dd/mm/yyyy hh:mm", value: (values === null || values === void 0 ? void 0 : values.eta) || '', timeZone: timezone.value, hideDialogHeader: true, useInitialStart: 'hour' })),
                                React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'eta') : undefined })),
                            React__default.createElement(FormElement, null,
                                React__default.createElement(FormLabel, { fieldName: "etd" }, "ETD *"),
                                React__default.createElement(FormFieldWrapper, null,
                                    React__default.createElement(DateTimePicker, { key: (values === null || values === void 0 ? void 0 : values._id) + " etd", name: 'etd', onDateTimeChange: function (date) { return onChangeValue('etd', date); }, disabled: readOnly, icon: React__default.createElement("i", { className: "icon-calendar-1" }), placeholder: "dd/mm/yyyy hh:mm", value: (values === null || values === void 0 ? void 0 : values.etd) || '', timeZone: timezone.value, hideDialogHeader: true, useInitialStart: 'hour' })),
                                React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'etd') : undefined }))),
                        React__default.createElement("h4", null, "Discharge window"),
                        React__default.createElement(InlineFormElement, null,
                            React__default.createElement(FormElement, null,
                                React__default.createElement(FormLabel, { fieldName: "windowStart" }, "Start of schedule arrival window *"),
                                React__default.createElement(FormFieldWrapper, null,
                                    React__default.createElement(DateTimePicker, { key: (values === null || values === void 0 ? void 0 : values._id) + " windowStart", name: 'windowStart', onDateTimeChange: function (date) { return onChangeValue('windowStart', date); }, disabled: readOnly, icon: React__default.createElement("i", { className: "icon-calendar-1" }), placeholder: "dd/mm/yyyy hh:mm", value: (values === null || values === void 0 ? void 0 : values.windowStart) || '', timeZone: timezone.value, hideDialogHeader: true, useInitialStart: 'hour' })),
                                React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'windowStart') : undefined })),
                            React__default.createElement(FormElement, null,
                                React__default.createElement(FormLabel, { fieldName: "windowEnd" }, "End of schedule arival window *"),
                                React__default.createElement(FormFieldWrapper, null,
                                    React__default.createElement(DateTimePicker, { key: (values === null || values === void 0 ? void 0 : values._id) + " windowEnd", name: 'windowEnd', onDateTimeChange: function (date) { return onChangeValue('windowEnd', date); }, disabled: readOnly, icon: React__default.createElement("i", { className: "icon-calendar-1" }), placeholder: "dd/mm/yyyy hh:mm", value: (values === null || values === void 0 ? void 0 : values.windowEnd) || '', timeZone: timezone.value, hideDialogHeader: true, useInitialStart: 'hour' })),
                                React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'windowEnd') : undefined }))),
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "amount" }, "Nominated quantity"),
                            React__default.createElement("div", { className: "flex amount-and-quantityUnit-container" },
                                React__default.createElement(FormFieldWrapper, null,
                                    React__default.createElement("input", { value: values === null || values === void 0 ? void 0 : values.amount, type: "number", name: 'amount', disabled: readOnly, step: 1, min: 1, onChange: onChange })),
                                React__default.createElement(SelectionBox, { fieldName: 'quantityUnit', placeholder: 'Select quantity', value: values === null || values === void 0 ? void 0 : values.quantityUnit, renderFieldValue: function (selectedItem) {
                                        return "" + selectedItem.text;
                                    }, valueKey: "value", displayKey: "text", disabled: readOnly, onChangeValue: function (unit) {
                                        onChangeValue('quantityUnit', unit === null || unit === void 0 ? void 0 : unit.value);
                                    }, options: QUANTITY_UNITS, renderOption: function (option) { return React__default.createElement(SelectOption, { label: option.text }); } })),
                            React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'amount') : undefined })),
                        props.sandboxList && !props.activeEvent && (
                        // only rendering the sandbox select if it's in sandbox mode and we are creating a new event
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "sandboxId" }, "Sandbox"),
                            React__default.createElement(SelectionBox, { fieldName: 'sandboxId', placeholder: 'Select Sandbox...', value: (values === null || values === void 0 ? void 0 : values.sandboxId) || '', valueKey: "_id", displayKey: "name", sortOptions: true, disabled: readOnly, onChangeValue: function (sandbox) {
                                    onChangeValue('sandboxId', sandbox === null || sandbox === void 0 ? void 0 : sandbox._id);
                                }, options: props.sandboxList, renderOption: function (option) { return React__default.createElement(SelectOption, { label: option.name }); } }),
                            React__default.createElement(FormErrorMessage, null, errors ? get(errors, 'sandboxId') : undefined))),
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "receiver" }, "Receiver"),
                            React__default.createElement(TextField, { fieldName: "receiver", disabled: readOnly, value: (values === null || values === void 0 ? void 0 : values.receiver) || '', onChange: onChange }),
                            React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'receiver') : undefined })),
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "supplier" }, "Supplier"),
                            React__default.createElement(TextField, { fieldName: "supplier", disabled: readOnly, value: (values === null || values === void 0 ? void 0 : values.supplier) || '', onChange: onChange }),
                            React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'supplier') : undefined })),
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "vendorReference" }, "Reference"),
                            React__default.createElement(TextField, { fieldName: "vendorReference", disabled: readOnly, value: (values === null || values === void 0 ? void 0 : values.vendorReference) || '', onChange: onChange }),
                            React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'vendorReference') : undefined })),
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "remark" }, "Additional information"),
                            React__default.createElement("textarea", { className: "textarea", id: 'remark', name: 'remark', value: (values === null || values === void 0 ? void 0 : values.remark) || '', disabled: props.readOnly, onChange: onChange }))))),
            !readOnly && (React__default.createElement(ButtonGroup, null,
                React__default.createElement(Button, { primary: true, preventDoubleClick: true, onClick: function () {
                        handleSubmit();
                    }, disabled: !isDifferentFromInitial && !props.mergeForm, title: isDifferentFromInitial || props.mergeForm ? '' : 'No changes detected' }, props.submitText || (React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(Icon, null,
                        React__default.createElement(FontAwesomeIcon, { icon: faCalendarCheck })),
                    ' ',
                    !!props.activeEvent ? 'Save changes' : 'Add event'))),
                props.handleRemoveEvent && props.activeEvent !== undefined ? (React__default.createElement(Button, { danger: true, preventDoubleClick: true, outline: true, className: "secondary danger", onClick: function () {
                        setRemoveDialogActive(true);
                    } }, "Remove event")) : (React__default.createElement(Button, { secondary: true, preventDoubleClick: true, onClick: function () {
                        props.handleCancelForm();
                    }, disabled: false }, "Cancel")))))));
    function validate(event) {
        return props.sandboxList ? validateSandboxPromptForm(event) : validatePromptForm(event);
    }
    function onSubmit(event) {
        submitChanges(event, props.handleFormEditComplete, 'discharge', props.activeEvent, props.vendorCompanyId);
    }
    function setupForm() {
        if (props.activeEvent) {
            setInitialFormValue(props.activeEvent);
        }
        else {
            setInitialFormValue(DEFAULT_FORM_VALUES$4);
        }
    }
};

var DEFAULT_FORM_VALUES$5 = {
    _type: 'lngbunkering',
    amount: 0,
    quantityUnit: QuantityUnit.TONNES,
    eta: '',
    etd: '',
    locationId: '',
    vendorReference: '',
    remark: '',
    receiver: '',
    bunkerShipId: null,
    companyId: undefined,
    receivingShipId: undefined,
    ncomments: 0,
    pipelineId: null
};
var PromptLngBunkeringForm = function (props) {
    useEffect(function () {
        setupForm();
    }, [props.activeEvent]);
    var _a = useState(DEFAULT_FORM_VALUES$5), initialFormValue = _a[0], setInitialFormValue = _a[1];
    var _b = useState(false), removeDialogActive = _b[0], setRemoveDialogActive = _b[1];
    var _c = useForm({
        initialValues: initialFormValue,
        onValidSubmit: onSubmit,
        validate: validatePromptForm
    }), handleSubmit = _c.handleSubmit, onChange = _c.onChange, onChangeValue = _c.onChangeValue, isDifferentFromInitial = _c.isDifferentFromInitial, values = _c.values, errors = _c.errors;
    var readOnly = props.readOnly;
    var timezone = useLocationTimeZone(values === null || values === void 0 ? void 0 : values.locationId, props.locationService);
    return (React__default.createElement("form", { className: classNames('prompt-event-form', { 'not-edit': readOnly }) },
        React__default.createElement(Prompt, { when: isDifferentFromInitial, message: 'You have unsaved changes. Would you like to continue?' }),
        React__default.createElement(Dialog, { showDialog: removeDialogActive, onCloseDialog: function () {
                setRemoveDialogActive(false);
            }, type: "small", title: "Remove Event" },
            React__default.createElement("p", null, "Are you sure you want to delete this event? This action can not be undone."),
            React__default.createElement(ButtonGroup, null,
                React__default.createElement(Button, { danger: true, preventDoubleClick: true, onClick: function () {
                        if (props.handleRemoveEvent) {
                            props.handleRemoveEvent();
                        }
                        setRemoveDialogActive(false);
                    } }, "Remove event"))),
        React__default.createElement("div", { className: "prompt-event-content" },
            React__default.createElement("div", { className: "prompt-event-row" },
                React__default.createElement("div", { className: "prompt-event-column" },
                    React__default.createElement(FormWrapper, null,
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "vendorReference" }, "Vendor reference"),
                            React__default.createElement(TextField, { fieldName: "vendorReference", disabled: readOnly, value: (values === null || values === void 0 ? void 0 : values.vendorReference) || '', onChange: onChange }),
                            React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'vendorReference') : undefined }))),
                    props.sandboxList && !props.activeEvent && (
                    // only rendering the sandbox select if it's in sandbox mode and we are creating a new event
                    React__default.createElement(FormElement, null,
                        React__default.createElement(FormLabel, { fieldName: "sandboxId" }, "Sandbox"),
                        React__default.createElement(SelectionBox, { fieldName: 'sandboxId', placeholder: 'Select Sandbox...', value: (values === null || values === void 0 ? void 0 : values.sandboxId) || '', valueKey: "_id", displayKey: "name", sortOptions: true, disabled: readOnly, onChangeValue: function (sandbox) {
                                onChangeValue('sandboxId', sandbox === null || sandbox === void 0 ? void 0 : sandbox._id);
                            }, options: props.sandboxList, renderOption: function (option) { return React__default.createElement(SelectOption, { label: option.name }); } }),
                        React__default.createElement(FormErrorMessage, null, errors ? get(errors, 'sandboxId') : undefined))),
                    React__default.createElement(FormElement, null,
                        React__default.createElement(FormLabel, { fieldName: "bunkerShipId" }, "Bunker vessel"),
                        React__default.createElement(SelectionBox, { fieldName: 'bunkerShipId', placeholder: 'Select Bunker Vessel...', value: (values === null || values === void 0 ? void 0 : values.bunkerShipId) || undefined, valueKey: "_id", displayKey: "name", sortOptions: true, disabled: readOnly, onChangeValue: function (option) {
                                onChangeValue('bunkerShipId', option === null || option === void 0 ? void 0 : option._id);
                            }, options: props.bunkerShips, renderOption: function (option) { return React__default.createElement(ShipSearchSelectOption, { ship: option }); } }),
                        React__default.createElement(FormErrorMessage, null, errors ? get(errors, 'bunkerShipId') : undefined)),
                    React__default.createElement(LocationSearch$1, { locationService: props.locationService, onChange: function (value) {
                            onChangeValue('locationId', value);
                        }, label: "Delivery Point", disabled: readOnly, fieldName: "locationId", error: errors ? get(errors, 'locationId') : undefined, value: (values === null || values === void 0 ? void 0 : values.locationId) || '' }),
                    React__default.createElement(FormElement, null,
                        React__default.createElement(FormLabel, { fieldName: "amount" }, "Nominated quantity"),
                        React__default.createElement("div", { className: "flex amount-and-quantityUnit-container" },
                            React__default.createElement(FormFieldWrapper, null,
                                React__default.createElement("input", { value: values === null || values === void 0 ? void 0 : values.amount, type: "number", name: 'amount', disabled: readOnly, step: 1, min: 1, onChange: onChange })),
                            React__default.createElement(SelectionBox, { fieldName: 'quantityUnit', placeholder: 'Select quantity', value: values === null || values === void 0 ? void 0 : values.quantityUnit, renderFieldValue: function (selectedItem) {
                                    return "" + selectedItem.text;
                                }, valueKey: "value", displayKey: "text", disabled: readOnly, onChangeValue: function (unit) {
                                    onChangeValue('quantityUnit', unit === null || unit === void 0 ? void 0 : unit.value);
                                }, options: QUANTITY_UNITS, renderOption: function (option) { return React__default.createElement(SelectOption, { label: option.text }); } }),
                            React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'amount') : undefined }))),
                    React__default.createElement(FormElement, null,
                        React__default.createElement(FormLabel, { fieldName: "receiver" }, "Receiver"),
                        React__default.createElement(TextField, { fieldName: "receiver", disabled: readOnly, value: (values === null || values === void 0 ? void 0 : values.receiver) || '', onChange: onChange }),
                        React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'receiver') : undefined })),
                    React__default.createElement(InlineFormElement, null,
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "eta" }, "ETA"),
                            React__default.createElement(FormFieldWrapper, null,
                                React__default.createElement(DateTimePicker, { key: (values === null || values === void 0 ? void 0 : values._id) + " eta", name: 'eta', onDateTimeChange: function (date) { return onChangeValue('eta', date); }, disabled: readOnly, icon: React__default.createElement("i", { className: "icon-calendar-1" }), placeholder: "dd/mm/yyyy hh:mm", value: (values === null || values === void 0 ? void 0 : values.eta) || '', timeZone: timezone.value, hideDialogHeader: true, useInitialStart: 'hour' })),
                            React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'eta') : undefined })),
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "etd" }, "ETD"),
                            React__default.createElement(FormFieldWrapper, null,
                                React__default.createElement(DateTimePicker, { key: (values === null || values === void 0 ? void 0 : values._id) + " etd", name: 'etd', onDateTimeChange: function (date) { return onChangeValue('etd', date); }, disabled: readOnly, icon: React__default.createElement("i", { className: "icon-calendar-1" }), placeholder: "dd/mm/yyyy hh:mm", value: (values === null || values === void 0 ? void 0 : values.etd) || '', timeZone: timezone.value, hideDialogHeader: true, useInitialStart: 'hour' })),
                            React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'etd') : undefined }))),
                    React__default.createElement(FormElement, null,
                        React__default.createElement(FormLabel, { fieldName: "remark" }, "Additional information"),
                        React__default.createElement("textarea", { className: "textarea", id: 'remark', name: 'remark', value: (values === null || values === void 0 ? void 0 : values.remark) || '', disabled: props.readOnly, onChange: onChange })))),
            !readOnly && (React__default.createElement(ButtonGroup, null,
                React__default.createElement(Button, { primary: true, preventDoubleClick: true, onClick: function () {
                        handleSubmit();
                    }, disabled: !isDifferentFromInitial && !props.mergeForm, title: isDifferentFromInitial || props.mergeForm ? '' : 'No changes detected' }, props.submitText || (React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(Icon, null,
                        React__default.createElement(FontAwesomeIcon, { icon: faCalendarCheck })),
                    ' ',
                    !!props.activeEvent ? 'Save changes' : 'Add event'))),
                props.handleRemoveEvent && props.activeEvent !== undefined ? (React__default.createElement(Button, { danger: true, preventDoubleClick: true, outline: true, className: "secondary danger", onClick: function () {
                        setRemoveDialogActive(true);
                    } }, "Remove event")) : (React__default.createElement(Button, { secondary: true, preventDoubleClick: true, onClick: function () {
                        props.handleCancelForm();
                    }, disabled: false }, "Cancel")))))));
    function setupForm() {
        if (props.activeEvent) {
            setInitialFormValue(props.activeEvent);
        }
        else {
            setInitialFormValue(DEFAULT_FORM_VALUES$5);
        }
    }
    function onSubmit(event) {
        submitChanges(event, props.handleFormEditComplete, 'lngbunkering', props.activeEvent, props.vendorCompanyId);
    }
    function validatePromptForm(values) {
        var errors = {};
        if (!values.sandboxId && props.sandboxList && !props.activeEvent) {
            errors.sandboxId = 'Required';
        }
        if (!values.eta) {
            errors.eta = 'Required';
        }
        if (!values.etd) {
            errors.etd = 'Required';
        }
        if (!values.locationId) {
            errors.locationId = 'Required';
        }
        if (values.eta) {
            if (values.etd &&
                isAfter(parseDateOrStringToDateTime(values.eta), parseDateOrStringToDateTime(values.etd))) {
                errors.eta = 'ETA must be before ETD';
            }
        }
        if (values.etd) {
            if (values.eta &&
                isBefore(parseDateOrStringToDateTime(values.etd), parseDateOrStringToDateTime(values.eta))) {
                errors.etd = 'ETD must be after ETA';
            }
        }
        if (values.eta && !isValidDate(values.eta)) {
            errors.eta = 'Fill in a valid date';
        }
        if (values.etd && !isValidDate(values.etd)) {
            errors.etd = 'Fill in a valid date';
        }
        return errors;
    }
};

var DEFAULT_FORM_VALUES$6 = {
    _type: 'loading',
    eta: '',
    etd: '',
    ata: '',
    atd: '',
    amount: 0,
    quantityUnit: QuantityUnit.TONNES,
    locationId: '',
    vendorReference: '',
    supplier: '',
    remark: '',
    receiver: '',
    gasUp: false,
    coolDown: false,
    bunkerShipId: null,
    ncomments: 0,
    windowStart: '',
    windowEnd: '',
    onBehalf: false,
    reactionOnBehalf: false,
    pipelineId: null
};
var PromptLoadingForm = function (props) {
    var _a = useState(DEFAULT_FORM_VALUES$6), initialFormValue = _a[0], setInitialFormValue = _a[1];
    var _b = useState(false), removeDialogActive = _b[0], setRemoveDialogActive = _b[1];
    var readOnly = props.readOnly;
    useEffect(function () {
        setupForm();
    }, [props.activeEvent]);
    var _c = useForm({
        initialValues: initialFormValue,
        onValidSubmit: onSubmit,
        validate: validatePromptForm
    }), handleSubmit = _c.handleSubmit, onChange = _c.onChange, onChangeValue = _c.onChangeValue, isDifferentFromInitial = _c.isDifferentFromInitial, values = _c.values, errors = _c.errors;
    var timezone = useLocationTimeZone(values === null || values === void 0 ? void 0 : values.locationId, props.locationService);
    return (React__default.createElement("form", { className: classNames('prompt-event-form', { 'not-edit': readOnly }), onSubmit: handleSubmit },
        React__default.createElement(Prompt, { when: isDifferentFromInitial, message: 'You have unsaved changes. Would you like to continue?' }),
        React__default.createElement(Dialog, { showDialog: removeDialogActive, onCloseDialog: function () {
                setRemoveDialogActive(false);
            }, type: "small", title: "Remove Event" },
            React__default.createElement("p", null, "Are you sure you want to delete this event? This action can not be undone."),
            React__default.createElement(ButtonGroup, null,
                React__default.createElement(Button, { danger: true, preventDoubleClick: true, onClick: function () {
                        if (props.handleRemoveEvent) {
                            props.handleRemoveEvent();
                        }
                        setRemoveDialogActive(false);
                    } }, "Remove event"))),
        React__default.createElement("div", { className: "prompt-event-content" },
            React__default.createElement("div", { className: "prompt-event-row" },
                React__default.createElement("div", { className: "prompt-event-column" },
                    React__default.createElement(FormWrapper, null,
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "bunkerShipId" }, "Bunker vessel *"),
                            React__default.createElement(SelectionBox, { fieldName: 'bunkerShipId', placeholder: 'Select Bunker Vessel...', value: (values === null || values === void 0 ? void 0 : values.bunkerShipId) || undefined, valueKey: "_id", displayKey: "name", sortOptions: true, disabled: readOnly, onChangeValue: function (option) {
                                    onChangeValue('bunkerShipId', option === null || option === void 0 ? void 0 : option._id);
                                }, options: props.bunkerShips, renderOption: function (option) { return React__default.createElement(ShipSearchSelectOption, { ship: option }); } }),
                            React__default.createElement(FormErrorMessage, null, errors ? get(errors, 'bunkerShipId') : undefined)),
                        React__default.createElement(LocationSearch$1, { locationService: props.locationService, onChange: function (value) {
                                onChangeValue('locationId', value);
                            }, label: "Location *", disabled: readOnly, fieldName: "locationId", error: errors ? get(errors, 'locationId') : undefined, value: (values === null || values === void 0 ? void 0 : values.locationId) || '' }),
                        React__default.createElement(InlineFormElement, null,
                            React__default.createElement(FormElement, null,
                                React__default.createElement(FormLabel, { fieldName: "eta" }, "ETA *"),
                                React__default.createElement(FormFieldWrapper, null,
                                    React__default.createElement(DateTimePicker, { key: (values === null || values === void 0 ? void 0 : values._id) + " eta", name: 'eta', onDateTimeChange: function (date) { return onChangeValue('eta', date); }, disabled: readOnly, icon: React__default.createElement("i", { className: "icon-calendar-1" }), placeholder: "dd/mm/yyyy hh:mm", value: (values === null || values === void 0 ? void 0 : values.eta) || '', timeZone: timezone.value, hideDialogHeader: true, useInitialStart: 'hour' })),
                                React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'eta') : undefined })),
                            React__default.createElement(FormElement, null,
                                React__default.createElement(FormLabel, { fieldName: "etd" }, "ETD *"),
                                React__default.createElement(FormFieldWrapper, null,
                                    React__default.createElement(DateTimePicker, { key: (values === null || values === void 0 ? void 0 : values._id) + " etd", name: 'etd', onDateTimeChange: function (date) { return onChangeValue('etd', date); }, disabled: readOnly, icon: React__default.createElement("i", { className: "icon-calendar-1" }), placeholder: "dd/mm/yyyy hh:mm", value: (values === null || values === void 0 ? void 0 : values.etd) || '', timeZone: timezone.value, hideDialogHeader: true, useInitialStart: 'hour' })),
                                React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'etd') : undefined }))),
                        props.sandboxList && !props.activeEvent && (
                        // only rendering the sandbox select if it's in sandbox mode and we are creating a new event
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "sandboxId" }, "Sandbox"),
                            React__default.createElement(SelectionBox, { fieldName: 'sandboxId', placeholder: 'Select Sandbox...', value: (values === null || values === void 0 ? void 0 : values.sandboxId) || '', valueKey: "_id", displayKey: "name", sortOptions: true, disabled: readOnly, onChangeValue: function (sandbox) {
                                    onChangeValue('sandboxId', sandbox === null || sandbox === void 0 ? void 0 : sandbox._id);
                                }, options: props.sandboxList, renderOption: function (option) { return React__default.createElement(SelectOption, { label: option.name }); } }),
                            React__default.createElement(FormErrorMessage, null, errors ? get(errors, 'sandboxId') : undefined))),
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "amount" }, "Quantity"),
                            React__default.createElement("div", { className: "flex amount-and-quantityUnit-container" },
                                React__default.createElement(FormFieldWrapper, null,
                                    React__default.createElement("input", { value: values === null || values === void 0 ? void 0 : values.amount, type: "number", name: 'amount', disabled: readOnly, step: 1, min: 1, onChange: onChange })),
                                React__default.createElement(SelectionBox, { fieldName: 'quantityUnit', placeholder: 'Select quantity', value: values === null || values === void 0 ? void 0 : values.quantityUnit, renderFieldValue: function (selectedItem) {
                                        return "" + selectedItem.text;
                                    }, valueKey: "value", displayKey: "text", disabled: readOnly, onChangeValue: function (unit) {
                                        onChangeValue('quantityUnit', unit === null || unit === void 0 ? void 0 : unit.value);
                                    }, options: QUANTITY_UNITS, renderOption: function (option) { return React__default.createElement(SelectOption, { label: option.text }); } })),
                            React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'amount') : undefined })),
                        React__default.createElement("h4", null, "Loading window"),
                        React__default.createElement(InlineFormElement, null,
                            React__default.createElement(FormElement, null,
                                React__default.createElement(FormLabel, { fieldName: "windowStart" }, "Start of schedule arrival window *"),
                                React__default.createElement(FormFieldWrapper, null,
                                    React__default.createElement(DateTimePicker, { key: (values === null || values === void 0 ? void 0 : values._id) + " windowStart", name: 'windowStart', onDateTimeChange: function (date) { return onChangeValue('windowStart', date); }, disabled: readOnly, icon: React__default.createElement("i", { className: "icon-calendar-1" }), placeholder: "dd/mm/yyyy hh:mm", value: (values === null || values === void 0 ? void 0 : values.windowStart) || '', timeZone: timezone.value, hideDialogHeader: true, useInitialStart: 'hour' })),
                                React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'windowStart') : undefined })),
                            React__default.createElement(FormElement, null,
                                React__default.createElement(FormLabel, { fieldName: "windowEnd" }, "End of schedule arival window *"),
                                React__default.createElement(FormFieldWrapper, null,
                                    React__default.createElement(DateTimePicker, { key: (values === null || values === void 0 ? void 0 : values._id) + " windowEnd", name: 'windowEnd', onDateTimeChange: function (date) { return onChangeValue('windowEnd', date); }, disabled: readOnly, icon: React__default.createElement("i", { className: "icon-calendar-1" }), placeholder: "dd/mm/yyyy hh:mm", value: (values === null || values === void 0 ? void 0 : values.windowEnd) || '', timeZone: timezone.value, hideDialogHeader: true, useInitialStart: 'hour' })),
                                React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'windowEnd') : undefined }))),
                        React__default.createElement(Checkbox, { onChange: onChange, label: 'Gas up', field: 'gasUp', value: values && values.gasUp }),
                        React__default.createElement(Checkbox, { onChange: onChange, field: 'coolDown', label: 'Cool down', value: values && values.coolDown }),
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "receiver" }, "Receiver"),
                            React__default.createElement(TextField, { fieldName: "receiver", disabled: readOnly, value: (values === null || values === void 0 ? void 0 : values.receiver) || '', onChange: onChange }),
                            React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'receiver') : undefined })),
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "supplier" }, "Supplier"),
                            React__default.createElement(TextField, { fieldName: "supplier", disabled: readOnly, value: (values === null || values === void 0 ? void 0 : values.supplier) || '', onChange: onChange }),
                            React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'supplier') : undefined })),
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "vendorReference" }, "Reference"),
                            React__default.createElement(TextField, { fieldName: "vendorReference", disabled: readOnly, value: (values === null || values === void 0 ? void 0 : values.vendorReference) || '', onChange: onChange }),
                            React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'vendorReference') : undefined })),
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "remark" }, "Additional information"),
                            React__default.createElement("textarea", { className: "textarea", id: 'remark', name: 'remark', value: (values === null || values === void 0 ? void 0 : values.remark) || '', disabled: props.readOnly, onChange: onChange }))))),
            !readOnly && (React__default.createElement(ButtonGroup, null,
                React__default.createElement(Button, { primary: true, preventDoubleClick: true, onClick: function () {
                        handleSubmit();
                    }, disabled: !isDifferentFromInitial && !props.mergeForm, title: isDifferentFromInitial || props.mergeForm ? '' : 'No changes detected' }, props.submitText || (React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(Icon, null,
                        React__default.createElement(FontAwesomeIcon, { icon: faCalendarCheck })),
                    ' ',
                    !!props.activeEvent ? 'Save changes' : 'Add event'))),
                props.handleRemoveEvent && props.activeEvent !== undefined ? (React__default.createElement(Button, { preventDoubleClick: true, danger: true, outline: true, className: "secondary danger", onClick: function () {
                        setRemoveDialogActive(true);
                    } }, "Remove event")) : (React__default.createElement(Button, { secondary: true, preventDoubleClick: true, onClick: function () {
                        props.handleCancelForm();
                    }, disabled: false }, "Cancel")))))));
    function onSubmit(event) {
        submitChanges(event, props.handleFormEditComplete, 'loading', props.activeEvent, props.vendorCompanyId);
    }
    function setupForm() {
        if (props.activeEvent) {
            setInitialFormValue(props.activeEvent);
        }
        else {
            setInitialFormValue(DEFAULT_FORM_VALUES$6);
        }
    }
    function validatePromptForm(values) {
        var errors = {};
        if (!values.sandboxId && props.sandboxList && !props.activeEvent) {
            errors.sandboxId = 'Required';
        }
        if (!values.bunkerShipId) {
            errors.bunkerShipId = 'Required';
        }
        if (!values.eta) {
            errors.eta = 'Required';
        }
        if (!values.etd) {
            errors.etd = 'Required';
        }
        if (!values.windowStart) {
            errors.windowStart = 'Required';
        }
        if (!values.windowEnd) {
            errors.windowEnd = 'Required';
        }
        if (!values.locationId) {
            errors.locationId = 'Required';
        }
        if (values.eta) {
            if (values.etd &&
                isAfter(parseDateOrStringToDateTime(values.eta), parseDateOrStringToDateTime(values.etd))) {
                errors.eta = 'ETA must be before ETD';
            }
        }
        if (values.etd) {
            if (values.eta &&
                isBefore(parseDateOrStringToDateTime(values.etd), parseDateOrStringToDateTime(values.eta))) {
                errors.etd = 'ETD must be after ETA';
            }
        }
        if (values.windowEnd) {
            if (values.windowStart &&
                isBefore(parseDateOrStringToDateTime(values.windowEnd), parseDateOrStringToDateTime(values.windowStart))) {
                errors.windowEnd = 'End must be after Start';
            }
        }
        if (values.windowStart) {
            if (values.windowEnd &&
                isAfter(parseDateOrStringToDateTime(values.windowStart), parseDateOrStringToDateTime(values.windowEnd))) {
                errors.windowStart = 'Start must be before End ';
            }
        }
        if (values.eta && !isValidDate(values.eta)) {
            errors.eta = 'Fill in a valid date';
        }
        if (values.etd && !isValidDate(values.etd)) {
            errors.etd = 'Fill in a valid date';
        }
        if (values.windowStart && !isValidDate(values.windowStart)) {
            errors.windowStart = 'Fill in a valid date';
        }
        if (values.windowEnd && !isValidDate(values.windowEnd)) {
            errors.windowEnd = 'Fill in a valid date';
        }
        return errors;
    }
};

var DEFAULT_FORM_VALUES$7 = {
    _type: 'maintenance',
    eta: '',
    etd: '',
    locationId: '',
    vendorReference: '',
    remark: '',
    bunkerShipId: null,
    ncomments: 0,
    pipelineId: null
};
var PromptMaintenanceForm = function (props) {
    var _a = useState(DEFAULT_FORM_VALUES$7), initialFormValue = _a[0], setInitialFormValue = _a[1];
    var _b = useState(false), removeDialogActive = _b[0], setRemoveDialogActive = _b[1];
    var readOnly = props.readOnly;
    useEffect(function () {
        setupForm();
    }, [props.activeEvent]);
    var _c = useForm({
        initialValues: initialFormValue,
        onValidSubmit: onSubmit,
        validate: validate
    }), handleSubmit = _c.handleSubmit, onChange = _c.onChange, onChangeValue = _c.onChangeValue, isDifferentFromInitial = _c.isDifferentFromInitial, values = _c.values, errors = _c.errors;
    var timezone = useLocationTimeZone(values === null || values === void 0 ? void 0 : values.locationId, props.locationService);
    return (React__default.createElement("form", { className: classNames('prompt-event-form', { 'not-edit': readOnly }) },
        React__default.createElement(Prompt, { when: isDifferentFromInitial, message: 'You have unsaved changes. Would you like to continue?' }),
        React__default.createElement(Dialog, { showDialog: removeDialogActive, onCloseDialog: function () {
                setRemoveDialogActive(false);
            }, type: "small", title: "Remove Event" },
            React__default.createElement("p", null, "Are you sure you want to delete this event? This action can not be undone."),
            React__default.createElement(ButtonGroup, null,
                React__default.createElement(Button, { preventDoubleClick: true, danger: true, onClick: function () {
                        if (props.handleRemoveEvent) {
                            props.handleRemoveEvent();
                        }
                        setRemoveDialogActive(false);
                    } }, "Remove event"))),
        React__default.createElement("div", { className: "prompt-event-content" },
            React__default.createElement("div", { className: "prompt-event-row" },
                React__default.createElement("div", { className: "prompt-event-column" },
                    React__default.createElement(FormWrapper, null,
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "bunkerShipId" }, "Bunker vessel *"),
                            React__default.createElement(SelectionBox, { fieldName: 'bunkerShipId', placeholder: 'Select Bunker Vessel...', value: (values === null || values === void 0 ? void 0 : values.bunkerShipId) || undefined, valueKey: "_id", displayKey: "name", sortOptions: true, disabled: readOnly, onChangeValue: function (option) {
                                    onChangeValue('bunkerShipId', option === null || option === void 0 ? void 0 : option._id);
                                }, options: props.bunkerShips, renderOption: function (option) { return React__default.createElement(ShipSearchSelectOption, { ship: option }); } }),
                            React__default.createElement(FormErrorMessage, null, errors ? get(errors, 'bunkerShipId') : undefined)),
                        React__default.createElement(LocationSearch$1, { locationService: props.locationService, onChange: function (value) {
                                onChangeValue('locationId', value);
                            }, label: "Location *", disabled: readOnly, fieldName: "locationId", error: errors ? get(errors, 'locationId') : undefined, value: (values === null || values === void 0 ? void 0 : values.locationId) || '' }),
                        React__default.createElement(InlineFormElement, null,
                            React__default.createElement(FormElement, null,
                                React__default.createElement(FormLabel, { fieldName: "eta" }, "ETA *"),
                                React__default.createElement(FormFieldWrapper, null,
                                    React__default.createElement(DateTimePicker, { key: (values === null || values === void 0 ? void 0 : values._id) + " eta", name: 'eta', onDateTimeChange: function (date) { return onChangeValue('eta', date); }, disabled: readOnly, icon: React__default.createElement("i", { className: "icon-calendar-1" }), placeholder: "dd/mm/yyyy hh:mm", value: (values === null || values === void 0 ? void 0 : values.eta) || '', timeZone: timezone.value, hideDialogHeader: true, useInitialStart: 'hour' })),
                                React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'eta') : undefined })),
                            React__default.createElement(FormElement, null,
                                React__default.createElement(FormLabel, { fieldName: "etd" }, "ETD *"),
                                React__default.createElement(FormFieldWrapper, null,
                                    React__default.createElement(DateTimePicker, { key: (values === null || values === void 0 ? void 0 : values._id) + " etd", name: 'etd', onDateTimeChange: function (date) { return onChangeValue('etd', date); }, disabled: readOnly, icon: React__default.createElement("i", { className: "icon-calendar-1" }), placeholder: "dd/mm/yyyy hh:mm", value: (values === null || values === void 0 ? void 0 : values.etd) || '', timeZone: timezone.value, hideDialogHeader: true, useInitialStart: 'hour' })),
                                React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'etd') : undefined }))),
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "vendorReference" }, "Reference"),
                            React__default.createElement(TextField, { fieldName: "vendorReference", disabled: readOnly, value: (values === null || values === void 0 ? void 0 : values.vendorReference) || '', onChange: onChange }),
                            React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'vendorReference') : undefined })),
                        props.sandboxList && !props.activeEvent && (
                        // only rendering the sandbox select if it's in sandbox mode and we are creating a new event
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "sandboxId" }, "Sandbox"),
                            React__default.createElement(SelectionBox, { fieldName: 'sandboxId', placeholder: 'Select Sandbox...', value: (values === null || values === void 0 ? void 0 : values.sandboxId) || '', valueKey: "_id", displayKey: "name", sortOptions: true, disabled: readOnly, onChangeValue: function (sandbox) {
                                    onChangeValue('sandboxId', sandbox === null || sandbox === void 0 ? void 0 : sandbox._id);
                                }, options: props.sandboxList, renderOption: function (option) { return React__default.createElement(SelectOption, { label: option.name }); } }),
                            React__default.createElement(FormErrorMessage, null, errors ? get(errors, 'sandboxId') : undefined))),
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "remark" }, "Additional information"),
                            React__default.createElement("textarea", { className: "textarea", id: 'remark', name: 'remark', value: (values === null || values === void 0 ? void 0 : values.remark) || '', disabled: props.readOnly, onChange: onChange }))))),
            !readOnly && (React__default.createElement(ButtonGroup, null,
                React__default.createElement(Button, { primary: true, preventDoubleClick: true, onClick: function () {
                        handleSubmit();
                    }, disabled: !isDifferentFromInitial && !props.mergeForm, title: isDifferentFromInitial || props.mergeForm ? '' : 'No changes detected' }, props.submitText || (React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(Icon, null,
                        React__default.createElement(FontAwesomeIcon, { icon: faCalendarCheck })),
                    ' ',
                    !!props.activeEvent ? 'Save changes' : 'Add event'))),
                props.handleRemoveEvent && props.activeEvent !== undefined ? (React__default.createElement(Button, { preventDoubleClick: true, danger: true, outline: true, className: "secondary danger", onClick: function () {
                        setRemoveDialogActive(true);
                    } }, "Remove event")) : (React__default.createElement(Button, { secondary: true, preventDoubleClick: true, onClick: function () {
                        props.handleCancelForm();
                    }, disabled: false }, "Cancel")))))));
    function validate(event) {
        return props.sandboxList ? validateSandboxPromptForm(event) : validatePromptForm(event);
    }
    function onSubmit(event) {
        submitChanges(event, props.handleFormEditComplete, 'maintenance', props.activeEvent, props.vendorCompanyId);
    }
    function setupForm() {
        if (props.activeEvent) {
            setInitialFormValue(props.activeEvent);
        }
        else {
            setInitialFormValue(DEFAULT_FORM_VALUES$7);
        }
    }
};

var DEFAULT_FORM_VALUES$8 = {
    _type: 'pool',
    eta: '',
    etd: '',
    vendorReference: '',
    remark: '',
    bunkerShipId: null,
    ncomments: 0,
    pipelineId: null
};
var PromptPoolForm = function (props) {
    var _a = useState(DEFAULT_FORM_VALUES$8), initialFormValue = _a[0], setInitialFormValue = _a[1];
    var _b = useState(false), removeDialogActive = _b[0], setRemoveDialogActive = _b[1];
    var readOnly = props.readOnly;
    useEffect(function () {
        setupForm();
    }, [props.activeEvent]);
    var _c = useForm({
        initialValues: initialFormValue,
        onValidSubmit: onSubmit,
        validate: validate
    }), handleSubmit = _c.handleSubmit, onChange = _c.onChange, onChangeValue = _c.onChangeValue, isDifferentFromInitial = _c.isDifferentFromInitial, values = _c.values, errors = _c.errors;
    return (React__default.createElement("form", { className: classNames('prompt-event-form', { 'not-edit': readOnly }), onSubmit: handleSubmit },
        React__default.createElement(Prompt, { when: isDifferentFromInitial, message: 'You have unsaved changes. Would you like to continue?' }),
        React__default.createElement(Dialog, { showDialog: removeDialogActive, onCloseDialog: function () {
                setRemoveDialogActive(false);
            }, type: "small", title: "Remove Event" },
            React__default.createElement("p", null, "Are you sure you want to delete this event? This action can not be undone."),
            React__default.createElement(ButtonGroup, null,
                React__default.createElement(Button, { preventDoubleClick: true, danger: true, onClick: function () {
                        if (props.handleRemoveEvent) {
                            props.handleRemoveEvent();
                        }
                        setRemoveDialogActive(false);
                    } }, "Remove event"))),
        React__default.createElement("div", { className: "prompt-event-content" },
            React__default.createElement("div", { className: "prompt-event-row" },
                React__default.createElement("div", { className: "prompt-event-column" },
                    React__default.createElement(FormWrapper, null,
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "vendorReference" }, "Vendor reference"),
                            React__default.createElement(TextField, { fieldName: "vendorReference", disabled: readOnly, value: (values === null || values === void 0 ? void 0 : values.vendorReference) || '', onChange: onChange }),
                            React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'vendorReference') : undefined })),
                        props.sandboxList && !props.activeEvent && (
                        // only rendering the sandbox select if it's in sandbox mode and we are creating a new event
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "sandboxId" }, "Sandbox"),
                            React__default.createElement(SelectionBox, { fieldName: 'sandboxId', placeholder: 'Select Sandbox...', value: (values === null || values === void 0 ? void 0 : values.sandboxId) || '', valueKey: "_id", displayKey: "name", sortOptions: true, disabled: readOnly, onChangeValue: function (sandbox) {
                                    onChangeValue('sandboxId', sandbox === null || sandbox === void 0 ? void 0 : sandbox._id);
                                }, options: props.sandboxList, renderOption: function (option) { return React__default.createElement(SelectOption, { label: option.name }); } }),
                            React__default.createElement(FormErrorMessage, null, errors ? get(errors, 'sandboxId') : undefined))),
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "bunkerShipId" }, "Bunker vessel"),
                            React__default.createElement(SelectionBox, { fieldName: 'bunkerShipId', placeholder: 'Select Bunker Vessel...', value: (values === null || values === void 0 ? void 0 : values.bunkerShipId) || undefined, valueKey: "_id", displayKey: "name", sortOptions: true, disabled: readOnly, onChangeValue: function (option) {
                                    onChangeValue('bunkerShipId', option === null || option === void 0 ? void 0 : option._id);
                                }, options: props.bunkerShips, renderOption: function (option) { return (React__default.createElement(ShipSearchSelectOption, { ship: option, currentUser: props.userProfile })); } }),
                            React__default.createElement(FormErrorMessage, null, errors ? get(errors, 'bunkerShipId') : undefined)),
                        React__default.createElement(InlineFormElement, null,
                            React__default.createElement(FormElement, null,
                                React__default.createElement(FormLabel, { fieldName: "eta" }, "ETA"),
                                React__default.createElement(FormFieldWrapper, null,
                                    React__default.createElement(DateTimePicker, { key: (values === null || values === void 0 ? void 0 : values._id) + " eta", name: 'eta', onDateTimeChange: function (date) { return onChangeValue('eta', date); }, disabled: readOnly, icon: React__default.createElement("i", { className: "icon-calendar-1" }), placeholder: "dd/mm/yyyy hh:mm", value: (values === null || values === void 0 ? void 0 : values.eta) || '', hideDialogHeader: true, useInitialStart: 'hour' })),
                                React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'eta') : undefined })),
                            React__default.createElement(FormElement, null,
                                React__default.createElement(FormLabel, { fieldName: "etd" }, "ETD"),
                                React__default.createElement(FormFieldWrapper, null,
                                    React__default.createElement(DateTimePicker, { key: (values === null || values === void 0 ? void 0 : values._id) + " etd", name: 'etd', onDateTimeChange: function (date) { return onChangeValue('etd', date); }, disabled: readOnly, icon: React__default.createElement("i", { className: "icon-calendar-1" }), placeholder: "dd/mm/yyyy hh:mm", value: (values === null || values === void 0 ? void 0 : values.etd) || '', hideDialogHeader: true, useInitialStart: 'hour' })),
                                React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'etd') : undefined }))),
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "remark" }, "Additional information"),
                            React__default.createElement("textarea", { className: "textarea", id: 'remark', name: 'remark', value: (values === null || values === void 0 ? void 0 : values.remark) || '', disabled: props.readOnly, onChange: onChange }))))),
            !readOnly && (React__default.createElement(ButtonGroup, null,
                React__default.createElement(Button, { primary: true, preventDoubleClick: true, onClick: function () {
                        handleSubmit();
                    }, disabled: !isDifferentFromInitial && !props.mergeForm, title: isDifferentFromInitial || props.mergeForm ? '' : 'No changes detected' }, props.submitText || (React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(Icon, null,
                        React__default.createElement(FontAwesomeIcon, { icon: faCalendarCheck })),
                    ' ',
                    !!props.activeEvent ? 'Save changes' : 'Add event'))),
                props.handleRemoveEvent && props.activeEvent !== undefined ? (React__default.createElement(Button, { danger: true, outline: true, preventDoubleClick: true, className: "secondary danger", onClick: function () {
                        setRemoveDialogActive(true);
                    } }, "Remove event")) : (React__default.createElement(Button, { secondary: true, preventDoubleClick: true, onClick: function () {
                        props.handleCancelForm();
                    }, disabled: false }, "Cancel")))))));
    function validate(event) {
        return props.sandboxList ? validateSandboxPromptForm(event) : validatePromptForm(event);
    }
    function onSubmit(event) {
        submitChanges(event, props.handleFormEditComplete, 'pool', props.activeEvent, props.vendorCompanyId);
    }
    function setupForm() {
        if (props.activeEvent) {
            setInitialFormValue(props.activeEvent);
        }
        else {
            setInitialFormValue(DEFAULT_FORM_VALUES$8);
        }
    }
};

var DEFAULT_FORM_VALUES$9 = {
    _type: 'tentative',
    eta: '',
    etd: '',
    locationId: '',
    vendorReference: '',
    remark: '',
    receiver: '',
    supplier: '',
    sourceId: '',
    destinationId: '',
    amount: 0,
    quantityUnit: QuantityUnit.TONNES,
    bunkerShipId: null,
    companyId: undefined,
    receivingShipId: undefined,
    gasUp: false,
    coolDown: false,
    ncomments: 0,
    pipelineId: null
};
var tentativeEventOptions = [
    { label: 'Bunkering', value: 'bunkering' },
    { label: 'Charter Out', value: 'charterout' },
    { label: 'Conditioning', value: 'conditioning' },
    { label: 'Discharge', value: 'discharge' },
    { label: 'LNG Bunkering', value: 'lngbunkering' },
    { label: 'Loading', value: 'loading' },
    { label: 'Maintenance', value: 'maintenance' },
    { label: 'Nomination', value: 'nomination' },
    { label: 'Pool', value: 'pool' },
    { label: 'Travel', value: 'travel' },
    { label: 'Waiting', value: 'waiting' }
];
var PromptTentativeForm = function (props) {
    var _a = useState(DEFAULT_FORM_VALUES$9), initialFormValue = _a[0], setInitialFormValue = _a[1];
    var _b = useState(false), removeDialogActive = _b[0], setRemoveDialogActive = _b[1];
    var readOnly = props.readOnly;
    useEffect(function () {
        setupForm();
    }, [props.activeEvent]);
    var _c = useForm({
        initialValues: initialFormValue,
        onValidSubmit: onSubmit,
        validate: validateTentativeForm
    }), handleSubmit = _c.handleSubmit, onChange = _c.onChange, onChangeValue = _c.onChangeValue, isDifferentFromInitial = _c.isDifferentFromInitial, values = _c.values, errors = _c.errors, triggerValidation = _c.triggerValidation, setAllValues = _c.setAllValues;
    var companyId = values === null || values === void 0 ? void 0 : values.companyId;
    useEffect(function () {
        if (companyId) {
            fetchCustomerFleetList(companyId);
        }
    }, [companyId]);
    var userRoles = props.userProfile ? props.userProfile.roles : undefined;
    var _d = useState([]), customerFleet = _d[0], setCustomerFleet = _d[1];
    var timezone = useLocationTimeZone(values === null || values === void 0 ? void 0 : values.locationId, props.locationService);
    // used to check if the tentative conversion button must become visible
    var isTentativeNomination = props.activeEvent &&
        props.activeEvent._type &&
        props.activeEvent.tentativeType === 'nomination' &&
        (values === null || values === void 0 ? void 0 : values.tentativeType) === 'nomination' &&
        !props.activeEvent.sandboxId;
    return (React__default.createElement("form", { className: classNames('prompt-event-form', { 'not-edit': readOnly }) },
        React__default.createElement(Prompt, { when: isDifferentFromInitial, message: 'You have unsaved changes. Would you like to continue?' }),
        React__default.createElement(Dialog, { showDialog: removeDialogActive, onCloseDialog: function () {
                setRemoveDialogActive(false);
            }, type: "small", title: "Remove Event" },
            React__default.createElement("p", null, "Are you sure you want to delete this event? This action can not be undone."),
            React__default.createElement(ButtonGroup, null,
                React__default.createElement(Button, { danger: true, preventDoubleClick: true, onClick: function () {
                        if (props.handleRemoveEvent) {
                            props.handleRemoveEvent();
                        }
                        setRemoveDialogActive(false);
                    } }, "Remove event"))),
        React__default.createElement("div", { className: "prompt-event-content" },
            React__default.createElement("div", { className: "prompt-event-row" },
                React__default.createElement("div", { className: "prompt-event-column" },
                    React__default.createElement(FormWrapper, null,
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "vendorReference" }, "Vendor reference"),
                            React__default.createElement(TextField, { fieldName: "vendorReference", disabled: readOnly, value: (values === null || values === void 0 ? void 0 : values.vendorReference) || '', onChange: onChange }),
                            React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'vendorReference') : undefined })),
                        props.sandboxList && !props.activeEvent && (
                        // only rendering the sandbox select if it's in sandbox mode and we are creating a new event
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "sandboxId" }, "Sandbox"),
                            React__default.createElement(SelectionBox, { fieldName: 'sandboxId', placeholder: 'Select Sandbox...', value: (values === null || values === void 0 ? void 0 : values.sandboxId) || '', valueKey: "_id", displayKey: "name", sortOptions: true, disabled: readOnly, onChangeValue: function (sandbox) {
                                    onChangeValue('sandboxId', sandbox === null || sandbox === void 0 ? void 0 : sandbox._id);
                                }, options: props.sandboxList, renderOption: function (option) { return React__default.createElement(SelectOption, { label: option.name }); } }),
                            React__default.createElement(FormErrorMessage, null, errors ? get(errors, 'sandboxId') : undefined))),
                        isCustomer(userRoles) ? null : (React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "tentativeType" }, "Tentative type"),
                            React__default.createElement(SelectionBox, { fieldName: 'tentativeType', value: (values === null || values === void 0 ? void 0 : values.tentativeType) || '', placeholder: 'Select Type...', valueKey: "value", displayKey: "label", sortOptions: true, disabled: readOnly, onChangeValue: function (eventType) {
                                    onChangeValue('tentativeType', eventType === null || eventType === void 0 ? void 0 : eventType.value);
                                }, options: tentativeEventOptions, renderOption: function (option) { return React__default.createElement(SelectOption, { label: option.value }); } }),
                            React__default.createElement(FormErrorMessage, null, errors ? get(errors, 'tentativeType') : undefined))),
                        isCustomer(userRoles) ? null : (React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "bunkerShipId" }, "Bunker vessel"),
                            React__default.createElement(SelectionBox, { fieldName: 'bunkerShipId', placeholder: 'Select Bunker Vessel...', value: (values === null || values === void 0 ? void 0 : values.bunkerShipId) || undefined, valueKey: "_id", displayKey: "name", sortOptions: true, disabled: readOnly, onChangeValue: function (option) {
                                    onChangeValue('bunkerShipId', option === null || option === void 0 ? void 0 : option._id);
                                }, options: props.bunkerShips, renderOption: function (option) { return React__default.createElement(ShipSearchSelectOption, { ship: option }); } }),
                            React__default.createElement(FormErrorMessage, null, errors ? get(errors, 'bunkerShipId') : undefined))),
                        props.companies && (React__default.createElement(React__default.Fragment, null,
                            isCustomer(userRoles) ? null : (React__default.createElement(FormElement, null,
                                React__default.createElement(FormLabel, { fieldName: "companyId" }, "Select company"),
                                React__default.createElement(SelectionBox, { value: values === null || values === void 0 ? void 0 : values.companyId, fieldName: "companyId", placeholder: 'Select Company...', onChangeValue: function (company) {
                                        var newValues = __assign(__assign({}, values), { receivingShipId: undefined, companyId: company === null || company === void 0 ? void 0 : company._id });
                                        setAllValues(newValues);
                                    }, options: props.companies, valueKey: '_id', displayKey: "name", renderOption: function (option) {
                                        return React__default.createElement("div", null, option.name);
                                    } }),
                                React__default.createElement(FormErrorMessage, null, errors === null || errors === void 0 ? void 0 : errors.companyId))),
                            React__default.createElement(FormElement, null,
                                React__default.createElement(FormLabel, { fieldName: "receivingShipId" }, "Receiving vessel"),
                                React__default.createElement(SelectionBox, { fieldName: 'receivingShipId', value: values === null || values === void 0 ? void 0 : values.receivingShipId, placeholder: 'Select Receiving Vessel...', valueKey: "_id", displayKey: "name", sortOptions: true, disabled: readOnly, onChangeValue: function (option) {
                                        onChangeValue('receivingShipId', option === null || option === void 0 ? void 0 : option._id);
                                    }, options: customerFleet, renderOption: function (option) { return (React__default.createElement(ShipSearchSelectOption, { ship: option, currentUser: props.userProfile })); } }),
                                React__default.createElement(FormErrorMessage, null, errors ? get(errors, 'receivingShipId') : undefined)))),
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "amount" }, "Nominated quantity"),
                            React__default.createElement("div", { className: "flex amount-and-quantityUnit-container" },
                                React__default.createElement(FormFieldWrapper, null,
                                    React__default.createElement("input", { value: values === null || values === void 0 ? void 0 : values.amount, type: "number", name: 'amount', disabled: readOnly, step: 1, min: 1, onChange: onChange })),
                                React__default.createElement(SelectionBox, { fieldName: 'quantityUnit', placeholder: 'Select quantity', value: values === null || values === void 0 ? void 0 : values.quantityUnit, renderFieldValue: function (selectedItem) {
                                        return "" + selectedItem.text;
                                    }, valueKey: "value", displayKey: "text", disabled: readOnly, onChangeValue: function (unit) {
                                        onChangeValue('quantityUnit', unit === null || unit === void 0 ? void 0 : unit.value);
                                    }, options: QUANTITY_UNITS, renderOption: function (option) { return React__default.createElement(SelectOption, { label: option.text }); } })),
                            React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'amount') : undefined })),
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "receiver" }, "Receiver"),
                            React__default.createElement(TextField, { fieldName: "receiver", disabled: readOnly, value: (values === null || values === void 0 ? void 0 : values.receiver) || '', onChange: onChange }),
                            React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'receiver') : undefined })),
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "supplier" }, "Supplier"),
                            React__default.createElement(TextField, { fieldName: "supplier", disabled: readOnly, value: (values === null || values === void 0 ? void 0 : values.supplier) || '', onChange: onChange }),
                            React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'supplier') : undefined })),
                        React__default.createElement(LocationSearch$1, { locationService: props.locationService, onChange: function (value) {
                                onChangeValue('locationId', value);
                            }, label: "Delivery Point", disabled: readOnly, fieldName: "locationId", error: errors ? get(errors, 'locationId') : undefined, value: (values === null || values === void 0 ? void 0 : values.locationId) || '' }),
                        React__default.createElement(LocationSearch$1, { locationService: props.locationService, onChange: function (value) {
                                onChangeValue('destinationId', value);
                            }, label: "Destination", disabled: readOnly, fieldName: "destinationId", error: errors ? get(errors, 'destinationId') : undefined, value: (values === null || values === void 0 ? void 0 : values.destinationId) || '' }),
                        React__default.createElement(InlineFormElement, null,
                            React__default.createElement(FormElement, null,
                                React__default.createElement(FormLabel, { fieldName: "eta" }, "ETA"),
                                React__default.createElement(FormFieldWrapper, null,
                                    React__default.createElement(DateTimePicker, { key: (values === null || values === void 0 ? void 0 : values._id) + " eta", name: 'eta', onDateTimeChange: function (date) { return onChangeValue('eta', date); }, disabled: readOnly, icon: React__default.createElement("i", { className: "icon-calendar-1" }), placeholder: "dd/mm/yyyy hh:mm", value: (values === null || values === void 0 ? void 0 : values.eta) || '', timeZone: timezone.value, hideDialogHeader: true, useInitialStart: 'hour' })),
                                React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'eta') : undefined })),
                            React__default.createElement(FormElement, null,
                                React__default.createElement(FormLabel, { fieldName: "etd" }, "ETD"),
                                React__default.createElement(FormFieldWrapper, null,
                                    React__default.createElement(DateTimePicker, { key: (values === null || values === void 0 ? void 0 : values._id) + " etd", name: 'etd', onDateTimeChange: function (date) { return onChangeValue('etd', date); }, disabled: readOnly, icon: React__default.createElement("i", { className: "icon-calendar-1" }), placeholder: "dd/mm/yyyy hh:mm", value: (values === null || values === void 0 ? void 0 : values.etd) || '', timeZone: timezone.value, hideDialogHeader: true, useInitialStart: 'hour' })),
                                React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'etd') : undefined }))),
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "remark" }, "Additional information"),
                            React__default.createElement("textarea", { className: "textarea", id: 'remark', name: 'remark', value: (values === null || values === void 0 ? void 0 : values.remark) || '', disabled: props.readOnly, onChange: onChange }))))),
            !readOnly && (React__default.createElement(ButtonGroup, null,
                React__default.createElement(Button, { primary: true, preventDoubleClick: true, onClick: function () {
                        handleSubmit();
                    }, disabled: !isDifferentFromInitial && !props.mergeForm, title: isDifferentFromInitial || props.mergeForm ? '' : 'No changes detected' }, props.submitText || (React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(Icon, null,
                        React__default.createElement(FontAwesomeIcon, { icon: faCalendarCheck })),
                    ' ',
                    !!props.activeEvent ? 'Save changes' : 'Add event'))),
                isTentativeNomination && props.convertTentativeToNomination && (React__default.createElement(Button, { preventDoubleClick: true, disabled: isDifferentFromInitial, title: 'Please submit your changes first', primary: true, outline: true, onClick: handleConvertToFirm }, "Convert to nomination")),
                props.handleRemoveEvent && props.activeEvent !== undefined ? (React__default.createElement(Button, { preventDoubleClick: true, danger: true, outline: true, className: "secondary danger", onClick: function () {
                        setRemoveDialogActive(true);
                    } }, "Remove event")) : (React__default.createElement(Button, { secondary: true, preventDoubleClick: true, onClick: function () {
                        props.handleCancelForm();
                    }, disabled: false }, "Cancel")))))));
    function validateTentativeForm(event) {
        return props.sandboxList
            ? validateSandboxPromptForm(event)
            : event.tentativeType && event.tentativeType === 'nomination'
                ? validateTentativeNomination(event)
                : validatePromptForm(event);
    }
    function fetchCustomerFleetList(companyId) {
        return __awaiter(this, void 0, void 0, function () {
            var fleetList, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, getCompanyFleetList(props.authenticationService, companyId)];
                    case 1:
                        fleetList = _a.sent();
                        setCustomerFleet(fleetList);
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        handleFetchError(err_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    function handleConvertToFirm(e) {
        return __awaiter(this, void 0, void 0, function () {
            var errors, completeEvent;
            return __generator(this, function (_a) {
                e.preventDefault();
                if (!props.convertTentativeToNomination) {
                    return [2 /*return*/];
                }
                if (!values) {
                    // should never happen
                    toast.error('No values found');
                    return [2 /*return*/];
                }
                triggerValidation();
                errors = validateTentativeForm(values);
                if (isEmpty$1(errors)) {
                    completeEvent = produce$1(values, function (draftEvent) {
                        draftEvent.vendorCompanyId = props.vendorCompanyId || values.vendorCompanyId;
                    });
                    props.convertTentativeToNomination(completeEvent);
                }
                else {
                    toast.error('Please fill in all required fields');
                }
                return [2 /*return*/];
            });
        });
    }
    function onSubmit(event) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                submitChanges(event, props.handleFormEditComplete, 'tentative', props.activeEvent, props.vendorCompanyId);
                return [2 /*return*/];
            });
        });
    }
    function setupForm() {
        var _a, _b;
        if (props.activeEvent) {
            setInitialFormValue(props.activeEvent);
        }
        else {
            var initialFormValues = cloneDeep(DEFAULT_FORM_VALUES$9);
            if (isCustomer((_a = props.userProfile) === null || _a === void 0 ? void 0 : _a.roles) && ((_b = props.userProfile) === null || _b === void 0 ? void 0 : _b.companyId)) {
                initialFormValues.companyId = props.userProfile.companyId;
                initialFormValues.tentativeType = 'nomination';
            }
            setInitialFormValue(initialFormValues);
        }
    }
};

var DEFAULT_FORM_VALUES$a = {
    _type: 'travel',
    eta: '',
    etd: '',
    destinationId: '',
    sourceId: '',
    vendorReference: '',
    remark: '',
    speed: '',
    fuelUsage: '',
    bunkerShipId: null,
    ncomments: 0,
    pipelineId: null
};
var PromptTravelForm = function (props) {
    var _a = useState(DEFAULT_FORM_VALUES$a), initialFormValue = _a[0], setInitialFormValue = _a[1];
    var _b = useState(false), removeDialogActive = _b[0], setRemoveDialogActive = _b[1];
    var readOnly = props.readOnly;
    useEffect(function () {
        setupForm();
    }, [props.activeEvent]);
    var _c = useForm({
        initialValues: initialFormValue,
        onValidSubmit: onSubmit,
        validate: validatePromptForm
    }), handleSubmit = _c.handleSubmit, onChange = _c.onChange, onChangeValue = _c.onChangeValue, isDifferentFromInitial = _c.isDifferentFromInitial, values = _c.values, errors = _c.errors;
    var sourceTimezone = useLocationTimeZone((values === null || values === void 0 ? void 0 : values.sourceId) || undefined, props.locationService);
    var destinationTimezone = useLocationTimeZone(values === null || values === void 0 ? void 0 : values.destinationId, props.locationService);
    return (React__default.createElement("form", { className: classNames('prompt-event-form', { 'not-edit': readOnly }), onSubmit: handleSubmit },
        React__default.createElement(Prompt, { when: isDifferentFromInitial, message: 'You have unsaved changes. Would you like to continue?' }),
        React__default.createElement(Dialog, { showDialog: removeDialogActive, onCloseDialog: function () {
                setRemoveDialogActive(false);
            }, type: "small", title: "Remove Event" },
            React__default.createElement("p", null, "Are you sure you want to delete this event? This action can not be undone."),
            React__default.createElement(ButtonGroup, null,
                React__default.createElement(Button, { danger: true, preventDoubleClick: true, onClick: function () {
                        if (props.handleRemoveEvent) {
                            props.handleRemoveEvent();
                        }
                        setRemoveDialogActive(false);
                    } }, "Remove event"))),
        React__default.createElement("div", { className: "prompt-event-content" },
            React__default.createElement("div", { className: "prompt-event-row" },
                React__default.createElement("div", { className: "prompt-event-column" },
                    React__default.createElement(FormWrapper, null,
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "bunkerShipId" }, "Bunker vessel *"),
                            React__default.createElement(SelectionBox, { fieldName: 'bunkerShipId', placeholder: 'Select Bunker Vessel...', value: (values === null || values === void 0 ? void 0 : values.bunkerShipId) || undefined, valueKey: "_id", displayKey: "name", sortOptions: true, disabled: readOnly, onChangeValue: function (option) {
                                    onChangeValue('bunkerShipId', option === null || option === void 0 ? void 0 : option._id);
                                }, options: props.bunkerShips, renderOption: function (option) { return (React__default.createElement(ShipSearchSelectOption, { ship: option, currentUser: props.userProfile })); } }),
                            React__default.createElement(FormErrorMessage, null, errors ? get(errors, 'bunkerShipId') : undefined)),
                        React__default.createElement(InlineFormElement, null,
                            React__default.createElement(LocationSearch$1, { locationService: props.locationService, onChange: function (value) {
                                    onChangeValue('sourceId', value);
                                }, label: "From location *", disabled: readOnly, fieldName: "sourceId", error: errors ? get(errors, 'sourceId') : undefined, value: (values === null || values === void 0 ? void 0 : values.sourceId) || '' }),
                            React__default.createElement(FormElement, null,
                                React__default.createElement(FormLabel, { fieldName: "etd" }, "ETD *"),
                                React__default.createElement(FormFieldWrapper, null,
                                    React__default.createElement(DateTimePicker, { key: (values === null || values === void 0 ? void 0 : values._id) + " etd", name: 'etd', onDateTimeChange: function (date) { return onChangeValue('etd', date); }, disabled: readOnly, icon: React__default.createElement("i", { className: "icon-calendar-1" }), placeholder: "dd/mm/yyyy hh:mm", value: (values === null || values === void 0 ? void 0 : values.etd) || '', timeZone: destinationTimezone.value, hideDialogHeader: true, useInitialStart: 'hour' })),
                                React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'etd') : undefined }))),
                        React__default.createElement(InlineFormElement, null,
                            React__default.createElement(LocationSearch$1, { locationService: props.locationService, onChange: function (value) {
                                    onChangeValue('destinationId', value);
                                }, label: "To destination *", disabled: readOnly, fieldName: "destinationId", error: errors ? get(errors, 'destinationId') : undefined, value: (values === null || values === void 0 ? void 0 : values.destinationId) || '' }),
                            React__default.createElement(FormElement, null,
                                React__default.createElement(FormLabel, { fieldName: "eta" }, "ETA *"),
                                React__default.createElement(FormFieldWrapper, null,
                                    React__default.createElement(DateTimePicker, { key: (values === null || values === void 0 ? void 0 : values._id) + " eta", name: 'eta', onDateTimeChange: function (date) { return onChangeValue('eta', date); }, disabled: readOnly, icon: React__default.createElement("i", { className: "icon-calendar-1" }), placeholder: "dd/mm/yyyy hh:mm", value: (values === null || values === void 0 ? void 0 : values.eta) || '', timeZone: sourceTimezone.value, hideDialogHeader: true, useInitialStart: 'hour' })),
                                React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'eta') : undefined }))),
                        props.sandboxList && !props.activeEvent && (
                        // only rendering the sandbox select if it's in sandbox mode and we are creating a new event
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "sandboxId" }, "Sandbox"),
                            React__default.createElement(SelectionBox, { fieldName: 'sandboxId', placeholder: 'Select Sandbox...', value: (values === null || values === void 0 ? void 0 : values.sandboxId) || '', valueKey: "_id", displayKey: "name", sortOptions: true, disabled: readOnly, onChangeValue: function (sandbox) {
                                    onChangeValue('sandboxId', sandbox === null || sandbox === void 0 ? void 0 : sandbox._id);
                                }, options: props.sandboxList, renderOption: function (option) { return React__default.createElement(SelectOption, { label: option.name }); } }),
                            React__default.createElement(FormErrorMessage, null, errors ? get(errors, 'sandboxId') : undefined))),
                        React__default.createElement(InlineFormElement, null,
                            React__default.createElement(FormElement, null,
                                React__default.createElement(FormLabel, { fieldName: "speed" }, "Speed (kt)"),
                                React__default.createElement(TextField, { fieldName: "speed", disabled: readOnly, value: (values === null || values === void 0 ? void 0 : values.speed) || '', onChange: onChange }),
                                React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'speed') : undefined })),
                            React__default.createElement(FormElement, null,
                                React__default.createElement(FormLabel, { fieldName: "fuelUsage" }, "Fuel usage"),
                                React__default.createElement(TextField, { fieldName: "fuelUsage", disabled: readOnly, value: (values === null || values === void 0 ? void 0 : values.fuelUsage) || '', onChange: onChange }),
                                React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'fuelUsage') : undefined }))),
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "remark" }, "Additional information"),
                            React__default.createElement("textarea", { className: "textarea", id: 'remark', name: 'remark', value: (values === null || values === void 0 ? void 0 : values.remark) || '', disabled: props.readOnly, onChange: onChange }))))),
            !readOnly && (React__default.createElement(ButtonGroup, null,
                React__default.createElement(Button, { primary: true, preventDoubleClick: true, onClick: function () {
                        handleSubmit();
                    }, disabled: !isDifferentFromInitial && !props.mergeForm, title: isDifferentFromInitial || props.mergeForm ? '' : 'No changes detected' }, props.submitText || (React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(Icon, null,
                        React__default.createElement(FontAwesomeIcon, { icon: faCalendarCheck })),
                    ' ',
                    !!props.activeEvent ? 'Save changes' : 'Add event'))),
                props.handleRemoveEvent && props.activeEvent !== undefined ? (React__default.createElement(Button, { preventDoubleClick: true, danger: true, outline: true, className: "secondary danger", onClick: function () {
                        setRemoveDialogActive(true);
                    } }, "Remove event")) : (React__default.createElement(Button, { secondary: true, preventDoubleClick: true, onClick: function () {
                        props.handleCancelForm();
                    }, disabled: false }, "Cancel")))))));
    function onSubmit(event) {
        submitChanges(event, props.handleFormEditComplete, 'travel', props.activeEvent, props.vendorCompanyId);
    }
    function setupForm() {
        if (props.activeEvent) {
            setInitialFormValue(props.activeEvent);
        }
        else {
            setInitialFormValue(DEFAULT_FORM_VALUES$a);
        }
    }
    function validatePromptForm(values) {
        var errors = {};
        if (!values.sandboxId && props.sandboxList && !props.activeEvent) {
            errors.sandboxId = 'Required';
        }
        if (!values.bunkerShipId) {
            errors.bunkerShipId = 'Required';
        }
        if (!values.sourceId) {
            errors.sourceId = 'Required';
        }
        if (!values.destinationId) {
            errors.destinationId = 'Required';
        }
        if (!values.eta) {
            errors.eta = 'Required';
        }
        if (!values.etd) {
            errors.etd = 'Required';
        }
        if (!values.sourceId) {
            errors.sourceId = 'Required';
        }
        if (!values.destinationId) {
            errors.destinationId = 'Required';
        }
        if (values.eta) {
            if (values.etd &&
                isBefore(parseDateOrStringToDateTime(values.eta), parseDateOrStringToDateTime(values.etd))) {
                errors.eta = 'ETS must be before ETA';
            }
        }
        if (values.etd) {
            if (values.eta &&
                isAfter(parseDateOrStringToDateTime(values.etd), parseDateOrStringToDateTime(values.eta))) {
                errors.etd = 'ETA must be after ETS';
            }
        }
        if (values.eta && !isValidDate(values.eta)) {
            errors.eta = 'Fill in a valid date';
        }
        if (values.etd && !isValidDate(values.etd)) {
            errors.etd = 'Fill in a valid date';
        }
        return errors;
    }
};

var DEFAULT_FORM_VALUES$b = {
    _type: 'waiting',
    eta: '',
    etd: '',
    locationId: '',
    vendorReference: '',
    remark: '',
    bunkerShipId: null,
    ncomments: 0,
    pipelineId: null
};
var PromptWaitingForm = function (props) {
    var _a = useState(DEFAULT_FORM_VALUES$b), initialFormValue = _a[0], setInitialFormValue = _a[1];
    var _b = useState(false), removeDialogActive = _b[0], setRemoveDialogActive = _b[1];
    var readOnly = props.readOnly;
    useEffect(function () {
        setupForm();
    }, [props.activeEvent]);
    var _c = useForm({
        initialValues: initialFormValue,
        onValidSubmit: onSubmit,
        validate: validate
    }), handleSubmit = _c.handleSubmit, onChange = _c.onChange, onChangeValue = _c.onChangeValue, isDifferentFromInitial = _c.isDifferentFromInitial, values = _c.values, errors = _c.errors;
    var timezone = useLocationTimeZone(values === null || values === void 0 ? void 0 : values.locationId, props.locationService);
    return (React__default.createElement("form", { className: classNames('prompt-event-form', { 'not-edit': readOnly }), onSubmit: handleSubmit },
        React__default.createElement(Prompt, { when: isDifferentFromInitial, message: 'You have unsaved changes. Would you like to continue?' }),
        React__default.createElement(Dialog, { showDialog: removeDialogActive, onCloseDialog: function () {
                setRemoveDialogActive(false);
            }, type: "small", title: "Remove Event" },
            React__default.createElement("p", null, "Are you sure you want to delete this event? This action can not be undone."),
            React__default.createElement(ButtonGroup, null,
                React__default.createElement(Button, { danger: true, preventDoubleClick: true, onClick: function () {
                        if (props.handleRemoveEvent) {
                            props.handleRemoveEvent();
                        }
                        setRemoveDialogActive(false);
                    } }, "Remove event"))),
        React__default.createElement("div", { className: "prompt-event-content" },
            React__default.createElement("div", { className: "prompt-event-row" },
                React__default.createElement("div", { className: "prompt-event-column" },
                    React__default.createElement(FormWrapper, null,
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "vendorReference" }, "Vendor reference"),
                            React__default.createElement(TextField, { fieldName: "vendorReference", disabled: readOnly, value: (values === null || values === void 0 ? void 0 : values.vendorReference) || '', onChange: onChange }),
                            React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'vendorReference') : undefined })),
                        props.sandboxList && !props.activeEvent && (
                        // only rendering the sandbox select if it's in sandbox mode and we are creating a new event
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "sandboxId" }, "Sandbox"),
                            React__default.createElement(SelectionBox, { fieldName: 'sandboxId', placeholder: 'Select Sandbox...', value: (values === null || values === void 0 ? void 0 : values.sandboxId) || '', valueKey: "_id", displayKey: "name", sortOptions: true, disabled: readOnly, onChangeValue: function (sandbox) {
                                    onChangeValue('sandboxId', sandbox === null || sandbox === void 0 ? void 0 : sandbox._id);
                                }, options: props.sandboxList, renderOption: function (option) { return React__default.createElement(SelectOption, { label: option.name }); } }),
                            React__default.createElement(FormErrorMessage, null, errors ? get(errors, 'sandboxId') : undefined))),
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "bunkerShipId" }, "Bunker vessel"),
                            React__default.createElement(SelectionBox, { fieldName: 'bunkerShipId', placeholder: 'Select Bunker Vessel...', value: (values === null || values === void 0 ? void 0 : values.bunkerShipId) || undefined, valueKey: "_id", displayKey: "name", sortOptions: true, disabled: readOnly, onChangeValue: function (option) {
                                    onChangeValue('bunkerShipId', option === null || option === void 0 ? void 0 : option._id);
                                }, options: props.bunkerShips, renderOption: function (option) { return (React__default.createElement(ShipSearchSelectOption, { ship: option, currentUser: props.userProfile })); } }),
                            React__default.createElement(FormErrorMessage, null, errors ? get(errors, 'bunkerShipId') : undefined)),
                        React__default.createElement(LocationSearch$1, { locationService: props.locationService, onChange: function (value) {
                                onChangeValue('locationId', value);
                            }, label: "Location", disabled: readOnly, fieldName: "locationId", error: errors ? get(errors, 'locationId') : undefined, value: (values === null || values === void 0 ? void 0 : values.locationId) || '' }),
                        React__default.createElement(InlineFormElement, null,
                            React__default.createElement(FormElement, null,
                                React__default.createElement(FormLabel, { fieldName: "eta" }, "ETA"),
                                React__default.createElement(FormFieldWrapper, null,
                                    React__default.createElement(DateTimePicker, { key: (values === null || values === void 0 ? void 0 : values._id) + " eta", name: 'eta', onDateTimeChange: function (date) { return onChangeValue('eta', date); }, disabled: readOnly, icon: React__default.createElement("i", { className: "icon-calendar-1" }), placeholder: "dd/mm/yyyy hh:mm", value: (values === null || values === void 0 ? void 0 : values.eta) || '', timeZone: timezone.value, hideDialogHeader: true, useInitialStart: 'hour' })),
                                React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'eta') : undefined })),
                            React__default.createElement(FormElement, null,
                                React__default.createElement(FormLabel, { fieldName: "etd" }, "ETD"),
                                React__default.createElement(FormFieldWrapper, null,
                                    React__default.createElement(DateTimePicker, { key: (values === null || values === void 0 ? void 0 : values._id) + " etd", name: 'etd', onDateTimeChange: function (date) { return onChangeValue('etd', date); }, disabled: readOnly, icon: React__default.createElement("i", { className: "icon-calendar-1" }), placeholder: "dd/mm/yyyy hh:mm", value: (values === null || values === void 0 ? void 0 : values.etd) || '', timeZone: timezone.value, hideDialogHeader: true, useInitialStart: 'hour' })),
                                React__default.createElement(FormErrorMessage, { errorMessage: errors ? get(errors, 'etd') : undefined }))),
                        React__default.createElement(FormElement, null,
                            React__default.createElement(FormLabel, { fieldName: "remark" }, "Additional information"),
                            React__default.createElement("textarea", { className: "textarea", id: 'remark', name: 'remark', value: (values === null || values === void 0 ? void 0 : values.remark) || '', disabled: props.readOnly, onChange: onChange }))))),
            !readOnly && (React__default.createElement(ButtonGroup, null,
                React__default.createElement(Button, { primary: true, preventDoubleClick: true, onClick: function () {
                        handleSubmit();
                    }, disabled: !isDifferentFromInitial && !props.mergeForm, title: isDifferentFromInitial || props.mergeForm ? '' : 'No changes detected' }, props.submitText || (React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(Icon, null,
                        React__default.createElement(FontAwesomeIcon, { icon: faCalendarCheck })),
                    ' ',
                    !!props.activeEvent ? 'Save changes' : 'Add event'))),
                props.handleRemoveEvent && props.activeEvent !== undefined ? (React__default.createElement(Button, { danger: true, preventDoubleClick: true, outline: true, className: "secondary danger", onClick: function () {
                        setRemoveDialogActive(true);
                    } }, "Remove event")) : (React__default.createElement(Button, { secondary: true, preventDoubleClick: true, onClick: function () {
                        props.handleCancelForm();
                    }, disabled: false }, "Cancel")))))));
    function validate(event) {
        return props.sandboxList ? validateSandboxPromptForm(event) : validatePromptForm(event);
    }
    function onSubmit(event) {
        submitChanges(event, props.handleFormEditComplete, 'waiting', props.activeEvent, props.vendorCompanyId);
    }
    function setupForm() {
        if (props.activeEvent) {
            setInitialFormValue(props.activeEvent);
        }
        else {
            setInitialFormValue(DEFAULT_FORM_VALUES$b);
        }
    }
};

var PromptForm = function (props) {
    var _a;
    var vendorCompaniesFilteredByContract = (_a = props.vendorCompanies) === null || _a === void 0 ? void 0 : _a.filter(function (company) {
        return props.vendorsWithContract.has(company._id);
    });
    // sort the companies alphabetically to look more pleasing in the selectbox
    var vendorCompaniesSorted = (vendorCompaniesFilteredByContract || []).sort(function (a, b) {
        return sortAlphabetically$2(a, b, 'name');
    });
    var propsForAllForms = {
        bunkerShips: props.bunkerShips,
        authenticationService: props.authenticationService,
        handleFormEditComplete: props.handleFormEditComplete,
        readOnly: isEditable(),
        sandboxList: props.sandboxList,
        handleRemoveEvent: props.handleRemoveEvent,
        locationService: props.locationService,
        vendorCompanyId: props.vendorCompanyId,
        vendorCompanies: vendorCompaniesSorted,
        handleCancelForm: props.handleCancelForm,
        userProfile: props.userProfile
    };
    switch (props.promptEventType) {
        case 'bunkering':
            return (React__default.createElement(React__default.Fragment, null,
                React__default.createElement("h1", null, "MGO bunkering"),
                React__default.createElement(PromptBunkeringForm, __assign({ activeEvent: props.selectedPromptEvent }, propsForAllForms))));
        case 'lngbunkering':
            return (React__default.createElement(React__default.Fragment, null,
                React__default.createElement("h1", null, "LNG Bunkering"),
                React__default.createElement(PromptLngBunkeringForm, __assign({ activeEvent: props.selectedPromptEvent }, propsForAllForms))));
        case 'charterout':
            return (React__default.createElement(React__default.Fragment, null,
                React__default.createElement("h1", null, "Charter Out"),
                React__default.createElement(PromptCharterOutForm, __assign({ activeEvent: props.selectedPromptEvent }, propsForAllForms))));
        case 'conditioning':
            return (React__default.createElement(React__default.Fragment, null,
                React__default.createElement("h1", null, "Conditioning"),
                React__default.createElement(PromptConditioningForm, __assign({ activeEvent: props.selectedPromptEvent }, propsForAllForms))));
        case 'discharge':
            return (React__default.createElement(React__default.Fragment, null,
                React__default.createElement("h1", null, "Discharge"),
                React__default.createElement(PromptDischargeForm, __assign({ activeEvent: props.selectedPromptEvent }, propsForAllForms))));
        case 'loading':
            return (React__default.createElement(React__default.Fragment, null,
                React__default.createElement("h1", null, "Loading"),
                React__default.createElement(PromptLoadingForm, __assign({ activeEvent: props.selectedPromptEvent, loadingFacilities: props.loadingFacilities || [] }, propsForAllForms))));
        case 'maintenance':
            return (React__default.createElement(React__default.Fragment, null,
                React__default.createElement("h1", null, "Maintenance"),
                React__default.createElement(PromptMaintenanceForm, __assign({ activeEvent: props.selectedPromptEvent }, propsForAllForms))));
        case 'pool':
            return (React__default.createElement(React__default.Fragment, null,
                React__default.createElement("h1", null, "Pool"),
                React__default.createElement(PromptPoolForm, __assign({ activeEvent: props.selectedPromptEvent }, propsForAllForms))));
        case 'tentative':
            return (React__default.createElement(React__default.Fragment, null,
                React__default.createElement("h1", null, "Tentative"),
                React__default.createElement(PromptTentativeForm, __assign({}, propsForAllForms, { activeEvent: props.selectedPromptEvent, companies: props.companies, userProfile: props.userProfile, convertTentativeToNomination: props.convertTentativeToNomination }))));
        case 'travel':
            return (React__default.createElement(React__default.Fragment, null,
                React__default.createElement("h1", null, "Travel"),
                React__default.createElement(PromptTravelForm, __assign({ activeEvent: props.selectedPromptEvent }, propsForAllForms))));
        case 'waiting':
            return (React__default.createElement(React__default.Fragment, null,
                React__default.createElement("h1", null, "Waiting"),
                React__default.createElement(PromptWaitingForm, __assign({ activeEvent: props.selectedPromptEvent }, propsForAllForms))));
        default:
            return null;
    }
    /**
     * Check whether the prompt event can still be edited:
     * once cancelled or finalized, the event cannot be edited anymore
     * and in the sandbox, live events cannot be edited
     */
    function isEditable() {
        if (props.readOnly === true) {
            return props.readOnly;
        }
        if (!!props.sandboxList &&
            props.selectedPromptEvent &&
            props.selectedPromptEvent.sandboxId === null) {
            // checks if sandbox mode is active, if the event does not have a sandboxId it means it's a live event.
            // In that case we should not be able to edit the live event.
            return true;
        }
        return false;
    }
};
var PromptForm$1 = React__default.memo(PromptForm, function (prevProps, nextProps) {
    // Because of fetching the userProfile often the datepicker would close because of a new render
    return JSON.stringify(prevProps) === JSON.stringify(nextProps);
});
function sortAlphabetically$2(a, b, propertyToSort) {
    if (a[propertyToSort] < b[propertyToSort]) {
        return -1;
    }
    if (a[propertyToSort] > b[propertyToSort]) {
        return 1;
    }
    return 0;
}

var PROMPT_EVENT_TYPES = [
    { name: 'Conditioning', value: 'conditioning' },
    { name: 'Discharge', value: 'discharge' },
    { name: 'Loading', value: 'loading' },
    { name: 'Maintenance', value: 'maintenance' },
    { name: 'MGO Bunkering', value: 'bunkering' },
    { name: 'Travel', value: 'travel' }
];
var PromptEventSelector = function (props) {
    var _a;
    var roles = props.user.roles;
    var selectionBoxReadOnly = roles && isSupplier(roles) && isCaptain(roles);
    var _b = useState((_a = props.selectedPromptEvent) === null || _a === void 0 ? void 0 : _a._type), promptEventType = _b[0], setPromptEventType = _b[1];
    useEffect(function () {
        if (props.selectedPromptEvent && promptEventType !== props.selectedPromptEvent._type) {
            setPromptEventType(props.selectedPromptEvent._type);
        }
    }, [props.selectedPromptEvent]);
    return (React__default.createElement("div", { className: "chorus-component", style: { height: '95vh' } },
        React__default.createElement("div", { className: "prompt-event-type-container" },
            React__default.createElement(FormElement, { style: { width: '200px' } },
                React__default.createElement(SelectionBox, { fieldName: 'prompt-event-type-selector', placeholder: '+ Add event', value: promptEventType, valueKey: "value", displayKey: "name", disabled: selectionBoxReadOnly, onChangeValue: function (option) {
                        if (!(option === null || option === void 0 ? void 0 : option.value))
                            return;
                        setPromptEventType(option.value);
                        props.handleSelectEventType(option.value);
                    }, options: PROMPT_EVENT_TYPES, renderOption: function (option) { return React__default.createElement(SelectOption, { label: option.name }); } })),
            promptEventType && (React__default.createElement("div", { className: "prompt-event-popup", style: { position: 'absolute', backgroundColor: 'white' } },
                React__default.createElement("button", { className: 'close-dialog-button', onClick: handleCancelForm }, "x"),
                React__default.createElement(PromptForm$1, { promptEventType: promptEventType, bunkerShips: props.bunkerShips, authenticationService: props.authenticationService, handleFormEditComplete: onFormEditComplete, selectedPromptEvent: props.selectedPromptEvent, loadingFacilities: props.loadingFacilities, sandboxList: undefined, handleRemoveEvent: props.handleRemoveEvent, locationService: props.locationService, companies: props.companies, userProfile: props.user, readOnly: props.readOnly, convertTentativeToNomination: props.convertTentativeToNomination, vendorCompanyId: isSupplier(props.user.roles) ? props.user.companyId : '', vendorCompanies: props.vendorCompanies, vendorsWithContract: props.vendorsWithContract, handleCancelForm: handleCancelForm }))))));
    function handleCancelForm() {
        setPromptEventType(undefined);
        if (props.closeSelectedEvent) {
            props.closeSelectedEvent();
        }
    }
    function onFormEditComplete(event, isNew) {
        props.handleFormEditComplete(event, isNew);
        handleCancelForm();
    }
};

var ShipSelectionBox = function (props) {
    var disabled = props.disabled, error = props.error, label = props.label, value = props.value, prevValue = props.prevValue, ships = props.ships;
    var previousValue = prevValue !== value ? ships.find(function (x) { return x._id === prevValue; }) : undefined;
    return (React__default.createElement(FormElement, null,
        React__default.createElement(FormLabel, { fieldName: props.fieldName }, label || ''),
        React__default.createElement(FormLabel, { fieldName: props.fieldName }, previousValue ? previousValue.name : undefined),
        React__default.createElement(SelectionBox, { fieldName: props.fieldName, value: value, valueKey: "_id", displayKey: "text", sortOptions: true, disabled: disabled, onChangeValue: function (option) {
                props.onChange(option);
            }, options: ships, renderOption: function (option) { return (React__default.createElement(ShipSearchSelectOption, { ship: option, currentUser: props.userProfile },
                React__default.createElement("div", null, option.mmsi),
                React__default.createElement("div", null, isValidFleetShip(option) ? option.imoNumber : option.imo))); } }),
        React__default.createElement(FormErrorMessage, null, error)));
    function isValidFleetShip(object) {
        return 'imoNumber' in object;
    }
};

var NotificationPopup = function (props) {
    return (React__default.createElement("div", { className: "custom-toast-notification" },
        React__default.createElement("div", { className: "notification-header" },
            React__default.createElement("div", { className: "notification-icon" },
                React__default.createElement(Icon, null,
                    React__default.createElement(FontAwesomeIcon, { icon: faSyncAlt }))),
            React__default.createElement("h3", null, props.message)),
        React__default.createElement("div", { className: "notification-buttons" },
            React__default.createElement(Button, { preventDoubleClick: true, className: "secondary", onClick: props.onAction }, props.actionText))));
};

var ThirdPartyContactContext = React__default.createContext({
    user: {},
    activeEditedRowId: '',
    formErrorFields: []
});
var ThirdPartyContactProvider = function (props) {
    return (React__default.createElement(ThirdPartyContactContext.Provider, { value: {
            user: props.user,
            activeEditedRowId: props.activeEditedRowId,
            formErrorFields: props.formErrorFields
        } }, props.children));
};
var ThirdPartyContactProvider$1 = React__default.memo(ThirdPartyContactProvider);

// Create an editable cell renderer
var EditableCell = function (_a) {
    var disabled = _a.disabled, cell = _a.cell, updateCellData = _a.updateCellData // This is a custom function that we supplied to our table instance
    ;
    // We need to keep and update the state of the cell normally
    var _b = useState(cell.value), value = _b[0], setValue = _b[1];
    var formErrorFields = useContext(ThirdPartyContactContext).formErrorFields;
    // If the initialValue is changed external, sync it up with our state
    useEffect(function () {
        setValue(cell.value);
    }, [cell.value]);
    var header = cell.column.Header;
    var onTextInputChange = function (e) {
        setValue(e.target.value);
    };
    var onBlur = function () {
        if (cell.value !== value) {
            updateCellData(cell.row.index, cell.column.id, value);
        }
    };
    var onRoleSelectChange = function (selectedItem) {
        setValue((selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value) || '');
        updateCellData(cell.row.index, cell.column.id, (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value) || value);
    };
    var user = useContext(ThirdPartyContactContext).user;
    if (header === 'Company Type') {
        return (React__default.createElement("td", __assign({}, cell.getCellProps()),
            React__default.createElement(SelectionBox, { disabled: disabled, valueKey: "value", displayKey: "text", fieldName: 'role', placeholder: 'Select...', value: value || '', onChangeValue: onRoleSelectChange, options: getAllowedThirdPartyContactRoles(user.roles), className: "contact-input-field " + (!disabled && formErrorFields.includes(cell.column.id) ? 'error' : 'nice') })));
    }
    return (React__default.createElement("td", __assign({}, cell.getCellProps()),
        React__default.createElement(FormElement, null,
            React__default.createElement(TextField, { fieldName: "" + cell.column.id, disabled: disabled, value: value, onChange: onTextInputChange, onBlur: onBlur, className: "contact-input-field " + (!disabled && formErrorFields.includes(cell.column.id) ? 'error' : 'nice') }))));
};
var EditableCell$1 = React__default.memo(EditableCell);

var ContactRow = function (props) {
    var _a = useContext(ThirdPartyContactContext), user = _a.user, activeEditedRowId = _a.activeEditedRowId;
    var actionsCell = function (rowId) {
        return rowId === 'new_record' || activeEditedRowId === rowId ? (React__default.createElement(Button$1, { preventDoubleClick: true, iconButton: true, onClick: function () { return props.onRowSave(rowId); }, primary: true, tooltipText: 'Save' },
            React__default.createElement(Icon, null,
                React__default.createElement(FontAwesomeIcon, { icon: faSave })))) : (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(Button$1, { preventDoubleClick: true, iconButton: true, className: "edit-button", onClick: function () { return props.onRowEdit(rowId); }, primary: true, tooltipText: 'Edit' },
                React__default.createElement(Icon, null,
                    React__default.createElement(FontAwesomeIcon, { icon: faPencil }))),
            React__default.createElement(Button$1, { preventDoubleClick: true, iconButton: true, onClick: function () { return props.onRowDelete(rowId); }, secondary: true, tooltipText: 'Delete' },
                React__default.createElement(Icon, null,
                    React__default.createElement(FontAwesomeIcon, { icon: faTimes })))));
    };
    return (React__default.createElement("tr", __assign({}, props.row.getRowProps(), { className: props.row.original._id === activeEditedRowId ? "editing-active" : '' }),
        props.row.cells.map(function (cell) {
            return (React__default.createElement(EditableCell$1, { user: user, updateCellData: props.updateCellData, cell: cell, disabled: props.row.original._id !== activeEditedRowId }));
        }),
        React__default.createElement("div", { className: "contact-row__action-buttons" }, actionsCell(props.row.original._id))));
};

var GlobalSearch = function (_a) {
    var filter = _a.filter, setFilter = _a.setFilter;
    return (React__default.createElement("div", { className: "third-party-search-wrapper" },
        React__default.createElement(FormElement, null,
            React__default.createElement(TextField, { fieldName: "search", placeholder: "Search...", type: "text", value: filter || '', onChange: function (e) { return setFilter(e.target.value); } }))));
};

var GenericTable = function (_a) {
    var children = _a.children, columns = _a.columns, data = _a.data, updateCellData = _a.updateCellData, skipPageReset = _a.skipPageReset, onRowEdit = _a.onRowEdit, onRowDelete = _a.onRowDelete, onRowSave = _a.onRowSave;
    var _b = useTable({
        columns: columns,
        data: data,
        autoResetPage: !skipPageReset,
        updateCellData: updateCellData
    }, useGlobalFilter, useSortBy, usePagination), getTableProps = _b.getTableProps, getTableBodyProps = _b.getTableBodyProps, headerGroups = _b.headerGroups, prepareRow = _b.prepareRow, page = _b.page, canPreviousPage = _b.canPreviousPage, canNextPage = _b.canNextPage, pageCount = _b.pageCount, gotoPage = _b.gotoPage, nextPage = _b.nextPage, previousPage = _b.previousPage, setPageSize = _b.setPageSize, _c = _b.state, pageIndex = _c.pageIndex, pageSize = _c.pageSize, globalFilter = _c.globalFilter, setGlobalFilter = _b.setGlobalFilter;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(GlobalSearch, { filter: globalFilter, setFilter: setGlobalFilter }),
        React__default.createElement("table", __assign({}, getTableProps(), { className: "table-third-party-contact" }),
            React__default.createElement("thead", null, headerGroups.map(function (headerGroup) { return (React__default.createElement("tr", __assign({}, headerGroup.getHeaderGroupProps()), headerGroup.headers.map(function (column) { return (React__default.createElement("th", __assign({}, column.getHeaderProps(column.getSortByToggleProps())),
                column.render('Header'),
                ' ',
                React__default.createElement("span", null, column.isSorted ? (column.isSortedDesc ? (React__default.createElement(Icon, null,
                    React__default.createElement(FontAwesomeIcon, { icon: faSortDown }))) : (React__default.createElement(Icon, null,
                    React__default.createElement(FontAwesomeIcon, { icon: faSortUp })))) : (React__default.createElement(Icon, null,
                    React__default.createElement(FontAwesomeIcon, { icon: faSort })))))); }))); })),
            React__default.createElement("tbody", __assign({}, getTableBodyProps()), page.map(function (row, i) {
                prepareRow(row);
                return (React__default.createElement(ContactRow, { row: row, onRowDelete: onRowDelete, onRowEdit: onRowEdit, onRowSave: onRowSave, updateCellData: updateCellData }));
            }))),
        React__default.createElement("div", { className: "pagination" }, children({
            pageCount: pageCount,
            pageIndex: pageIndex,
            canNextPage: canNextPage,
            canPreviousPage: canPreviousPage,
            pageSize: pageSize,
            totalRecords: data.length,
            maxPage: pageCount,
            previousPage: previousPage,
            nextPage: nextPage,
            setPageSize: setPageSize,
            gotoPage: gotoPage
        }))));
};

var ThirdPartyContactsTable = function (props) {
    var columns = React__default.useMemo(function () { return [
        {
            Header: 'Contact Person',
            accessor: 'name'
        },
        {
            Header: 'E-mail',
            accessor: 'email'
        },
        {
            Header: 'Company',
            accessor: 'companyName'
        },
        {
            Header: 'Company Type',
            accessor: 'role'
        }
    ]; }, []);
    var _a = useThirdPartyContactService(props.authenticationService, props.userCompanyId || ''), thirdPartyContactList = _a.thirdPartyContactList, updateThirdPartyContactService = _a.updateThirdPartyContactService, deleteThirdPartyContactService = _a.deleteThirdPartyContactService, saveThirdPartyContact = _a.saveThirdPartyContact;
    var _b = useState([]), data = _b[0], setData = _b[1];
    var _c = useState(false), skipPageReset = _c[0], setSkipPageReset = _c[1];
    var _d = useState(''), activeEditedRowId = _d[0], setActiveEditedRowId = _d[1];
    var _e = useState([]), formErrorFields = _e[0], setFormErrorFields = _e[1];
    var _f = useState(''), rowIdToDelete = _f[0], setRowIdToDelete = _f[1];
    useEffect(function () {
        setData(thirdPartyContactList);
    }, [thirdPartyContactList]);
    useEffect(function () {
        setSkipPageReset(false);
    }, [data]);
    useEffect(function () {
        setFormErrorFields([]); // reset form errors
        if (activeEditedRowId !== 'new_record' && data[0] && data[0]._id === 'new_record') {
            data.shift();
            setData(__spreadArrays(data));
        }
    }, [activeEditedRowId]);
    var updateCellData = function (rowIndex, columnId, value) {
        setSkipPageReset(true);
        setData(function (old) {
            return old.map(function (row, index) {
                var _a;
                if (index === rowIndex) {
                    return __assign(__assign({}, old[rowIndex]), (_a = {}, _a[columnId] = value, _a));
                }
                return row;
            });
        });
    };
    var handleRowSave = function (rowId) {
        var errors = lookForEmptyValues(data[0]);
        if (errors.length) {
            setFormErrorFields(errors);
            return;
        }
        if (formErrorFields.length)
            setFormErrorFields([]);
        // Row Update
        if (rowId !== 'new_record') {
            var update = data.find(function (_) { return _._id === rowId; });
            update && updateThirdPartyContactService(update);
            setActiveEditedRowId('');
        }
        // New Contact
        else {
            data[0]._id = '';
            saveThirdPartyContact(data[0]);
            setActiveEditedRowId('');
        }
    };
    // Toggle the null row in the table on Add Contact clicked
    var handleAddContact = function () {
        if (!data[0] || data[0]._id !== 'new_record') {
            setData(__spreadArrays([
                {
                    _id: 'new_record',
                    companyId: props.userCompanyId,
                    companyName: '',
                    email: '',
                    name: '',
                    role: ''
                }
            ], data));
            setActiveEditedRowId('new_record'); // To update the activeEditedRowId in the provider
        }
        else {
            data.shift();
            setData(__spreadArrays(data));
        }
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Button$1, { preventDoubleClick: true, iconButton: true, className: "btn btn-primary add-new-contact-button", onClick: handleAddContact, primary: true },
            React__default.createElement(Icon, null,
                React__default.createElement(FontAwesomeIcon, { icon: faPlus })),
            ' ',
            "Add new contact"),
        React__default.createElement(ThirdPartyContactProvider$1, { user: props.user, activeEditedRowId: activeEditedRowId, formErrorFields: formErrorFields },
            React__default.createElement(GenericTable, { columns: columns, data: data, updateCellData: updateCellData, skipPageReset: skipPageReset, onRowEdit: setActiveEditedRowId, onRowDelete: setRowIdToDelete, onRowSave: handleRowSave }, function (paginationComponentProps) { return props.children(__assign({}, paginationComponentProps)); }),
            rowIdToDelete && (React__default.createElement(Dialog, { showDialog: !!rowIdToDelete, type: "medium", title: "Delete contact person", onCloseDialog: function () { return setRowIdToDelete(''); }, className: "dialog-box__delete-contact" },
                React__default.createElement("h3", null, "Are you sure you want to delete user?"),
                React__default.createElement(Button$1, { danger: true, onClick: function () {
                        rowIdToDelete && deleteThirdPartyContactService(rowIdToDelete);
                        setRowIdToDelete('');
                    } }, "Confirm"),
                React__default.createElement(Button$1, { onClick: function () { return setRowIdToDelete(''); } }, "Cancel"))))));
};
function lookForEmptyValues(data) {
    var findings = Object.keys(data).filter(function (key) {
        if (data[key] === '') {
            return data;
        }
    });
    return findings && findings.length > 0 ? findings : [];
}

var TimelineFilterItem = function (props) {
    return (React__default.createElement("div", { className: "timeline-filter-item " + (props.filterActive ? 'filter-active' : ''), onClick: props.onClick },
        props.type && getDeliveryModeIcon(props.type),
        React__default.createElement("div", { className: "timeline-filter-item-title" }, props.title)));
};

var TimelineFilter = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return (React__default.createElement("div", { className: "timeline-filter " + (props.isCollapsed ? 'collapsed' : '') + " " + (props.className || '') },
        !props.hideDeliveryModeFilter && (React__default.createElement("div", { className: "timeline-delivery-mode-filter" },
            !((_a = props.disabledDeliveryModes) === null || _a === void 0 ? void 0 : _a.includes('SHIP')) && (React__default.createElement("div", { className: "delivery-mode-filter-item " + (props.timelineFiltering.filteredDeliveryModes.includes('SHIP') ? 'filter-active' : ''), onClick: function () {
                    props.timelineFiltering.toggleDeliveryMode('SHIP');
                } }, getDeliveryModeIcon('SHIP'))),
            !((_b = props.disabledDeliveryModes) === null || _b === void 0 ? void 0 : _b.includes('TRUCK')) && (React__default.createElement("div", { className: "delivery-mode-filter-item " + (props.timelineFiltering.filteredDeliveryModes.includes('TRUCK') ? 'filter-active' : ''), onClick: function () {
                    props.timelineFiltering.toggleDeliveryMode('TRUCK');
                } }, getDeliveryModeIcon('TRUCK'))),
            !((_c = props.disabledDeliveryModes) === null || _c === void 0 ? void 0 : _c.includes('CONTAINER')) && (React__default.createElement("div", { className: "delivery-mode-filter-item " + (props.timelineFiltering.filteredDeliveryModes.includes('CONTAINER') ? 'filter-active' : ''), onClick: function () {
                    props.timelineFiltering.toggleDeliveryMode('CONTAINER');
                } }, getDeliveryModeIcon('CONTAINER'))),
            !((_d = props.disabledDeliveryModes) === null || _d === void 0 ? void 0 : _d.includes('PIPE')) && (React__default.createElement("div", { className: "delivery-mode-filter-item " + (props.timelineFiltering.filteredDeliveryModes.includes('PIPE') ? 'filter-active' : ''), onClick: function () {
                    props.timelineFiltering.toggleDeliveryMode('PIPE');
                } }, getDeliveryModeIcon('PIPE'))))),
        React__default.createElement("div", { className: "timeline-assets-filter" },
            !((_e = props.disabledDeliveryModes) === null || _e === void 0 ? void 0 : _e.includes('SHIP')) && (React__default.createElement(React__default.Fragment, null, props.bunkerships.map(function (ship) {
                return (React__default.createElement(TimelineFilterItem, { key: "shipfilter " + ship._id, filterActive: props.timelineFiltering.filteredBunkerAssets.includes(ship._id), type: "SHIP", title: ship.name, onClick: function () {
                        props.timelineFiltering.toggleBunkerAsset(ship._id, 'SHIP');
                    } }));
            }))),
            !((_f = props.disabledDeliveryModes) === null || _f === void 0 ? void 0 : _f.includes('TRUCK')) && (React__default.createElement(TimelineFilterItem, { filterActive: props.timelineFiltering.filteredDeliveryModes.includes('TRUCK'), type: "TRUCK", title: 'Trucks', onClick: function () {
                    props.timelineFiltering.toggleDeliveryMode('TRUCK');
                } })),
            !((_g = props.disabledDeliveryModes) === null || _g === void 0 ? void 0 : _g.includes('CONTAINER')) && (React__default.createElement(TimelineFilterItem, { filterActive: props.timelineFiltering.filteredDeliveryModes.includes('CONTAINER'), type: "CONTAINER", title: 'Containers', onClick: function () {
                    props.timelineFiltering.toggleDeliveryMode('CONTAINER');
                } })),
            !((_h = props.disabledDeliveryModes) === null || _h === void 0 ? void 0 : _h.includes('PIPE')) && (React__default.createElement(React__default.Fragment, null, props.pipelines.map(function (pipe) {
                return (React__default.createElement(TimelineFilterItem, { key: "shipfilter " + pipe._id, filterActive: props.timelineFiltering.filteredBunkerAssets.includes(pipe._id), type: "PIPE", title: pipe.name, onClick: function () {
                        props.timelineFiltering.toggleBunkerAsset(pipe._id, 'PIPE');
                    } }));
            }))))));
};

var MultiOptionButton = function (props) {
    return (React__default.createElement("div", { className: "multi-option-button " + (props.className || '') }, props.options.map(function (option, index) {
        var isSelected = option === props.selected;
        return (React__default.createElement(Button, { primary: true, outline: true, preventDoubleClick: true, key: index, className: isSelected ? 'selected' : '', onClick: function () { return props.onChange(option); } }, option));
    })));
};

var TimelineSidebar = function (props) {
    var _a = useState(false), collapsedSidebar = _a[0], setCollapsedSidebar = _a[1];
    return (createElement("div", { className: "timeline-sidebar sidebar-container" },
        createElement("div", { className: "sidebar-icon-bar" },
            createElement("div", { className: "toggle-icon", onClick: function () { return setCollapsedSidebar(!collapsedSidebar); } },
                createElement(Icon, null, collapsedSidebar ? createElement(FontAwesomeIcon, { icon: faFilter }) : createElement(FontAwesomeIcon, { icon: faArrowLeft })))),
        createElement("div", { className: "sidebar-wrapper sidebar-tabs sidebar-sandbox " + (collapsedSidebar ? 'collapsed' : '') },
            props.displayName && (createElement("div", { className: "sidebar-top" },
                createElement("h3", null, props.displayName))),
            props.children)));
};

var NominationDataExporter = function (props) {
    var _a = useState(new Date().toISOString()), fromDate = _a[0], setFromDate = _a[1];
    var _b = useState(new Date().toISOString()), toDate = _b[0], setToDate = _b[1];
    var _c = useState(undefined), error = _c[0], setError = _c[1];
    return (React__default.createElement(Dialog, { type: "small", showDialog: props.isActive, onCloseDialog: props.closeDataExport, title: 'Export Nomination Data' },
        React__default.createElement(FormElement, null,
            React__default.createElement(FormLabel, { fieldName: "from" }, "From date"),
            React__default.createElement(FormFieldWrapper, null,
                React__default.createElement(DatePicker, { onDateChange: function (date, inputValue) {
                        setFromDate(date || inputValue);
                    }, dateSeperator: "-", icon: React__default.createElement("i", { className: "icon-calendar-1" }), locale: 'nl', value: fromDate })),
            React__default.createElement(FormErrorMessage, { errorMessage: error ? error : undefined })),
        React__default.createElement(FormElement, null,
            React__default.createElement(FormLabel, { fieldName: "to" }, "To date"),
            React__default.createElement(FormFieldWrapper, null,
                React__default.createElement(DatePicker, { onDateChange: function (date, inputValue) {
                        setToDate(date || inputValue);
                    }, dateSeperator: "-", icon: React__default.createElement("i", { className: "icon-calendar-1" }), locale: 'nl', value: toDate })),
            React__default.createElement(FormErrorMessage, { errorMessage: error ? error : undefined })),
        React__default.createElement(ButtonGroup, null,
            React__default.createElement(Button, { preventDoubleClick: true, primary: true, onClick: downloadNominationsExport }, "Export"))));
    function downloadNominationsExport() {
        try {
            if (fromDate && toDate) {
                if (isValidDate(fromDate) && isValidDate(toDate)) {
                    getNominationsExport(props.authenticationService, fromDate, toDate);
                    setError(undefined);
                }
                else {
                    setError('Please fill in valid dates');
                }
            }
            else {
                setError('Please fill in both dates');
            }
        }
        catch (error) {
            handleFetchError(error);
        }
    }
};

var TimelineActionMenu = function (props) {
    var _a = useState(false), nominationExportActive = _a[0], setNominationExportActive = _a[1];
    var _b = useState(false), showTimezonePicker = _b[0], setShowTimezonePicker = _b[1];
    var _c = useState(false), datepickerActive = _c[0], setDatepickerActive = _c[1];
    var timeSelectionDropdown = useRef(null);
    var timezoneSelection = useRef(null);
    useOnClickOutside(timeSelectionDropdown, function () {
        if (datepickerActive) {
            setDatepickerActive(false);
        }
    });
    useOnClickOutside(timezoneSelection, function () {
        if (showTimezonePicker) {
            setShowTimezonePicker(false);
        }
    });
    var unsavedChangesCount = Object.keys(props.unsavedChanges).length;
    var hasSelectedEvents = props.selectedEventsCount > 0;
    var userRoles = props.userProfile ? props.userProfile.roles : undefined;
    var timeFrameText = DateTime.fromJSDate(props.startTime).toFormat('dd MMM') + " - " + DateTime.fromJSDate(props.endTime).toFormat('dd MMM y');
    return (React__default.createElement(React__default.Fragment, null,
        props.showDataExport === true && (React__default.createElement(NominationDataExporter, { authenticationService: props.authenticationService, isActive: nominationExportActive, closeDataExport: function () {
                setNominationExportActive(false);
            } })),
        React__default.createElement("div", { className: "content-left" },
            React__default.createElement("div", { className: "time-selection-dropdown-wrapper", ref: timeSelectionDropdown },
                React__default.createElement(DropDownButton, { buttonText: "", primary: true, outline: true, iconButton: true, renderCustomIcon: function () {
                        return React__default.createElement(FontAwesomeIcon, { icon: faCalendar });
                    } },
                    React__default.createElement(DropDownButtonItem, { onClick: function () { return handleChangeViewPort('TODAY'); } }, "Today"),
                    React__default.createElement(DropDownButtonItem, { onClick: function () { return handleChangeViewPort('THIS_WEEK'); } }, "This week"),
                    React__default.createElement(DropDownButtonItem, { onClick: function () { return handleChangeViewPort('THIS_MONTH'); } }, "This month"),
                    React__default.createElement(DropDownButtonItem, { onClick: function () { return handleChangeViewPort('PICK_A_DATE'); } }, "Pick a date")),
                React__default.createElement(DateDialog, { onDateSave: goToDate, showDateDialog: datepickerActive, closeDateDialog: function () { return setDatepickerActive(false); }, dateSelectDialogTitle: '' })),
            React__default.createElement("div", { ref: timezoneSelection, className: classNames('timezone-select-wrapper', { visible: showTimezonePicker }) },
                React__default.createElement(Button$1, { iconButton: true, preventDoubleClick: true, primary: true, outline: true, onClick: function () {
                        setShowTimezonePicker(!showTimezonePicker);
                    }, title: "Select a timezone" },
                    React__default.createElement(Icon, null,
                        React__default.createElement(FontAwesomeIcon, { icon: faClock }))),
                React__default.createElement(FormElement, null,
                    React__default.createElement(SelectionBox, { placeholder: 'Local Time', fieldName: 'timezone', value: props.activeTimezone || undefined, valueKey: "value", displayKey: "value", renderFieldValue: function (selectedItem) {
                            return "" + selectedItem.value;
                        }, onChangeValue: function (selectedItem) {
                            if (selectedItem) {
                                handleTimezoneChange(selectedItem.value);
                            }
                        }, options: __spreadArrays(['Local'], TIMEZONE_NAMES).map(function (view) { return ({ value: view }); }), renderOption: function (option) {
                            return (React__default.createElement("div", null,
                                React__default.createElement("span", null, option.value)));
                        } }))),
            unsavedChangesCount > 0 && (React__default.createElement("div", { className: "unsaved-changes-wrapper" },
                React__default.createElement(Button$1, { primary: true, outline: true, preventDoubleClick: true, disabled: unsavedChangesCount === 0 || props.isSavingChanges, onClick: props.saveAllUnsavedChanges, title: "Save all changed items" }, "Save changes " + (unsavedChangesCount > 0 ? "(" + unsavedChangesCount + ")" : '')))),
            hasSelectedEvents && (React__default.createElement(Button$1, { primary: true, outline: true, preventDoubleClick: true, onClick: props.copySelection, disabled: !hasSelectedEvents, title: "Copy one or multiple prompt events selected using Ctrl+Click" },
                React__default.createElement(Icon, null,
                    React__default.createElement(FontAwesomeIcon, { icon: faCopy })),
                "Copy selection ",
                hasSelectedEvents ? "(" + props.selectedEventsCount + ")" : null))),
        React__default.createElement("div", { className: "content-center" },
            React__default.createElement("div", { className: "timeframe-selection" },
                React__default.createElement(Button$1, { iconButton: true, preventDoubleClick: true, primary: true, outline: true, onClick: function () {
                        moveTimeframe('UP');
                    }, title: "Move up" },
                    React__default.createElement(Icon, null,
                        React__default.createElement(FontAwesomeIcon, { icon: faCaretLeft }))),
                React__default.createElement("div", { className: "timeframe-text" }, timeFrameText),
                React__default.createElement(Button$1, { iconButton: true, primary: true, outline: true, onClick: function () {
                        moveTimeframe('DOWN');
                    }, title: "Move down" },
                    React__default.createElement(Icon, null,
                        React__default.createElement(FontAwesomeIcon, { icon: faCaretRight }))))),
        React__default.createElement("div", { className: "content-right" },
            React__default.createElement(Button$1, { iconButton: true, preventDoubleClick: true, primary: true, outline: true, className: "small stick-top", onClick: zoomOut, title: "Zoom out (Ctrl + scroll wheel)" },
                React__default.createElement(Icon, null,
                    React__default.createElement(FontAwesomeIcon, { icon: faSearchMinus }))),
            React__default.createElement(Button$1, { preventDoubleClick: true, iconButton: true, primary: true, outline: true, className: "small", onClick: zoomIn, title: "Zoom in (Ctrl + scroll wheel)" },
                React__default.createElement(Icon, null,
                    React__default.createElement(FontAwesomeIcon, { icon: faSearchPlus }))),
            !props.sandboxMode && isAdmin(userRoles) && props.showDataExport === true && (React__default.createElement(Button$1, { preventDoubleClick: true, primary: true, outline: true, onClick: function () { return setNominationExportActive(true); } },
                React__default.createElement(Icon, null,
                    React__default.createElement(FontAwesomeIcon, { icon: faFileExport })),
                "Export")))));
    function moveTimeframe(movement) {
        var startTime = props.startTime, endTime = props.endTime;
        var duration = endTime.valueOf() - startTime.valueOf();
        if (movement === 'UP') {
            props.onChange(new Date(startTime.valueOf() - duration), new Date(endTime.valueOf() - duration));
        }
        else {
            props.onChange(new Date(startTime.valueOf() + duration), new Date(endTime.valueOf() + duration));
        }
    }
    function handleChangeViewPort(viewport) {
        var now = DateTime.local();
        switch (viewport) {
            case 'TODAY':
                props.onChange(now.startOf('day').toJSDate(), now.plus({ days: 1 }).startOf('day').toJSDate());
                break;
            case 'THIS_WEEK':
                props.onChange(now.startOf('week').toJSDate(), now.plus({ weeks: 1 }).startOf('week').toJSDate());
                break;
            case 'NEXT_WEEK':
                props.onChange(now.plus({ weeks: 1 }).startOf('week').toJSDate(), now.plus({ weeks: 2 }).startOf('week').toJSDate());
                break;
            case 'THIS_MONTH':
                props.onChange(now.startOf('month').toJSDate(), now.plus({ months: 1 }).startOf('month').toJSDate());
                break;
            case 'PICK_A_DATE':
                setDatepickerActive(!datepickerActive);
                break;
            default:
                console.error("unknown view port value \"" + viewport + "\"");
        }
    }
    function zoomIn() {
        var startTime = props.startTime, endTime = props.endTime;
        var centerTime = (startTime.valueOf() + endTime.valueOf()) / 2;
        var duration = endTime.valueOf() - startTime.valueOf();
        props.onChange(new Date(centerTime - (duration * ZOOM_FACTOR) / 2), new Date(centerTime + (duration * ZOOM_FACTOR) / 2));
    }
    function zoomOut() {
        var startTime = props.startTime, endTime = props.endTime;
        var centerTime = (startTime.valueOf() + endTime.valueOf()) / 2;
        var duration = endTime.valueOf() - startTime.valueOf();
        props.onChange(new Date(centerTime - duration / ZOOM_FACTOR / 2), new Date(centerTime + duration / ZOOM_FACTOR / 2));
    }
    function handleTimezoneChange(timezone) {
        props.onChangeTimezone(timezone);
        setShowTimezonePicker(false);
    }
    function goToDate(date) {
        var dateToNavigate = DateTime.fromISO(date);
        var startTime = props.startTime, endTime = props.endTime;
        var duration = endTime.valueOf() - startTime.valueOf();
        var newStartTime = props.activeTimezone
            ? dateToNavigate.setZone(props.activeTimezone)
            : dateToNavigate;
        var newEndTime = newStartTime.plus({ milliseconds: duration });
        props.onChange(newStartTime.toJSDate(), newEndTime.toJSDate());
        setDatepickerActive(false);
    }
};
var TimelineActionMenu$1 = React__default.memo(TimelineActionMenu);

var TimeGridLines = function (props) {
    // get the zoned start / end of the timeline.
    var zonedTimelineStartEndTime = props.zonedStartEndTimes;
    // get dates for all the time axis labels that should be showed.
    var times = customListTimes(zonedTimelineStartEndTime.start, zonedTimelineStartEndTime.end);
    // create a line in the timeline for each of the dates returned
    return (React__default.createElement(React__default.Fragment, null, times.map(function (time, index) {
        var top = props.timeToScreen(time.toJSDate());
        return React__default.createElement("div", { key: index, style: { top: top }, className: "time-axis-grid-line" });
    })));
};
var TimeGridLines$1 = React__default.memo(TimeGridLines);

var TimelineAxis = function (props) {
    var times = customListTimes(props.zonedStartEndTimes.start, props.zonedStartEndTimes.end);
    // show hours only when the steps are smaller then 24 hours
    var hoursBetweenSteps = times.length >= 2 ? times[1].diff(times[0], 'hours').toObject().hours : undefined;
    var showHours = hoursBetweenSteps && hoursBetweenSteps < 24;
    return (React__default.createElement("div", { className: "time-axis" }, times.map(function (time, index) {
        var top = props.timeToScreen(time.toJSDate());
        var title = time.toFormat('dd MMM yyyy');
        if (showHours) {
            return (React__default.createElement("div", { key: index, style: { top: top }, className: "time-axis-item", title: title },
                React__default.createElement("div", { className: "label multiline" },
                    React__default.createElement("span", null, time.toFormat('dd MMM yyyy')),
                    React__default.createElement("br", null),
                    time.toFormat('HH:mm'))));
        }
        else {
            return (React__default.createElement("div", { key: index, style: { top: top }, className: "time-axis-item", title: title },
                React__default.createElement("div", { className: "label" }, time.toFormat('dd MMM yyyy'))));
        }
    })));
};
var TimelineAxis$1 = React__default.memo(TimelineAxis);

var TimelineColumns = function (props) {
    var _a = useState([]), timelineColumns = _a[0], setTimelineColumns = _a[1];
    useEffect(function () {
        composeTimelineColumns(props.bunkerShips, props.pipelines, props.eventsCollection, props.filteredDeliveryModes);
    }, [props.bunkerShips, props.eventsCollection, props.filteredDeliveryModes, props.pipelines]);
    return React__default.createElement(React__default.Fragment, null, props.children(timelineColumns));
    function composeTimelineColumns(bunkerShips, pipelines, eventsCollection, filteredDeliveryModes) {
        var allTimelineColumns = createColumnCollection(bunkerShips, pipelines, eventsCollection, filteredDeliveryModes);
        var sortedAndCombinedColumns = sortAndCombineColumns(bunkerShips, allTimelineColumns);
        var columnsWithIndexes = assignColumnIndexes(sortedAndCombinedColumns);
        var finalisedColumns = assignColumnClassnames(eventsCollection, columnsWithIndexes, allTimelineColumns.bunkerShipColumns.length, bunkerShips.length);
        setTimelineColumns(finalisedColumns);
    }
    function createColumnCollection(bunkerShips, pipelines, eventsCollection, filteredDeliveryModes) {
        var bunkerShipColumns = [];
        var unplannedColumns = [];
        var trucksColumns = [];
        var containerColumns = [];
        var pipelineColumns = [];
        eventsCollection.forEach(function (collection) {
            // Creates columns for each of the items in a scheduleCollection
            // Then puts them in an array with all the same type of columns grouped together
            var unplannedColumn = {
                displayName: 'Unplanned',
                collectionName: collection.name ? collection.name : '',
                unplanned: true,
                bunkerShipId: '',
                pipelineId: null,
                x: 0,
                columnCollectionId: collection._id ? collection._id : '',
                columnType: 'UNASSIGNED',
            };
            var trucksColumn = {
                displayName: 'Trucks',
                collectionName: collection.name ? collection.name : '',
                unplanned: false,
                bunkerShipId: null,
                pipelineId: null,
                x: 0,
                columnCollectionId: collection._id ? collection._id : '',
                columnType: 'TRUCK',
            };
            var containerColumn = {
                displayName: 'Container',
                collectionName: collection.name ? collection.name : '',
                unplanned: false,
                bunkerShipId: null,
                pipelineId: null,
                x: 0,
                columnCollectionId: collection._id ? collection._id : '',
                columnType: 'CONTAINER',
            };
            var pipeColumns = pipelines.map(function (pipeline) {
                return {
                    displayName: pipeline.name,
                    collectionName: collection.name ? collection.name : '',
                    unplanned: false,
                    bunkerShipId: null,
                    pipelineId: pipeline._id,
                    x: 0,
                    columnCollectionId: collection._id ? collection._id : '',
                    columnType: 'PIPE',
                };
            });
            var bunkerColumns = bunkerShips.map(function (bunkerShip) {
                return {
                    displayName: bunkerShip.name,
                    collectionName: collection.name ? collection.name : '',
                    unplanned: false,
                    x: 0,
                    bunkerShipId: bunkerShip._id,
                    pipelineId: null,
                    isSandbox: collection.isSandboxCollection,
                    columnCollectionId: collection._id ? collection._id : '',
                    columnType: 'SHIP',
                };
            });
            // Add all the columns of the same type together
            unplannedColumns = __spreadArrays(unplannedColumns, [unplannedColumn]);
            bunkerShipColumns = filteredDeliveryModes.includes('SHIP') ? [] : __spreadArrays(bunkerShipColumns, bunkerColumns);
            trucksColumns = filteredDeliveryModes.includes('TRUCK') ? [] : __spreadArrays(trucksColumns, [trucksColumn]);
            containerColumns = filteredDeliveryModes.includes('CONTAINER') ? [] : __spreadArrays(containerColumns, [containerColumn]);
            pipelineColumns = filteredDeliveryModes.includes('PIPE') ? [] : __spreadArrays(pipelineColumns, pipeColumns);
        });
        return {
            unplannedColumns: unplannedColumns,
            bunkerShipColumns: bunkerShipColumns,
            trucksColumns: trucksColumns,
            containerColumns: containerColumns,
            pipelineColumns: pipelineColumns,
        };
    }
    function sortAndCombineColumns(bunkerShips, timelineColumnCollection) {
        // Creates arrays grouping all the columns belonging to one bunkership together, then sorts them in the right order.
        // This way they are grouped and also ordered by the collection id.
        var sortedBunkerShipColumns = bunkerShips.map(function (bunkerShip) {
            return (timelineColumnCollection.bunkerShipColumns
                .map(function (bunkerShipColumn) {
                if (bunkerShip._id === bunkerShipColumn.bunkerShipId) {
                    return bunkerShipColumn;
                }
                else {
                    return null;
                }
            })
                .filter(function (x) { return x !== null; }) // filters out any null values
                // @ts-ignore Null values are being filtered out in the above rule TODO: Possibly make this more explicit
                .sort(sortByCollection)
                // @ts-ignore
                .reduce(function (acc, element) {
                // sorts the columns so live is always in front for each ship/unplanned/loading faclity column
                if (element !== null && element.columnCollectionId === SANDBOX_ID_LIVE) {
                    return __spreadArrays([element], acc);
                }
                return __spreadArrays(acc, [element]);
            }, []));
        });
        // Sorts and combines all the columns together.
        var sortedUnplannedColumns = sortColumnsByCollectionAndLive(timelineColumnCollection.unplannedColumns);
        // @ts-ignore
        var mergedBunkerShipColumns = [].concat.apply([], sortedBunkerShipColumns);
        var sortedTruckColumns = sortColumnsByCollectionAndLive(timelineColumnCollection.trucksColumns);
        var sortedContainerColumns = sortColumnsByCollectionAndLive(timelineColumnCollection.containerColumns);
        var sortedPipelineColumns = sortColumnsByCollectionAndLive(timelineColumnCollection.pipelineColumns);
        // combine all the different types of columns into one array.
        var columns = __spreadArrays(sortedUnplannedColumns, mergedBunkerShipColumns, sortedTruckColumns, sortedContainerColumns, sortedPipelineColumns);
        return columns;
    }
    function assignColumnIndexes(timelineColumns) {
        // assigns the right indexes to the columns after sorting / combining
        return timelineColumns.map(function (column, index) {
            column.x = index;
            return column;
        });
    }
    function assignColumnClassnames(eventsCollection, timelineColumns, bunkerShipColumnAmount, bunkerShipsAmount) {
        var updatedTimelineColumns = [];
        // Assign the column classNames to give each column the corresponding collection color.
        eventsCollection.forEach(function (collection) {
            timelineColumns.forEach(function (column, columnIndex) {
                if (column.columnCollectionId === SANDBOX_ID_LIVE) {
                    column.sandboxClassName = 'timeline-column-live';
                }
                // Adds a special class to the last column of each ship
                if (!column.columnCollectionId && !collection._id) {
                    column.sandboxClassName = 'timeline-column-detailed';
                }
                // adds the last column class to the last column of each ship/unplanned/loading facility section
                else if ((columnIndex + 1) % (bunkerShipColumnAmount / bunkerShipsAmount) === 0) {
                    column.sandboxClassName = column.sandboxClassName ? column.sandboxClassName : ' last-column';
                }
                updatedTimelineColumns.push(column);
            });
        });
        return updatedTimelineColumns;
    }
    function sortColumnsByCollectionAndLive(columnCollection) {
        return columnCollection.sort(sortByCollection).reduce(function (acc, element) {
            // Sorts the array so the items with the collectionId of live are always in front
            if (element !== null && element.columnCollectionId === SANDBOX_ID_LIVE) {
                return __spreadArrays([element], acc);
            }
            return __spreadArrays(acc, [element]);
        }, []);
    }
    function sortByCollection(a, b) {
        // sorts an array of timelinecolumns based on their collection id
        if (a.columnCollectionId < b.columnCollectionId) {
            return -1;
        }
        if (a.columnCollectionId > b.columnCollectionId) {
            return 1;
        }
        return 0;
    }
};
var TimelineColumns$1 = React__default.memo(TimelineColumns);

var ItemContent = function (props) {
    var sourceName = useLocationName(props.timelineItem.sourceId, props.locationService, formatPortTerminal);
    var destinationName = useLocationName(props.timelineItem.destinationId, props.locationService, formatPortTerminal);
    var locationName = useLocationName(props.timelineItem.locationId, props.locationService, formatPortTerminal);
    var fromToLocation = props.timelineItem.sourceId && props.timelineItem.destinationId
        ? sourceName.text + " - " + destinationName.text
        : null;
    var locationTitle = fromToLocation || locationName.text || props.timelineItem.locationId;
    var shipName = props.receivingShipDetails ? props.receivingShipDetails.name : null;
    var eventHoverText = props.timelineItem._type === 'nomination'
        ? (shipName || '') + " " + (props.timelineItem.amount ? props.timelineItem.amount + 'MT' : '') + " " + (props.companyDetails ? props.companyDetails.companyName : '')
        : props.timelineItem._type + " " + (props.timelineItem.amount ? props.timelineItem.amount + ' MT' : '');
    return (createElement("div", { className: "item-contents", onClick: function (event) {
            props.onTimelineItemClick(event);
        }, title: eventHoverText },
        createElement("div", null,
            createElement("b", null, locationTitle || '')),
        (props.timelineItem._type === 'spot' || props.timelineItem._type === 'nomination') && (createElement("div", { className: "icons" },
            props.timelineItem._type === 'spot' && (createElement(Fragment, null,
                createElement(Icon, null,
                    createElement(FontAwesomeIcon, { icon: faBullseye })))),
            props.timelineItem.deliveryModes &&
                props.timelineItem.deliveryModes.map(function (mode, index) {
                    return createElement("div", null, getDeliveryModeIcon(mode, "deliveryMode-icon-" + index));
                }))),
        createElement("div", { className: "timeline-item-value" }, [getEventTypeText(), getQuantityText()].filter(function (e) { return e; }).join(' | '))));
    function getEventTypeText() {
        if (props.timelineItem._type &&
            (props.timelineItem._type === 'nomination' || props.timelineItem._type === 'spot')) {
            // Nomination, don't show the type, but show the vessel name
            if (shipName) {
                return shipName;
            }
        }
        else {
            // Other event types (loading, travel, etc), return the event type name
            return getTimelineItemDisplayName(props.timelineItem._type, props.timelineItem.tentativeType);
        }
        return null;
    }
    function getQuantityText() {
        return props.timelineItem.amount
            ? props.timelineItem.amount + " " + (props.timelineItem.quantityUnit === 'CUBIC_METERS' ? 'm³' : 'mt') + " "
            : null;
    }
};

var TimeTooltips = function (props) {
    return (createElement("div", { className: "time-tooltips" },
        createElement("div", { className: props.displayLocation === 'left' ? 'time-tooltip tooltip-left start' : 'time-tooltip tooltip-right start' }, formatJSDateWithZone(props.startTime, 'H:mm', props.activeTimezone)),
        createElement("div", { className: props.displayLocation === 'left' ? 'time-tooltip tooltip-left end' : 'time-tooltip tooltip-right end' }, formatJSDateWithZone(props.endTime, 'H:mm', props.activeTimezone))));
};

var EnquiryItem = function (props) {
    var _a;
    var timelineItemTimeData = props.enquiryTimelineItem.itemData;
    var enquiry = props.enquiryTimelineItem.event;
    var unassigned = isEmpty$1(enquiry.bunkerShipId);
    // const background = this.props.companyDetails ? this.props.companyDetails.companyColor : 'gray'
    var background = '#E8E8E8';
    var column = findColumn(enquiry.bunkerShipId ? enquiry.bunkerShipId : null, enquiry.pipelineId, props.columns, enquiry.column, props.sandboxId);
    var yUnitToScreen = props.timeToScreen;
    var xUnitToScreen = props.xToScreen;
    var className = classNames('item', 'transfer', "" + enquiry._id, {
        unassigned: unassigned,
    }, { 'timeline-grouped-item': props.isGrouped ? true : false });
    // Makes sure the item is not rendered if it's not in the timeline viewport
    if (!props.isVisible(timelineItemTimeData.yStart, timelineItemTimeData.yEnd)) {
        return null;
    }
    return (React__default.createElement(ViewerItem, { key: "transfer:" + props.enquiryTimelineItem.event._id, item: timelineItemTimeData, movement: MOVE_CENTER, yUnitToScreen: yUnitToScreen, xUnitToScreen: xUnitToScreen, className: className + " " + enquiry.state + " " + ((_a = enquiry.attributes) === null || _a === void 0 ? void 0 : _a.fbStatus), style: { background: background }, onChange: handleChangeItem },
        React__default.createElement("div", { className: classNames('grouping-indicator', { visible: props.isGrouped ? true : false }) }),
        React__default.createElement(ItemContent, { timelineItem: enquiry, sandboxId: props.sandboxId, locationService: props.locationService, companyDetails: props.companyDetails, onTimelineItemClick: function () {
                props.onSelectEnquiry('spot', props.enquiryTimelineItem.event, props.sandboxId);
            } }),
        React__default.createElement(TimeTooltips, { startTime: timelineItemTimeData.yStart, endTime: timelineItemTimeData.yEnd, displayLocation: column.x === props.columns.length - 1 ? 'left' : 'right', activeTimezone: props.activeTimezone })));
    function handleChangeItem(item) {
        if (props.readOnly) {
            return;
        }
        var timelineItem = props.enquiryTimelineItem;
        var timelineItemEvent = timelineItem.event;
        var updatedItemData = item.updatedItem;
        var timelineColumn = getTimelineColumn(updatedItemData, timelineItemEvent, props.columns);
        // 0 to make sure the item can't be dragged in time. Only between bunkerships
        props.moveTimelineItems(0, timelineItemEvent, timelineColumn);
    }
};
var EnquiryItem$1 = React__default.memo(EnquiryItem);

var ItemWithWindow = /** @class */ (function (_super) {
    __extends(ItemWithWindow, _super);
    function ItemWithWindow() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            locationName: '(loading...)'
        };
        _this.renderWindow = function (timelineItem, column) {
            if (!timelineItem.windowData) {
                return null;
            }
            var timelineItemEvent = timelineItem.event;
            if (!column || !timelineItemEvent.windowStart || !timelineItemEvent.windowEnd) {
                return null;
            }
            if (!_this.props.isVisible(timelineItem.windowData.yStart, timelineItem.windowData.yEnd)) {
                return null;
            }
            var yUnitToScreen = _this.props.timeToScreen;
            var xUnitToScreen = _this.props.xToScreen;
            return (React__default.createElement(ViewerItem, { key: "windowBlock:" + timelineItemEvent._id, item: timelineItem.windowData, movement: MOVE_CENTER, yUnitToScreen: yUnitToScreen, xUnitToScreen: xUnitToScreen, className: classNames('item', _this.props.timelineItem.event._type + "-window", 'timeline-block'), onChange: function (itemChange) {
                    _this.handleChangeItem(itemChange, 'WINDOW');
                } },
                React__default.createElement("div", { className: "item-contents", onClick: function () { return _this.props.openPromptEventBlockModal(_this.props.timelineItem.event._type, timelineItemEvent); }, title: "window event" },
                    React__default.createElement("div", { className: "block-title" }, timelineItemEvent._type === 'discharge' ? 'Discharge Window' : 'Loading Window'),
                    React__default.createElement("div", { className: "timeline-item-value location" },
                        React__default.createElement(Icon, null,
                            React__default.createElement(FontAwesomeIcon, { icon: faMapMarkerAlt })),
                        _this.state.locationName),
                    React__default.createElement("div", { className: "timeline-item-value" },
                        React__default.createElement(Icon, null,
                            React__default.createElement(FontAwesomeIcon, { icon: faUser })),
                        timelineItemEvent.receiver ? timelineItemEvent.receiver : '-')),
                React__default.createElement(TimeTooltips, { startTime: timelineItem.windowData.yStart, endTime: timelineItem.windowData.yEnd, displayLocation: column.x === _this.props.columns.length - 1 ? 'left' : 'right', activeTimezone: _this.props.activeTimezone })));
        };
        _this.onTimelineItemClick = function (event) {
            if (event.ctrlKey || event.metaKey) {
                _this.toggleItemInGroup(_this.props.timelineItem);
            }
            else if (_this.props.timelineItem) {
                _this.props.openPromptEventBlockModal(_this.props.timelineItem.event._type, _this.props.timelineItem.event, _this.props.sandboxId);
            }
        };
        _this.toggleItemInGroup = function (timelineItem) {
            _this.props.toggleItemInTimelineGroup(timelineItem.event);
        };
        _this.handleChangeItem = function (itemChange, itemType) {
            if (_this.props.readOnly) {
                return;
            }
            var timelineItem = _this.props.timelineItem;
            var timelineItemEvent = timelineItem.event;
            var updatedItemData = itemChange.updatedItem;
            var timelineColumn = getTimelineColumn(updatedItemData, timelineItemEvent, _this.props.columns);
            if (itemType && itemType === 'WINDOW') {
                var timeDragged = getTimeDragged(updatedItemData, timelineItemEvent, true);
                _this.props.moveTimelineItems(timeDragged, timelineItemEvent, timelineColumn, true);
                // call container function with extra thingy
            }
            else {
                // call normal container function
                var timeDragged = getTimeDragged(updatedItemData, timelineItemEvent);
                _this.props.moveTimelineItems(timeDragged, timelineItemEvent, timelineColumn);
            }
        };
        return _this;
    }
    ItemWithWindow.prototype.componentDidMount = function () {
        this.updateLocation(this.props.timelineItem.event.locationId);
    };
    ItemWithWindow.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        if (this.props.timelineItem.event.locationId !== prevProps.timelineItem.event.locationId) {
            this.updateLocation(this.props.timelineItem.event.locationId);
        }
    };
    ItemWithWindow.prototype.updateLocation = function (locationId) {
        var _this = this;
        if (locationId) {
            try {
                this.props.locationService.findLocationById(locationId).then(function (location) {
                    _this.setState({
                        locationName: formatPortTerminal(location)
                    });
                });
            }
            catch (err) {
                this.setState({
                    locationName: '(Error loading location)'
                });
            }
        }
        else {
            this.setState({
                locationName: '-'
            });
        }
    };
    ItemWithWindow.prototype.render = function () {
        var isGrouped = this.props.isGrouped;
        var itemOutsideWindow = false;
        var timelineItem = this.props.timelineItem.event;
        var column = findColumn(timelineItem.bunkerShipId, timelineItem.pipelineId, this.props.columns, timelineItem.column, this.props.sandboxId);
        var itemData = this.props.timelineItem.itemData;
        var windowData = this.props.timelineItem.windowData;
        var yUnitToScreen = this.props.timeToScreen;
        var xUnitToScreen = this.props.xToScreen;
        if (timelineItem.etd == null || timelineItem.eta == null || !column) {
            return null;
        }
        // Checks if the item is outside of it's window.
        if (windowData && windowData.yStart && windowData.yEnd) {
            if (isAfter(DateTime.fromJSDate(itemData.yStart), DateTime.fromJSDate(windowData.yEnd)) ||
                isBefore(DateTime.fromJSDate(itemData.yStart), DateTime.fromJSDate(windowData.yEnd))) {
                itemOutsideWindow = true;
            }
        }
        return (React__default.createElement(React__default.Fragment, null,
            this.renderWindow(this.props.timelineItem, column),
            this.props.isVisible(itemData.yStart, itemData.yEnd) && (React__default.createElement(ViewerItem, { key: "dischargeBlock:" + timelineItem._id, item: itemData, movement: MOVE_CENTER, yUnitToScreen: yUnitToScreen, xUnitToScreen: xUnitToScreen, className: classNames('item', this.props.timelineItem.event._type + "-block", 'timeline-block', {
                    'window-warning': itemOutsideWindow,
                    'timeline-grouped-item': isGrouped ? true : false,
                }), onChange: this.handleChangeItem },
                React__default.createElement(React__default.Fragment, null,
                    React__default.createElement("div", { className: classNames('grouping-indicator', { visible: isGrouped ? true : false }) }),
                    React__default.createElement(ItemContent, { timelineItem: timelineItem, sandboxId: this.props.sandboxId, openPromptEventBlockModal: this.props.openPromptEventBlockModal, locationService: this.props.locationService, onTimelineItemClick: this.onTimelineItemClick }),
                    React__default.createElement(TimeTooltips, { startTime: itemData.yStart, endTime: itemData.yEnd, displayLocation: column.x === this.props.columns.length - 1 ? 'left' : 'right', activeTimezone: this.props.activeTimezone }))))));
    };
    return ItemWithWindow;
}(React__default.PureComponent));

var HoverHandler = function (props) {
    return (createElement("div", { onClick: function (event) { return props.handleClick(event); }, className: "contents", 
        //  Below functions handle all the events which can cause
        //  the various components to become visible / invisible.
        //  The timers are used in case the leave/out events don't trigger.
        onMouseEnter: function () {
            props.handleMouseOverItem(props.nomination._id);
            props.setHovering(true);
        }, onMouseLeave: function () {
            if (!props.isDragging) {
                props.handleMouseLeaveItem(props.nomination._id);
            }
            props.setHovering(false);
        }, onMouseDown: function () { return props.setDragging(true); }, onMouseUp: function () { return props.setDragging(false); }, onMouseMove: function () {
            clearTimeout(props.timer);
            var timer = setTimeout(function () {
                if (!props.isHovering) {
                    props.setDragging(false);
                    props.handleMouseLeaveItem(props.nomination._id);
                }
            }, 200);
            props.setTimer(timer);
        }, onMouseOut: function () {
            clearTimeout(props.timer);
            var timer = setTimeout(function () {
                props.setDragging(false);
                props.setHovering(false);
                props.handleMouseLeaveItem(props.nomination._id);
            }, 500);
            props.setTimer(timer);
        } }, props.children));
};

var NominationItem = /** @class */ (function (_super) {
    __extends(NominationItem, _super);
    function NominationItem(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChangeItem = function (itemChange) {
            var nomination = _this.props.nominationTimelineItem.event;
            if ((nomination.state && (nomination.state === 'CANCELLED' || nomination.state === 'COMPLETED')) ||
                _this.props.readOnly) {
                return; // makes sure the cancelled nominations can't be dragged / altered anymore.
            }
            if (!_this.props.draggingStarted) {
                _this.setState({ originalNomination: nomination, originalItem: itemChange.initialItem });
            }
            var updatedNomination = _this.createUpdatedNomination(itemChange.updatedItem, nomination);
            if (!isEqual(updatedNomination, nomination)) {
                // updates the nomination with the original times, allows for horizontal scrolling without the times of the item changing.
                var updatedNominationWithOriginalTimes = _this.dragItemWithOriginalTimes(updatedNomination);
                _this.props.handleChangeTimelineNominationItem(updatedNominationWithOriginalTimes, _this.props.sandboxId);
            }
            _this.props.setDraggingStarted();
        };
        _this.createUpdatedNomination = function (item, nomination) {
            var xOffset = COLUMN_CENTER -
                (hasReceivingShipWithTimes$1(nomination) ? COLUMN_NOMINATION_SHIP_RIGHT : COLUMN_NOMINATION_SHIP_LEFT);
            var xColumn = Math.floor(item.xStart + xOffset);
            var timelineColumn = findColumnByNumber(xColumn, _this.props.columns);
            var startTime = snapToHour(item.yStart);
            var timeToSet = nomination.bunkershipEta
                ? DateTime.fromISO(nomination.bunkershipEta)
                : nomination.bst
                    ? DateTime.fromISO(nomination.bst)
                    : undefined;
            var windowEndTime = nomination.etd ? DateTime.fromISO(nomination.etd) : undefined;
            var allowedBunkeringTime = nomination.allowedBunkeringTime;
            // Bas todo make sure the item can't extend beyond the maximum eta allowed.
            var maxEta = null;
            if (windowEndTime && timeToSet && allowedBunkeringTime !== undefined) {
                maxEta =
                    allowedBunkeringTime <= 0
                        ? (maxEta = windowEndTime.minus({ hours: DEFAULT_TRANSFER_DURATION_HOURS }).toISO())
                        : (maxEta = windowEndTime.minus({ hours: allowedBunkeringTime }).toISO());
            }
            if (timeToSet && nomination.bst) {
                var diffMillis = DateTime.fromJSDate(startTime).diff(timeToSet).milliseconds;
                var updatedTime = timeToSet.plus({ milliseconds: diffMillis }).toISO();
                return Object.assign({}, nomination, {
                    bunkerShipId: timelineColumn ? timelineColumn.bunkerShipId : null,
                    pipelineId: timelineColumn ? timelineColumn.pipelineId : null,
                    bunkershipEta: _this.determineBunkerShipEta(updatedTime, nomination.bst, maxEta),
                    column: timelineColumn ? timelineColumn.columnType : '',
                });
            }
            return nomination;
        };
        /**
         * Makes sure the orignal times of the dragging item stay the same when dragging between bunkerships.
         * Horizontal scrolling maintains the original tst and tet of the dragged item this way.
         */
        _this.dragItemWithOriginalTimes = function (updatedNomination) {
            if (_this.state.originalNomination &&
                _this.state.originalNomination.bunkerShipId !== updatedNomination.bunkerShipId) {
                if (_this.state.originalNomination.bunkershipEta === null) {
                    updatedNomination.bunkershipEta = _this.state.originalNomination.bst;
                }
                else {
                    updatedNomination.bunkershipEta = _this.state.originalNomination.bunkershipEta;
                }
            }
            return updatedNomination;
        };
        _this.determineBunkerShipEta = function (updatedTime, bst, maxEta) {
            // makes sure the eta is after the bst, otherwise it sets the bst as the time.
            // if the eta is after the bst it checks if the end of the window is not after the etd of the receiving ship.
            var parsedUpdateTime = DateTime.fromISO(updatedTime);
            var parsedBST = DateTime.fromISO(bst);
            if (isAfter(parsedUpdateTime, parsedBST)) {
                if (maxEta) {
                    if (isBefore(parsedUpdateTime, DateTime.fromISO(maxEta))) {
                        return updatedTime;
                    }
                    else {
                        return maxEta;
                    }
                }
                else {
                    return updatedTime;
                }
            }
            else {
                return bst;
            }
        };
        _this.onTimelineItemClick = function () {
            if (_this.props.nominationTimelineItem.event) {
                _this.props.onSelectNomination('nomination', _this.props.nominationTimelineItem.event, _this.props.sandboxId);
            }
        };
        _this.toggleItemInGroup = function (timelineItem) {
            _this.props.toggleItemInTimelineGroup(timelineItem.event);
        };
        _this.handleClick = function (event) {
            event.preventDefault();
            event.stopPropagation();
            if (_this.props.nominationTimelineItem.event) {
                _this.props.onSelectNomination('nomination', _this.props.nominationTimelineItem.event, _this.props.sandboxId);
            }
        };
        _this.state = {
            isDragging: false,
            isHovering: false,
            timer: null,
        };
        return _this;
    }
    NominationItem.prototype.render = function () {
        var nomination = this.props.nominationTimelineItem.event;
        var column = findColumn(nomination.bunkerShipId, nomination.pipelineId, this.props.columns, nomination.column, this.props.sandboxId);
        var timeToScreen = this.props.timeToScreen;
        var xToScreen = this.props.xToScreen;
        var timelineItemTimeData = this.props.nominationTimelineItem.itemData;
        // Makes sure the item is not rendered if it's not in the timeline viewport
        if (!this.props.isVisible(timelineItemTimeData.yStart, timelineItemTimeData.yEnd)) {
            return null;
        }
        return [
            // this.renderReceivingShip(column.x, nomination, timeToScreen, xToScreen),
            // this.renderBunkerWindow(column.x, nomination, timeToScreen, xToScreen),
            this.renderBunkerTransfer(column.x, nomination, timeToScreen, xToScreen),
        ];
    };
    // // render receiving ship ETA and ETD
    // protected renderReceivingShip(
    //   xColumn: number,
    //   nomination: IPromptNomination,
    //   timeToScreen: (time: Date) => number,
    //   xToScreen: (x: number) => number
    // ) {
    //   if (nomination.eta == null || nomination.etd == null || nomination.receivingShipId == null) {
    //     return null
    //   }
    //   const top = timeToScreen(DateTime.fromISO(nomination.eta).toJSDate())
    //   const bottom = timeToScreen(DateTime.fromISO(nomination.etd).toJSDate())
    //   const left = xToScreen(xColumn + COLUMN_NOMINATION_SHIP_LEFT)
    //   const right = xToScreen(xColumn + COLUMN_NOMINATION_SHIP_RIGHT)
    //   const width = right - left
    //   const height = bottom - top
    //   const ship = this.props.receivingShipDetails
    //   const description = ship ? ship.name + (ship.imoNumber ? ` (${ship.imoNumber})` : '') : nomination.receivingShipId
    //   return (
    //     <div
    //       key={`receiving-ship:${nomination._id}`}
    //       className={`item receiving-ship ${nomination._id}`}
    //       style={{ left, top, width, height }}
    //     >
    //       <div className="icon">
    //         <i className="fas fa-ship" />
    //       </div>
    //       <div className="description">{description}</div>
    //     </div>
    //   )
    // }
    // // render an item displaying BST and BET
    // protected renderBunkerWindow(
    //   xColumn: number,
    //   nomination: IPromptNomination,
    //   timeToScreen: (time: Date) => number,
    //   xToScreen: (x: number) => number
    // ) {
    //   if (nomination.bst === null || nomination.etd === null) {
    //     return null
    //   }
    //   const windowStartTime = nomination.bst
    //   const windowEndTime = nomination.etd
    //   const assigned = hasReceivingShipWithTimes(nomination)
    //   const top = timeToScreen(DateTime.fromISO(windowStartTime).toJSDate())
    //   const bottom = timeToScreen(DateTime.fromISO(windowEndTime).toJSDate())
    //   const left = xToScreen(xColumn + (assigned ? COLUMN_TRAVEL_LEFT : COLUMN_NOMINATION_SHIP_RIGHT))
    //   const right = xToScreen(xColumn + COLUMN_TRAVEL_RIGHT)
    //   const width = right - left
    //   const height = bottom - top
    //   return (
    //     <div
    //       key={`bunker:${nomination._id}`}
    //       className={`item bunker ${nomination._id}`}
    //       style={{ left, top, width, height }}
    //     >
    //       <div className="bst" title={`Bunkering Start Time (BST): ${formatDateTime(windowStartTime)}`}>
    //         <span className="inner">{formatTime(windowStartTime)}</span>
    //       </div>
    //       <div className="bet" title={`Bunkering Start Time (BET): ${formatDateTime(windowEndTime)}`}>
    //         <span className="inner">{formatTime(windowEndTime)}</span>
    //       </div>
    //     </div>
    //   )
    // }
    // render an item displaying the molecule transfer time
    NominationItem.prototype.renderBunkerTransfer = function (xColumn, nomination, timeToScreen, xToScreen) {
        var _this = this;
        var _a;
        var timelineItemTimeData = this.props.nominationTimelineItem.itemData;
        var unassigned = isEmpty$1(nomination.bunkerShipId);
        var assignedReceivingShip = hasReceivingShipWithTimes$1(nomination);
        // const background = this.props.companyDetails ? this.props.companyDetails.companyColor : 'gray'
        var background = '#E8E8E8';
        var className = classNames('item', 'transfer', "" + nomination._id, {
            'assigned-receiving-ship': assignedReceivingShip,
            unassigned: unassigned,
        }, { 'timeline-grouped-item': this.props.isGrouped ? true : false });
        var stateDescription = getPromptStateDescription(nomination);
        return (React__default.createElement(ViewerItem, { key: "transfer:" + nomination._id, item: timelineItemTimeData, movement: MOVE_CENTER, yUnitToScreen: timeToScreen, xUnitToScreen: xToScreen, className: className + " " + nomination.state + " " + ((_a = nomination.attributes) === null || _a === void 0 ? void 0 : _a.fbStatus), style: { background: background }, onChange: this.handleChangeItem },
            React__default.createElement("div", { className: classNames('grouping-indicator', { visible: this.props.isGrouped ? true : false }) }),
            React__default.createElement(HoverHandler, { nomination: nomination, isDragging: this.state.isDragging, isHovering: this.state.isHovering, timer: this.state.timer, handleClick: this.onTimelineItemClick, handleMouseOverItem: this.handleMouseOverItem, handleMouseLeaveItem: this.handleMouseLeaveItem, setHovering: function (state) { return _this.setState({ isHovering: state }); }, setDragging: function (state) { return _this.setState({ isDragging: state }); }, setTimer: function (timer) { return _this.setState({ timer: timer }); } },
                React__default.createElement(ItemContent, { timelineItem: nomination, sandboxId: this.props.sandboxId, locationService: this.props.locationService, stateDescription: stateDescription, companyDetails: this.props.companyDetails, receivingShipDetails: this.props.receivingShipDetails, onTimelineItemClick: function () {
                        return;
                    } })),
            React__default.createElement(TimeTooltips, { startTime: timelineItemTimeData.yStart, endTime: timelineItemTimeData.yEnd, displayLocation: xColumn === this.props.columns.length - 1 ? 'left' : 'right', activeTimezone: this.props.activeTimezone })));
    };
    NominationItem.prototype.handleMouseOverItem = function (itemId) {
        var elementsToSelect = document.getElementsByClassName("" + itemId);
        Array.from(elementsToSelect).forEach(function (element) {
            element.classList.add('hovered-item');
        });
    };
    NominationItem.prototype.handleMouseLeaveItem = function (itemId) {
        var elementsToSelect = document.getElementsByClassName("" + itemId);
        Array.from(elementsToSelect).forEach(function (element) {
            element.classList.remove('hovered-item');
        });
    };
    return NominationItem;
}(React__default.PureComponent));
function getPromptStateDescription(event) {
    return "State: " + event.state + ", updated " + formatDateTime(event.reactionTime) + " by " + (event.author ? event.author.name : '?') + ".";
}
function hasReceivingShipWithTimes$1(nomination) {
    return nomination.eta != null && nomination.etd != null && nomination.receivingShipId != null;
}

var TimelineItem = /** @class */ (function (_super) {
    __extends(TimelineItem, _super);
    function TimelineItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onTimelineItemClick = function (event) {
            if (event.ctrlKey || event.metaKey) {
                _this.toggleItemInGroup(_this.props.timelineItem);
            }
            else if (_this.props.timelineItem) {
                _this.props.openPromptEventBlockModal(_this.props.timelineItem.event._type, _this.props.timelineItem.event, _this.props.sandboxId);
            }
        };
        _this.toggleItemInGroup = function (timelineItem) {
            _this.props.toggleItemInTimelineGroup(timelineItem.event);
        };
        _this.handleChangeItem = function (item) {
            if (_this.props.readOnly) {
                return;
            }
            var timelineItem = _this.props.timelineItem;
            var timelineItemEvent = timelineItem.event;
            var updatedItemData = item.updatedItem;
            var timelineColumn = getTimelineColumn(updatedItemData, timelineItemEvent, _this.props.columns);
            // updating items gets handled by the container
            var timeDragged = _this.props.movementType !== 'HORIZONTAL' ? getTimeDragged(updatedItemData, timelineItemEvent) : 0;
            _this.props.moveTimelineItems(timeDragged, timelineItemEvent, timelineColumn);
        };
        return _this;
    }
    TimelineItem.prototype.render = function () {
        var _a = this.props, timelineItem = _a.timelineItem, isGrouped = _a.isGrouped;
        var column = timelineItem.column;
        var item = timelineItem.itemData;
        var timeToScreen = this.props.timeToScreen;
        var xToScreen = this.props.xToScreen;
        return (React__default.createElement(ViewerItem, { item: item, movement: this.getTimelineMovement(this.props.movementType), yUnitToScreen: timeToScreen, xUnitToScreen: xToScreen, className: classNames('item', this.props.timelineItem.event._type + "-block", 'timeline-block'), onChange: this.handleChangeItem },
            React__default.createElement(React__default.Fragment, null,
                React__default.createElement("div", { className: classNames('grouping-indicator', { visible: isGrouped ? true : false }) }),
                React__default.createElement(ItemContent, { timelineItem: this.props.timelineItem.event, sandboxId: this.props.sandboxId, openPromptEventBlockModal: this.props.openPromptEventBlockModal, onTimelineItemClick: this.onTimelineItemClick, locationService: this.props.locationService, companyDetails: this.props.companyDetails }),
                React__default.createElement(TimeTooltips, { startTime: item.yStart, endTime: item.yEnd, displayLocation: column.x === this.props.columns.length - 1 ? 'left' : 'right', activeTimezone: this.props.activeTimezone }))));
    };
    TimelineItem.prototype.getTimelineMovement = function (movementType) {
        switch (movementType) {
            case 'CENTER':
                return MOVE_CENTER;
            case 'VERTICAL':
                return MOVE_VERTICAL;
            case 'HORIZONTAL':
                return MOVE_HORIZONTAL;
            default:
                return MOVE_CENTER;
        }
    };
    return TimelineItem;
}(React__default.PureComponent));

var TimelineItemRenderer = /** @class */ (function (_super) {
    __extends(TimelineItemRenderer, _super);
    function TimelineItemRenderer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Triggers the various functions required to create the data structure for the timeline events, handle the cascading and rendering.
         */
        _this.renderAllTimelineEvents = function (eventsCollection) {
            return eventsCollection.map(function (collection) {
                var promptEventsCollection = collection.promptEvents;
                var timelineItems = _this.createTimelineItems(promptEventsCollection, collection); // creates the datastructure for the timeline events
                var groupedAndSortedItems = _this.groupAndSortTimelineItems(timelineItems); // groups all the timeline events by column and then sorts the events by their starttime
                var itemsWithCascading = _this.addCascadingIndentation(groupedAndSortedItems); // adds the cascading indentation level for each timeline item
                // @ts-ignore -> ts for some reason doesn't like me crushing all the items back into one array. Ignoring this for now.
                var allCombinedTimelineItems = [].concat.apply([], itemsWithCascading); // combines all the cascaded and processed timeline events back into one array.
                var timelineComponents = _this.renderTimelineComponents(allCombinedTimelineItems, collection); // renders the timeline events with the right components
                return timelineComponents;
            });
        };
        /**
         * Creates the datastructure for the timeline events.
         * Adds itemData with start/end times and groups the items into ITimelineItemTypes[]
         */
        _this.createTimelineItems = function (timelineEvents, collection) {
            var timelineColumns = _this.props.timelineColumns;
            var extendedTimelineItems = [];
            timelineEvents.forEach(function (timelineEvent) {
                var timeProperties = getTimelineItemTimeProperties(timelineEvent);
                if (instanceOfBasicTimelineItem(timelineEvent) &&
                    timelineEvent.bunkerShipId !== undefined &&
                    timelineEvent.pipelineId !== undefined) {
                    // PROMPT / BASIC EVENT
                    // creates the object for a prompt event // basic timeline item
                    var column = findColumn(timelineEvent.bunkerShipId, timelineEvent.pipelineId, timelineColumns, timelineEvent.column, collection._id);
                    var itemData = _this.createItemDataObject(timelineEvent, timeProperties, column);
                    var basicItem = {
                        event: timelineEvent,
                        column: column,
                        itemData: itemData,
                        indentationLevel: 0,
                        type: 'basicItem'
                    };
                    extendedTimelineItems.push(basicItem);
                }
                else if (instanceOfINominationEnquiryEvent(timelineEvent) &&
                    timelineEvent.bunkerShipId !== undefined &&
                    timelineEvent.pipelineId !== undefined) {
                    var column = findColumn(timelineEvent.bunkerShipId, timelineEvent.pipelineId, timelineColumns, timelineEvent.column, collection._id);
                    var itemData = _this.createItemDataObject(timelineEvent, timeProperties, column);
                    var enquirItem = {
                        event: timelineEvent,
                        column: column,
                        itemData: itemData,
                        indentationLevel: 0,
                        type: 'spot'
                    };
                    extendedTimelineItems.push(enquirItem);
                }
                else if (instanceOfTimelineEventWithWindow(timelineEvent) &&
                    timelineEvent.bunkerShipId !== undefined &&
                    timelineEvent.pipelineId !== undefined) {
                    // WINDOW EVENT
                    // creates the object for a timeline item with a window ( LOADING / DISCHARGE )
                    var column = findColumn(timelineEvent.bunkerShipId, timelineEvent.pipelineId, timelineColumns, timelineEvent.column, collection._id);
                    var itemData = _this.createItemDataObject(timelineEvent, timeProperties, column);
                    var windowData = _this.createWindowDataObject(timelineEvent, column);
                    var itemWithWindow = {
                        event: timelineEvent,
                        column: column,
                        itemData: itemData,
                        windowData: windowData,
                        indentationLevel: 0,
                        type: 'windowItem'
                    };
                    extendedTimelineItems.push(itemWithWindow);
                }
                else if (instanceOfNominationTimelineItem(timelineEvent) &&
                    timelineEvent.bunkerShipId !== undefined &&
                    timelineEvent.pipelineId !== undefined) {
                    // NOMINATION ITEM
                    // creates the object for the timeline nomination item
                    var column = findColumn(timelineEvent.bunkerShipId, timelineEvent.pipelineId, timelineColumns, timelineEvent.column, collection._id);
                    var itemData = _this.createNominationDataObject(timelineEvent, column);
                    if (itemData) {
                        var nominationItem = {
                            event: timelineEvent,
                            column: column,
                            itemData: itemData,
                            indentationLevel: 0,
                            type: 'nomination'
                        };
                        extendedTimelineItems.push(nominationItem);
                    }
                }
                else {
                    console.warn("Timeline item not being rendered");
                }
            });
            return extendedTimelineItems;
        };
        /**
         * Groups all the timelineItems by their column and then sorts the items in each column based on their starttime.
         */
        _this.groupAndSortTimelineItems = function (timelineItems) {
            // group items by column
            // we group either by bunkershipId or the column type
            // TODO: Later on extend with individual pipeline id's.
            var groupedItemsByColumn = groupBy(timelineItems, function (item) { return item.column.bunkerShipId || item.column.columnType; });
            // sort the items based on their starttime.
            return Object.keys(groupedItemsByColumn).map(function (column) {
                var sortedColumn = groupedItemsByColumn[column].sort(function (a, b) {
                    if (isBefore(parseDateOrStringToDateTime(a.itemData.yStart), parseDateOrStringToDateTime(b.itemData.yStart))) {
                        return -1;
                    }
                    else if (isAfter(parseDateOrStringToDateTime(a.itemData.yStart), parseDateOrStringToDateTime(b.itemData.yStart))) {
                        return 1;
                    }
                    else {
                        return 0;
                    }
                });
                return sortedColumn;
            });
        };
        /**
         * Loops through the items sorted by starttime and then adds a indentation/cascading level to each item when they have overlap with other events.
         */
        _this.addCascadingIndentation = function (sortedItemsByTimeAndColumn) {
            return sortedItemsByTimeAndColumn.map(function (column) {
                return column.map(function (item, index) {
                    var previousItem = column[index - 1];
                    if (previousItem) {
                        if (isBefore(parseDateOrStringToDateTime(item.itemData.yStart), parseDateOrStringToDateTime(item.itemData.yEnd)) &&
                            isBefore(parseDateOrStringToDateTime(previousItem.itemData.yStart), parseDateOrStringToDateTime(previousItem.itemData.yEnd))) {
                            // check for overlap between the current item and the previous item.
                            var currentItemInterval = Interval.fromDateTimes(item.itemData.yStart, item.itemData.yEnd);
                            var previousItemInterval = Interval.fromDateTimes(previousItem.itemData.yStart, previousItem.itemData.yEnd);
                            var areOverlapping = currentItemInterval.overlaps(previousItemInterval);
                            if (areOverlapping) {
                                // if items overlap, add a indentationLevel to the event
                                item.indentationLevel = previousItem.indentationLevel + 1;
                                item.itemData.xStart = item.itemData.xStart + 0.1 * item.indentationLevel;
                            }
                        }
                    }
                    return item;
                });
            });
        };
        /**
         * Renders each timeline item based on their type. Calls the render function for each individual timeline item.
         */
        _this.renderTimelineComponents = function (timelineItems, schedule) {
            var timelineEvents = timelineItems.map(function (timelineItem) {
                var xToScreen = _this.props.xToScreen;
                var timeToScreen = _this.props.timeToScreen;
                if (timelineItem.type === 'basicItem') {
                    var basicTimelineItem = timelineItem;
                    if (basicTimelineItem.event._id !== undefined) {
                        return _this.renderTimelineItemBlock(basicTimelineItem, timeToScreen, xToScreen, basicTimelineItem.event._id, schedule._id);
                    }
                    else {
                        return null;
                    }
                }
                else if (timelineItem.type === 'windowItem') {
                    var itemWithWindow = timelineItem;
                    if (itemWithWindow.event._id !== undefined) {
                        return _this.renderDischargeBlockEvent(itemWithWindow, timeToScreen, xToScreen, itemWithWindow.event._id, schedule._id);
                    }
                    else {
                        return null;
                    }
                }
                else if (instanceOfNominationTimelineItem(timelineItem.event)) {
                    return _this.renderNomination(timelineItem, timeToScreen, xToScreen, schedule._id);
                }
                else if (timelineItem.type === 'spot') {
                    if (timelineItem.event._id !== undefined) {
                        return _this.renderEnquiryTimelineItem(timelineItem, timeToScreen, xToScreen, timelineItem.event._id, schedule._id);
                    }
                    else {
                        return null;
                    }
                }
                else {
                    return null;
                }
            });
            return timelineEvents;
        };
        _this.createItemDataObject = function (timelineItem, timeProperties, column) {
            var itemData = {
                yStart: DateTime.fromISO(timelineItem[timeProperties.startTimeProperty]).toJSDate(),
                yEnd: DateTime.fromISO(timelineItem[timeProperties.endTimeProperty]).toJSDate(),
                xStart: column.x + COLUMN_NOMINATION_SHIP_RIGHT,
                xEnd: column.x + COLUMN_TRAVEL_RIGHT
            };
            return itemData;
        };
        _this.createWindowDataObject = function (timelineItem, column) {
            if (timelineItem.windowStart && timelineItem.windowEnd) {
                var itemData = {
                    yStart: DateTime.fromISO(timelineItem.windowStart).toJSDate(),
                    yEnd: DateTime.fromISO(timelineItem.windowEnd).toJSDate(),
                    xStart: column.x + COLUMN_NOMINATION_SHIP_RIGHT,
                    xEnd: column.x + COLUMN_TRAVEL_RIGHT
                };
                return itemData;
            }
            return null;
        };
        _this.createNominationDataObject = function (timelineItem, column) {
            var defaultDuration = 24;
            if (timelineItem.bst) {
                var startTimestamp = timelineItem.bunkershipAta && timelineItem.hosesDisconnected
                    ? timelineItem.bunkershipAta // finished / completed
                    : timelineItem.bunkershipEta
                        ? timelineItem.bunkershipEta // has been dragged / eta was set so use that time
                        : timelineItem.bst; // otherwise use default of bst for the start
                var startTime = DateTime.fromISO(startTimestamp);
                var endTime = void 0;
                if (timelineItem.bunkershipAta && timelineItem.hosesDisconnected) {
                    // event finished / completed
                    endTime = DateTime.fromISO(timelineItem.hosesDisconnected);
                }
                else {
                    if (startTime) {
                        if (timelineItem.allowedBunkeringTime) {
                            endTime = startTime.plus({ hours: timelineItem.allowedBunkeringTime });
                        }
                        else {
                            if (timelineItem.etd) {
                                endTime = DateTime.fromISO(timelineItem.etd);
                            }
                            else {
                                // if neither the allowedBunkeringTime and the ETD of the receiving vessel have been filled in, use a default duration of 24h
                                endTime = startTime.plus({ hours: defaultDuration });
                            }
                        }
                    }
                    else {
                        endTime = null;
                    }
                }
                if (!startTime || !endTime) {
                    return null;
                }
                var itemData = {
                    yStart: startTime.toJSDate(),
                    yEnd: endTime.toJSDate(),
                    xStart: column.x + COLUMN_NOMINATION_SHIP_RIGHT,
                    xEnd: column.x + COLUMN_TRAVEL_RIGHT
                };
                return itemData;
            }
            return null;
        };
        return _this;
    }
    TimelineItemRenderer.prototype.render = function () {
        return createElement(Fragment, null, this.renderAllTimelineEvents(this.props.eventsCollection));
    };
    TimelineItemRenderer.prototype.renderNomination = function (nominationTimelineItem, timeToScreen, xToScreen, sandboxId) {
        var promptNomination = nominationTimelineItem.event;
        var companyDetails = promptNomination.companyId
            ? getCompanyDetails(this.props.companies, promptNomination.companyId)
            : undefined;
        var receivingShipDetails = promptNomination.receivingShipId
            ? this.props.shipDetailsById[promptNomination.receivingShipId]
            : undefined;
        return (createElement(NominationItem, { key: promptNomination._id, columns: this.props.timelineColumns, nominationTimelineItem: nominationTimelineItem, receivingShipDetails: receivingShipDetails, companyDetails: companyDetails, timeToScreen: timeToScreen, xToScreen: xToScreen, onSelectNomination: this.props.openPromptEventBlockModal, locationService: this.props.locationService, sandboxId: sandboxId, isVisible: this.props.isEventInTimelineView, toggleItemInTimelineGroup: this.props.toggleItemInTimelineGroup, draggingStarted: this.props.draggingStarted, setDraggingStarted: this.props.setDraggingStarted, handleChangeTimelineNominationItem: this.props.handleChangeTimelineNominationItem, isGrouped: !isEmpty$1(this.props.groupedTimelineItems.find(function (x) { return x._id === nominationTimelineItem.event._id; })), activeTimezone: this.props.activeTimezone, readOnly: this.props.readOnly }));
    };
    TimelineItemRenderer.prototype.renderEnquiryTimelineItem = function (timelineItem, timeToScreen, xToScreen, key, sandboxId) {
        var companyDetails = instanceOfEventWithCompanyId(timelineItem.event) && timelineItem.event.companyId
            ? getCompanyDetails(this.props.companies, timelineItem.event.companyId)
            : undefined;
        return (createElement(EnquiryItem$1, { enquiryTimelineItem: timelineItem, key: timelineItem.event._id, columns: this.props.timelineColumns, companyDetails: companyDetails, timeToScreen: timeToScreen, xToScreen: xToScreen, locationService: this.props.locationService, sandboxId: sandboxId, isVisible: this.props.isEventInTimelineView, draggingStarted: this.props.draggingStarted, onSelectEnquiry: this.props.openPromptEventBlockModal, isGrouped: false, activeTimezone: this.props.activeTimezone, readOnly: this.props.readOnly, moveTimelineItems: this.props.moveTimelineItems }));
    };
    TimelineItemRenderer.prototype.renderTimelineItemBlock = function (timelineItem, timeToScreen, xToScreen, key, sandboxId) {
        var companyDetails = instanceOfEventWithCompanyId(timelineItem.event) && timelineItem.event.companyId
            ? getCompanyDetails(this.props.companies, timelineItem.event.companyId)
            : undefined;
        return (createElement(TimelineItem, { key: key, columns: this.props.timelineColumns, timelineItem: timelineItem, timeToScreen: timeToScreen, xToScreen: xToScreen, movementType: instanceOfINominationEnquiryEvent(timelineItem.event) ? 'HORIZONTAL' : 'CENTER', openPromptEventBlockModal: this.props.openPromptEventBlockModal, locationService: this.props.locationService, sandboxId: sandboxId, isVisible: this.props.isEventInTimelineView, toggleItemInTimelineGroup: this.props.toggleItemInTimelineGroup, moveTimelineItems: this.props.moveTimelineItems, isGrouped: !isEmpty$1(this.props.groupedTimelineItems.find(function (x) { return x._id === timelineItem.event._id; })), activeTimezone: this.props.activeTimezone, companyDetails: companyDetails, readOnly: this.props.readOnly }));
    };
    TimelineItemRenderer.prototype.renderDischargeBlockEvent = function (timelineItemWithWindow, timeToScreen, xToScreen, key, sandboxId) {
        return (createElement(ItemWithWindow, { key: key, columns: this.props.timelineColumns, timelineItem: timelineItemWithWindow, timeToScreen: timeToScreen, xToScreen: xToScreen, openPromptEventBlockModal: this.props.openPromptEventBlockModal, locationService: this.props.locationService, sandboxId: sandboxId, isVisible: this.props.isEventInTimelineView, toggleItemInTimelineGroup: this.props.toggleItemInTimelineGroup, moveTimelineItems: this.props.moveTimelineItems, isGrouped: !isEmpty$1(this.props.groupedTimelineItems.find(function (x) { return x._id === timelineItemWithWindow.event._id; })), activeTimezone: this.props.activeTimezone, readOnly: this.props.readOnly }));
    };
    return TimelineItemRenderer;
}(PureComponent));
function instanceOfEventWithCompanyId(object) {
    return 'companyId' in object;
}

var WeekendRows = function (props) {
    var zonedTimelineStartEndTime = props.zonedStartEndTimes;
    // add a day to both sides of the timeline to prevent weekends falling of if there's only a partial weekend in the window
    var zonedForWeekends = {
        start: zonedTimelineStartEndTime.start.minus({ days: 1 }),
        end: zonedTimelineStartEndTime.end.plus({ days: 1 }),
    };
    var weekendDays = [];
    // loop through all the days inside the window, then save each saturday and sunday to the array of weekend days
    var dateToCheck = zonedForWeekends.start;
    while (zonedForWeekends.end.diff(dateToCheck).milliseconds > 0) {
        if (dateToCheck.weekday === 6 || dateToCheck.weekday === 7) {
            weekendDays.push(dateToCheck.startOf('day'));
        }
        dateToCheck = dateToCheck.plus({ days: 1 });
    }
    // Go through all the weekendDays and create a weekendrow div for each weekend.
    var weekendRows = weekendDays.map(function (day, index) {
        var top = props.timeToScreen(day.toJSDate());
        var bottom = props.timeToScreen(day.plus({ days: 1 }).toJSDate());
        return React__default.createElement("div", { key: 'weekendrow' + index, style: { top: top, height: bottom - top }, className: "weekend-row" });
    });
    return React__default.createElement(React__default.Fragment, null, weekendRows);
};
var WeekendRows$1 = React__default.memo(WeekendRows);

var BunkerTimeline = /** @class */ (function (_super) {
    __extends(BunkerTimeline, _super);
    function BunkerTimeline(props) {
        var _this = _super.call(this, props) || this;
        _this.saveTimeTimeout = null;
        _this.handleChangeTimezone = function (timezone) {
            if (_this.state.activeTimezone !== timezone) {
                if (timezone === 'Local time') {
                    _this.setState({ activeTimezone: undefined });
                    saveToLocalStorage('ACTIVE_TIMEZONE', undefined);
                }
                else {
                    _this.setState({ activeTimezone: timezone });
                    saveToLocalStorage('ACTIVE_TIMEZONE', timezone);
                }
            }
        };
        _this.isEventInTimelineView = function (eventStartTime, eventEndTime) {
            // makes the viewport slightly bigger so the events have a bit of extra render spacing
            var viewportStartTime = DateTime.fromJSDate(_this.state.startTime).minus({ weeks: 1 });
            var viewportEndTime = DateTime.fromJSDate(_this.state.endTime).plus({ weeks: 1 });
            var eventStart = DateTime.fromJSDate(eventStartTime);
            var eventEnd = DateTime.fromJSDate(eventEndTime);
            return isBefore(eventStart, viewportEndTime) && isAfter(eventEnd, viewportStartTime);
        };
        _this.handleResize = function (dimensions) {
            _this.setState({
                width: dimensions.width,
                height: dimensions.height
            });
        };
        _this.handleTimeChange = function (startTime, endTime) {
            // @ts-ignore // item will always be a date here
            _this.setState({ startTime: startTime, endTime: endTime });
            if (_this.saveTimeTimeout) {
                clearTimeout(_this.saveTimeTimeout);
            }
            _this.saveTimeTimeout = setTimeout(function () {
                saveToLocalStorage('START_TIME_PROMPT', startTime);
                saveToLocalStorage('END_TIME_PROMPT', endTime);
            }, 1000);
        };
        _this.saveViewPortSettings = function (startTime, endTime) {
            _this.setState({
                startTime: startTime,
                endTime: endTime
            });
            saveToLocalStorage('START_TIME_PROMPT', startTime);
            saveToLocalStorage('END_TIME_PROMPT', endTime);
        };
        _this.updateNow = function () {
            _this.setState({ now: new Date() });
        };
        _this.setDraggingStarted = function () {
            _this.setState({ draggingStarted: true });
        };
        var defaultStart = DateTime.local()
            .startOf('day')
            .minus({ hours: DEFAULT_VIEWPORT_HOURS * 0.25 })
            .toISO();
        var defaultEnd = DateTime.local()
            .startOf('day')
            .plus({ hours: DEFAULT_VIEWPORT_HOURS * 0.75 })
            .toISO();
        _this.state = {
            width: 0,
            height: 0,
            now: new Date(),
            startTime: DateTime.fromISO(loadFromLocalStorage('START_TIME_PROMPT', defaultStart)).toJSDate(),
            endTime: DateTime.fromISO(loadFromLocalStorage('END_TIME_PROMPT', defaultEnd)).toJSDate(),
            timelineColumns: [],
            draggingStarted: false,
            activeTimezone: loadFromLocalStorage('ACTIVE_TIMEZONE', undefined)
        };
        return _this;
    }
    BunkerTimeline.prototype.render = function () {
        var _this = this;
        var startEndTimes = this.getZonedStartEndTimes();
        return (React__default.createElement("div", { className: classNames('bunker-timeline', { 'read-only': this.props.readOnly }) },
            React__default.createElement(Refresher, { onRefresh: this.updateNow, interval: REFRESH_INTERVAL_NOW, refreshOnMount: false }),
            this.props.readOnly === false && (React__default.createElement("div", { className: "timeline-menu" },
                React__default.createElement(TimelineActionMenu$1, { authenticationService: this.props.authenticationService, sandboxMode: this.props.sandboxMode, openPromptEventBlockModal: this.props.openPromptEventBlockModal, unsavedChanges: this.props.unsavedChanges, saveAllUnsavedChanges: this.props.saveAllUnsavedChanges, isSavingChanges: this.props.isSavingChanges, selectedEventsCount: size(this.props.groupedTimelineItems), clearTimelineGrouping: this.props.clearTimelineGrouping, copySelection: this.props.copySelection, userProfile: this.props.userProfile, showDataExport: this.props.showDataExport, startTime: this.state.startTime, endTime: this.state.endTime, onChange: this.saveViewPortSettings, activeTimezone: this.state.activeTimezone, onChangeTimezone: this.handleChangeTimezone }))),
            React__default.createElement("div", { className: "contents" },
                React__default.createElement(Viewer, { xMargin: 0, xType: "Number", xStart: 0, xEnd: this.state.timelineColumns.length, yType: "Date", yStart: this.getStartTime(), yEnd: this.getEndTime(), onYChange: this.handleTimeChange, width: this.state.width, height: this.state.height, onResize: this.handleResize, onDraggingCompleted: function () {
                        _this.props.saveTimelineItemAfterDragging();
                        _this.props.setDraggingStarted(false);
                        _this.setState({ draggingStarted: false });
                    }, disablePanScroll: true }, function (_a) {
                    var measureRef = _a.measureRef, yUnitToScreen = _a.yUnitToScreen, xUnitToScreen = _a.xUnitToScreen;
                    return (React__default.createElement("div", { className: "terminal-viewer-contents" },
                        React__default.createElement("div", { className: "top-panel" }, _this.renderColumnLabels(xUnitToScreen)),
                        React__default.createElement("div", { className: "bottom-panel" },
                            React__default.createElement("div", { className: "left-panel" },
                                _this.state.activeTimezone && (React__default.createElement("div", { className: "axis-timezone" }, _this.state.activeTimezone)),
                                React__default.createElement(TimelineAxis$1, { zonedStartEndTimes: startEndTimes, timeToScreen: yUnitToScreen })),
                            React__default.createElement("div", { className: "right-panel", ref: measureRef, onClick: function (event) {
                                    if (event.target instanceof Element) {
                                        var clickedClassNames = event.target.className;
                                        if (clickedClassNames.includes('current-time') ||
                                            clickedClassNames.includes('column')) {
                                            // this is the div that is targeted when clicking in the timeline box
                                            _this.props.clearTimelineGrouping(); // clear the grouping when clicked in the timeline
                                        }
                                    }
                                } },
                                React__default.createElement(TimelineColumns$1, { bunkerShips: _this.props.bunkerShips, pipelines: _this.props.pipelines, eventsCollection: _this.props.eventsCollection, filteredDeliveryModes: _this.props.timelineFiltering.filteredDeliveryModes }, function (timelineColumns) {
                                    return _this.renderColumns(xUnitToScreen, timelineColumns);
                                }),
                                React__default.createElement(TimeGridLines$1, { timeToScreen: yUnitToScreen, zonedStartEndTimes: startEndTimes }),
                                _this.renderCurrentTime(_this.state.now, yUnitToScreen),
                                React__default.createElement(WeekendRows$1, { timeToScreen: yUnitToScreen, zonedStartEndTimes: startEndTimes }),
                                _this.state.timelineColumns.length > 0 && (React__default.createElement(TimelineItemRenderer, { eventsCollection: _this.props.eventsCollection, bunkerShips: _this.props.bunkerShips, timelineColumns: _this.state.timelineColumns, draggingStarted: _this.state.draggingStarted, locationService: _this.props.locationService, shipDetailsById: _this.props.shipDetailsById, companies: _this.props.companies, timeToScreen: yUnitToScreen, xToScreen: xUnitToScreen, setDraggingStarted: _this.setDraggingStarted, handleChangeTimelineNominationItem: _this.props.handleChangeTimelineNominationItem, isEventInTimelineView: _this.isEventInTimelineView, openPromptEventBlockModal: _this.props.openPromptEventBlockModal, toggleItemInTimelineGroup: _this.props.toggleItemInTimelineGroup, moveTimelineItems: _this.props.moveTimelineItems, groupedTimelineItems: _this.props.groupedTimelineItems, activeTimezone: _this.state.activeTimezone, readOnly: _this.props.readOnly }))))));
                }))));
    };
    BunkerTimeline.prototype.getStartTime = function () {
        return this.state.startTime || DateTime.local().startOf('day').toJSDate();
    };
    BunkerTimeline.prototype.getEndTime = function () {
        return this.state.endTime || DateTime.local().endOf('day').toJSDate();
    };
    BunkerTimeline.prototype.renderColumns = function (xToScreen, timelineColumns) {
        // if the timeline columns have not been set in the state yet, the xToScreen function
        // will return Infinity and NAN values. To Prevent this we first check if the columns are present
        // this will only happen on the first render.
        var columns = this.state.timelineColumns.length === 0 ? (React__default.createElement("div", { className: "columns" })) : (timelineColumns.map(function (column, index) {
            var left = xToScreen(index);
            var right = xToScreen(index + 1);
            var width = right - left;
            var className = column.unplanned ? 'column unplanned' : 'column';
            var sandboxClassName = column.sandboxClassName ? column.sandboxClassName : '';
            return (React__default.createElement("div", { key: index, style: { left: left, width: width }, className: className + ' ' + sandboxClassName }));
        }));
        this.setState({
            timelineColumns: timelineColumns
        });
        return React__default.createElement("div", { className: "columns" }, columns);
    };
    BunkerTimeline.prototype.getZonedStartEndTimes = function () {
        var timeZone = this.state.activeTimezone;
        var startISO = this.getStartTime().toISOString();
        var endISO = this.getEndTime().toISOString();
        var startTime = timeZone
            ? DateTime.fromISO(startISO, { zone: timeZone })
            : DateTime.fromISO(startISO);
        var endTime = timeZone
            ? DateTime.fromISO(endISO, { zone: timeZone })
            : DateTime.fromISO(endISO);
        return {
            start: startTime,
            end: endTime
        };
    };
    BunkerTimeline.prototype.renderColumnLabels = function (xToScreen) {
        // creates labels for each sandbox column
        var sandboxColumns = this.state.timelineColumns.map(function (column, index) {
            var left = xToScreen(index);
            var right = xToScreen(index + 1);
            var width = right - left;
            return (React__default.createElement("div", { key: index, style: { left: left, width: width }, className: "column-label" }, column.collectionName));
        });
        // creates labels for the headers of each column. To the ship names and unplanned/loading columns
        var columnHeaders = this.state.timelineColumns
            .map(function (column, index) {
            var left = xToScreen(index);
            var right = xToScreen(index + 1);
            var width = right - left;
            // const bunkerShip = filteredBunkerShips.find((x) => x._id === column.bunkerShipId)
            return (React__default.createElement("div", { key: index, style: { left: left, width: width }, className: "column-label" },
                column.columnType !== 'UNASSIGNED' &&
                    column.columnType !== 'UNASSIGNED_DELEGATED' &&
                    getDeliveryModeIcon(column.columnType),
                column.displayName));
        })
            .filter(function (x) { return x !== null; });
        // If there's more than 1 schedule -> show additional labels for the columns
        // This means in detailed view it only shows the column names, in sandbox mode the sandbox labels are showed too.
        if (this.props.eventsCollection.length > 1) {
            return (React__default.createElement("div", { className: "column-labels" },
                React__default.createElement("div", { className: "combined-column-labels" }, columnHeaders),
                React__default.createElement("div", { className: "single-column-labels" }, sandboxColumns)));
        }
        else {
            return React__default.createElement("div", { className: "column-labels" }, columnHeaders);
        }
    };
    BunkerTimeline.prototype.renderCurrentTime = function (now, timeToScreen) {
        if (now < this.state.startTime) {
            // we're looking in the future
            return null;
        }
        else if (now > this.state.endTime) {
            // we're looking in the past
            return React__default.createElement("div", { key: "currentTime", className: "current-time", style: { height: '100%' } });
        }
        else {
            // we're looking at now
            var height = timeToScreen(now);
            return React__default.createElement("div", { key: "currentTime", className: "current-time border", style: { height: height } });
        }
    };
    return BunkerTimeline;
}(React__default.PureComponent));

var SchedulingTimeline = function (props) {
    var _a = useState([]), timelineEventsCollection = _a[0], setTimelineEventsCollection = _a[1];
    var _b = useState({}), unsavedChanges = _b[0], setUnsavedChanges = _b[1];
    var _c = useState(undefined), lastDraggedTimelineEvents = _c[0], setLastDraggedTimelineEvents = _c[1];
    var _d = useState([]), groupedTimelineItems = _d[0], setGroupedTimelineItems = _d[1];
    var _e = useState([]), originalGroupedTimelineItems = _e[0], setOriginalGroupedTimelineItems = _e[1];
    var _f = useState(false), isSavingChanges = _f[0], setIsSavingChanges = _f[1];
    var _g = useState(false), draggingStarted = _g[0], setDraggingStarted = _g[1];
    useEffect(function () {
        setTimelineEventsCollection(props.eventsCollection);
    }, [props.eventsCollection]);
    var userRoles = props.userProfile.roles;
    return (React__default.createElement("div", { className: "page-component timeline" },
        React__default.createElement(Refresher, { onRefresh: refreshData, interval: DATA_REFRESH_INTERVAL }),
        React__default.createElement(BunkerTimeline, { authenticationService: props.authenticationService, 
            // fetched data props
            sandboxMode: props.sandboxMode, locationService: props.locationService, companies: props.companies, bunkerShips: props.bunkerShips, pipelines: props.pipelines, eventsCollection: timelineEventsCollection, shipDetailsById: props.receivingShips, userProfile: props.userProfile, 
            // modal props
            openPromptEventBlockModal: props.navigateToTimelineEvent, 
            // handle timeline item changes props
            handleChangeTimelineNominationItem: handleChangeTimelineNominationItem, 
            // saving changes props
            isSavingChanges: isSavingChanges, unsavedChanges: unsavedChanges, saveAllUnsavedChanges: saveAllUnsavedChanges, saveTimelineItemAfterDragging: saveTimelineItemAfterDragging, 
            // grouping functions
            toggleItemInTimelineGroup: toggleItemInTimelineGroup, moveTimelineItems: moveTimelineItems, groupedTimelineItems: groupedTimelineItems, clearTimelineGrouping: clearTimelineGrouping, copySelection: copySelection, 
            // Drag handling
            setDraggingStarted: setDraggingStarted, readOnly: isReadOnlyUser(userRoles), showDataExport: props.showDataExport, timelineFiltering: props.timelineFiltering })));
    /**
     * --------------------------------------
     * STATE SETUP / EXTEND FUNCTIONS
     * --------------------------------------
     */
    function handleChange() {
        if (props.onChange) {
            // pokes the sandbox that something has changed
            props.onChange();
        }
    }
    function refreshData() {
        if (isEmpty$1(unsavedChanges)) {
            props.fetchEventsCollections(undefined, undefined);
        }
    }
    /**
     * --------------------------------------
     * TIMELINE ITEM CHANGE HANDLER FUNCTIONS
     * --------------------------------------
     */
    /**
     * Handles the changes triggered by dragging a item/group in the timeline. Updates the state and adds items to the unsavedChanges
     */
    function handleChangeTimelineBlockItems(timelineBlockItems, sandboxId) {
        if (props.sandboxMode) {
            // means we are editing sandbox items
            if (sandboxId) {
                // means its a sandbox item ( and not a live one )
                return {
                    eventsCollection: findAndUpdateEventsCollectionByGroup(timelineEventsCollection, timelineBlockItems, sandboxId),
                    unsavedChanges: unsavedChanges,
                    lastDraggedTimelineEvents: timelineBlockItems
                };
            }
        }
        else {
            // checks if the item is canceled, then doesn't update the item in the unsavedChanges list.
            var unsavedChangesList_1 = cloneDeep(unsavedChanges);
            timelineBlockItems.forEach(function (item) {
                var _a;
                if (item.eventId) {
                    unsavedChangesList_1 = Object.assign({}, unsavedChangesList_1, (_a = {},
                        _a[item.eventId] = item,
                        _a));
                }
            });
            return {
                eventsCollection: findAndUpdateEventsCollectionByGroup(timelineEventsCollection, timelineBlockItems, sandboxId),
                unsavedChanges: unsavedChangesList_1
            };
        }
        // fallback just to be sure something is always being returned ( this should never happen in practice )
        return {
            eventsCollection: timelineEventsCollection,
            unsavedChanges: unsavedChanges
        };
    }
    function handleChangeTimelineNominationItem(updateNomination, sandboxId) {
        var _a;
        if (sandboxId) {
            if (sandboxId !== SANDBOX_ID_LIVE) {
                // means its a sandbox item
                // updates the timelineItem in the state, the saving of the item is done in saveTimelineItemAfterDragging when the dragging event is done.
                setTimelineEventsCollection(findAndUpdateEventsCollection(timelineEventsCollection, updateNomination, sandboxId));
                setLastDraggedTimelineEvents(updateNomination);
            }
        }
        else {
            setTimelineEventsCollection(findAndUpdateEventsCollection(timelineEventsCollection, updateNomination, sandboxId));
            setUnsavedChanges(updateNomination.eventId
                ? Object.assign({}, unsavedChanges, (_a = {},
                    _a[updateNomination.eventId] = updateNomination,
                    _a))
                : unsavedChanges);
        }
    }
    /**
     * --------------------------------------
     * EVENT API SAVE AND UPDATE FUNCTIONS
     * --------------------------------------
     */
    /**
     * Saves a single promptEvent from the unsavedChanges to the API
     */
    function savePromptEventUnsavedChange(promptEvent) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                props.updateTimelineEvent(promptEvent);
                handleChange();
                return [2 /*return*/];
            });
        });
    }
    /**
     * Gathers all the unsavedChanges and calls to corresponding function to save the single unsaved event.
     */
    function saveAllUnsavedChanges() {
        return __awaiter(this, void 0, void 0, function () {
            var unsavedChangesList, _a, _b, _i, key, item, error_1;
            var _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        // makes sure we always work with a clone of the state's saved changes
                        setIsSavingChanges(true);
                        unsavedChangesList = cloneDeep(unsavedChanges);
                        _a = [];
                        for (_b in unsavedChangesList)
                            _a.push(_b);
                        _i = 0;
                        _d.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 6];
                        key = _a[_i];
                        if (!unsavedChangesList.hasOwnProperty(key)) return [3 /*break*/, 5];
                        item = unsavedChangesList[key];
                        _d.label = 2;
                    case 2:
                        _d.trys.push([2, 4, , 5]);
                        // deletes the unsavedItem from the items list
                        delete unsavedChangesList[key];
                        return [4 /*yield*/, savePromptEventUnsavedChange(item)];
                    case 3:
                        _d.sent();
                        toast.success('Changes are saved');
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _d.sent();
                        // if saving failed somehow, it puts the unsavedItem back in the state
                        unsavedChangesList = Object.assign({}, unsavedChangesList, (_c = {}, _c[key] = item, _c));
                        toast.error(error_1.toString(), { autoClose: false });
                        return [3 /*break*/, 5];
                    case 5:
                        _i++;
                        return [3 /*break*/, 1];
                    case 6:
                        setIsSavingChanges(false);
                        setUnsavedChanges(unsavedChangesList);
                        return [2 /*return*/];
                }
            });
        });
    }
    /**
     * Saves timeline items once dragging is complete
     * After the users stops dragging a item in the timeline this function get's called.
     */
    function saveTimelineItemAfterDragging() {
        return __awaiter(this, void 0, void 0, function () {
            var error_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(lastDraggedTimelineEvents && props.sandboxMode)) return [3 /*break*/, 6];
                        if (!instanceOfNominationTimelineItem(lastDraggedTimelineEvents)) return [3 /*break*/, 5];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, props.updateTimelineEvent(lastDraggedTimelineEvents)];
                    case 2:
                        _a.sent();
                        if (props.onChange) {
                            props.onChange();
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        handleFetchError(error_2);
                        return [3 /*break*/, 4];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        lastDraggedTimelineEvents.forEach(function (timelineEvent) { return __awaiter(_this, void 0, void 0, function () {
                            var error_3;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!(timelineEvent.sandboxId && timelineEvent.sandboxId !== SANDBOX_ID_LIVE)) return [3 /*break*/, 4];
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([1, 3, , 4]);
                                        return [4 /*yield*/, props.updateTimelineEvent(timelineEvent)];
                                    case 2:
                                        _a.sent();
                                        if (props.onChange) {
                                            props.onChange();
                                        }
                                        return [3 /*break*/, 4];
                                    case 3:
                                        error_3 = _a.sent();
                                        handleFetchError(error_3);
                                        return [3 /*break*/, 4];
                                    case 4: return [2 /*return*/];
                                }
                            });
                        }); });
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    }
    /**
     * ----------------------------------------------------
     * STATE SCHEDULES COLLECTION SEARCH / UPDATE FUNCTIONS
     * ----------------------------------------------------
     */
    /**
     * Find the schedule collection based on a sandbox Id, if there's no sandbox id it selects the detailedView's standard collection.
     * Then updates the collection in the state based on the updatedTimelineBlockItem param.
     */
    function findAndUpdateEventsCollection(eventsCollection, updatedTimelineBlockItem, sandboxId) {
        if (sandboxId) {
            return eventsCollection.map(function (collection) {
                return collection._id === sandboxId
                    ? updateSingleScheduleCollection(collection, updatedTimelineBlockItem)
                    : collection;
            });
        }
        else {
            return eventsCollection.map(function (collection) {
                return updateSingleScheduleCollection(collection, updatedTimelineBlockItem);
            });
        }
    }
    /**
     * Find the schedule collection based on a sandbox Id, if there's no sandbox id it selects the detailedView's standard collection.
     * Then updates the collection in the state based on the updatedTimelineBlockItem param.
     */
    function findAndUpdateEventsCollectionByGroup(eventsCollection, updatedTimelineBlockItems, sandboxId) {
        if (sandboxId) {
            return eventsCollection.map(function (collection) {
                return collection._id === sandboxId
                    ? updateSingleScheduleCollectionFromGroup(collection, updatedTimelineBlockItems)
                    : collection;
            });
        }
        else {
            return eventsCollection.map(function (collection) {
                return updateSingleScheduleCollectionFromGroup(collection, updatedTimelineBlockItems);
            });
        }
    }
    /**
     * Searches the eventsCollection for the right collection. Then adds the new timeline event to the right collection and returns the updated eventsCollections
     */
    function addEventToSandboxEventsCollection(eventsCollection, newTimelineItem, sandboxId) {
        return eventsCollection.map(function (collection) {
            if (collection._id === sandboxId ||
                (sandboxId === null && (collection._id === SANDBOX_ID_LIVE || collection._id === undefined))) {
                var collectionToUpdate = cloneDeep(collection);
                var extendedPromptEvents = collectionToUpdate.promptEvents.concat(newTimelineItem);
                collectionToUpdate.promptEvents = extendedPromptEvents;
                return collectionToUpdate;
            }
            else {
                return collection;
            }
        });
    }
    /**
     * In a single collection, maps through the collection and updates a promptEvent or Proposal based on the updatedItem item in that collection.
     * Returns the updates collection.
     */
    function updateSingleScheduleCollection(collection, updatedTimelineBlockItem) {
        // Update the promptEvents
        var itemToUpdate = updatedTimelineBlockItem;
        var alreadyExists = false;
        var updatedPromptEvents = collection.promptEvents.map(function (promptEvent) {
            var found = promptEvent.eventId === itemToUpdate.eventId;
            if (found) {
                alreadyExists = true;
            }
            return found ? itemToUpdate : promptEvent;
        });
        if (!alreadyExists) {
            updatedPromptEvents.push(itemToUpdate);
        }
        collection.promptEvents = updatedPromptEvents;
        // return the updatedCollection
        return collection;
    }
    function updateSingleScheduleCollectionFromGroup(collection, updatedTimelineBlockItems) {
        var collectionToUpdate = cloneDeep(collection);
        var updatedPromptEvents = collectionToUpdate.promptEvents.map(function (timelineEvent) {
            var itemToUpdate = updatedTimelineBlockItems.find(function (x) { return x._id === timelineEvent._id; });
            if (itemToUpdate) {
                // update the entire item with the passed event
                return itemToUpdate;
            }
            else {
                // dont do anything with it and return the original
                return timelineEvent;
            }
        });
        collectionToUpdate.promptEvents = updatedPromptEvents;
        return collectionToUpdate;
    }
    /**
     * ----------------------------------------------------
     * GROUPING FUNCTIONS
     * ----------------------------------------------------
     */
    function toggleItemInTimelineGroup(item) {
        var groupedItemsList = groupedTimelineItems;
        var itemInGroup = groupedItemsList.find(function (x) { return x._id === item._id; });
        var groupSandboxId = getTimelineGroupSandboxId(groupedItemsList);
        var canAddItemToGroup = groupSandboxId === undefined ? true : groupSandboxId === item.sandboxId ? true : false;
        var userProfile = props.userProfile;
        var userRoles = userProfile ? userProfile.roles : undefined;
        if ((instanceOfNominationTimelineItem(item) && item.state === 'CANCELLED') ||
            isReadOnlyUser(userRoles)) {
            return;
        }
        if (itemInGroup) {
            setGroupedTimelineItems(groupedItemsList.filter(function (x) { return x._id !== item._id; }));
        }
        else if (canAddItemToGroup && !isSandboxLiveItem(item)) {
            setGroupedTimelineItems(groupedItemsList.concat(item));
        }
    }
    function moveTimelineItems(draggedTimeInMilis, draggedItem, timelineColumn, isUpdatingWindow) {
        var userProfile = props.userProfile;
        var userRoles = userProfile ? userProfile.roles : undefined;
        if ((instanceOfNominationTimelineItem(draggedItem) && draggedItem.state === 'CANCELLED') ||
            isReadOnlyUser(userRoles)) {
            return; // make sure a item is never moved / altered if it's cancelled
        }
        var originalItems = originalGroupedTimelineItems; // finds the original version of each item when dragging began
        var groupedItems = cloneDeep(groupedTimelineItems);
        var isDraggedItemInGroup = groupedItems.find(function (x) { return x._id === draggedItem._id; }); // checks if the dragged item is in the group
        if (!isDraggedItemInGroup && !isSandboxLiveItem(draggedItem)) {
            groupedItems = [draggedItem];
        }
        // replaces the group with the dragged item if a item was selected which is not in the group
        if (!draggingStarted && !instanceOfINominationEnquiryEvent(draggedItem)) {
            setOriginalGroupedTimelineItems(groupedItems);
        } // sets the original items
        var updatedGroup = updateAllGroupeditems(groupedItems, draggedTimeInMilis, originalItems, timelineColumn, isUpdatingWindow); // updates the entire group
        var sandboxId = getTimelineGroupSandboxId(groupedItems); // finds the sandbox ( if in sandbox mode )
        var updatedCollectionAndUnsavedItems = handleChangeTimelineBlockItems(updatedGroup, sandboxId); // this gets the updated collection, unsavedChanges and lastDraggedItems
        // also set dragging started to true, so the first check with orignal items won't trigger again
        setTimelineEventsCollection(updatedCollectionAndUnsavedItems.eventsCollection);
        setUnsavedChanges(updatedCollectionAndUnsavedItems.unsavedChanges);
        setLastDraggedTimelineEvents(updatedCollectionAndUnsavedItems.lastDraggedTimelineEvents);
        setGroupedTimelineItems(updatedGroup.filter(function (item) { return !instanceOfINominationEnquiryEvent(item); }));
        setDraggingStarted(true);
    }
    function updateAllGroupeditems(groupedTimelineItemsList, draggedTimeInMilis, originalGroupedItemsList, timelineColumn, isUpdatingWindow) {
        return groupedTimelineItemsList.map(function (timelineItem) {
            var originalItem = originalGroupedItemsList.find(function (orignalItem) { return orignalItem._id === timelineItem._id; });
            var timeProperties = getTimelineItemTimeProperties(timelineItem, isUpdatingWindow);
            var movingInUnassignedColumn = originalItem && originalItem.column === 'UNASSIGNED' && timelineItem.column === 'UNASSIGNED';
            var movingBetweenShips = movingInUnassignedColumn
                ? false
                : originalItem && originalItem.bunkerShipId !== timelineItem.bunkerShipId;
            return updateTimelineItem(timelineItem, timeProperties, draggedTimeInMilis, originalItem, movingBetweenShips, timelineColumn, isUpdatingWindow);
        });
    }
    function updateTimelineItem(timelineItem, timeProperties, draggedTimeInMilis, originalItem, movingBetweenShips, timelineColumn, isUpdatingWindow) {
        var _a;
        var updatedBunkerShipId = isUpdatingWindow
            ? timelineItem.bunkerShipId
            : timelineColumn
                ? timelineColumn.bunkerShipId
                : null;
        var updatedPipelineId = isUpdatingWindow
            ? timelineItem.pipelineId
            : timelineColumn
                ? timelineColumn.pipelineId
                : null;
        var updatedStartTime = movingBetweenShips && originalItem
            ? originalItem[timeProperties.startTimeProperty]
            : DateTime.fromISO(timelineItem[timeProperties.startTimeProperty])
                .plus({ milliseconds: draggedTimeInMilis })
                .toISO();
        var updatedEndTime = movingBetweenShips && originalItem
            ? originalItem[timeProperties.endTimeProperty]
            : DateTime.fromISO(timelineItem[timeProperties.endTimeProperty])
                .plus({ milliseconds: draggedTimeInMilis })
                .toISO();
        var updatedTimelineItem = Object.assign({}, timelineItem, (_a = {
                bunkerShipId: updatedBunkerShipId,
                pipelineId: updatedPipelineId
            },
            _a[timeProperties.startTimeProperty] = updatedStartTime,
            _a[timeProperties.endTimeProperty] = updatedEndTime,
            _a.column = timelineColumn ? timelineColumn.columnType : 'UNASSIGNED',
            _a));
        return updatedTimelineItem;
    }
    function clearTimelineGrouping() {
        setGroupedTimelineItems([]);
    }
    function getTimelineGroupSandboxId(groupedTimelineItems) {
        if (groupedTimelineItems && groupedTimelineItems.length > 0) {
            var firstItemCheck = groupedTimelineItems[0];
            var sandboxId = firstItemCheck.sandboxId;
            return sandboxId || undefined;
        }
        else {
            return undefined;
        }
    }
    function copySelection() {
        return __awaiter(this, void 0, void 0, function () {
            var createdPromptEvents, newCollection_1, err_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, Promise.all(groupedTimelineItems.map(function (promptEvent) { return __awaiter(_this, void 0, void 0, function () {
                                var newPromptEvent, createdPromptEvent;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            newPromptEvent = cloneDeep(promptEvent);
                                            delete newPromptEvent._id;
                                            delete newPromptEvent.eventId;
                                            delete newPromptEvent.vendorReference;
                                            delete newPromptEvent.documents;
                                            return [4 /*yield*/, props.createNewPromptEvent(newPromptEvent)];
                                        case 1:
                                            createdPromptEvent = _a.sent();
                                            return [2 /*return*/, createdPromptEvent];
                                    }
                                });
                            }); }))];
                    case 1:
                        createdPromptEvents = _a.sent();
                        newCollection_1 = cloneDeep(timelineEventsCollection);
                        createdPromptEvents.forEach(function (createdPromptEvent) {
                            var updatedScheduleCollection = addEventToSandboxEventsCollection(newCollection_1, createdPromptEvent, createdPromptEvent.sandboxId || undefined);
                            newCollection_1 = updatedScheduleCollection;
                        });
                        setTimelineEventsCollection(newCollection_1);
                        setGroupedTimelineItems(createdPromptEvents);
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        console.error(err_1);
                        toast.error(err_1.toString(), { autoClose: false });
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    /**
     * ----------------------------------------------------
     * HELPER FUNCTIONS
     * ----------------------------------------------------
     */
    function isSandboxLiveItem(timelineItem) {
        return props.sandboxMode && !timelineItem.sandboxId;
    }
};
var SchedulingTimeline$1 = React__default.memo(SchedulingTimeline);

var SignFlowMessage = function (props) {
    return (React__default.createElement("div", { className: "signflow-message-container" },
        React__default.createElement("div", { className: "message" }, props.message),
        props.children,
        props.url && props.loggedIn && (React__default.createElement(Button$1, { onClick: function () { return window.location.replace(props.url); } }, "Go to nomination"))));
};

function preSignRequest(baseURL, token) {
    var postBody = { token: token };
    return responseHandler(fetch(baseURL + "/documents/preSign", {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(postBody)
    }));
}
function postSignRequest(baseURL, token) {
    var postBody = { token: token };
    return responseHandler(fetch(baseURL + "/documents/postSign", {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(postBody)
    }));
}
function responseHandler(response) {
    return response
        .then(function (r) {
        if (r.ok)
            return r.json();
        throw r;
    })
        .catch(function (e) {
        throw e;
    });
}

var SignFlowState;
(function (SignFlowState) {
    SignFlowState["SIGNED"] = "SIGNED";
    SignFlowState["ERROR"] = "ERROR";
    SignFlowState["ALREADY_SIGNED"] = "ALREADY_SIGNED";
    SignFlowState["REDIRECTING"] = "REDIRECTING";
    SignFlowState["LOADING"] = "LOADING";
    SignFlowState["EXPIRED"] = "EXPIRED";
})(SignFlowState || (SignFlowState = {}));
var SignFlowType;
(function (SignFlowType) {
    SignFlowType["PRE_SIGNING"] = "PRE_SIGNING";
    SignFlowType["POST_SIGNING"] = "POST_SIGNING";
})(SignFlowType || (SignFlowType = {}));
function useSignFlow(token, baseUrl, flowType) {
    var _a = useState(SignFlowState.LOADING), state = _a[0], setState = _a[1];
    var _b = useState(), url = _b[0], setUrl = _b[1];
    var _c = useState(), error = _c[0], setError = _c[1];
    useEffect(function () {
        responseHandler(requestForType(baseUrl, token, flowType));
    }, [token]);
    var requestForType = function (baseUrl, token, type) {
        if (type === SignFlowType.PRE_SIGNING)
            return preSignRequest(baseUrl, token);
        return postSignRequest(baseUrl, token);
    };
    var responseHandler = function (response) {
        response
            .then(function (r) {
            responseDataHandler(r);
        })
            .catch(function (e) {
            setError((e === null || e === void 0 ? void 0 : e.status) || 'unknown');
            setState(SignFlowState.ERROR);
        });
    };
    var responseDataHandler = function (response) {
        if (response && response.url) {
            setUrl(response.url);
        }
        if (!response || response.error) {
            if (response.expired) {
                setState(SignFlowState.EXPIRED);
            }
            else {
                setState(SignFlowState.ERROR);
            }
            return;
        }
        if (response.expired) {
            setState(SignFlowState.EXPIRED);
            return;
        }
        if (flowType === SignFlowType.POST_SIGNING) {
            setState(SignFlowState.SIGNED);
            return;
        }
        if (response.signed) {
            setState(SignFlowState.ALREADY_SIGNED);
            return;
        }
        if (response.url) {
            window.location.replace(response.url);
            setState(SignFlowState.REDIRECTING);
            return;
        }
        setState(SignFlowState.ERROR);
        return;
    };
    return { state: state, url: url, error: error };
}

var SignFlowGo = function (props) {
    var _a = useSignFlow(props.token, props.baseUrl, SignFlowType.PRE_SIGNING), state = _a.state, url = _a.url, error = _a.error;
    useEffect(function () {
        if (props.setStateCallback)
            props.setStateCallback(state);
    }, [state]);
    if (state === SignFlowState.LOADING) {
        return React__default.createElement(LoadingIndicator, { loading: true });
    }
    if (state === SignFlowState.ERROR)
        return (React__default.createElement(SignFlowMessage, { message: "Something went wrong", url: url, loggedIn: props.loggedIn }, error && React__default.createElement("p", null,
            "a ",
            error,
            " error accured")));
    if (SignFlowState.SIGNED || SignFlowState.ALREADY_SIGNED)
        return (React__default.createElement(SignFlowMessage, { message: "Document is already signeds", url: url, loggedIn: props.loggedIn }));
    if (SignFlowState.REDIRECTING) {
        return (React__default.createElement(SignFlowMessage, { message: "Rederecting to the signing page", url: undefined, loggedIn: false },
            React__default.createElement(Button$1, { onClick: function () { return window.location.replace(url); } }, "Go to signing")));
    }
    else
        return React__default.createElement(SignFlowMessage, { message: "Something went wrong", url: url, loggedIn: props.loggedIn });
};
var SignFlowReturn = function (props) {
    var _a = useSignFlow(props.token, props.baseUrl, SignFlowType.POST_SIGNING), state = _a.state, url = _a.url, error = _a.error;
    if (state === SignFlowState.LOADING) {
        return React__default.createElement(LoadingIndicator, { loading: true });
    }
    if (state === SignFlowState.ERROR)
        return (React__default.createElement(SignFlowMessage, { message: "Something went wrong", url: url, loggedIn: props.loggedIn }, error && React__default.createElement("p", null,
            "a ",
            error,
            " error accured")));
    if (!props.loggedIn)
        return React__default.createElement(SignFlowMessage, { message: "Thank you for signing!", url: undefined, loggedIn: false });
    return React__default.createElement(SignFlowMessage, { message: "Thank you for signing!", url: url, loggedIn: true });
};

var nominationRefreshHandler = function (allowAutoRefresh, refresh, setNewerVersion, popupFunction, refreshNotification) {
    if (allowAutoRefresh) {
        setNewerVersion(false);
        refresh();
        if (refreshNotification)
            refreshNotification();
    }
    else {
        popupFunction(refresh, setNewerVersion);
    }
};
function onNewerVersionAvailablePopup(refetchNomination, setNewerVersion) {
    toast(React__default.createElement(NotificationPopup, { message: "There is a newer version of the nomination available", actionText: "Load latest Nomination", onAction: function () {
            refetchNomination();
            setNewerVersion(false);
        } }), {
        autoClose: false,
        position: 'bottom-right',
        className: 'warning-notification',
        onClose: function () {
            setNewerVersion(false);
        },
        closeButton: React__default.createElement("div", { className: "close-button" }, "x")
    });
}
function onRefreshNotification() {
    toast.info('Loaded newest nomination data', {
        autoClose: 2000,
        closeOnClick: true
    });
}

var useCharterShipService = function (authenticationService, shipType, refreshHook) {
    var _a = useBasicAPIDataService(function () { return getCharterebleShips(authenticationService, shipType); }, []), ships = _a.data, loading = _a.loading, refresh = _a.refresh;
    var charterShip = function (shipId, charter) {
        putCharterShip(authenticationService, shipType, shipId, charter).finally(function () {
            refresh();
            if (refreshHook)
                refreshHook();
        });
    };
    return {
        ships: ships,
        loading: loading,
        setCharterebleShips: refresh,
        charterShip: charterShip
    };
};

function useGlobalDataService(authenticationService, user) {
    var _a = useBasicAPIDataService(function () { return getBunkerShips(authenticationService, undefined, true); }, []), bunkerShips = _a.data, loadingBunkerShips = _a.loading;
    var _b = useBasicAPIDataService(function () { return getAllCompanies(authenticationService); }, []), companies = _b.data, loadingCompanies = _b.loading;
    var _c = useBasicAPIDataService(function () { return getCompanyFleetList(authenticationService, user.companyId, true); }, []), userFleet = _c.data, loadingUserFleet = _c.loading;
    var _d = useBasicAPIDataService(function () { return getAllPipelines(authenticationService); }, []), pipelines = _d.data, loadingPipelines = _d.loading;
    return {
        bunkerShips: bunkerShips,
        companies: companies,
        userFleet: userFleet,
        loading: loadingBunkerShips || loadingCompanies || loadingUserFleet || loadingPipelines,
        pipelines: pipelines
    };
}

/**
 *
 * @param nomination IPromptNomination object
 * @returns string of searchable attributes of the nomination combined in one string separated by a comma `,`
 */
var nominationToSearchString = function (nomination) {
    var _a, _b, _c, _d, _e, _f;
    return (((_a = nomination.attributes) === null || _a === void 0 ? void 0 : _a.bunkerShipName) +
        ',' + ((_b = nomination.attributes) === null || _b === void 0 ? void 0 : _b.receivingShipName) +
        ',' + ((_c = nomination.attributes) === null || _c === void 0 ? void 0 : _c.companyName) +
        ',' + ((_d = nomination.attributes) === null || _d === void 0 ? void 0 : _d.vendorCompanyName) +
        ',' + ((_e = nomination.attributes) === null || _e === void 0 ? void 0 : _e.pipelineName) +
        ',' + ((_f = nomination.attributes) === null || _f === void 0 ? void 0 : _f.port) +
        ',' +
        nomination.location)
        .replace(' ', '')
        .toLowerCase();
};
/**
 *
 * @param nomination IPromptNomination object
 * @param searchString string to search on string can contain multiple attributes of nomination separated by a comma `,`
 * @returns boolean true when the string matches the nomination
 */
var nominationContainsSearch = function (nomination, searchString) {
    var nominationSearchString = nominationToSearchString(nomination);
    return searchString
        .replace(' ', '')
        .split(',')
        .every(function (sv) { return nominationSearchString.includes(sv.toLowerCase()); });
};

function InfiniteScroll(_a) {
    var _this = this;
    var fetchNextPage = _a.fetchNextPage, uniqueKey = _a.uniqueKey, renderItem = _a.renderItem, _b = _a.initialPage, initialPage = _b === void 0 ? 0 : _b, _c = _a.bufferNextPage, bufferNextPage = _c === void 0 ? 5 : _c, _d = _a.filter, filter = _d === void 0 ? undefined : _d, _e = _a.refresh, refresh = _e === void 0 ? undefined : _e, _f = _a.refreshInterval, refreshInterval = _f === void 0 ? 1000 * 5 : _f, _g = _a.loadingComponent, loadingComponent = _g === void 0 ? undefined : _g, _h = _a.refreshingComponent, refreshingComponent = _h === void 0 ? undefined : _h;
    var _j = useState([]), data = _j[0], setData = _j[1];
    var _k = useState(initialPage), currentPage = _k[0], setCurrentPage = _k[1];
    var _l = useState(false), loading = _l[0], setLoading = _l[1];
    var _m = useState(true), hasMore = _m[0], setHasMore = _m[1];
    var _o = useState(false), refreshing = _o[0], setRefreshing = _o[1];
    var loaderRef = useRef(null);
    useEffect(function () {
        loadNextPage(initialPage);
    }, []);
    var loadNextPage = useCallback(function (page) { return __awaiter(_this, void 0, void 0, function () {
        var newData_1, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (loading || !hasMore)
                        return [2 /*return*/];
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, fetchNextPage(page)];
                case 2:
                    newData_1 = _a.sent();
                    if (newData_1.length === 0) {
                        setHasMore(false);
                    }
                    else {
                        setData(function (prevData) { return __spreadArrays(prevData, newData_1); });
                        setCurrentPage(page);
                    }
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    // Handle error here
                    console.error('Error fetching data:', error_1);
                    setHasMore(false);
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [fetchNextPage, loading, hasMore, currentPage]);
    var handleRefresh = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var newData, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    setRefreshing(true);
                    return [4 /*yield*/, (refresh === null || refresh === void 0 ? void 0 : refresh(currentPage))];
                case 1:
                    newData = _a.sent();
                    if (typeof newData !== 'undefined' && newData.length > 0) {
                        setData(newData);
                    }
                    return [3 /*break*/, 4];
                case 2:
                    error_2 = _a.sent();
                    console.error('Error fetching data:', error_2);
                    return [3 /*break*/, 4];
                case 3:
                    setRefreshing(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [currentPage]);
    useEffect(function () {
        var observerDown = new IntersectionObserver(function (entries) {
            var target = entries[0];
            if (target.isIntersecting) {
                loadNextPage(currentPage + 1);
            }
        });
        if (loaderRef.current) {
            observerDown.observe(loaderRef.current);
        }
        return function () {
            if (loaderRef.current) {
                observerDown.unobserve(loaderRef.current);
            }
        };
    }, [loadNextPage, loaderRef.current]);
    return (React__default.createElement("div", null,
        refreshing && refreshingComponent && refreshingComponent,
        React__default.createElement(Refresher, { onRefresh: handleRefresh, interval: refreshInterval }),
        data.map(function (item, index) {
            var key = typeof item[uniqueKey] === 'string' ? item[uniqueKey] : undefined;
            if (!filter || filter(item)) {
                return (React__default.createElement("div", { key: key },
                    renderItem(item),
                    index === data.length - bufferNextPage && React__default.createElement("div", { ref: loaderRef })));
            }
            else if (index === data.length - bufferNextPage) {
                return React__default.createElement("div", { ref: loaderRef });
            }
        }),
        data.length < bufferNextPage && React__default.createElement("div", { ref: loaderRef }),
        React__default.createElement("div", null, loading && loadingComponent ? loadingComponent : loading && 'Loading...'),
        !loading && !hasMore && React__default.createElement("div", null, "No (more) items found.")));
}

var CopyFromPreviousNomination = function (props) {
    var _a = useState(false), searchEnabled = _a[0], setSearchEnabled = _a[1];
    var searchRef = useRef(null);
    useOnClickOutside(searchRef, function () {
        if (searchEnabled) {
            setSearchEnabled(false);
        }
    });
    var fetchNominations = function (offset) {
        return getPromptNominationsForUser(props.authenticationService, props.userProfile, undefined, undefined, undefined, undefined, 20, offset * 20 - 20);
    };
    return (React__default.createElement("div", { ref: searchRef, className: "copy-from-previous-component" },
        React__default.createElement(Button$1, { iconButton: true, onClick: function () { return setSearchEnabled(true); }, primary: true, className: "copy-from-previous-button" },
            React__default.createElement(FontAwesomeIcon, { icon: faCopy }),
            "Copy from previous nomination"),
        searchEnabled && (React__default.createElement(SearchPreviousNomination, { callback: function (previous) {
                setSearchEnabled(false);
                props.callback(previous);
            }, fetchPage: fetchNominations }))));
};
var SearchPreviousNomination = function (props) {
    var _a = useState(''), searchValue = _a[0], setSearchValue = _a[1];
    return (React__default.createElement("div", { className: "search-previous-nomination-wrapper shadow" },
        React__default.createElement("div", { className: "search-previous-input shadow" },
            React__default.createElement(FormElement, null,
                React__default.createElement(TextField, { fieldName: "search_previous-nomination", onChange: function (e) { return setSearchValue(e.target.value); }, value: searchValue, placeholder: "Search nomination.." }))),
        React__default.createElement("div", { className: "search-previous-result" },
            React__default.createElement(React__default.Fragment, null,
                React__default.createElement(InfiniteScroll, { fetchNextPage: props.fetchPage, uniqueKey: "eventId", initialPage: 1, filter: function (item) { return nominationContainsSearch(item, searchValue); }, renderItem: function (item) {
                        var _a, _b, _c;
                        return (React__default.createElement("div", { className: "nomination-result", onClick: function () { return props.callback(item); } },
                            React__default.createElement("div", { className: "information" },
                                React__default.createElement("h4", null, renderWithCommaPrefix((_a = item.attributes) === null || _a === void 0 ? void 0 : _a.receivingShipName, (_b = item.attributes) === null || _b === void 0 ? void 0 : _b.port, (_c = item.attributes) === null || _c === void 0 ? void 0 : _c.country)),
                                React__default.createElement("span", null, formatDateTime(item.eta || undefined))),
                            React__default.createElement("div", { className: "unit" },
                                item.deliveryMode && getDeliveryModeIcon(item.deliveryMode),
                                React__default.createElement("span", null, item.actualAmount || item.amount),
                                React__default.createElement("span", null, getQuantityUnitLabel(item.quantityUnit).toLocaleUpperCase()))));
                    } })))));
    function renderWithCommaPrefix() {
        var arg = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arg[_i] = arguments[_i];
        }
        return arg.filter(function (item) { return item; }).join(', ');
    }
};

var sortBy = function (key, type) {
    if (type === void 0) { type = 'asc'; }
    return type === 'asc' ? sortByAsc(key) : sortByDesc(key);
};
var sortByAsc = function (key) {
    return function (a, b) {
        return a[key] < b[key] ? -1 : a[key] > b[key] ? 1 : 0;
    };
};
var sortByDesc = function (key) {
    return function (a, b) {
        return a[key] < b[key] ? 1 : a[key] > b[key] ? -1 : 0;
    };
};

var integrationSort = sortBy('created', 'desc');
var useAssetData = function (authenticationService) {
    var _a = useState([]), compositionData = _a[0], setCompositionData = _a[1];
    var _b = useState([]), quantityData = _b[0], setQuantityData = _b[1];
    useEffect(function () {
        var cancel = requestAll();
        return cancel;
    }, []);
    var requestAll = function (limit, offset, addToPrevious) {
        var cancelRequests = false;
        if (!addToPrevious) {
            setCompositionData([]);
            setQuantityData([]);
        }
        getAllLNGSpecification(authenticationService, 'SHIP', limit, offset).then(function (data) {
            return !cancelRequests &&
                setCompositionData(function (current) { return __spreadArrays(current, data).sort(integrationSort); });
        });
        getAllQuantity(authenticationService, 'SHIP', limit, offset).then(function (data) {
            return !cancelRequests && setQuantityData(function (current) { return __spreadArrays(current, data).sort(integrationSort); });
        });
        getAllLNGSpecification(authenticationService, 'PIPE', limit, offset).then(function (data) {
            return !cancelRequests &&
                setCompositionData(function (current) { return __spreadArrays(current, data).sort(integrationSort); });
        });
        getAllQuantity(authenticationService, 'PIPE', limit, offset).then(function (data) {
            return !cancelRequests && setQuantityData(function (current) { return __spreadArrays(current, data).sort(integrationSort); });
        });
        return function () {
            cancelRequests = true;
        };
    };
    var saveComposition = function (type, id, data) {
        postLNGSpecification(authenticationService, type, id, data).then(function (data) {
            return setCompositionData(function (current) { return __spreadArrays([data], current); });
        });
    };
    var saveQuantity = function (type, id, data) {
        postQuantity(authenticationService, type, id, data).then(function (data) {
            return setQuantityData(function (current) { return __spreadArrays([data], current); });
        });
    };
    return { compositionData: compositionData, quantityData: quantityData, saveComposition: saveComposition, saveQuantity: saveQuantity };
};

var NewButton = function (props) {
    if (props.selected)
        return (React__default.createElement(Button, { primary: true, onClick: props.onClick }, "Create new version"));
    return null;
};
var mapAssetsToId = function (assets) {
    return new Map(assets.map(function (it) { return [it.asset._id, it]; }));
};
var toAssets = function (ships, pipelines) {
    return __spreadArrays(ships.map(shipToAsset), pipelines.map(pipelineToAsset)).sort(function (a, b) {
        return a.asset.name > b.asset.name ? 1 : -1;
    });
};
var shipToAsset = function (ship) {
    return { type: 'SHIP', asset: ship };
};
var pipelineToAsset = function (pipeline) {
    return { type: 'PIPE', asset: pipeline };
};
var tableColums = [
    {
        header: 'Bunker asset',
        accessor: '_id',
        renderer: function (data) {
            var _a;
            var assetId = data.data.bunkerShipId || data.data.pipelineId;
            if (assetId)
                return ((_a = data.assets.get(assetId)) === null || _a === void 0 ? void 0 : _a.asset.name) || 'Unknown asset';
            return 'Unknown asset';
        }
    },
    {
        header: 'Created',
        accessor: 'created',
        renderer: function (data) { return formatDateTime(data.data.created); }
    },
    {
        header: 'Created by',
        accessor: 'createdByUserName'
    },
    {
        header: 'Description',
        accessor: 'description',
        renderer: function (data) {
            if (!data.data.description) {
                return React__default.createElement("i", { className: "no-data" }, "No description");
            }
            return data.data.description;
        }
    }
];
var filterIntegrationData = function (data, active) {
    return active
        ? data.filter(function (it) {
            if (active.type === 'PIPE') {
                return it.pipelineId === active.asset._id;
            }
            return it.bunkerShipId === active.asset._id;
        })
        : data;
};
var enableAllPropertiesFields = {
    density: true,
    grossHeatingMass: true,
    grossHeatingVol: true,
    grossWobbeIdx: true,
    methaneNumber: true,
    netHeatingMass: true,
    netHeatingVol: true,
    netWobbeIdx: true
};

var IntegrationFormWrapper = function (props) {
    var _a;
    var _b = useState(((_a = props.selectedIntegration) === null || _a === void 0 ? void 0 : _a.description) || ''), description = _b[0], setDescription = _b[1];
    var backName = props.selectedAsset ? 'for ' + props.selectedAsset.asset.name : '';
    return (React__default.createElement("div", { className: "lng-asset-data-tables " },
        React__default.createElement("div", { className: "lng-asset-data-back" },
            React__default.createElement("div", { className: "back-wrapper" },
                React__default.createElement(Button, { iconButton: true, onClick: props.backButton, className: "back-button" },
                    React__default.createElement(Icon, null,
                        React__default.createElement(FontAwesomeIcon, { icon: faArrowLeft }))),
                React__default.createElement("span", { className: "lng-asset-back-text" },
                    ' ',
                    "LNG ",
                    props.formType,
                    " ",
                    backName)),
            React__default.createElement("div", { className: "lng-asset-actions" }, props.creatingNew ? (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(Button, { onClick: function () { return props.saveButton(description); }, disabled: props.disableSaveButton, primary: true },
                    "Save as new LNG ",
                    props.formType),
                React__default.createElement(Button, { onClick: props.backButton }, "Cancel"))) : (React__default.createElement(Button, { onClick: function () { return props.saveButton(description); }, disabled: props.disableSaveButton, primary: true },
                "Create new LNG ",
                props.formType)))),
        React__default.createElement("hr", null),
        React__default.createElement(FormElement, null,
            React__default.createElement(FormLabel, { fieldName: "numberField" },
                "Description ",
                React__default.createElement("i", null, "(optional)")),
            React__default.createElement(TextField, { className: "lng-asset-data-description-field", fieldName: "description", value: description, onChange: function (event) {
                    return setDescription(event.target.value);
                }, readOnly: typeof props.saveButton === 'undefined' })),
        React__default.createElement("div", { className: "ebdn-wrapper lng-asset-ebdn-wrapper" }, props.children)));
};

var MassIntegrationForm = function (props) {
    var _a;
    var creatingNew = props.selectedIntegration === null && props.selectedAsset !== undefined;
    var _b = useState(), problems = _b[0], setProblems = _b[1];
    var _c = useState(((_a = props.selectedIntegration) === null || _a === void 0 ? void 0 : _a.quantity.mass) || null), mass = _c[0], setMass = _c[1];
    function validation() {
        if (mass === undefined || (mass !== null && isNaN(mass))) {
            setProblems({
                globalError: {
                    problemType: 'ERROR',
                    message: 'Mass can not be empty and must be a valid number'
                }
            });
        }
        else {
            setProblems(undefined);
        }
    }
    useFuncOnStopChanging(mass, null, validation, false);
    function saveCallBack(description) {
        var asset = props.selectedIntegration
            ? assetFromIntegration(props.selectedIntegration)
            : props.selectedAsset;
        if (asset) {
            props.save(asset.type, asset.asset._id, {
                description: description,
                quantity: {
                    mass: mass
                }
            });
            props.setSelectedIntegration(undefined);
        }
    }
    return (React__default.createElement(IntegrationFormWrapper, { selectedAsset: props.selectedAsset, selectedIntegration: props.selectedIntegration, backButton: function () { return props.setSelectedIntegration(undefined); }, saveButton: saveCallBack, disableSaveButton: !isValidOBJ(problems) || mass === null, formType: "mass", creatingNew: creatingNew },
        React__default.createElement(Collapse$1, { id: "eBDN-step-mass", isOpen: true, collapseHeaderContent: function () {
                return React__default.createElement(BDNStepHeader, { stepTitle: "LNG mass", stepInactive: false, problems: problems });
            } },
            React__default.createElement("table", { cellSpacing: "0", cellPadding: "0" },
                React__default.createElement("tbody", null,
                    React__default.createElement("tr", null,
                        React__default.createElement("td", null, "Mass"),
                        React__default.createElement("td", null,
                            React__default.createElement("input", { type: "number", value: mass || undefined, step: "0.01", onChange: function (e) {
                                    setMass(Number(e.target.value) || undefined);
                                } })),
                        React__default.createElement("td", null, "tons")))))));
};
var LNGSpecificationsIntegrationForm = function (props) {
    var _a, _b, _c, _d, _e;
    var _f = useState(), problemsComposition = _f[0], setProblemsComposition = _f[1];
    var _g = useState(), problemsProperties = _g[0], setProblemsProperties = _g[1];
    var creatingNew = props.selectedIntegration === null && typeof props.selectedAsset !== undefined;
    var _h = useState((_a = props.selectedIntegration) === null || _a === void 0 ? void 0 : _a.composition), composition = _h[0], setComposition = _h[1];
    var _j = useState((_b = props.selectedIntegration) === null || _b === void 0 ? void 0 : _b.properties), properties = _j[0], setProperties = _j[1];
    function saveCallBack(description) {
        var asset = props.selectedIntegration
            ? assetFromIntegration(props.selectedIntegration)
            : props.selectedAsset;
        if (asset) {
            props.save(asset.type, asset.asset._id, {
                description: description,
                composition: composition,
                properties: properties
            });
            props.setSelectedIntegration(undefined);
        }
    }
    return (React__default.createElement(IntegrationFormWrapper, { selectedAsset: props.selectedAsset, selectedIntegration: props.selectedIntegration, backButton: function () { return props.setSelectedIntegration(undefined); }, saveButton: saveCallBack, disableSaveButton: !isValidOBJ(problemsComposition) ||
            (!objHasValues(composition) && !objHasValues(properties)), formType: "specification", creatingNew: creatingNew },
        React__default.createElement(Collapse$1, { id: "eBDN-step-lngComposition", isOpen: true, collapseHeaderContent: function () {
                return (React__default.createElement(BDNStepHeader, { stepTitle: "LNG Composition", stepInactive: false, problems: problemsComposition }));
            } },
            React__default.createElement(CompositionTable, { bunkerAsset: (_c = props.selectedAsset) === null || _c === void 0 ? void 0 : _c.asset, values: creatingNew ? composition : (_d = props.selectedIntegration) === null || _d === void 0 ? void 0 : _d.composition, readOnly: false, showCalculationOption: false, calculateComposition: undefined, update: setComposition, hideTableHeaders: true, setProblems: setProblemsComposition, problems: problemsComposition, autoSave: true, integrationData: undefined, fieldsMandatory: false })),
        React__default.createElement(Collapse$1, { id: "eBDN-step-lngComposition", isOpen: true, collapseHeaderContent: function () {
                return (React__default.createElement(BDNStepHeader, { stepTitle: "LNG Properties", stepInactive: false, problems: problemsProperties }));
            } },
            React__default.createElement(PropertiesTable, { readOnly: false, update: setProperties, values: creatingNew ? properties : (_e = props.selectedIntegration) === null || _e === void 0 ? void 0 : _e.properties, hideTableHeaders: true, configuration: enableAllPropertiesFields, showCalculationOption: false, setProblems: setProblemsProperties, problems: problemsProperties, autoSave: true, integrationData: undefined }))));
};
var assetFromIntegration = function (integration) {
    return {
        type: integration.bunkerShipId ? 'SHIP' : 'PIPE',
        asset: integration.bunkerShipId
            ? { _id: integration.bunkerShipId }
            : { _id: integration.pipelineId }
    };
};

var LngAssetDataTable = function (props) {
    var _a = useState(5), showAmount = _a[0], setShowAmount = _a[1];
    var data = props.data.slice(0, showAmount);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("table", { className: "lng-asset-data-table" },
            React__default.createElement("thead", null,
                React__default.createElement("tr", null, props.table.map(function (item) { return (React__default.createElement("th", { key: item.accessor + "-LngAssetDataTable" },
                    React__default.createElement("span", null, item.header))); }))),
            React__default.createElement("tbody", null, data.map(function (data) { return (React__default.createElement("tr", { onClick: function () { return !props.disableDefaultCallback && props.callBack(data); } }, props.table.map(function (item) { return (React__default.createElement("td", { key: data._id + "-" + item.accessor + "-LngAssetDataTable" }, item.renderer
                ? item.renderer({
                    data: data,
                    assets: props.assets
                })
                : data[item.accessor])); }))); }))),
        showAmount < props.data.length && (React__default.createElement("span", { className: "show-more-data", onClick: function () { return setShowAmount(function (it) { return it + 5; }); } },
            React__default.createElement(FontAwesomeIcon, { icon: faChevronRight }),
            " ",
            React__default.createElement("b", null, "Show more")))));
};

var LngAssetData = function (props) {
    var assets = toAssets(props.ships, props.pipelines);
    var _a = useState(assets.length === 1 ? assets[0] || undefined : undefined), active = _a[0], setActive = _a[1];
    var _b = useState(), selectedComposition = _b[0], setSelectedComposition = _b[1];
    var _c = useState(), selectedQuantity = _c[0], setSelectedQuantity = _c[1];
    var _d = useAssetData(props.authenticationService), compositionData = _d.compositionData, quantityData = _d.quantityData, saveComposition = _d.saveComposition, saveQuantity = _d.saveQuantity;
    var showTables = (typeof selectedComposition === 'undefined' && typeof selectedQuantity === 'undefined') ||
        ((selectedComposition === null || selectedQuantity === null) && !active);
    var mappedAssets = mapAssetsToId(assets);
    var renderLNGAssetDataTables = function () {
        var quantities = filterIntegrationData(quantityData, active);
        var compositions = filterIntegrationData(compositionData, active);
        return (React__default.createElement("div", { className: "lng-asset-data-tables" },
            React__default.createElement("h3", null,
                "LNG mass ",
                React__default.createElement(NewButton, { selected: active, onClick: function () { return setSelectedQuantity(null); } })),
            React__default.createElement(LngAssetDataTable, { table: tableColums, assets: mappedAssets, data: quantities, callBack: function (d) { return setSelectedQuantity(d); } }),
            React__default.createElement("h3", { className: "margin-top" },
                "LNG specification",
                React__default.createElement(NewButton, { selected: active, onClick: function () { return setSelectedComposition(null); } })),
            React__default.createElement(LngAssetDataTable, { table: tableColums, assets: mappedAssets, data: compositions, callBack: function (d) { return setSelectedComposition(d); } })));
    };
    var renderForm = function () {
        if (showTables) {
            return renderLNGAssetDataTables();
        }
        if (typeof selectedComposition !== 'undefined') {
            return (React__default.createElement(LNGSpecificationsIntegrationForm, { selectedIntegration: selectedComposition, setSelectedIntegration: setSelectedComposition, selectedAsset: active, save: saveComposition }));
        }
        if (typeof selectedQuantity !== 'undefined') {
            return (React__default.createElement(MassIntegrationForm, { selectedIntegration: selectedQuantity, setSelectedIntegration: setSelectedQuantity, selectedAsset: active, save: saveQuantity }));
        }
        return 'something went wrong';
    };
    var changeActive = function (active) {
        setActive(function (old) { return ((old === null || old === void 0 ? void 0 : old.asset._id) === (active === null || active === void 0 ? void 0 : active.asset._id) ? undefined : active); });
        setSelectedComposition(undefined);
        setSelectedQuantity(undefined);
    };
    return (React__default.createElement("div", { className: "lng-asset-data-wrapper" },
        React__default.createElement("div", { className: "lng-asset-data-options" },
            assets.length > 1 && (React__default.createElement(TimelineFilterItem, { key: 'all-assets-key', type: undefined, title: 'All assets', filterActive: !active, onClick: function () { return changeActive(undefined); } })),
            assets.map(function (item) { return (React__default.createElement(TimelineFilterItem, { key: item.asset._id, type: item.type, title: item.asset.name, filterActive: (active === null || active === void 0 ? void 0 : active.asset._id) === item.asset._id, onClick: function () { return changeActive(item); } })); })),
        renderForm()));
};

/**
 * File is copied from the shared chorus-utility-library
 */
function useNominationService(_a) {
    var nominationId = _a.nominationId, authenticationService = _a.authenticationService, userProfile = _a.userProfile, setLoading = _a.setLoading, onNewerVersionAvailable = _a.onNewerVersionAvailable, sandboxId = _a.sandboxId, vendorCompanyId = _a.vendorCompanyId, successCallback = _a.successCallback;
    var _b = useState([]), nominationHistory = _b[0], setNominationHistory = _b[1];
    var _c = useState(undefined), nominationEventId = _c[0], setNominationEventId = _c[1];
    var _d = useState(undefined), latestNomination = _d[0], setLatestNomination = _d[1];
    var _e = useState(nominationHistory ? nominationHistory.length - 1 : 0), selectedNominationIndex = _e[0], setSelectedNominationIndex = _e[1];
    var selectedHistoricNomination = nominationHistory && !isEqual(nominationHistory[selectedNominationIndex], latestNomination)
        ? nominationHistory[selectedNominationIndex]
        : undefined;
    var previousHistoricNomination = selectedNominationIndex > 0 ? nominationHistory[selectedNominationIndex - 1] : undefined;
    var _f = useState(false), newerVersionAvailable = _f[0], setNewerVersionAvailable = _f[1];
    useEffect(function () {
        fetchNominationData(nominationId, sandboxId);
        setNominationEventId(nominationId);
    }, [nominationId]);
    function fetchNominationData(eventId, sandboxId) {
        return __awaiter(this, void 0, void 0, function () {
            var eventHistory;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        if (!eventId) return [3 /*break*/, 2];
                        return [4 /*yield*/, fetchNominationHistory(eventId, sandboxId)];
                    case 1:
                        eventHistory = _a.sent();
                        if (eventHistory) {
                            setNominationHistory(eventHistory);
                            setLatestNomination(eventHistory[eventHistory.length - 1]);
                            setSelectedNominationIndex(eventHistory.length - 1);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        setNominationHistory([]);
                        setLatestNomination(undefined);
                        setSelectedNominationIndex(0);
                        _a.label = 3;
                    case 3:
                        setLoading(false);
                        return [2 /*return*/];
                }
            });
        });
    }
    function fetchNominationHistory(eventId, sandboxId) {
        return __awaiter(this, void 0, void 0, function () {
            var eventHistory, filteredEventHistory, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, getPromptEventHistory(authenticationService, eventId, sandboxId)];
                    case 1:
                        eventHistory = _a.sent();
                        filteredEventHistory = eventHistory.filter(function (event) {
                            return isPromptNomination(event);
                        });
                        return [2 /*return*/, filteredEventHistory];
                    case 2:
                        err_1 = _a.sent();
                        handleFetchError(err_1);
                        return [2 /*return*/, []];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    function delegatePromptNomination(promptNomination, supplierId) {
        return __awaiter(this, void 0, void 0, function () {
            var promptNominationToUpdate;
            return __generator(this, function (_a) {
                promptNominationToUpdate = cloneDeep(promptNomination);
                // remove the bunkership from the nomination
                promptNominationToUpdate.bunkerShipId = null;
                // set the nominations supplierId to actually delegate it to that part
                promptNominationToUpdate.supplierId = supplierId;
                // then update the nomination itself through the api
                updatePromptNomination('AMEND', promptNominationToUpdate);
                return [2 /*return*/];
            });
        });
    }
    function updatePromptNomination(action, updatedNomination, suppressNotification, amendAndAccept) {
        return __awaiter(this, void 0, void 0, function () {
            var nominationToUpdate, _a, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        setLoading(true);
                        nominationToUpdate = cloneDeep(updatedNomination);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 14, 15, 16]);
                        _a = action;
                        switch (_a) {
                            case 'AMEND': return [3 /*break*/, 2];
                            case 'COUNTER': return [3 /*break*/, 4];
                            case 'COMPLETE': return [3 /*break*/, 6];
                            case 'CREATE': return [3 /*break*/, 8];
                        }
                        return [3 /*break*/, 10];
                    case 2: return [4 /*yield*/, amendPromptNomination(authenticationService, nominationToUpdate, amendAndAccept)];
                    case 3:
                        nominationToUpdate = _b.sent();
                        return [3 /*break*/, 11];
                    case 4: return [4 /*yield*/, counterPromptNomination(authenticationService, nominationToUpdate)];
                    case 5:
                        nominationToUpdate = _b.sent();
                        return [3 /*break*/, 11];
                    case 6: return [4 /*yield*/, completeDelivery(authenticationService, nominationToUpdate, nominationToUpdate.eventId)];
                    case 7:
                        nominationToUpdate = _b.sent();
                        return [3 /*break*/, 11];
                    case 8: return [4 /*yield*/, createNewPromptNomination(authenticationService, nominationToUpdate)];
                    case 9:
                        nominationToUpdate = _b.sent();
                        return [3 /*break*/, 11];
                    case 10: return [3 /*break*/, 11];
                    case 11:
                        if (suppressNotification !== true) {
                            toast.success('Nomination is submitted');
                        }
                        if (!(nominationToUpdate && nominationToUpdate.eventId)) return [3 /*break*/, 13];
                        // set the nomination eventID in case a nomination was just created.
                        setNominationEventId(nominationToUpdate.eventId);
                        return [4 /*yield*/, fetchNominationData(nominationToUpdate.eventId, sandboxId)];
                    case 12:
                        _b.sent();
                        if (successCallback) {
                            successCallback(action, nominationToUpdate);
                        }
                        _b.label = 13;
                    case 13: return [3 /*break*/, 16];
                    case 14:
                        error_1 = _b.sent();
                        // 422 => Unprocessable Entity code from the backend which tells us a amend request is not possible.
                        // Therefore a counter should be done.
                        if (error_1.status && error_1.status === 422) {
                            throw error_1;
                        }
                        else {
                            handleFetchError(error_1);
                            return [2 /*return*/, error_1];
                        }
                    case 15:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 16: return [2 /*return*/];
                }
            });
        });
    }
    function updateSandboxPromptNomination(updatedNomination, sandboxId) {
        return __awaiter(this, void 0, void 0, function () {
            var actualNomination, latestId, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        updatedNomination = cloneDeep(updatedNomination);
                        setLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        actualNomination = cloneDeep(latestNomination);
                        latestId = actualNomination ? actualNomination._id : undefined;
                        return [4 /*yield*/, putPromptEventSandbox(authenticationService, updatedNomination, sandboxId, latestId)];
                    case 2:
                        updatedNomination = _a.sent();
                        toast.success('Sandbox nomination is saved');
                        return [3 /*break*/, 4];
                    case 3:
                        err_2 = _a.sent();
                        handleFetchError(err_2);
                        return [3 /*break*/, 4];
                    case 4:
                        setLoading(false);
                        return [2 /*return*/];
                }
            });
        });
    }
    function updatePromptNominationState(newState, onBehalf, reason) {
        return __awaiter(this, void 0, void 0, function () {
            var error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(latestNomination === null || latestNomination === void 0 ? void 0 : latestNomination._id) || !nominationEventId) {
                            console.warn('Trying to update the state of a nomination without eventId');
                            return [2 /*return*/];
                        }
                        setLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, postPromptProposalState(authenticationService, latestNomination._id, newState, onBehalf, reason, sandboxId)];
                    case 2:
                        _a.sent();
                        toast.success('Proposal status is updated to ' + newState);
                        fetchNominationData(nominationEventId, sandboxId);
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        handleFetchError(error_2);
                        return [3 /*break*/, 4];
                    case 4:
                        setLoading(false);
                        return [2 /*return*/];
                }
            });
        });
    }
    function acceptPendingNomination(pendingNomination) {
        return __awaiter(this, void 0, void 0, function () {
            var error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!pendingNomination._id || !nominationEventId) {
                            return [2 /*return*/];
                        }
                        setLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, acceptPendingPromptProposal(authenticationService, pendingNomination._id)];
                    case 2:
                        _a.sent();
                        toast.success('Nomination has been accepted');
                        fetchNominationData(nominationEventId);
                        return [3 /*break*/, 4];
                    case 3:
                        error_3 = _a.sent();
                        handleFetchError(error_3);
                        return [3 /*break*/, 4];
                    case 4:
                        setLoading(false);
                        return [2 /*return*/];
                }
            });
        });
    }
    function selectNextHistoricNomination() {
        if (nominationHistory) {
            var selectedIndexInHistory = selectedNominationIndex + 1 < nominationHistory.length;
            if (selectedIndexInHistory) {
                setSelectedNominationIndex(selectedNominationIndex + 1);
            }
        }
    }
    function selectPreviousHistoricNomination() {
        if (nominationHistory) {
            if (selectedNominationIndex - 1 >= 0)
                setSelectedNominationIndex(selectedNominationIndex - 1);
        }
    }
    function refetchNominationData() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!nominationEventId) return [3 /*break*/, 2];
                        return [4 /*yield*/, fetchNominationData(nominationEventId, sandboxId)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    }
    function checkIfNewerNominationAvailable() {
        return __awaiter(this, void 0, void 0, function () {
            var eventHistory, newLatestNomination;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!nominationEventId) return [3 /*break*/, 2];
                        return [4 /*yield*/, fetchNominationHistory(nominationEventId, sandboxId)];
                    case 1:
                        eventHistory = _a.sent();
                        if (eventHistory) {
                            newLatestNomination = eventHistory[eventHistory.length - 1];
                            if (latestNomination &&
                                newLatestNomination &&
                                !isEqual(latestNomination, newLatestNomination)) {
                                if (!newerVersionAvailable) {
                                    setNewerVersionAvailable(true);
                                    onNewerVersionAvailable(refetchNominationData, setNewerVersionAvailable);
                                }
                            }
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/, newerVersionAvailable];
                }
            });
        });
    }
    function attachFileToNomination(file, fileType, itemWithDocuments, companyId, fileName) {
        return __awaiter(this, void 0, void 0, function () {
            var fileReturn, event_1, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        return [4 /*yield*/, uploadDocument(authenticationService, companyId, fileType, file, fileName)];
                    case 2:
                        fileReturn = _a.sent();
                        event_1 = itemWithDocuments;
                        if (!((fileReturn === null || fileReturn === void 0 ? void 0 : fileReturn._id) && event_1.eventId)) return [3 /*break*/, 5];
                        return [4 /*yield*/, attachDocuments(authenticationService, event_1.eventId, [fileReturn === null || fileReturn === void 0 ? void 0 : fileReturn._id])];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, refetchNominationData()];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        err_3 = _a.sent();
                        handleFetchError(err_3);
                        return [3 /*break*/, 7];
                    case 7:
                        setLoading(false);
                        return [2 /*return*/];
                }
            });
        });
    }
    function attachEBDNToNomination(file) {
        return __awaiter(this, void 0, void 0, function () {
            var error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        if (!(latestNomination && latestNomination._id)) return [3 /*break*/, 4];
                        return [4 /*yield*/, uploadEBDNFile(authenticationService, file, "ebdn-" + latestNomination._id + ".xlsx", latestNomination._id)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, refetchNominationData()];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        toast.error('Save the nomination first to upload the EBDN');
                        _a.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        error_4 = _a.sent();
                        if (error_4.status === 400) {
                            toast.error('Uploaded file is not a valid eBDN spreadsheet');
                        }
                        else {
                            handleFetchError(error_4);
                        }
                        return [3 /*break*/, 7];
                    case 7:
                        setLoading(false);
                        return [2 /*return*/];
                }
            });
        });
    }
    function createBDNDocument() {
        return __awaiter(this, void 0, void 0, function () {
            var error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, 6, 7]);
                        if (!(latestNomination === null || latestNomination === void 0 ? void 0 : latestNomination.eventId)) return [3 /*break*/, 4];
                        return [4 /*yield*/, createSignableBDNDocument(authenticationService, latestNomination.eventId)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, refetchNominationData()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [3 /*break*/, 7];
                    case 5:
                        error_5 = _a.sent();
                        handleFetchError(error_5);
                        return [3 /*break*/, 7];
                    case 6:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    }
    function generateAndSendOrderConfirmation() {
        return __awaiter(this, void 0, void 0, function () {
            var error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, 5, 6]);
                        if (!nominationEventId) return [3 /*break*/, 3];
                        return [4 /*yield*/, createOrderConfirmation(authenticationService, nominationEventId)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [3 /*break*/, 6];
                    case 4:
                        error_6 = _a.sent();
                        handleFetchError(error_6);
                        return [3 /*break*/, 6];
                    case 5:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    }
    function cancelDelegatedNomination(originNominationId, reason) {
        return __awaiter(this, void 0, void 0, function () {
            var error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, cancelDelegation(authenticationService, originNominationId, reason)];
                    case 2:
                        _a.sent();
                        toast.success('Nomination has been un-delegated');
                        refetchNominationData();
                        return [3 /*break*/, 4];
                    case 3:
                        error_7 = _a.sent();
                        handleFetchError(error_7);
                        return [3 /*break*/, 4];
                    case 4:
                        setLoading(false);
                        return [2 /*return*/];
                }
            });
        });
    }
    return {
        nominationHistory: nominationHistory,
        latestNomination: latestNomination,
        nominationSelection: {
            selectedNominationIndex: selectedNominationIndex,
            previousHistoricNomination: previousHistoricNomination,
            selectedHistoricNomination: selectedHistoricNomination,
            selectNextHistoricNomination: selectNextHistoricNomination,
            selectPreviousHistoricNomination: selectPreviousHistoricNomination
        },
        updatePromptNomination: updatePromptNomination,
        updatePromptNominationState: updatePromptNominationState,
        updateSandboxPromptNomination: updateSandboxPromptNomination,
        delegatePromptNomination: delegatePromptNomination,
        acceptPendingNomination: acceptPendingNomination,
        refetchNominationData: refetchNominationData,
        checkIfNewerNominationAvailable: checkIfNewerNominationAvailable,
        attachEBDNToNomination: attachEBDNToNomination,
        attachFileToNomination: attachFileToNomination,
        createBDNDocument: createBDNDocument,
        generateAndSendOrderConfirmation: generateAndSendOrderConfirmation,
        cancelDelegatedNomination: cancelDelegatedNomination
    };
}

function useNominationCollectionService(props) {
    var _a;
    var _b = useState(undefined), associatedNominationId = _b[0], setAssociatedNominationId = _b[1];
    var originalNominationData = useNominationService(props);
    var originalIsDelegation = !!((_a = originalNominationData.latestNomination) === null || _a === void 0 ? void 0 : _a.delegationOriginEventId);
    var delegatedNominationData = useNominationService(__assign(__assign({}, props), { nominationId: associatedNominationId }));
    var originalAndDelegatedAreSwitched = !!(originalIsDelegation && delegatedNominationData.latestNomination);
    useEffect(findAssociatedId, [originalNominationData]);
    useEffect(resetState, [props.nominationId]);
    function findAssociatedId() {
        var _a, _b, _c;
        // The latest data since the nominationId changed is not fetched yet, so waiting for that
        if (((_a = originalNominationData.latestNomination) === null || _a === void 0 ? void 0 : _a.eventId) !== props.nominationId) {
            return;
        }
        var delegationId = (_b = originalNominationData.latestNomination) === null || _b === void 0 ? void 0 : _b.delegatedNominationEventId;
        var originalId = (_c = originalNominationData.latestNomination) === null || _c === void 0 ? void 0 : _c.delegationOriginEventId;
        if (delegationId) {
            // Original one has a delegation linked, set that id
            if (associatedNominationId !== delegationId) {
                setAssociatedNominationId(delegationId);
            }
        }
        else if (originalId) {
            // The original nomination is already the delegation, so need to set the original id as associated
            if (associatedNominationId !== originalId) {
                setAssociatedNominationId(originalId);
            }
        }
        else {
            // It's not a delegation, no need to set the associated id
            if (associatedNominationId)
                setAssociatedNominationId(undefined);
        }
    }
    function resetState() {
        setAssociatedNominationId(undefined);
    }
    // When the passed in nominationId is already from a delegation the fetched data is the other way around
    return {
        originalNomination: originalAndDelegatedAreSwitched
            ? delegatedNominationData
            : originalNominationData,
        delegatedNomination: originalAndDelegatedAreSwitched
            ? originalNominationData
            : delegatedNominationData
    };
}

var DialogCreateNewNOR = function (props) {
    var _a;
    return (React__default.createElement(Dialog, { showDialog: props.isDialogActive, onCloseDialog: function () {
            props.setDialogVisibility(false);
        }, type: "small", title: "Generate new Notice of Readiness document" },
        React__default.createElement("p", null,
            React__default.createElement(FormElement, null,
                React__default.createElement(FormLabel, { fieldName: "nor-document-datetime" }, "Document Date and Time"),
                React__default.createElement(DateTimePicker, { name: 'nor-document-datetime', onDateTimeChange: function (isoDate, inputValue) {
                        return props.onChangeValue('datetime', isoDate || inputValue);
                    }, icon: React__default.createElement("i", { className: "icon-calendar-1" }), placeholder: 'dd/mm/yyyy hh:mm', value: ((_a = props.values) === null || _a === void 0 ? void 0 : _a.datetime) || new Date().toISOString(), timeZone: props.timeZone, hideDialogHeader: true }))),
        React__default.createElement(ButtonGroup, null,
            React__default.createElement(Button, { primary: true, preventDoubleClick: true, onClick: function () {
                    props.onConfirm();
                    props.setDialogVisibility(false);
                } }, "Confirm"),
            React__default.createElement(Button, { danger: true, preventDoubleClick: true, onClick: function () {
                    props.setDialogVisibility(false);
                } }, "Cancel"))));
};

var initialValues = { datetime: new Date().toISOString() };
var NoticeOfReadiness = function (props) {
    var _a = useForm({
        initialValues: initialValues,
        onValidSubmit: handleGenerateDocument
    }), values = _a.values, onChangeValue = _a.onChangeValue;
    var _b = useState(false), dialogCreateDocument = _b[0], setDialogCreateDocument = _b[1];
    var locationService = useLocationService(props.authenticationService);
    var timeZone = useLocationTimeZone(props.event.locationId, locationService);
    var canGenerateForBunkerVessel = (isCaptain(props.userProfile.roles) &&
        props.userProfile.bunkerShipId === props.event.bunkerShipId &&
        !!props.event.bunkerShipId) ||
        (isOperator(props.userProfile.roles) &&
            ((props.userProfile.pipelineId === props.event.pipelineId && !!props.event.pipelineId) ||
                (props.userProfile.pipelineId === props.event.loadingTerminalId &&
                    !!props.event.loadingTerminalId))); // double !! is required or it will pick the value
    var canGenerateForReceivingVessel = isReceivingCaptain(props.userProfile.roles) &&
        props.userProfile.receivingShipId === props.event.receivingShipId &&
        !!props.event.receivingShipId; // double !! is required or it will pick the value
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("section", { className: "nor-document-status-wrapper" },
            React__default.createElement("div", { className: "nor-document-status-content" },
                React__default.createElement("div", { className: "document-status-box" },
                    React__default.createElement("div", { className: "document-status-box-content" },
                        React__default.createElement(DocumentStatusBlock, { title: 'NOR', isDifferentFromInitial: false, readOnly: false, statusArray: generateStatusForNOR(props.event.documents, 'NOR_BUNKERSHIP'), generatePDF: function () { return setDialogCreateDocument(true); }, canGeneratePDF: canGenerateForBunkerVessel },
                            React__default.createElement(PDFDocumentHandler, { authenticationService: props.authenticationService, eventWithDocuments: props.event, userProfile: props.userProfile, allowedDocumentTypes: ['NOR_BUNKERSHIP'], withWrapper: true, readOnly: !isBunkerCaptain(props.userProfile.roles) &&
                                    !isOperator(props.userProfile.roles), refetchEvent: props.refetchNominationData, updateItem: props.updateItem })))),
                React__default.createElement("div", { className: "seperator" }),
                React__default.createElement("div", { className: "document-status-box" },
                    React__default.createElement("div", { className: "document-status-box-content" },
                        React__default.createElement(DocumentStatusBlock, { title: 'NOR', isDifferentFromInitial: false, readOnly: false, statusArray: generateStatusForNOR(props.event.documents, 'NOR_RECEIVINGSHIP'), generatePDF: function () { return setDialogCreateDocument(true); }, canGeneratePDF: canGenerateForReceivingVessel },
                            React__default.createElement(PDFDocumentHandler, { authenticationService: props.authenticationService, eventWithDocuments: props.event, userProfile: props.userProfile, allowedDocumentTypes: ['NOR_RECEIVINGSHIP'], withWrapper: true, readOnly: !isReceivingCaptain(props.userProfile.roles), refetchEvent: props.refetchNominationData, updateItem: props.updateItem })))))),
        React__default.createElement(DialogCreateNewNOR, { isDialogActive: dialogCreateDocument, setDialogVisibility: setDialogCreateDocument, onConfirm: handleGenerateDocument, values: values, onChangeValue: onChangeValue, timeZone: timeZone.value })));
    function handleGenerateDocument() {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!values || !values.datetime) {
                            toast.error('Selected Date and Time is not appropriate!');
                            return [2 /*return*/, false];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        toast('Document is being created...', { toastId: 'progress', type: 'info' });
                        return [4 /*yield*/, createNOR(props.authenticationService, props.event.eventId, values)];
                    case 2:
                        _a.sent();
                        toast.update('progress', { type: 'success', render: 'Document has been created!' });
                        props.refetchNominationData();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        handleFetchError(error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    function getNORStatus(nor) {
        if (!nor)
            return 'NOT_STARTED';
        if (nor.signingStatus === 'SIGNED')
            return 'COMPLETED';
        return 'IN_PROGRESS';
    }
    function generateStatusForNOR(documents, type) {
        var latestNor = documents
            ? __spreadArrays(documents).reverse().find(function (document) { return document.type === type; })
            : undefined;
        var user = type === 'NOR_BUNKERSHIP'
            ? 'Bunker vessel'
            : type === 'NOR_RECEIVINGSHIP'
                ? 'Receiving vessel'
                : 'Unknown';
        var status = {
            user: user,
            status: getNORStatus(latestNor)
        };
        return [status];
    }
};

var DialogCreateNewMRF = function (props) {
    return (React__default.createElement(Dialog, { showDialog: props.isDialogActive, onCloseDialog: function () {
            props.setNewMRFDialog(false);
        }, type: "small", title: "Are you sure you want to create a new form?" },
        React__default.createElement("p", null,
            "This action",
            ' ',
            React__default.createElement("strong", null,
                React__default.createElement("u", null, "will remove the current form")),
            ' ',
            "and make a new one with the latest data from the nomination"),
        React__default.createElement(ButtonGroup, null,
            React__default.createElement(Button, { primary: true, preventDoubleClick: true, onClick: props.handleCreateNewForm }, "Confirm"),
            React__default.createElement(Button, { danger: true, preventDoubleClick: true, onClick: function () {
                    props.setNewMRFDialog(false);
                } }, "Cancel"))));
};

var MasterRequisitionForm = function (props) {
    var values = props.values, onChangeFormValue = props.onChangeFormValue, onChange = props.onChange;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("div", { className: "mr-form" },
            React__default.createElement("table", { className: "mr-form-table-header" },
                React__default.createElement("tbody", null,
                    React__default.createElement("tr", null,
                        React__default.createElement("td", null, "Buyer of LNG:"),
                        React__default.createElement("td", null,
                            React__default.createElement(FormElement, null,
                                React__default.createElement(TextField, { fieldName: "receiver", value: (values === null || values === void 0 ? void 0 : values.receiver) || '', onChange: onChange })))),
                    React__default.createElement("tr", null,
                        React__default.createElement("td", null, "Receiving vessel:"),
                        React__default.createElement("td", null,
                            React__default.createElement(FormElement, null,
                                React__default.createElement(TextField, { fieldName: "receivingShipName", value: (values === null || values === void 0 ? void 0 : values.receivingShipName) || '', onChange: onChange })))),
                    React__default.createElement("tr", null,
                        React__default.createElement("td", null, "Seller of LNG:"),
                        React__default.createElement("td", null,
                            React__default.createElement(FormElement, null,
                                React__default.createElement(TextField, { fieldName: "supplier", value: (values === null || values === void 0 ? void 0 : values.supplier) || '', onChange: onChange })))),
                    React__default.createElement("tr", null,
                        React__default.createElement("td", null, "Bunker vessel:"),
                        React__default.createElement("td", null,
                            React__default.createElement(FormElement, null,
                                React__default.createElement(TextField, { fieldName: "bunkerShipName", value: (values === null || values === void 0 ? void 0 : values.bunkerShipName) || '', onChange: onChange })))),
                    React__default.createElement("tr", null,
                        React__default.createElement("td", null, "Delivery point:"),
                        React__default.createElement("td", null,
                            React__default.createElement(FormElement, null,
                                React__default.createElement(TextField, { fieldName: "deliveryPoint", value: (values === null || values === void 0 ? void 0 : values.deliveryPoint) || '', onChange: onChange })))),
                    React__default.createElement("tr", null,
                        React__default.createElement("td", null,
                            "Contract party and assigned supplier: ",
                            React__default.createElement("i", null, "(if applicable)")),
                        React__default.createElement("td", null,
                            React__default.createElement(FormElement, null,
                                React__default.createElement(TextField, { fieldName: "contractParty", value: (values === null || values === void 0 ? void 0 : values.contractParty) || '', onChange: onChange })))),
                    React__default.createElement("tr", null,
                        React__default.createElement("td", null, "Receiver\u2019s BDN reference:"),
                        React__default.createElement("td", null,
                            React__default.createElement(FormElement, null,
                                React__default.createElement(TextField, { fieldName: "bdnReference", value: (values === null || values === void 0 ? void 0 : values.bdnReference) || '', onChange: onChange })))),
                    React__default.createElement("tr", null,
                        React__default.createElement("td", null, "Next port of call:"),
                        React__default.createElement("td", null,
                            React__default.createElement(FormElement, null,
                                React__default.createElement(TextField, { fieldName: "nextDestination", value: (values === null || values === void 0 ? void 0 : values.nextDestination) || '', onChange: onChange })))))),
            React__default.createElement("p", null, "Please supply my receiving vessel with the following marine LNG : - "),
            React__default.createElement("table", { className: "mr-form-table-quantity" },
                React__default.createElement("thead", null,
                    React__default.createElement("th", null, "Quantity"),
                    React__default.createElement("th", null, "Measurement (m3 or MT)"),
                    React__default.createElement("th", null, "Bulk Transfer Rate (m3/hr)")),
                React__default.createElement("tbody", null,
                    React__default.createElement("tr", null,
                        React__default.createElement("td", null,
                            React__default.createElement(FormElement, null,
                                React__default.createElement(TextField, { fieldName: "quantity", value: values === null || values === void 0 ? void 0 : values.quantity, onChange: onChange }))),
                        React__default.createElement("td", null,
                            React__default.createElement(FormElement, null,
                                React__default.createElement(SelectionBox, { value: values === null || values === void 0 ? void 0 : values.quantityUnit, valueKey: "value", displayKey: "text", fieldName: "quantityUnit", options: [
                                        { text: 'm3', value: QuantityUnit.CUBIC_METERS },
                                        { text: 'MT', value: QuantityUnit.TONNES }
                                    ], onChangeValue: function (selectedItem) {
                                        return onChangeFormValue('quantityUnit', selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value);
                                    } }))),
                        React__default.createElement("td", null,
                            React__default.createElement(FormElement, null,
                                React__default.createElement(TextField, { fieldName: "rate", value: values === null || values === void 0 ? void 0 : values.rate, onChange: onChange })))))),
            React__default.createElement("p", null,
                React__default.createElement(InlineFormElement, null,
                    React__default.createElement("p", null, "The charges for the bunker transfer shall be sent to: "),
                    "\u00A0",
                    React__default.createElement(FormElement, null,
                        React__default.createElement(TextField, { fieldName: "chargesTo", value: (values === null || values === void 0 ? void 0 : values.chargesTo) || (values === null || values === void 0 ? void 0 : values.receiver) || '', onChange: onChange })))),
            React__default.createElement("p", null,
                "I\u00A0",
                React__default.createElement(FormElement, null,
                    React__default.createElement(SelectionBox, { value: values === null || values === void 0 ? void 0 : values.representative.toString(), valueKey: "value", displayKey: "text", fieldName: "representative", options: [
                            { text: 'will', value: 'true' },
                            { text: 'will not', value: 'false' }
                        ], onChangeValue: function (selectedItem) {
                            return onChangeFormValue('representative', selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value);
                        } })),
                "\u00A0 appoint a representative to witness and check either the opening and closing meter readings/calculations or, if meters are not available, the opening and closing tank dips/calculations on my behalf. Any appointment of a representative will not delay the Bunkering Operation.",
                React__default.createElement("br", null)),
            React__default.createElement("p", null,
                "The bunker transfer\u00A0",
                React__default.createElement(FormElement, null,
                    React__default.createElement(SelectionBox, { value: values === null || values === void 0 ? void 0 : values.vapourReturn.toString(), valueKey: "value", displayKey: "text", fieldName: "vapourReturn", options: [
                            { text: 'will', value: 'true' },
                            { text: 'will not', value: 'false' }
                        ], onChangeValue: function (selectedItem) { return onChangeFormValue('vapourReturn', selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value); } })),
                "\u00A0 require LNG vapour return. I acknowledge that if vapour return is required then additional charges may be incurred."),
            React__default.createElement("p", null,
                "The \u00A0",
                React__default.createElement(FormElement, null,
                    React__default.createElement(SelectionBox, { value: values === null || values === void 0 ? void 0 : values.stopPumpingSignal.toString(), valueKey: "value", displayKey: "text", fieldName: "stopPumpingSignal", options: [
                            { text: 'Bunker Vessel', value: 'BUNKER_VESSEL' },
                            { text: 'Receiving Vessel', value: 'RECEIVING_VESSEL' }
                        ], onChangeValue: function (selectedItem) {
                            return onChangeFormValue('stopPumpingSignal', selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value);
                        } })),
                "\u00A0 will give the final \u201Cstop pumping\u201D signal. In the event that",
                ' ',
                React__default.createElement("strong", null, "receiving vessel\u2019s"),
                " valves are closed on board without giving the agreed/contractual warning to the ",
                React__default.createElement("strong", null, "bunker vessel"),
                ", I recognize that the",
                ' ',
                React__default.createElement("strong", null, "receiving vessel"),
                "is solely responsible for any damage caused by excess pressure to supplier\u2019s bunkering equipment or any resulting spillage/leak of LNG/Gas."),
            ' ',
            React__default.createElement("p", null, "In the event that I am unable to accommodate the full quantity ordered above, I accept that my principals will be liable for lighterage, handling charges and any other expenses incurred on the shut-out quantity."),
            React__default.createElement("p", null,
                ' ',
                "At the time of this form being issued it is planned that the",
                ' ',
                React__default.createElement("strong", null, "receiving vessel"),
                " will be moored with the",
                ' ',
                React__default.createElement(FormElement, null,
                    React__default.createElement(SelectionBox, { value: values === null || values === void 0 ? void 0 : values.side.toString(), valueKey: "value", displayKey: "text", fieldName: "side", options: [
                            { text: 'Port', value: 'PORT' },
                            { text: 'Starboard', value: 'STARBOARD' }
                        ], onChangeValue: function (selectedItem) { return onChangeFormValue('side', selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value); } })),
                "\u00A0 side to the quay. Any changes to this to be communicated to Receiving Vessel as soon as possible."),
            React__default.createElement("p", null,
                "I confirm that the ",
                React__default.createElement("strong", null, "receiving vessel\u2019s"),
                " LNG tanks will be cold and ready for loading prior to arrival of the ",
                React__default.createElement("strong", null, "bunker vessel"),
                " at the Delivery Point in accordance with the delivery procedures manual and at no point warmer than -140 deg C at the tank(s) bottom ."))));
};

var MastersRequisition = function (props) {
    var _a, _b;
    var _c = useMastersRequisitionService(props.authenticationService, props.event.eventId), masterRequisitionForm = _c.masterRequisitionForm, generateMastersRequisitionDocument = _c.generateMastersRequisitionDocument, saveMastersRequisitionForm = _c.saveMastersRequisitionForm;
    var userPermissions = useContext(UserPermissionContext).userPermissions;
    var receiver = useMemo(function () { return getCompanyNameById(props.event.companyId, props.companies); }, [props.event.companyId]) || '';
    var supplier = useMemo(function () { return getCompanyNameById(props.event.vendorCompanyId || undefined, props.companies); }, [props.event.vendorCompanyId]) || 'N/A';
    var customerFleet = useFleetService(props.event.companyId || '', props.authenticationService).ships;
    var receivingShipName = ((_a = customerFleet.find(function (vessel) { return vessel._id === props.event.receivingShipId; })) === null || _a === void 0 ? void 0 : _a.name) || 'N/A';
    var _d = useState(), bunkerShipName = _d[0], setBunkerVessel = _d[1];
    useEffect(function () {
        if (props.event.bunkerShipId) {
            setVesselInfo(props.event.bunkerShipId);
        }
    }, [props.event]);
    var locationService = useLocationService(props.authenticationService);
    var deliveryPoint = (_b = useLocationName(props.event.locationId || undefined, locationService, formatPortCountry)) === null || _b === void 0 ? void 0 : _b.text;
    var contractParty = getCompanyNameById(props.event.vendorCompanyId || undefined, props.companies) || null;
    var quantity = props.event.amount;
    var noDocumentMessage = !isReceivingCaptain(props.userProfile.roles)
        ? "When the receiving vessel's captain creates a master's requisition document, it will appear here."
        : undefined;
    var _e = useState(getMRFormValues()), MRFormValues = _e[0], setMRFormValues = _e[1];
    useEffect(function () {
        if (masterRequisitionForm) {
            setMRFormValues(masterRequisitionForm);
        }
        else {
            setMRFormValues(getMRFormValues());
        }
    }, [
        masterRequisitionForm,
        receiver,
        supplier,
        customerFleet,
        receivingShipName,
        bunkerShipName,
        deliveryPoint,
        contractParty,
        quantity
    ]);
    // Form hook
    var _f = useForm({
        initialValues: MRFormValues,
        onValidSubmit: function (values) { return null; }
    }), values = _f.values, onChange = _f.onChange, onChangeValue = _f.onChangeValue;
    // Dialog
    var _g = useState(false), newMRFDialog = _g[0], setNewMRFDialog = _g[1];
    return (React__default.createElement("section", { className: "masters-requisition-wrapper" },
        !isReceivingCaptain(props.userProfile.roles) ? null : (React__default.createElement(React__default.Fragment, null,
            React__default.createElement("div", { className: "masters-requisition-content" },
                React__default.createElement("header", { className: "flex" },
                    React__default.createElement("h2", null, "Master's requisition form"),
                    React__default.createElement(Button, { primary: true, outline: true, onClick: function () { return setNewMRFDialog(true); } }, "Create new form")),
                React__default.createElement(DialogCreateNewMRF, { isDialogActive: newMRFDialog, setNewMRFDialog: setNewMRFDialog, handleCreateNewForm: handleCreateNewForm }),
                React__default.createElement(MasterRequisitionForm, { values: values, onChange: onChange, onChangeFormValue: onChangeValue })),
            React__default.createElement("div", null,
                React__default.createElement(Button, { primary: true, onClick: handleSaveForm }, "Save current form")))),
        React__default.createElement("div", { className: "document-status-box" },
            React__default.createElement("div", { className: "document-status-box-content" },
                React__default.createElement(DocumentStatusBlock, { title: "Master's Requisition Form", isDifferentFromInitial: false, readOnly: !doesUserHavePermission(userPermissions, 'MRF_UPDATE'), statusArray: undefined, generatePDF: handleGenerateDocument, canGeneratePDF: doesUserHavePermission(userPermissions, 'MRF_GENERATE_DOCUMENT') },
                    React__default.createElement(PDFDocumentHandler, { authenticationService: props.authenticationService, eventWithDocuments: props.event, userProfile: props.userProfile, allowedDocumentTypes: ['MASTERS_REQUISITION_FORM'], withWrapper: true, readOnly: !doesUserHavePermission(userPermissions, 'MRF_UPDATE'), refetchEvent: props.refetchEvent, updateItem: function () { }, noDocumentMessage: noDocumentMessage }))))));
    function getMRFormValues() {
        return {
            _id: null,
            receiver: receiver || '',
            receivingShipName: receivingShipName || '',
            supplier: supplier || '',
            bunkerShipName: bunkerShipName || 'n/a',
            deliveryPoint: deliveryPoint || '',
            contractParty: contractParty || '',
            bdnReference: '',
            nextDestination: '',
            quantity: quantity || 0,
            quantityUnit: QuantityUnit['TONNES'],
            rate: 0,
            chargesTo: '',
            representative: false,
            vapourReturn: false,
            stopPumpingSignal: Vessel.BUNKER_VESSEL,
            side: Side.PORT
        };
    }
    function setVesselInfo(vesselId) {
        return __awaiter(this, void 0, void 0, function () {
            var vessel, _a, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 4]);
                        _a = props.bunkerVessels.find(function (vessel) { return vessel._id === vesselId; }) ||
                            props.customerFleet.find(function (vessel) { return vessel._id === vesselId; });
                        if (_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, getShipsById(props.authenticationService, [vesselId])];
                    case 1:
                        _a = (_b.sent());
                        _b.label = 2;
                    case 2:
                        vessel = _a;
                        setBunkerVessel(vessel instanceof Array ? vessel[0].name : vessel.name);
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _b.sent();
                        setBunkerVessel('n/a');
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    function handleCreateNewForm() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setMRFormValues(getMRFormValues());
                        return [4 /*yield*/, saveMastersRequisitionForm(getMRFormValues())];
                    case 1:
                        _a.sent();
                        setNewMRFDialog(false);
                        toast.success('New Master`s Requisition Form has been created!');
                        return [2 /*return*/];
                }
            });
        });
    }
    function handleGenerateDocument() {
        return __awaiter(this, void 0, void 0, function () {
            var documentStatus;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, handleSaveForm()]; // Save the current form first without creating the document
                    case 1:
                        _a.sent(); // Save the current form first without creating the document
                        toast.info('Document is being created!');
                        return [4 /*yield*/, generateMastersRequisitionDocument()];
                    case 2:
                        documentStatus = _a.sent();
                        toast.dismiss();
                        if (documentStatus) {
                            toast.success('Document has been created!');
                            props.refetchEvent();
                        }
                        return [2 /*return*/];
                }
            });
        });
    }
    function handleSaveForm() {
        return __awaiter(this, void 0, void 0, function () {
            var form;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!values)
                            return [2 /*return*/];
                        return [4 /*yield*/, saveMastersRequisitionForm(values)];
                    case 1:
                        form = _a.sent();
                        if (form) {
                            toast.success('Form has been saved!');
                        }
                        return [2 /*return*/];
                }
            });
        });
    }
    function getCompanyNameById(companyId, companies) {
        var _a;
        return ((_a = companies.find(function (company) { return company._id === companyId; })) === null || _a === void 0 ? void 0 : _a.name) || 'n/a';
    }
};

export { ACTION, AddThirdPartyContactDialog, AlternativeFuelSelector, BDNOverview, BdnConfigurationForm, BunkerAssetLNGContents, BunkerShipDeleteFail$1 as BunkerShipDeleteFail, BunkerShipForm, ChecklistType, ChecklistValue, ChecklistValueType, CommentBox, CommentList, CopyFromPreviousNomination, CreateEnquiry, CreateNomination$1 as CreateNomination, DelegationContainer, DeliveryModeSelection, DocumentHandler, ENERGY_UNITS, EnergyUnit, EnquiryNegotiation, EventsCalendar$1 as EventsCalendar, ExternalSignerRole, IAPHHelpTextContext, IAPHHelpTextProvider, Icon, InfiniteScroll, LngAssetData, LoadingIndicator, LocationSearch$1 as LocationSearch, MastersRequisition, MultiOptionButton, NegotiationStatusHeader$1 as NegotiationStatusHeader, NegotiationStatusSummary, NominationFormLabels, NominationNegotiation$1 as NominationNegotiation, NominationStateLabels, NoticeOfReadiness, NotificationPopup, POSITION_REPORT_OPERATING_MODE, POSITION_REPORT_READING_TYPE, POSITION_REPORT_TYPE, POSITION_REPORT_VESSEL_STATUS, PRICE_UNITS, PermissionsWarning, PressureUnit, PriceUnit, PromptEventSelector, PromptForm$1 as PromptForm, PromptNominationForm, QUANTITY_UNITS, QuantityUnit, Refresher, ResizableBox, SANDBOX_ID_LIVE, SHIP_TYPE_REQUEST, SOFOverview, SafetyChecklistForms, SafetyChecklistHelpTextContext, SafetyChecklistHelpTextProvider, SafetyChecklistIndividualPart, SafetyChecklistPart, SafetyChecklistPressureUnit, SafetyChecklistType, SchedulingTimeline$1 as SchedulingTimeline, ShipSelectionBox, Side, SignFlowGo, SignFlowReturn, SignFlowState, SignFlowType, SofConfiguration, Tag, TemperatureUnit, ThirdPartyContactsTable, TimelineFilter, TimelineSidebar, UserPermissionContext, UserPermissionProvider, ValidationWarning, Vessel, comparingNominationFields, doesUserHavePermission, formatPortCountry, formatTerminalCountry, getAllowedThirdPartyContactRoles, getCompanyDetails, getCompanyName, getNominationNegotiationFieldPermissions, getNominationStatusIcon, getQuantityUnitLabel, getUserNegotiationPermissions, handleFetchError, instanceOfINominationEnquiryEvent, instanceOfNominationTimelineItem, isAdmin, isBunkerCaptain, isCaptain, isCaptainOnNomination, isContractParty, isCustomer, isCustomerAdmin, isOneOf, isOperator, isPromptEvent, isReceivingCaptain, isScheduler, isSchedulerCaptain, isSupplier, isSysAdmin, loadFromLocalStorage, nominationRefreshHandler, onNewerVersionAvailablePopup, onRefreshNotification, removeFromLocalStorage, saveToLocalStorage, toRelativeTime, useAssetData, useBdnConfigurationService$1 as useBdnConfigurationService, useBdnService, useBunkerShipService, useBunkershipService, useCharterShipService, useContractService, useEnquiryService, useFleetService, useGlobalDataService, useLocation, useLocationName, useLocationService, useLocationTimeZone, useNominationCollectionService, useNominationService, usePipelineService, usePromptCollectionService, usePromptEventService, useShipsService, useSignFlow, useSofConfigurationService, useSofService, useThirdPartyContactService, useUpdateEffect, userCanEditContract };
